import * as Vue from "vue";
import { reactive, watch, defineComponent, openBlock, createElementBlock, createElementVNode, normalizeClass, normalizeStyle, withModifiers, useCssVars, toDisplayString, createCommentVNode, resolveComponent, createVNode, createBlock, Fragment, renderList, nextTick, computed, inject, withCtx, createTextVNode, unref, renderSlot, Teleport, withDirectives, vShow, pushScopeId, popScopeId, vModelText, vModelCheckbox, createSlots, normalizeProps, guardReactiveProps, mergeProps, resolveDynamicComponent, withKeys, vModelSelect, createApp, provide } from "vue";
import * as Router from "vue-router";
var lib = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get install() {
    return install;
  },
  get getArrayHeaders() {
    return getArrayHeaders;
  },
  get TableDataSet() {
    return TableDataSet;
  },
  get TableInfo() {
    return TableInfo;
  },
  get TableSort() {
    return TableSort;
  },
  get TableRow() {
    return TableRow;
  },
  get TableFilterHelper() {
    return TableFilterHelper;
  },
  get TableModel() {
    return TableModel;
  },
  get HelpHelper() {
    return HelpHelper;
  },
  get Logger() {
    return Logger$1;
  },
  get TABLE_CONSTS() {
    return consts;
  },
  get TABLE_ICONS() {
    return ICONS;
  },
  get TABLE_CLASSES() {
    return TABLE_CLASSES;
  },
  get SCROLL_INTO_VIEW_PARAMS() {
    return SCROLL_INTO_VIEW_PARAMS;
  },
  get TABLE_STYLES() {
    return TABLE_STYLES;
  },
  get TABLE_GLOBAL_HANDLERS() {
    return TABLE_GLOBAL_HANDLERS;
  },
  get boolToString() {
    return boolToString;
  },
  get declension() {
    return declension;
  },
  get isNumeric() {
    return isNumeric;
  },
  get dateFormat() {
    return dateFormat;
  },
  get moment() {
    return moment;
  },
  get ApiService() {
    return ApiService$1;
  },
  get HttpService() {
    return HttpService$1;
  },
  get TableComponent() {
    return TableComponent;
  },
  get TableCellComponent() {
    return TableCellComponent;
  },
  get TableMultiHeaders() {
    return TableMultiHeaders;
  },
  get TableMultiHeadersTh() {
    return TableMultiHeadersTh;
  },
  get TableIndicatorsComponent() {
    return TableIndicatorsComponent;
  },
  get PanelFilters() {
    return PanelFilters;
  },
  get PanelFiltersItem() {
    return PanelFiltersItem;
  },
  get TableCellLabelComponent() {
    return TableCellLabelComponent;
  },
  get TableCellVocComponent() {
    return TableCellVocComponent;
  },
  get TableCellModalComponent() {
    return TableCellModalComponent;
  },
  get TableCellModalSelect() {
    return TableCellModalSelect;
  },
  get TableCellCalcComponent() {
    return TableCellCalcComponent;
  },
  get TableCellSimple() {
    return TableCellSimple;
  },
  get TableActionsComponent() {
    return TableActionsComponent;
  },
  get TableFilterComponent() {
    return TableFilterComponent;
  },
  get TablePaginationBottom() {
    return TablePaginationBottom;
  },
  get AttrInputBase() {
    return AttrInputBase;
  },
  get AttrInputList() {
    return AttrInputList;
  },
  get AttrsComponent() {
    return AttrsComponent;
  },
  get ContextInput() {
    return ContextInput;
  },
  get TableDefaultRepository() {
    return TableDefaultRepository;
  },
  get TableLocalRepository() {
    return TableLocalRepository;
  },
  get PointerHelper() {
    return PointerHelper;
  },
  get getTableModelArrayByFormRepository() {
    return getTableModelArrayByFormRepository;
  },
  get getTableRowsByFormRead() {
    return getTableRowsByFormRead;
  },
  get ContextMenu() {
    return ContextMenu;
  },
  get ContextMenuGlobal() {
    return ContextMenuGlobal;
  },
  get ButtonComponent() {
    return ButtonComponent;
  },
  get ButtonIconComponent() {
    return ButtonIconComponent;
  },
  get CheckboxComponent() {
    return CheckboxComponent;
  },
  get TooltipComponent() {
    return TooltipComponent;
  },
  get ModalComponent() {
    return ModalComponent;
  },
  get TDynamicModal() {
    return DynamicModal;
  },
  get BlueHelpComponent() {
    return BlueHelpComponent;
  },
  get SwitchComponent() {
    return SwitchComponent;
  },
  get CircleLoader() {
    return CircleLoader;
  },
  get TInputComponent() {
    return TInputComponent;
  },
  get TEditableSpan() {
    return TEditableSpan;
  },
  get TSelectComponent() {
    return TSelectComponent;
  },
  get TRadioButton() {
    return TRadioButton;
  },
  get TDatePicker() {
    return TDatePicker;
  },
  get DropdownComponent() {
    return DropdownComponent;
  },
  get ScreenSpinner() {
    return ScreenSpinner;
  },
  get EnterModalComponent() {
    return EnterModalComponent;
  },
  get EditableHelpComponent() {
    return EditableHelpComponent;
  },
  get ResizeComponent() {
    return ResizeComponent;
  },
  get TTestDynamicModalComponent() {
    return TTestDynamicModalComponent;
  },
  get TActionProgress() {
    return TActionProgress;
  },
  get TInputFile() {
    return TInputFile;
  },
  get TInputFiles() {
    return TInputFiles;
  },
  get TTable() {
    return TTable;
  },
  get TCollapse() {
    return TCollapse;
  },
  get TCaption() {
    return TCaption;
  },
  get TBorder() {
    return TBorder;
  },
  get TInput() {
    return TInput;
  },
  get TCaptionInput() {
    return TCaptionInput;
  },
  get TFlex() {
    return TFlex;
  },
  get TBoxColumn() {
    return TBoxColumn;
  },
  get TBoxRow() {
    return TBoxRow;
  },
  get TBoxColumnContainer() {
    return TBoxColumnContainer;
  },
  get TBoxContainer() {
    return TBoxContainer;
  },
  get PlusIcon() {
    return PlusIcon;
  },
  get CloseIcon() {
    return CloseIcon;
  },
  get MenuDownIcon() {
    return MenuDownIcon;
  },
  get ChevronDownIcon() {
    return ChevronDownIcon;
  },
  get DotsVerticalIcon() {
    return DotsVerticalIcon;
  },
  get FaqIcon() {
    return FaqIcon;
  },
  get RecalcActivityRadionuclides() {
    return RecalcActivityRadionuclides;
  },
  get RecalcActivityRadionuclidesDemo() {
    return RecalcActivityRadionuclidesDemo;
  },
  get CalcCodeRao() {
    return CalcCodeRao;
  },
  get CalcCodeRaoDemo() {
    return CalcCodeRaoDemo;
  },
  get CalcCategoryRao() {
    return CalcCategoryRao;
  },
  get CalcCategoryZriDemo() {
    return CalcCategoryZriDemo;
  },
  get CalcCategoryZri() {
    return CalcCategoryZri;
  },
  get CalcCodeWasteWaterReceiver() {
    return CalcCodeWasteWaterReceiver;
  },
  get CalcCodeWasteWaterReceiverDemo() {
    return CalcCodeWasteWaterReceiverDemo;
  },
  get CalcCodeOyat() {
    return CalcCodeOyat;
  },
  get CalcCodeOyatDemo() {
    return CalcCodeOyatDemo;
  },
  get CalcCodeTerritory() {
    return CalcCodeTerritory;
  },
  get CalcCodeTerritoryDemo() {
    return CalcCodeTerritoryDemo;
  },
  get CalcPeriodPotentialDanger() {
    return CalcPeriodPotentialDanger;
  },
  get CalcPeriodPotentialDangerDemo() {
    return CalcPeriodPotentialDangerDemo;
  },
  get CalcCodeStorage() {
    return CalcCodeStorage;
  },
  get CalcCodeStorageDemo() {
    return CalcCodeStorageDemo;
  },
  get CalcTotalActivityRaoDepletedUraniumProducts() {
    return CalcTotalActivityRaoDepletedUraniumProducts;
  },
  get CalcTotalActivityRaoDepletedUraniumProductsDemo() {
    return CalcTotalActivityRaoDepletedUraniumProductsDemo;
  },
  get NotificationsComponent() {
    return NotificationsComponent;
  },
  get NotificationsService() {
    return NotificationsService$1;
  },
  get TABLE_RELEASE_JSON() {
    return release;
  },
  get getHeaderProcessed() {
    return getHeaderProcessed;
  },
  get ApiErrorInstance() {
    return ApiErrorInstance;
  },
  get DataSet() {
    return DataSet;
  },
  get DocumentStyleHelper() {
    return DocumentStyleHelper;
  },
  get EventHelper() {
    return EventHelper;
  },
  get FilterFactory() {
    return FilterFactory;
  },
  get FormContext() {
    return FormContext;
  },
  get KeyboardEventHelper() {
    return KeyboardEventHelper;
  },
  get PanelFiltersSet() {
    return PanelFiltersSet;
  },
  get SortFactory() {
    return SortFactory;
  },
  get DEFAULT_ATTR_LABEL_OPTS() {
    return DEFAULT_ATTR_LABEL_OPTS;
  },
  get TableCell() {
    return TableCell;
  },
  get TableKeyboard() {
    return TableKeyboard;
  },
  get TableSelected() {
    return TableSelected;
  },
  get TablePagination() {
    return TablePagination;
  },
  get TableStylesHelper() {
    return TableStylesHelper;
  },
  get TableDataSetFactory() {
    return TableDataSetFactory;
  },
  get PaginationDataSet() {
    return PaginationDataSet;
  },
  get TableChanges() {
    return TableChanges;
  },
  get TableChangeEvents() {
    return TableChangeEvents;
  },
  get TableEventAbstract() {
    return TableEventAbstract;
  },
  get TableEventResizeColumn() {
    return TableEventResizeColumn;
  },
  get TableEventChangeCell() {
    return TableEventChangeCell;
  },
  get TableEventChangeRow() {
    return TableEventChangeRow;
  },
  get TableEventAddRow() {
    return TableEventAddRow;
  },
  get TableEventMoveRow() {
    return TableEventMoveRow;
  },
  get TableEventDeleteRow() {
    return TableEventDeleteRow;
  },
  get TableEventUpdateRowIndexes() {
    return TableEventUpdateRowIndexes;
  },
  get VocDataSet() {
    return VocDataSet;
  },
  get PanelFiltersSaveModuleAbstract() {
    return PanelFiltersSaveModuleAbstract;
  },
  get ApiHelper() {
    return ApiHelper;
  },
  get copyToClipboard() {
    return copyToClipboard;
  },
  get copy() {
    return copy;
  },
  get cloneDeep() {
    return cloneDeep;
  },
  get classToQuerySelector() {
    return classToQuerySelector;
  },
  get debounce() {
    return debounce;
  },
  get dateTransform() {
    return dateTransform;
  },
  get digestText() {
    return digestText;
  },
  get fillObject() {
    return fillObject;
  },
  get firstOrDefault() {
    return firstOrDefault;
  },
  get firstKeyOrDefault() {
    return firstKeyOrDefault;
  },
  get getMinMaxCellPointer() {
    return getMinMaxCellPointer;
  },
  get getNumbersByObject() {
    return getNumbersByObject;
  },
  get queueIsDeleteRows() {
    return queueIsDeleteRows;
  },
  get queueIsChangeCells() {
    return queueIsChangeCells;
  },
  get queueIsChangeRows() {
    return queueIsChangeRows;
  },
  get queueIsAddRow() {
    return queueIsAddRow;
  },
  get combineQueue() {
    return combineQueue;
  },
  get groupBy() {
    return groupBy;
  },
  get groupByMap() {
    return groupByMap;
  },
  get get() {
    return get;
  },
  get getDifferencesObjects() {
    return getDifferencesObjects;
  },
  get getFirstByProp() {
    return getFirstByProp;
  },
  get getValueOrOriginal() {
    return getValueOrOriginal;
  },
  get getKeys() {
    return getKeys;
  },
  get getTime() {
    return getTime;
  },
  get timeToStr() {
    return timeToStr;
  },
  get formatTimeStr() {
    return formatTimeStr;
  },
  get getMinutes() {
    return getMinutes;
  },
  get insert() {
    return insert;
  },
  get insertBefore() {
    return insertBefore;
  },
  get isLocatedRange() {
    return isLocatedRange;
  },
  get isNullOrUndefined() {
    return isNullOrUndefined;
  },
  get importDefault() {
    return importDefault;
  },
  get lastOrDefault() {
    return lastOrDefault;
  },
  get makeId() {
    return makeId;
  },
  get minBy() {
    return minBy;
  },
  get maxBy() {
    return maxBy;
  },
  get isObject() {
    return isObject;
  },
  get mergeDeep() {
    return mergeDeep;
  },
  get ModelHelper() {
    return ModelHelper;
  },
  get md5() {
    return md5;
  },
  get normaliseRange() {
    return normaliseRange;
  },
  get PaginationHelper() {
    return PaginationHelper;
  },
  get randomInt() {
    return randomInt;
  },
  get sortBy() {
    return sortBy;
  },
  get NUMBER_COMPARER_ASC() {
    return NUMBER_COMPARER_ASC;
  },
  get NUMBER_COMPARER_DESC() {
    return NUMBER_COMPARER_DESC;
  },
  get sleep() {
    return sleep;
  },
  get set() {
    return set;
  },
  get toJS() {
    return toJS;
  },
  get toNumberOrNull() {
    return toNumberOrNull;
  },
  get toNumberOrUndefined() {
    return toNumberOrUndefined;
  },
  get toNumberOrDefault() {
    return toNumberOrDefault;
  },
  get toUndefinedIfNull() {
    return toUndefinedIfNull;
  },
  get toNormaliseDomId() {
    return toNormaliseDomId;
  },
  get toStr() {
    return toStr;
  },
  get toClearObject() {
    return toClearObject;
  },
  get unique() {
    return unique;
  },
  get uniqBy() {
    return uniqBy;
  },
  get VocValueHelper() {
    return VocValueHelper;
  },
  get waitTablesQueue() {
    return waitTablesQueue;
  },
  get wrapNotifyAndAwaited() {
    return wrapNotifyAndAwaited;
  },
  get STATUS_REPORT_NAME() {
    return STATUS_REPORT_NAME;
  },
  get getStatusReportName() {
    return getStatusReportName;
  },
  get STATUS_REPORTING_FORM_NAME() {
    return STATUS_REPORTING_FORM_NAME;
  },
  get getStatusReportingFormName() {
    return getStatusReportingFormName;
  },
  get REPORTING_FORM_RULES() {
    return REPORTING_FORM_RULES;
  },
  get STATUS_REPORTING_FORM_SELECT_VALUES() {
    return STATUS_REPORTING_FORM_SELECT_VALUES;
  },
  get Subject() {
    return Subject;
  },
  get VOC_NAMES_DICT() {
    return VOC_NAMES_DICT;
  },
  get strToFilterComparisonOption() {
    return strToFilterComparisonOption;
  },
  get filterComparisonOptionToStr() {
    return filterComparisonOptionToStr;
  },
  get FILTER_COMPARISON_OPERATION_OPTIONS() {
    return FILTER_COMPARISON_OPERATION_OPTIONS;
  },
  get FILTER_COMPARISON_OPERATIONS() {
    return FILTER_COMPARISON_OPERATIONS;
  },
  get FILTER_LOCAL_COMPARISON_OPERATIONS() {
    return FILTER_LOCAL_COMPARISON_OPERATIONS;
  },
  get FILTER_LOCAL_COMPARISON_OPERATIONS_ARRAY() {
    return FILTER_LOCAL_COMPARISON_OPERATIONS_ARRAY;
  },
  get FILTER_COMPARISON_OPERATION__CREATE_INPUT() {
    return FILTER_COMPARISON_OPERATION__CREATE_INPUT;
  },
  get FILTER_COMPARISON_OPERATION_SUPPORT_TYPE_INPUT() {
    return FILTER_COMPARISON_OPERATION_SUPPORT_TYPE_INPUT;
  },
  get FILTER_LOGICAL_OPERATIONS() {
    return FILTER_LOGICAL_OPERATIONS;
  },
  get NOT_SUPPORT_FILTER_ATTR_INPUT_BASE_TYPES() {
    return NOT_SUPPORT_FILTER_ATTR_INPUT_BASE_TYPES;
  },
  get NOT_SUPPORT_LIKE_ATTR_INPUT_BASE_TYPES() {
    return NOT_SUPPORT_LIKE_ATTR_INPUT_BASE_TYPES;
  },
  get isSupportFilterAttrInput() {
    return isSupportFilterAttrInput;
  },
  get GlobalContext() {
    return GlobalContext;
  },
  get RepoPartDefault() {
    return RepoPartDefault;
  },
  get RepoService() {
    return RepoService;
  },
  get GlobalTableSettingsService() {
    return GlobalTableSettingsService;
  },
  get getVocUniqueValuesColumn() {
    return getVocUniqueValuesColumn;
  },
  get stringToFormInfoDataDto() {
    return stringToFormInfoDataDto;
  },
  get TableSettingsService() {
    return TableSettingsService;
  },
  get TableHandlersHelper() {
    return TableHandlersHelper;
  },
  get PanelFiltersFactory() {
    return PanelFiltersFactory;
  },
  get getModelVoc() {
    return getModelVoc;
  },
  get ValidErrorEnum() {
    return ValidErrorEnum;
  },
  get getValidError() {
    return getValidError;
  },
  get getValidErrorLabel() {
    return getValidErrorLabel;
  },
  get getModelDtoSort() {
    return getModelDtoSort;
  },
  get getModelDtoDict() {
    return getModelDtoDict;
  },
  get ContextMenuService() {
    return ContextMenuService;
  },
  get TDynamicModalService() {
    return TDynamicModalService;
  },
  get CALC_PARAMS() {
    return CALC_PARAMS;
  },
  get getCalcHeader() {
    return getCalcHeader;
  },
  get INIT_CODE_SYMBOL() {
    return INIT_CODE_SYMBOL;
  },
  get VocValueStatusEnum() {
    return VocValueStatusEnum;
  },
  get PageService() {
    return PageService;
  },
  get getApiDefaultPage() {
    return getApiDefaultPage;
  },
  get PagePlugin() {
    return PagePlugin;
  }
}, Symbol.toStringTag, { value: "Module" }));
var fonts = "";
var table = "";
var blocks = "";
var buttons = "";
var labels = "";
function isNullOrUndefined(value) {
  return value === null || value === void 0;
}
function replaceCommaNumber(value) {
  if (typeof value === "string") {
    value = value.replace(",", ".");
  }
  return value;
}
function isNumeric(str, replaceComma = false) {
  if (isNullOrUndefined(str)) {
    return false;
  }
  if (typeof str !== "number" && typeof str !== "string") {
    return false;
  }
  if (replaceComma) {
    str = replaceCommaNumber(str);
  }
  return !isNaN(str) && !isNaN(parseFloat(str));
}
function toNumberOrDefault(str, defaultValue = 0) {
  str = replaceCommaNumber(str);
  if (isNumeric(str)) {
    return Number(str);
  }
  return defaultValue;
}
class TableHandlersHelper {
  static getHandlers(handlersDto) {
    return Object.keys(handlersDto).reduce(
      (handlers, handlerKey) => {
        handlers[handlerKey] = handlersDto[handlerKey].map(
          (handlerNameOrObject) => {
            return TableHandlersHelper.getHandler(
              handlerKey,
              handlerNameOrObject
            );
          }
        );
        return handlers;
      },
      {}
    );
  }
  static getHandler(handlerKey, handlerNameOrObject) {
    if (typeof handlerNameOrObject === "string") {
      return {
        name: handlerNameOrObject,
        handler: TABLE_GLOBAL_HANDLERS[handlerKey][handlerNameOrObject],
        params: void 0
      };
    }
    if (typeof handlerNameOrObject === "object") {
      return {
        name: handlerNameOrObject.handler,
        handler: TABLE_GLOBAL_HANDLERS[handlerKey][handlerNameOrObject.handler || ""],
        params: handlerNameOrObject.params
      };
    }
    return {
      name: "",
      handler: () => {
      },
      params: void 0
    };
  }
  static executeBeforeSave(before_save, value, setValue) {
    if (!before_save) {
      return false;
    }
    let newValue = value;
    before_save.forEach(
      (handler) => newValue = handler.handler(handler.params, newValue)
    );
    setValue(newValue);
    return true;
  }
  static executeBeforeLabel(before_label, value, setValue) {
    if (!before_label) {
      return false;
    }
    let newValue = value;
    before_label.forEach(
      (handler) => newValue = handler.handler(handler.params, newValue)
    );
    setValue(newValue);
    return true;
  }
}
function toStr(v) {
  if (isNullOrUndefined(v)) {
    return "";
  }
  if (typeof v === "string") {
    return v;
  }
  if (typeof v === "object") {
    return JSON.stringify(v);
  }
  return "" + v;
}
class ModelHelper {
  static getRequired(model, type) {
    var _a;
    if ("required" in model) {
      return Boolean(model.required);
    }
    if (!type) {
      return false;
    }
    return Boolean((_a = type.validation) == null ? void 0 : _a.required);
  }
  static getSelectionMode(model, type, _default = "single") {
    if (model && "selection_mode" in model) {
      return model.selection_mode || _default;
    }
    if (!type) {
      return _default;
    }
    return type.selection_mode || _default;
  }
  static getHandlers(model, type, globalHandlers) {
    return ModelHelper.mergeHandlers(
      [globalHandlers, model == null ? void 0 : model.handlers, type == null ? void 0 : type.handlers].filter(
        Boolean
      )
    );
  }
  static mergeHandlers(handlersArray) {
    if (handlersArray.length === 1) {
      return handlersArray[0];
    }
    const handlers = {};
    handlersArray.forEach((currentHandler) => {
      Object.keys(currentHandler).forEach((key) => {
        var _a;
        const keyHandlers = currentHandler[key];
        if (!Array.isArray(keyHandlers)) {
          return;
        }
        (_a = handlers[key]) != null ? _a : handlers[key] = [];
        handlers[key].push(...keyHandlers);
      });
    });
    return handlers;
  }
  static getWidth(width) {
    let widthStr = toStr(width);
    if (isNumeric(width)) {
      widthStr = width + "px";
    }
    return widthStr;
  }
  static isSupportFilterComparison(model, comparison) {
    if (!model.filter) {
      return false;
    }
    if (typeof model.filter === "boolean") {
      return model.filter;
    }
    return model.filter.includes(comparison);
  }
}
const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
function makeId(length) {
  let result = "";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result.replace(/\d/, "x");
}
function toNumberOrUndefined(str) {
  str = replaceCommaNumber(str);
  if (isNumeric(str)) {
    return Number(str);
  }
  return void 0;
}
function getTime(str) {
  if (!(str == null ? void 0 : str.length)) {
    return void 0;
  }
  str = toStr(str);
  const rawResult = str.includes(":") ? str.split(":") : str.match(/\d{1,2}/g);
  if (!rawResult || rawResult.length > 2) {
    return void 0;
  }
  const result = rawResult.map(toNumberOrUndefined).filter((x) => x !== void 0);
  if (!(result == null ? void 0 : result.length)) {
    return void 0;
  }
  if (result.length === 2) {
    return {
      hours: result[0],
      minutes: result[1]
    };
  } else if (result.length === 1) {
    return {
      hours: result[0],
      minutes: 0
    };
  }
  return void 0;
}
function timeToStr(time) {
  const hours = toStr(time.hours).padStart(2, "0");
  const minutes = toStr(time.minutes).padStart(2, "0");
  return `${hours}:${minutes}`;
}
function formatTimeStr(str) {
  const time = getTime(str);
  if (time) {
    return timeToStr(time);
  }
  return str;
}
function getMinutes(str) {
  const time = getTime(str);
  if (!time) {
    return void 0;
  }
  return time.hours * 60 + time.minutes;
}
const SERVER_DATE_FORMAT = "YYYY-MM-DD";
const SERVER_DATE_TIME_FORMAT = "YYYY-MM-DD HH:mm:ss.SSSSSS";
const DISPLAY_DATE_FORMAT = "DD.MM.YYYY";
const DISPLAY_DATE_TIME_FORMAT = "DD.MM.YYYY HH:mm";
const SCROLL_INTO_VIEW_PARAMS = {
  behavior: "auto",
  block: "nearest",
  inline: "nearest"
};
const TABLE_LIB_CONFIG = reactive({
  path: ""
});
const TABLE_CLASSES = {
  container: "table-container",
  table: "table",
  virtualScroll: "table__virtual-scroll",
  header: "table__header",
  selectedHeader: "table__header__selected",
  th: "table__th",
  thDiv: "table__th__div",
  thDivContent: "table__th__div__content",
  thDivResize: "table__th__div__resize",
  thDivResizeDiv: "table__th__div__resize-div",
  thDivFilter: "table__th__div__filter",
  thHelp: "table__th__help",
  cell: "table__td",
  cellDiv: "table__td__div",
  cellIndicators: "table__td__indicators",
  cellIndicatorsCircle: "table__td__indicators-circle",
  cellInvalid: "table__td__invalid",
  cellCheckboxSizeCssVariable: "--cell-checkbox-size",
  selectedCell: "table__td__selected",
  selectedCell2: "table__td__selected2",
  editedCell: "table__td__edited",
  row: "table__tr",
  selectedRow: "table__tr__selected",
  numCell: "table__td__num",
  selectCell: "table__td__select",
  thNum: "table__th__num"
};
const DEFAULT_REPOSITORY_READ_TYPE_DTO = {
  base_type: "BASE"
};
const selectedBorderColor = "#035ea1";
const borderColor = "#E0E0E0";
const TABLE_STYLES = {
  container: {
    color: "#333",
    background: "#ffffff"
  },
  header: {
    color: "#333",
    "font-size": "12px",
    height: "12px"
  },
  selectedHeader: {
    background: "#e1efff"
  },
  th: {
    "border-color": borderColor,
    background: "#f5f7f9"
  },
  cell: {
    "border-color": borderColor,
    "font-size": "12px",
    background: void 0
  },
  cellDiv: {
    height: "30px",
    "padding-inline": "10px"
  },
  selectedCell: {
    "border-color": selectedBorderColor
  },
  selectedCell2: {
    "border-color": selectedBorderColor
  },
  editedCell: {
    "border-color": selectedBorderColor
  },
  row: {
    background: "#ffffff",
    color: "#333"
  },
  row2: {
    background: "#f3f3f3"
  },
  selectedRow: {},
  "*|*:link": {
    color: "#0000EE"
  },
  "*|*:visited": {
    color: "#551A8B"
  }
};
const ORIGINAL_TABLE_ICONS = {
  sortNumericDescending: {
    src: "/interface/sort-numeric-descending.svg",
    alt: "\u21939-0"
  },
  sortNumericAscending: {
    src: "/interface/sort-numeric-ascending.svg",
    alt: "\u21930-9"
  },
  pencilOutline: {
    src: "/interface/pencil-outline.svg",
    alt: "\u270E"
  },
  sigma: {
    src: "/interface/sigma.svg",
    alt: "\u03A3"
  },
  eyeOff: {
    src: "/interface/eye-off.svg",
    alt: "\u{1F441}\u{1F512}"
  },
  arrowHorizontalLock: {
    src: "/interface/arrow-horizontal-lock.svg",
    alt: "\u{1F512}\u2B7E"
  },
  arrowULeftBottom: {
    src: "/interface/arrow-u-left-bottom.svg",
    alt: "\u2190"
  },
  arrowULeftTop: {
    src: "/interface/arrow-u-left-top.svg",
    alt: "\u2190"
  },
  filterOutline: {
    src: "/interface/filter-outline.svg",
    alt: "Y"
  },
  download: {
    src: "/interface/download.svg",
    alt: "\u2B73"
  },
  upload: {
    src: "/interface/upload.svg",
    alt: "\u2B71"
  },
  restore: {
    src: "/interface/restore.svg",
    alt: "\u21BA"
  },
  restoreBlue: {
    src: "/interface/restore-blue.svg",
    alt: "\u21BA"
  },
  close: {
    src: "/interface/close.svg",
    alt: "x"
  },
  closeBlue: {
    src: "/interface/close-blue.svg",
    alt: "x"
  },
  check: {
    src: "/interface/check.svg",
    alt: "\u2713"
  },
  chevronDown: {
    src: "/interface/chevron-down.svg",
    alt: "\u2228"
  },
  chevronUp: {
    src: "/interface/chevron-up.svg",
    alt: "\u2227"
  },
  chevronDownAccent: {
    src: "/interface/chevron-down-accent.svg",
    alt: "\u2228"
  },
  chevronUpAccent: {
    src: "/interface/chevron-up-accent.svg",
    alt: "\u2227"
  },
  dotsVertical: {
    src: "/interface/dots-vertical.svg",
    alt: "\uFE19"
  },
  copy: {
    src: "/interface/copy.svg",
    alt: ""
  },
  copyBlue: {
    src: "/interface/copy-blue.svg",
    alt: ""
  },
  copyAccent: {
    src: "/interface/copy-accent.svg",
    alt: ""
  },
  trashCanOutline: {
    src: "/interface/trash-can-outline1.svg",
    alt: "\u{1F5D1}"
  },
  plus: {
    src: "/interface/plus.svg",
    alt: "+"
  },
  plusBlue: {
    src: "/interface/plus-blue.svg",
    alt: "+"
  },
  plusWhite: {
    src: "/interface/plus-white.svg",
    alt: "+"
  },
  faq: {
    src: "/interface/faq.svg",
    alt: "?"
  },
  informationOutline: {
    src: "/interface/information-outline.svg",
    alt: "!"
  },
  autorenew: {
    src: "/interface/autorenew.svg",
    alt: "\u21BB"
  },
  cogOutline: {
    src: "/interface/cog-outline.svg",
    alt: "\u2699\uFE0F"
  },
  cogOutlineBlue: {
    src: "/interface/cog-outline-blue.svg",
    alt: "\u2699\uFE0F"
  },
  closeCircle: {
    src: "/interface/close-circle.svg",
    alt: "x"
  },
  magnify: {
    src: "/interface/magnify.svg",
    alt: "\u{1F50D}"
  },
  chevronDone: {
    src: "/interface/arrow/chevron_done.svg",
    alt: "\u2714"
  },
  error: {
    src: "/interface/error.svg",
    alt: "\u2612"
  },
  menuDown: {
    src: "/interface/menu-down.svg",
    alt: "\u2193"
  },
  menuDownBlack: {
    src: "/interface/menu-down-black-24.svg",
    alt: "\u2193"
  },
  calculatorVariantOutline: {
    src: "/interface/calculator-variant-outline.svg",
    alt: "\u{1F5A9}"
  },
  detail: {
    src: "/interface/detail.svg",
    alt: "\u0414\u0435\u0442\u0430\u043B\u044C\u043D\u043E"
  },
  chatSquare: {
    src: "/interface/chat-square.svg",
    alt: ""
  },
  chatSquareBlue: {
    src: "/interface/chat-square-blue.svg",
    alt: ""
  },
  chatSquareAccent: {
    src: "/interface/chat-square-accent.svg",
    alt: ""
  },
  fileTree: {
    src: "/interface/file-tree.svg",
    alt: ""
  },
  bxSave: {
    src: "/interface/bx-save.svg",
    alt: "\u{1F4BE}"
  },
  vector: {
    src: "/interface/vector.svg",
    alt: "\u2190"
  },
  documentOutline: {
    src: "/interface/document-outline.svg",
    alt: "\u{1F5CB}"
  },
  expandOutline: {
    src: "/interface/expand-outline.svg",
    alt: "\u0420\u0430\u0441\u0448\u0438\u0440\u0438\u0442\u044C"
  },
  contractOutline: {
    src: "/interface/contract-outline.svg",
    alt: "\u0421\u0443\u0437\u0438\u0442\u044C"
  },
  newspaperOutline: {
    src: "/interface/newspaper-outline.svg",
    alt: ""
  },
  newspaperOutlineBlue: {
    src: "/interface/newspaper-outline-blue.svg",
    alt: ""
  },
  arrowDownOutline: {
    src: "/interface/arrow-down-outline.svg",
    alt: "\u2193"
  },
  arrowDownOutlineBlue: {
    src: "/interface/arrow-down-outline-blue.svg",
    alt: "\u2193"
  },
  arrowUpOutline: {
    src: "/interface/arrow-up-outline.svg",
    alt: "\u2191"
  },
  arrowUpOutlineBlue: {
    src: "/interface/arrow-up-outline-blue.svg",
    alt: "\u2191"
  },
  insertTable: {
    src: "/interface/insert-table.svg",
    alt: ""
  },
  insertTableBlue: {
    src: "/interface/insert-table-blue.svg",
    alt: ""
  },
  chatCircle: {
    src: "/interface/chat-circle.svg",
    alt: ""
  },
  chatCircleBlue: {
    src: "/interface/chat-circle-blue.svg",
    alt: ""
  },
  wordWrap: {
    src: "/interface/word-wrap.svg",
    alt: ""
  },
  wordWrapBlue: {
    src: "/interface/word-wrap-blue.svg",
    alt: ""
  },
  autoWidth: {
    src: "/interface/auto-width.svg",
    alt: ""
  },
  autoWidthBlue: {
    src: "/interface/auto-width-blue.svg",
    alt: ""
  },
  n: {
    src: "/interface/n.svg",
    alt: "N"
  },
  nBlue: {
    src: "/interface/n-blue.svg",
    alt: "N"
  }
};
const ICONS = reactive({});
function setPathIcon(icon) {
  return {
    ...icon,
    src: TABLE_LIB_CONFIG.path + icon.src
  };
}
function setPathIcons() {
  for (const iconKey in ORIGINAL_TABLE_ICONS) {
    ICONS[iconKey] = setPathIcon(ORIGINAL_TABLE_ICONS[iconKey]);
  }
}
watch(
  () => TABLE_LIB_CONFIG.path,
  () => {
    setPathIcons();
  },
  { immediate: true }
);
function getExponential(fractionDigits = void 0, value) {
  if (typeof value === "number") {
    value = toStr(value);
  }
  if (isNullOrUndefined(value) || typeof value !== "string" || value === "-" || value.trim() === "") {
    return {
      value,
      valid: false
    };
  }
  let procValue = value.toLowerCase().trim().replace(",", ".").replace("\u0435", "e");
  let isBracketsFound = false;
  if (procValue.startsWith("(") && procValue.endsWith(")")) {
    procValue = procValue.replace("(", "").replace(")", "");
    isBracketsFound = true;
  }
  if (procValue.includes("+") && !procValue.includes("e+")) {
    procValue = procValue.replace("+", "e+");
  } else if (procValue.includes("-") && !procValue.includes("e-")) {
    procValue = procValue.replace("-", "e-");
  }
  if (isNaN(procValue)) {
    return {
      value,
      valid: false
    };
  }
  const format = parseFloat(procValue);
  function processing(v) {
    const splitValues = v.split("+");
    if (splitValues.length > 1) {
      splitValues[1] = splitValues[1].padStart(2, "0");
      v = splitValues.join("+");
    }
    if (isBracketsFound) {
      return `(${v})`;
    }
    return v;
  }
  let expValue = format.toExponential(fractionDigits);
  if (expValue.length && !expValue.includes(".")) {
    expValue = expValue.replace("e", ".00e");
  }
  if (expValue === "Infinity") {
    return {
      value,
      valid: false
    };
  }
  return {
    value: processing(expValue),
    valid: true
  };
}
const anyTypeHandlers = {
  exponential_to_number: (params, value) => {
    const { valid, value: exponentialValue } = getExponential(params, value);
    if (!valid) {
      return value;
    }
    return `${toNumberOrDefault(exponentialValue, value)}`;
  },
  exponential: (params, value) => {
    return getExponential(params, value).value;
  },
  time: (params, value) => {
    if (isNullOrUndefined(value) || typeof value !== "string") {
      return value;
    }
    return formatTimeStr(value);
  },
  trim(params, value) {
    if (isNullOrUndefined(value) || typeof value !== "string") {
      return value;
    }
    return value.trim();
  },
  money(params, value) {
    if (isNullOrUndefined(value) || typeof value !== "string" && typeof value !== "number") {
      return value;
    }
    const number = toNumberOrDefault(toStr(value).trim(), value);
    if (typeof number !== "number") {
      return number;
    }
    const locales = Array.isArray(params) ? params[0] : "ru-RU";
    const currencyOriginal = Array.isArray(params) ? params[1] : void 0;
    const currency = currencyOriginal != null ? currencyOriginal : "RUB";
    let result = new Intl.NumberFormat(locales, {
      style: "currency",
      currency
    }).format(number);
    if (currencyOriginal === void 0) {
      const lastIndex = result.lastIndexOf(" ");
      result = result.slice(0, lastIndex - 1);
    }
    return result;
  },
  quantity(params, value) {
    if (isNullOrUndefined(value) || typeof value !== "string" && typeof value !== "number") {
      return value;
    }
    const number = toNumberOrDefault(toStr(value).trim(), value);
    if (typeof number !== "number") {
      return number;
    }
    return new Intl.NumberFormat("ru-RU").format(number);
  }
};
const TABLE_GLOBAL_HANDLERS = {
  before_save: {
    ...anyTypeHandlers
  },
  before_label: {
    ...anyTypeHandlers
  }
};
const VALIDATION_HANDLERS = {
  exponential: (model, type, value) => {
    const handlersDto = ModelHelper.getHandlers(model, type);
    if (!handlersDto) {
      return {};
    }
    const handlers = TableHandlersHelper.getHandlers(handlersDto);
    const handlersArray = [
      handlers.before_save,
      handlers.before_label
    ].filter(Boolean).flat();
    const exponentialHandler = handlersArray.find(
      (x) => x.name === "exponential"
    );
    if (!exponentialHandler) {
      return {};
    }
    const fractionDigits = exponentialHandler.params;
    const exponentialResult = getExponential(fractionDigits, value);
    if (exponentialResult.valid) {
      return {};
    }
    return {
      label: "\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043F\u0440\u0435\u043E\u0431\u0440\u0430\u0437\u043E\u0432\u0430\u043D\u043E \u0432 \u044D\u043A\u0441\u043F\u043E\u043D\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u0443\u044E \u0444\u043E\u0440\u043C\u0443"
    };
  },
  trim: (model, type, value) => {
    if (typeof value === "string") {
      return value.trim();
    }
    return value;
  }
};
const ATTRS_TYPES = {
  exponential: {
    base_type: "BASE",
    validation: {
      type: "str",
      handlers: ["exponential"]
    },
    handlers: {
      before_save: [
        {
          handler: "exponential",
          params: 2
        }
      ]
    }
  }
};
const TVuePropTypes = {
  style: [Object, String, Array],
  class: [Object, String, Array]
};
const DEFAULT_LEFT_COLUMN_NAME = "\u2116 \u043F/\u043F";
const DEFAULT_GET_UUID = (original, tableRow) => {
  var _a;
  return (_a = tableRow == null ? void 0 : tableRow.uuid) != null ? _a : original == null ? void 0 : original.__uuid;
};
const DEFAULT_MAKE_UUID = () => makeId(10) + Date.now();
const TABLE_HOTKEYS = [
  {
    key: "F1",
    text: "\u041E\u0442\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u044C \u043E\u043A\u043D\u043E \u043F\u043E\u043C\u043E\u0449\u0438"
  },
  {
    key: "F2/\u0414\u0432\u043E\u0439\u043D\u043E\u0439 \u043A\u043B\u0438\u043A \u043C\u044B\u0448\u043A\u043E\u0439",
    text: "\u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0442\u0435\u043A\u0443\u0449\u0443\u044E \u044F\u0447\u0435\u0439\u043A\u0443"
  },
  {
    key: "ESC",
    text: "\u0432\u044B\u0445\u043E\u0434 \u0438\u0437 \u0440\u0435\u0436\u0438\u043C\u0430 \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0431\u0435\u0437 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F"
  },
  {
    key: "\u2191/\u2193/\u2192/\u2190",
    text: "\u043D\u0430\u0432\u0438\u0433\u0430\u0446\u0438\u044F \u043F\u043E \u044F\u0447\u0435\u0439\u043A\u0430\u043C"
  },
  {
    key: "Tab",
    text: "\u0432\u044B\u0431\u0440\u0430\u0442\u044C \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0443\u044E \u044F\u0447\u0435\u0439\u043A\u0443"
  },
  {
    key: "Shift+Tab",
    text: "\u0432\u044B\u0431\u0440\u0430\u0442\u044C \u043F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0443\u044E \u044F\u0447\u0435\u0439\u043A\u0443"
  },
  {
    key: "Enter",
    text: "\u0432\u044B\u0431\u0440\u0430\u0442\u044C \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0443\u044E \u0441\u0442\u0440\u043E\u043A\u0443"
  },
  {
    key: "Home/End",
    text: "\u043F\u0435\u0440\u0435\u0439\u0442\u0438 \u0432 \u043D\u0430\u0447\u0430\u043B\u043E/\u043A\u043E\u043D\u0435\u0446 \u0441\u0442\u0440\u043E\u043A\u0438"
  },
  {
    key: "Ctrl+A",
    text: "\u0432\u044B\u0434\u0435\u043B\u0438\u0442\u044C \u0432\u0441\u0435 \u044F\u0447\u0435\u0439\u043A\u0438"
  },
  {
    key: "Shift+(\u2191/\u2193/\u2192/\u2190/Home/End)",
    text: "\u0432\u044B\u0434\u0435\u043B\u0438\u0442\u044C \u043F\u0440\u044F\u043C\u043E\u0443\u0433\u043E\u043B\u044C\u043D\u0443\u044E \u043E\u0431\u043B\u0430\u0441\u0442\u044C"
  },
  {
    key: "Ins",
    text: "\u0432\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043F\u0443\u0441\u0442\u0443\u044E \u0441\u0442\u0440\u043E\u043A\u0443 \u043F\u0435\u0440\u0435\u0434 \u0442\u0435\u043A\u0443\u0449\u0435\u0439"
  },
  {
    key: "Shift+Ins",
    text: "\u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043F\u0443\u0441\u0442\u0443\u044E \u0441\u0442\u0440\u043E\u043A\u0443 \u0432 \u043A\u043E\u043D\u0435\u0446 \u0442\u0430\u0431\u043B\u0438\u0446\u044B"
  },
  {
    key: "Ctrl+Del",
    text: "\u0443\u0434\u0430\u043B\u0438\u0442\u044C \u0441\u0442\u0440\u043E\u043A\u0443"
  },
  {
    key: "Ctrl+D",
    text: "\u0434\u0443\u0431\u043B\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0442\u0435\u043A\u0443\u0449\u0443\u044E \u0441\u0442\u0440\u043E\u043A\u0443"
  },
  {
    key: "Ctrl+C",
    text: "\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432\u044B\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0439 \u0431\u043B\u043E\u043A"
  },
  {
    key: "Ctrl+V",
    text: "\u0432\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u0431\u043B\u043E\u043A \u0432 \u0442\u0435\u043A\u0443\u0449\u0443\u044E \u043F\u043E\u0437\u0438\u0446\u0438\u044E"
  },
  {
    key: "Del",
    text: "\u043E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u0432\u044B\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0439 \u0431\u043B\u043E\u043A/\u0442\u0435\u043A\u0443\u0449\u0443\u044E \u044F\u0447\u0435\u0439\u043A\u0443"
  },
  {
    key: "Alt+Shift+Up",
    text: "\u043F\u0435\u0440\u0435\u043C\u0435\u0449\u0435\u043D\u0438\u0435 \u0442\u0435\u043A\u0443\u0449\u0435\u0439 \u0441\u0442\u0440\u043E\u043A\u0438 \u0432\u0432\u0435\u0440\u0445"
  },
  {
    key: "Alt+Shift+Down",
    text: "\u043F\u0435\u0440\u0435\u043C\u0435\u0449\u0435\u043D\u0438\u0435 \u0442\u0435\u043A\u0443\u0449\u0435\u0439 \u0441\u0442\u0440\u043E\u043A\u0438 \u0432\u043D\u0438\u0437"
  },
  {
    key: "Ctrl+Z",
    text: "\u043E\u0442\u043C\u0435\u043D\u0430 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0433\u043E \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F"
  },
  {
    key: "Ctrl+Y/Ctrl+Shift+Z",
    text: "\u043F\u043E\u0432\u0442\u043E\u0440\u0435\u043D\u0438\u0435 \u043E\u0442\u043C\u0435\u043D\u0451\u043D\u043D\u043E\u0433\u043E \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F"
  },
  {
    key: "Shift+F2",
    text: "\u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0435 \u043A \u044F\u0447\u0435\u0439\u043A\u0435"
  },
  {
    key: "Ctrl+Shift+F2",
    text: "\u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439 \u043A \u044F\u0447\u0435\u0439\u043A\u0435"
  },
  {
    key: "Alt+\u2193",
    text: "\u043E\u0442\u043A\u0440\u044B\u0442\u044C \u043C\u043E\u0434\u0430\u043B\u044C\u043D\u043E\u0435 \u043E\u043A\u043D\u043E \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u044F\u0447\u0435\u0439\u043A\u0438, \u0435\u0441\u043B\u0438 \u0442\u0430\u043A\u043E\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442"
  },
  {
    key: "Alt + F",
    text: "\u041E\u0442\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u044C \u0442\u0430\u0431\u043B\u0438\u0446\u0443 \u0432 \u043F\u043E\u043B\u043D\u043E\u044D\u043A\u0440\u0430\u043D\u043D\u043E\u043C \u0440\u0435\u0436\u0438\u043C\u0435 \u0438\u043B\u0438 \u0432\u044B\u0439\u0442\u0438 \u0438\u0437 \u043D\u0435\u0433\u043E"
  }
];
const GLOBAL_ATTRS_HANDLERS = {
  before_save: ["trim"]
};
var consts = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  SERVER_DATE_FORMAT,
  SERVER_DATE_TIME_FORMAT,
  DISPLAY_DATE_FORMAT,
  DISPLAY_DATE_TIME_FORMAT,
  SCROLL_INTO_VIEW_PARAMS,
  TABLE_LIB_CONFIG,
  TABLE_CLASSES,
  DEFAULT_REPOSITORY_READ_TYPE_DTO,
  TABLE_STYLES,
  ORIGINAL_TABLE_ICONS,
  ICONS,
  getExponential,
  TABLE_GLOBAL_HANDLERS,
  VALIDATION_HANDLERS,
  ATTRS_TYPES,
  TVuePropTypes,
  DEFAULT_LEFT_COLUMN_NAME,
  DEFAULT_GET_UUID,
  DEFAULT_MAKE_UUID,
  TABLE_HOTKEYS,
  GLOBAL_ATTRS_HANDLERS
}, Symbol.toStringTag, { value: "Module" }));
const boolToString = (value) => {
  if (value) {
    return "true";
  }
  return "false";
};
var _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const _sfc_main$1B = defineComponent({
  name: "FaqIcon"
});
const _hoisted_1$1l = {
  fill: "none",
  height: "18",
  viewBox: "0 0 18 18",
  width: "18",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$13 = /* @__PURE__ */ createElementVNode("path", {
  d: "M9 3.5C7.91221 3.5 6.84884 3.82257 5.94437 4.42692C5.0399 5.03127 4.33495 5.89025 3.91867 6.89524C3.50238 7.90024 3.39346 9.0061 3.60568 10.073C3.8179 11.1399 4.34173 12.1199 5.11092 12.8891C5.8801 13.6583 6.86011 14.1821 7.92701 14.3943C8.9939 14.6065 10.0998 14.4976 11.1048 14.0813C12.1098 13.6651 12.9687 12.9601 13.5731 12.0556C14.1774 11.1512 14.5 10.0878 14.5 9C14.4983 7.54184 13.9183 6.14389 12.8872 5.11281C11.8561 4.08174 10.4582 3.50172 9 3.5ZM9 13.5C8.10999 13.5 7.23996 13.2361 6.49994 12.7416C5.75992 12.2471 5.18314 11.5443 4.84254 10.7221C4.50195 9.89981 4.41284 8.99501 4.58647 8.12209C4.7601 7.24918 5.18869 6.44736 5.81802 5.81802C6.44736 5.18868 7.24918 4.7601 8.1221 4.58647C8.99501 4.41283 9.89981 4.50195 10.7221 4.84254C11.5443 5.18314 12.2472 5.75991 12.7416 6.49993C13.2361 7.23996 13.5 8.10998 13.5 9C13.4985 10.193 13.024 11.3368 12.1804 12.1804C11.3368 13.024 10.193 13.4985 9 13.5ZM9.5 11.25V12.25H8.5V11.25H9.5ZM11 7.75C11.0005 8.04987 10.9334 8.34598 10.8035 8.61627C10.6737 8.88656 10.4844 9.12404 10.25 9.311C9.87129 9.60447 9.6152 10.0283 9.5315 10.5H8.5155C8.55971 10.1145 8.68066 9.74179 8.87121 9.40379C9.06177 9.06579 9.31807 8.76937 9.625 8.532C9.74818 8.43342 9.84628 8.30709 9.9113 8.16334C9.97631 8.01959 10.0064 7.8625 9.99907 7.7049C9.99176 7.5473 9.94726 7.39367 9.86921 7.25656C9.79116 7.11945 9.68178 7.00275 9.55 6.916C9.40313 6.82 9.23414 6.76317 9.05911 6.75092C8.88407 6.73867 8.70882 6.7714 8.55 6.846C8.3806 6.9272 8.23844 7.05586 8.1408 7.21635C8.04315 7.37683 7.99424 7.56223 8 7.75C8 7.88261 7.94732 8.00979 7.85356 8.10355C7.75979 8.19732 7.63261 8.25 7.5 8.25C7.36739 8.25 7.24022 8.19732 7.14645 8.10355C7.05268 8.00979 7 7.88261 7 7.75C6.99256 7.36572 7.09859 6.98777 7.30483 6.66344C7.51106 6.3391 7.80835 6.08277 8.1595 5.9265C8.47078 5.78739 8.81207 5.7289 9.15191 5.75642C9.49174 5.78395 9.81917 5.89661 10.104 6.084C10.3792 6.2662 10.6051 6.51368 10.7614 6.80437C10.9178 7.09507 10.9997 7.41993 11 7.75Z",
  fill: "currentColor",
  "fill-opacity": "0.8"
}, null, -1);
const _hoisted_3$V = [
  _hoisted_2$13
];
function _sfc_render$1B(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1$1l, _hoisted_3$V);
}
var FaqIcon = /* @__PURE__ */ _export_sfc(_sfc_main$1B, [["render", _sfc_render$1B]]);
class HttpService {
  constructor() {
    this.defaultUrl = "";
  }
  setDefaultUrl(defaultUrl) {
    this.defaultUrl = defaultUrl;
  }
  async request(input, init = {}) {
    if (this.defaultUrl.length) {
      if (typeof input === "string") {
        if (input.startsWith("/")) {
          input = this.defaultUrl + input;
        }
      } else {
        if (input.url.startsWith("/")) {
          input = new Request(this.defaultUrl + input, input);
        }
      }
    }
    if (!init.headers) {
      init.headers = {};
    }
    init.headers["X-Screen-Resolution"] = `${toStr(
      window.screen.width
    )}x${toStr(window.screen.height)}`;
    init.headers["X-URL"] = toStr(document.URL);
    return new Promise((resolve, reject) => {
      fetch(input, init).then((response) => {
        if (response.headers.has("content-type")) {
          const contentType = response.headers.get("content-type");
          if (!(contentType == null ? void 0 : contentType.includes("application/json"))) {
            if (response.ok) {
              resolve({
                json: void 0,
                response
              });
              return;
            }
            reject({
              json: void 0,
              response
            });
            return;
          }
        }
        response.json().then((json) => {
          if (response.ok) {
            resolve({
              response,
              json
            });
          } else {
            reject({
              response,
              json
            });
          }
          return;
        }).catch((json) => {
          return reject({
            response,
            json
          });
        });
      }).catch((reason) => {
        reject(reason);
      });
    });
  }
  post(input, init) {
    return this.request(input, { method: "POST", ...init });
  }
  get(input, init) {
    return this.request(input, { method: "GET", ...init });
  }
}
var HttpService$1 = new HttpService();
class Logger {
  constructor() {
    this.isDebug = false;
    this.isLog = true;
    this.isTrace = true;
    this.isError = true;
    this.isWarn = true;
  }
  debug(...args) {
    if (this.isDebug) {
      console.debug(...args);
    }
  }
  log(...args) {
    if (this.isLog) {
      console.log(...args);
    }
  }
  trace(...args) {
    if (this.isTrace) {
      console.trace(...args);
    }
  }
  error(...args) {
    if (this.isError) {
      console.error(...args);
      console.trace();
    }
  }
  warn(...args) {
    if (this.isWarn) {
      console.warn(...args);
    }
  }
}
var Logger$1 = new Logger();
const VOC_NAMES_DICT = {
  radionuclide_voc: "radionuclide_voc1",
  organizations: "organizations",
  users: "users",
  bugreports: "bugreports",
  bugreports_admin: "bugreports_admin",
  user_logs: "user_logs"
};
function strToFilterComparisonOption(comparison) {
  if (!comparison) {
    return void 0;
  }
  try {
    return JSON.parse(comparison);
  } catch (e) {
    return void 0;
  }
}
function filterComparisonOptionToStr(comparisonObj) {
  if (comparisonObj.not !== true) {
    delete comparisonObj.not;
  }
  return JSON.stringify(comparisonObj);
}
const FILTER_COMPARISON_OPERATION_OPTIONS = [
  {
    label: "\u0440\u0430\u0432\u043D\u043E",
    value: filterComparisonOptionToStr({ value: "=" })
  },
  {
    label: "\u043D\u0435 \u0440\u0430\u0432\u043D\u043E",
    value: filterComparisonOptionToStr({
      value: "=",
      not: true
    })
  },
  {
    label: "\u0431\u043E\u043B\u044C\u0448\u0435",
    value: filterComparisonOptionToStr({ value: ">" })
  },
  {
    label: "\u043C\u0435\u043D\u044C\u0448\u0435",
    value: filterComparisonOptionToStr({ value: "<" })
  },
  {
    label: "\u0431\u043E\u043B\u044C\u0448\u0435 \u0438\u043B\u0438 \u0440\u0430\u0432\u043D\u043E",
    value: filterComparisonOptionToStr({ value: ">=" })
  },
  {
    label: "\u043C\u0435\u043D\u044C\u0448\u0435 \u0438\u043B\u0438 \u0440\u0430\u0432\u043D\u043E",
    value: filterComparisonOptionToStr({ value: "<=" })
  },
  {
    label: "\u0441\u043E\u0434\u0435\u0440\u0436\u0438\u0442",
    value: filterComparisonOptionToStr({ value: "like" })
  },
  {
    label: "\u043D\u0435 \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u0442",
    value: filterComparisonOptionToStr({
      value: "like",
      not: true
    })
  },
  {
    label: "sql",
    value: filterComparisonOptionToStr({ value: "sql" })
  }
];
const FILTER_COMPARISON_OPERATIONS = /* @__PURE__ */ new Set([
  "=",
  ">",
  ">=",
  "<",
  "<=",
  "in",
  "like",
  "sql"
]);
const FILTER_LOCAL_COMPARISON_OPERATIONS = /* @__PURE__ */ new Set(["=", ">", ">=", "<", "<=", "like"]);
const FILTER_LOCAL_COMPARISON_OPERATIONS_ARRAY = Array.from(FILTER_LOCAL_COMPARISON_OPERATIONS);
const FILTER_COMPARISON_OPERATION__CREATE_INPUT = /* @__PURE__ */ new Set([
  "=",
  ">",
  ">=",
  "<",
  "<=",
  "in",
  "like",
  "sql"
]);
const FILTER_COMPARISON_OPERATION_SUPPORT_TYPE_INPUT = /* @__PURE__ */ new Set(["=", ">", ">=", "<", "<=", "like"]);
const FILTER_LOGICAL_OPERATIONS = /* @__PURE__ */ new Set([
  "and",
  "or"
]);
const NOT_SUPPORT_FILTER_ATTR_INPUT_BASE_TYPES = /* @__PURE__ */ new Set(["SLOT"]);
const NOT_SUPPORT_LIKE_ATTR_INPUT_BASE_TYPES = /* @__PURE__ */ new Set(["VOC", "DICT"]);
function isSupportComparisonTypeInput(comparisonOp) {
  return comparisonOp && FILTER_COMPARISON_OPERATION_SUPPORT_TYPE_INPUT.has(comparisonOp);
}
function isSupportBaseTypeAttrInput(baseType) {
  return !NOT_SUPPORT_FILTER_ATTR_INPUT_BASE_TYPES.has(baseType);
}
function isSupportAttrInputComparisonOperation(baseType, comparisonOp) {
  if (comparisonOp === "like" && NOT_SUPPORT_LIKE_ATTR_INPUT_BASE_TYPES.has(baseType)) {
    return false;
  }
  return true;
}
function isSupportFilterAttrInput(baseType, comparisonOption) {
  const comparisonOp = comparisonOption == null ? void 0 : comparisonOption.value;
  const supportComparison = isSupportComparisonTypeInput(comparisonOp);
  const supportBaseType = isSupportBaseTypeAttrInput(baseType);
  const supportComparisonAndBaseType = isSupportAttrInputComparisonOperation(
    baseType,
    comparisonOp
  );
  return supportComparison && supportBaseType && supportComparisonAndBaseType;
}
class FilterFactory {
  static createLogical(logicalOperation, comparisonObjOrLogicalArray) {
    return [logicalOperation, ...comparisonObjOrLogicalArray];
  }
  static combineLogicalObj(logicalOperation, logicalObjArray) {
    return [logicalOperation, ...logicalObjArray];
  }
  static createComparison(comparisonOperation, parameter, value, optionalModifierArray = []) {
    return [comparisonOperation, parameter, value, ...optionalModifierArray];
  }
  static getString(filter) {
    if (!filter) {
      return void 0;
    }
    return JSON.stringify(filter);
  }
  static isLogicalObj(filter) {
    return FILTER_LOGICAL_OPERATIONS.has(filter[0]);
  }
  static isLogicalObjParse(filter) {
    return FILTER_LOGICAL_OPERATIONS.has(filter[0]);
  }
  static isComparisonObj(filter) {
    return FILTER_COMPARISON_OPERATIONS.has(filter[0]);
  }
  static isComparisonObjParse(filter) {
    if (Array.isArray(filter)) {
      return false;
    }
    return FILTER_COMPARISON_OPERATIONS.has(filter.comparisonOp);
  }
  static parseLogicalObj(logicalObj) {
    return [
      logicalObj[0],
      ...logicalObj.slice(1).map(FilterFactory.parseComparisonObj)
    ];
  }
  static parseComparisonObj(comparisonObj) {
    const comparisonOp = comparisonObj[0];
    const field = comparisonObj[1];
    const value = comparisonObj[2];
    const modifiers = new Set(comparisonObj.slice(3));
    return {
      comparisonOp,
      field,
      value,
      modifiers
    };
  }
  static parseLogicalObjOrComparisonObj(filter) {
    if (FilterFactory.isLogicalObj(filter) && !FilterFactory.isComparisonObj(filter)) {
      return FilterFactory.parseLogicalObj(filter);
    }
    return FilterFactory.parseComparisonObj(filter);
  }
  static isSupportLocalFilterLogicalParse(filter) {
    return filter.slice(1).every(FilterFactory.isSupportLocalFilterLogicalOrComparisonParse);
  }
  static isSupportLocalFilterComparisonParse(filter) {
    return FILTER_LOCAL_COMPARISON_OPERATIONS.has(filter.comparisonOp);
  }
  static isSupportLocalFilterLogicalOrComparisonParse(filter) {
    if (!FilterFactory.isComparisonObjParse(filter)) {
      return FilterFactory.isSupportLocalFilterLogicalParse(filter);
    }
    return FilterFactory.isSupportLocalFilterComparisonParse(filter);
  }
  static createSearchFilter(search, systemFields) {
    search = search.toLowerCase().trim();
    if (search.length === 0 || !systemFields.length) {
      return void 0;
    }
    return FilterFactory.createLogical(
      "or",
      systemFields.map((field) => {
        return FilterFactory.createComparison("like", field, search);
      })
    );
  }
  static parseString(filter) {
    if (!filter) {
      return void 0;
    }
    try {
      const obj = JSON.parse(filter);
      if (FilterFactory.isLogicalObj(obj) || FilterFactory.isComparisonObj(obj)) {
        return obj;
      } else {
        return void 0;
      }
    } catch (ex) {
      return void 0;
    }
  }
}
function sleep(timeout) {
  return new Promise((resolve) => setTimeout(resolve, timeout));
}
class ApiService {
  constructor() {
    this.isLoggingCache = false;
    this.cache = {};
  }
  setCache(key, value, resultGetValue, loading) {
    this.cache[key] = {
      date: Date.now(),
      value,
      resultGetValue,
      loading
    };
    if (this.isLoggingCache) {
      Logger$1.trace("setCache", this.cache[key]);
    }
  }
  getCache(key) {
    return this.cache[key];
  }
  clearCache(key) {
    if (this.isLoggingCache) {
      Logger$1.trace("clearCache", key);
    }
    if (key) {
      delete this.cache[key];
    } else {
      this.cache = {};
    }
  }
  async useCache(key, getValue) {
    if (this.isLoggingCache) {
      Logger$1.trace("useCache", key);
    }
    const currentCacheValue = this.getCache(key);
    if (currentCacheValue) {
      if (currentCacheValue.loading) {
        return await currentCacheValue.resultGetValue;
      }
      return await currentCacheValue.value;
    }
    const value = getValue();
    this.setCache(key, void 0, value, true);
    const awaitedValue = await value;
    this.setCache(key, awaitedValue, value);
    return awaitedValue;
  }
  getQueryParams(object, autoEncodeURIComponent = false) {
    return Object.entries(object).filter(([, value]) => !isNullOrUndefined(value)).map(([key, value]) => {
      if (typeof object[key] === "object") {
        if (Array.isArray(object[key])) {
          return object[key].map((arrayValue) => {
            arrayValue = autoEncodeURIComponent ? encodeURIComponent(arrayValue) : arrayValue;
            return `${key}=${arrayValue}`;
          }).join("&");
        }
        let json = JSON.stringify(object[key]);
        json = autoEncodeURIComponent ? encodeURIComponent(json) : json;
        return `${key}=${json}`;
      }
      value = autoEncodeURIComponent ? encodeURIComponent(value) : value;
      return `${key}=${value}`;
    }).join("&");
  }
  getFormData(data) {
    const formData = new FormData();
    Object.entries(data).forEach(([key, value]) => {
      formData.append(key, JSON.stringify(value));
    });
    return formData;
  }
  formRead(form_id) {
    return HttpService$1.get(
      "/api/forms?" + this.getQueryParams({
        action: "read",
        form_id
      })
    );
  }
  getVocRepository(voc_type) {
    return HttpService$1.get(
      "/api/repository/vocs?" + this.getQueryParams({
        action: "read",
        voc_type
      })
    );
  }
  getVocValues(voc_type, listParams, isUseCache, value, config_url, data_url, context) {
    if (data_url) {
      const { selected_cell, selected_row, selected_rows } = context != null ? context : {};
      return this.postVocValues(data_url, {
        value,
        ...listParams,
        selected_cell,
        selected_row,
        selected_rows,
        voc_type
      });
    }
    const url = this.getVocListByTypeUrl(
      voc_type,
      value,
      listParams,
      config_url
    );
    return this.request(url, void 0, isUseCache);
  }
  getVocValuesByFilter(voc_type, valueIdArray, value, config_url, data_url, context, useSortAndFilter = true) {
    const listParams = {};
    if (useSortAndFilter) {
      const comparisonObjArray = valueIdArray.map(
        (value_id) => FilterFactory.createComparison("=", "value_id", value_id)
      );
      const logicalObj = comparisonObjArray.length ? FilterFactory.createLogical("or", comparisonObjArray) : void 0;
      listParams.filter = FilterFactory.getString(logicalObj);
    }
    if (data_url) {
      const { selected_cell, selected_row, selected_rows } = context != null ? context : {};
      return this.postVocValues(data_url, {
        selected_cell,
        selected_row,
        selected_rows,
        voc_type,
        value
      });
    }
    return HttpService$1.get(
      this.getVocListByTypeUrl(voc_type, value, listParams, config_url)
    );
  }
  postVocValues(data_url, body) {
    return HttpService$1.post(data_url, {
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json"
      }
    });
  }
  getVocDict() {
    const url = "/api/repository/vocs/types?" + this.getQueryParams({
      action: "dict"
    });
    return this.useCache(url, () => HttpService$1.get(url));
  }
  repositoryRead(object_type) {
    return HttpService$1.get(
      "/api/repository/forms?" + this.getQueryParams({
        action: "read",
        object_type
      })
    );
  }
  postForm(action, form_id, table_name, data) {
    return HttpService$1.post(
      "/api/forms?" + this.getQueryParams({
        action,
        form_id,
        table_name
      }),
      {
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json"
        }
      }
    );
  }
  exportManagerRead(object_type) {
    return HttpService$1.get(
      "/api/repository/forms/exports/types?" + this.getQueryParams({
        action: "read",
        object_type
      })
    );
  }
  formValidate(form_id) {
    return HttpService$1.get(
      "/api/forms?" + this.getQueryParams({
        action: "validate",
        form_id
      })
    );
  }
  getVocRecord(record_id, voc_type) {
    return HttpService$1.get(
      `/api/vocs?action=read&record_id=${record_id}&voc_type=${voc_type}`
    );
  }
  getSelectValues(url, clearCache = false) {
    if (clearCache) {
      this.clearCache(url);
    }
    return this.useCache(
      url,
      () => HttpService$1.get(url)
    );
  }
  getVocsSearchByValueId(voc_type, value_id, limit = 150, only_active, filter, value, data_url, context) {
    const thenCrutch = (x) => {
      var _a, _b;
      if (typeof ((_b = (_a = x.json) == null ? void 0 : _a.result) == null ? void 0 : _b[0]) === "object") {
        x.json.result = x.json.result.map(
          (x2) => x2.value_id
        );
      }
      return x;
    };
    const filterObj = FilterFactory.parseString(filter);
    const comparisonObj = value_id ? FilterFactory.createComparison("like", "value_id", value_id) : void 0;
    const filters = [filterObj, comparisonObj].filter(
      Boolean
    );
    const logicalObj = FilterFactory.createLogical("and", filters);
    const listParams = {
      filter: FilterFactory.getString(logicalObj),
      extract: ["value_id"],
      limit,
      only_active,
      unique: true
    };
    if (data_url) {
      const { selected_cell, selected_row, selected_rows } = context != null ? context : {};
      return this.postVocValues(data_url, {
        value,
        selected_cell,
        selected_row,
        selected_rows,
        ...listParams,
        voc_type
      }).then(thenCrutch);
    }
    const url = this.getVocListByTypeUrl(
      voc_type,
      void 0,
      listParams,
      void 0
    );
    return HttpService$1.get(url).then(thenCrutch);
  }
  getVocListByTypeUrl(voc_type, value, listParams, config_url) {
    let basePath = "/api/vocs?";
    let params = {
      action: "list_by_type",
      voc_type,
      value,
      ...listParams || {}
    };
    if (config_url) {
      if (config_url.base_path) {
        basePath = config_url.base_path;
      }
      if (config_url.params) {
        Object.assign(params, config_url.params);
      }
      if (config_url.rename_params) {
        Object.keys(config_url.rename_params).forEach((key) => {
          const newKey = config_url.rename_params[key];
          const value2 = params[key];
          delete params[key];
          params[newKey] = value2;
        });
      }
    }
    return this.getUrl(basePath, params);
  }
  getList(url, params, useCache) {
    return this.request(this.getUrl(url, params), void 0, useCache);
  }
  request(url, init, useCache) {
    const getResult = () => HttpService$1.request(url, init);
    if (useCache) {
      const key = typeof useCache === "boolean" ? url : `${useCache}_${url}`;
      return this.useCache(key, getResult);
    }
    return getResult();
  }
  getUrl(url, params, autoEncodeURIComponent = false) {
    if (!url.endsWith("?") && !url.endsWith("&")) {
      const indexQuestion = url.lastIndexOf("?");
      if (indexQuestion === -1) {
        url += "?";
      } else {
        url += "&";
      }
    }
    return url + this.getQueryParams(params, autoEncodeURIComponent);
  }
  async uploadFile(file, url, progressFunc) {
    let is_active = true;
    let result = null;
    let error = null;
    let xhr = new XMLHttpRequest();
    xhr.upload.onprogress = function(event) {
      if (progressFunc) {
        progressFunc(event);
      }
    };
    xhr.upload.onerror = function(event) {
      error = event;
      is_active = false;
    };
    xhr.onloadend = function() {
      if (xhr.status != 200) {
        result = `\u041E\u0448\u0438\u0431\u043A\u0430 ${xhr.status}: ${xhr.statusText}`;
      } else {
        result = JSON.parse(xhr.response);
      }
      is_active = false;
    };
    let formData = new FormData();
    formData.append(file.name, file);
    xhr.open("POST", url);
    xhr.send(formData);
    while (is_active) {
      await sleep(100);
    }
    if (error) {
      throw error;
    }
    return result;
  }
}
var ApiService$1 = new ApiService();
class PaginationHelper {
  static next(pagination) {
    return {
      ...pagination,
      offset: toNumberOrDefault(pagination.offset) + PaginationHelper.getLimitOrDefault(pagination.limit)
    };
  }
  static getStateByLazyResult(result) {
    return {
      values_remain: Boolean(result == null ? void 0 : result.values_remain)
    };
  }
  static all(pagination) {
    const next = PaginationHelper.next(pagination);
    next.limit = void 0;
    return next;
  }
  static getLimitOrDefault(limit, _default = 0) {
    return isNullOrUndefined(limit) ? _default : limit;
  }
  static isPagination(pagination) {
    return Boolean(pagination && (pagination.limit || pagination.offset));
  }
  static getPaginationByMode(mode, tablePagination) {
    if (!tablePagination.params || tablePagination.loading) {
      return void 0;
    }
    if (mode === "next") {
      return PaginationHelper.next(tablePagination.params);
    } else {
      return PaginationHelper.all(tablePagination.params);
    }
  }
}
class VocValueHelper {
  static getDictByVocValueDtoArray(vocValues) {
    return vocValues.reduce((dict, vocValueDto) => {
      dict[toStr(vocValueDto.value_id)] = vocValueDto;
      return dict;
    }, {});
  }
  static async getVocValueDictByIds(vocDataSetData, vocValuesId, value, config_url, data_url, context) {
    var _a;
    if (!vocDataSetData.lazyPaginationState || !vocDataSetData.lazyPaginationState.values_remain) {
      return vocDataSetData.valuesDictByValueId;
    }
    if (vocValuesId.length === 0) {
      return {};
    }
    const vocValueDtoArray = (await ApiService$1.getVocValuesByFilter(
      (_a = vocDataSetData.type) == null ? void 0 : _a.voc_type,
      vocValuesId,
      value,
      config_url,
      data_url,
      context
    )).json.result;
    return VocValueHelper.getDictByVocValueDtoArray(vocValueDtoArray);
  }
}
async function getModelVoc({
  voc_type,
  listParams,
  currentVocDataSetData,
  value,
  context,
  repositoryType,
  params
}) {
  var _a, _b, _c, _d, _e, _f, _g;
  if (isNullOrUndefined(voc_type) && !repositoryType.select_form) {
    throw new Error(`getModelVoc not voc_type or not select_form`);
  }
  const getVocRepository = async () => {
    if (repositoryType.select_form) {
      return repositoryType.select_form;
    }
    const vocDto = (currentVocDataSetData == null ? void 0 : currentVocDataSetData.dto) || (await ApiService$1.getVocRepository(voc_type)).json;
    return vocDto;
  };
  const vocDict = voc_type ? (await ApiService$1.getVocDict()).json : void 0;
  const data_url = (_c = (_b = params == null ? void 0 : params.listUrl) != null ? _b : (_a = repositoryType.select_form) == null ? void 0 : _a.data_source_url) != null ? _c : repositoryType.data_url;
  const vocValuesResult = (await ApiService$1.getVocValues(
    voc_type,
    listParams,
    false,
    value,
    (_d = repositoryType.voc) == null ? void 0 : _d.config_url,
    data_url ? ApiService$1.getUrl(data_url, (_e = params == null ? void 0 : params.staticParams) != null ? _e : {}) : void 0,
    context
  )).json;
  const vocDataSetData = {
    dto: await getVocRepository(),
    values: (_f = vocValuesResult == null ? void 0 : vocValuesResult.result) != null ? _f : [],
    type: voc_type ? vocDict[voc_type] : void 0,
    valuesDictByValueId: VocValueHelper.getDictByVocValueDtoArray(
      (_g = vocValuesResult == null ? void 0 : vocValuesResult.result) != null ? _g : []
    ),
    lazyPaginationState: listParams ? PaginationHelper.getStateByLazyResult(vocValuesResult) : void 0,
    repositoryType
  };
  if (currentVocDataSetData) {
    if (listParams == null ? void 0 : listParams.offset) {
      currentVocDataSetData.values.push(...vocDataSetData.values);
      vocDataSetData.values = currentVocDataSetData.values;
    }
    Object.assign(
      currentVocDataSetData.valuesDictByValueId,
      vocDataSetData.valuesDictByValueId
    );
    vocDataSetData.valuesDictByValueId = currentVocDataSetData.valuesDictByValueId;
  }
  return vocDataSetData;
}
function debounce(func, timeout = 300) {
  let timer;
  const debounceFunc = (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
  return debounceFunc;
}
class TablePagination {
  constructor(opts = {}) {
    this.opts = opts;
    this.params = {};
    this.loading = false;
    this.valuesRemain = false;
    this._isServerManagement = false;
    this.normaliseLimit();
    if (this.opts.lazyLoadSize) {
      this._isServerManagement = true;
    }
  }
  static getKey(paginationParams) {
    return JSON.stringify(paginationParams);
  }
  isServerManagement(tableDataSet) {
    var _a;
    if (((_a = tableDataSet.options.optionsDto) == null ? void 0 : _a.server_filter_sort) === false) {
      return false;
    }
    return this._isServerManagement || this.valuesRemain || !tableDataSet.isSupportLocalFilters;
  }
  setLoading(loading) {
    this.loading = loading;
    return this;
  }
  setParams(params) {
    this.params = params;
    return this;
  }
  resetParams() {
    this.params = {
      limit: this.opts.lazyLoadSize,
      offset: 0
    };
    return this;
  }
  normaliseLimit() {
    if (this.opts.lazyLoadSize && isNullOrUndefined(this.params.limit)) {
      this.setParamsPartial({ limit: this.opts.lazyLoadSize });
    }
    return this;
  }
  setOffset(offset) {
    this.setParamsPartial({ offset });
    return this;
  }
  setValuesRemain(valuesRemain) {
    this.valuesRemain = valuesRemain;
    this.updateIsServerManagement();
    return this;
  }
  updateIsServerManagement() {
    if (this.valuesRemain) {
      this._isServerManagement = true;
    } else {
      if (this._isServerManagement && !this.params.filter) {
        this._isServerManagement = false;
      }
    }
    return this;
  }
  clear() {
    this.loading = false;
    this.valuesRemain = false;
    this._isServerManagement = false;
    this.resetParams();
    return this;
  }
  setParamsPartial(params) {
    this.setParams({ ...this.params, ...params });
    return this;
  }
}
class SortFactory {
  static createSort(field, sortType) {
    return sortType === "ASC" ? field : `-${field}`;
  }
  static getString(sort) {
    return sort == null ? void 0 : sort.join(",");
  }
}
class ApiErrorInstance {
  constructor(value) {
    this.value = value;
  }
  get type() {
    return this.value.type_ || this.value.type;
  }
  getMessage() {
    return this.value.rus_message || this.value.rus_message || "\u041D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u0430\u044F \u043E\u0448\u0438\u0431\u043A\u0430";
  }
}
class Subject {
  constructor() {
    this.observers = {};
  }
  subscribe(next = () => {
  }) {
    const observer = {
      next,
      id: makeId(5) + "_" + Object.keys(this.observers).length + Date.now()
    };
    this.observers[observer.id] = observer;
    return () => {
      delete this.observers[observer.id];
    };
  }
  next(value) {
    Object.values(this.observers).forEach((x) => x.next(value));
  }
}
class NotificationsService {
  constructor() {
    this.notificationsSubject = new Subject();
  }
  send(params) {
    this.notificationsSubject.next(params);
  }
}
var NotificationsService$1 = new NotificationsService();
function isObject(item) {
  return item && typeof item === "object" && !Array.isArray(item);
}
function mergeDeep(target, ...sources) {
  if (!sources.length)
    return target;
  const source = sources.shift();
  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key])
          Object.assign(target, { [key]: {} });
        mergeDeep(target[key], source[key]);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    }
  }
  return mergeDeep(target, ...sources);
}
function getPropByObject(v, key, maxDeep = 3, deep = 0) {
  if (key in v) {
    return { find: true, value: v[key], deep };
  }
  let minDeepFind;
  let minDeepValue = void 0;
  for (const x in v) {
    const result = getProp(v[x], key, maxDeep, deep + 1);
    if (result.find) {
      if (minDeepFind === void 0 || minDeepFind > result.deep) {
        minDeepFind = result.deep;
        minDeepValue = result.value;
      }
    }
  }
  return {
    find: minDeepFind !== void 0,
    value: minDeepValue,
    deep
  };
}
function getProp(v, key, maxDeep = 3, deep = 0) {
  if (isNullOrUndefined(v) || typeof v !== "object") {
    return { find: false, deep };
  }
  const resultObj = getPropByObject(v, key);
  if (resultObj.find) {
    return resultObj;
  }
  if (deep < maxDeep && Array.isArray(v)) {
    for (const x of v) {
      const result = getPropByObject(x, key);
      if (result.find) {
        return result;
      }
    }
    let minDeepFind;
    let minDeepValue = void 0;
    for (const x of v) {
      const result = getProp(x, key, maxDeep, deep + 1);
      if (result.find) {
        if (minDeepFind === void 0 || minDeepFind > result.deep) {
          minDeepFind = result.deep;
          minDeepValue = result.value;
        }
      }
    }
    if (minDeepFind !== void 0) {
      return {
        deep: minDeepFind,
        value: minDeepValue,
        find: true
      };
    }
  }
  return { find: false, deep };
}
class ApiHelper {
  static async getErrorMessage(error) {
    var _a, _b, _c;
    if (typeof error === "string") {
      return error;
    }
    if (error instanceof Promise) {
      try {
        const errorResult = await error;
        return ApiHelper.getErrorMessage(errorResult);
      } catch (e) {
        return ApiHelper.getErrorMessage(e);
      }
    }
    if (isObject(error)) {
      if (typeof ((_a = error.json) == null ? void 0 : _a.error) === "string") {
        return error.json.error;
      }
      if ((_b = error.json) == null ? void 0 : _b.errors) {
        return error.json.errors[0].rus_message || error.json.errors[0].message;
      }
      if (error.message) {
        if (error.message === "Failed to fetch") {
          return "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043E\u0442\u0432\u0435\u0442 \u043E\u0442 \u0441\u0435\u0440\u0432\u0435\u0440\u0430";
        }
        return error.message;
      }
      if (((_c = error.json) == null ? void 0 : _c.message) === "Unexpected token < in JSON at position 0") {
        return "\u0421\u0435\u0440\u0432\u0435\u0440 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u0435\u043D";
      }
      if (error.response) {
        return await ApiHelper.getErrorMessage(error.response);
      }
      if (error.statusText) {
        if (error.statusText === "Internal Server Error") {
          return "\u0421\u0435\u0440\u0432\u0435\u0440\u043D\u0430\u044F \u043E\u0448\u0438\u0431\u043A\u0430";
        }
        return error.statusText;
      }
      const log_msgs = getProp(error, "log_msgs");
      if (log_msgs.find) {
        if (Array.isArray(log_msgs.value)) {
          return log_msgs.value.join("\n\n");
        }
      }
    }
    if (Array.isArray(error) && error.length > 0) {
      return await ApiHelper.getErrorMessage(error[0]);
    }
    return "\u041D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u0430\u044F \u043E\u0448\u0438\u0431\u043A\u0430";
  }
  static async getErrors(error) {
    var _a;
    if (error instanceof Promise) {
      try {
        const errorResult = await error;
        return ApiHelper.getErrors(errorResult);
      } catch (e) {
        return ApiHelper.getErrors(e);
      }
    }
    if (typeof error === "object") {
      if ((_a = error.json) == null ? void 0 : _a.errors) {
        return error.json.errors.map((x) => new ApiErrorInstance(x));
      }
      if (error.message) {
        return [new ApiErrorInstance(error)];
      }
      if (typeof error.json === "function") {
        try {
          const json = error.json();
          return await ApiHelper.getErrors(json);
        } catch (e) {
        }
      }
    }
    if (typeof error.json === "function") {
      try {
        const json = error.json();
        return await ApiHelper.getErrors(json);
      } catch (e) {
      }
    }
    return [];
  }
  static async getError(error) {
    const errors = await ApiHelper.getErrors(error);
    if (errors.length > 0) {
      return errors[0];
    }
    return new ApiErrorInstance({
      type: "",
      message: await ApiHelper.getErrorMessage(error)
    });
  }
  static async wrapNotifyError(funcOrResult, _params = {}) {
    const getResult = async (result) => {
      if (typeof result === "function") {
        return getResult(result());
      }
      if (result instanceof Promise) {
        return getResult(await result);
      }
      if (_params.isError) {
        throw result;
      }
      return result;
    };
    try {
      const result = await getResult(funcOrResult);
      _params.resolve && _params.resolve(result);
      return result;
    } catch (e) {
      const error = await ApiHelper.getError(e);
      let send = true;
      if (_params.reject) {
        const rejectResult = _params.reject(e);
        if (typeof rejectResult === "boolean") {
          send = !rejectResult;
        }
      }
      if (send) {
        NotificationsService$1.send({
          type: "error",
          title: _params.title || "\u041E\u0448\u0438\u0431\u043A\u0430",
          text: error.getMessage(),
          duration: _params.duration
        });
      }
    }
  }
}
function toNormaliseDomId(id) {
  return id.replace(/^[^a-z]+|[^\w-]+/gi, "_");
}
function md5(inputString) {
  let hc = "0123456789abcdef";
  function rh(n) {
    let j, s = "";
    for (j = 0; j <= 3; j++)
      s += hc.charAt(n >> j * 8 + 4 & 15) + hc.charAt(n >> j * 8 & 15);
    return s;
  }
  function ad(x2, y) {
    let l = (x2 & 65535) + (y & 65535);
    let m = (x2 >> 16) + (y >> 16) + (l >> 16);
    return m << 16 | l & 65535;
  }
  function rl(n, c2) {
    return n << c2 | n >>> 32 - c2;
  }
  function cm(q, a2, b2, x2, s, t) {
    return ad(rl(ad(ad(a2, q), ad(x2, t)), s), b2);
  }
  function ff(a2, b2, c2, d2, x2, s, t) {
    return cm(b2 & c2 | ~b2 & d2, a2, b2, x2, s, t);
  }
  function gg(a2, b2, c2, d2, x2, s, t) {
    return cm(b2 & d2 | c2 & ~d2, a2, b2, x2, s, t);
  }
  function hh(a2, b2, c2, d2, x2, s, t) {
    return cm(b2 ^ c2 ^ d2, a2, b2, x2, s, t);
  }
  function ii(a2, b2, c2, d2, x2, s, t) {
    return cm(c2 ^ (b2 | ~d2), a2, b2, x2, s, t);
  }
  function sb(x2) {
    let i2;
    let nblk = (x2.length + 8 >> 6) + 1;
    let blks = new Array(nblk * 16);
    for (i2 = 0; i2 < nblk * 16; i2++)
      blks[i2] = 0;
    for (i2 = 0; i2 < x2.length; i2++)
      blks[i2 >> 2] |= x2.charCodeAt(i2) << i2 % 4 * 8;
    blks[i2 >> 2] |= 128 << i2 % 4 * 8;
    blks[nblk * 16 - 2] = x2.length * 8;
    return blks;
  }
  let i, x = sb("" + inputString), a = 1732584193, b = -271733879, c = -1732584194, d = 271733878, olda, oldb, oldc, oldd;
  for (i = 0; i < x.length; i += 16) {
    olda = a;
    oldb = b;
    oldc = c;
    oldd = d;
    a = ff(a, b, c, d, x[i + 0], 7, -680876936);
    d = ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = ff(c, d, a, b, x[i + 10], 17, -42063);
    b = ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = ff(b, c, d, a, x[i + 15], 22, 1236535329);
    a = gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = gg(b, c, d, a, x[i + 0], 20, -373897302);
    a = gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = gg(b, c, d, a, x[i + 12], 20, -1926607734);
    a = hh(a, b, c, d, x[i + 5], 4, -378558);
    d = hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = hh(d, a, b, c, x[i + 0], 11, -358537222);
    c = hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = hh(b, c, d, a, x[i + 2], 23, -995338651);
    a = ii(a, b, c, d, x[i + 0], 6, -198630844);
    d = ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = ii(b, c, d, a, x[i + 9], 21, -343485551);
    a = ad(a, olda);
    b = ad(b, oldb);
    c = ad(c, oldc);
    d = ad(d, oldd);
  }
  return rh(a) + rh(b) + rh(c) + rh(d);
}
const getInitData = () => ({
  searchFilters: [],
  panelFilters: [],
  search: "",
  prompts: /* @__PURE__ */ new Set(),
  promptsValue: null
});
class VocDataSet {
  constructor(type, repositoryType, uniqueId = Math.random().toString(), params = void 0) {
    this.type = type;
    this.repositoryType = repositoryType;
    this.uniqueId = uniqueId;
    this.params = params;
    this.loadQueueValueId = /* @__PURE__ */ new Set();
    this.value = void 0;
    this.data = reactive(getInitData());
    this.$cachedVoc = reactive({
      value: null
    });
    this.$cachedVocValues = reactive({
      value: {}
    });
    this.context = {};
    this.executeLoadValueIds = debounce(this.executeLoadValueIds.bind(this), 1);
    this.initPagination();
  }
  get typeOrRepository() {
    var _a;
    return (_a = this.type) != null ? _a : this.repositoryType.select_form;
  }
  get cachedVoc() {
    return this.$cachedVoc.value;
  }
  get cachedVocValues() {
    return this.$cachedVocValues.value;
  }
  setContext(context) {
    this.context = context;
  }
  clearCache() {
    this.initPagination();
    ApiService$1.clearCache(this.getKey());
    this.setCachedVoc(null);
    this.clearCachedVocValues();
    return this;
  }
  checkCache(prevKey, newKey) {
    if (prevKey === newKey) {
      return;
    }
    ApiService$1.clearCache(prevKey);
  }
  async get(paginationParams = this.pagination.params) {
    try {
      this.pagination.setLoading(true);
      const cacheKey = this.getKey(paginationParams);
      const voc = await ApiService$1.useCache(
        cacheKey,
        () => this.getVocDataSetData(paginationParams)
      );
      this.setPaginationParams(paginationParams);
      this.pagination.setLoading(false);
      this.setCachedVoc(voc);
      return voc;
    } catch (e) {
      this.pagination.setLoading(false);
      throw e;
    }
  }
  setPaginationParams(pagination) {
    const prevKey = this.getKey(this.pagination.params);
    this.pagination.setParams(pagination);
    const newKey = this.getKey(pagination);
    this.checkCache(prevKey, newKey);
  }
  setFilter(filter) {
    return this.setPaginationParamsPartial({
      filter: FilterFactory.getString(filter)
    });
  }
  setSort(sort) {
    return this.setPaginationParamsPartial({
      sort: SortFactory.getString(sort)
    });
  }
  setPaginationParamsPartial(paginationParams) {
    return this.setPaginationParams({
      ...this.pagination.params,
      ...paginationParams
    });
  }
  setDataAssign(data) {
    Object.assign(this.data, data);
  }
  async getCacheOrLoad() {
    const cacheKey = this.getKey();
    const cacheVoc = ApiService$1.getCache(cacheKey);
    if (!cacheVoc) {
      return this.get();
    }
    if (cacheVoc.loading) {
      return this.get();
    }
    if (this.cachedVoc !== cacheVoc.value) {
      Logger$1.warn(
        "load this.cachedVoc !== cacheVoc.value",
        this.cachedVoc,
        cacheVoc.value
      );
      if (cacheVoc.value instanceof Promise) {
        Logger$1.error("cacheVoc === promise!", this);
        return await cacheVoc.value;
      }
    }
    return cacheVoc.value;
  }
  reload() {
    this.clearCache();
    return this.get();
  }
  getVocValueDto(value_id) {
    var _a;
    if ((_a = this.cachedVoc) == null ? void 0 : _a.valuesDictByValueId[value_id]) {
      return this.cachedVoc.valuesDictByValueId[value_id];
    }
    return this.loadValueIds([value_id]).cachedVocValues[value_id];
  }
  loadValueIds(value_ids) {
    const notCachedValueIds = value_ids.filter(
      (value_id) => !(value_id in this.cachedVocValues)
    );
    if (notCachedValueIds.length === 0) {
      return this;
    }
    this.setCachedVocValues(notCachedValueIds, [], void 0);
    for (const notCachedValueId of notCachedValueIds) {
      this.loadQueueValueId.add(notCachedValueId);
    }
    this.executeLoadValueIds();
    return this;
  }
  executeLoadValueIds(resolve) {
    var _a, _b, _c, _d, _e;
    const valueIds = [...this.loadQueueValueId];
    if (valueIds.length === 0) {
      return;
    }
    this.loadQueueValueId.clear();
    const useSortAndFilter = ((_b = (_a = this.typeOrRepository.form) == null ? void 0 : _a.table.options) == null ? void 0 : _b.server_filter_sort) !== false;
    ApiService$1.getVocValuesByFilter(
      (_c = this.type) == null ? void 0 : _c.voc_type,
      valueIds,
      this.value,
      (_d = this.repositoryType.voc) == null ? void 0 : _d.config_url,
      (_e = this.repositoryType) == null ? void 0 : _e.data_url,
      this.context,
      useSortAndFilter
    ).then(({ json: vocValuesResult }) => {
      this.setCachedVocValues(valueIds, vocValuesResult.result, null);
      if (resolve) {
        resolve();
      }
    });
  }
  async paginationLoad(mode, tableDataSet, factory) {
    const paginationParams = PaginationHelper.getPaginationByMode(
      mode,
      this.pagination
    );
    if (!paginationParams) {
      return;
    }
    const dataSetData = await this.get(paginationParams);
    await this.initRows(dataSetData, tableDataSet, factory);
  }
  async initRows(dataSetData, tableDataSet, factory) {
    const tableRows = factory.setRows(
      dataSetData.values.map(
        (x) => VocDataSet.getAttrs(x, this.typeOrRepository)
      ),
      dataSetData.values
    ).getTableRows(tableDataSet.modelUnref);
    tableDataSet.initRows(tableRows);
    await this.updateValuesRemain(dataSetData, tableDataSet);
  }
  async updateValuesRemain(dataSetData, tableDataSet) {
    if (!dataSetData.lazyPaginationState) {
      return;
    }
    const pagination = this.pagination;
    pagination.setValuesRemain(dataSetData.lazyPaginationState.values_remain);
    tableDataSet.options.pagination = pagination;
  }
  async onChangeFilters(tableDataSet, factory) {
    if (!tableDataSet.isServerFilterAndSort) {
      this.setFilter(void 0);
      return;
    }
    this.pagination.setOffset(0).normaliseLimit();
    const filter = tableDataSet.getFilterLogicalObj();
    this.setFilter(filter);
    await this.onLoad(tableDataSet, factory);
  }
  async onChangeSort(tableDataSet, factory) {
    if (!tableDataSet.isServerFilterAndSort) {
      this.setSort(void 0);
      return;
    }
    this.pagination.setOffset(0).normaliseLimit();
    const sort = tableDataSet.getSort();
    this.setSort(sort);
    await this.onLoad(tableDataSet, factory);
  }
  async onLoad(tableDataSet, factory) {
    try {
      const dataSetData = await this.get();
      await this.initRows(dataSetData, tableDataSet, factory);
    } catch (e) {
      await ApiHelper.wrapNotifyError(e, {
        isError: true,
        title: "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0435 \u0441\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A\u0430"
      });
    }
  }
  destroy() {
    this.clearCache();
  }
  tableDataSetDestroy(tableDataSet) {
  }
  initPagination() {
    var _a, _b, _c, _d;
    if (!this.pagination) {
      const server_filter_sort = (_d = (_c = (_b = (_a = this.typeOrRepository.form) == null ? void 0 : _a.table) == null ? void 0 : _b.options) == null ? void 0 : _c.server_filter_sort) != null ? _d : true;
      const lazyLoadSize = isNumeric(this.repositoryType.lazy_load_size) && this.repositoryType.selection_mode !== "multiple" && server_filter_sort ? this.repositoryType.lazy_load_size : void 0;
      this.pagination = new TablePagination({
        lazyLoadSize
      });
    }
    this.pagination.setOffset(0);
  }
  setValue(value) {
    this.value = value;
  }
  static getAttrs(value, vocDto) {
    return vocDto.attrs_wrap === false ? value : value.attrs;
  }
  static setAttrs(value, newAttrs, vocDto) {
    if (vocDto.attrs_wrap === false) {
      Object.assign(value, newAttrs);
    } else {
      value.attrs = newAttrs;
    }
  }
  getValueId(value) {
    return VocDataSet.getValueId(this.typeOrRepository, value);
  }
  static getValueId(repository, value) {
    var _a;
    return value[(_a = repository.value_attr) != null ? _a : "value_id"];
  }
  setCachedVoc(cachedVoc) {
    if (this.$cachedVoc.value !== cachedVoc) {
      this.$cachedVoc.value = cachedVoc;
    }
    return this;
  }
  clearCachedVocValues() {
    this.$cachedVocValues.value = {};
    return this;
  }
  setCachedVocValues(value_ids, vocValuesDto, missingValue) {
    if (value_ids.length === 0) {
      return this;
    }
    const vocValuesDict = vocValuesDto.reduce((dict, vocValueDto) => {
      dict[toStr(this.getValueId(vocValueDto))] = vocValueDto;
      return dict;
    }, {});
    for (const value_id of value_ids) {
      this.$cachedVocValues.value[value_id] = vocValuesDict[value_id] || missingValue;
    }
    return this;
  }
  getVocDataSetData(paginationParams = this.pagination.params) {
    var _a;
    return getModelVoc({
      voc_type: (_a = this.type) == null ? void 0 : _a.voc_type,
      listParams: {
        ...paginationParams,
        only_active: true
      },
      currentVocDataSetData: this.cachedVoc,
      value: this.value,
      repositoryType: this.repositoryType,
      context: this.context,
      params: this.params
    });
  }
  getKey(paginationParams = this.pagination.params) {
    var _a, _b;
    return toNormaliseDomId(
      md5(
        `voc-data-set-${(_b = (_a = this.type) == null ? void 0 : _a.voc_type) != null ? _b : this.repositoryType.data_url}_${this.uniqueId}_${TablePagination.getKey(paginationParams)}`
      )
    );
  }
}
const VOC_JOIN_SEPARATOR = ";";
function getVocValuesIdByCellValue(value) {
  if (Boolean(value) && typeof value === "string" && value.trim().length !== 0) {
    return value.split(VOC_JOIN_SEPARATOR).map((x) => x.trim());
  }
  return [];
}
const prototypeFunctions = /* @__PURE__ */ new Map();
prototypeFunctions.set(Map.prototype, (object) => {
  const map = object;
  const newMap = /* @__PURE__ */ new Map();
  map.forEach((value, key) => {
    newMap.set(copy(key), copy(value));
  });
  return newMap;
});
prototypeFunctions.set(Set.prototype, (object) => {
  const set2 = object;
  const newSet = /* @__PURE__ */ new Set();
  set2.forEach((value) => {
    newSet.add(copy(value));
  });
  return newSet;
});
function cloneDeep(object) {
  const cloning = {};
  const prototype = Object.getPrototypeOf(object);
  if (prototypeFunctions.has(prototype)) {
    return prototypeFunctions.get(prototype)(object);
  }
  Object.keys(object).map((prop) => {
    if (Array.isArray(object[prop])) {
      cloning[prop] = [].concat(object[prop]);
    } else if (!isNullOrUndefined(object[prop]) && typeof object[prop] === "object") {
      cloning[prop] = cloneDeep(object[prop]);
    } else {
      cloning[prop] = object[prop];
    }
  });
  return cloning;
}
function copy(obj) {
  if (isNullOrUndefined(obj)) {
    return obj;
  }
  if (typeof obj === "string") {
    return obj;
  }
  if (Array.isArray(obj)) {
    return obj.map((x) => copy(x));
  }
  if (typeof obj === "object") {
    return cloneDeep(obj);
  }
  return obj;
}
class PointerHelper {
  static incRow(pointer, count = 1) {
    if (pointer.row === void 0) {
      throw new Error(`incRow row undefined, ${toStr(pointer)}`);
    }
    return {
      ...pointer,
      row: pointer.row + count
    };
  }
  static getRequired(tableDataSet, pointer, params) {
    var _a, _b;
    const pointerResult = {
      col: isNullOrUndefined(pointer.col) ? -1 : pointer.col,
      row: isNullOrUndefined(pointer.row) ? -1 : pointer.row,
      col_name: isNullOrUndefined(pointer.col) ? pointer.col_name || "" : (_b = (_a = tableDataSet.getModelOrUndefined(pointer.col)) == null ? void 0 : _a.field) != null ? _b : "",
      visual_row: isNullOrUndefined(pointer.visual_row) ? -1 : pointer.visual_row
    };
    if (pointerResult.col_name) {
      if (pointerResult.col === -1) {
        pointerResult.col = tableDataSet.getColIndex(pointerResult.col_name);
      }
    }
    if (pointerResult.visual_row === -1) {
      const tableRow = tableDataSet.getRowOrUndefined(pointerResult.row);
      const visualRow = tableRow == null ? void 0 : tableRow.visualRow;
      if (visualRow !== void 0) {
        pointerResult.visual_row = visualRow;
      } else {
        pointerResult.visual_row = pointerResult.row;
      }
    }
    if (pointerResult.row === -1) {
      if (pointerResult.visual_row != -1) {
        const tableRow = tableDataSet.getRowByVisualRow(
          pointerResult.visual_row
        );
        if (tableRow) {
          const row = tableRow.row;
          if (row !== void 0) {
            pointerResult.row = row;
          }
        }
      }
    }
    if (pointerResult.col === -1 || pointerResult.col === void 0) {
      throw new Error(
        `PointerHelper.getRequired pointer.col === ${pointerResult.col}`
      );
    }
    if (pointerResult.row === -1 || pointerResult.row === void 0) {
      throw new Error(
        `PointerHelper.getRequired pointer.row === ${pointerResult.row}`
      );
    }
    if (params) {
      if (params.resetVisualRow) {
        pointerResult.visual_row = pointerResult.row;
      }
    }
    return pointerResult;
  }
  static getRequiredOrUndefined(tableDataSet, pointer, params) {
    if (!pointer) {
      return void 0;
    }
    try {
      return PointerHelper.getRequired(tableDataSet, pointer, params);
    } catch {
      return void 0;
    }
  }
  static getKey(pointer) {
    if (typeof pointer === "string") {
      return pointer;
    }
    if (!pointer) {
      return "";
    }
    if (PointerHelper.isCellPointer(pointer)) {
      return `${pointer.row}_${pointer.col_name}`;
    }
    return `${pointer.row}`;
  }
  static isLocatedRange(cursor, tableDataSet) {
    if (tableDataSet.selected.isSelectedMode && tableDataSet.selected.start && tableDataSet.selected.cursor) {
      const pointer1 = tableDataSet.selected.start;
      const pointer2 = tableDataSet.selected.cursor;
      const minRow = Math.min(pointer1.row, pointer2.row);
      const maxRow = Math.max(pointer1.row, pointer2.row);
      const minCol = Math.min(pointer1.col, pointer2.col);
      const maxCol = Math.max(pointer1.col, pointer2.col);
      return cursor.row >= minRow && cursor.row <= maxRow && cursor.col >= minCol && cursor.col <= maxCol;
    }
    if (tableDataSet.selected.cursor) {
      return cursor.col === tableDataSet.selected.cursor.col && cursor.row === tableDataSet.selected.cursor.row;
    }
    return false;
  }
  static deleteVisualRow(pointer, isCopy = false) {
    if (pointer) {
      if (isCopy) {
        pointer = copy(pointer);
      }
      if (isObject(pointer) && "visual_row" in pointer) {
        delete pointer.visual_row;
      }
    }
    return pointer;
  }
  static getServerFormatManual(row, col_name) {
    return {
      row,
      col_name
    };
  }
  static getServerFormat(pointer) {
    if (isNullOrUndefined(pointer)) {
      return pointer;
    }
    return {
      col_name: pointer.col_name,
      row: pointer.row
    };
  }
  static isCellPointer(pointer) {
    if (typeof pointer !== "object") {
      return false;
    }
    return ("col_name" in pointer || "col" in pointer) && !isNullOrUndefined(pointer["row"]);
  }
  static isRowPointer(pointer) {
    if (!pointer || typeof pointer !== "object") {
      return false;
    }
    return !PointerHelper.isCellPointer(pointer) && !isNullOrUndefined(pointer.row);
  }
  static isEqualByServerFormat(pointer, pointer2) {
    return pointer.row === pointer2.row && pointer.col_name === pointer2.col_name;
  }
}
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function commonjsRequire(path) {
  throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var moment$1 = { exports: {} };
(function(module, exports) {
  (function(global2, factory) {
    module.exports = factory();
  })(commonjsGlobal, function() {
    var hookCallback;
    function hooks() {
      return hookCallback.apply(null, arguments);
    }
    function setHookCallback(callback) {
      hookCallback = callback;
    }
    function isArray(input) {
      return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject2(input) {
      return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
      return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
      if (Object.getOwnPropertyNames) {
        return Object.getOwnPropertyNames(obj).length === 0;
      } else {
        var k;
        for (k in obj) {
          if (hasOwnProp(obj, k)) {
            return false;
          }
        }
        return true;
      }
    }
    function isUndefined(input) {
      return input === void 0;
    }
    function isNumber(input) {
      return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
      return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
      var res = [], i, arrLen = arr.length;
      for (i = 0; i < arrLen; ++i) {
        res.push(fn(arr[i], i));
      }
      return res;
    }
    function extend(a, b) {
      for (var i in b) {
        if (hasOwnProp(b, i)) {
          a[i] = b[i];
        }
      }
      if (hasOwnProp(b, "toString")) {
        a.toString = b.toString;
      }
      if (hasOwnProp(b, "valueOf")) {
        a.valueOf = b.valueOf;
      }
      return a;
    }
    function createUTC(input, format2, locale2, strict) {
      return createLocalOrUTC(input, format2, locale2, strict, true).utc();
    }
    function defaultParsingFlags() {
      return {
        empty: false,
        unusedTokens: [],
        unusedInput: [],
        overflow: -2,
        charsLeftOver: 0,
        nullInput: false,
        invalidEra: null,
        invalidMonth: null,
        invalidFormat: false,
        userInvalidated: false,
        iso: false,
        parsedDateParts: [],
        era: null,
        meridiem: null,
        rfc2822: false,
        weekdayMismatch: false
      };
    }
    function getParsingFlags(m) {
      if (m._pf == null) {
        m._pf = defaultParsingFlags();
      }
      return m._pf;
    }
    var some;
    if (Array.prototype.some) {
      some = Array.prototype.some;
    } else {
      some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for (i = 0; i < len; i++) {
          if (i in t && fun.call(this, t[i], i, t)) {
            return true;
          }
        }
        return false;
      };
    }
    function isValid(m) {
      if (m._isValid == null) {
        var flags = getParsingFlags(m), parsedParts = some.call(flags.parsedDateParts, function(i) {
          return i != null;
        }), isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
        if (m._strict) {
          isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === void 0;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) {
          m._isValid = isNowValid;
        } else {
          return isNowValid;
        }
      }
      return m._isValid;
    }
    function createInvalid(flags) {
      var m = createUTC(NaN);
      if (flags != null) {
        extend(getParsingFlags(m), flags);
      } else {
        getParsingFlags(m).userInvalidated = true;
      }
      return m;
    }
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to2, from2) {
      var i, prop, val, momentPropertiesLen = momentProperties.length;
      if (!isUndefined(from2._isAMomentObject)) {
        to2._isAMomentObject = from2._isAMomentObject;
      }
      if (!isUndefined(from2._i)) {
        to2._i = from2._i;
      }
      if (!isUndefined(from2._f)) {
        to2._f = from2._f;
      }
      if (!isUndefined(from2._l)) {
        to2._l = from2._l;
      }
      if (!isUndefined(from2._strict)) {
        to2._strict = from2._strict;
      }
      if (!isUndefined(from2._tzm)) {
        to2._tzm = from2._tzm;
      }
      if (!isUndefined(from2._isUTC)) {
        to2._isUTC = from2._isUTC;
      }
      if (!isUndefined(from2._offset)) {
        to2._offset = from2._offset;
      }
      if (!isUndefined(from2._pf)) {
        to2._pf = getParsingFlags(from2);
      }
      if (!isUndefined(from2._locale)) {
        to2._locale = from2._locale;
      }
      if (momentPropertiesLen > 0) {
        for (i = 0; i < momentPropertiesLen; i++) {
          prop = momentProperties[i];
          val = from2[prop];
          if (!isUndefined(val)) {
            to2[prop] = val;
          }
        }
      }
      return to2;
    }
    function Moment(config) {
      copyConfig(this, config);
      this._d = new Date(config._d != null ? config._d.getTime() : NaN);
      if (!this.isValid()) {
        this._d = new Date(NaN);
      }
      if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
      }
    }
    function isMoment(obj) {
      return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
      if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) {
        console.warn("Deprecation warning: " + msg);
      }
    }
    function deprecate(msg, fn) {
      var firstTime = true;
      return extend(function() {
        if (hooks.deprecationHandler != null) {
          hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
          var args = [], arg, i, key, argLen = arguments.length;
          for (i = 0; i < argLen; i++) {
            arg = "";
            if (typeof arguments[i] === "object") {
              arg += "\n[" + i + "] ";
              for (key in arguments[0]) {
                if (hasOwnProp(arguments[0], key)) {
                  arg += key + ": " + arguments[0][key] + ", ";
                }
              }
              arg = arg.slice(0, -2);
            } else {
              arg = arguments[i];
            }
            args.push(arg);
          }
          warn(
            msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack
          );
          firstTime = false;
        }
        return fn.apply(this, arguments);
      }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
      if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
      }
      if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
      }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
      return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set2(config) {
      var prop, i;
      for (i in config) {
        if (hasOwnProp(config, i)) {
          prop = config[i];
          if (isFunction(prop)) {
            this[i] = prop;
          } else {
            this["_" + i] = prop;
          }
        }
      }
      this._config = config;
      this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
      );
    }
    function mergeConfigs(parentConfig, childConfig) {
      var res = extend({}, parentConfig), prop;
      for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
          if (isObject2(parentConfig[prop]) && isObject2(childConfig[prop])) {
            res[prop] = {};
            extend(res[prop], parentConfig[prop]);
            extend(res[prop], childConfig[prop]);
          } else if (childConfig[prop] != null) {
            res[prop] = childConfig[prop];
          } else {
            delete res[prop];
          }
        }
      }
      for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject2(parentConfig[prop])) {
          res[prop] = extend({}, res[prop]);
        }
      }
      return res;
    }
    function Locale(config) {
      if (config != null) {
        this.set(config);
      }
    }
    var keys2;
    if (Object.keys) {
      keys2 = Object.keys;
    } else {
      keys2 = function(obj) {
        var i, res = [];
        for (i in obj) {
          if (hasOwnProp(obj, i)) {
            res.push(i);
          }
        }
        return res;
      };
    }
    var defaultCalendar = {
      sameDay: "[Today at] LT",
      nextDay: "[Tomorrow at] LT",
      nextWeek: "dddd [at] LT",
      lastDay: "[Yesterday at] LT",
      lastWeek: "[Last] dddd [at] LT",
      sameElse: "L"
    };
    function calendar(key, mom, now2) {
      var output = this._calendar[key] || this._calendar["sameElse"];
      return isFunction(output) ? output.call(mom, now2) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
      var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign2 = number >= 0;
      return (sign2 ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    function addFormatToken(token2, padded, ordinal2, callback) {
      var func = callback;
      if (typeof callback === "string") {
        func = function() {
          return this[callback]();
        };
      }
      if (token2) {
        formatTokenFunctions[token2] = func;
      }
      if (padded) {
        formatTokenFunctions[padded[0]] = function() {
          return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
      }
      if (ordinal2) {
        formatTokenFunctions[ordinal2] = function() {
          return this.localeData().ordinal(
            func.apply(this, arguments),
            token2
          );
        };
      }
    }
    function removeFormattingTokens(input) {
      if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, "");
      }
      return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format2) {
      var array = format2.match(formattingTokens), i, length;
      for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
          array[i] = formatTokenFunctions[array[i]];
        } else {
          array[i] = removeFormattingTokens(array[i]);
        }
      }
      return function(mom) {
        var output = "", i2;
        for (i2 = 0; i2 < length; i2++) {
          output += isFunction(array[i2]) ? array[i2].call(mom, format2) : array[i2];
        }
        return output;
      };
    }
    function formatMoment(m, format2) {
      if (!m.isValid()) {
        return m.localeData().invalidDate();
      }
      format2 = expandFormat(format2, m.localeData());
      formatFunctions[format2] = formatFunctions[format2] || makeFormatFunction(format2);
      return formatFunctions[format2](m);
    }
    function expandFormat(format2, locale2) {
      var i = 5;
      function replaceLongDateFormatTokens(input) {
        return locale2.longDateFormat(input) || input;
      }
      localFormattingTokens.lastIndex = 0;
      while (i >= 0 && localFormattingTokens.test(format2)) {
        format2 = format2.replace(
          localFormattingTokens,
          replaceLongDateFormatTokens
        );
        localFormattingTokens.lastIndex = 0;
        i -= 1;
      }
      return format2;
    }
    var defaultLongDateFormat = {
      LTS: "h:mm:ss A",
      LT: "h:mm A",
      L: "MM/DD/YYYY",
      LL: "MMMM D, YYYY",
      LLL: "MMMM D, YYYY h:mm A",
      LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
      var format2 = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
      if (format2 || !formatUpper) {
        return format2;
      }
      this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
        if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") {
          return tok.slice(1);
        }
        return tok;
      }).join("");
      return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
      return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
      return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
      future: "in %s",
      past: "%s ago",
      s: "a few seconds",
      ss: "%d seconds",
      m: "a minute",
      mm: "%d minutes",
      h: "an hour",
      hh: "%d hours",
      d: "a day",
      dd: "%d days",
      w: "a week",
      ww: "%d weeks",
      M: "a month",
      MM: "%d months",
      y: "a year",
      yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
      var output = this._relativeTime[string];
      return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff2, output) {
      var format2 = this._relativeTime[diff2 > 0 ? "future" : "past"];
      return isFunction(format2) ? format2(output) : format2.replace(/%s/i, output);
    }
    var aliases = {};
    function addUnitAlias(unit, shorthand) {
      var lowerCase = unit.toLowerCase();
      aliases[lowerCase] = aliases[lowerCase + "s"] = aliases[shorthand] = unit;
    }
    function normalizeUnits(units) {
      return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : void 0;
    }
    function normalizeObjectUnits(inputObject) {
      var normalizedInput = {}, normalizedProp, prop;
      for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
          normalizedProp = normalizeUnits(prop);
          if (normalizedProp) {
            normalizedInput[normalizedProp] = inputObject[prop];
          }
        }
      }
      return normalizedInput;
    }
    var priorities = {};
    function addUnitPriority(unit, priority) {
      priorities[unit] = priority;
    }
    function getPrioritizedUnits(unitsObj) {
      var units = [], u;
      for (u in unitsObj) {
        if (hasOwnProp(unitsObj, u)) {
          units.push({ unit: u, priority: priorities[u] });
        }
      }
      units.sort(function(a, b) {
        return a.priority - b.priority;
      });
      return units;
    }
    function isLeapYear(year) {
      return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    function absFloor(number) {
      if (number < 0) {
        return Math.ceil(number) || 0;
      } else {
        return Math.floor(number);
      }
    }
    function toInt(argumentForCoercion) {
      var coercedNumber = +argumentForCoercion, value = 0;
      if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
      }
      return value;
    }
    function makeGetSet(unit, keepTime) {
      return function(value) {
        if (value != null) {
          set$1(this, unit, value);
          hooks.updateOffset(this, keepTime);
          return this;
        } else {
          return get2(this, unit);
        }
      };
    }
    function get2(mom, unit) {
      return mom.isValid() ? mom._d["get" + (mom._isUTC ? "UTC" : "") + unit]() : NaN;
    }
    function set$1(mom, unit, value) {
      if (mom.isValid() && !isNaN(value)) {
        if (unit === "FullYear" && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
          value = toInt(value);
          mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](
            value,
            mom.month(),
            daysInMonth(value, mom.month())
          );
        } else {
          mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value);
        }
      }
    }
    function stringGet(units) {
      units = normalizeUnits(units);
      if (isFunction(this[units])) {
        return this[units]();
      }
      return this;
    }
    function stringSet(units, value) {
      if (typeof units === "object") {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
        for (i = 0; i < prioritizedLen; i++) {
          this[prioritized[i].unit](units[prioritized[i].unit]);
        }
      } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
          return this[units](value);
        }
      }
      return this;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, regexes;
    regexes = {};
    function addRegexToken(token2, regex, strictRegex) {
      regexes[token2] = isFunction(regex) ? regex : function(isStrict, localeData2) {
        return isStrict && strictRegex ? strictRegex : regex;
      };
    }
    function getParseRegexForToken(token2, config) {
      if (!hasOwnProp(regexes, token2)) {
        return new RegExp(unescapeFormat(token2));
      }
      return regexes[token2](config._strict, config._locale);
    }
    function unescapeFormat(s) {
      return regexEscape(
        s.replace("\\", "").replace(
          /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
          function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
          }
        )
      );
    }
    function regexEscape(s) {
      return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    var tokens = {};
    function addParseToken(token2, callback) {
      var i, func = callback, tokenLen;
      if (typeof token2 === "string") {
        token2 = [token2];
      }
      if (isNumber(callback)) {
        func = function(input, array) {
          array[callback] = toInt(input);
        };
      }
      tokenLen = token2.length;
      for (i = 0; i < tokenLen; i++) {
        tokens[token2[i]] = func;
      }
    }
    function addWeekParseToken(token2, callback) {
      addParseToken(token2, function(input, array, config, token3) {
        config._w = config._w || {};
        callback(input, config._w, config, token3);
      });
    }
    function addTimeToArrayFromToken(token2, input, config) {
      if (input != null && hasOwnProp(tokens, token2)) {
        tokens[token2](input, config._a, config, token2);
      }
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    function mod(n, x) {
      return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) {
      indexOf = Array.prototype.indexOf;
    } else {
      indexOf = function(o) {
        var i;
        for (i = 0; i < this.length; ++i) {
          if (this[i] === o) {
            return i;
          }
        }
        return -1;
      };
    }
    function daysInMonth(year, month) {
      if (isNaN(year) || isNaN(month)) {
        return NaN;
      }
      var modMonth = mod(month, 12);
      year += (month - modMonth) / 12;
      return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    addFormatToken("M", ["MM", 2], "Mo", function() {
      return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format2) {
      return this.localeData().monthsShort(this, format2);
    });
    addFormatToken("MMMM", 0, 0, function(format2) {
      return this.localeData().months(this, format2);
    });
    addUnitAlias("month", "M");
    addUnitPriority("month", 8);
    addRegexToken("M", match1to2);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale2) {
      return locale2.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale2) {
      return locale2.monthsRegex(isStrict);
    });
    addParseToken(["M", "MM"], function(input, array) {
      array[MONTH] = toInt(input) - 1;
    });
    addParseToken(["MMM", "MMMM"], function(input, array, config, token2) {
      var month = config._locale.monthsParse(input, token2, config._strict);
      if (month != null) {
        array[MONTH] = month;
      } else {
        getParsingFlags(config).invalidMonth = input;
      }
    });
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split(
      "_"
    ), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format2) {
      if (!m) {
        return isArray(this._months) ? this._months : this._months["standalone"];
      }
      return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format2) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format2) {
      if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
      }
      return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format2) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format2, strict) {
      var i, ii, mom, llc = monthName.toLocaleLowerCase();
      if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
          mom = createUTC([2e3, i]);
          this._shortMonthsParse[i] = this.monthsShort(
            mom,
            ""
          ).toLocaleLowerCase();
          this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
        }
      }
      if (strict) {
        if (format2 === "MMM") {
          ii = indexOf.call(this._shortMonthsParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._longMonthsParse, llc);
          return ii !== -1 ? ii : null;
        }
      } else {
        if (format2 === "MMM") {
          ii = indexOf.call(this._shortMonthsParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._longMonthsParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._longMonthsParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._shortMonthsParse, llc);
          return ii !== -1 ? ii : null;
        }
      }
    }
    function localeMonthsParse(monthName, format2, strict) {
      var i, mom, regex;
      if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format2, strict);
      }
      if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
      }
      for (i = 0; i < 12; i++) {
        mom = createUTC([2e3, i]);
        if (strict && !this._longMonthsParse[i]) {
          this._longMonthsParse[i] = new RegExp(
            "^" + this.months(mom, "").replace(".", "") + "$",
            "i"
          );
          this._shortMonthsParse[i] = new RegExp(
            "^" + this.monthsShort(mom, "").replace(".", "") + "$",
            "i"
          );
        }
        if (!strict && !this._monthsParse[i]) {
          regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
          this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
        }
        if (strict && format2 === "MMMM" && this._longMonthsParse[i].test(monthName)) {
          return i;
        } else if (strict && format2 === "MMM" && this._shortMonthsParse[i].test(monthName)) {
          return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
          return i;
        }
      }
    }
    function setMonth(mom, value) {
      var dayOfMonth;
      if (!mom.isValid()) {
        return mom;
      }
      if (typeof value === "string") {
        if (/^\d+$/.test(value)) {
          value = toInt(value);
        } else {
          value = mom.localeData().monthsParse(value);
          if (!isNumber(value)) {
            return mom;
          }
        }
      }
      dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
      mom._d["set" + (mom._isUTC ? "UTC" : "") + "Month"](value, dayOfMonth);
      return mom;
    }
    function getSetMonth(value) {
      if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
      } else {
        return get2(this, "Month");
      }
    }
    function getDaysInMonth() {
      return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
      if (this._monthsParseExact) {
        if (!hasOwnProp(this, "_monthsRegex")) {
          computeMonthsParse.call(this);
        }
        if (isStrict) {
          return this._monthsShortStrictRegex;
        } else {
          return this._monthsShortRegex;
        }
      } else {
        if (!hasOwnProp(this, "_monthsShortRegex")) {
          this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
      }
    }
    function monthsRegex(isStrict) {
      if (this._monthsParseExact) {
        if (!hasOwnProp(this, "_monthsRegex")) {
          computeMonthsParse.call(this);
        }
        if (isStrict) {
          return this._monthsStrictRegex;
        } else {
          return this._monthsRegex;
        }
      } else {
        if (!hasOwnProp(this, "_monthsRegex")) {
          this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
      }
    }
    function computeMonthsParse() {
      function cmpLenRev(a, b) {
        return b.length - a.length;
      }
      var shortPieces = [], longPieces = [], mixedPieces = [], i, mom;
      for (i = 0; i < 12; i++) {
        mom = createUTC([2e3, i]);
        shortPieces.push(this.monthsShort(mom, ""));
        longPieces.push(this.months(mom, ""));
        mixedPieces.push(this.months(mom, ""));
        mixedPieces.push(this.monthsShort(mom, ""));
      }
      shortPieces.sort(cmpLenRev);
      longPieces.sort(cmpLenRev);
      mixedPieces.sort(cmpLenRev);
      for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
      }
      for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
      }
      this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
      this._monthsShortRegex = this._monthsRegex;
      this._monthsStrictRegex = new RegExp(
        "^(" + longPieces.join("|") + ")",
        "i"
      );
      this._monthsShortStrictRegex = new RegExp(
        "^(" + shortPieces.join("|") + ")",
        "i"
      );
    }
    addFormatToken("Y", 0, 0, function() {
      var y = this.year();
      return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, ["YY", 2], 0, function() {
      return this.year() % 100;
    });
    addFormatToken(0, ["YYYY", 4], 0, "year");
    addFormatToken(0, ["YYYYY", 5], 0, "year");
    addFormatToken(0, ["YYYYYY", 6, true], 0, "year");
    addUnitAlias("year", "y");
    addUnitPriority("year", 1);
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken(["YYYYY", "YYYYYY"], YEAR);
    addParseToken("YYYY", function(input, array) {
      array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
      array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
      array[YEAR] = parseInt(input, 10);
    });
    function daysInYear(year) {
      return isLeapYear(year) ? 366 : 365;
    }
    hooks.parseTwoDigitYear = function(input) {
      return toInt(input) + (toInt(input) > 68 ? 1900 : 2e3);
    };
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
      return isLeapYear(this.year());
    }
    function createDate(y, m, d, h, M, s, ms) {
      var date;
      if (y < 100 && y >= 0) {
        date = new Date(y + 400, m, d, h, M, s, ms);
        if (isFinite(date.getFullYear())) {
          date.setFullYear(y);
        }
      } else {
        date = new Date(y, m, d, h, M, s, ms);
      }
      return date;
    }
    function createUTCDate(y) {
      var date, args;
      if (y < 100 && y >= 0) {
        args = Array.prototype.slice.call(arguments);
        args[0] = y + 400;
        date = new Date(Date.UTC.apply(null, args));
        if (isFinite(date.getUTCFullYear())) {
          date.setUTCFullYear(y);
        }
      } else {
        date = new Date(Date.UTC.apply(null, arguments));
      }
      return date;
    }
    function firstWeekOffset(year, dow, doy) {
      var fwd = 7 + dow - doy, fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
      return -fwdlw + fwd - 1;
    }
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
      var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
      if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
      } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
      } else {
        resYear = year;
        resDayOfYear = dayOfYear;
      }
      return {
        year: resYear,
        dayOfYear: resDayOfYear
      };
    }
    function weekOfYear(mom, dow, doy) {
      var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
      if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
      } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
      } else {
        resYear = mom.year();
        resWeek = week;
      }
      return {
        week: resWeek,
        year: resYear
      };
    }
    function weeksInYear(year, dow, doy) {
      var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
      return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    addFormatToken("w", ["ww", 2], "wo", "week");
    addFormatToken("W", ["WW", 2], "Wo", "isoWeek");
    addUnitAlias("week", "w");
    addUnitAlias("isoWeek", "W");
    addUnitPriority("week", 5);
    addUnitPriority("isoWeek", 5);
    addRegexToken("w", match1to2);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken(
      ["w", "ww", "W", "WW"],
      function(input, week, config, token2) {
        week[token2.substr(0, 1)] = toInt(input);
      }
    );
    function localeWeek(mom) {
      return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
      dow: 0,
      doy: 6
    };
    function localeFirstDayOfWeek() {
      return this._week.dow;
    }
    function localeFirstDayOfYear() {
      return this._week.doy;
    }
    function getSetWeek(input) {
      var week = this.localeData().week(this);
      return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
      var week = weekOfYear(this, 1, 4).week;
      return input == null ? week : this.add((input - week) * 7, "d");
    }
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format2) {
      return this.localeData().weekdaysMin(this, format2);
    });
    addFormatToken("ddd", 0, 0, function(format2) {
      return this.localeData().weekdaysShort(this, format2);
    });
    addFormatToken("dddd", 0, 0, function(format2) {
      return this.localeData().weekdays(this, format2);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    addUnitAlias("day", "d");
    addUnitAlias("weekday", "e");
    addUnitAlias("isoWeekday", "E");
    addUnitPriority("day", 11);
    addUnitPriority("weekday", 11);
    addUnitPriority("isoWeekday", 11);
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale2) {
      return locale2.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale2) {
      return locale2.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale2) {
      return locale2.weekdaysRegex(isStrict);
    });
    addWeekParseToken(["dd", "ddd", "dddd"], function(input, week, config, token2) {
      var weekday = config._locale.weekdaysParse(input, token2, config._strict);
      if (weekday != null) {
        week.d = weekday;
      } else {
        getParsingFlags(config).invalidWeekday = input;
      }
    });
    addWeekParseToken(["d", "e", "E"], function(input, week, config, token2) {
      week[token2] = toInt(input);
    });
    function parseWeekday(input, locale2) {
      if (typeof input !== "string") {
        return input;
      }
      if (!isNaN(input)) {
        return parseInt(input, 10);
      }
      input = locale2.weekdaysParse(input);
      if (typeof input === "number") {
        return input;
      }
      return null;
    }
    function parseIsoWeekday(input, locale2) {
      if (typeof input === "string") {
        return locale2.weekdaysParse(input) % 7 || 7;
      }
      return isNaN(input) ? null : input;
    }
    function shiftWeekdays(ws, n) {
      return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format2) {
      var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format2) ? "format" : "standalone"];
      return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
      return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
      return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format2, strict) {
      var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
      if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];
        for (i = 0; i < 7; ++i) {
          mom = createUTC([2e3, 1]).day(i);
          this._minWeekdaysParse[i] = this.weekdaysMin(
            mom,
            ""
          ).toLocaleLowerCase();
          this._shortWeekdaysParse[i] = this.weekdaysShort(
            mom,
            ""
          ).toLocaleLowerCase();
          this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
        }
      }
      if (strict) {
        if (format2 === "dddd") {
          ii = indexOf.call(this._weekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else if (format2 === "ddd") {
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        }
      } else {
        if (format2 === "dddd") {
          ii = indexOf.call(this._weekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else if (format2 === "ddd") {
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._weekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._minWeekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._weekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        }
      }
    }
    function localeWeekdaysParse(weekdayName, format2, strict) {
      var i, mom, regex;
      if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format2, strict);
      }
      if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
      }
      for (i = 0; i < 7; i++) {
        mom = createUTC([2e3, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
          this._fullWeekdaysParse[i] = new RegExp(
            "^" + this.weekdays(mom, "").replace(".", "\\.?") + "$",
            "i"
          );
          this._shortWeekdaysParse[i] = new RegExp(
            "^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$",
            "i"
          );
          this._minWeekdaysParse[i] = new RegExp(
            "^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$",
            "i"
          );
        }
        if (!this._weekdaysParse[i]) {
          regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
          this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
        }
        if (strict && format2 === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) {
          return i;
        } else if (strict && format2 === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) {
          return i;
        } else if (strict && format2 === "dd" && this._minWeekdaysParse[i].test(weekdayName)) {
          return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
          return i;
        }
      }
    }
    function getSetDayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }
      var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
      if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, "d");
      } else {
        return day;
      }
    }
    function getSetLocaleDayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }
      var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
      return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }
      if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
      } else {
        return this.day() || 7;
      }
    }
    function weekdaysRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, "_weekdaysRegex")) {
          computeWeekdaysParse.call(this);
        }
        if (isStrict) {
          return this._weekdaysStrictRegex;
        } else {
          return this._weekdaysRegex;
        }
      } else {
        if (!hasOwnProp(this, "_weekdaysRegex")) {
          this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
      }
    }
    function weekdaysShortRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, "_weekdaysRegex")) {
          computeWeekdaysParse.call(this);
        }
        if (isStrict) {
          return this._weekdaysShortStrictRegex;
        } else {
          return this._weekdaysShortRegex;
        }
      } else {
        if (!hasOwnProp(this, "_weekdaysShortRegex")) {
          this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
      }
    }
    function weekdaysMinRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, "_weekdaysRegex")) {
          computeWeekdaysParse.call(this);
        }
        if (isStrict) {
          return this._weekdaysMinStrictRegex;
        } else {
          return this._weekdaysMinRegex;
        }
      } else {
        if (!hasOwnProp(this, "_weekdaysMinRegex")) {
          this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
      }
    }
    function computeWeekdaysParse() {
      function cmpLenRev(a, b) {
        return b.length - a.length;
      }
      var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
      for (i = 0; i < 7; i++) {
        mom = createUTC([2e3, 1]).day(i);
        minp = regexEscape(this.weekdaysMin(mom, ""));
        shortp = regexEscape(this.weekdaysShort(mom, ""));
        longp = regexEscape(this.weekdays(mom, ""));
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
      }
      minPieces.sort(cmpLenRev);
      shortPieces.sort(cmpLenRev);
      longPieces.sort(cmpLenRev);
      mixedPieces.sort(cmpLenRev);
      this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
      this._weekdaysShortRegex = this._weekdaysRegex;
      this._weekdaysMinRegex = this._weekdaysRegex;
      this._weekdaysStrictRegex = new RegExp(
        "^(" + longPieces.join("|") + ")",
        "i"
      );
      this._weekdaysShortStrictRegex = new RegExp(
        "^(" + shortPieces.join("|") + ")",
        "i"
      );
      this._weekdaysMinStrictRegex = new RegExp(
        "^(" + minPieces.join("|") + ")",
        "i"
      );
    }
    function hFormat() {
      return this.hours() % 12 || 12;
    }
    function kFormat() {
      return this.hours() || 24;
    }
    addFormatToken("H", ["HH", 2], 0, "hour");
    addFormatToken("h", ["hh", 2], 0, hFormat);
    addFormatToken("k", ["kk", 2], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
      return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
      return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
      return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
      return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token2, lowercase) {
      addFormatToken(token2, 0, 0, function() {
        return this.localeData().meridiem(
          this.hours(),
          this.minutes(),
          lowercase
        );
      });
    }
    meridiem("a", true);
    meridiem("A", false);
    addUnitAlias("hour", "h");
    addUnitPriority("hour", 13);
    function matchMeridiem(isStrict, locale2) {
      return locale2._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2);
    addRegexToken("h", match1to2);
    addRegexToken("k", match1to2);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken(["H", "HH"], HOUR);
    addParseToken(["k", "kk"], function(input, array, config) {
      var kInput = toInt(input);
      array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(["a", "A"], function(input, array, config) {
      config._isPm = config._locale.isPM(input);
      config._meridiem = input;
    });
    addParseToken(["h", "hh"], function(input, array, config) {
      array[HOUR] = toInt(input);
      getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
      var pos = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos));
      array[MINUTE] = toInt(input.substr(pos));
      getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
      var pos1 = input.length - 4, pos2 = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos1));
      array[MINUTE] = toInt(input.substr(pos1, 2));
      array[SECOND] = toInt(input.substr(pos2));
      getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
      var pos = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos));
      array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
      var pos1 = input.length - 4, pos2 = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos1));
      array[MINUTE] = toInt(input.substr(pos1, 2));
      array[SECOND] = toInt(input.substr(pos2));
    });
    function localeIsPM(input) {
      return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours2, minutes2, isLower) {
      if (hours2 > 11) {
        return isLower ? "pm" : "PM";
      } else {
        return isLower ? "am" : "AM";
      }
    }
    var baseConfig = {
      calendar: defaultCalendar,
      longDateFormat: defaultLongDateFormat,
      invalidDate: defaultInvalidDate,
      ordinal: defaultOrdinal,
      dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
      relativeTime: defaultRelativeTime,
      months: defaultLocaleMonths,
      monthsShort: defaultLocaleMonthsShort,
      week: defaultLocaleWeek,
      weekdays: defaultLocaleWeekdays,
      weekdaysMin: defaultLocaleWeekdaysMin,
      weekdaysShort: defaultLocaleWeekdaysShort,
      meridiemParse: defaultLocaleMeridiemParse
    };
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
      var i, minl = Math.min(arr1.length, arr2.length);
      for (i = 0; i < minl; i += 1) {
        if (arr1[i] !== arr2[i]) {
          return i;
        }
      }
      return minl;
    }
    function normalizeLocale(key) {
      return key ? key.toLowerCase().replace("_", "-") : key;
    }
    function chooseLocale(names) {
      var i = 0, j, next, locale2, split;
      while (i < names.length) {
        split = normalizeLocale(names[i]).split("-");
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split("-") : null;
        while (j > 0) {
          locale2 = loadLocale(split.slice(0, j).join("-"));
          if (locale2) {
            return locale2;
          }
          if (next && next.length >= j && commonPrefix(split, next) >= j - 1) {
            break;
          }
          j--;
        }
        i++;
      }
      return globalLocale;
    }
    function isLocaleNameSane(name) {
      return name.match("^[^/\\\\]*$") != null;
    }
    function loadLocale(name) {
      var oldLocale = null, aliasedRequire;
      if (locales[name] === void 0 && true && module && module.exports && isLocaleNameSane(name)) {
        try {
          oldLocale = globalLocale._abbr;
          aliasedRequire = commonjsRequire;
          aliasedRequire("./locale/" + name);
          getSetGlobalLocale(oldLocale);
        } catch (e) {
          locales[name] = null;
        }
      }
      return locales[name];
    }
    function getSetGlobalLocale(key, values) {
      var data;
      if (key) {
        if (isUndefined(values)) {
          data = getLocale(key);
        } else {
          data = defineLocale(key, values);
        }
        if (data) {
          globalLocale = data;
        } else {
          if (typeof console !== "undefined" && console.warn) {
            console.warn(
              "Locale " + key + " not found. Did you forget to load it?"
            );
          }
        }
      }
      return globalLocale._abbr;
    }
    function defineLocale(name, config) {
      if (config !== null) {
        var locale2, parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
          deprecateSimple(
            "defineLocaleOverride",
            "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
          );
          parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
          if (locales[config.parentLocale] != null) {
            parentConfig = locales[config.parentLocale]._config;
          } else {
            locale2 = loadLocale(config.parentLocale);
            if (locale2 != null) {
              parentConfig = locale2._config;
            } else {
              if (!localeFamilies[config.parentLocale]) {
                localeFamilies[config.parentLocale] = [];
              }
              localeFamilies[config.parentLocale].push({
                name,
                config
              });
              return null;
            }
          }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));
        if (localeFamilies[name]) {
          localeFamilies[name].forEach(function(x) {
            defineLocale(x.name, x.config);
          });
        }
        getSetGlobalLocale(name);
        return locales[name];
      } else {
        delete locales[name];
        return null;
      }
    }
    function updateLocale(name, config) {
      if (config != null) {
        var locale2, tmpLocale, parentConfig = baseConfig;
        if (locales[name] != null && locales[name].parentLocale != null) {
          locales[name].set(mergeConfigs(locales[name]._config, config));
        } else {
          tmpLocale = loadLocale(name);
          if (tmpLocale != null) {
            parentConfig = tmpLocale._config;
          }
          config = mergeConfigs(parentConfig, config);
          if (tmpLocale == null) {
            config.abbr = name;
          }
          locale2 = new Locale(config);
          locale2.parentLocale = locales[name];
          locales[name] = locale2;
        }
        getSetGlobalLocale(name);
      } else {
        if (locales[name] != null) {
          if (locales[name].parentLocale != null) {
            locales[name] = locales[name].parentLocale;
            if (name === getSetGlobalLocale()) {
              getSetGlobalLocale(name);
            }
          } else if (locales[name] != null) {
            delete locales[name];
          }
        }
      }
      return locales[name];
    }
    function getLocale(key) {
      var locale2;
      if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
      }
      if (!key) {
        return globalLocale;
      }
      if (!isArray(key)) {
        locale2 = loadLocale(key);
        if (locale2) {
          return locale2;
        }
        key = [key];
      }
      return chooseLocale(key);
    }
    function listLocales() {
      return keys2(locales);
    }
    function checkOverflow(m) {
      var overflow, a = m._a;
      if (a && getParsingFlags(m).overflow === -2) {
        overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
          overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
          overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
          overflow = WEEKDAY;
        }
        getParsingFlags(m).overflow = overflow;
      }
      return m;
    }
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
      ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
      ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
      ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
      ["GGGG-[W]WW", /\d{4}-W\d\d/, false],
      ["YYYY-DDD", /\d{4}-\d{3}/],
      ["YYYY-MM", /\d{4}-\d\d/, false],
      ["YYYYYYMMDD", /[+-]\d{10}/],
      ["YYYYMMDD", /\d{8}/],
      ["GGGG[W]WWE", /\d{4}W\d{3}/],
      ["GGGG[W]WW", /\d{4}W\d{2}/, false],
      ["YYYYDDD", /\d{7}/],
      ["YYYYMM", /\d{6}/, false],
      ["YYYY", /\d{4}/, false]
    ], isoTimes = [
      ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
      ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
      ["HH:mm:ss", /\d\d:\d\d:\d\d/],
      ["HH:mm", /\d\d:\d\d/],
      ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
      ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
      ["HHmmss", /\d\d\d\d\d\d/],
      ["HHmm", /\d\d\d\d/],
      ["HH", /\d\d/]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
      UT: 0,
      GMT: 0,
      EDT: -4 * 60,
      EST: -5 * 60,
      CDT: -5 * 60,
      CST: -6 * 60,
      MDT: -6 * 60,
      MST: -7 * 60,
      PDT: -7 * 60,
      PST: -8 * 60
    };
    function configFromISO(config) {
      var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat2, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
      if (match) {
        getParsingFlags(config).iso = true;
        for (i = 0, l = isoDatesLen; i < l; i++) {
          if (isoDates[i][1].exec(match[1])) {
            dateFormat2 = isoDates[i][0];
            allowTime = isoDates[i][2] !== false;
            break;
          }
        }
        if (dateFormat2 == null) {
          config._isValid = false;
          return;
        }
        if (match[3]) {
          for (i = 0, l = isoTimesLen; i < l; i++) {
            if (isoTimes[i][1].exec(match[3])) {
              timeFormat = (match[2] || " ") + isoTimes[i][0];
              break;
            }
          }
          if (timeFormat == null) {
            config._isValid = false;
            return;
          }
        }
        if (!allowTime && timeFormat != null) {
          config._isValid = false;
          return;
        }
        if (match[4]) {
          if (tzRegex.exec(match[4])) {
            tzFormat = "Z";
          } else {
            config._isValid = false;
            return;
          }
        }
        config._f = dateFormat2 + (timeFormat || "") + (tzFormat || "");
        configFromStringAndFormat(config);
      } else {
        config._isValid = false;
      }
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
      var result = [
        untruncateYear(yearStr),
        defaultLocaleMonthsShort.indexOf(monthStr),
        parseInt(dayStr, 10),
        parseInt(hourStr, 10),
        parseInt(minuteStr, 10)
      ];
      if (secondStr) {
        result.push(parseInt(secondStr, 10));
      }
      return result;
    }
    function untruncateYear(yearStr) {
      var year = parseInt(yearStr, 10);
      if (year <= 49) {
        return 2e3 + year;
      } else if (year <= 999) {
        return 1900 + year;
      }
      return year;
    }
    function preprocessRFC2822(s) {
      return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
      if (weekdayStr) {
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(
          parsedInput[0],
          parsedInput[1],
          parsedInput[2]
        ).getDay();
        if (weekdayProvided !== weekdayActual) {
          getParsingFlags(config).weekdayMismatch = true;
          config._isValid = false;
          return false;
        }
      }
      return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
      if (obsOffset) {
        return obsOffsets[obsOffset];
      } else if (militaryOffset) {
        return 0;
      } else {
        var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
        return h * 60 + m;
      }
    }
    function configFromRFC2822(config) {
      var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
      if (match) {
        parsedArray = extractFromRFC2822Strings(
          match[4],
          match[3],
          match[2],
          match[5],
          match[6],
          match[7]
        );
        if (!checkWeekday(match[1], parsedArray, config)) {
          return;
        }
        config._a = parsedArray;
        config._tzm = calculateOffset(match[8], match[9], match[10]);
        config._d = createUTCDate.apply(null, config._a);
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        getParsingFlags(config).rfc2822 = true;
      } else {
        config._isValid = false;
      }
    }
    function configFromString(config) {
      var matched = aspNetJsonRegex.exec(config._i);
      if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
      }
      configFromISO(config);
      if (config._isValid === false) {
        delete config._isValid;
      } else {
        return;
      }
      configFromRFC2822(config);
      if (config._isValid === false) {
        delete config._isValid;
      } else {
        return;
      }
      if (config._strict) {
        config._isValid = false;
      } else {
        hooks.createFromInputFallback(config);
      }
    }
    hooks.createFromInputFallback = deprecate(
      "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
      function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
      }
    );
    function defaults(a, b, c) {
      if (a != null) {
        return a;
      }
      if (b != null) {
        return b;
      }
      return c;
    }
    function currentDateArray(config) {
      var nowValue = new Date(hooks.now());
      if (config._useUTC) {
        return [
          nowValue.getUTCFullYear(),
          nowValue.getUTCMonth(),
          nowValue.getUTCDate()
        ];
      }
      return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }
    function configFromArray(config) {
      var i, date, input = [], currentDate, expectedWeekday, yearToUse;
      if (config._d) {
        return;
      }
      currentDate = currentDateArray(config);
      if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
      }
      if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
          getParsingFlags(config)._overflowDayOfYear = true;
        }
        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
      }
      for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
      }
      for (; i < 7; i++) {
        config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
      }
      if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
      }
      config._d = (config._useUTC ? createUTCDate : createDate).apply(
        null,
        input
      );
      expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
      if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
      }
      if (config._nextDay) {
        config._a[HOUR] = 24;
      }
      if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) {
        getParsingFlags(config).weekdayMismatch = true;
      }
    }
    function dayOfYearFromWeekInfo(config) {
      var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
      w = config._w;
      if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;
        weekYear = defaults(
          w.GG,
          config._a[YEAR],
          weekOfYear(createLocal(), 1, 4).year
        );
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
          weekdayOverflow = true;
        }
      } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;
        curWeek = weekOfYear(createLocal(), dow, doy);
        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
        week = defaults(w.w, curWeek.week);
        if (w.d != null) {
          weekday = w.d;
          if (weekday < 0 || weekday > 6) {
            weekdayOverflow = true;
          }
        } else if (w.e != null) {
          weekday = w.e + dow;
          if (w.e < 0 || w.e > 6) {
            weekdayOverflow = true;
          }
        } else {
          weekday = dow;
        }
      }
      if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
      } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
      } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
      }
    }
    hooks.ISO_8601 = function() {
    };
    hooks.RFC_2822 = function() {
    };
    function configFromStringAndFormat(config) {
      if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
      }
      if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
      }
      config._a = [];
      getParsingFlags(config).empty = true;
      var string = "" + config._i, i, parsedInput, tokens2, token2, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
      tokens2 = expandFormat(config._f, config._locale).match(formattingTokens) || [];
      tokenLen = tokens2.length;
      for (i = 0; i < tokenLen; i++) {
        token2 = tokens2[i];
        parsedInput = (string.match(getParseRegexForToken(token2, config)) || [])[0];
        if (parsedInput) {
          skipped = string.substr(0, string.indexOf(parsedInput));
          if (skipped.length > 0) {
            getParsingFlags(config).unusedInput.push(skipped);
          }
          string = string.slice(
            string.indexOf(parsedInput) + parsedInput.length
          );
          totalParsedInputLength += parsedInput.length;
        }
        if (formatTokenFunctions[token2]) {
          if (parsedInput) {
            getParsingFlags(config).empty = false;
          } else {
            getParsingFlags(config).unusedTokens.push(token2);
          }
          addTimeToArrayFromToken(token2, parsedInput, config);
        } else if (config._strict && !parsedInput) {
          getParsingFlags(config).unusedTokens.push(token2);
        }
      }
      getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
      if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
      }
      if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = void 0;
      }
      getParsingFlags(config).parsedDateParts = config._a.slice(0);
      getParsingFlags(config).meridiem = config._meridiem;
      config._a[HOUR] = meridiemFixWrap(
        config._locale,
        config._a[HOUR],
        config._meridiem
      );
      era = getParsingFlags(config).era;
      if (era !== null) {
        config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
      }
      configFromArray(config);
      checkOverflow(config);
    }
    function meridiemFixWrap(locale2, hour, meridiem2) {
      var isPm;
      if (meridiem2 == null) {
        return hour;
      }
      if (locale2.meridiemHour != null) {
        return locale2.meridiemHour(hour, meridiem2);
      } else if (locale2.isPM != null) {
        isPm = locale2.isPM(meridiem2);
        if (isPm && hour < 12) {
          hour += 12;
        }
        if (!isPm && hour === 12) {
          hour = 0;
        }
        return hour;
      } else {
        return hour;
      }
    }
    function configFromStringAndArray(config) {
      var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
      if (configfLen === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
      }
      for (i = 0; i < configfLen; i++) {
        currentScore = 0;
        validFormatFound = false;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
          tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);
        if (isValid(tempConfig)) {
          validFormatFound = true;
        }
        currentScore += getParsingFlags(tempConfig).charsLeftOver;
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
        getParsingFlags(tempConfig).score = currentScore;
        if (!bestFormatIsValid) {
          if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
            if (validFormatFound) {
              bestFormatIsValid = true;
            }
          }
        } else {
          if (currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
          }
        }
      }
      extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
      if (config._d) {
        return;
      }
      var i = normalizeObjectUnits(config._i), dayOrDate = i.day === void 0 ? i.date : i.day;
      config._a = map(
        [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
        function(obj) {
          return obj && parseInt(obj, 10);
        }
      );
      configFromArray(config);
    }
    function createFromConfig(config) {
      var res = new Moment(checkOverflow(prepareConfig(config)));
      if (res._nextDay) {
        res.add(1, "d");
        res._nextDay = void 0;
      }
      return res;
    }
    function prepareConfig(config) {
      var input = config._i, format2 = config._f;
      config._locale = config._locale || getLocale(config._l);
      if (input === null || format2 === void 0 && input === "") {
        return createInvalid({ nullInput: true });
      }
      if (typeof input === "string") {
        config._i = input = config._locale.preparse(input);
      }
      if (isMoment(input)) {
        return new Moment(checkOverflow(input));
      } else if (isDate(input)) {
        config._d = input;
      } else if (isArray(format2)) {
        configFromStringAndArray(config);
      } else if (format2) {
        configFromStringAndFormat(config);
      } else {
        configFromInput(config);
      }
      if (!isValid(config)) {
        config._d = null;
      }
      return config;
    }
    function configFromInput(config) {
      var input = config._i;
      if (isUndefined(input)) {
        config._d = new Date(hooks.now());
      } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
      } else if (typeof input === "string") {
        configFromString(config);
      } else if (isArray(input)) {
        config._a = map(input.slice(0), function(obj) {
          return parseInt(obj, 10);
        });
        configFromArray(config);
      } else if (isObject2(input)) {
        configFromObject(config);
      } else if (isNumber(input)) {
        config._d = new Date(input);
      } else {
        hooks.createFromInputFallback(config);
      }
    }
    function createLocalOrUTC(input, format2, locale2, strict, isUTC) {
      var c = {};
      if (format2 === true || format2 === false) {
        strict = format2;
        format2 = void 0;
      }
      if (locale2 === true || locale2 === false) {
        strict = locale2;
        locale2 = void 0;
      }
      if (isObject2(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) {
        input = void 0;
      }
      c._isAMomentObject = true;
      c._useUTC = c._isUTC = isUTC;
      c._l = locale2;
      c._i = input;
      c._f = format2;
      c._strict = strict;
      return createFromConfig(c);
    }
    function createLocal(input, format2, locale2, strict) {
      return createLocalOrUTC(input, format2, locale2, strict, false);
    }
    var prototypeMin = deprecate(
      "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
      function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
          return other < this ? this : other;
        } else {
          return createInvalid();
        }
      }
    ), prototypeMax = deprecate(
      "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
      function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
          return other > this ? this : other;
        } else {
          return createInvalid();
        }
      }
    );
    function pickBy(fn, moments) {
      var res, i;
      if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
      }
      if (!moments.length) {
        return createLocal();
      }
      res = moments[0];
      for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
          res = moments[i];
        }
      }
      return res;
    }
    function min() {
      var args = [].slice.call(arguments, 0);
      return pickBy("isBefore", args);
    }
    function max() {
      var args = [].slice.call(arguments, 0);
      return pickBy("isAfter", args);
    }
    var now = function() {
      return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
      "year",
      "quarter",
      "month",
      "week",
      "day",
      "hour",
      "minute",
      "second",
      "millisecond"
    ];
    function isDurationValid(m) {
      var key, unitHasDecimal = false, i, orderLen = ordering.length;
      for (key in m) {
        if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
          return false;
        }
      }
      for (i = 0; i < orderLen; ++i) {
        if (m[ordering[i]]) {
          if (unitHasDecimal) {
            return false;
          }
          if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
            unitHasDecimal = true;
          }
        }
      }
      return true;
    }
    function isValid$1() {
      return this._isValid;
    }
    function createInvalid$1() {
      return createDuration(NaN);
    }
    function Duration(duration) {
      var normalizedInput = normalizeObjectUnits(duration), years2 = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months2 = normalizedInput.month || 0, weeks2 = normalizedInput.week || normalizedInput.isoWeek || 0, days2 = normalizedInput.day || 0, hours2 = normalizedInput.hour || 0, minutes2 = normalizedInput.minute || 0, seconds2 = normalizedInput.second || 0, milliseconds2 = normalizedInput.millisecond || 0;
      this._isValid = isDurationValid(normalizedInput);
      this._milliseconds = +milliseconds2 + seconds2 * 1e3 + minutes2 * 6e4 + hours2 * 1e3 * 60 * 60;
      this._days = +days2 + weeks2 * 7;
      this._months = +months2 + quarters * 3 + years2 * 12;
      this._data = {};
      this._locale = getLocale();
      this._bubble();
    }
    function isDuration(obj) {
      return obj instanceof Duration;
    }
    function absRound(number) {
      if (number < 0) {
        return Math.round(-1 * number) * -1;
      } else {
        return Math.round(number);
      }
    }
    function compareArrays(array1, array2, dontConvert) {
      var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
      for (i = 0; i < len; i++) {
        if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) {
          diffs++;
        }
      }
      return diffs + lengthDiff;
    }
    function offset(token2, separator) {
      addFormatToken(token2, 0, 0, function() {
        var offset2 = this.utcOffset(), sign2 = "+";
        if (offset2 < 0) {
          offset2 = -offset2;
          sign2 = "-";
        }
        return sign2 + zeroFill(~~(offset2 / 60), 2) + separator + zeroFill(~~offset2 % 60, 2);
      });
    }
    offset("Z", ":");
    offset("ZZ", "");
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken(["Z", "ZZ"], function(input, array, config) {
      config._useUTC = true;
      config._tzm = offsetFromString(matchShortOffset, input);
    });
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
      var matches = (string || "").match(matcher), chunk, parts, minutes2;
      if (matches === null) {
        return null;
      }
      chunk = matches[matches.length - 1] || [];
      parts = (chunk + "").match(chunkOffset) || ["-", 0, 0];
      minutes2 = +(parts[1] * 60) + toInt(parts[2]);
      return minutes2 === 0 ? 0 : parts[0] === "+" ? minutes2 : -minutes2;
    }
    function cloneWithOffset(input, model) {
      var res, diff2;
      if (model._isUTC) {
        res = model.clone();
        diff2 = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        res._d.setTime(res._d.valueOf() + diff2);
        hooks.updateOffset(res, false);
        return res;
      } else {
        return createLocal(input).local();
      }
    }
    function getDateOffset(m) {
      return -Math.round(m._d.getTimezoneOffset());
    }
    hooks.updateOffset = function() {
    };
    function getSetOffset(input, keepLocalTime, keepMinutes) {
      var offset2 = this._offset || 0, localAdjust;
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }
      if (input != null) {
        if (typeof input === "string") {
          input = offsetFromString(matchShortOffset, input);
          if (input === null) {
            return this;
          }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
          input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
          localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
          this.add(localAdjust, "m");
        }
        if (offset2 !== input) {
          if (!keepLocalTime || this._changeInProgress) {
            addSubtract(
              this,
              createDuration(input - offset2, "m"),
              1,
              false
            );
          } else if (!this._changeInProgress) {
            this._changeInProgress = true;
            hooks.updateOffset(this, true);
            this._changeInProgress = null;
          }
        }
        return this;
      } else {
        return this._isUTC ? offset2 : getDateOffset(this);
      }
    }
    function getSetZone(input, keepLocalTime) {
      if (input != null) {
        if (typeof input !== "string") {
          input = -input;
        }
        this.utcOffset(input, keepLocalTime);
        return this;
      } else {
        return -this.utcOffset();
      }
    }
    function setOffsetToUTC(keepLocalTime) {
      return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
      if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;
        if (keepLocalTime) {
          this.subtract(getDateOffset(this), "m");
        }
      }
      return this;
    }
    function setOffsetToParsedOffset() {
      if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
      } else if (typeof this._i === "string") {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
          this.utcOffset(tZone);
        } else {
          this.utcOffset(0, true);
        }
      }
      return this;
    }
    function hasAlignedHourOffset(input) {
      if (!this.isValid()) {
        return false;
      }
      input = input ? createLocal(input).utcOffset() : 0;
      return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
      return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
      if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
      }
      var c = {}, other;
      copyConfig(c, this);
      c = prepareConfig(c);
      if (c._a) {
        other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
      } else {
        this._isDSTShifted = false;
      }
      return this._isDSTShifted;
    }
    function isLocal() {
      return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
      return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
      return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
      var duration = input, match = null, sign2, ret, diffRes;
      if (isDuration(input)) {
        duration = {
          ms: input._milliseconds,
          d: input._days,
          M: input._months
        };
      } else if (isNumber(input) || !isNaN(+input)) {
        duration = {};
        if (key) {
          duration[key] = +input;
        } else {
          duration.milliseconds = +input;
        }
      } else if (match = aspNetRegex.exec(input)) {
        sign2 = match[1] === "-" ? -1 : 1;
        duration = {
          y: 0,
          d: toInt(match[DATE]) * sign2,
          h: toInt(match[HOUR]) * sign2,
          m: toInt(match[MINUTE]) * sign2,
          s: toInt(match[SECOND]) * sign2,
          ms: toInt(absRound(match[MILLISECOND] * 1e3)) * sign2
        };
      } else if (match = isoRegex.exec(input)) {
        sign2 = match[1] === "-" ? -1 : 1;
        duration = {
          y: parseIso(match[2], sign2),
          M: parseIso(match[3], sign2),
          w: parseIso(match[4], sign2),
          d: parseIso(match[5], sign2),
          h: parseIso(match[6], sign2),
          m: parseIso(match[7], sign2),
          s: parseIso(match[8], sign2)
        };
      } else if (duration == null) {
        duration = {};
      } else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
        diffRes = momentsDifference(
          createLocal(duration.from),
          createLocal(duration.to)
        );
        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
      }
      ret = new Duration(duration);
      if (isDuration(input) && hasOwnProp(input, "_locale")) {
        ret._locale = input._locale;
      }
      if (isDuration(input) && hasOwnProp(input, "_isValid")) {
        ret._isValid = input._isValid;
      }
      return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign2) {
      var res = inp && parseFloat(inp.replace(",", "."));
      return (isNaN(res) ? 0 : res) * sign2;
    }
    function positiveMomentsDifference(base, other) {
      var res = {};
      res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
      if (base.clone().add(res.months, "M").isAfter(other)) {
        --res.months;
      }
      res.milliseconds = +other - +base.clone().add(res.months, "M");
      return res;
    }
    function momentsDifference(base, other) {
      var res;
      if (!(base.isValid() && other.isValid())) {
        return { milliseconds: 0, months: 0 };
      }
      other = cloneWithOffset(other, base);
      if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
      } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
      }
      return res;
    }
    function createAdder(direction, name) {
      return function(val, period) {
        var dur, tmp;
        if (period !== null && !isNaN(+period)) {
          deprecateSimple(
            name,
            "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
          );
          tmp = val;
          val = period;
          period = tmp;
        }
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
      };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
      var milliseconds2 = duration._milliseconds, days2 = absRound(duration._days), months2 = absRound(duration._months);
      if (!mom.isValid()) {
        return;
      }
      updateOffset = updateOffset == null ? true : updateOffset;
      if (months2) {
        setMonth(mom, get2(mom, "Month") + months2 * isAdding);
      }
      if (days2) {
        set$1(mom, "Date", get2(mom, "Date") + days2 * isAdding);
      }
      if (milliseconds2) {
        mom._d.setTime(mom._d.valueOf() + milliseconds2 * isAdding);
      }
      if (updateOffset) {
        hooks.updateOffset(mom, days2 || months2);
      }
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
      return typeof input === "string" || input instanceof String;
    }
    function isMomentInput(input) {
      return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === void 0;
    }
    function isMomentInputObject(input) {
      var objectTest = isObject2(input) && !isObjectEmpty(input), propertyTest = false, properties = [
        "years",
        "year",
        "y",
        "months",
        "month",
        "M",
        "days",
        "day",
        "d",
        "dates",
        "date",
        "D",
        "hours",
        "hour",
        "h",
        "minutes",
        "minute",
        "m",
        "seconds",
        "second",
        "s",
        "milliseconds",
        "millisecond",
        "ms"
      ], i, property, propertyLen = properties.length;
      for (i = 0; i < propertyLen; i += 1) {
        property = properties[i];
        propertyTest = propertyTest || hasOwnProp(input, property);
      }
      return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
      var arrayTest = isArray(input), dataTypeTest = false;
      if (arrayTest) {
        dataTypeTest = input.filter(function(item) {
          return !isNumber(item) && isString(input);
        }).length === 0;
      }
      return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
      var objectTest = isObject2(input) && !isObjectEmpty(input), propertyTest = false, properties = [
        "sameDay",
        "nextDay",
        "lastDay",
        "nextWeek",
        "lastWeek",
        "sameElse"
      ], i, property;
      for (i = 0; i < properties.length; i += 1) {
        property = properties[i];
        propertyTest = propertyTest || hasOwnProp(input, property);
      }
      return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now2) {
      var diff2 = myMoment.diff(now2, "days", true);
      return diff2 < -6 ? "sameElse" : diff2 < -1 ? "lastWeek" : diff2 < 0 ? "lastDay" : diff2 < 1 ? "sameDay" : diff2 < 2 ? "nextDay" : diff2 < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
      if (arguments.length === 1) {
        if (!arguments[0]) {
          time = void 0;
          formats = void 0;
        } else if (isMomentInput(arguments[0])) {
          time = arguments[0];
          formats = void 0;
        } else if (isCalendarSpec(arguments[0])) {
          formats = arguments[0];
          time = void 0;
        }
      }
      var now2 = time || createLocal(), sod = cloneWithOffset(now2, this).startOf("day"), format2 = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format2]) ? formats[format2].call(this, now2) : formats[format2]);
      return this.format(
        output || this.localeData().calendar(format2, this, createLocal(now2))
      );
    }
    function clone() {
      return new Moment(this);
    }
    function isAfter(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input);
      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }
      units = normalizeUnits(units) || "millisecond";
      if (units === "millisecond") {
        return this.valueOf() > localInput.valueOf();
      } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
      }
    }
    function isBefore(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input);
      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }
      units = normalizeUnits(units) || "millisecond";
      if (units === "millisecond") {
        return this.valueOf() < localInput.valueOf();
      } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
      }
    }
    function isBetween(from2, to2, units, inclusivity) {
      var localFrom = isMoment(from2) ? from2 : createLocal(from2), localTo = isMoment(to2) ? to2 : createLocal(to2);
      if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
        return false;
      }
      inclusivity = inclusivity || "()";
      return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input), inputMs;
      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }
      units = normalizeUnits(units) || "millisecond";
      if (units === "millisecond") {
        return this.valueOf() === localInput.valueOf();
      } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
      }
    }
    function isSameOrAfter(input, units) {
      return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
      return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
      var that, zoneDelta, output;
      if (!this.isValid()) {
        return NaN;
      }
      that = cloneWithOffset(input, this);
      if (!that.isValid()) {
        return NaN;
      }
      zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
      units = normalizeUnits(units);
      switch (units) {
        case "year":
          output = monthDiff(this, that) / 12;
          break;
        case "month":
          output = monthDiff(this, that);
          break;
        case "quarter":
          output = monthDiff(this, that) / 3;
          break;
        case "second":
          output = (this - that) / 1e3;
          break;
        case "minute":
          output = (this - that) / 6e4;
          break;
        case "hour":
          output = (this - that) / 36e5;
          break;
        case "day":
          output = (this - that - zoneDelta) / 864e5;
          break;
        case "week":
          output = (this - that - zoneDelta) / 6048e5;
          break;
        default:
          output = this - that;
      }
      return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
      if (a.date() < b.date()) {
        return -monthDiff(b, a);
      }
      var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
      if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
        adjust = (b - anchor) / (anchor - anchor2);
      } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
        adjust = (b - anchor) / (anchor2 - anchor);
      }
      return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
      return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
      if (!this.isValid()) {
        return null;
      }
      var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
      if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(
          m,
          utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
        );
      }
      if (isFunction(Date.prototype.toISOString)) {
        if (utc) {
          return this.toDate().toISOString();
        } else {
          return new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", formatMoment(m, "Z"));
        }
      }
      return formatMoment(
        m,
        utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
      );
    }
    function inspect() {
      if (!this.isValid()) {
        return "moment.invalid(/* " + this._i + " */)";
      }
      var func = "moment", zone = "", prefix, year, datetime, suffix;
      if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
        zone = "Z";
      }
      prefix = "[" + func + '("]';
      year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
      datetime = "-MM-DD[T]HH:mm:ss.SSS";
      suffix = zone + '[")]';
      return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
      if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
      }
      var output = formatMoment(this, inputString);
      return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
      if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
        return createDuration({ to: this, from: time }).locale(this.locale()).humanize(!withoutSuffix);
      } else {
        return this.localeData().invalidDate();
      }
    }
    function fromNow(withoutSuffix) {
      return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
      if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
        return createDuration({ from: this, to: time }).locale(this.locale()).humanize(!withoutSuffix);
      } else {
        return this.localeData().invalidDate();
      }
    }
    function toNow(withoutSuffix) {
      return this.to(createLocal(), withoutSuffix);
    }
    function locale(key) {
      var newLocaleData;
      if (key === void 0) {
        return this._locale._abbr;
      } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
          this._locale = newLocaleData;
        }
        return this;
      }
    }
    var lang = deprecate(
      "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
      function(key) {
        if (key === void 0) {
          return this.localeData();
        } else {
          return this.locale(key);
        }
      }
    );
    function localeData() {
      return this._locale;
    }
    var MS_PER_SECOND = 1e3, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
    function mod$1(dividend, divisor) {
      return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
      if (y < 100 && y >= 0) {
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
      } else {
        return new Date(y, m, d).valueOf();
      }
    }
    function utcStartOfDate(y, m, d) {
      if (y < 100 && y >= 0) {
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
      } else {
        return Date.UTC(y, m, d);
      }
    }
    function startOf(units) {
      var time, startOfDate;
      units = normalizeUnits(units);
      if (units === void 0 || units === "millisecond" || !this.isValid()) {
        return this;
      }
      startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
      switch (units) {
        case "year":
          time = startOfDate(this.year(), 0, 1);
          break;
        case "quarter":
          time = startOfDate(
            this.year(),
            this.month() - this.month() % 3,
            1
          );
          break;
        case "month":
          time = startOfDate(this.year(), this.month(), 1);
          break;
        case "week":
          time = startOfDate(
            this.year(),
            this.month(),
            this.date() - this.weekday()
          );
          break;
        case "isoWeek":
          time = startOfDate(
            this.year(),
            this.month(),
            this.date() - (this.isoWeekday() - 1)
          );
          break;
        case "day":
        case "date":
          time = startOfDate(this.year(), this.month(), this.date());
          break;
        case "hour":
          time = this._d.valueOf();
          time -= mod$1(
            time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
            MS_PER_HOUR
          );
          break;
        case "minute":
          time = this._d.valueOf();
          time -= mod$1(time, MS_PER_MINUTE);
          break;
        case "second":
          time = this._d.valueOf();
          time -= mod$1(time, MS_PER_SECOND);
          break;
      }
      this._d.setTime(time);
      hooks.updateOffset(this, true);
      return this;
    }
    function endOf(units) {
      var time, startOfDate;
      units = normalizeUnits(units);
      if (units === void 0 || units === "millisecond" || !this.isValid()) {
        return this;
      }
      startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
      switch (units) {
        case "year":
          time = startOfDate(this.year() + 1, 0, 1) - 1;
          break;
        case "quarter":
          time = startOfDate(
            this.year(),
            this.month() - this.month() % 3 + 3,
            1
          ) - 1;
          break;
        case "month":
          time = startOfDate(this.year(), this.month() + 1, 1) - 1;
          break;
        case "week":
          time = startOfDate(
            this.year(),
            this.month(),
            this.date() - this.weekday() + 7
          ) - 1;
          break;
        case "isoWeek":
          time = startOfDate(
            this.year(),
            this.month(),
            this.date() - (this.isoWeekday() - 1) + 7
          ) - 1;
          break;
        case "day":
        case "date":
          time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
          break;
        case "hour":
          time = this._d.valueOf();
          time += MS_PER_HOUR - mod$1(
            time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
            MS_PER_HOUR
          ) - 1;
          break;
        case "minute":
          time = this._d.valueOf();
          time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
          break;
        case "second":
          time = this._d.valueOf();
          time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
          break;
      }
      this._d.setTime(time);
      hooks.updateOffset(this, true);
      return this;
    }
    function valueOf() {
      return this._d.valueOf() - (this._offset || 0) * 6e4;
    }
    function unix() {
      return Math.floor(this.valueOf() / 1e3);
    }
    function toDate() {
      return new Date(this.valueOf());
    }
    function toArray() {
      var m = this;
      return [
        m.year(),
        m.month(),
        m.date(),
        m.hour(),
        m.minute(),
        m.second(),
        m.millisecond()
      ];
    }
    function toObject() {
      var m = this;
      return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
      };
    }
    function toJSON() {
      return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
      return isValid(this);
    }
    function parsingFlags() {
      return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
      return getParsingFlags(this).overflow;
    }
    function creationData() {
      return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
      };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", ["y", 1], "yo", "eraYear");
    addFormatToken("y", ["yy", 2], 0, "eraYear");
    addFormatToken("y", ["yyy", 3], 0, "eraYear");
    addFormatToken("y", ["yyyy", 4], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken(
      ["N", "NN", "NNN", "NNNN", "NNNNN"],
      function(input, array, config, token2) {
        var era = config._locale.erasParse(input, token2, config._strict);
        if (era) {
          getParsingFlags(config).era = era;
        } else {
          getParsingFlags(config).invalidEra = input;
        }
      }
    );
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken(["y", "yy", "yyy", "yyyy"], YEAR);
    addParseToken(["yo"], function(input, array, config, token2) {
      var match;
      if (config._locale._eraYearOrdinalRegex) {
        match = input.match(config._locale._eraYearOrdinalRegex);
      }
      if (config._locale.eraYearOrdinalParse) {
        array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
      } else {
        array[YEAR] = parseInt(input, 10);
      }
    });
    function localeEras(m, format2) {
      var i, l, date, eras = this._eras || getLocale("en")._eras;
      for (i = 0, l = eras.length; i < l; ++i) {
        switch (typeof eras[i].since) {
          case "string":
            date = hooks(eras[i].since).startOf("day");
            eras[i].since = date.valueOf();
            break;
        }
        switch (typeof eras[i].until) {
          case "undefined":
            eras[i].until = Infinity;
            break;
          case "string":
            date = hooks(eras[i].until).startOf("day").valueOf();
            eras[i].until = date.valueOf();
            break;
        }
      }
      return eras;
    }
    function localeErasParse(eraName, format2, strict) {
      var i, l, eras = this.eras(), name, abbr, narrow;
      eraName = eraName.toUpperCase();
      for (i = 0, l = eras.length; i < l; ++i) {
        name = eras[i].name.toUpperCase();
        abbr = eras[i].abbr.toUpperCase();
        narrow = eras[i].narrow.toUpperCase();
        if (strict) {
          switch (format2) {
            case "N":
            case "NN":
            case "NNN":
              if (abbr === eraName) {
                return eras[i];
              }
              break;
            case "NNNN":
              if (name === eraName) {
                return eras[i];
              }
              break;
            case "NNNNN":
              if (narrow === eraName) {
                return eras[i];
              }
              break;
          }
        } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
          return eras[i];
        }
      }
    }
    function localeErasConvertYear(era, year) {
      var dir = era.since <= era.until ? 1 : -1;
      if (year === void 0) {
        return hooks(era.since).year();
      } else {
        return hooks(era.since).year() + (year - era.offset) * dir;
      }
    }
    function getEraName() {
      var i, l, val, eras = this.localeData().eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        val = this.clone().startOf("day").valueOf();
        if (eras[i].since <= val && val <= eras[i].until) {
          return eras[i].name;
        }
        if (eras[i].until <= val && val <= eras[i].since) {
          return eras[i].name;
        }
      }
      return "";
    }
    function getEraNarrow() {
      var i, l, val, eras = this.localeData().eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        val = this.clone().startOf("day").valueOf();
        if (eras[i].since <= val && val <= eras[i].until) {
          return eras[i].narrow;
        }
        if (eras[i].until <= val && val <= eras[i].since) {
          return eras[i].narrow;
        }
      }
      return "";
    }
    function getEraAbbr() {
      var i, l, val, eras = this.localeData().eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        val = this.clone().startOf("day").valueOf();
        if (eras[i].since <= val && val <= eras[i].until) {
          return eras[i].abbr;
        }
        if (eras[i].until <= val && val <= eras[i].since) {
          return eras[i].abbr;
        }
      }
      return "";
    }
    function getEraYear() {
      var i, l, dir, val, eras = this.localeData().eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        dir = eras[i].since <= eras[i].until ? 1 : -1;
        val = this.clone().startOf("day").valueOf();
        if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) {
          return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
      }
      return this.year();
    }
    function erasNameRegex(isStrict) {
      if (!hasOwnProp(this, "_erasNameRegex")) {
        computeErasParse.call(this);
      }
      return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
      if (!hasOwnProp(this, "_erasAbbrRegex")) {
        computeErasParse.call(this);
      }
      return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
      if (!hasOwnProp(this, "_erasNarrowRegex")) {
        computeErasParse.call(this);
      }
      return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale2) {
      return locale2.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale2) {
      return locale2.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale2) {
      return locale2.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale2) {
      return locale2._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
      var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, eras = this.eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        namePieces.push(regexEscape(eras[i].name));
        abbrPieces.push(regexEscape(eras[i].abbr));
        narrowPieces.push(regexEscape(eras[i].narrow));
        mixedPieces.push(regexEscape(eras[i].name));
        mixedPieces.push(regexEscape(eras[i].abbr));
        mixedPieces.push(regexEscape(eras[i].narrow));
      }
      this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
      this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
      this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
      this._erasNarrowRegex = new RegExp(
        "^(" + narrowPieces.join("|") + ")",
        "i"
      );
    }
    addFormatToken(0, ["gg", 2], 0, function() {
      return this.weekYear() % 100;
    });
    addFormatToken(0, ["GG", 2], 0, function() {
      return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token2, getter) {
      addFormatToken(0, [token2, token2.length], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    addUnitAlias("weekYear", "gg");
    addUnitAlias("isoWeekYear", "GG");
    addUnitPriority("weekYear", 1);
    addUnitPriority("isoWeekYear", 1);
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken(
      ["gggg", "ggggg", "GGGG", "GGGGG"],
      function(input, week, config, token2) {
        week[token2.substr(0, 2)] = toInt(input);
      }
    );
    addWeekParseToken(["gg", "GG"], function(input, week, config, token2) {
      week[token2] = hooks.parseTwoDigitYear(input);
    });
    function getSetWeekYear(input) {
      return getSetWeekYearHelper.call(
        this,
        input,
        this.week(),
        this.weekday(),
        this.localeData()._week.dow,
        this.localeData()._week.doy
      );
    }
    function getSetISOWeekYear(input) {
      return getSetWeekYearHelper.call(
        this,
        input,
        this.isoWeek(),
        this.isoWeekday(),
        1,
        4
      );
    }
    function getISOWeeksInYear() {
      return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
      return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
      var weekInfo = this.localeData()._week;
      return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
      var weekInfo = this.localeData()._week;
      return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
      var weeksTarget;
      if (input == null) {
        return weekOfYear(this, dow, doy).year;
      } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
          week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
      }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
      var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
      this.year(date.getUTCFullYear());
      this.month(date.getUTCMonth());
      this.date(date.getUTCDate());
      return this;
    }
    addFormatToken("Q", 0, "Qo", "quarter");
    addUnitAlias("quarter", "Q");
    addUnitPriority("quarter", 7);
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
      array[MONTH] = (toInt(input) - 1) * 3;
    });
    function getSetQuarter(input) {
      return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    addFormatToken("D", ["DD", 2], "Do", "date");
    addUnitAlias("date", "D");
    addUnitPriority("date", 9);
    addRegexToken("D", match1to2);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale2) {
      return isStrict ? locale2._dayOfMonthOrdinalParse || locale2._ordinalParse : locale2._dayOfMonthOrdinalParseLenient;
    });
    addParseToken(["D", "DD"], DATE);
    addParseToken("Do", function(input, array) {
      array[DATE] = toInt(input.match(match1to2)[0]);
    });
    var getSetDayOfMonth = makeGetSet("Date", true);
    addFormatToken("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
    addUnitAlias("dayOfYear", "DDD");
    addUnitPriority("dayOfYear", 4);
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken(["DDD", "DDDD"], function(input, array, config) {
      config._dayOfYear = toInt(input);
    });
    function getSetDayOfYear(input) {
      var dayOfYear = Math.round(
        (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
      ) + 1;
      return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    addFormatToken("m", ["mm", 2], 0, "minute");
    addUnitAlias("minute", "m");
    addUnitPriority("minute", 14);
    addRegexToken("m", match1to2);
    addRegexToken("mm", match1to2, match2);
    addParseToken(["m", "mm"], MINUTE);
    var getSetMinute = makeGetSet("Minutes", false);
    addFormatToken("s", ["ss", 2], 0, "second");
    addUnitAlias("second", "s");
    addUnitPriority("second", 15);
    addRegexToken("s", match1to2);
    addRegexToken("ss", match1to2, match2);
    addParseToken(["s", "ss"], SECOND);
    var getSetSecond = makeGetSet("Seconds", false);
    addFormatToken("S", 0, 0, function() {
      return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, ["SS", 2], 0, function() {
      return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, ["SSS", 3], 0, "millisecond");
    addFormatToken(0, ["SSSS", 4], 0, function() {
      return this.millisecond() * 10;
    });
    addFormatToken(0, ["SSSSS", 5], 0, function() {
      return this.millisecond() * 100;
    });
    addFormatToken(0, ["SSSSSS", 6], 0, function() {
      return this.millisecond() * 1e3;
    });
    addFormatToken(0, ["SSSSSSS", 7], 0, function() {
      return this.millisecond() * 1e4;
    });
    addFormatToken(0, ["SSSSSSSS", 8], 0, function() {
      return this.millisecond() * 1e5;
    });
    addFormatToken(0, ["SSSSSSSSS", 9], 0, function() {
      return this.millisecond() * 1e6;
    });
    addUnitAlias("millisecond", "ms");
    addUnitPriority("millisecond", 16);
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for (token = "SSSS"; token.length <= 9; token += "S") {
      addRegexToken(token, matchUnsigned);
    }
    function parseMs(input, array) {
      array[MILLISECOND] = toInt(("0." + input) * 1e3);
    }
    for (token = "S"; token.length <= 9; token += "S") {
      addParseToken(token, parseMs);
    }
    getSetMillisecond = makeGetSet("Milliseconds", false);
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    function getZoneAbbr() {
      return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
      return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) {
      proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
      };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
      "dates accessor is deprecated. Use date instead.",
      getSetDayOfMonth
    );
    proto.months = deprecate(
      "months accessor is deprecated. Use month instead",
      getSetMonth
    );
    proto.years = deprecate(
      "years accessor is deprecated. Use year instead",
      getSetYear
    );
    proto.zone = deprecate(
      "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
      getSetZone
    );
    proto.isDSTShifted = deprecate(
      "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
      isDaylightSavingTimeShifted
    );
    function createUnix(input) {
      return createLocal(input * 1e3);
    }
    function createInZone() {
      return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
      return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set2;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format2, index, field, setter) {
      var locale2 = getLocale(), utc = createUTC().set(setter, index);
      return locale2[field](utc, format2);
    }
    function listMonthsImpl(format2, index, field) {
      if (isNumber(format2)) {
        index = format2;
        format2 = void 0;
      }
      format2 = format2 || "";
      if (index != null) {
        return get$1(format2, index, field, "month");
      }
      var i, out = [];
      for (i = 0; i < 12; i++) {
        out[i] = get$1(format2, i, field, "month");
      }
      return out;
    }
    function listWeekdaysImpl(localeSorted, format2, index, field) {
      if (typeof localeSorted === "boolean") {
        if (isNumber(format2)) {
          index = format2;
          format2 = void 0;
        }
        format2 = format2 || "";
      } else {
        format2 = localeSorted;
        index = format2;
        localeSorted = false;
        if (isNumber(format2)) {
          index = format2;
          format2 = void 0;
        }
        format2 = format2 || "";
      }
      var locale2 = getLocale(), shift = localeSorted ? locale2._week.dow : 0, i, out = [];
      if (index != null) {
        return get$1(format2, (index + shift) % 7, field, "day");
      }
      for (i = 0; i < 7; i++) {
        out[i] = get$1(format2, (i + shift) % 7, field, "day");
      }
      return out;
    }
    function listMonths(format2, index) {
      return listMonthsImpl(format2, index, "months");
    }
    function listMonthsShort(format2, index) {
      return listMonthsImpl(format2, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format2, index) {
      return listWeekdaysImpl(localeSorted, format2, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format2, index) {
      return listWeekdaysImpl(localeSorted, format2, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format2, index) {
      return listWeekdaysImpl(localeSorted, format2, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
      eras: [
        {
          since: "0001-01-01",
          until: Infinity,
          offset: 1,
          name: "Anno Domini",
          narrow: "AD",
          abbr: "AD"
        },
        {
          since: "0000-12-31",
          until: -Infinity,
          offset: 1,
          name: "Before Christ",
          narrow: "BC",
          abbr: "BC"
        }
      ],
      dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
      ordinal: function(number) {
        var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
        return number + output;
      }
    });
    hooks.lang = deprecate(
      "moment.lang is deprecated. Use moment.locale instead.",
      getSetGlobalLocale
    );
    hooks.langData = deprecate(
      "moment.langData is deprecated. Use moment.localeData instead.",
      getLocale
    );
    var mathAbs = Math.abs;
    function abs() {
      var data = this._data;
      this._milliseconds = mathAbs(this._milliseconds);
      this._days = mathAbs(this._days);
      this._months = mathAbs(this._months);
      data.milliseconds = mathAbs(data.milliseconds);
      data.seconds = mathAbs(data.seconds);
      data.minutes = mathAbs(data.minutes);
      data.hours = mathAbs(data.hours);
      data.months = mathAbs(data.months);
      data.years = mathAbs(data.years);
      return this;
    }
    function addSubtract$1(duration, input, value, direction) {
      var other = createDuration(input, value);
      duration._milliseconds += direction * other._milliseconds;
      duration._days += direction * other._days;
      duration._months += direction * other._months;
      return duration._bubble();
    }
    function add$1(input, value) {
      return addSubtract$1(this, input, value, 1);
    }
    function subtract$1(input, value) {
      return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
      if (number < 0) {
        return Math.floor(number);
      } else {
        return Math.ceil(number);
      }
    }
    function bubble() {
      var milliseconds2 = this._milliseconds, days2 = this._days, months2 = this._months, data = this._data, seconds2, minutes2, hours2, years2, monthsFromDays;
      if (!(milliseconds2 >= 0 && days2 >= 0 && months2 >= 0 || milliseconds2 <= 0 && days2 <= 0 && months2 <= 0)) {
        milliseconds2 += absCeil(monthsToDays(months2) + days2) * 864e5;
        days2 = 0;
        months2 = 0;
      }
      data.milliseconds = milliseconds2 % 1e3;
      seconds2 = absFloor(milliseconds2 / 1e3);
      data.seconds = seconds2 % 60;
      minutes2 = absFloor(seconds2 / 60);
      data.minutes = minutes2 % 60;
      hours2 = absFloor(minutes2 / 60);
      data.hours = hours2 % 24;
      days2 += absFloor(hours2 / 24);
      monthsFromDays = absFloor(daysToMonths(days2));
      months2 += monthsFromDays;
      days2 -= absCeil(monthsToDays(monthsFromDays));
      years2 = absFloor(months2 / 12);
      months2 %= 12;
      data.days = days2;
      data.months = months2;
      data.years = years2;
      return this;
    }
    function daysToMonths(days2) {
      return days2 * 4800 / 146097;
    }
    function monthsToDays(months2) {
      return months2 * 146097 / 4800;
    }
    function as(units) {
      if (!this.isValid()) {
        return NaN;
      }
      var days2, months2, milliseconds2 = this._milliseconds;
      units = normalizeUnits(units);
      if (units === "month" || units === "quarter" || units === "year") {
        days2 = this._days + milliseconds2 / 864e5;
        months2 = this._months + daysToMonths(days2);
        switch (units) {
          case "month":
            return months2;
          case "quarter":
            return months2 / 3;
          case "year":
            return months2 / 12;
        }
      } else {
        days2 = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
          case "week":
            return days2 / 7 + milliseconds2 / 6048e5;
          case "day":
            return days2 + milliseconds2 / 864e5;
          case "hour":
            return days2 * 24 + milliseconds2 / 36e5;
          case "minute":
            return days2 * 1440 + milliseconds2 / 6e4;
          case "second":
            return days2 * 86400 + milliseconds2 / 1e3;
          case "millisecond":
            return Math.floor(days2 * 864e5) + milliseconds2;
          default:
            throw new Error("Unknown unit " + units);
        }
      }
    }
    function valueOf$1() {
      if (!this.isValid()) {
        return NaN;
      }
      return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
    }
    function makeAs(alias) {
      return function() {
        return this.as(alias);
      };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y");
    function clone$1() {
      return createDuration(this);
    }
    function get$2(units) {
      units = normalizeUnits(units);
      return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
      return function() {
        return this.isValid() ? this._data[name] : NaN;
      };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
      return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
      ss: 44,
      s: 45,
      m: 45,
      h: 22,
      d: 26,
      w: null,
      M: 11
    };
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale2) {
      return locale2.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds2, locale2) {
      var duration = createDuration(posNegDuration).abs(), seconds2 = round(duration.as("s")), minutes2 = round(duration.as("m")), hours2 = round(duration.as("h")), days2 = round(duration.as("d")), months2 = round(duration.as("M")), weeks2 = round(duration.as("w")), years2 = round(duration.as("y")), a = seconds2 <= thresholds2.ss && ["s", seconds2] || seconds2 < thresholds2.s && ["ss", seconds2] || minutes2 <= 1 && ["m"] || minutes2 < thresholds2.m && ["mm", minutes2] || hours2 <= 1 && ["h"] || hours2 < thresholds2.h && ["hh", hours2] || days2 <= 1 && ["d"] || days2 < thresholds2.d && ["dd", days2];
      if (thresholds2.w != null) {
        a = a || weeks2 <= 1 && ["w"] || weeks2 < thresholds2.w && ["ww", weeks2];
      }
      a = a || months2 <= 1 && ["M"] || months2 < thresholds2.M && ["MM", months2] || years2 <= 1 && ["y"] || ["yy", years2];
      a[2] = withoutSuffix;
      a[3] = +posNegDuration > 0;
      a[4] = locale2;
      return substituteTimeAgo.apply(null, a);
    }
    function getSetRelativeTimeRounding(roundingFunction) {
      if (roundingFunction === void 0) {
        return round;
      }
      if (typeof roundingFunction === "function") {
        round = roundingFunction;
        return true;
      }
      return false;
    }
    function getSetRelativeTimeThreshold(threshold, limit) {
      if (thresholds[threshold] === void 0) {
        return false;
      }
      if (limit === void 0) {
        return thresholds[threshold];
      }
      thresholds[threshold] = limit;
      if (threshold === "s") {
        thresholds.ss = limit - 1;
      }
      return true;
    }
    function humanize(argWithSuffix, argThresholds) {
      if (!this.isValid()) {
        return this.localeData().invalidDate();
      }
      var withSuffix = false, th = thresholds, locale2, output;
      if (typeof argWithSuffix === "object") {
        argThresholds = argWithSuffix;
        argWithSuffix = false;
      }
      if (typeof argWithSuffix === "boolean") {
        withSuffix = argWithSuffix;
      }
      if (typeof argThresholds === "object") {
        th = Object.assign({}, thresholds, argThresholds);
        if (argThresholds.s != null && argThresholds.ss == null) {
          th.ss = argThresholds.s - 1;
        }
      }
      locale2 = this.localeData();
      output = relativeTime$1(this, !withSuffix, th, locale2);
      if (withSuffix) {
        output = locale2.pastFuture(+this, output);
      }
      return locale2.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
      return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
      if (!this.isValid()) {
        return this.localeData().invalidDate();
      }
      var seconds2 = abs$1(this._milliseconds) / 1e3, days2 = abs$1(this._days), months2 = abs$1(this._months), minutes2, hours2, years2, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
      if (!total) {
        return "P0D";
      }
      minutes2 = absFloor(seconds2 / 60);
      hours2 = absFloor(minutes2 / 60);
      seconds2 %= 60;
      minutes2 %= 60;
      years2 = absFloor(months2 / 12);
      months2 %= 12;
      s = seconds2 ? seconds2.toFixed(3).replace(/\.?0+$/, "") : "";
      totalSign = total < 0 ? "-" : "";
      ymSign = sign(this._months) !== sign(total) ? "-" : "";
      daysSign = sign(this._days) !== sign(total) ? "-" : "";
      hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
      return totalSign + "P" + (years2 ? ymSign + years2 + "Y" : "") + (months2 ? ymSign + months2 + "M" : "") + (days2 ? daysSign + days2 + "D" : "") + (hours2 || minutes2 || seconds2 ? "T" : "") + (hours2 ? hmsSign + hours2 + "H" : "") + (minutes2 ? hmsSign + minutes2 + "M" : "") + (seconds2 ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate(
      "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
      toISOString$1
    );
    proto$2.lang = lang;
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
      config._d = new Date(parseFloat(input) * 1e3);
    });
    addParseToken("x", function(input, array, config) {
      config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.29.4";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    hooks.HTML5_FMT = {
      DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
      DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
      DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
      DATE: "YYYY-MM-DD",
      TIME: "HH:mm",
      TIME_SECONDS: "HH:mm:ss",
      TIME_MS: "HH:mm:ss.SSS",
      WEEK: "GGGG-[W]WW",
      MONTH: "YYYY-MM"
    };
    return hooks;
  });
})(moment$1);
var momentLib = moment$1.exports;
const moment = momentLib;
function dateTransform(date, currentFormat, newFormat) {
  try {
    const result = moment(date, currentFormat).format(newFormat);
    if (result === "Invalid date") {
      return date;
    }
    return result;
  } catch (e) {
    Logger$1.error("\u041E\u0448\u0438\u0431\u043A\u0430 \u0432 dateTransform");
    Logger$1.error(e);
    return void 0;
  }
}
const DEFAULT_ATTR_LABEL_OPTS = {
  serverDateFormat: SERVER_DATE_FORMAT,
  displayDateFormat: DISPLAY_DATE_FORMAT,
  vocDataSet: void 0
};
class TableCell {
  static setValue(data, value) {
    data.value = value;
    return this;
  }
  static clearInfoData(tableCellData) {
    Object.keys(tableCellData).forEach((key) => {
      if (key === "value") {
        return;
      }
      delete tableCellData[key];
    });
  }
  static setRow(data, row) {
    Object.keys(data).forEach((dataKey) => {
      const dataDto = data[dataKey];
      if ((dataDto == null ? void 0 : dataDto.pointer) && dataDto.pointer.row !== row) {
        PointerHelper.deleteVisualRow(dataDto.pointer);
        dataDto.pointer.row = row;
      }
    });
  }
  static setAllByRepository(data, pointer, table_cell, changes) {
    TableCell.setValue(data, table_cell.value);
    changes.forEach((key) => {
      if (key === "value") {
        TableCell.setValue(data, table_cell.value);
        return;
      }
    });
    return this;
  }
  static async getCopyValue(value, tableDataSet, model) {
    const type = tableDataSet.getTypeModel(model);
    if (type.base_type === "JSON") {
      return TableCell.getLabelByJsonType(value, type);
    }
    if (type.base_type === "VOC") {
      return TableCell.getLabelByVocType(model.vocDataSet, value, "value_id");
    }
    return toStr(value);
  }
  static clear(data) {
    data.value = "";
  }
  static getRepository(data) {
    return {
      value: data.value
    };
  }
  static getRepositoryFormat(data, newValue) {
    const iRepositoryTableCell = { ...data };
    if (!newValue) {
      return iRepositoryTableCell;
    }
    Object.keys(newValue).forEach((key) => {
      const value = newValue[key];
      if (typeof value === "string") {
        iRepositoryTableCell[key] = value;
      } else if (typeof value === "object") {
        iRepositoryTableCell[key] = value.value.text;
      }
    });
    return iRepositoryTableCell;
  }
  static getRepositoryFormatByChangeCell(changeCell) {
    return this.getRepositoryFormat(
      { value: changeCell.value },
      changeCell.info
    );
  }
  static getRepositoryTableCellAndPointerFormatByChangeCellAndPointer(changeCellAndPointer) {
    return {
      table_cell: this.getRepositoryFormatByChangeCell(
        changeCellAndPointer.changeCell
      ),
      pointer: changeCellAndPointer.pointer,
      changes: changeCellAndPointer.changes
    };
  }
  static getChangeValue(cellData, info) {
    return {
      value: cellData.value,
      info
    };
  }
  static getDefaultValue(type) {
    if (!type) {
      return "";
    }
    if (type.default !== void 0) {
      return type.default;
    }
    if (type.base_type === "DICT") {
      return Object.keys(type.data_source)[0];
    }
    if (type.base_type === "LIST" && type.strict) {
      return type.data_source[0];
    }
    return "";
  }
  static getEmptyValue(type) {
    return "";
  }
  static getLabelByJsonType(value, type) {
    if (!value || typeof value !== "object") {
      return "";
    }
    return Object.keys(type.labels).map((labelKey) => `${type.labels[labelKey]} ${value[labelKey]}`).join(", ");
  }
  static getLabelByVocType(vocDataSet, value, mode) {
    if (!value || typeof value !== "string") {
      return "";
    }
    if (!vocDataSet || mode === "value_id" || !vocDataSet.typeOrRepository.translate_value_id) {
      return value;
    }
    const value_ids = getVocValuesIdByCellValue(value);
    return value_ids.map((value_id) => {
      const vocValueDto = vocDataSet.getVocValueDto(value_id);
      if (vocValueDto === void 0) {
        return "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430..";
      }
      if (vocValueDto === null) {
        return value_id;
      }
      return toStr(vocValueDto.label);
    }).join(`${VOC_JOIN_SEPARATOR} `);
  }
  static getLabelByDictType(value, type) {
    if (typeof type.data_source === "object" && value in type.data_source) {
      return type.data_source[value];
    }
    return toStr(value);
  }
  static getLabelByValue(value, type, model, opts = DEFAULT_ATTR_LABEL_OPTS) {
    var _a;
    if (type.base_type === "DATE") {
      return (_a = dateTransform(value, opts.serverDateFormat, opts.displayDateFormat) || value) != null ? _a : "";
    }
    if (type.base_type === "VOC") {
      return TableCell.getLabelByVocType(opts.vocDataSet, value, "default");
    }
    if (type.base_type === "JSON") {
      return TableCell.getLabelByJsonType(value, type);
    }
    if (type.base_type === "DICT") {
      return TableCell.getLabelByDictType(value, type);
    }
    return toStr(value);
  }
  static getSystemAttrs(tableRow, field) {
    var _a;
    const key = "__cell_" + field;
    return (_a = tableRow.cells[key]) == null ? void 0 : _a.value;
  }
}
function get(t, path) {
  return path.split(".").reduce((r, k) => r == null ? void 0 : r[k], t);
}
function set(obj, path, value) {
  if (typeof path === "string") {
    const pList = path.split(".");
    const lastKey = pList.pop();
    const pointer = pList.reduce(
      (accumulator, currentValue) => {
        if (accumulator[currentValue] === void 0)
          accumulator[currentValue] = {};
        return accumulator[currentValue];
      },
      obj
    );
    if (typeof lastKey !== "undefined") {
      pointer[lastKey] = value;
      return obj;
    }
  }
  return obj;
}
class GlobalContext {
  static setContext(path, contextValue) {
    set(this.contextDict, path, contextValue);
    this.logUpdate(contextValue);
  }
  static set(contextName, value) {
    this.contextDict[contextName] = value;
  }
  static setAssign(partialContext) {
    Object.keys(partialContext).forEach((key) => {
      Object.defineProperty(this.contextDict, key, {
        configurable: true,
        enumerable: true,
        get: function() {
          return partialContext[key];
        },
        set: function(value) {
          partialContext[key] = value;
        }
      });
    });
    this.logUpdate(partialContext);
  }
  static setMerge(partialContext) {
    mergeDeep(this.contextDict, partialContext);
    this.logUpdate(partialContext);
  }
  static setMutate(mutateFunc) {
    mutateFunc(this.contextDict);
    this.logUpdate();
  }
  static get(path) {
    const value = !isNullOrUndefined(path) ? get(this.contextDict, path) : void 0;
    if (value !== void 0) {
      return value;
    }
    return copy(this.contextDict);
  }
  static logUpdate(...updates) {
    Logger$1.debug("UpdateContext", {
      context: this.contextDict,
      update: updates.length === 1 ? updates[0] : updates
    });
  }
}
GlobalContext.contextDict = reactive({});
class TableModel {
  constructor(tableModel) {
    Object.assign(this, tableModel);
  }
  static isSupportServerSort(model) {
    if (!model) {
      return false;
    }
    const support = model.modelDto.sort;
    if (isNullOrUndefined(support)) {
      return false;
    }
    return support;
  }
  static async initVoc(model, types) {
    if (!model.type) {
      return void 0;
    }
    const type = types[model.type];
    if (!type) {
      return void 0;
    }
    if (type.base_type !== "VOC") {
      return void 0;
    }
    const getVocDto = async () => {
      if (!type.voc_type) {
        return void 0;
      }
      const vocTypes = (await ApiService$1.getVocDict()).json;
      const vocDto2 = vocTypes[type.voc_type];
      if (!vocDto2) {
        Logger$1.warn(`not found voc_type: ${type.voc_type}`, vocTypes);
      }
      return vocDto2;
    };
    const vocDto = await getVocDto();
    if (vocDto) {
      model.vocDataSet = new VocDataSet(vocDto, type);
    } else {
      return void 0;
    }
    model.vocDataSet = new VocDataSet(vocDto, type);
    model.vocDataSet.setContext(GlobalContext.get());
    return model.vocDataSet;
  }
  setWidth(width) {
    this.width = width;
  }
  setHide(hide) {
    this.hide = hide;
  }
  destroy() {
    var _a;
    (_a = this.vocDataSet) == null ? void 0 : _a.destroy();
  }
  getFilter() {
    var _a;
    return (_a = this.modelDto.filter) != null ? _a : FILTER_LOCAL_COMPARISON_OPERATIONS_ARRAY;
  }
  getAutoWidth(tableDataSet) {
    const type = tableDataSet.getTypeModel(this);
    const labelOpts = tableDataSet.getCellLabelOpts(this.field);
    const maxLength = tableDataSet.rows.map(
      (x) => TableCell.getLabelByValue(
        x.cells[this.field].value,
        type,
        this.modelDto,
        labelOpts
      )
    ).reduce((maxLength2, currentValue) => {
      const currentLength = toStr(currentValue).length;
      if (currentLength > maxLength2) {
        maxLength2 = currentLength;
      }
      return maxLength2;
    }, 0);
    let width = Math.floor(2 + maxLength / 2);
    width = Math.max(5, width);
    width = Math.min(20, width);
    return `${width}em`;
  }
}
var ResizeComponent_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$1A = defineComponent({
  name: "ResizeComponent",
  components: {},
  props: {
    mode: {
      type: String,
      default: "height"
    },
    class: {},
    classDiv: {},
    style: TVuePropTypes.style,
    divStyle: TVuePropTypes.style,
    size: Number,
    componentSize: {
      type: String,
      default: "2px"
    },
    elementRef: {
      type: Object,
      required: true
    }
  },
  emits: ["change", "mouseup", "dblclick"],
  setup() {
    return {};
  },
  data() {
    return {
      mouseMovePrev: null
    };
  },
  computed: {
    widthStr() {
      if (this.mode === "width") {
        return this.componentSize;
      }
      return "100%";
    },
    heightStr() {
      if (this.mode === "height") {
        return this.componentSize;
      }
      return "100%";
    },
    widthDivStr() {
      if (this.mode === "width") {
        return this.componentSize;
      }
      return "100%";
    },
    heightDivStr() {
      if (this.mode === "height") {
        return this.componentSize;
      }
      return "100%";
    },
    styleComputed() {
      return [
        {
          width: this.widthStr,
          height: this.heightStr
        },
        this.style
      ];
    },
    divStyleComputed() {
      return [
        {
          height: this.heightDivStr,
          width: this.widthDivStr
        },
        this.divStyle
      ];
    }
  },
  watch: {},
  created() {
  },
  methods: {
    setSize(value) {
      this.$emit("change", value);
    },
    onMouseLeave(event) {
      if (event.buttons != 1) {
        return;
      }
      document.addEventListener("mousemove", this.onDocumentMouseMove);
      this.onMouseMove(event);
    },
    onDocumentMouseMove(event) {
      this.onMouseMove(event);
    },
    onMouseMove(event) {
      if (event.buttons !== 1) {
        this.onMouseUp(event);
        return;
      }
      const prev = this.mouseMovePrev;
      this.mouseMovePrev = event;
      let offsetSizeProperty = "offsetHeight";
      let clientSizeProperty = "clientY";
      if (this.mode === "width") {
        offsetSizeProperty = "offsetWidth";
        clientSizeProperty = "clientX";
      }
      const currentSize = this.size || this.elementRef[offsetSizeProperty];
      let differenceSize = prev ? prev[clientSizeProperty] - event[clientSizeProperty] : 0;
      if (this.mode === "width") {
        differenceSize *= -1;
      }
      if (differenceSize !== 0) {
        this.setSize(currentSize + differenceSize);
      }
    },
    onMouseUp(event) {
      if (this.mouseMovePrev === null) {
        return;
      }
      this.clearMouse();
      this.$emit("mouseup", event);
    },
    clearMouse() {
      document.removeEventListener("mousemove", this.onDocumentMouseMove);
      this.mouseMovePrev = null;
    }
  }
});
const _hoisted_1$1k = ["onSelect", "onSelectstart"];
function _sfc_render$1A(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass([this.class, "resize-component"]),
    style: normalizeStyle(_ctx.styleComputed),
    onDblclick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("dblclick", $event)),
    onMouseleave: _cache[1] || (_cache[1] = (...args) => _ctx.onMouseLeave && _ctx.onMouseLeave(...args)),
    onMousemove: _cache[2] || (_cache[2] = (...args) => _ctx.onMouseMove && _ctx.onMouseMove(...args)),
    onMouseup: _cache[3] || (_cache[3] = (...args) => _ctx.onMouseUp && _ctx.onMouseUp(...args)),
    onSelect: withModifiers(($event) => false, ["prevent"]),
    onSelectstart: withModifiers(($event) => false, ["prevent"])
  }, [
    createElementVNode("div", {
      ref: "resizeDivRef",
      class: normalizeClass([_ctx.classDiv, "resize-component-div"]),
      style: normalizeStyle(_ctx.divStyleComputed)
    }, null, 6)
  ], 46, _hoisted_1$1k);
}
var ResizeComponent = /* @__PURE__ */ _export_sfc(_sfc_main$1A, [["render", _sfc_render$1A], ["__scopeId", "data-v-5b447cfb"]]);
var CheckboxComponent_vue_vue_type_style_index_0_scoped_true_lang = "";
const __default__$6 = defineComponent({
  name: "CheckboxComponent",
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false
    },
    class: {
      required: false
    },
    icon: {
      type: Object
    },
    containerClass: {
      type: String,
      default: "checkbox-container"
    },
    container2Class: {
      type: String,
      default: "checkbox-container-2"
    },
    labelClass: {
      type: String,
      default: "checkbox-label"
    },
    size: {
      type: String,
      default: "24px"
    }
  },
  setup() {
    return {
      ICONS,
      boolToString
    };
  },
  data() {
    return {};
  },
  computed: {
    iconComputed() {
      return this.icon || ICONS.chevronDone;
    }
  },
  methods: {}
});
const __injectCSSVars__$6 = () => {
  useCssVars((_ctx) => ({
    "7d23214e": _ctx.size
  }));
};
const __setup__$6 = __default__$6.setup;
__default__$6.setup = __setup__$6 ? (props, ctx) => {
  __injectCSSVars__$6();
  return __setup__$6(props, ctx);
} : __injectCSSVars__$6;
const _sfc_main$1z = __default__$6;
const _hoisted_1$1j = ["data-disabled"];
const _hoisted_2$12 = ["data-checked"];
const _hoisted_3$U = ["alt", "src"];
function _sfc_render$1z(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass([this.containerClass, this.class]),
    "data-disabled": _ctx.boolToString(_ctx.disabled)
  }, [
    createElementVNode("div", {
      class: normalizeClass(_ctx.container2Class),
      "data-checked": _ctx.boolToString(Boolean(_ctx.checked))
    }, [
      createElementVNode("img", {
        alt: _ctx.iconComputed.alt,
        src: _ctx.iconComputed.src,
        style: normalizeStyle({ opacity: _ctx.checked ? 1 : 0 })
      }, null, 12, _hoisted_3$U)
    ], 10, _hoisted_2$12),
    _ctx.label ? (openBlock(), createElementBlock("label", {
      key: 0,
      class: normalizeClass(_ctx.labelClass)
    }, toDisplayString(_ctx.label), 3)) : createCommentVNode("", true)
  ], 10, _hoisted_1$1j);
}
var CheckboxComponent = /* @__PURE__ */ _export_sfc(_sfc_main$1z, [["render", _sfc_render$1z], ["__scopeId", "data-v-aa4937d2"]]);
const _sfc_main$1y = defineComponent({
  name: "TableMultiHeadersTh",
  components: {
    ResizeComponent,
    FaqIcon,
    CheckboxComponent
  },
  props: {
    classes: {
      type: Object,
      default: TABLE_CLASSES
    },
    tableDataSet: {
      type: Object,
      required: true
    },
    cell: {
      type: Object,
      required: true
    },
    model: {
      type: TableModel
    }
  },
  emits: ["click-left-col", "click-left-column"],
  setup() {
    return {
      boolToString,
      ICONS
    };
  },
  data() {
    return {
      prevWidth: void 0,
      newWidth: void 0,
      thRef: void 0
    };
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
    var _a;
    this.prevWidth = (_a = this.model) == null ? void 0 : _a.width;
    this.newWidth = this.prevWidth;
    this.updateRefs();
  },
  updated() {
    this.updateRefs();
  },
  methods: {
    updateRefs() {
      if (this.thRef !== this.$refs.thRef) {
        this.thRef = this.$refs.thRef;
      }
    },
    onClickFilter(event, field) {
      this.tableDataSet.getFilterComponent().setField(field);
      this.tableDataSet.tooltip.show("filter", event);
    },
    onClickCell(event, cell) {
      if (cell.isLeftCol) {
        this.$emit("click-left-col", event);
        return;
      }
      if (cell.leftColumn) {
        this.$emit("click-left-column", {
          event,
          cell
        });
        return;
      }
      if (cell.field !== void 0) {
        this.tableDataSet.selected.selectedCol(this.tableDataSet, cell.field);
      }
    },
    onWidthChange(value) {
      const width = value === void 0 ? void 0 : `${Math.max(30, toNumberOrDefault(value))}px`;
      if (this.prevWidth === width) {
        return;
      }
      this.tableDataSet.colResize(
        {
          prev_width: this.prevWidth,
          width,
          col_name: this.model.field
        },
        false
      );
      this.newWidth = width;
    },
    onWidthChangeSave() {
      if (this.prevWidth === this.newWidth) {
        return;
      }
      this.tableDataSet.colResize({
        prev_width: this.prevWidth,
        width: this.newWidth,
        col_name: this.model.field
      });
      this.prevWidth = this.newWidth;
    },
    onWidthDblClick(event) {
      this.newWidth = ModelHelper.getWidth(this.model.modelDto.width);
      this.onWidthChangeSave();
    }
  }
});
const _hoisted_1$1i = ["colspan", "data-field", "rowspan"];
const _hoisted_2$11 = ["title"];
const _hoisted_3$T = ["data-active"];
const _hoisted_4$J = ["alt", "src"];
function _sfc_render$1y(_ctx, _cache, $props, $setup, $data, $options) {
  var _a, _b, _c;
  const _component_FaqIcon = resolveComponent("FaqIcon");
  const _component_CheckboxComponent = resolveComponent("CheckboxComponent");
  const _component_ResizeComponent = resolveComponent("ResizeComponent");
  return openBlock(), createElementBlock("th", {
    ref: "thRef",
    class: normalizeClass({
      [_ctx.classes.th]: true,
      [_ctx.classes.thNum]: _ctx.cell.isLeftCol && _ctx.cell.leftColumn,
      [_ctx.classes.selectCell]: _ctx.cell.isLeftCol && _ctx.cell.caption === "checkbox" || _ctx.cell.leftColumn,
      [_ctx.classes.selectedHeader]: _ctx.tableDataSet.isSelectedHeader((_a = _ctx.model) == null ? void 0 : _a.field) && _ctx.cell.child === void 0 && !_ctx.cell.isLeftCol && !_ctx.cell.leftColumn
    }),
    colspan: _ctx.cell.colspan,
    "data-field": (_b = _ctx.model) == null ? void 0 : _b.field,
    rowspan: _ctx.cell.rowspan,
    onClick: _cache[3] || (_cache[3] = withModifiers(($event) => _ctx.onClickCell($event, _ctx.cell), ["stop"])),
    onContextmenu: _cache[4] || (_cache[4] = withModifiers(($event) => _ctx.tableDataSet.showContextMenu({
      event: $event,
      type: "header",
      pointer: _ctx.model ? { col: _ctx.model.index, col_name: _ctx.model.field } : void 0
    }), ["prevent"]))
  }, [
    _ctx.tableDataSet.helpHelper.visible && (_ctx.cell.help || _ctx.tableDataSet.getEdit("hint")) ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: normalizeClass(_ctx.classes.thHelp),
      title: _ctx.cell.help || "[\u043D\u0435 \u0437\u0430\u0434\u0430\u043D\u043E]",
      onClick: _cache[0] || (_cache[0] = withModifiers(($event) => {
        var _a2;
        return _ctx.tableDataSet.helpHelper.setHelp(_ctx.cell.help || "[\u043D\u0435 \u0437\u0430\u0434\u0430\u043D\u043E]", {
          tableDataSet: _ctx.tableDataSet,
          field: (_a2 = _ctx.model) == null ? void 0 : _a2.field
        });
      }, ["stop"]))
    }, [
      createVNode(_component_FaqIcon)
    ], 10, _hoisted_2$11)) : createCommentVNode("", true),
    _ctx.cell.isLeftCol && _ctx.cell.caption === "checkbox" || ((_c = _ctx.cell.leftColumn) == null ? void 0 : _c.type) === "checkbox" ? (openBlock(), createElementBlock("label", {
      key: 1,
      class: normalizeClass(_ctx.classes.thDiv)
    }, [
      createVNode(_component_CheckboxComponent, {
        checked: _ctx.tableDataSet.isSelectedAll
      }, null, 8, ["checked"])
    ], 2)) : (openBlock(), createElementBlock("div", {
      key: 2,
      class: normalizeClass(_ctx.classes.thDiv)
    }, [
      createElementVNode("div", {
        class: normalizeClass(_ctx.classes.thDivContent)
      }, toDisplayString(_ctx.cell.caption), 3),
      _ctx.model ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(_ctx.classes.thDivFilter),
        "data-active": _ctx.boolToString(
          _ctx.tableDataSet.sort.sort !== null && _ctx.tableDataSet.sort.model === _ctx.model || _ctx.tableDataSet.groupsManager.groups.some(
            (group) => group.field === _ctx.model.field
          )
        ),
        onClick: _cache[1] || (_cache[1] = withModifiers(($event) => _ctx.onClickFilter($event, _ctx.model.field), ["stop"]))
      }, [
        createElementVNode("img", {
          alt: _ctx.ICONS.filterOutline.alt,
          src: _ctx.ICONS.filterOutline.src
        }, null, 8, _hoisted_4$J)
      ], 10, _hoisted_3$T)) : createCommentVNode("", true)
    ], 2)),
    _ctx.model && _ctx.thRef ? (openBlock(), createBlock(_component_ResizeComponent, {
      key: 3,
      class: normalizeClass(_ctx.classes.thDivResize),
      "class-div": _ctx.classes.thDivResizeDiv,
      "element-ref": _ctx.thRef,
      "component-size": "4px",
      mode: "width",
      onChange: _ctx.onWidthChange,
      onMouseup: withModifiers(_ctx.onWidthChangeSave, ["stop"]),
      onDblclick: withModifiers(_ctx.onWidthDblClick, ["stop"]),
      onClick: _cache[2] || (_cache[2] = withModifiers(() => {
      }, ["stop"]))
    }, null, 8, ["class", "class-div", "element-ref", "onChange", "onMouseup", "onDblclick"])) : createCommentVNode("", true)
  ], 42, _hoisted_1$1i);
}
var TableMultiHeadersTh = /* @__PURE__ */ _export_sfc(_sfc_main$1y, [["render", _sfc_render$1y]]);
const _sfc_main$1x = defineComponent({
  name: "TableMultiHeaders",
  components: {
    TableMultiHeadersTh,
    FaqIcon
  },
  props: {
    classes: {
      type: Object,
      default: TABLE_CLASSES
    },
    leftCol: {
      type: String,
      required: false
    },
    tableDataSet: {
      type: Object,
      required: true
    },
    leftColumns: {
      type: Array
    }
  },
  emits: ["click-left-col", "click-left-column"],
  setup() {
    return {
      boolToString,
      ICONS,
      toStr
    };
  },
  data() {
    return {
      maxLevel: 0,
      headersModelCache: []
    };
  },
  computed: {
    headersModel: function() {
      this.setHeadersModelCache([]);
      this.headersNode(this.headersTree(), 1);
      return this.headersModelCache;
    }
  },
  mounted() {
  },
  methods: {
    setHeadersModelCache(cache) {
      this.headersModelCache = cache;
    },
    findHeaders: function(data, field_name) {
      if (!Array.isArray(data)) {
        return null;
      }
      if (data.includes(field_name)) {
        return [];
      }
      for (let item of data) {
        if (typeof item === "string") {
          continue;
        }
        let caption = Object.keys(item)[0];
        if (caption == field_name) {
          return [];
        }
        let child = item[caption];
        let res = this.findHeaders(child, field_name);
        if (res) {
          res.push(caption);
          return res;
        }
      }
      return null;
    },
    countFields: function(container) {
      let res = 0;
      for (let item of container) {
        if (item == null ? void 0 : item.field) {
          res++;
        } else {
          res += this.countFields(item.child);
        }
      }
      container.size = res;
      return res;
    },
    childLevels: function(node) {
      if (!node.child) {
        return 0;
      }
      let res = 0;
      for (let item of node.child) {
        let levels = this.childLevels(item) + 1;
        if (levels > res) {
          res = levels;
        }
      }
      return res;
    },
    headersTree: function() {
      var _a;
      let res = [];
      let maxLevel = 0;
      if (this.leftColumns) {
        this.leftColumns.forEach((leftColumn) => {
          res.push({
            level: 1,
            caption: leftColumn.caption,
            leftColumn
          });
        });
      }
      for (const modelDto of this.tableDataSet.modelUnref) {
        let fh = this.findHeaders(
          this.tableDataSet.headersUnref,
          modelDto.field
        );
        let container = res;
        let level = 1;
        if (fh) {
          if (fh.length > maxLevel) {
            maxLevel = fh.length;
          }
          while (fh.length) {
            let h = fh.pop();
            if (((_a = container[container.length - 1]) == null ? void 0 : _a.caption) != h) {
              container.push({
                level,
                caption: h,
                child: []
              });
            }
            level++;
            container = container[container.length - 1].child;
          }
        }
        const model = this.tableDataSet.getModelOrUndefined(modelDto.field);
        if (model == null ? void 0 : model.hide) {
          continue;
        }
        const headerCell = {
          level,
          caption: modelDto.caption,
          field: modelDto.field,
          modelIndex: model.index,
          help: model.index >= 0 ? model.modelDto.help : void 0
        };
        container.push(headerCell);
      }
      this.maxLevel = maxLevel;
      if (typeof this.leftCol === "string") {
        res.unshift({
          level: 1,
          caption: this.leftCol,
          isLeftCol: true
        });
      }
      return res;
    },
    headersNode: function(nodes, level) {
      var _a;
      for (let node of nodes) {
        node.colspan = node.child ? this.countFields(node.child) : 1;
        node.level = level;
        node.rowspan = this.maxLevel + 1 - this.childLevels(node) - (level - 1);
        if (this.headersModelCache[node.level - 1] == void 0) {
          this.headersModelCache[node.level - 1] = [];
        }
        if (!node.isLeftCol && !node.leftColumn && node.modelIndex === void 0 && !((_a = node.child) == null ? void 0 : _a.length)) {
          continue;
        }
        this.headersModelCache[node.level - 1].push(node);
        if (node.child) {
          this.headersNode(node.child, level + node.rowspan);
        }
      }
    }
  }
});
function _sfc_render$1x(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TableMultiHeadersTh = resolveComponent("TableMultiHeadersTh");
  return openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.headersModel, (level, levelIndex) => {
    return openBlock(), createElementBlock("tr", {
      key: levelIndex,
      class: normalizeClass(_ctx.classes.header)
    }, [
      (openBlock(true), createElementBlock(Fragment, null, renderList(level, (cell, cellIndex) => {
        return openBlock(), createBlock(_component_TableMultiHeadersTh, {
          key: _ctx.toStr(cell.field) + cellIndex + cell.modelIndex,
          cell,
          classes: _ctx.classes,
          model: _ctx.tableDataSet.getModelOrUndefined(cell.field),
          "table-data-set": _ctx.tableDataSet,
          onClickLeftCol: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("click-left-col", $event)),
          onClickLeftColumn: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("click-left-column", $event))
        }, null, 8, ["cell", "classes", "model", "table-data-set"]);
      }), 128))
    ], 2);
  }), 128);
}
var TableMultiHeaders = /* @__PURE__ */ _export_sfc(_sfc_main$1x, [["render", _sfc_render$1x]]);
var TableCellListComponent_vue_vue_type_style_index_0_lang = "";
const _sfc_main$1w = defineComponent({
  name: "TableCellListComponent",
  emits: [
    "change",
    "blur",
    "keydown"
  ],
  props: {
    value: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => []
    },
    isStrict: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      id: makeId(5)
    };
  },
  mounted() {
    this.focus();
  },
  methods: {
    focus() {
      this.$nextTick(() => {
        this.$refs.inputRef.focus();
      });
    },
    onChange(value) {
      this.$emit("change", value);
    },
    onKeyDown(event) {
      if (event.key === "ArrowDown") {
        event.stopPropagation();
        return;
      }
      if (event.ctrlKey) {
        if (event.code === "KeyA") {
          event.stopPropagation();
          return;
        }
      }
    }
  },
  computed: {}
});
const _hoisted_1$1h = { class: "cell-list-container" };
const _hoisted_2$10 = { class: "cell-list-input-block" };
const _hoisted_3$S = ["list", "value"];
const _hoisted_4$I = ["id"];
const _hoisted_5$w = ["value"];
function _sfc_render$1w(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$1h, [
    createElementVNode("div", _hoisted_2$10, [
      createElementVNode("input", {
        ref: "inputRef",
        list: _ctx.id,
        value: _ctx.value,
        onBlur: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("blur", $event)),
        onChange: _cache[1] || (_cache[1] = ($event) => _ctx.onChange($event.target.value)),
        onKeydown: _cache[2] || (_cache[2] = (...args) => _ctx.onKeyDown && _ctx.onKeyDown(...args))
      }, null, 40, _hoisted_3$S),
      createElementVNode("datalist", { id: _ctx.id }, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.options, (option) => {
          return openBlock(), createElementBlock("option", {
            key: option,
            value: option
          }, null, 8, _hoisted_5$w);
        }), 128))
      ], 8, _hoisted_4$I)
    ])
  ]);
}
var TableCellListComponent = /* @__PURE__ */ _export_sfc(_sfc_main$1w, [["render", _sfc_render$1w]]);
class EventHelper {
  constructor(event) {
    this.event = event;
    this.results = [];
    this.funcIfTrue = [];
  }
  get isAllTrue() {
    return this.setResult(!this.results.some((x) => !x));
  }
  get isAllFalse() {
    return this.setResult(!this.results.some((x) => x));
  }
  get isAnyTrue() {
    return this.setResult(this.results.some((x) => x));
  }
  get isAnyFalse() {
    return this.setResult(this.results.some((x) => !x));
  }
  get stop() {
    this.funcIfTrue.push(() => {
      this.event.stopPropagation();
    });
    return this;
  }
  get stopImmediate() {
    this.funcIfTrue.push(() => {
      this.event.stopImmediatePropagation();
    });
    return this;
  }
  get prevent() {
    this.funcIfTrue.push(() => {
      this.event.preventDefault();
    });
    return this;
  }
  clear() {
    this.results = [];
    this.funcIfTrue = [];
  }
  setResult(result) {
    if (result) {
      this.funcIfTrue.forEach((x) => x());
    }
    this.clear();
    return result;
  }
}
const keys = {
  arrowLeft: "ArrowLeft",
  arrowRight: "ArrowRight",
  arrowUp: "ArrowUp",
  arrowDown: "ArrowDown",
  F1: "F1",
  F2: "F2",
  F3: "F3",
  F4: "F4",
  F5: "F5",
  F6: "F6",
  F7: "F7",
  F8: "F8",
  F9: "F9",
  F10: "F10",
  F11: "F11",
  F12: "F12"
};
const keysArrowHorizontal = [keys.arrowLeft, keys.arrowRight];
const keysArrowVertical = [keys.arrowUp, keys.arrowDown];
class KeyboardEventHelper extends EventHelper {
  constructor(event) {
    super(event);
    this.event = event;
  }
  get keyArrow() {
    this.results.push(KeyboardEventHelper.isKeyArrow(this.event));
    return this;
  }
  get keyArrowLeft() {
    this.results.push(KeyboardEventHelper.isKeyArrowLeft(this.event));
    return this;
  }
  get keyArrowRight() {
    this.results.push(KeyboardEventHelper.isKeyArrowRight(this.event));
    return this;
  }
  get keyArrowUp() {
    this.results.push(KeyboardEventHelper.isKeyArrowUp(this.event));
    return this;
  }
  get keyArrowDown() {
    this.results.push(KeyboardEventHelper.isKeyArrowDown(this.event));
    return this;
  }
  get keyArrowVertical() {
    this.results.push(KeyboardEventHelper.isKeyArrowVertical(this.event));
    return this;
  }
  get keyArrowHorizontal() {
    this.results.push(KeyboardEventHelper.isKeyArrowHorizontal(this.event));
    return this;
  }
  get keyEnter() {
    this.results.push(KeyboardEventHelper.isKeyEnter(this.event));
    return this;
  }
  get keyTab() {
    this.results.push(KeyboardEventHelper.isKeyTab(this.event));
    return this;
  }
  get keyEscape() {
    this.results.push(KeyboardEventHelper.isKeyEscape(this.event));
    return this;
  }
  get keyAlt() {
    this.results.push(KeyboardEventHelper.isKeyAlt(this.event));
    return this;
  }
  get keyF1() {
    this.results.push(KeyboardEventHelper.isKeyF1(this.event));
    return this;
  }
  get keyF2() {
    this.results.push(KeyboardEventHelper.isKeyF2(this.event));
    return this;
  }
  get keyF3() {
    this.results.push(KeyboardEventHelper.isKeyF3(this.event));
    return this;
  }
  get keyF4() {
    this.results.push(KeyboardEventHelper.isKeyF4(this.event));
    return this;
  }
  get keyF5() {
    this.results.push(KeyboardEventHelper.isKeyF5(this.event));
    return this;
  }
  get keyF6() {
    this.results.push(KeyboardEventHelper.isKeyF6(this.event));
    return this;
  }
  get keyF7() {
    this.results.push(KeyboardEventHelper.isKeyF7(this.event));
    return this;
  }
  get keyF8() {
    this.results.push(KeyboardEventHelper.isKeyF8(this.event));
    return this;
  }
  get keyF9() {
    this.results.push(KeyboardEventHelper.isKeyF9(this.event));
    return this;
  }
  get keyF10() {
    this.results.push(KeyboardEventHelper.isKeyF10(this.event));
    return this;
  }
  get keyF11() {
    this.results.push(KeyboardEventHelper.isKeyF11(this.event));
    return this;
  }
  get keyF12() {
    this.results.push(KeyboardEventHelper.isKeyF12(this.event));
    return this;
  }
  get codeKeyV() {
    this.results.push(KeyboardEventHelper.isCodeKeyV(this.event));
    return this;
  }
  get codeSpace() {
    this.results.push(KeyboardEventHelper.isCodeSpace(this.event));
    return this;
  }
  get codeDelete() {
    this.results.push(KeyboardEventHelper.isCodeDelete(this.event));
    return this;
  }
  get pressCtrl() {
    this.results.push(KeyboardEventHelper.isPressCtrl(this.event));
    return this;
  }
  get pressShift() {
    this.results.push(KeyboardEventHelper.isPressShift(this.event));
    return this;
  }
  get pressAlt() {
    this.results.push(KeyboardEventHelper.isPressAlt(this.event));
    return this;
  }
  static isKeyArrow(event) {
    return event.key.includes("Arrow");
  }
  static isKeyArrowLeft(event) {
    return event.key === keys.arrowLeft;
  }
  static isKeyArrowRight(event) {
    return event.key === keys.arrowRight;
  }
  static isKeyArrowUp(event) {
    return event.key === keys.arrowUp;
  }
  static isKeyArrowDown(event) {
    return event.key === keys.arrowDown;
  }
  static isKeyArrowHorizontal(event) {
    return keysArrowHorizontal.includes(event.key);
  }
  static isKeyArrowVertical(event) {
    return keysArrowVertical.includes(event.key);
  }
  static isKeyEnter(event) {
    return event.key === "Enter";
  }
  static isKeyTab(event) {
    return event.key === "Tab";
  }
  static isKeyEscape(event) {
    return event.key === "Escape";
  }
  static isKeyAlt(event) {
    return event.key === "Alt";
  }
  static isKeyF1(event) {
    return event.key === keys.F1;
  }
  static isKeyF2(event) {
    return event.key === keys.F2;
  }
  static isKeyF3(event) {
    return event.key === keys.F3;
  }
  static isKeyF4(event) {
    return event.key === keys.F4;
  }
  static isKeyF5(event) {
    return event.key === keys.F5;
  }
  static isKeyF6(event) {
    return event.key === keys.F6;
  }
  static isKeyF7(event) {
    return event.key === keys.F7;
  }
  static isKeyF8(event) {
    return event.key === keys.F8;
  }
  static isKeyF9(event) {
    return event.key === keys.F9;
  }
  static isKeyF10(event) {
    return event.key === keys.F10;
  }
  static isKeyF11(event) {
    return event.key === keys.F11;
  }
  static isKeyF12(event) {
    return event.key === keys.F12;
  }
  static isCodeDelete(event) {
    return event.code === "Delete";
  }
  static isCodeKeyV(event) {
    return event.code === "KeyV";
  }
  static isCodeSpace(event) {
    return event.code === "Space";
  }
  static isPressCtrl(event) {
    return event.ctrlKey;
  }
  static isPressShift(event) {
    return event.shiftKey;
  }
  static isPressAlt(event) {
    return event.altKey;
  }
}
var TableCellDictComponent_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$1v = defineComponent({
  name: "TableCellDictComponent",
  emits: [
    "change",
    "blur",
    "keydown"
  ],
  props: {
    value: {
      type: String,
      default: ""
    },
    options: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      isOpen: false,
      id: makeId(5)
    };
  },
  mounted() {
    this.focus();
  },
  methods: {
    focus() {
      this.$nextTick(() => {
        this.$refs.selectRef.focus();
      });
    },
    onChange(event) {
      const target = event.target;
      this.$emit("change", target.value);
    },
    onKeyDown(event) {
      const eventHelper = new KeyboardEventHelper(event);
      if (eventHelper.stop.keyArrowVertical.isAnyTrue) {
        return;
      }
      this.$emit("keydown", event);
    }
  },
  computed: {
    isValid() {
      if (this.value in this.options) {
        return true;
      }
      return false;
    }
  }
});
const _hoisted_1$1g = { class: "cell-dict-container" };
const _hoisted_2$$ = { class: "cell-dict-input-block" };
const _hoisted_3$R = ["selected"];
const _hoisted_4$H = ["value"];
const _hoisted_5$v = ["selected", "value"];
function _sfc_render$1v(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$1g, [
    createElementVNode("div", _hoisted_2$$, [
      createElementVNode("select", {
        ref: "selectRef",
        onBlur: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("blur")),
        onChange: _cache[1] || (_cache[1] = (...args) => _ctx.onChange && _ctx.onChange(...args)),
        onKeydown: _cache[2] || (_cache[2] = (...args) => _ctx.onKeyDown && _ctx.onKeyDown(...args))
      }, [
        createElementVNode("option", {
          selected: !_ctx.value || _ctx.value === "",
          value: ""
        }, null, 8, _hoisted_3$R),
        !_ctx.isValid && _ctx.value ? (openBlock(), createElementBlock("option", {
          key: 0,
          value: _ctx.value,
          selected: "",
          style: { "color": "red !important" },
          title: "\u041D\u0435\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435"
        }, toDisplayString(_ctx.value), 9, _hoisted_4$H)) : createCommentVNode("", true),
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.options, (option, key) => {
          return openBlock(), createElementBlock("option", {
            key,
            selected: _ctx.value === key,
            value: key
          }, toDisplayString(option), 9, _hoisted_5$v);
        }), 128))
      ], 544)
    ])
  ]);
}
var TableCellDictComponent = /* @__PURE__ */ _export_sfc(_sfc_main$1v, [["render", _sfc_render$1v], ["__scopeId", "data-v-1173ce5c"]]);
function lastOrDefault(array, _default) {
  if (!array) {
    return _default;
  }
  if (array instanceof Set) {
    if (array.size === 0) {
      return _default;
    }
    let value;
    for (value of array) {
    }
    return value;
  }
  if (array.length === 0) {
    return _default;
  }
  return array[array.length - 1];
}
class TableRow {
  static getEmptyTableRowRecord(model, types, row) {
    return {
      row,
      data: TableRow.getEmptyTableRowData(model, types),
      original: void 0
    };
  }
  static getEmptyTableRowData(model, types) {
    return model.reduce((row, modelRow) => {
      row[modelRow.field] = {
        value: TableCell.getDefaultValue(
          TableDataSet.getTypeModel(types, modelRow)
        )
      };
      return row;
    }, {});
  }
  static getRepositoryFormat(newValue) {
    return Object.keys(newValue).reduce((table_row, key) => {
      const value = newValue[key];
      if (value) {
        table_row[key] = value.value.text;
      }
      return table_row;
    }, {});
  }
  static getInfoData(tableInfo, pointer) {
    return tableInfo.getAllByPointer(pointer);
  }
  static setRowByRowInfoData(rowInfoData, row) {
    if (!rowInfoData) {
      return;
    }
    for (const infoDataDto of Object.values(rowInfoData)) {
      if (typeof infoDataDto !== "object" || !infoDataDto.pointer || typeof infoDataDto.pointer !== "object") {
        continue;
      }
      infoDataDto.pointer.row = row;
    }
  }
  static setValue(tableRow, value) {
    Object.keys(tableRow.cells).forEach((col_name) => {
      TableCell.setValue(tableRow.cells[col_name], value[col_name]);
    });
  }
  static setRowByRowChange(rowChange, row) {
    rowChange.row = row;
    rowChange.changeCells.forEach((changeCellAndPointer) => {
      changeCellAndPointer.pointer.row = row;
      if (changeCellAndPointer.changeCell.info) {
        TableRow.setRowByRowInfoData(changeCellAndPointer.changeCell.info, row);
      }
    });
  }
  static getDictCellChange(tableDataSet, row) {
    return tableDataSet.modelUnref.reduce((cellChanges, model) => {
      var _a;
      const pointer = {
        row,
        col_name: model.field
      };
      const info = tableDataSet.info.getAllByPointer(pointer);
      const value = (_a = tableDataSet.getCellData(pointer)) == null ? void 0 : _a.value;
      cellChanges[pointer.col_name] = {
        info,
        value
      };
      return cellChanges;
    }, {});
  }
  static getChangeCellAndPointerArray(tableDataSet, row, changes) {
    return tableDataSet.modelUnref.reduce((cellChanges, model) => {
      var _a;
      const pointer = {
        row,
        col_name: model.field
      };
      const info = tableDataSet.info.getAllByPointer(pointer);
      const value = (_a = tableDataSet.getCellData(pointer)) == null ? void 0 : _a.value;
      cellChanges.push({
        changeCell: {
          info,
          value
        },
        pointer,
        changes
      });
      return cellChanges;
    }, []);
  }
  static getRecordByChange(rowChange) {
    return {
      row: rowChange.row,
      data: rowChange.changeCells.reduce((cellData, changeCellAndPointer) => {
        cellData[changeCellAndPointer.pointer.col_name] = {
          value: changeCellAndPointer.changeCell.value
        };
        return cellData;
      }, {}),
      original: rowChange.original
    };
  }
  static getEmptyChange(tableDataSet, { row }) {
    const record = TableRow.getEmptyTableRowRecord(
      tableDataSet.modelUnref,
      tableDataSet.types,
      row
    );
    return TableRow.getChangeByRecord(record, ["value"]);
  }
  static createChange(tableDataSet, row, data) {
    const tableRowHeader = tableDataSet.createRow(row);
    TableRow.setValue(tableRowHeader, data);
    return TableRow.getChangeByTableRow(tableDataSet, tableRowHeader);
  }
  static getChangeByTableRow(tableDataSet, tableRow) {
    const tableRowHeaderChange = TableRow.getChangeByRecord(
      {
        row: tableRow.row,
        data: tableRow.cells,
        original: TableRow.getValue(tableRow)
      },
      tableDataSet.getAllCellChangesKeys()
    );
    tableRowHeaderChange.tableRow = tableRow;
    return tableRowHeaderChange;
  }
  static getChangeByRecord(record, changes) {
    return {
      row: record.row,
      data: {},
      changeCells: Object.keys(record.data).map((col_name) => {
        return {
          pointer: {
            row: record.row,
            col_name
          },
          changeCell: {
            value: record.data[col_name].value,
            info: void 0
          },
          changes
        };
      }),
      original: record.original,
      tableRow: void 0
    };
  }
  static getChangeRow(tableDataSet, tableRow) {
    const pointer = { row: tableRow.row };
    return {
      row: tableRow.row,
      data: tableDataSet.info.getAllByPointer(pointer),
      changeCells: TableRow.getChangeCellAndPointerArray(
        tableDataSet,
        pointer.row,
        tableDataSet.getAllCellChangesKeys()
      ),
      original: tableRow.original,
      tableRow
    };
  }
  static setInfoByRowChange(info, rowChange) {
    rowChange.changeCells.forEach((cellChangeAndPointer) => {
      info.setAllByPointer(
        cellChangeAndPointer.changeCell.info,
        cellChangeAndPointer.pointer
      );
    });
  }
  static getTableRowObj(tableRowRecord, modelArray, getUUID = DEFAULT_GET_UUID) {
    var _a;
    const cells = Object.keys(tableRowRecord.data).reduce((fields, field) => {
      fields[field] = tableRowRecord.data[field];
      return fields;
    }, {});
    return reactive({
      row: tableRowRecord.row,
      show: true,
      select: false,
      cells,
      visualRow: tableRowRecord.row,
      original: tableRowRecord.original,
      uuid: (_a = getUUID(tableRowRecord.original)) != null ? _a : DEFAULT_MAKE_UUID()
    });
  }
  static getValue(obj) {
    return Object.keys(obj.cells).reduce((value, key) => {
      value[key] = obj.cells[key].value;
      return value;
    }, {});
  }
  static getLabelValue(tableDataSet, obj) {
    const value = TableRow.getValue(obj);
    Object.keys(value).forEach((key) => {
      const model = tableDataSet.getModelOrUndefined(key);
      if (!model) {
        return;
      }
      const type = tableDataSet.getTypeModel(model);
      value[key] = TableCell.getLabelByValue(value[key], type, model, {
        displayDateFormat: tableDataSet.displayDateFormat,
        serverDateFormat: tableDataSet.serverDateFormat,
        vocDataSet: model == null ? void 0 : model.vocDataSet
      });
    });
    return value;
  }
  static focusFirstCell(tableDataSet, obj) {
    var _a;
    const pointer = {
      row: obj.row,
      col_name: tableDataSet.getFirstColNameVisible()
    };
    tableDataSet.setCursor(pointer);
    if (pointer.row !== void 0 && pointer.col_name !== void 0) {
      (_a = tableDataSet.getCellEl(pointer.row, pointer.col_name)) == null ? void 0 : _a.focus();
    }
    return this;
  }
  static setRow(obj, row) {
    if (obj.row !== row) {
      obj.row = row;
    }
    for (const tableCell of Object.values(obj.cells)) {
      TableCell.setRow(tableCell, row);
    }
    return this;
  }
  static setOriginal(obj, original) {
    obj.original = original;
    return this;
  }
  static updateRowIndex(obj, row) {
    TableRow.setRow(obj, row);
    return this;
  }
  static setShow(obj, show) {
    if (obj.show !== show) {
      obj.show = show;
      return true;
    }
    return false;
  }
  static setVisualRow(obj, visualRow) {
    if (obj.visualRow !== visualRow) {
      obj.visualRow = visualRow;
    }
    return this;
  }
  static clearGroup(tableRow) {
    if (!(tableRow == null ? void 0 : tableRow.cacheGroup)) {
      return;
    }
    delete tableRow.cacheGroup;
  }
  static setGroup(tableDataSet, tableRow, group) {
    var _a, _b, _c;
    const prevGroups = tableDataSet.groupsManager.getPreviousGroups(
      tableDataSet,
      group
    );
    const notFindGroup = prevGroups.find(
      (prevGroup2) => !prevGroup2.rows.has(tableRow)
    );
    if (notFindGroup) {
      Logger$1.warn(
        "\u0421\u0442\u0440\u043E\u043A\u0430 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u0430 \u0432 \u043F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0435\u0439 \u0433\u0440\u0443\u043F\u043F\u0435:",
        tableDataSet.getDisplayRowIndex(tableRow.row),
        { notFindGroup }
      );
      return;
    }
    const prevGroup = lastOrDefault((_a = tableRow.cacheGroup) == null ? void 0 : _a.groups);
    const groups = (_c = (_b = tableRow.cacheGroup) == null ? void 0 : _b.groups) != null ? _c : [];
    if ((prevGroup == null ? void 0 : prevGroup.field) !== group.field) {
      groups.push(group);
    }
    tableRow.cacheGroup = {
      groups
    };
  }
  static getGroup(field, tableRow) {
    var _a;
    return (_a = tableRow.cacheGroup) == null ? void 0 : _a.groups.find((x) => x.field === field);
  }
  static isSelectable(tableRow) {
    var _a;
    return !toStr((_a = tableRow == null ? void 0 : tableRow.original) == null ? void 0 : _a.value_id).endsWith(":") && !(tableRow == null ? void 0 : tableRow.group);
  }
  static getSystemAttrs(tableRow) {
    var _a;
    return (_a = tableRow.cells["__row"]) == null ? void 0 : _a.value;
  }
  static isRowExistInHeader(tableRowHeader, tableRow) {
    if (!tableRowHeader.group) {
      return false;
    }
    if (tableRowHeader.group.rows.has(tableRow)) {
      return true;
    }
    return false;
  }
  static log(tableDataSet, tableRow, ...args) {
    const getTableRowLogObj = (tableRow2, deep = 0) => {
      var _a, _b, _c;
      const obj = {
        ...tableRow2,
        labelValue: TableRow.getLabelValue(tableDataSet, tableRow2),
        value: TableRow.getValue(tableRow2),
        el: tableDataSet.getCellEl(
          tableRow2.row,
          (_c = (_a = tableRow2.group) == null ? void 0 : _a.field) != null ? _c : (_b = tableDataSet.modelUnref[0]) == null ? void 0 : _b.field
        )
      };
      if (tableRow2.group && deep < 5) {
        obj.groupRows = [...tableRow2.group.rows].map(
          (x) => getTableRowLogObj(x, deep + 1)
        );
      }
      return obj;
    };
    Logger$1.log(
      ...args,
      Array.isArray(tableRow) ? tableRow.map((x) => getTableRowLogObj(x)) : getTableRowLogObj(tableRow)
    );
  }
  static getCellValue(tableRow, field) {
    field = typeof field === "string" ? field : field.field;
    return tableRow.cells[field].value;
  }
}
function getCellData(tableDataSet, { row, col_name }) {
  const tableRow = tableDataSet.rows[row];
  if (!tableRow) {
    return void 0;
  }
  return tableRow.cells[col_name];
}
class TableEventAbstract {
}
class TableEventAddRow extends TableEventAbstract {
  constructor(pointer, rowChange) {
    super();
    this.pointer = pointer;
    this.rowChange = rowChange;
  }
  async return(changesObject, tableDataSet, tableChangeEvents, saveRepository) {
    tableDataSet.rowDelete([this.pointer], false, saveRepository);
  }
  async returnCancel(changesObject, tableDataSet, tableChangeEvents, saveRepository) {
    tableDataSet.rowInsert(this.rowChange, false, saveRepository);
  }
}
class TableEventDeleteRow extends TableEventAbstract {
  constructor(changes) {
    super();
    this.changes = changes;
  }
  async return(changesObject, tableDataSet, tableChangeEvents, saveRepository) {
    for (const change of this.changes) {
      tableDataSet.rowInsert(change, false, saveRepository);
    }
  }
  async returnCancel(changesObject, tableDataSet, tableChangeEvents, saveRepository) {
    tableDataSet.rowDelete(
      this.changes.map((x) => ({ row: x.row })),
      false,
      saveRepository
    );
  }
}
class TableChangeEvents {
  constructor(opts) {
    this.opts = opts;
    this.events = [];
    this.getPointer = () => void 0;
    this.getPointerCancelled = () => void 0;
  }
  add(...events) {
    this.events.push(...events);
    return this;
  }
  setCursor(pointer) {
    if (typeof pointer === "function") {
      this.getPointer = pointer;
    } else {
      this.getPointer = () => pointer;
    }
    return this;
  }
  setCursorCancelled(pointer) {
    if (typeof pointer === "function") {
      this.getPointerCancelled = pointer;
    } else {
      this.getPointerCancelled = () => pointer;
    }
    return this;
  }
  async return(tableDataSet, saveRepository) {
    var _a;
    tableDataSet.repository.startBuffering();
    for (const x of this.events) {
      await x.return(tableDataSet.changes, tableDataSet, this, saveRepository);
    }
    tableDataSet.repository.finishBuffering();
    if ((_a = this.opts) == null ? void 0 : _a.afterReturnHandler) {
      this.opts.afterReturnHandler();
    }
  }
  async returnCancel(tableDataSet, saveRepository) {
    var _a;
    tableDataSet.repository.startBuffering();
    for (const x of this.events) {
      await x.returnCancel(
        tableDataSet.changes,
        tableDataSet,
        this,
        saveRepository
      );
    }
    tableDataSet.repository.finishBuffering();
    if ((_a = this.opts) == null ? void 0 : _a.afterReturnCancelHandler) {
      this.opts.afterReturnCancelHandler();
    }
  }
  static merge(map) {
    const filterMap = map.filter((x) => Boolean(x));
    if (!filterMap.length) {
      throw new Error("TableChangeEvents.merge: empty array");
    }
    const last = lastOrDefault(filterMap);
    const events = filterMap.flatMap((x) => x.events);
    const changeEvents = new TableChangeEvents(last.opts);
    changeEvents.setCursor(last.getPointer);
    changeEvents.setCursorCancelled(last.getPointerCancelled);
    changeEvents.add(...events);
    return changeEvents;
  }
}
class TableEventMoveRow extends TableEventAbstract {
  constructor(pointer, tableRow, moveMode) {
    super();
    this.pointer = pointer;
    this.tableRow = tableRow;
    this.moveMode = moveMode;
  }
  async return(changesObject, tableDataSet, tableChangeEvents, saveRepository) {
    switch (this.moveMode) {
      case "down": {
        tableDataSet.rowMoveDown(this.pointer, false, saveRepository);
        tableChangeEvents.setCursor(this.pointer);
        return;
      }
      case "up": {
        tableDataSet.rowMoveUp(this.pointer, false, saveRepository);
        tableChangeEvents.setCursor(this.pointer);
        return;
      }
    }
  }
  async returnCancel(changesObject, tableDataSet, tableChangeEvents, saveRepository) {
    switch (this.moveMode) {
      case "down": {
        tableDataSet.rowMoveDown(this.pointer, false, saveRepository);
        tableChangeEvents.setCursor(this.pointer);
        return;
      }
      case "up": {
        tableDataSet.rowMoveUp(this.pointer, false, saveRepository);
        tableChangeEvents.setCursor(this.pointer);
        return;
      }
    }
  }
}
function isLocatedRange(value, number1, number2) {
  const rangeStart = Math.min(number1, number2);
  const rangeEnd = Math.max(number1, number2);
  return value >= rangeStart && value <= rangeEnd;
}
function isEqualCellPointers(pointer1, pointer2) {
  if (!pointer1 || !pointer2) {
    return !pointer1 && !pointer2;
  }
  if (!isNullOrUndefined(pointer1.col_name) && !isNullOrUndefined(pointer2.col_name)) {
    return pointer1.col_name === pointer2.col_name && pointer1.row === pointer2.row;
  }
  if (!isNullOrUndefined(pointer1.col) && !isNullOrUndefined(pointer2.col)) {
    return pointer1.col === pointer2.col && pointer1.row === pointer2.row;
  }
  throw new Error(
    `isEqualCellPointers \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E \u0441\u0432\u043E\u0439\u0441\u0442\u0432\u043E \u0441\u0442\u043E\u043B\u0431\u0446\u0430 \u0434\u043B\u044F \u0441\u0440\u0430\u0432\u043D\u0435\u043D\u0438\u044F: 
    ${toStr(pointer1)}
    ${toStr(pointer2)}
    `
  );
}
function firstOrDefault(array, _default = void 0) {
  if (!array || array.length === 0) {
    return _default;
  }
  return array[0];
}
class TableSelected {
  constructor() {
    this.isSelectedMode = false;
    this.isAllowFocus = true;
    this._cursor = null;
  }
  get cursor() {
    return this._cursor;
  }
  get cursorOrUndefined() {
    return this.cursor || void 0;
  }
  getTextCursor(tableDataSet) {
    if (!this.cursor) {
      return "";
    }
    return this.getText(tableDataSet, this.cursor);
  }
  getText(tableDataSet, pointer) {
    var _a, _b;
    if (Array.isArray(pointer) && pointer.length === 1) {
      pointer = firstOrDefault(pointer);
    }
    if (Array.isArray(pointer)) {
      if (pointer.find((x) => PointerHelper.isCellPointer(x))) {
        return `[${pointer.length} \u044F\u0447\u0435\u0435\u043A]`;
      }
      return `[${pointer.length} \u0441\u0442\u0440\u043E\u043A]`;
    }
    if (typeof pointer !== "object") {
      return `[${pointer}]`;
    }
    const rowCaption = `\u0421\u0442\u0440\u043E\u043A\u0430 ${tableDataSet.getDisplayRowIndex(
      pointer.row
    )}`;
    if (PointerHelper.isRowPointer(pointer)) {
      return `[${rowCaption}]`;
    }
    const colCaption = tableDataSet.getColCaption(
      (_b = (_a = pointer.col_name) != null ? _a : pointer.col) != null ? _b : ""
    );
    return `[${rowCaption}, ${colCaption}]`;
  }
  getFirstCursor() {
    if (!this.isSelectedMode || !this.start) {
      return this.cursor;
    }
    if (!this.cursor) {
      return this.start;
    }
    if (this.start.visual_row === this.cursor.visual_row) {
      return this.start.col < this.cursor.col ? this.start : this.cursor;
    }
    return this.start.visual_row < this.cursor.visual_row ? this.start : this.cursor;
  }
  setCursor(tableDataSet, pointer) {
    this._cursor = pointer;
    const virtualScroll = tableDataSet.virtualScroll;
    if (pointer && virtualScroll) {
      const { size } = virtualScroll.state;
      if (pointer.visual_row > virtualScroll.start + size - 1) {
        virtualScroll.setStart(
          pointer.visual_row - virtualScroll.state.size + 1
        );
      } else if (pointer.visual_row < virtualScroll.start) {
        virtualScroll.setStart(pointer.visual_row);
      }
    }
  }
  enableSelectedMode(pointer) {
    this.isSelectedMode = true;
    this.start = pointer;
  }
  disableSelectedMode() {
    this.isSelectedMode = false;
  }
  disableFocusCell() {
    this.isAllowFocus = false;
  }
  enableFocusCell() {
    this.isAllowFocus = true;
  }
  selectedAll(tableDataSet) {
    const endPointer = tableDataSet.getEndPointerRequired();
    if (!endPointer) {
      return;
    }
    this.enableSelectedMode(endPointer);
    this.setCursor(
      tableDataSet,
      PointerHelper.getRequired(tableDataSet, {
        col_name: tableDataSet.getFirstColNameVisible(),
        row: tableDataSet.getFirstRowVisible()
      })
    );
  }
  selectedCol(tableDataSet, col_name) {
    const endColPointer = tableDataSet.getEndColPointerRequired(col_name);
    if (!endColPointer) {
      return;
    }
    this.enableSelectedMode(endColPointer);
    const cursor = PointerHelper.getRequired(tableDataSet, {
      col_name,
      row: tableDataSet.getFirstRowVisible()
    });
    this.setCursor(tableDataSet, cursor);
  }
  onSelectNextRow(tableDataSet) {
    Logger$1.debug("TableSelected onSelectNextRow");
    if (!tableDataSet.selected.cursor) {
      return void 0;
    }
    tableDataSet.setCurrentEdit(null);
    const visibleRows = tableDataSet.visibleRows;
    const nextRow = (() => {
      let nextRow2 = tableDataSet.selected.cursor.visual_row + 1;
      while (nextRow2 < visibleRows.length) {
        if (visibleRows[nextRow2].show) {
          return nextRow2;
        }
        nextRow2++;
      }
      return void 0;
    })();
    if (nextRow === void 0) {
      return false;
    }
    tableDataSet.setCursor({
      col_name: tableDataSet.selected.cursor.col_name,
      visual_row: nextRow
    });
    return true;
  }
  onSelectPrevRow(tableDataSet) {
    Logger$1.debug("TableSelected onSelectPrevRow");
    if (!tableDataSet.selected.cursor) {
      return;
    }
    tableDataSet.setCurrentEdit(null);
    const visibleRows = tableDataSet.visibleRows;
    const prevRow = (() => {
      let visual_row = tableDataSet.selected.cursor.visual_row - 1;
      while (visual_row >= 0) {
        if (!visibleRows[visual_row]) {
          return void 0;
        }
        if (visibleRows[visual_row].show) {
          return visual_row;
        }
        visual_row--;
      }
      return void 0;
    })();
    if (prevRow === void 0) {
      return false;
    }
    tableDataSet.setCursor({
      col_name: tableDataSet.selected.cursor.col_name,
      visual_row: prevRow
    });
    return true;
  }
  onSelectNextCol(tableDataSet) {
    var _a;
    Logger$1.debug("TableSelected onSelectNextCol");
    if (!tableDataSet.selected.cursor) {
      return;
    }
    tableDataSet.setCurrentEdit(null);
    let nextCol = tableDataSet.selected.cursor.col + 1;
    while ((_a = tableDataSet.getModelOrUndefined(nextCol)) == null ? void 0 : _a.hide) {
      nextCol++;
    }
    if (tableDataSet.modelUnref.length <= nextCol) {
      return false;
    }
    tableDataSet.setCursor({
      col: nextCol,
      row: tableDataSet.selected.cursor.row
    });
    return true;
  }
  onSelectPrevCol(tableDataSet) {
    var _a;
    Logger$1.debug("TableSelected onSelectPrevCol");
    if (!tableDataSet.selected.cursor) {
      return;
    }
    tableDataSet.setCurrentEdit(null);
    let prevCol = tableDataSet.selected.cursor.col - 1;
    while ((_a = tableDataSet.getModelOrUndefined(prevCol)) == null ? void 0 : _a.hide) {
      prevCol--;
    }
    if (0 > prevCol) {
      return false;
    }
    tableDataSet.setCursor({
      col: prevCol,
      row: tableDataSet.selected.cursor.row
    });
    return true;
  }
  onSelectedNext(tableDataSet) {
    Logger$1.debug("TableSelected onSelectedNext");
    if (!tableDataSet.selected.cursor) {
      return;
    }
    if (this.onSelectNextCol(tableDataSet)) {
      return;
    }
    if (this.onSelectNextRow(tableDataSet)) {
      tableDataSet.setCursor({
        col_name: tableDataSet.getFirstColNameVisible(),
        row: tableDataSet.selected.cursor.row
      });
    }
  }
  onSelectedPrev(tableDataSet) {
    Logger$1.debug("TableSelected onSelectedPrev");
    if (!tableDataSet.selected.cursor) {
      return;
    }
    if (this.onSelectPrevCol(tableDataSet)) {
      return;
    }
    if (this.onSelectPrevRow(tableDataSet)) {
      tableDataSet.setCursor({
        col_name: tableDataSet.getLastColNameVisible(),
        row: tableDataSet.selected.cursor.row
      });
    }
  }
  isSelectedCol(colIndex) {
    var _a;
    return colIndex === ((_a = this.cursor) == null ? void 0 : _a.col);
  }
  isSelectedColName(col_name) {
    var _a;
    return col_name === ((_a = this.cursor) == null ? void 0 : _a.col_name);
  }
  isSelectedRow(rowIndex) {
    var _a;
    if (this.isSelectedMode && !this.isCursorAtStart()) {
      return false;
    }
    return rowIndex === ((_a = this.cursor) == null ? void 0 : _a.row);
  }
  isSelectedCell(pointer) {
    var _a;
    if (!this.cursor) {
      return 0;
    }
    let count = 0;
    if (pointer.visual_row === ((_a = this.cursor) == null ? void 0 : _a.visual_row) && this.isSelectedColName(pointer.col_name)) {
      count++;
    }
    if (this.start && this.isSelectedMode && !this.isCursorAtStart() && isLocatedRange(
      pointer.visual_row,
      this.start.visual_row,
      this.cursor.visual_row
    ) && isLocatedRange(pointer.col, this.start.col, this.cursor.col)) {
      count++;
    }
    return count;
  }
  isFocusedCell(pointer) {
    if (!isEqualCellPointers(this.cursor, pointer)) {
      return false;
    }
    return this.isAllowFocus;
  }
  isCursorAtStart() {
    return isEqualCellPointers(this.start, this.cursor);
  }
}
const MAX = 1e3;
class TableChanges {
  constructor() {
    this.changes = [];
    this.cancelledChanges = [];
  }
  add(changeEvents, tableDataSet, options = {}) {
    const { isClearCancelledChanges = true } = options;
    if (!changeEvents) {
      return;
    }
    this.changes.push(changeEvents);
    if (this.changes.length > MAX) {
      this.changes.shift();
    }
    if (isClearCancelledChanges) {
      this.cancelledChanges = [];
    }
    this.setChangeCursor(tableDataSet, changeEvents);
  }
  async returnLast(tableDataSet, saveRepository) {
    const changeEvents = this.changes.pop();
    if (!changeEvents) {
      return void 0;
    }
    await changeEvents.return(tableDataSet, saveRepository);
    if (saveRepository) {
      this.addCancelledChange(tableDataSet, changeEvents);
    }
    return this.getChangePointerCancelled(changeEvents, tableDataSet);
  }
  getChangePointer(changeEvents, tableDataSet) {
    return PointerHelper.getRequiredOrUndefined(
      tableDataSet,
      changeEvents.getPointer()
    );
  }
  getChangePointerCancelled(changeEvents, tableDataSet) {
    return PointerHelper.getRequiredOrUndefined(
      tableDataSet,
      changeEvents.getPointerCancelled()
    );
  }
  setChangeCursor(tableDataSet, changeEvents) {
    const pointer = this.getChangePointer(changeEvents, tableDataSet);
    if (pointer !== void 0) {
      tableDataSet.setCursor(pointer);
    }
  }
  async returnCanceledLast(tableDataSet) {
    const change = this.cancelledChanges.pop();
    if (!change) {
      return void 0;
    }
    await change.returnCancel(tableDataSet, true);
    this.add(change, tableDataSet, { isClearCancelledChanges: false });
    return this.getChangePointer(change, tableDataSet);
  }
  async cancelQueueChanges(tableDataSet) {
    while (tableDataSet.repository.queue.length) {
      const queue = tableDataSet.repository.queue.pop();
      const lastChangeEvents = lastOrDefault(this.changes);
      if (!lastChangeEvents) {
        continue;
      }
      if (queue.changeEvents === lastChangeEvents) {
        await this.returnLast(tableDataSet, false);
      }
    }
    this.cancelledChanges = [];
  }
  addCancelledChange(tableDataSet, changeEvents) {
    this.cancelledChanges.push(changeEvents);
    if (this.cancelledChanges.length > MAX) {
      this.cancelledChanges.shift();
    }
  }
}
class TableEventResizeColumn extends TableEventAbstract {
  constructor(event) {
    super();
    this.event = event;
  }
  async return(changesObject, tableDataSet, changesEvents, saveRepository) {
    tableDataSet.colResize(
      {
        col_name: this.event.col_name,
        width: this.event.prev_width,
        prev_width: this.event.width
      },
      false,
      saveRepository
    );
  }
  async returnCancel(changesObject, tableDataSet, changesEvents, saveRepository) {
    tableDataSet.colResize(
      {
        col_name: this.event.col_name,
        width: this.event.width,
        prev_width: this.event.prev_width
      },
      false,
      saveRepository
    );
  }
}
class TableKeyboard {
  constructor() {
    this.shiftKey = false;
    this.ctrlKey = false;
    this.altKey = false;
    this.ignoreNextTableMouse = false;
    this.tableMouseFunctions = [];
    this.clear();
  }
  get isCtrlV() {
    if (this.tableEvent !== this.tableKeyboardEvent) {
      return false;
    }
    return new KeyboardEventHelper(this.tableKeyboardEvent).codeKeyV.pressCtrl.isAllTrue;
  }
  setTableEvent(event) {
    this.tableEvent = event;
    this.tableKeyboardEvent = event;
    this.setKeys(event);
    return event;
  }
  setTablePointerEvent(event) {
    this.tableEvent = event;
    this.tablePointerEvent = event;
    this.setKeys(event);
    return event;
  }
  setTableMouse(event) {
    if (this.ignoreNextTableMouse) {
      this.ignoreNextTableMouse = false;
      return;
    }
    this.tableMouse = event;
    while (this.tableMouseFunctions.length > 0) {
      this.tableMouseFunctions.shift()();
    }
  }
  setCellEditEvent(event) {
    this.cellEditEvent = event;
    return event;
  }
  setKeys(event) {
    this.shiftKey = event.shiftKey;
    this.ctrlKey = event.ctrlKey;
    this.altKey = event.altKey;
  }
  clear() {
    this.setTableEvent(new KeyboardEvent("", {}));
    this.setCellEditEvent(new KeyboardEvent("", {}));
  }
  nextTableMouse$(func) {
    this.tableMouseFunctions.push(func);
    this.ignoreNextTableMouse = true;
  }
}
const TABLE_INFO__OBJ_KEYS = [
  {
    key: "comment",
    name: "\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439",
    plural: "\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0438",
    backgroundColor: "#294bc4",
    cell: true,
    row: true,
    icon: ICONS.chatCircleBlue,
    hotkey: "CTRL+SHIFT+F2"
  },
  {
    key: "remark",
    name: "\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0435",
    plural: "\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u044F",
    backgroundColor: "#4bb8ff",
    cell: true,
    icon: ICONS.chatSquareBlue,
    hotkey: "SHIFT+F2"
  },
  {
    key: "error",
    name: "\u041E\u0448\u0438\u0431\u043A\u0430",
    plural: "\u041E\u0448\u0438\u0431\u043A\u0438",
    backgroundColor: "#e36464",
    readonly: true,
    cell: true,
    row: true
  },
  {
    key: "notification",
    name: "\u041D\u0430\u043F\u043E\u043C\u0438\u043D\u0430\u043D\u0438\u0435",
    plural: "\u041D\u0430\u043F\u043E\u043C\u0438\u043D\u0430\u043D\u0438\u044F",
    backgroundColor: "#4b1b52",
    readonly: true,
    cell: false,
    row: false
  }
];
class TableInfo {
  constructor(dataSet, initKeys, initTab = "remark") {
    this.dataSet = dataSet;
    this.keys = [];
    this.keysEditable = [];
    this.keysDict = {};
    this.rootKeys = [];
    this.rootKeysDict = {};
    this.setKeys(initKeys);
    this.setTab(initTab);
  }
  static setInfoDataPointer(data, pointer) {
    if (data && typeof data === "object") {
      data.pointer = pointer;
    }
    return data;
  }
  removeByRow(row, fields) {
    fields.forEach((col_name) => {
      const pointer = PointerHelper.getServerFormat({
        row,
        col_name
      });
      this.setAll(pointer, void 0, this.keys);
    });
    const pointerRow = { row };
    this.keys.forEach((dataKey) => {
      this.setDataByPointer(dataKey, pointerRow, void 0);
    });
  }
  removeByRows(start, deleteCount, fields, rowLengthBeforeDelete) {
    const end = start + deleteCount;
    for (let currentRow = start; currentRow < end; currentRow++) {
      this.removeByRow(currentRow, fields);
    }
    this.correctionAfterDeletingRows(
      rowLengthBeforeDelete,
      start,
      deleteCount,
      fields
    );
  }
  swapInfoRows(row1, row2, fields) {
    if (row1 === row2) {
      return;
    }
    try {
      const pointerRow1 = { row: row1 };
      const pointerRow2 = { row: row2 };
      Object.keys(this.dataSet.data).forEach((dataKey) => {
        const valueRow1 = copy(
          this.getByPointer(dataKey, pointerRow1)
        );
        const valueRow2 = copy(
          this.getByPointer(dataKey, pointerRow2)
        );
        this.setDataByPointer(dataKey, pointerRow2, valueRow1);
        this.setDataByPointer(dataKey, pointerRow1, valueRow2);
        fields.forEach((col_name) => {
          const pointer1 = {
            row: pointerRow1.row,
            col_name
          };
          const pointer2 = {
            row: pointerRow2.row,
            col_name
          };
          const value1 = copy(
            this.getByPointer(dataKey, pointer1)
          );
          const value2 = copy(
            this.getByPointer(dataKey, pointer2)
          );
          if (value1 !== void 0 || value2 !== void 0) {
            this.setDataByPointer(dataKey, pointer1, value2);
            this.setDataByPointer(dataKey, pointer2, value1);
          }
        });
      });
    } catch (e) {
      Logger$1.error(e);
    }
  }
  clearByDataKey(dataKey) {
    Object.values(this.dataSet.getByDataKey(dataKey)).forEach(
      (infoDto) => {
        if (!infoDto) {
          return;
        }
        this.setDataByPointer(dataKey, infoDto.pointer, void 0);
      }
    );
  }
  correctionAfterDeletingRows(rowLengthBeforeDelete, start, deleteCount, fields) {
    if (deleteCount === 0) {
      return;
    }
    const end = start + deleteCount;
    for (let i = end; i <= rowLengthBeforeDelete; i++) {
      Object.keys(this.dataSet.data).forEach((dataKey) => {
        const pointerRowPrev = { row: i };
        const newRow = pointerRowPrev.row - deleteCount;
        const value = this.getByPointer(
          dataKey,
          pointerRowPrev
        );
        if (value !== void 0) {
          this.setDataByPointer(dataKey, pointerRowPrev, void 0);
          this.setDataByPointer(dataKey, { row: newRow }, value);
        }
        fields.forEach((col_name) => {
          const pointerPrev = {
            row: pointerRowPrev.row,
            col_name
          };
          const value2 = this.getByPointer(
            dataKey,
            pointerPrev
          );
          if (value2 !== void 0) {
            this.setDataByPointer(dataKey, pointerPrev, void 0);
            this.setDataByPointer(
              dataKey,
              {
                row: newRow,
                col_name
              },
              value2
            );
          }
        });
      });
    }
  }
  insertRow(rowsLength, start, insertCount, fields) {
    if (insertCount === 0) {
      return;
    }
    const end = start + insertCount;
    const rows = rowsLength - 1;
    for (let i = rows; i >= end; i--) {
      const pointerRowPrev = { row: i - insertCount };
      const pointerRowNew = { row: i };
      Object.keys(this.dataSet.data).forEach((dataKey) => {
        const value = this.getByPointer(
          dataKey,
          pointerRowPrev
        );
        if ((value == null ? void 0 : value.pointer) && typeof value.pointer === "object") {
          value.pointer.row = pointerRowNew.row;
        }
        this.setDataByPointer(dataKey, pointerRowPrev, void 0);
        this.setDataByPointer(dataKey, pointerRowNew, value);
        fields.forEach((col_name) => {
          const pointerPrev = {
            row: pointerRowPrev.row,
            col_name
          };
          const pointerNew = {
            row: pointerRowNew.row,
            col_name
          };
          const value2 = this.getByPointer(
            dataKey,
            pointerPrev
          );
          if (value2 !== void 0) {
            this.setDataByPointer(dataKey, pointerPrev, void 0);
            this.setDataByPointer(dataKey, pointerNew, value2);
          }
        });
      });
    }
  }
  setKeys(keys2) {
    this.keys.length = 0;
    this.keysEditable.length = 0;
    this.keysDict = {};
    keys2.forEach((key) => this.setKey(key));
  }
  setKey(key) {
    if (key.useRoot) {
      this.rootKeys.push(key.key);
      if (!key.readonly) {
        this.keysEditable.push(key.key);
      }
      this.rootKeysDict[key.key] = key;
      return;
    }
    this.keys.push(key.key);
    if (!key.readonly) {
      this.keysEditable.push(key.key);
    }
    this.keysDict[key.key] = key;
  }
  setTab(tab) {
    this.tab = tab;
  }
  setDataByPointer(dataKey, pointer, value) {
    const key = PointerHelper.getKey(pointer);
    this.dataSet.setData(
      dataKey,
      key,
      TableInfo.setInfoDataPointer(value, pointer)
    );
  }
  setAll(pointer, newData = {}, changes) {
    (changes !== void 0 ? changes : Object.keys(newData)).forEach((key) => {
      this.setDataByPointer(key, pointer, newData[key]);
    });
  }
  setDictData(data) {
    Object.keys(data).forEach((dataKey) => {
      const values = data[dataKey];
      if (!values) {
        return;
      }
      values.forEach((value) => {
        if (!value.value.text) {
          value.value.text = "";
        }
        this.setDataByPointer(dataKey, value.pointer, value);
      });
    });
  }
  setInfoArray(infoKey, infoArray) {
    infoArray.forEach((validate) => {
      this.setDataByPointer(infoKey, validate.pointer, validate);
    });
  }
  setAllByPointer(infoRowByPointer = {}, pointer) {
    Object.keys(infoRowByPointer).forEach((dataKey) => {
      this.setDataByPointer(dataKey, pointer, infoRowByPointer[dataKey]);
    });
  }
  getByPointer(dataKey, pointer) {
    const pointerKey = PointerHelper.getKey(pointer);
    return this.dataSet.getByDataKey(dataKey)[pointerKey];
  }
  getAllByPointer(pointer) {
    const pointerKey = PointerHelper.getKey(pointer);
    return this.keys.reduce((value, dataKey) => {
      const dataByKey = this.dataSet.data[dataKey];
      if (dataByKey && dataByKey[pointerKey]) {
        value[dataKey] = copy(dataByKey[pointerKey]);
      }
      return value;
    }, {});
  }
  getFormInfoDataArray(dataKey) {
    return Object.values(this.dataSet.data[dataKey] || {}).filter(Boolean);
  }
  getCellKeys() {
    return this.keys.filter((x) => this.keysDict[x].cell).map((x) => this.keysDict[x]);
  }
  getCellEditableKeys() {
    return this.keysEditable.filter((x) => this.keysDict[x].cell).map((x) => this.keysDict[x]);
  }
  getRowKeys() {
    return this.keys.filter((x) => this.keysDict[x].row).map((x) => this.keysDict[x]);
  }
  getRowEditableKeys() {
    return this.keysEditable.filter((x) => this.keysDict[x].row).map((x) => this.keysDict[x]);
  }
}
const DEFAULT_CONFIRMATION_HELPER_BUTTONS = {
  success: {
    title: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C"
  },
  cancel: {
    title: "\u041E\u0442\u043C\u0435\u043D\u0430"
  }
};
class ConfirmationHelper {
  constructor() {
    this.visible = false;
    this.message = "";
    this.buttons = copy(
      DEFAULT_CONFIRMATION_HELPER_BUTTONS
    );
  }
  setConfirmation({
    title,
    message,
    cancel,
    success,
    buttons: buttons2
  }) {
    this.buttons = copy(DEFAULT_CONFIRMATION_HELPER_BUTTONS);
    this.title = title;
    this.message = message;
    if (buttons2) {
      Object.assign(this.buttons, buttons2);
    }
    this.visible = true;
    this.success = async () => {
      try {
        success ? success() : void 0;
      } catch (ex) {
        NotificationsService$1.send({
          title: "\u041E\u0448\u0438\u0431\u043A\u0430",
          text: toStr(ex)
        });
      }
      this.hide();
    };
    this.cancel = async () => {
      cancel ? cancel() : void 0;
      this.hide();
    };
  }
  async success() {
  }
  async cancel() {
  }
  hide() {
    this.visible = false;
  }
}
class TooltipHelper {
  constructor() {
    this.mode = {};
  }
  isShow(mode) {
    return !!this.mode[mode];
  }
  getEvent(mode) {
    return this.mode[mode];
  }
  show(mode = "default", event) {
    this.mode[mode] = event;
  }
  hide(mode) {
    if (mode) {
      delete this.mode[mode];
    } else {
      this.mode = {};
    }
  }
}
class HelpHelper {
  constructor() {
    this._help = null;
    this.visible = true;
  }
  get help() {
    if (this.visible) {
      return this._help;
    }
    return null;
  }
  getContext() {
    return this._context;
  }
  setHelp(help, context) {
    this._help = help;
    this._context = context;
    return this;
  }
  setVisible(visible = !this.visible) {
    this.visible = visible;
    return this;
  }
}
class TableSort {
  constructor() {
    this.model = null;
    this.sort = null;
  }
  static getCompareFn(tableDataSet, model, sort) {
    const labelOpts = tableDataSet.getCellLabelOpts(model.field);
    return (row1, row2) => {
      const cellType = tableDataSet.getTypeModel(model);
      const cellData1 = row1.cells[model.field];
      const cellData2 = row2.cells[model.field];
      const cell1Label = TableCell.getLabelByValue(
        cellData1.value,
        cellType,
        model.modelDto,
        labelOpts
      );
      const cell2Label = TableCell.getLabelByValue(
        cellData2.value,
        cellType,
        model.modelDto,
        labelOpts
      );
      return TableSort.compare(
        cellData1.value,
        cell1Label,
        cellData2.value,
        cell2Label,
        cellType,
        sort
      );
    };
  }
  static compare(value1, label1, value2, label2, type, sort) {
    var _a;
    const mult = sort === "DESC" ? -1 : 1;
    const validationType = (_a = type.validation) == null ? void 0 : _a.type;
    function getResult(value) {
      return value * mult;
    }
    if (validationType === "date") {
      const date1 = new Date(label1);
      const date2 = new Date(label2);
      return getResult(((date1 == null ? void 0 : date1.valueOf()) || 0) - ((date2 == null ? void 0 : date2.valueOf()) || 0));
    }
    if (validationType === "time") {
      const minutes1 = getMinutes(label1);
      const minutes2 = getMinutes(label2);
      if (minutes1 === void 0 && minutes2 === void 0) {
        return 0;
      }
      if (minutes1 === void 0) {
        return getResult(-1);
      }
      if (minutes2 === void 0) {
        return getResult(1);
      }
      return getResult(minutes1 - minutes2);
    }
    if (validationType === "int" || validationType === "float") {
      return getResult(toNumberOrDefault(label1) - toNumberOrDefault(label2));
    }
    return getResult(label1.localeCompare(label2));
  }
  setSort(tableDataSet, model, sort) {
    this.model = model;
    this.sort = sort;
    tableDataSet.onChangeSort();
  }
  clear(tableDataSet) {
    if (this.model || this.sort) {
      this.model = null;
      this.sort = null;
      tableDataSet.onChangeSort();
      return true;
    }
    return false;
  }
  getSortedRows(tableDataSet) {
    const { model, sort } = this;
    if (sort === null || model === null || tableDataSet.isServerFilterAndSort) {
      if (tableDataSet.sortFlag && tableDataSet.filteredFlag) {
        tableDataSet.updateFilterFlag = true;
      }
      tableDataSet.sortFlag = false;
      return tableDataSet.getVisualRows();
    }
    const sortedRows = [...tableDataSet.rows].sort(
      TableSort.getCompareFn(tableDataSet, model, sort)
    );
    tableDataSet.sortFlag = true;
    return sortedRows;
  }
}
async function copyToClipboard(text) {
  var _a;
  if ((_a = navigator == null ? void 0 : navigator.clipboard) == null ? void 0 : _a.writeText) {
    await navigator.clipboard.writeText(text);
  }
  const prevActiveElement = document.activeElement;
  const textarea = document.createElement("textarea");
  textarea.textContent = text;
  textarea.style.position = "fixed";
  document.body.appendChild(textarea);
  textarea.select();
  try {
    return document.execCommand("cut");
  } catch (ex) {
    Logger$1.warn("Copy to clipboard failed.", ex);
    return false;
  } finally {
    document.body.removeChild(textarea);
    if (typeof (prevActiveElement == null ? void 0 : prevActiveElement.focus) === "function") {
      prevActiveElement.focus();
    }
  }
}
class TableSettingsService {
  constructor(id, opts) {
    this.id = id;
    this.opts = opts;
    this.isSaving = true;
    this.settings = reactive({
      value: void 0
    });
  }
  get keySettings() {
    return `table-settings-${this.id}`;
  }
  get defaultSettings() {
    return { hiddenColumns: [] };
  }
  async getSettings() {
    try {
      const settings = await this.opts.getSettings(this.keySettings);
      if (!settings || typeof settings !== "object") {
        return this.defaultSettings;
      }
      this.settings.value = settings;
      return settings;
    } catch {
      return this.defaultSettings;
    }
  }
  async init(tableDataSet) {
    const promises = [];
    const settings = await this.getSettings();
    for (const column of settings.hiddenColumns) {
      const model = tableDataSet.getModelOrUndefined(column);
      if (model) {
        promises.push(tableDataSet.setHideColumn(model, true, false, false));
      }
    }
    return await Promise.all(promises);
  }
  setIsSaving(isSaving) {
    this.isSaving = isSaving;
  }
  async setItem(key, value) {
    if (!this.isSaving) {
      return;
    }
    this.settings.value = value;
    return await this.opts.onSave(key, value);
  }
  async assignSave(settings = this.defaultSettings) {
    const newSettings = Object.assign(copy(await this.getSettings()), settings);
    return await this.setItem(this.keySettings, newSettings);
  }
}
function sortBy(array, getValue, comparer = (v) => Number(v)) {
  return array.sort((a, b) => {
    return comparer(getValue(a), getValue(b));
  });
}
const NUMBER_COMPARER_ASC = (a, b) => {
  return toNumberOrDefault(a, Number.MIN_SAFE_INTEGER) - toNumberOrDefault(b, Number.MIN_SAFE_INTEGER);
};
const NUMBER_COMPARER_DESC = (a, b) => {
  return toNumberOrDefault(b, Number.MIN_SAFE_INTEGER) - toNumberOrDefault(a, Number.MIN_SAFE_INTEGER);
};
class TableEventUpdateRowIndexes extends TableEventAbstract {
  constructor(indexes) {
    super();
    this.indexes = indexes;
  }
  async return(changesObject, tableDataSet, tableChangeEvents, saveRepository) {
    tableDataSet.updateRowIndexes(
      this.indexes.map((x) => ({
        old_index: x.new_index,
        new_index: x.old_index
      })),
      false,
      saveRepository
    );
  }
  async returnCancel(changesObject, tableDataSet, tableChangeEvents, saveRepository) {
    tableDataSet.updateRowIndexes(this.indexes, false, saveRepository);
  }
}
function getMinMaxCellPointer(pointer, pointer2, rowKey) {
  const minRow = Math.min(pointer[rowKey], pointer2[rowKey]);
  const maxRow = Math.max(pointer[rowKey], pointer2[rowKey]);
  const minCol = Math.min(pointer.col, pointer2.col);
  const maxCol = Math.max(pointer.col, pointer2.col);
  return {
    minRow,
    maxRow,
    minCol,
    maxCol
  };
}
const isDev = window.location.href.startsWith(`http://localhost:808`);
class TableEventChangeRow extends TableEventAbstract {
  constructor(pointer, prevValue, newValue, changes) {
    super();
    this.pointer = pointer;
    this.prevValue = prevValue;
    this.newValue = newValue;
    this.changes = changes;
  }
  async return(changesObject, tableDataSet, tableChangeEvents, saveRepository) {
    await tableDataSet.updateRowInfoData(
      this.pointer,
      this.prevValue,
      this.changes
    );
    const tableRowAndPointer = {
      table_row: TableRow.getRepositoryFormat(this.prevValue),
      pointer: this.pointer,
      changes: this.changes
    };
    if (saveRepository) {
      tableDataSet.repository.changeTableRows(tableDataSet, [
        tableRowAndPointer
      ]);
    }
    tableChangeEvents.setCursor(this.getCursor(tableDataSet));
  }
  async returnCancel(changesObject, tableDataSet, tableChangeEvents, saveRepository) {
    await tableDataSet.updateRowInfoData(
      this.pointer,
      this.newValue,
      this.changes
    );
    const tableRowAndPointer = {
      table_row: TableRow.getRepositoryFormat(this.newValue),
      pointer: this.pointer,
      changes: this.changes
    };
    if (saveRepository) {
      tableDataSet.repository.changeTableRows(tableDataSet, [
        tableRowAndPointer
      ]);
    }
    tableChangeEvents.setCursor(this.getCursor(tableDataSet));
  }
  getCursor(tableDataSet) {
    return PointerHelper.getRequired(tableDataSet, {
      row: this.pointer.row,
      col_name: tableDataSet.getFirstColNameVisible()
    });
  }
}
class TableFilterHelper {
  static isLogicalObj(logicalObj, tableDataSet, tableRow) {
    const logicalOp = logicalObj[0];
    const filters = logicalObj.slice(1);
    const method = logicalOp === "or" ? "some" : "every";
    return filters[method](
      (filter) => TableFilterHelper.isShow(filter, tableDataSet, tableRow)
    );
  }
  static isShow(filter, tableDataSet, tableRow) {
    if (!FilterFactory.isComparisonObjParse(filter)) {
      return TableFilterHelper.isLogicalObj(filter, tableDataSet, tableRow);
    }
    return TableFilterHelper.isFilterComparisonOperation(
      filter,
      tableDataSet,
      tableRow
    );
  }
  static isFilterComparisonOperation(parse, tableDataSet, tableRow) {
    var _a;
    const not = parse.modifiers.has("not");
    function executeModifiers(result2) {
      return not ? !result2 : result2;
    }
    const localField = TableFilterHelper.getLocalField(
      tableDataSet,
      parse.field
    );
    let result = true;
    let cellValue = (_a = tableRow.cells[localField]) == null ? void 0 : _a.value;
    switch (parse.comparisonOp) {
      case "=": {
        result = toStr(cellValue) === toStr(parse.value);
        break;
      }
      case ">": {
        result = toNumberOrDefault(cellValue, cellValue) > toNumberOrDefault(parse.value, parse.value);
        break;
      }
      case ">=": {
        result = toNumberOrDefault(cellValue, cellValue) >= toNumberOrDefault(parse.value, parse.value);
        break;
      }
      case "<": {
        result = toNumberOrDefault(cellValue, cellValue) < toNumberOrDefault(parse.value, parse.value);
        break;
      }
      case "<=": {
        result = toNumberOrDefault(cellValue, cellValue) <= toNumberOrDefault(parse.value, parse.value);
        break;
      }
      case "like": {
        result = TableFilterHelper.isLike(parse, tableDataSet, tableRow);
        break;
      }
      case "in":
      case "sql":
      default: {
        throw new Error(
          `not supporting comparison operation: ${parse.comparisonOp}`
        );
      }
    }
    return executeModifiers(result);
  }
  static isLike(parse, tableDataSet, tableRow) {
    var _a;
    const localField = TableFilterHelper.getLocalField(
      tableDataSet,
      parse.field
    );
    const not_ignore_case = parse.modifiers.has("not_ignore_case");
    const complete_match = parse.modifiers.has("complete_match");
    let value1 = toStr(parse.value);
    let value2 = toStr((_a = tableRow.cells[localField]) == null ? void 0 : _a.value);
    if (!not_ignore_case) {
      value1 = value1.toLowerCase();
      value2 = value2.toLowerCase();
    }
    if (complete_match) {
      return value1 === value2;
    }
    return value2.includes(value1);
  }
  static getLocalField(tableDataSet, field) {
    var _a, _b;
    return (_b = (_a = tableDataSet.getModelBySystem(field)) == null ? void 0 : _a.field) != null ? _b : field;
  }
}
function toClearObject(obj) {
  for (const key of Object.keys(obj)) {
    delete obj[key];
  }
}
class DataSet {
  constructor() {
    this.data = {};
    this.dataSets = /* @__PURE__ */ new Map();
    this.listeners = {};
  }
  setDataSet(dataSetKey, dataSet) {
    dataSet.rootDataSet = this;
    this.dataSets.set(dataSetKey, dataSet);
  }
  setData(dataKey, valueKey, value) {
    const listeners = this.getListeners(dataKey);
    if (listeners) {
      this.executeListeners(listeners, {
        dataKey,
        valueKey,
        value
      });
    }
    const data = this.getByDataKey(dataKey);
    if (value === void 0) {
      delete this.data[dataKey][valueKey];
    } else {
      data[valueKey] = value;
    }
    return this;
  }
  getByDataKey(dataKey) {
    if (!this.data[dataKey]) {
      this.data[dataKey] = {};
    }
    return this.data[dataKey];
  }
  getDataSet(dataSetKey) {
    return this.dataSets.get(dataSetKey);
  }
  subscribe(subs) {
    this.createListenersIfNotExist(subs.dataKey).getListeners(subs.dataKey).add(subs);
  }
  unsubscribe(subs) {
    var _a;
    return (_a = this.getListeners(subs.dataKey)) == null ? void 0 : _a.delete(subs);
  }
  executeListeners(listeners, argumentsSetData) {
    for (const [i, listener] of listeners.entries()) {
      try {
        listener.next(this, argumentsSetData);
      } catch (ex) {
        Logger$1.error(`Error tableInfo listener ${listener.dataKey} ${i}:`, {
          ex,
          listener
        });
      }
    }
  }
  clearData() {
    toClearObject(this.data);
  }
  getListeners(dataKey) {
    return this.listeners[dataKey];
  }
  createListenersIfNotExist(dataKey) {
    if (!(dataKey in this.listeners)) {
      this.listeners[dataKey] = /* @__PURE__ */ new Set();
    }
    return this;
  }
  clearListeners() {
    this.listeners = {};
  }
}
class ContextMenuService {
  static send(event) {
    if (Object.keys(this.eventSubject.observers).length === 0) {
      Logger$1.error("\u041A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442 \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0439 \u043D\u0435 \u0431\u044B\u043B \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D!", event);
    }
    this.eventSubject.next(event);
  }
}
ContextMenuService.eventSubject = new Subject();
class TableVirtualScroll {
  constructor(options) {
    this.options = options;
    this.state = this.getState();
    this.start = 0;
    this.multiplier = 2;
  }
  isLastPage() {
    return this.start + this.state.size >= this.options.getCountAll();
  }
  isEnabled() {
    return this.options.getCountAll() >= this.options.getMinLength();
  }
  resetVirtualScroll() {
    this.setStart(0);
  }
  updateState() {
    this.state = this.getState();
    return this.state;
  }
  setStart(start) {
    if (this.start !== start) {
      this.start = start;
    }
  }
  setVirtualScrollPartial(options) {
    Object.assign(this.options, options);
  }
  getState() {
    const options = this.options;
    const displaySize = Math.ceil(
      this.options.getHeight() / options.getItemHeight()
    );
    const size = Math.floor(displaySize * this.multiplier);
    return {
      size,
      options,
      displaySize
    };
  }
  getTopHeight() {
    const {
      start,
      state: {
        options: { getItemHeight }
      }
    } = this;
    const itemHeight = getItemHeight();
    const value = start * itemHeight;
    return value;
  }
  getBottomHeight() {
    const count = this.options.getCountAll();
    const {
      start,
      state: {
        size,
        options: { getItemHeight }
      }
    } = this;
    const itemHeight = getItemHeight();
    const viewHeight = size * itemHeight;
    const value = (count - start) * itemHeight - viewHeight;
    return Math.max(0, value);
  }
  async onScroll(tableDataSet) {
    const target = tableDataSet.tableComponent.$refs.virtualScrollDiv;
    if (!target || !this.isEnabled()) {
      return;
    }
    const virtualScrollState = this.state;
    const itemHeight = virtualScrollState.options.getItemHeight();
    if (!itemHeight) {
      return;
    }
    const topHeight = this.getTopHeight();
    const bottomHeight = this.getBottomHeight();
    const topAndBottomHeight = topHeight + bottomHeight;
    const visibleScrollTop = target.scrollTop - topHeight;
    const visibleScrollHeight = target.scrollHeight - topAndBottomHeight;
    const params = {
      topHeight,
      bottomHeight,
      topAndBottomHeight,
      scrollHeight: target.scrollHeight,
      scrollTop: target.scrollTop,
      scrollTopOriginal: target.scrollTop,
      clientHeight: target.clientHeight,
      offsetHeight: target.offsetHeight,
      visibleScrollTop,
      visibleScrollHeight,
      start: Math.floor(target.scrollTop / itemHeight),
      itemHeight
    };
    const countPages = Math.floor(
      params.start / virtualScrollState.displaySize
    );
    let start = countPages * virtualScrollState.displaySize;
    if (start === this.start) {
      return;
    }
    const countAll = virtualScrollState.options.getCountAll();
    const maxStart = countAll - virtualScrollState.size;
    if (start > maxStart) {
      start = maxStart;
    }
    this.setStart(start);
  }
}
function groupBy(array, getValue) {
  return array.reduce((rv, x) => {
    const key = getValue(x);
    rv[key] || (rv[key] = []);
    rv[key].push(x);
    return rv;
  }, {});
}
function groupByMap(array, getValue) {
  return array.reduce((rv, x) => {
    const key = getValue(x);
    if (!rv.has(key)) {
      rv.set(key, []);
    }
    rv.get(key).push(x);
    return rv;
  }, /* @__PURE__ */ new Map());
}
const maxBy = (arr, fn) => {
  if (arr.length === 0) {
    return void 0;
  }
  let currentMax = arr[0];
  for (const v of arr) {
    const num = fn(v);
    if (fn(currentMax) < num) {
      currentMax = v;
    }
  }
  return currentMax;
};
function randomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}
function randomRgb(colorBlockList) {
  let min = 0;
  let max = 255;
  switch (colorBlockList) {
    case "white": {
      max /= 2;
      break;
    }
    case "black": {
      min = max / 2;
      break;
    }
  }
  return "rgb(" + randomInt(min, max) + "," + randomInt(min, max) + "," + randomInt(min, max) + ")";
}
class TableRowGroupHelper {
  static createAndInsert(tableDataSet, tableRowChange, group, currentGroups) {
    var _a, _b;
    (_a = group.index) != null ? _a : group.index = currentGroups.filter((x) => x.field === group.field).length;
    (_b = group.color) != null ? _b : group.color = tableDataSet.groupsManager.getGroupColor(
      `${group.deep}_${group.index}`
    );
    tableRowChange.tableRow.group = group;
    tableDataSet.rowInsert(tableRowChange, false, false);
    return group;
  }
  static addRowByPreviousGroup(tableDataSet, group, tableRow) {
    const groupsPrev = tableDataSet.groupsManager.getPreviousGroups(
      tableDataSet,
      group
    );
    for (const groupPrev of groupsPrev) {
      groupPrev.rows.add(tableRow);
    }
    group.rows.add(tableRow);
  }
}
class TableGroupsManager {
  constructor() {
    this.groups = reactive([]);
    this.groupColors = /* @__PURE__ */ new Map();
  }
  get isGrouping() {
    return Boolean(this.groups.length);
  }
  get groupedFields() {
    return new Set(Object.keys(groupBy(this.groups, (x) => x.field)));
  }
  get deep() {
    return maxBy(this.groups, (x) => x.deep);
  }
  static getDeepByRowsHeaders(tableRows) {
    var _a, _b, _c;
    return (_c = (_b = (_a = maxBy(tableRows, (x) => {
      var _a2, _b2;
      return (_b2 = (_a2 = x.group) == null ? void 0 : _a2.deep) != null ? _b2 : 0;
    })) == null ? void 0 : _a.group) == null ? void 0 : _b.deep) != null ? _c : 0;
  }
  static fixSort(tableDataSet, tableRows) {
    let cancelled = false;
    let lastFindRows = void 0;
    const fixHeaders = () => {
      let findRows = void 0;
      const findError = (row1, row2) => {
        if (!row1.group || !row1.group.open) {
          return false;
        }
        if (row1.group.rows.has(row2) && (!row2.group || row2.group.deep >= row1.group.deep)) {
          return false;
        }
        return true;
      };
      for (let groupedRowIndex = 0; groupedRowIndex < tableRows.length - 1; groupedRowIndex++) {
        const row1 = tableRows[groupedRowIndex];
        const row2 = tableRows[groupedRowIndex + 1];
        if (findError(row1, row2)) {
          findRows = [row1, row2];
        }
      }
      return findRows;
    };
    let countFix = 0;
    while (true) {
      const findRows = fixHeaders();
      if (!findRows) {
        break;
      }
      countFix++;
      if (isDev) {
        let localCountFix = countFix;
        nextTick(() => {
          TableRow.log(
            tableDataSet,
            findRows,
            `fixHeaders \u0441\u0440\u0430\u0431\u043E\u0442\u0430\u043B ${localCountFix}`
          );
        });
      }
      if (countFix >= 2) {
        Logger$1.warn(
          `fixHeaders \u0441\u0440\u0430\u0431\u043E\u0442\u0430\u043B ${countFix} \u0440\u0430\u0437 \u0438 \u043E\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u043B\u0441\u044F, \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u044B \u0431\u0430\u0433\u0438`,
          tableRows.map((x) => ({
            ...x,
            value: TableRow.getLabelValue(tableDataSet, x)
          }))
        );
        lastFindRows = findRows;
        cancelled = true;
        break;
      }
    }
    if (cancelled) {
      nextTick(() => {
        if (lastFindRows === void 0) {
          return;
        }
        TableRow.log(tableDataSet, lastFindRows, "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u044F\u044F \u043D\u0430\u0439\u0434\u0435\u043D\u043D\u0430\u044F \u043E\u0448\u0438\u0431\u043A\u0430:");
        NotificationsService$1.send({
          type: "error",
          title: "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u043A\u0435",
          text: "\u0412\u043E\u0437\u043C\u043E\u0436\u043D\u044B \u043E\u0448\u0438\u0431\u043A\u0438. \u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u0442\u0441\u044F \u043E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u044E\u044E \u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u043A\u0443."
        });
      }).then();
    }
  }
  getGroups(field) {
    return field !== void 0 ? this.groups.filter((x) => x.field === field) : this.groups;
  }
  isGrouped(field) {
    return this.getGroups(field).length > 0;
  }
  getSortModel(tableDataSet, model) {
    const groupedFields = this.groupedFields;
    return [
      ...[...groupedFields].map((x) => tableDataSet.getModelOrUndefined(x)),
      ...model.filter((x) => !groupedFields.has(x.field))
    ];
  }
  getHeadersRows(tableDataSet, field) {
    return tableDataSet.rows.filter(
      (x) => {
        var _a;
        return field === void 0 ? x.group : ((_a = x.group) == null ? void 0 : _a.field) === field;
      }
    );
  }
  cleanAndSetGroups(groups) {
    this.groups.length = 0;
    this.groups.push(...groups);
  }
  async ungroup(tableDataSet, field) {
    const notCleanFields = [...this.groupedFields].filter((x) => x !== field);
    const openState = this.getOpenState();
    this.cleanAndSetGroups([]);
    const pointers = this.getHeadersRows(tableDataSet).map(
      (x) => ({ row: x.row })
    );
    tableDataSet.rowDelete(pointers, false, false);
    this.clearCacheGroups(tableDataSet);
    if (notCleanFields.length > 0) {
      notCleanFields.forEach((field2) => {
        this.addGrouping(
          tableDataSet,
          tableDataSet.getModelOrUndefined(field2)
        );
      });
      this.setOpenState(openState);
      this.updateCacheGroups(tableDataSet);
    } else {
      this.groupColors.clear();
      tableDataSet.updateFilterFlag = true;
    }
  }
  getOpenState() {
    const prevOpenState = /* @__PURE__ */ new Map();
    this.groups.forEach((group) => {
      if (!prevOpenState.has(group.field)) {
        prevOpenState.set(group.field, /* @__PURE__ */ new Map());
      }
      prevOpenState.get(group.field).set(group.value, group.open);
    });
    return prevOpenState;
  }
  setOpenState(openState) {
    this.groups.forEach((group) => {
      if (!openState.has(group.field) || !openState.get(group.field).has(group.value)) {
        return;
      }
      const open = openState.get(group.field).get(group.value);
      group.open = open;
    });
  }
  async setGroups(tableDataSet, groups) {
    await this.ungroup(tableDataSet);
    return this.addGroups(tableDataSet, groups);
  }
  addGroups(tableDataSet, groups) {
    this.groups.push(...groups);
    this.updateCacheGroups(tableDataSet);
    tableDataSet.updateFilterFlag = true;
  }
  clearCacheGroups(tableDataSet) {
    tableDataSet.rows.filter((x) => x.cacheGroup).forEach((tableRow) => {
      TableRow.clearGroup(tableRow);
    });
  }
  updateCacheGroups(tableDataSet) {
    this.clearCacheGroups(tableDataSet);
    this.getGroups().forEach((group) => {
      group.rows.forEach((tableRow) => {
        TableRow.setGroup(tableDataSet, tableRow, group);
      });
    });
  }
  switchOpen(tableDataSet, group) {
    group.open = !group.open;
    tableDataSet.updateFilterFlag = true;
  }
  addGrouping(tableDataSet, model, open = isDev) {
    const groups = [];
    const groupingRows = groupByMap(
      tableDataSet.rows,
      (tableRow) => tableRow.group ? tableRow.group : toStr(tableRow.cells[model.field].value)
    );
    groupingRows.forEach((groupRows) => {
      if (groupRows.length < 1) {
        return;
      }
      const groupingRowsByPrevGroup = groupByMap(
        groupRows,
        (tableRow) => {
          var _a;
          return lastOrDefault((_a = tableRow.cacheGroup) == null ? void 0 : _a.groups);
        }
      );
      groupingRowsByPrevGroup.forEach(
        (groupingRowsInPrevGroup, groupingRowsGroup) => {
          const firstNotHeaderRow = groupingRowsInPrevGroup.find(
            (x) => !x.group
          );
          if (!firstNotHeaderRow) {
            return;
          }
          const value = TableRow.getCellValue(firstNotHeaderRow, model);
          const tableRowHeaderChange = TableRow.createChange(
            tableDataSet,
            firstNotHeaderRow.row,
            {
              [model.field]: value
            }
          );
          const rows = /* @__PURE__ */ new Set();
          rows.add(tableRowHeaderChange.tableRow);
          let deep = 0;
          if (groupingRowsGroup) {
            deep = groupingRowsGroup.deep + 1;
            TableRowGroupHelper.addRowByPreviousGroup(
              tableDataSet,
              groupingRowsGroup,
              tableRowHeaderChange.tableRow
            );
          }
          for (const tableRow of groupingRowsInPrevGroup) {
            rows.add(tableRow);
          }
          const group = TableRowGroupHelper.createAndInsert(
            tableDataSet,
            tableRowHeaderChange,
            {
              field: model.field,
              rows,
              header: tableRowHeaderChange.tableRow,
              value,
              deep,
              open
            },
            groups
          );
          groups.push(group);
        }
      );
    });
    this.addGroups(tableDataSet, groups);
  }
  getPreviousGroups(tableDataSet, group) {
    const prevGroups = [];
    for (const prevGroup of this.groups) {
      if (prevGroup === group) {
        break;
      }
      if (prevGroup.rows.has(group.header)) {
        prevGroups.push(prevGroup);
      }
    }
    return prevGroups;
  }
  isGroupedRow(visualRow) {
    return Boolean(visualRow.cacheGroup);
  }
  getGroupColor(key) {
    if (!this.groupColors.has(key)) {
      this.groupColors.set(key, randomRgb("black"));
    }
    return this.groupColors.get(key);
  }
}
function classToQuerySelector(classStr) {
  return "." + classStr.split(" ").filter((x) => x.length > 0).join(".");
}
class PanelFiltersFactory {
  static toFilterLogical(data) {
    if (!data.logical) {
      return void 0;
    }
    const dataItems = Object.values(data.items);
    const comparisonObjArray = dataItems.filter((x) => !x.disabled && x.rules.comparison).map((dataItem) => {
      const comparisonObj = strToFilterComparisonOption(
        dataItem.rules.comparison
      );
      dataItem.rules.modifiers.not = comparisonObj.not;
      const modifiers = Object.keys(dataItem.rules.modifiers).filter(
        (key) => dataItem.rules.modifiers[key]
      );
      return FilterFactory.createComparison(
        comparisonObj.value,
        dataItem.rules.field,
        dataItem.rules.comparisonValue,
        modifiers
      );
    });
    if (!comparisonObjArray.length) {
      return void 0;
    }
    const filter = FilterFactory.createLogical(
      data.logical,
      comparisonObjArray
    );
    return filter;
  }
  static getInitialData() {
    return { items: {}, logical: "and" };
  }
  static getInitialDataItem() {
    return {
      id: makeId(5) + Date.now(),
      rules: {
        modifiers: {},
        comparisonValue: ""
      }
    };
  }
  static addDataItem(data, dataItem) {
    data.items[dataItem.id] = dataItem;
    return data;
  }
  static getInitialDataAndItem() {
    return PanelFiltersFactory.addDataItem(
      PanelFiltersFactory.getInitialData(),
      PanelFiltersFactory.getInitialDataItem()
    );
  }
  static setFilter(data, urlFilter) {
    if (!urlFilter) {
      return;
    }
  }
  static getDataItemModifiers(modifiers) {
    if (!modifiers) {
      return {};
    }
    return {
      not: modifiers.has("not"),
      complete_match: modifiers.has("complete_match"),
      not_ignore_case: modifiers.has("not_ignore_case")
    };
  }
  static getDataItem(comparisonObjParse) {
    const item = PanelFiltersFactory.getInitialDataItem();
    item.rules.modifiers = PanelFiltersFactory.getDataItemModifiers(
      comparisonObjParse.modifiers
    );
    item.rules.comparison = filterComparisonOptionToStr({
      value: comparisonObjParse.comparisonOp,
      not: item.rules.modifiers.not
    });
    item.rules.field = comparisonObjParse.field;
    item.rules.comparisonValue = comparisonObjParse.value;
    return item;
  }
  static getData(logicalParse) {
    const data = PanelFiltersFactory.getInitialData();
    if (!logicalParse)
      return data;
    data.logical = logicalParse[0];
    for (let i = 1; i < logicalParse.length; i++) {
      const comparisonObjParse = logicalParse[i];
      const item = PanelFiltersFactory.getDataItem(comparisonObjParse);
      PanelFiltersFactory.addDataItem(data, item);
    }
    return data;
  }
}
class TableEventChangeCell extends TableEventAbstract {
  constructor(pointer, prevValue, newValue, changes, vocNewValueDict) {
    super();
    this.pointer = pointer;
    this.prevValue = prevValue;
    this.newValue = newValue;
    this.changes = changes;
    this.vocNewValueDict = vocNewValueDict;
  }
  async return(changesObject, tableDataSet, tableChangeEvents, saveRepository) {
    const tableRow = tableDataSet.getRowOrUndefined(this.pointer.row);
    await tableDataSet.updateCells(
      [
        {
          changes: this.changes,
          pointer: this.pointer,
          newValue: this.prevValue,
          vocNewValueDict: this.vocNewValueDict,
          original: tableRow == null ? void 0 : tableRow.original
        }
      ],
      false,
      saveRepository
    );
    tableChangeEvents.setCursorCancelled(this.pointer, tableDataSet);
  }
  async returnCancel(changesObject, tableDataSet, tableChangeEvents, saveRepository) {
    const tableRow = tableDataSet.getRowOrUndefined(this.pointer.row);
    await tableDataSet.updateCells(
      [
        {
          changes: this.changes,
          pointer: this.pointer,
          newValue: this.newValue,
          vocNewValueDict: this.vocNewValueDict,
          original: tableRow == null ? void 0 : tableRow.original
        }
      ],
      false,
      saveRepository
    );
    tableChangeEvents.setCursor(this.pointer, tableDataSet);
  }
}
class TableUpdateCellsHelper {
  static async updateCells(opts) {
    const vocValuesDictAll = {};
    const updatesContext = opts.updates.map((update) => {
      return TableUpdateCellsHelper.getUpdateContext(
        opts.tableDataSet,
        update,
        vocValuesDictAll
      );
    }).filter(Boolean);
    const valuesDictByValueId = {};
    await TableUpdateCellsHelper.loadVocValuesDictAll(
      opts.tableDataSet,
      valuesDictByValueId,
      vocValuesDictAll
    );
    const updates = [];
    for (const updateContext of updatesContext) {
      updates.push(
        ...await TableUpdateCellsHelper.executeGeneral({
          tableDataSet: opts.tableDataSet,
          changeEvents: opts.changeEvents,
          tableCellsAndPointers: opts.tableCellsAndPointers,
          updateContext,
          updatesContext,
          valuesDictByValueId,
          saveChanges: opts.saveChanges,
          saveRepository: opts.saveRepository
        })
      );
    }
    if (updates.length === 0) {
      return [];
    }
    return await this.updateCells({
      ...opts,
      updates
    });
  }
  static async executeGeneral(opts) {
    const {
      updateContext,
      updatesContext,
      tableCellsAndPointers,
      valuesDictByValueId,
      changeEvents,
      tableDataSet,
      saveRepository,
      saveChanges
    } = opts;
    const generalOpts = {
      tableDataSet,
      changeEvents,
      tableCellsAndPointers,
      saveRepository,
      saveChanges
    };
    if (updateContext.updateContext.model && Boolean(updateContext.updateContext.update.newValue.value) && typeof updateContext.updateContext.update.newValue.value === "string") {
      TableUpdateCellsHelper.executeMapContext({
        ...generalOpts,
        updateContext,
        valuesDictByValueId,
        updatesContext
      });
    }
    TableUpdateCellsHelper.executeUpdate({
      ...generalOpts,
      update: updateContext.updateContext.update,
      cellData: updateContext.updateContext.cellData
    });
    const updates = [];
    updates.push(
      ...await TableUpdateCellsHelper.executeOnChange({
        ...generalOpts,
        updateContext,
        updatesContext
      })
    );
    return updates;
  }
  static executeUpdate(opts) {
    const {
      tableDataSet,
      cellData,
      update,
      tableCellsAndPointers,
      changeEvents
    } = opts;
    if (typeof update.newValue.value === "string") {
      update.newValue.value = update.newValue.value.replace(/[\t\n\r]/gm, "").trim();
    }
    const prevValueChange = TableCell.getChangeValue(
      cellData,
      tableDataSet.info.getAllByPointer(update.pointer)
    );
    tableDataSet.updateCell(update.pointer, update.newValue, update.changes);
    tableCellsAndPointers.push({
      pointer: update.pointer,
      changeCell: update.newValue,
      changes: update.changes
    });
    changeEvents.events.push(
      new TableEventChangeCell(
        update.pointer,
        prevValueChange,
        update.newValue,
        update.changes,
        update.vocNewValueDict
      )
    );
  }
  static getUpdateContext(tableDataSet, update, vocValuesDictAll) {
    var _a;
    const cellData = (_a = tableDataSet.getCellData(update.pointer)) != null ? _a : { value: "" };
    const model = tableDataSet.getModelOrUndefined(update.pointer.col_name);
    if (model && model.modelDto.readonly) {
      return void 0;
    }
    const mapContext = model ? TableUpdateCellsHelper.getMapContext(
      tableDataSet,
      model,
      update,
      vocValuesDictAll
    ) : void 0;
    return {
      updateContext: {
        update,
        cellData,
        model
      },
      mapContext
    };
  }
  static getMapContext(tableDataSet, model, update, vocValuesDictAll) {
    const map = model.modelDto.map;
    const vocDataSet = model.vocDataSet;
    if (!map || !vocDataSet) {
      return void 0;
    }
    const mapChanges = Object.keys(map).map((fieldTable) => {
      var _a, _b;
      const fieldVoc = map[fieldTable];
      const vocValuesId = getVocValuesIdByCellValue(update.newValue.value);
      (_b = vocValuesDictAll[_a = model.field]) != null ? _b : vocValuesDictAll[_a] = [];
      vocValuesId.forEach((value_id) => {
        var _a2, _b2;
        if ((_b2 = (_a2 = update.vocNewValueDict) == null ? void 0 : _a2[value_id]) == null ? void 0 : _b2.value) {
          return;
        }
        vocValuesDictAll[model.field].push(value_id);
      });
      return {
        fieldTable,
        fieldVoc,
        vocValuesId
      };
    });
    return {
      mapChanges,
      map,
      vocDataSet
    };
  }
  static executeMapContext(opts) {
    const {
      updateContext,
      tableDataSet,
      tableCellsAndPointers,
      changeEvents,
      valuesDictByValueId,
      saveRepository,
      saveChanges
    } = opts;
    const {
      updateContext: {
        update: {
          pointer: { row },
          vocNewValueDict
        },
        cellData
      },
      mapContext
    } = updateContext;
    if (!mapContext) {
      return;
    }
    const model = updateContext.updateContext.model;
    const { mapChanges } = mapContext;
    for (const { fieldTable, fieldVoc, vocValuesId } of mapChanges) {
      vocValuesId.forEach((vocValueId) => {
        var _a, _b;
        const vocValueDto = (_b = (_a = vocNewValueDict == null ? void 0 : vocNewValueDict[vocValueId]) == null ? void 0 : _a.value) != null ? _b : valuesDictByValueId[model.field][vocValueId];
        if (isNullOrUndefined(vocValueDto)) {
          return;
        }
        const pointer = PointerHelper.getRequiredOrUndefined(tableDataSet, {
          row,
          col_name: fieldTable
        });
        if (!pointer) {
          Logger$1.warn(
            `(map) \u0421\u0442\u0440\u043E\u043A\u0430 ${row}, \u0430\u0442\u0440\u0438\u0431\u0443\u0442 "${fieldTable}" - \u044F\u0447\u0435\u0439\u043A\u0430 \u043D\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442 \u0432 \u0442\u0430\u0431\u043B\u0438\u0446\u0435. \u041F\u043E\u0434\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u043C\u044B\u0439 \u0430\u0442\u0440\u0438\u0431\u0443\u0442 \u0441\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A\u0430: "${fieldVoc}".`
          );
          return;
        }
        const attrs = VocDataSet.getAttrs(
          vocValueDto,
          model.vocDataSet.typeOrRepository
        );
        const update = tableDataSet.getEmitUpdateValueCell(
          pointer,
          attrs[fieldVoc]
        );
        TableUpdateCellsHelper.executeUpdate({
          tableDataSet,
          cellData,
          update,
          changeEvents,
          tableCellsAndPointers,
          saveRepository,
          saveChanges
        });
      });
    }
  }
  static async loadVocValuesDictAll(tableDataSet, valuesDictByValueId, vocValuesDictAll) {
    await Promise.all(
      Object.keys(vocValuesDictAll).map((field) => {
        return (async () => {
          var _a;
          const fields = vocValuesDictAll[field];
          if (!fields.length) {
            return;
          }
          const model = tableDataSet.getModelOrUndefined(field);
          const typeDto = tableDataSet.getTypeModel(model);
          const vocDataSet = model.vocDataSet;
          const voc = await vocDataSet.get();
          valuesDictByValueId[field] = await VocValueHelper.getVocValueDictByIds(
            voc,
            vocValuesDictAll[field],
            vocDataSet.value,
            (_a = vocDataSet.repositoryType.voc) == null ? void 0 : _a.config_url,
            typeDto == null ? void 0 : typeDto.data_url,
            vocDataSet.context
          );
        })();
      })
    );
  }
  static async executeOnChange(opts) {
    const updates = [];
    const { tableDataSet, updateContext } = opts;
    const model = updateContext.updateContext.model;
    if (!(model == null ? void 0 : model.modelDto.on_change) || !updateContext.updateContext.update.changes.includes("value")) {
      return updates;
    }
    tableDataSet.spinnerCounter++;
    try {
      const { page_data } = GlobalContext.get();
      if (page_data && typeof page_data === "object") {
        delete page_data.form_table_data;
        delete page_data.form_errors;
      }
      const context = tableDataSet.getContext({
        pointer: updateContext.updateContext.update.pointer,
        data: {
          page_data,
          event: "on_change"
        },
        value: updateContext.updateContext.update.newValue.value
      });
      const { json } = await HttpService$1.post(model.modelDto.on_change, {
        body: JSON.stringify(context),
        headers: {
          "Content-Type": "application/json"
        }
      });
      if (json.defaults) {
        updates.push(
          ...TableUpdateCellsHelper.executeRowChanges({
            ...opts,
            changes: json.defaults,
            mode: "defaults"
          })
        );
      }
      if (json.values) {
        updates.push(
          ...TableUpdateCellsHelper.executeRowChanges({
            ...opts,
            changes: json.values,
            mode: "values"
          })
        );
      }
    } catch (ex) {
      const rowDisplay = tableDataSet.getDisplayRowIndex(
        updateContext.updateContext.update.pointer.row
      );
      const title = `\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043F\u0440\u0438\u043C\u0435\u043D\u0435\u043D\u0438\u0438 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0439 \u043A \u0441\u0442\u0440\u043E\u043A\u0435 ${rowDisplay}`;
      NotificationsService$1.send({
        type: "error",
        title,
        text: await ApiHelper.getErrorMessage(ex)
      });
      Logger$1.warn(ex);
    }
    tableDataSet.spinnerCounter--;
    return updates;
  }
  static executeRowChanges(opts) {
    const { updateContext, changes, tableDataSet, mode } = opts;
    if (Object.keys(changes).length === 0) {
      return [];
    }
    const rowObj = tableDataSet.getRowOrUndefined(
      updateContext.updateContext.update.pointer.row
    );
    if (!rowObj) {
      return [];
    }
    const updates = [];
    for (const field in changes) {
      const cellData = rowObj.cells[field];
      if (!cellData) {
        Logger$1.warn(`\u0410\u0442\u0440\u0438\u0431\u0443\u0442 "${field}" \u043E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u0435\u0442 \u0432 \u0442\u0430\u0431\u043B\u0438\u0446\u0435.`);
        continue;
      }
      let checkValue = toStr(cellData.value);
      if (checkValue === "-") {
        checkValue = "";
      }
      const needUpdated = mode === "values" || mode === "defaults" && checkValue.length === 0;
      if (!needUpdated) {
        continue;
      }
      const pointer = {
        row: rowObj.row,
        col_name: field
      };
      const equalChange = opts.updatesContext.find(
        (update2) => PointerHelper.isEqualByServerFormat(
          pointer,
          update2.updateContext.update.pointer
        )
      );
      if (equalChange) {
        continue;
      }
      const update = tableDataSet.getEmitUpdateValueCell(
        pointer,
        changes[field]
      );
      updates.push(update);
    }
    return updates;
  }
}
const minBy = (arr, fn) => {
  if (arr.length === 0) {
    return void 0;
  }
  let currentMin = arr[0];
  for (const v of arr) {
    const num = fn(v);
    if (fn(currentMin) > num) {
      currentMin = v;
    }
  }
  return currentMin;
};
function uniqBy(arr, predicate) {
  const cb = typeof predicate === "function" ? predicate : (o) => o[predicate];
  return [
    ...arr.reduce((map, item) => {
      const key = item === null || item === void 0 ? item : cb(item);
      map.has(key) || map.set(key, item);
      return map;
    }, /* @__PURE__ */ new Map()).values()
  ];
}
const _GlobalTableSettingsService = class {
  static async useSaveSettingsInTableDataSet(tableDataSet) {
  }
  static setUseSaveSettingsInTableDataSet(useSaveSettingsInTableDataSet) {
    this.useSaveSettingsInTableDataSet = useSaveSettingsInTableDataSet;
  }
  static clearGlobalSettings() {
    toClearObject(this.globalSettings);
  }
  static setAssignGlobalSettings(settings) {
    Object.assign(this.globalSettings, settings);
  }
};
let GlobalTableSettingsService = _GlobalTableSettingsService;
GlobalTableSettingsService.globalSettings = reactive({});
GlobalTableSettingsService.currentTables = reactive(
  {}
);
GlobalTableSettingsService.tableDataSetsQueueLength = computed(() => {
  return Object.values(_GlobalTableSettingsService.currentTables).reduce((sum, table2) => {
    sum += table2.tableDataSet.repository.queue.length;
    return sum;
  }, 0);
});
GlobalTableSettingsService.countCurrentTables = computed(
  () => Object.keys(_GlobalTableSettingsService.currentTables).length
);
const INPUT_FORMATS = ["DD.MM.YYYY", "DD.MM.YY", "DD/MM/YYYY"];
function getFormatDate(value, inputFormats = INPUT_FORMATS) {
  return inputFormats.find((x) => moment(value, x).isValid());
}
function unique(...arrays) {
  const value = {};
  arrays.forEach((array) => {
    array == null ? void 0 : array.forEach((x) => {
      return value[x] = x;
    });
  });
  return Object.keys(value).map((x) => value[x]);
}
function isValidAnyDate(value) {
  return !(!value || value.length === 0 || value === "Invalid Date");
}
function getTransformCellValue(tableDataSet, model, value) {
  var _a;
  const type = tableDataSet.getTypeModel(model);
  if (type.base_type === "DATE") {
    const displayDateFormat = tableDataSet.displayDateFormat;
    const format = getFormatDate(
      value,
      unique([
        (_a = type.display) == null ? void 0 : _a.date_format,
        displayDateFormat,
        ...INPUT_FORMATS
      ]).filter((x) => !isNullOrUndefined(x))
    );
    if (!format) {
      return value;
    }
    const transformValue = dateTransform(
      value,
      format,
      tableDataSet.serverDateFormat
    );
    if (isValidAnyDate(transformValue)) {
      return transformValue;
    }
  }
  return value;
}
var ValidErrorEnum = /* @__PURE__ */ ((ValidErrorEnum2) => {
  ValidErrorEnum2[ValidErrorEnum2["Ok"] = 0] = "Ok";
  ValidErrorEnum2[ValidErrorEnum2["ValidationType"] = 1] = "ValidationType";
  ValidErrorEnum2[ValidErrorEnum2["Required"] = 2] = "Required";
  ValidErrorEnum2[ValidErrorEnum2["Regex"] = 3] = "Regex";
  ValidErrorEnum2[ValidErrorEnum2["Range"] = 4] = "Range";
  ValidErrorEnum2[ValidErrorEnum2["DictDataSourceNotFound"] = 5] = "DictDataSourceNotFound";
  ValidErrorEnum2[ValidErrorEnum2["ListStrict"] = 6] = "ListStrict";
  ValidErrorEnum2[ValidErrorEnum2["Handler"] = 7] = "Handler";
  return ValidErrorEnum2;
})(ValidErrorEnum || {});
function getValidError(model, type, value, validationHandlers) {
  const valueStr = toStr(value);
  const getValidAndLabel = (typeError) => {
    return {
      ...typeError,
      label: getValidErrorLabel(
        model,
        type,
        value,
        typeError,
        validationHandlers
      )
    };
  };
  if (!type) {
    return { type: 0 };
  }
  function executeValidation() {
    var _a, _b;
    if (!(type == null ? void 0 : type.validation)) {
      return getValidAndLabel({ type: 0 });
    }
    if ((_a = type.validation.allow_list) == null ? void 0 : _a.includes(valueStr)) {
      return getValidAndLabel({ type: 0 });
    }
    if (!isNullOrUndefined(value) && valueStr.length > 0) {
      switch (type.validation.type) {
        case "str":
          if (typeof value !== "string") {
            return getValidAndLabel({ type: 1 });
          }
          break;
        case "int":
        case "float":
          if (!isNumeric(value)) {
            return getValidAndLabel({ type: 1 });
          }
          break;
      }
      const handlerError = (_b = type.validation.handlers) == null ? void 0 : _b.map((handlerName) => {
        if (!validationHandlers[handlerName]) {
          Logger$1.warn(
            `\u0412 \u0442\u0438\u043F\u0435 '${model.type}' \u0443\u043A\u0430\u0437\u0430\u043D \u043D\u0435\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0439 \u0442\u0438\u043F \u0432\u0430\u043B\u0438\u0434\u0430\u0446\u0438\u0438: '${handlerName}'`
          );
          return {
            result: {},
            handlerName
          };
        }
        return {
          result: validationHandlers[handlerName](model, type, value),
          handlerName
        };
      }).find((x) => !isNullOrUndefined(x.result.label));
      if (handlerError) {
        return getValidAndLabel({
          type: 7,
          label: handlerError.result.label,
          handlerName: handlerError.handlerName
        });
      }
    }
    if (ModelHelper.getRequired(model, type) && (isNullOrUndefined(value) || valueStr.length === 0)) {
      return getValidAndLabel({ type: 2 });
    }
    if (isNullOrUndefined(value) || valueStr.length === 0) {
      return { type: 0 };
    }
    const regexStr = type.validation.regex;
    if (regexStr) {
      const regex = new RegExp(regexStr);
      if (!regex.test(value)) {
        return getValidAndLabel({ type: 3 });
      }
    }
    const range = type.validation.range;
    if (range) {
      const num = toNumberOrUndefined(value);
      if (num !== void 0) {
        const checkStart = range.start === void 0 || range.start <= num;
        const checkEnd = range.end === void 0 || range.end >= num;
        if (!checkStart || !checkEnd) {
          return getValidAndLabel({ type: 4 });
        }
      }
    }
    return getValidAndLabel({ type: 0 });
  }
  const resultValidation = executeValidation();
  if (resultValidation.type !== 0) {
    return resultValidation;
  }
  if (type.base_type === "DICT") {
    const dataSource = type.data_source;
    if (value in dataSource) {
      return getValidAndLabel({ type: 0 });
    } else {
      return getValidAndLabel({ type: 5 });
    }
  }
  if (type.base_type === "LIST" && type.strict) {
    const dataSource = type.data_source;
    if (dataSource.includes(value)) {
      return getValidAndLabel({ type: 0 });
    } else {
      return { type: 6 };
    }
  }
  return { type: 0 };
}
function getValidErrorLabel(model, type, value, error, validationHandlers) {
  switch (error.type) {
    case 0:
      return void 0;
    case 1:
      return `\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u0442\u0438\u043F\u0430 "${type.validation.type}"`;
    case 2:
      return "\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0434\u043B\u044F \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F";
    case 3:
      return (type == null ? void 0 : type.help) || `\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0435 \u0440\u0435\u0433\u0443\u043B\u044F\u0440\u043D\u043E\u0433\u043E \u0432\u044B\u0440\u0430\u0436\u0435\u043D\u0438\u044F "${type.validation.regex}"`;
    case 4: {
      const { start, end } = type.validation.range;
      if (start === void 0 && end !== void 0) {
        return `\u0427\u0438\u0441\u043B\u043E \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u043D\u0435 \u0431\u043E\u043B\u044C\u0448\u0435 ${end}`;
      }
      if (start !== void 0 && end === void 0) {
        return `\u0427\u0438\u0441\u043B\u043E \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u043D\u0435 \u043C\u0435\u043D\u044C\u0448\u0435 ${start}`;
      }
      return `\u0427\u0438\u0441\u043B\u043E \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u0432 \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D\u0435 \u043E\u0442 ${start} \u0434\u043E ${end}`;
    }
    case 5:
      if (isNullOrUndefined(value)) {
        return "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435";
      }
      return `\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u044F "${value}" \u043D\u0435\u0442\u0443 \u0432 \u0441\u043B\u043E\u0432\u0430\u0440\u0435`;
    case 6:
      return `\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u044F "${value}" \u043D\u0435\u0442 \u0432 \u0441\u043F\u0438\u0441\u043A\u0435`;
    case 7: {
      if (!error.handlerName) {
        throw new Error(
          `ValidErrorEnum.Handler, error.handler: ${error.handlerName}`
        );
      }
      const result = validationHandlers[error.handlerName](model, type, value);
      return result.label;
    }
  }
}
class TDynamicModalService {
  static show(componentOrUrl, context) {
    return new Promise((resolve, reject) => {
      this.showSubject.next({
        componentOrUrl,
        context,
        resolve,
        reject
      });
    });
  }
  static close(componentInstance) {
    this.closeSubject.next({ componentInstance });
  }
  static commit(componentInstance, result) {
    this.commitSubject.next({
      componentInstance,
      result
    });
  }
}
TDynamicModalService.showSubject = new Subject();
TDynamicModalService.closeSubject = new Subject();
TDynamicModalService.commitSubject = new Subject();
var TableEnterInput_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$1u = defineComponent({
  name: "TableEnterInput",
  props: {
    context: {
      type: Object,
      required: true
    },
    form: {
      type: Object,
      required: true
    },
    route: {
      type: Object,
      required: true
    }
  },
  provide: {
    form: Object,
    api: Object
  },
  components: {},
  setup() {
    const api = inject("api");
    return {
      api
    };
  },
  data() {
    return {
      newValue: ""
    };
  },
  async created() {
    this.form.set_caption(this.context.caption);
  },
  computed: {},
  methods: {
    async onCommit() {
      this.api.modal.commit(this, this.newValue);
    }
  }
});
const _hoisted_1$1f = {
  class: "flex-column-overflow-grow",
  style: { "gap": "10px", "padding": "10px" }
};
const _hoisted_2$_ = ["value"];
function _sfc_render$1u(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ButtonComponent = resolveComponent("ButtonComponent");
  return openBlock(), createElementBlock("div", _hoisted_1$1f, [
    createElementVNode("input", {
      style: { "padding": "5px" },
      type: "number",
      value: _ctx.newValue,
      onChange: _cache[0] || (_cache[0] = ($event) => _ctx.newValue = $event.target.value)
    }, null, 40, _hoisted_2$_),
    createVNode(_component_ButtonComponent, {
      class: "form-button",
      "data-type": "accent",
      onClick: _ctx.onCommit
    }, {
      default: withCtx(() => [
        createTextVNode(toDisplayString(_ctx.context.confirm.caption), 1)
      ]),
      _: 1
    }, 8, ["onClick"])
  ]);
}
var TableEnterInput = /* @__PURE__ */ _export_sfc(_sfc_main$1u, [["render", _sfc_render$1u], ["__scopeId", "data-v-b324836e"]]);
var CellEditMode = /* @__PURE__ */ ((CellEditMode2) => {
  CellEditMode2[CellEditMode2["Default"] = 0] = "Default";
  CellEditMode2[CellEditMode2["Reset"] = 1] = "Reset";
  CellEditMode2[CellEditMode2["Edit"] = 2] = "Edit";
  return CellEditMode2;
})(CellEditMode || {});
class TableDataSet {
  constructor(tableName, uniqueId, rows, model, types, repository, options) {
    var _a, _b, _c, _d, _e, _f;
    this.tableName = tableName;
    this.uniqueId = uniqueId;
    this.rows = rows;
    this.model = model;
    this.types = types;
    this.repository = repository;
    this.options = options;
    this.info = new TableInfo(new DataSet(), TABLE_INFO__OBJ_KEYS, "remark");
    this.sort = new TableSort();
    this.confirmation = new ConfirmationHelper();
    this.tooltip = new TooltipHelper();
    this.headerHeight = null;
    this.listeners = [];
    this.cellEditMode = {
      mode: 1,
      event: void 0
    };
    this.currentEdit = null;
    this.open = {
      help: false,
      remark: null,
      comment: null,
      visibilityColumns: false,
      enterModal: null
    };
    this.modelDict = {};
    this.modelSystemDict = {};
    this.editMode = reactive({
      edit: true,
      comment: true,
      remark: true,
      warning: true,
      hint: true
    });
    this.visibleRows = [];
    this.updateCursor = void 0;
    this.groupsManager = new TableGroupsManager();
    this.isDestroyed = false;
    this.updateSortFlag = false;
    this.updateFilterFlag = false;
    this.filteredFlag = false;
    this.sortFlag = false;
    this.initialFilters = reactive([]);
    this.isTableMounted = false;
    this.afterVisibleRows = [];
    this.spinnerCounter = 0;
    this.colIndexesComputed = computed(() => {
      return this.modelUnref.reduce((value, currentValue, index) => {
        value[currentValue.field] = index;
        return value;
      }, {});
    });
    this.displayColIndexDictComputed = computed(() => {
      return this.modelUnref.reduce((value, currentValue, index) => {
        value[this.getDisplayColIndex(index)] = currentValue.field;
        return value;
      }, {});
    });
    this.uuidMapComputed = computed(() => {
      return this.getUUIDMap();
    });
    this.modelComputed = computed(() => {
      let result;
      if (this.groupsManager.isGrouping) {
        result = this.groupsManager.getSortModel(this, this.model);
      } else {
        result = this.model;
      }
      result.forEach((model2, index) => {
        model2.index = index;
      });
      return result;
    });
    this.headersComputed = computed(() => {
      if (this.groupsManager.isGrouping) {
        return this.modelUnref.map((x) => x.field);
      }
      return this.headers;
    });
    this.selectedCellsPointersComputed = computed(() => {
      if (this.rows.length === 0) {
        return [];
      }
      if (!this.selected.isSelectedMode || !this.selected.start || !this.selected.cursor) {
        if (this.selected.cursor) {
          return [this.selected.cursor];
        }
        return [];
      }
      const minMaxCell = getMinMaxCellPointer(
        this.selected.start,
        this.selected.cursor,
        "visual_row"
      );
      const cellPointers = [];
      for (let visual_row = minMaxCell.minRow; visual_row <= minMaxCell.maxRow; visual_row++) {
        const tableRow = this.getRowByVisualRow(visual_row);
        if (!(tableRow == null ? void 0 : tableRow.show)) {
          continue;
        }
        for (let col = minMaxCell.minCol; col <= minMaxCell.maxCol; col++) {
          const model2 = this.getModelOrUndefined(col);
          if (model2.hide) {
            continue;
          }
          cellPointers.push(
            PointerHelper.getRequired(this, {
              col_name: model2.field,
              visual_row
            })
          );
        }
      }
      return cellPointers;
    });
    this.sortedAndFilteredRows = null;
    this.getEdit = (key) => {
      if (this.groupsManager.isGrouping) {
        return false;
      }
      const currentValue = this.editMode[key];
      if (this.options.editModePriority) {
        return this.options.editModePriority[key];
      }
      return currentValue;
    };
    this.rows = reactive(this.rows);
    this.model = reactive(this.model);
    (_b = (_a = this.options).isPasteAddRows) != null ? _b : _a.isPasteAddRows = true;
    (_d = (_c = this.options).validationHandlers) != null ? _d : _c.validationHandlers = VALIDATION_HANDLERS;
    this.updateModel();
    if (!options.display) {
      options.display = {
        incCol: 0,
        incRow: 0,
        rowIndexCol: false
      };
    }
    if (!options.logging) {
      options.logging = {
        typeCellNotFound: false
      };
    }
    this.headers = (_e = options.headers) != null ? _e : this.modelUnref.map((x) => x.field);
    if (options.settingsService) {
      this.settingsService = options.settingsService;
    } else {
      this.settingsService = new TableSettingsService(this.id, {
        getSettings: async (key) => {
          const value = localStorage.getItem(key);
          if (!value) {
            return void 0;
          }
          return JSON.parse(value);
        },
        onSave: async (key, value) => {
          if (!value) {
            localStorage.removeItem(key);
          } else {
            localStorage.setItem(key, JSON.stringify(value));
          }
        }
      });
    }
    this.selected = reactive(
      options.selected || new TableSelected()
    );
    this.changes = options.changes || new TableChanges();
    this.helpHelper = options.helpHelper || new HelpHelper();
    this.keyboard = new TableKeyboard();
    if (options.infoData) {
      this.setInfoData(options.infoData);
    }
    if ((_f = options.listeners) == null ? void 0 : _f.changeFilters) {
      options.listeners.changeFilters.next = debounce(
        options.listeners.changeFilters.next,
        1
      );
    }
    this.enableVirtualScroll();
  }
  get isSelectedAll() {
    return this.visibleRows.length > 0 && !this.visibleRows.some((x) => !x.select);
  }
  get getUUID() {
    var _a;
    return (_a = this.options.getUUID) != null ? _a : DEFAULT_GET_UUID;
  }
  get initialFiltersParse() {
    return this.initialFilters.map((x) => x.filter).map(FilterFactory.parseLogicalObjOrComparisonObj);
  }
  get isAllowRowCreate() {
    const rowCreate = this.getEdit("rowCreate");
    if (!isNullOrUndefined(rowCreate)) {
      return rowCreate;
    }
    return this.getEdit("edit");
  }
  get isAllowRowDelete() {
    const rowDelete = this.getEdit("rowDelete");
    if (!isNullOrUndefined(rowDelete)) {
      return rowDelete;
    }
    return this.getEdit("edit");
  }
  get isAllowRowMove() {
    const rowMove = this.getEdit("rowMove");
    if (!isNullOrUndefined(rowMove)) {
      return rowMove;
    }
    return this.getEdit("edit");
  }
  get id() {
    return toNormaliseDomId(`table-${this.tableName}-${this.uniqueId}`);
  }
  get idContainer() {
    return toNormaliseDomId(
      `table-container-${this.tableName}-${this.uniqueId}`
    );
  }
  get idContainerDivUp() {
    return toNormaliseDomId(this.idContainer + "_div-up");
  }
  get idContainerDivBottom() {
    return toNormaliseDomId(this.idContainer + "_div-bottom");
  }
  get classes() {
    var _a;
    return ((_a = this.tableComponent) == null ? void 0 : _a.classes) || TABLE_CLASSES;
  }
  get isServerManagement() {
    var _a;
    return Boolean((_a = this.options.pagination) == null ? void 0 : _a.isServerManagement(this));
  }
  get isServerFilterAndSort() {
    return this.isServerManagement;
  }
  get virtualScrollMinLength() {
    return toNumberOrDefault(this.options.virtualScrollMinLength, 200);
  }
  get displayDateFormat() {
    var _a;
    return ((_a = this.options.display) == null ? void 0 : _a.dateFormat) || DISPLAY_DATE_FORMAT;
  }
  get serverDateFormat() {
    return SERVER_DATE_FORMAT;
  }
  get isFullScreenAndMounted() {
    var _a;
    return ((_a = this.options.display) == null ? void 0 : _a.fullScreen) && this.isTableMounted;
  }
  get wordWrap() {
    var _a, _b;
    if (this.options.uniqueWordWrapSave) {
      return (_a = this.settingsService.settings.value) == null ? void 0 : _a.wordWrap;
    }
    return (_b = this.options.wordWrap) != null ? _b : GlobalTableSettingsService.globalSettings.wordWrap;
  }
  get screenSpinner() {
    return !this.isTableMounted || this.spinnerCounter > 0;
  }
  get modelUnref() {
    return unref(this.modelComputed);
  }
  get headersUnref() {
    return unref(this.headersComputed);
  }
  get uuidMapUnref() {
    return unref(this.uuidMapComputed);
  }
  get colIndexesUnref() {
    return unref(this.colIndexesComputed);
  }
  get displayColIndexDictUnref() {
    return unref(this.displayColIndexDictComputed);
  }
  get selectedCellsPointersUnref() {
    return unref(this.selectedCellsPointersComputed);
  }
  static getTypeModel(types, model) {
    var _a;
    return (_a = types[model.type]) != null ? _a : DEFAULT_REPOSITORY_READ_TYPE_DTO;
  }
  static getCellId(tableId, row, col_name) {
    return `${tableId}_${row}_${col_name}`;
  }
  isSupportLocalFilters() {
    return this.initialFiltersParse.every(
      FilterFactory.isSupportLocalFilterLogicalOrComparisonParse
    );
  }
  async mounted(tableComponent, listeners) {
    var _a, _b;
    this.initSort();
    this.initRows(this.rows);
    this.tableComponent = tableComponent;
    this.repository.runSaveInterval(this);
    await this.settingsService.init(this);
    this.listeners = listeners;
    this.listeners.forEach((x) => {
      window.addEventListener(x.type, x.handler);
    });
    (_b = (_a = this.options.listeners) == null ? void 0 : _a.mounted) == null ? void 0 : _b.next();
    this.isTableMounted = true;
    GlobalTableSettingsService.currentTables[this.id] = {
      tableDataSet: this
    };
  }
  async destroy() {
    var _a, _b;
    if (this.isDestroyed) {
      return;
    }
    delete GlobalTableSettingsService.currentTables[this.id];
    this.isTableMounted = false;
    this.isDestroyed = true;
    this.repository.destroy();
    this.listeners.forEach(
      (x) => window.removeEventListener(x.type, x.handler)
    );
    this.modelUnref.forEach((model) => {
      model.destroy();
    });
    this.tableComponent.tableDestroy();
    (_b = (_a = this.options.listeners) == null ? void 0 : _a.destroy) == null ? void 0 : _b.next();
  }
  onChangeFilters() {
    var _a, _b;
    this.updateFilterFlag = true;
    if (this.sortFlag) {
      this.updateSortFlag = true;
    }
    this.updateCursor = "start";
    (_b = (_a = this.options.listeners) == null ? void 0 : _a.changeFilters) == null ? void 0 : _b.next();
  }
  onChangeSort() {
    var _a, _b;
    this.updateSortFlag = true;
    this.updateCursor = "start";
    (_b = (_a = this.options.listeners) == null ? void 0 : _a.changeSort) == null ? void 0 : _b.next();
  }
  onRowDelete(selectedRows) {
    selectedRows = uniqBy(selectedRows, (x) => x.row);
    const message = `\u0412\u044B \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u0441\u0442\u0440\u043E\u043A${selectedRows.length === 1 ? "\u0443" : "\u0438"} \u043F\u043E\u0434 \u043D\u043E\u043C\u0435\u0440\u043E\u043C ${selectedRows.map((x) => this.getDisplayRowIndex(x.row)).join(", ")}?`;
    this.confirmation.setConfirmation({
      message,
      success: () => {
        this.tableComponent.rowDeleteEmit(selectedRows);
        if (this.selected.cursor && this.getCellData(this.selected.cursor) === void 0) {
          this.selected.onSelectPrevRow(this);
        }
        return this.tableComponent.focusTable();
      },
      cancel: () => {
        return this.tableComponent.focusTable();
      }
    });
  }
  initRows(rows) {
    if (this.rows === rows) {
      return;
    }
    this.rows = rows;
    this.updateSortAndFilter();
    this.enableVirtualScroll();
  }
  initSort() {
    if (this.isServerFilterAndSort) {
      return;
    }
    const modelSortDefault = this.modelUnref.find(
      (x) => x.modelDto.default_sort !== void 0
    );
    if (!modelSortDefault) {
      return;
    }
    const sortMode = modelSortDefault.modelDto.default_sort === "-" ? "DESC" : "ASC";
    this.sort.setSort(this, modelSortDefault, sortMode);
  }
  setDataInVisibleRows(rows) {
    const start = this.selected.getFirstCursor();
    if (!start) {
      return;
    }
    const visibleRowsLength = this.visibleRows.length;
    const visibleRowsStartIndex = start.visual_row;
    const updates = [];
    const needRows = (visibleRowsLength - visibleRowsStartIndex - rows.length) * -1;
    if (this.isAllowRowCreate && this.options.isPasteAddRows && needRows > 0) {
      this.rowsAppend(needRows);
    }
    const visibleRows = this.getVisibleRows();
    rows.forEach((rowValues, rowCurrent) => {
      const visibleRowsIndex = visibleRowsStartIndex + rowCurrent;
      const tableRow = visibleRows[visibleRowsIndex];
      if (!tableRow) {
        return;
      }
      let colCurrent = -1;
      rowValues.forEach((newValue) => {
        colCurrent++;
        const model = (() => {
          const colStart = start.col + colCurrent;
          for (let i = colStart; i < this.model.length; i++) {
            const model2 = this.getModelOrUndefined(i);
            if (!model2 || model2.hide) {
              colCurrent++;
              continue;
            }
            return model2;
          }
          return void 0;
        })();
        if (!model) {
          return;
        }
        const pointer = {
          row: tableRow.row,
          col_name: model.field
        };
        const cellData = this.getTableCell(pointer);
        if (!cellData) {
          return;
        }
        const value = getTransformCellValue(this, model, newValue.value);
        if (getValidError(
          model,
          this.types[model.type || ""],
          value,
          this.options.validationHandlers
        ).type === ValidErrorEnum.Ok) {
          updates.push({
            pointer,
            newValue: {
              value,
              info: void 0
            },
            changes: ["value"]
          });
        }
      });
    });
    if (updates.length > 0) {
      this.tableComponent.onUpdateCells(updates);
    }
  }
  setInfoData(infoData) {
    this.info.setDictData(infoData);
  }
  async setWordWrap(wordWrap = !this.wordWrap) {
    if (this.options.uniqueWordWrapSave) {
      await this.settingsService.assignSave({
        wordWrap
      });
    } else if (this.options.wordWrap !== void 0) {
      this.options.wordWrap = wordWrap;
    } else {
      GlobalTableSettingsService.globalSettings.wordWrap = wordWrap;
    }
  }
  async executeAutoWidth(saveChanges, saveRepository) {
    for (const model of this.modelUnref) {
      const width = model.getAutoWidth(this);
      this.colResize(
        {
          width,
          col_name: model.field,
          prev_width: model.width
        },
        saveChanges,
        saveRepository
      );
    }
  }
  clearInfoData() {
    this.info.dataSet.clearData();
  }
  clearCurrentSelected() {
    const pointers = this.getSelectedCellsPointers();
    if (pointers.length) {
      this.tableComponent.onUpdateCells(
        pointers.map((pointer) => {
          const value = TableCell.getEmptyValue(
            this.getTypeField(pointer.col_name)
          );
          return this.getEmitUpdateCell({
            changes: ["value"],
            newValue: {
              value,
              info: void 0
            },
            pointer
          });
        })
      );
    }
  }
  getFilterComponent() {
    if (!this.tableComponent) {
      throw new Error(
        `getFilterComponent, tableComponent === ${this.tableComponent}`
      );
    }
    return this.tableComponent.$refs.filterComponent;
  }
  getCellData(pointer) {
    if (!pointer) {
      return void 0;
    }
    return getCellData(this, pointer);
  }
  getRowByVisualRow(visual_row) {
    return this.getVisualRows()[visual_row];
  }
  getCellEl(row, col_name) {
    return document.getElementById(
      TableDataSet.getCellId(this.id, row, col_name)
    );
  }
  getTableEl() {
    return document.getElementById(this.id);
  }
  getContainerEl() {
    return document.getElementById(this.idContainer);
  }
  getFirstRowEl() {
    var _a;
    return (_a = this.getTableEl()) == null ? void 0 : _a.querySelector(
      classToQuerySelector(this.classes.row)
    );
  }
  getRowsElements() {
    var _a;
    return (_a = this.getTableEl()) == null ? void 0 : _a.querySelectorAll(
      classToQuerySelector(this.classes.row)
    );
  }
  getSelectedRow() {
    var _a;
    const row = (_a = this.selected.cursor) == null ? void 0 : _a.row;
    if (row === void 0) {
      return void 0;
    }
    return this.getRowOrUndefined(row);
  }
  getRowOrUndefined(row) {
    if (isNullOrUndefined(row)) {
      return void 0;
    }
    return this.rows[row];
  }
  getRowOrException(row) {
    const tableRow = this.getRowOrUndefined(row);
    if (!tableRow) {
      throw new Error(`\u0421\u0442\u0440\u043E\u043A\u0430 ${row} \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u0430 \u0432 \u0442\u0430\u0431\u043B\u0438\u0446\u0435 "${this.id}"`);
    }
    return tableRow;
  }
  getUUIDMap() {
    const map = /* @__PURE__ */ new Map();
    this.rows.forEach((tableRow) => {
      map.set(this.getUUID(tableRow.original, tableRow), tableRow);
    });
    return map;
  }
  getRowByUUID(uuid, row) {
    const tableRow = this.getRowOrUndefined(row);
    if (tableRow !== void 0 && this.getUUID(tableRow.original, tableRow) === uuid) {
      return tableRow;
    }
    return this.uuidMapUnref.get(uuid);
  }
  getRowValue(row) {
    const rowObj = this.getRowOrUndefined(row);
    if (!rowObj) {
      return void 0;
    }
    return TableRow.getValue(rowObj);
  }
  getValues() {
    return this.rows.map((x) => TableRow.getValue(x));
  }
  getStartPointer() {
    const col_name = this.getFirstColNameVisible();
    const row = this.getFirstRowVisible();
    if (col_name === void 0 || row === void 0) {
      return void 0;
    }
    return PointerHelper.getRequired(this, {
      col_name,
      row
    });
  }
  getEndPointer() {
    const col_name = this.getLastColNameVisible();
    const row = this.getLastRowVisible();
    if (!col_name || row === void 0) {
      return void 0;
    }
    return {
      col_name,
      row
    };
  }
  getEndColPointer(col_name) {
    const row = this.getLastRowVisible();
    if (row === void 0) {
      return void 0;
    }
    return {
      col_name,
      row
    };
  }
  getEndColPointerRequired(col_name) {
    const pointer = this.getEndColPointer(col_name);
    if (!pointer) {
      return void 0;
    }
    return PointerHelper.getRequired(this, pointer);
  }
  getEndPointerRequired() {
    const pointer = this.getEndPointer();
    if (!pointer) {
      return void 0;
    }
    return PointerHelper.getRequired(this, pointer);
  }
  getTypeModel(model) {
    return TableDataSet.getTypeModel(this.types, model);
  }
  getTypeField(field) {
    const model = this.getModelOrUndefined(field);
    if (!model) {
      throw Error(`field: "${field}" not found model`);
    }
    return this.getTypeModel(model);
  }
  getCellLabelOpts(field) {
    const model = this.modelDict[field];
    if (!model) {
      return {
        serverDateFormat: this.serverDateFormat,
        displayDateFormat: this.displayDateFormat,
        vocDataSet: void 0
      };
    }
    const type = this.getTypeModel(model);
    return {
      vocDataSet: model.vocDataSet,
      displayDateFormat: this.getDisplayDateFormat(type),
      serverDateFormat: this.getServerDateFormat(type)
    };
  }
  getDisplayDateFormat(type) {
    var _a, _b;
    return (_b = (_a = type == null ? void 0 : type.display) == null ? void 0 : _a.date_format) != null ? _b : this.displayDateFormat;
  }
  getServerDateFormat(type) {
    var _a, _b;
    return (_b = (_a = type == null ? void 0 : type.validation) == null ? void 0 : _a.date_format) != null ? _b : this.serverDateFormat;
  }
  getFilteredRows() {
    let visualRows = this.sortFlag ? this.getVisualRows() : this.rows;
    if (!this.groupsManager.isGrouping && (this.initialFilters.length === 0 || this.isServerFilterAndSort)) {
      if (this.filteredFlag && this.sortFlag) {
        this.updateSortFlag = true;
      }
      this.filteredFlag = false;
      this.rows.forEach((tableRow) => {
        TableRow.setShow(tableRow, true);
      });
      return visualRows;
    }
    this.filteredFlag = true;
    let filteredRows = [];
    const addRows = (tableRows) => {
      const getShowByGroup = (tableRow) => {
        if (!tableRow.cacheGroup) {
          return void 0;
        }
        for (const group of tableRow.cacheGroup.groups) {
          if (tableRow.group === group) {
            continue;
          }
          if (!group.open) {
            return false;
          }
        }
        return true;
      };
      for (let i = 0; i < tableRows.length; i++) {
        const tableRow = tableRows[i];
        let show = this.isServerFilterAndSort || this.isTableRowVisible(this.initialFiltersParse, tableRow);
        const showByGroup = getShowByGroup(tableRow);
        if (showByGroup !== void 0) {
          show = show && showByGroup;
        }
        TableRow.setShow(tableRow, show);
        if (show) {
          filteredRows.push(tableRow);
        }
      }
    };
    if (this.groupsManager.isGrouping) {
      const notGroupedRowsAll = [];
      let groupedRowsAll = [];
      visualRows.forEach((visualRow) => {
        if (this.groupsManager.isGroupedRow(visualRow)) {
          groupedRowsAll.push(visualRow);
        } else {
          notGroupedRowsAll.push(visualRow);
        }
      });
      addRows(notGroupedRowsAll);
      const groupedRows = groupByMap(groupedRowsAll, (visualRow) => {
        return firstOrDefault(visualRow.cacheGroup.groups);
      });
      const groups = Array.from(groupedRows.keys());
      groups.forEach((group) => {
        if (!group) {
          addRows(groupedRows.get(group));
          return;
        }
        let groupedRowsArray = groupedRows.get(group);
        const deep = TableGroupsManager.getDeepByRowsHeaders(groupedRowsArray);
        const getGroupedRowsDeep = (tableRows, deep2) => {
          return groupByMap(tableRows, (x) => x.cacheGroup.groups[deep2]);
        };
        for (let i = deep; i >= 0; i--) {
          let groupedRowsDeep = getGroupedRowsDeep(groupedRowsArray, i);
          groupedRowsArray = [];
          const groups2 = Array.from(groupedRowsDeep.keys());
          groups2.forEach((group2) => {
            let groupedRowsDeepArray = groupedRowsDeep.get(group2);
            groupedRowsDeepArray = sortBy(
              groupedRowsDeepArray,
              (x) => x,
              (x, y) => {
                var _a, _b;
                const yExist = TableRow.isRowExistInHeader(x, y);
                if (yExist) {
                  return -1;
                }
                const xExist = TableRow.isRowExistInHeader(y, x);
                if (xExist) {
                  return 1;
                }
                const getResultByIndex = (indexX, indexY) => {
                  const indexDifference = indexX - indexY;
                  if (indexDifference > 0) {
                    return -1;
                  }
                  if (indexDifference < 0) {
                    return 1;
                  }
                  return 0;
                };
                const xCache = x.cacheGroup;
                const yCache = y.cacheGroup;
                if (x.group || y.group) {
                  if (x.group && y.group) {
                    if (x.group.field === y.group.field) {
                      const indexDifference = getResultByIndex(
                        x.group.index,
                        y.group.index
                      );
                      if (indexDifference !== 0) {
                        return indexDifference;
                      }
                    } else {
                      return x.group.deep - y.group.deep;
                    }
                  } else {
                    const currentName = x.group ? "x" : "y";
                    const group1 = currentName === "x" ? x.group : y.group;
                    const group22 = (currentName === "x" ? yCache : xCache).groups.find((x2) => x2.field === group1.field);
                    if (group22) {
                      let indexDifference = getResultByIndex(
                        group1.index,
                        group22.index
                      );
                      if (currentName === "y") {
                        indexDifference *= -1;
                      }
                      if (indexDifference !== 0) {
                        return indexDifference;
                      }
                    }
                  }
                }
                const xCurrentOrCacheLast = (_a = x.group) != null ? _a : lastOrDefault(xCache.groups);
                const yCurrentOrCacheLast = (_b = y.group) != null ? _b : lastOrDefault(yCache.groups);
                if (xCurrentOrCacheLast.field === yCurrentOrCacheLast.field) {
                  const indexResult = getResultByIndex(
                    xCurrentOrCacheLast.index,
                    yCurrentOrCacheLast.index
                  );
                  if (indexResult !== 0) {
                    return indexResult;
                  }
                }
                return 0;
              }
            );
            groupedRowsArray.push(...groupedRowsDeepArray);
          });
        }
        if (isDev) {
          TableGroupsManager.fixSort(this, groupedRowsArray);
        }
        addRows(groupedRowsArray);
      });
    } else {
      addRows(visualRows);
    }
    return filteredRows;
  }
  updateVisualIndexes(visibleRows) {
    for (let visibleRow = 0; visibleRow < visibleRows.length; visibleRow++) {
      TableRow.setVisualRow(visibleRows[visibleRow], visibleRow);
    }
    return visibleRows;
  }
  setOpenByAssign(open) {
    Object.assign(this.open, open);
  }
  updateModel() {
    this.modelDict = this.modelUnref.reduce(
      (modelDict, model) => {
        modelDict[model.field] = model;
        return modelDict;
      },
      {}
    );
    this.modelSystemDict = this.modelUnref.reduce(
      (modelDict, model) => {
        modelDict[model.systemField || model.field] = model;
        return modelDict;
      },
      {}
    );
    return this;
  }
  addOptionsListeners(listeners) {
    var _a, _b;
    (_b = (_a = this.options).listeners) != null ? _b : _a.listeners = {};
    Object.keys(listeners).forEach((listenerKey) => {
      const prevListener = this.options.listeners[listenerKey];
      const newListener = listeners[listenerKey];
      if (prevListener) {
        newListener.next = (...args) => {
          newListener.next(...args);
          prevListener.next(...args);
        };
      }
      this.options.listeners[listenerKey] = newListener;
    });
  }
  setInitialFilters(initialFilters, runOnChange = true) {
    this.initialFilters.length = 0;
    this.initialFilters.push(
      ...initialFilters.filter(
        (x) => Boolean(x == null ? void 0 : x.filter)
      )
    );
    this.onChangeFilters();
  }
  removeInitialFilters(keys2) {
    return this.setInitialFilters(
      this.initialFilters.filter((x) => !keys2.includes(x.key))
    );
  }
  addOrReplaceInitialFilters(filters) {
    filters.forEach((obj) => {
      if (!obj) {
        return;
      }
      if (!obj.filter) {
        if (obj.key) {
          this.setInitialFilters(
            this.initialFilters.filter((x) => x.key !== obj.key),
            false
          );
        }
        return;
      }
      const index = this.initialFilters.findIndex((x) => x.key === obj.key);
      if (index !== -1) {
        this.initialFilters[index] = obj;
      } else {
        this.initialFilters.push(obj);
      }
    });
    this.onChangeFilters();
  }
  resetInitialFilters() {
    if (this.initialFilters.length !== 0) {
      this.setInitialFilters([]);
    }
  }
  setCurrentEdit(pointer, cellEditMode = 1) {
    if (pointer) {
      const model = this.getModelOrUndefined(pointer.col_name);
      if (model == null ? void 0 : model.modelDto.readonly) {
        return;
      }
    }
    this.currentEdit = pointer;
    if (pointer && this.selected.isSelectedMode) {
      this.selected.disableSelectedMode();
    }
    this.setCellEditMode(cellEditMode);
  }
  setCellEditMode(cellEditMode) {
    this.cellEditMode = { mode: cellEditMode };
  }
  async setHideColumn(model, hide = true, saveChanges = true, saveRepository = true) {
    this.colHide(
      {
        hide,
        col_name: model.field
      },
      saveChanges,
      saveRepository
    );
    if (saveRepository) {
      await this.saveHiddenColumns();
    }
  }
  saveHiddenColumns() {
    return this.settingsService.assignSave({
      hiddenColumns: this.modelUnref.filter((x) => x.hide).map((x) => x.field)
    });
  }
  setEditMode(editMode) {
    toClearObject(this.editMode);
    Object.assign(this.editMode, editMode);
  }
  setEditModePriority(editModePriority) {
    this.options.editModePriority = editModePriority;
    this.setEditMode(copy(this.editMode));
  }
  setCursor(pointer) {
    var _a, _b;
    if (this.updateCursor) {
      this.updateCursor = void 0;
    }
    if (isDev) {
      if ((pointer == null ? void 0 : pointer.visual_row) !== void 0 && pointer.row !== void 0 && pointer.visual_row !== ((_a = this.getRowOrUndefined(pointer.row)) == null ? void 0 : _a.visualRow)) {
        Logger$1.trace(
          `pointer.row: ${pointer.row}, pointer.visual_row: ${pointer.visual_row} !== current visual_row (${(_b = this.getRowOrUndefined(pointer.row)) == null ? void 0 : _b.visualRow})`
        );
      }
    }
    try {
      const requiredPointer = !pointer ? null : PointerHelper.getRequired(this, pointer);
      this.selected.setCursor(this, requiredPointer);
    } catch (e) {
      Logger$1.error("setCursor", e);
    }
    return pointer;
  }
  setCursorEndIfCurrentNotFound() {
    const tableRow = this.getSelectedRow();
    if (!tableRow) {
      this.setCursorEnd();
    }
  }
  getFirstVisibleCellPointer() {
    const cursor = {
      col_name: this.getFirstColNameVisible(),
      row: this.getFirstRowVisible()
    };
    return cursor;
  }
  setCursorStart() {
    const cursor = {
      col_name: this.getFirstColNameVisible(),
      row: this.getFirstRowVisible()
    };
    this.setCursor(cursor);
    return cursor;
  }
  setCursorEnd() {
    var _a, _b;
    const col_name = (_b = (_a = this.selected.cursor) == null ? void 0 : _a.col_name) != null ? _b : this.getFirstColNameVisible();
    const row = this.getLastRowVisible();
    if (!col_name || row === void 0) {
      return void 0;
    }
    const cursor = {
      col_name,
      row
    };
    this.setCursor(cursor);
    return cursor;
  }
  setCursorStartIfNull() {
    if (this.selected.cursor === null) {
      this.setCursor(this.getFirstVisibleCellPointer());
    }
  }
  setCursorStartCurrentRow() {
    if (!this.selected.cursor) {
      return;
    }
    this.setCursor({
      row: this.selected.cursor.row,
      col_name: this.getFirstColNameVisible()
    });
  }
  setCursorEndCurrentRow() {
    if (!this.selected.cursor) {
      return;
    }
    this.setCursor({
      row: this.selected.cursor.row,
      col_name: this.getLastColNameVisible()
    });
  }
  setTableRows(tableRows) {
    for (const tableRow of tableRows) {
      this.rows[tableRow.row] = tableRow;
    }
    this.enableVirtualScroll();
  }
  setFullScreenMode(fullScreen) {
    if (fullScreen === void 0) {
      fullScreen = !this.options.display.fullScreen;
    }
    this.options.display.fullScreen = fullScreen;
  }
  selectedAll() {
    this.selected.disableFocusCell();
    this.keyboard.clear();
    this.selected.selectedAll(this);
    nextTick(() => {
      this.selected.enableFocusCell();
    });
  }
  selectedRow(row) {
    this.selected.disableFocusCell();
    this.keyboard.clear();
    this.selected.enableSelectedMode(
      PointerHelper.getRequired(this, {
        row,
        col_name: this.getLastColNameVisible()
      })
    );
    this.setCursor({
      row,
      col_name: this.getFirstColNameVisible()
    });
    nextTick(() => {
      this.selected.enableFocusCell();
    });
  }
  rowAppend(saveChanges = true) {
    return this.rowsAppend(1, saveChanges);
  }
  rowsAppend(count, saveChanges = true) {
    var _a, _b;
    const onFinish = new Subject();
    (_b = (_a = this.options.listeners) == null ? void 0 : _a.rowsAppend) == null ? void 0 : _b.next({
      count,
      saveChanges,
      onFinish
    });
    let lastPointer = void 0;
    const rowChanges = [];
    for (let i = 0; i < count; i++) {
      const row = this.rows.length;
      const tableRow = this.createRow(row);
      this.addTableRow(this.rows.length, tableRow);
      lastPointer = {
        row
      };
      const rowChange = {
        row,
        data: {},
        original: void 0,
        changeCells: Object.keys(tableRow.cells).map((col_name) => {
          return {
            pointer: {
              row,
              col_name
            },
            changes: ["value"],
            changeCell: {
              value: tableRow.cells[col_name].value,
              info: void 0
            }
          };
        }),
        tableRow
      };
      rowChanges.push(rowChange);
    }
    rowChanges.reverse();
    if (lastPointer) {
      let changeEvents;
      if (saveChanges) {
        changeEvents = new TableChangeEvents();
        const col_name = this.getSelectedOrFirstVisibleColName();
        if (col_name) {
          const serverPointer = PointerHelper.getServerFormatManual(
            lastPointer.row,
            col_name
          );
          const serverPointerCancelled = PointerHelper.incRow(
            serverPointer,
            -count
          );
          changeEvents.setCursor(serverPointer).setCursorCancelled(serverPointerCancelled);
        }
        rowChanges.forEach(
          (rowChange) => changeEvents.add(
            new TableEventAddRow({ row: rowChange.row }, rowChange)
          )
        );
        this.changes.add(changeEvents, this);
      }
      rowChanges.forEach((rowChange) => {
        this.repository.addRow(
          {
            tableDataSet: this,
            changeEvents
          },
          rowChange
        );
      });
    }
    this.updateCursor = "end";
    onFinish.next({ rowChanges });
    return true;
  }
  pushRow(tableRow) {
    this.rows.push(tableRow);
    this.sort.clear(this);
  }
  setRowByIndex(index, tableRow) {
    this.rows[index] = tableRow;
    this.sort.clear(this);
  }
  rowsSplice(row, deleteCount, ...tableRows) {
    this.rows.splice(row, deleteCount, ...tableRows);
    this.sort.clear(this);
    this.resetInitialFilters();
    this.enableVirtualScroll();
  }
  updateIndexRows(start) {
    const end = this.rows.length - 1;
    const cacheUpdates = [];
    for (let currentRow = end; currentRow >= start; currentRow--) {
      const tableRow = this.getRowOrUndefined(currentRow);
      if (!tableRow) {
        continue;
      }
      cacheUpdates.push(() => {
        return TableRow.updateRowIndex(tableRow, currentRow);
      });
    }
    cacheUpdates.forEach((x) => x());
  }
  rowInsert(rowChange, saveChanges = true, saveRepository = true) {
    var _a, _b, _c;
    (_b = (_a = this.options.listeners) == null ? void 0 : _a.rowInsert) == null ? void 0 : _b.next({
      rowChange,
      saveChanges,
      saveRepository
    });
    const pointer = { row: rowChange.row };
    const tableRow = this.createRowByRowChange(rowChange);
    this.addTableRow(pointer.row, tableRow);
    TableRow.setInfoByRowChange(this.info, rowChange);
    let changeEvents;
    if (saveChanges) {
      const col_name = rowChange.col_name || ((_c = this.selected.cursor) == null ? void 0 : _c.col_name) || this.getFirstColNameVisible();
      changeEvents = new TableChangeEvents().add(
        new TableEventAddRow(pointer, rowChange)
      );
      if (col_name) {
        const pointerCancelled = {
          row: pointer.row,
          col_name
        };
        changeEvents.setCursor(pointerCancelled).setCursorCancelled(pointerCancelled);
      }
      this.changes.add(changeEvents, this);
    }
    if (saveRepository) {
      this.repository.addRow(
        {
          tableDataSet: this,
          changeEvents
        },
        rowChange
      );
    }
  }
  async updateRows(updates, saveChanges = true, saveRepository = true) {
    var _a, _b;
    (_b = (_a = this.options.listeners) == null ? void 0 : _a.updateRows) == null ? void 0 : _b.next({
      updates,
      saveChanges,
      saveRepository
    });
    const changeEvents = new TableChangeEvents();
    const tableRowsAndPointers = [];
    const setUpdate = (update) => {
      const prevValue = TableRow.getInfoData(this.info, update.pointer);
      const newValue = update.newValue || {};
      const newValueRepository = TableRow.getRepositoryFormat(newValue);
      this.updateRowInfoData(update.pointer, newValue, update.changes);
      tableRowsAndPointers.push({
        pointer: update.pointer,
        table_row: newValueRepository,
        changes: update.changes
      });
      if (prevValue && newValue) {
        changeEvents.events.push(
          new TableEventChangeRow(
            update.pointer,
            prevValue,
            newValue,
            update.changes
          )
        );
      }
    };
    updates.forEach(setUpdate);
    if (saveRepository) {
      this.repository.changeTableRows(
        {
          tableDataSet: this,
          changeEvents: saveChanges ? changeEvents : void 0
        },
        tableRowsAndPointers
      );
    }
    if (saveChanges) {
      this.changes.add(changeEvents, this);
    }
  }
  async updateCells(updates, saveChanges = true, saveRepository = true) {
    var _a, _b;
    try {
      (_b = (_a = this.options.listeners) == null ? void 0 : _a.updateCells) == null ? void 0 : _b.next({
        updates,
        saveChanges,
        saveRepository
      });
      const changeEvents = new TableChangeEvents();
      const tableCellsAndPointers = [];
      await TableUpdateCellsHelper.updateCells({
        updates,
        saveChanges,
        saveRepository,
        tableDataSet: this,
        changeEvents,
        tableCellsAndPointers
      });
      if (tableCellsAndPointers.length === 0) {
        return;
      }
      if (saveRepository) {
        this.repository.changeTableCells(
          {
            tableDataSet: this,
            changeEvents
          },
          tableCellsAndPointers
        );
      }
      if (saveChanges) {
        this.changes.add(changeEvents, this);
      }
    } catch (ex) {
      Logger$1.error(
        ex,
        this === void 0 ? "\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u043D\u0430\u043B\u0438\u0447\u0438\u0435 \u043A\u043E\u043D\u0442\u0435\u043A\u0441\u0442\u0430 (this)." : ""
      );
    }
  }
  updateCell(pointer, newValue, changes) {
    if (changes.includes("value")) {
      const cellData = this.getCellData(pointer);
      if (cellData) {
        TableCell.setValue(cellData, newValue.value);
      }
    }
    if (newValue.info) {
      this.info.setAll(
        pointer,
        newValue.info,
        changes.filter((x) => x !== "value")
      );
    }
  }
  updateRowInfoData(pointer, newData, changes) {
    this.info.setAll(pointer, newData, changes);
  }
  rowDuplicate(currentPointer, saveChanges = true) {
    const newRow = currentPointer.row + 1;
    const newTableRow = copy(this.rows[currentPointer.row]);
    const rowChange = TableRow.getChangeRow(this, newTableRow);
    TableRow.setRowByRowChange(rowChange, newRow);
    this.rowInsert(rowChange, saveChanges);
  }
  emitRowDuplicate(pointer) {
    this.tableComponent.$emit("row-duplicate", pointer);
  }
  deleteRows(range) {
    const fields = this.modelUnref.map((x) => x.field);
    const deleteCount = range.end - range.start + 1;
    for (let currentRow = range.start; currentRow <= range.end; currentRow++) {
      this.info.removeByRow(currentRow, fields);
    }
    const rowLengthBeforeDelete = this.rows.length;
    this.info.correctionAfterDeletingRows(
      rowLengthBeforeDelete,
      range.start,
      deleteCount,
      fields
    );
    this.rowsSplice(range.start, deleteCount);
    this.sort.clear(this);
  }
  rowDelete(pointers, saveChanges = true, saveRepository = true) {
    var _a, _b;
    if (pointers.length === 0) {
      return;
    }
    (_b = (_a = this.options.listeners) == null ? void 0 : _a.rowDelete) == null ? void 0 : _b.next({
      pointers,
      saveChanges,
      saveRepository
    });
    const changeEvents = new TableChangeEvents();
    const arrayOrderPointers = [[]];
    const sortPointers = sortBy(pointers, (x) => x.row, NUMBER_COMPARER_ASC);
    sortPointers.forEach((pointer) => {
      const lastArray = lastOrDefault(arrayOrderPointers);
      const lastPointer = lastOrDefault(lastArray);
      if (!lastPointer) {
        lastArray.push(pointer);
      } else {
        if (lastPointer.row + 1 === pointer.row) {
          lastArray.push(pointer);
        } else {
          arrayOrderPointers.push([pointer]);
        }
      }
    });
    arrayOrderPointers.reverse().forEach((pointers2) => {
      this.rowDeleteByOrder(
        pointers2,
        changeEvents,
        saveChanges,
        saveRepository
      );
    });
    if (saveChanges) {
      const col_name = this.getSelectedOrFirstVisibleColName();
      if (col_name) {
        const firstPointer = {
          row: firstOrDefault(pointers).row,
          col_name
        };
        changeEvents.setCursor(firstPointer);
      }
      this.selected.disableSelectedMode();
      this.changes.add(changeEvents, this);
    }
  }
  rowDeleteByOrder(pointers, changeEvents, saveChanges = true, saveRepository = true) {
    const pointersAndRows = pointers.map((pointer) => ({
      pointer,
      tableRow: this.getRowOrUndefined(pointer.row)
    })).filter((x) => Boolean(x.tableRow));
    const rowChangeArray = pointersAndRows.map(
      (x) => TableRow.getChangeRow(this, x.tableRow)
    );
    const rowIndexes = pointers.map((x) => x.row);
    const minIndex = Math.min(...rowIndexes);
    const maxIndex = Math.max(...rowIndexes);
    changeEvents.add(new TableEventDeleteRow(rowChangeArray));
    this.deleteRows({
      start: minIndex,
      end: maxIndex
    });
    this.updateIndexRows(minIndex);
    this.updateVisualIndexes(this.visibleRows);
    if (saveRepository) {
      this.repository.deleteRow(
        {
          tableDataSet: this,
          changeEvents: saveChanges ? changeEvents : void 0
        },
        pointersAndRows
      );
    }
  }
  rowMoveDown(pointer, saveChanges = true, saveRepository = true) {
    var _a, _b;
    if (pointer.row >= this.rows.length - 1) {
      return;
    }
    (_b = (_a = this.options.listeners) == null ? void 0 : _a.rowMoveDown) == null ? void 0 : _b.next({
      pointer,
      saveChanges,
      saveRepository
    });
    const newRowIndex = pointer.row + 1;
    const tableRow = this.swapRowIndexAndUpdate(pointer.row, newRowIndex);
    this.updateVisualIndexes(this.visibleRows);
    let changeEvents;
    if (saveChanges) {
      const newPointer = {
        row: newRowIndex,
        col_name: pointer.col_name
      };
      changeEvents = new TableChangeEvents().add(new TableEventMoveRow(newPointer, tableRow, "down")).setCursor(newPointer).setCursorCancelled(PointerHelper.incRow(newPointer, -1));
      this.changes.add(changeEvents, this);
      this.setCursor(newPointer);
    }
    if (saveRepository) {
      this.repository.moveRow(
        {
          tableDataSet: this,
          changeEvents
        },
        pointer,
        "down"
      );
    }
  }
  rowMoveUp(pointer, saveChanges = true, saveRepository = true) {
    var _a, _b;
    if (pointer.row === 0 || this.rows.length < 2) {
      return;
    }
    (_b = (_a = this.options.listeners) == null ? void 0 : _a.rowMoveUp) == null ? void 0 : _b.next({
      pointer,
      saveChanges,
      saveRepository
    });
    const newRowIndex = pointer.row - 1;
    const tableRow = this.swapRowIndexAndUpdate(pointer.row, newRowIndex);
    this.updateVisualIndexes(this.visibleRows);
    let changeEvents;
    if (saveChanges) {
      const newPointer = {
        row: newRowIndex,
        col_name: pointer.col_name
      };
      changeEvents = new TableChangeEvents().add(new TableEventMoveRow(pointer, tableRow, "up")).setCursor(newPointer).setCursorCancelled(PointerHelper.incRow(newPointer, 1));
      this.changes.add(changeEvents, this);
    }
    if (saveRepository) {
      this.repository.moveRow(
        {
          tableDataSet: this,
          changeEvents
        },
        pointer,
        "up"
      );
    }
  }
  swapRowIndexAndUpdate(row1, row2) {
    this.info.swapInfoRows(
      row1,
      row2,
      this.modelUnref.map((x) => x.field)
    );
    const tableRow1 = this.getRowOrException(row1);
    const tableRow2 = this.getRowOrException(row2);
    TableRow.updateRowIndex(tableRow1, row2);
    TableRow.updateRowIndex(tableRow2, row1);
    this.setRowByIndex(row1, tableRow2);
    this.setRowByIndex(row2, tableRow1);
    return tableRow1;
  }
  updateRowIndexesBySort() {
    const indexes = this.rows.map(
      (tableRow) => {
        return {
          old_index: tableRow.row,
          new_index: tableRow.visualRow
        };
      }
    );
    this.updateRowIndexes(indexes);
    this.sort.clear(this);
  }
  updateRowIndexes(indexes, saveChanges = true, saveRepository = true) {
    const changeEvents = new TableChangeEvents();
    changeEvents.add(new TableEventUpdateRowIndexes(indexes));
    if (saveRepository) {
      this.repository.updateRowIndexes(
        {
          tableDataSet: this,
          changeEvents: saveChanges ? changeEvents : void 0
        },
        indexes
      );
    }
    const tableRowsSorted = sortBy(
      indexes.map((indexDto) => {
        const tableRow = this.getRowOrUndefined(indexDto.old_index);
        if (!tableRow) {
          throw new Error(
            `updateRowIndexes row not found: ${indexDto.old_index}`
          );
        }
        TableRow.setRow(tableRow, indexDto.new_index);
        return tableRow;
      }),
      (tableRow) => tableRow.row,
      NUMBER_COMPARER_ASC
    );
    const infoSwapSet = /* @__PURE__ */ new Set();
    const fields = this.modelUnref.map((x) => x.field);
    indexes.forEach((indexDto) => {
      tableRowsSorted.forEach((tableRow) => {
        if (!infoSwapSet.has(indexDto.old_index)) {
          this.info.swapInfoRows(
            indexDto.old_index,
            indexDto.new_index,
            fields
          );
          infoSwapSet.add(indexDto.old_index);
          infoSwapSet.add(indexDto.new_index);
        }
        return tableRow;
      });
    });
    this.setTableRows(tableRowsSorted);
    if (saveChanges) {
      this.changes.add(changeEvents, this);
    }
  }
  colResize(event, saveChanges = true, saveRepository = true) {
    var _a, _b;
    const model = this.getModelOrUndefined(event.col_name);
    if (!model) {
      return;
    }
    const changeEvents = new TableChangeEvents();
    changeEvents.add(new TableEventResizeColumn(event));
    model.setWidth(event.width);
    if (saveChanges) {
      this.changes.add(changeEvents, this);
    }
    (_b = (_a = this.options.listeners) == null ? void 0 : _a.colResize) == null ? void 0 : _b.next({
      event,
      saveChanges,
      saveRepository
    });
  }
  colHide(event, saveChanges = true, saveRepository = true) {
    var _a, _b;
    const model = this.getModelOrUndefined(event.col_name);
    if (!model) {
      return;
    }
    model.setHide(event.hide);
    (_b = (_a = this.options.listeners) == null ? void 0 : _a.colHide) == null ? void 0 : _b.next({
      event,
      saveChanges,
      saveRepository
    });
  }
  isSelectedHeader(col_name) {
    var _a;
    if (this.selected.isSelectedMode && !this.selected.isCursorAtStart() || col_name === void 0) {
      return false;
    }
    return col_name === ((_a = this.selected.cursor) == null ? void 0 : _a.col_name);
  }
  createRow(row) {
    const tableRowRecord = TableRow.getEmptyTableRowRecord(
      this.modelUnref,
      this.types,
      row
    );
    return TableRow.getTableRowObj(
      tableRowRecord,
      this.modelUnref,
      this.options.getUUID
    );
  }
  createRowByRowChange(rowChange) {
    var _a, _b;
    const rowRecord = TableRow.getRecordByChange(rowChange);
    const tableRow = (_a = rowChange.tableRow) != null ? _a : TableRow.getTableRowObj(rowRecord, this.modelUnref, this.options.getUUID);
    if ((_b = rowChange.tableRow) == null ? void 0 : _b.group) {
      tableRow.group = rowChange.tableRow.group;
    }
    rowChange.tableRow = tableRow;
    return tableRow;
  }
  updateSortedRows() {
    this.sortedAndFilteredRows = this.sort.getSortedRows(this);
  }
  updateSortAndFilter() {
    this.updateSortFlag = true;
    this.updateFilterFlag = true;
  }
  updateFilteredRows() {
    this.sortedAndFilteredRows = this.getFilteredRows();
  }
  isTableRowVisible(currentFilters, tableRow) {
    return currentFilters.every(
      (filter) => TableFilterHelper.isShow(filter, this, tableRow)
    );
  }
  showContextMenu({
    event,
    type,
    pointer
  }) {
    let options = [];
    if (type === "cell" && pointer && PointerHelper.isCellPointer(pointer)) {
      const isLocatedSelected = PointerHelper.isLocatedRange(pointer, this);
      if (!isLocatedSelected) {
        this.selected.disableSelectedMode();
        this.setCursor(pointer);
      }
      options = this.getContextMenuCell(pointer);
    } else if (type === "header" && (!pointer || "col_name" in pointer)) {
      const model = this.getModelOrUndefined(pointer == null ? void 0 : pointer.col_name);
      options = this.getContextMenuHeader(model);
    } else if (type === "row" && PointerHelper.isRowPointer(pointer)) {
      options = this.getContextMenuRow(pointer);
    }
    if (options.length > 0) {
      ContextMenuService.send({
        event,
        options
      });
    }
  }
  setHeaderHeight(headerHeight) {
    var _a;
    this.headerHeight = headerHeight;
    (_a = this.virtualScroll) == null ? void 0 : _a.updateState();
  }
  fixCursor() {
    if (this.selected.cursor && this.selected.cursor.visual_row >= this.visibleRows.length) {
      const newCursor = copy(
        this.selected.cursor
      );
      if (newCursor) {
        newCursor.visual_row = this.visibleRows.length - 1;
        this.setCursor(newCursor);
      }
    }
  }
  getEmitUpdateCell({
    newValue,
    pointer,
    changes,
    original
  }) {
    var _a;
    return {
      newValue,
      pointer,
      changes,
      original: original || ((_a = this.getRowOrUndefined(pointer.row)) == null ? void 0 : _a.original)
    };
  }
  getEmitUpdateValueCell(pointer, value) {
    return this.getEmitUpdateCell({
      pointer,
      changes: ["value"],
      newValue: {
        value,
        info: void 0
      }
    });
  }
  getEmitUpdateRow({
    newValue,
    pointer,
    changes,
    original
  }) {
    var _a;
    return {
      newValue,
      pointer,
      changes,
      original: original || ((_a = this.getRowOrUndefined(pointer.row)) == null ? void 0 : _a.original)
    };
  }
  getColIndex(col_name) {
    return this.colIndexesUnref[col_name];
  }
  getDisplayColIndex(colIndexOrName) {
    var _a;
    if (this.options.display.modelColNum) {
      const model = this.getModelOrUndefined(colIndexOrName);
      if (model) {
        return toStr(model.modelDto.col_num);
      }
    }
    const inc = 1 + (((_a = this.options.display) == null ? void 0 : _a.incCol) || 0);
    if (typeof colIndexOrName === "string") {
      const colIndex = this.colIndexesUnref[colIndexOrName];
      if (!isNullOrUndefined(colIndex)) {
        return toStr(colIndex + inc);
      }
      return colIndexOrName;
    }
    return toStr(colIndexOrName + inc);
  }
  getColCaption(colIndexOrName) {
    var _a;
    const caption = this.getDisplayColIndex(colIndexOrName) || toNumberOrUndefined(colIndexOrName) || ((_a = this.getModelOrUndefined(colIndexOrName)) == null ? void 0 : _a.caption);
    if (caption) {
      return `\u0413\u0440\u0430\u0444\u0430 ${caption}`;
    }
    return toStr(colIndexOrName);
  }
  getColName(displayColIndexOrColNameOrColIndex) {
    var _a;
    return (_a = this.displayColIndexDictUnref[displayColIndexOrColNameOrColIndex]) != null ? _a : displayColIndexOrColNameOrColIndex;
  }
  getDisplayRowIndex(row) {
    var _a;
    return row + 1 + (((_a = this.options.display) == null ? void 0 : _a.incRow) || 0);
  }
  getRowByDisplayRow(displayRow) {
    var _a;
    return displayRow - 1 - (((_a = this.options.display) == null ? void 0 : _a.incRow) || 0);
  }
  getFirstColVisible() {
    const model = this.modelUnref.find((x) => !x.hide);
    if (!model) {
      return void 0;
    }
    return model.index;
  }
  getFirstColNameVisible() {
    var _a;
    return (_a = this.getModelOrUndefined(this.getFirstColVisible())) == null ? void 0 : _a.field;
  }
  getFirstRowVisible() {
    var _a;
    return (_a = firstOrDefault(this.visibleRows)) == null ? void 0 : _a.row;
  }
  getSelectedOrFirstVisibleColName() {
    var _a;
    return ((_a = this.selected.cursor) == null ? void 0 : _a.col_name) || this.getFirstColNameVisible();
  }
  getLastColVisible() {
    for (let i = this.modelUnref.length - 1; i >= 0; i--) {
      if (!this.modelUnref[i].hide) {
        return this.modelUnref[i].index;
      }
    }
    return void 0;
  }
  getLastColNameVisible() {
    var _a;
    return (_a = this.getModelOrUndefined(this.getLastColVisible())) == null ? void 0 : _a.field;
  }
  getLastRowVisible() {
    var _a;
    return (_a = lastOrDefault(this.visibleRows)) == null ? void 0 : _a.row;
  }
  getCurrentModelOrUndefined() {
    var _a;
    return this.getModelOrUndefined((_a = this.selected.cursor) == null ? void 0 : _a.col_name);
  }
  getModelOrUndefined(colIndexOrName) {
    if (isNullOrUndefined(colIndexOrName)) {
      return void 0;
    }
    if (typeof colIndexOrName === "string") {
      return this.modelDict[colIndexOrName];
    }
    return this.modelUnref[colIndexOrName];
  }
  getModelBySystem(systemColName) {
    if (systemColName === void 0) {
      return void 0;
    }
    return this.modelSystemDict[systemColName];
  }
  getShowSystemFields() {
    return this.modelUnref.filter((x) => !x.hide).map((x) => x.systemField || x.field);
  }
  getSystemFields() {
    return Object.keys(this.modelSystemDict);
  }
  getVisualRows() {
    const sortOrFilter = this.sortFlag || this.filteredFlag;
    if (!sortOrFilter && this.sortedAndFilteredRows) {
      this.sortedAndFilteredRows = null;
    }
    return Array.isArray(this.sortedAndFilteredRows) ? this.sortedAndFilteredRows : this.rows;
  }
  getVisibleRows() {
    var _a;
    const updateSortFlag = this.updateSortFlag;
    const updateFilterFlag = this.updateFilterFlag;
    if (updateSortFlag) {
      this.updateSortedRows();
      this.updateSortFlag = false;
    }
    if (updateFilterFlag || updateSortFlag) {
      this.updateFilteredRows();
      this.updateFilterFlag = false;
    }
    if (!this.isServerFilterAndSort && (this.updateSortFlag || this.updateFilterFlag)) {
      return this.getVisibleRows();
    }
    const visualRows = this.getVisualRows();
    if (updateSortFlag || updateFilterFlag) {
      this.updateVisualIndexes(visualRows);
      this.selected.disableSelectedMode();
      (_a = this.virtualScroll) == null ? void 0 : _a.resetVirtualScroll();
    }
    if (this.updateCursor !== void 0) {
      const cursor = this.updateCursor;
      this.updateCursor = void 0;
      setTimeout(() => {
        if (typeof cursor === "object") {
          this.setCursor(cursor);
        } else {
          if (cursor === "start") {
            this.setCursorStart();
          } else if (cursor === "end") {
            this.setCursorEnd();
          }
        }
      });
    }
    this.visibleRows = visualRows;
    for (const afterVisibleRow of this.afterVisibleRows) {
      afterVisibleRow();
    }
    this.afterVisibleRows.length = 0;
    return visualRows;
  }
  getAllCellsByCol(col) {
    const model = this.getModelOrUndefined(col);
    if (!model) {
      return [];
    }
    return this.rows.map((x) => x.cells[model.field]);
  }
  getContextMenuCell(pointer) {
    let result = [];
    const selectedCells = this.getSelectedCellsPointers();
    const selectedRowsIndexArray = this.getSelectedRowsIndexArray();
    const isOnlyCell = selectedCells.length === 1;
    const isOnlyRow = selectedRowsIndexArray.length === 1;
    const infoCellOptions = this.info.getCellEditableKeys().filter((infoKey) => !infoKey.readonly && this.getEdit(infoKey.key)).map((infoKey) => ({
      icon: infoKey.icon,
      text: `${infoKey.name} ${isOnlyCell ? "\u043A \u044F\u0447\u0435\u0439\u043A\u0435" : "\u043A \u044F\u0447\u0435\u0439\u043A\u0430\u043C"}`,
      rightText: infoKey.hotkey,
      click: () => {
        this.open[infoKey.key] = {
          pointers: selectedCells
        };
      }
    }));
    const infoRowOptions = isOnlyRow ? this.info.getRowEditableKeys().filter((infoKey) => !infoKey.readonly && this.getEdit(infoKey.key)).map((infoKey) => ({
      icon: infoKey.icon,
      text: `${infoKey.name} \u043A \u0441\u0442\u0440\u043E\u043A\u0435`,
      click: () => {
        this.selected.disableSelectedMode();
        this.open[infoKey.key] = { pointers: [{ row: pointer.row }] };
      }
    })) : [];
    const contextMenuRowOrCell = this.getContextMenuRowOrCell(pointer);
    const addDivider = () => {
      var _a;
      if (result.length === 0 || ((_a = lastOrDefault(result)) == null ? void 0 : _a.divider)) {
        return;
      }
      result.push({ divider: true });
    };
    const addOptions = (...options) => {
      result.push(...options.filter(Boolean));
    };
    addOptions(...infoRowOptions);
    addDivider();
    addOptions(...infoCellOptions);
    addDivider();
    addOptions({
      icon: ICONS.copyBlue,
      text: "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C",
      rightText: "CTRL+C",
      click: async () => {
        await this.tableComponent.copyCurrentSelected();
        await this.tableComponent.focusTable();
      }
    });
    if (this.getEdit("edit")) {
      addOptions({
        icon: ICONS.plusBlue,
        text: "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C",
        rightText: "CTRL+V",
        click: async () => {
          await this.tableComponent.pasteCurrentSelected(true);
        }
      });
      addOptions({
        icon: ICONS.insertTableBlue,
        text: "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0435 \u044F\u0447\u0435\u0439\u043A\u0438",
        click: async () => {
          await this.tableComponent.pasteCurrentSelected(false);
        }
      });
    }
    addDivider();
    addOptions(...contextMenuRowOrCell);
    addDivider();
    if (this.getEdit("edit") && !isOnlyCell) {
      addOptions({
        icon: ICONS.calculatorVariantOutline,
        text: "\u0421\u0443\u043C\u043C\u0430 \u043F\u043E \u0432\u044B\u0434\u0435\u043B\u0435\u043D\u0438\u044E \u044F\u0447\u0435\u0435\u043A",
        click: () => {
          const sum = toNumberOrDefault(
            this.getSelectedCells().reduce((allSum, tableRow) => {
              return tableRow.reduce((allSum2, selectedCell) => {
                return allSum2 + toNumberOrDefault(
                  getExponential(void 0, selectedCell.data.value).value
                );
              }, allSum);
            }, 0)
          );
          this.confirmation.setConfirmation({
            title: "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442 \u0441\u0443\u043C\u043C\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F",
            message: `${sum}`,
            buttons: {
              success: { title: "\u0421\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C" }
            },
            success: async () => {
              await copyToClipboard(`${sum}`);
              await this.tableComponent.focusTable();
            },
            cancel: () => {
              this.tableComponent.focusTable();
            }
          });
        }
      });
    }
    if (isOnlyCell) {
      addOptions({
        icon: ICONS.plusBlue,
        text: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0444\u0438\u043B\u044C\u0442\u0440",
        click: () => {
          var _a;
          const model = this.getModelOrUndefined(pointer == null ? void 0 : pointer.col_name);
          const value = (_a = this.getCellData(pointer)) == null ? void 0 : _a.value;
          this.addEmptyFilter(model, value);
        }
      });
    }
    return result;
  }
  getContextMenuHeader(model) {
    return [
      {
        icon: ICONS.eyeOff,
        text: "\u0412\u0438\u0434\u0438\u043C\u043E\u0441\u0442\u044C \u0441\u0442\u043E\u043B\u0431\u0446\u043E\u0432",
        click: () => {
          this.open.visibilityColumns = true;
        }
      },
      model ? {
        icon: ICONS.plus,
        text: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0444\u0438\u043B\u044C\u0442\u0440",
        click: () => {
          this.addEmptyFilter(model);
        }
      } : void 0,
      {
        icon: ICONS.restore,
        text: "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C \u0444\u0438\u043B\u044C\u0442\u0440\u044B",
        click: () => {
          this.resetInitialFilters();
        }
      }
    ].filter(Boolean);
  }
  addEmptyFilter(model, comparisonValue) {
    const filter = PanelFiltersFactory.getInitialDataItem();
    filter.autofocus = true;
    if (model) {
      filter.rules.field = model.systemField || model.field;
    }
    if (comparisonValue !== void 0) {
      filter.rules.comparisonValue = comparisonValue;
    }
    this.options.filtersSet.addItem(filter);
    this.options.filtersSet.setOpen(true);
  }
  getContextMenuRowOrCell(pointer) {
    const selectedRowsIndexArray = this.getSelectedRowsIndexArray();
    const isOnlyRow = selectedRowsIndexArray.length === 1;
    return [
      this.getEdit("edit") ? {
        icon: ICONS.trashCanOutline,
        text: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C",
        rightText: "DEL",
        click: () => {
          this.clearCurrentSelected();
          this.tableComponent.focusTable();
        }
      } : null,
      this.isAllowRowDelete ? {
        icon: ICONS.trashCanOutline,
        text: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C",
        rightText: "CTRL+DEL",
        click: () => {
          this.onRowDelete(this.getSelectedCellsPointers());
        }
      } : null,
      this.isAllowRowDelete && this.isAllowRowCreate ? { divider: true } : null,
      this.isAllowRowCreate && isOnlyRow ? {
        icon: ICONS.arrowUpOutlineBlue,
        text: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0441\u0442\u0440\u043E\u043A\u0443 \u0432\u044B\u0448\u0435",
        rightText: "INS",
        click: () => {
          this.tableComponent.$emit(
            "row-insert",
            TableRow.getEmptyChange(this, pointer)
          );
        }
      } : void 0,
      this.isAllowRowCreate && isOnlyRow ? {
        icon: ICONS.arrowDownOutlineBlue,
        text: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0441\u0442\u0440\u043E\u043A\u0443 \u043D\u0438\u0436\u0435",
        click: () => {
          this.tableComponent.$emit(
            "row-insert",
            TableRow.getEmptyChange(this, {
              row: pointer.row + 1
            })
          );
        }
      } : void 0,
      this.isAllowRowCreate && isOnlyRow ? {
        icon: ICONS.nBlue,
        text: "\u0414\u0443\u0431\u043B\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0441\u0442\u0440\u043E\u043A\u0443 N \u0440\u0430\u0437",
        click: async () => {
          const context = {
            caption: "\u0421\u043A\u043E\u043B\u044C\u043A\u043E \u0440\u0430\u0437 \u0434\u0443\u0431\u043B\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0441\u0442\u0440\u043E\u043A\u0443?",
            confirm: {
              caption: "\u0414\u0443\u0431\u043B\u0438\u0440\u043E\u0432\u0430\u0442\u044C"
            }
          };
          const newValue = await TDynamicModalService.show(TableEnterInput, context);
          const count = toNumberOrUndefined(newValue);
          if (isNullOrUndefined(count) || count < 1) {
            return;
          }
          for (let i = 0; i < count; i++) {
            this.emitRowDuplicate(pointer);
          }
        }
      } : void 0
    ].filter(Boolean);
  }
  getContextMenuRow(pointer) {
    const contextMenuRowOrCell = this.getContextMenuRowOrCell(pointer);
    const selectedRowsIndexArray = this.getSelectedRowsIndexArray();
    return [
      this.getEdit("comment") && selectedRowsIndexArray.length === 1 ? {
        icon: { src: "/interface/chat-circle.svg" },
        text: "\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439 \u043A \u0441\u0442\u0440\u043E\u043A\u0435",
        click: () => {
          this.selected.disableSelectedMode();
          this.open.comment = { pointers: [pointer] };
        }
      } : null,
      this.getEdit("comment") && contextMenuRowOrCell.length ? { divider: true } : null,
      ...contextMenuRowOrCell
    ].filter(Boolean);
  }
  getTableCell(pointer) {
    return getCellData(this, pointer);
  }
  getSelectedCellsPointers() {
    return this.selectedCellsPointersUnref;
  }
  getSelectedCells() {
    const { cursor, start, isSelectedMode } = this.selected;
    if (!isSelectedMode || !start || !cursor) {
      if (cursor) {
        const data = this.getTableCell(cursor);
        if (!data) {
          throw new Error(`cellData not found`);
        }
        const model = this.getModelOrUndefined(cursor.col_name);
        if (!model) {
          throw new Error(`model col_name: ${cursor.col_name} not found`);
        }
        const selectedCell = {
          field: model.field,
          data
        };
        return [[selectedCell]];
      }
      return [];
    }
    const minMaxCell = getMinMaxCellPointer(start, cursor, "visual_row");
    const cells = [];
    for (let visual_row = minMaxCell.minRow; visual_row <= minMaxCell.maxRow; visual_row++) {
      const currentRow = [];
      const tableRow = this.getRowByVisualRow(visual_row);
      if (!(tableRow == null ? void 0 : tableRow.show) || tableRow.group) {
        continue;
      }
      for (let col = minMaxCell.minCol; col <= minMaxCell.maxCol; col++) {
        const model = this.getModelOrUndefined(col);
        if (!model) {
          throw new Error(`model col: ${col} not found`);
        }
        const data = this.getTableCell(
          PointerHelper.getRequired(this, {
            visual_row,
            col_name: model.field
          })
        );
        if (!data) {
          throw new Error(`data col: ${col} not found`);
        }
        currentRow.push({
          field: model.field,
          data
        });
      }
      cells.push(currentRow);
    }
    return cells;
  }
  getSelectedRowsData(useOriginal = false) {
    const selectedRows = this.rows.filter((x) => x.select).map((rowObj) => rowObj.row);
    return selectedRows.map((row) => {
      const rowObj = this.getRowOrUndefined(row);
      if (!rowObj) {
        return {};
      }
      return useOriginal ? rowObj.original : TableRow.getValue(rowObj);
    });
  }
  getSelectedRowsIndexArray() {
    return uniqBy(this.getSelectedCellsPointers(), (x) => x.row).map(
      (x) => x.row
    );
  }
  getSelectedRows() {
    const selectedRowsIndexArray = this.getSelectedRowsIndexArray();
    return selectedRowsIndexArray.map((row) => {
      const rowObj = this.getRowOrUndefined(row);
      if (!rowObj) {
        return {
          attrs: {},
          original: void 0
        };
      }
      return {
        attrs: TableRow.getValue(rowObj),
        original: rowObj.original
      };
    });
  }
  async getStringFromSelectedCells(cells) {
    let value = "";
    for (let iCell = 0; iCell < cells.length; iCell++) {
      const rowCells = cells[iCell];
      for (let iRow = 0; iRow < rowCells.length; iRow++) {
        const selectedCell = rowCells[iRow];
        const col = this.getColIndex(selectedCell.field);
        const tab = `${rowCells.length - 1 === iRow ? "" : "	"}`;
        const model = this.getModelOrUndefined(col);
        if (!model) {
          Logger$1.warn(`Not found model by col: ${col}.`);
          continue;
        }
        const copyValue = await TableCell.getCopyValue(
          selectedCell.data.value,
          this,
          model
        );
        value += `${copyValue}${tab}`;
      }
      value += "\r\n";
    }
    return value;
  }
  async getStringSelectedCells(cells) {
    if (!cells) {
      return "";
    }
    return await this.getStringFromSelectedCells(cells);
  }
  getContext(opts = {}) {
    var _a;
    const data = (_a = opts.data) != null ? _a : {};
    const pointer = opts.pointer;
    const value = opts.value;
    const selected_row = this.getRowValue(pointer == null ? void 0 : pointer.row);
    let selected_cell;
    if (pointer && "col_name" in pointer && selected_row) {
      if (!isNullOrUndefined(value)) {
        selected_row[pointer.col_name] = value;
      }
      selected_cell = {
        field: pointer.col_name,
        value: selected_row[pointer.col_name]
      };
    }
    return {
      ...data,
      selected_table_cells: this.getSelectedCellsPointers().map((pointer2) => {
        return {
          pointer: PointerHelper.getServerFormat(pointer2),
          data: copy(this.getTableCell(pointer2))
        };
      }),
      selected_rows: this.rows.filter((x) => x.select).map((x) => x.row),
      cursor: PointerHelper.getServerFormat(this.selected.cursor),
      selected_row,
      selected_cell
    };
  }
  updateGlobalContext() {
    const tableDataSet = this;
    GlobalContext.setAssign({
      get selected_cell() {
        if (tableDataSet.isDestroyed) {
          return void 0;
        }
        return tableDataSet.getSelectedCell();
      },
      get selected_row() {
        if (tableDataSet.isDestroyed) {
          return void 0;
        }
        return tableDataSet.getSelectedRowValue();
      },
      get selected_rows() {
        if (tableDataSet.isDestroyed) {
          return void 0;
        }
        return tableDataSet.getSelectedRowsData();
      }
    });
  }
  getSelectedCell() {
    var _a;
    const pointer = this.selected.cursor;
    const rowObj = this.getRowOrUndefined(pointer == null ? void 0 : pointer.row);
    return pointer ? {
      field: pointer.col_name,
      value: (_a = rowObj == null ? void 0 : rowObj.cells[pointer.col_name].value) != null ? _a : ""
    } : void 0;
  }
  getSelectedRowValue() {
    const rowObj = this.getSelectedRow();
    return rowObj ? TableRow.getValue(rowObj) : void 0;
  }
  getAllCellChangesKeys() {
    return ["value", ...this.info.keysEditable];
  }
  getFilterLogicalObj() {
    if (this.initialFilters.length === 0) {
      return void 0;
    }
    return FilterFactory.createLogical(
      "and",
      this.initialFilters.map((x) => x.filter)
    );
  }
  getSort() {
    if (!this.sort.sort || !this.sort.model) {
      return void 0;
    }
    return [
      SortFactory.createSort(
        this.sort.model.systemField || this.sort.model.field,
        this.sort.sort
      )
    ];
  }
  getMinRowHeight() {
    var _a, _b, _c;
    let minHeight;
    if (this.wordWrap) {
      minHeight = (_b = minBy(
        (_a = this.getRowsElements()) != null ? _a : [],
        (e) => e.clientHeight
      )) == null ? void 0 : _b.clientHeight;
    } else {
      minHeight = (_c = this.getFirstRowEl()) == null ? void 0 : _c.clientHeight;
    }
    return minHeight != null ? minHeight : 44;
  }
  enableVirtualScroll(force) {
    if (this.virtualScroll) {
      return;
    }
    if (force || this.rows.length >= this.virtualScrollMinLength) {
      this.virtualScroll = new TableVirtualScroll({
        getItemHeight: () => {
          return this.getMinRowHeight();
        },
        getHeight: () => {
          const containerEl = this.getContainerEl();
          if (!containerEl) {
            return window.innerHeight;
          }
          return containerEl.scrollHeight;
        },
        getCountAll: () => {
          return this.visibleRows.length;
        },
        getMinLength: () => {
          return this.virtualScrollMinLength;
        }
      });
    }
  }
  async waitChanges() {
    while (this.repository.queue.length > 0) {
      await sleep(100);
    }
    return this;
  }
  addTableRow(row, tableRow) {
    this.rowsSplice(row, 0, tableRow);
    const fields = this.modelUnref.map((x) => x.field);
    this.info.insertRow(this.rows.length, row, 1, fields);
    this.updateIndexRows(row);
    this.updateVisualIndexes(this.visibleRows);
    if (isDev) {
      if (tableRow.row !== row) {
        Logger$1.warn("tableRow.row !== row", {
          tableRow,
          row
        });
      }
    }
  }
}
function queueIsDeleteRows(queue) {
  return queue.type === "delete_rows";
}
function queueIsChangeCells(queue) {
  return queue.type === "change_cells";
}
function queueIsChangeRows(queue) {
  return queue.type === "change_rows";
}
function queueIsAddRow(queue) {
  return queue.type === "add_row";
}
function combineQueue(queue) {
  if (queueIsChangeCells(queue[0])) {
    const queueOnly = {
      type: "change_cells",
      data: {
        table_cells: queue.flatMap((x) => x.data.table_cells)
      },
      changeEvents: TableChangeEvents.merge(queue.map((x) => x.changeEvents))
    };
    return [queueOnly];
  }
  if (queueIsDeleteRows(queue[0])) {
    const pointers = [];
    queue.forEach((x) => {
      pointers.push(...x.data.pointers);
    });
    return [
      {
        type: "delete_rows",
        data: { pointers }
      }
    ];
  }
  return queue;
}
class TableDefaultRepository {
  constructor() {
    this.subjectExecuteResult = new Subject();
    this.intervals = [];
    this._executeFree = true;
    this._lastError = false;
    this.queue = [];
    this._bufferingData = void 0;
  }
  runSaveInterval(tableDataSet) {
    this.intervals.push(
      setInterval(async () => {
        if (this.queue.length === 0 || !this._executeFree) {
          return;
        }
        this._executeFree = false;
        const task = this.queue[0];
        try {
          await this.execute(tableDataSet, task);
          this.queue.shift();
          this._lastError = false;
        } catch (e) {
          const error = await ApiHelper.getError(e);
          if (error.type === "PermissionDeniedException") {
            NotificationsService$1.send({
              type: "error",
              title: `\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0438 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0439 \u0432 \u0444\u043E\u0440\u043C\u0435. \u0414\u0430\u043B\u044C\u043D\u0435\u0439\u0448\u0435\u0435 \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0437\u0430\u043F\u0440\u0435\u0449\u0435\u043D\u043E.`,
              text: error.getMessage()
            });
            await tableDataSet.changes.cancelQueueChanges(tableDataSet);
            tableDataSet.setEditMode({});
            return;
          }
          if (error.value.not_repeat) {
            NotificationsService$1.send({
              type: "error",
              title: `\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0438 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0439 \u0432 \u0444\u043E\u0440\u043C\u0435. \u041D\u0435\u0441\u043E\u0445\u0440\u0430\u043D\u0451\u043D\u043D\u044B\u0435 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u043E\u0442\u043C\u0435\u043D\u0435\u043D\u044B.`,
              text: error.getMessage()
            });
            await tableDataSet.changes.cancelQueueChanges(tableDataSet);
            return;
          }
          this._lastError = true;
          await sleep(2e3);
        }
        this._executeFree = true;
      }, 100)
    );
  }
  destroy() {
    this.intervals.forEach((x) => clearInterval(x));
  }
  async execute(tableDataSet, queueOnly) {
    if (!tableDataSet.options.form_id) {
      Logger$1.warn("execute: form_id undefined");
      return;
    }
    const result = await ApiService$1.postForm(
      queueOnly.type,
      tableDataSet.options.form_id,
      tableDataSet.tableName,
      queueOnly.data
    );
    if (result.json) {
      this.subjectExecuteResult.next(result.json);
    }
    return result;
  }
  queuePush(queueOnly, isBuffer = false) {
    if (this._bufferingData !== void 0 && !isBuffer) {
      this._bufferingData.push(queueOnly);
      return;
    }
    this.queue.push(queueOnly);
  }
  clearAll() {
    while (this.queue.length) {
      this.queue.shift();
    }
  }
  addRow({ changeEvents, tableDataSet }, rowChange) {
    const queueOnly = {
      type: "add_row",
      data: {
        pointer: {
          row: rowChange.row
        },
        table_row: TableRow.getRepositoryFormat(rowChange.data),
        row_cells: rowChange.changeCells.map((changeCellAndPointer) => {
          return TableCell.getRepositoryTableCellAndPointerFormatByChangeCellAndPointer(
            changeCellAndPointer
          );
        })
      },
      changeEvents
    };
    this.queuePush(queueOnly);
  }
  changeTableCells({ changeEvents, tableDataSet }, table_cells) {
    const queueOnly = {
      type: "change_cells",
      data: {
        table_cells: table_cells.map(
          (x) => TableCell.getRepositoryTableCellAndPointerFormatByChangeCellAndPointer(
            x
          )
        )
      },
      changeEvents
    };
    this.queuePush(queueOnly);
  }
  changeTableRows({ changeEvents, tableDataSet }, table_rows) {
    this.queuePush({
      type: "change_rows",
      data: {
        table_rows
      },
      changeEvents
    });
  }
  deleteRow({ changeEvents, tableDataSet }, pointersAndRows) {
    const queueOnly = {
      type: "delete_rows",
      data: {
        pointers: pointersAndRows.map((x) => x.pointer)
      },
      changeEvents
    };
    this.queuePush(queueOnly);
  }
  moveRow({ changeEvents, tableDataSet }, pointer, move_mode) {
    const queueOnly = {
      type: "move_row",
      data: {
        pointer: { row: pointer.row },
        move_mode
      },
      changeEvents
    };
    this.queuePush(queueOnly);
  }
  updateRowIndexes({ changeEvents, tableDataSet }, indexes) {
    const queueOnly = {
      type: "update_row_indexes",
      data: {
        indexes
      },
      changeEvents
    };
    this.queuePush(queueOnly);
  }
  combineQueue(queue) {
    return combineQueue(queue);
  }
  startBuffering() {
    this._bufferingData = [];
  }
  finishBuffering() {
    if (this._bufferingData === void 0) {
      return;
    }
    const queue = [];
    let changeCells = [];
    let changeRows = [];
    let deleteRows = [];
    const addSpecTasks = () => {
      if (changeCells.length > 0) {
        queue.push(...this.combineQueue(changeCells));
        changeCells = [];
      }
      if (changeRows.length > 0) {
        queue.push(...this.combineQueue(changeRows));
        changeRows = [];
      }
      if (deleteRows.length > 0) {
        queue.push(...this.combineQueue(deleteRows));
        deleteRows = [];
      }
    };
    this._bufferingData.forEach((bufferQueue) => {
      if (queueIsChangeCells(bufferQueue)) {
        changeCells.push(bufferQueue);
        return;
      }
      if (queueIsChangeRows(bufferQueue)) {
        changeRows.push(bufferQueue);
        return;
      }
      if (queueIsDeleteRows(bufferQueue)) {
        deleteRows.push(bufferQueue);
        return;
      }
      addSpecTasks();
      queue.push(bufferQueue);
    });
    addSpecTasks();
    queue.forEach((x) => this.queuePush(x, true));
    this._bufferingData = void 0;
  }
}
const _sfc_main$1t = defineComponent({
  name: "ButtonIconComponent",
  props: {
    icon: {
      type: Object,
      required: false
    },
    iconStyle: {
      type: TVuePropTypes.style,
      required: false,
      default: () => ({})
    },
    iconClass: {
      type: String,
      required: false
    },
    iconRotate180: {
      type: Boolean,
      default: false
    },
    isIconRight: {
      type: Boolean,
      default: false
    },
    hasContent: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    boolToString
  }
});
const _hoisted_1$1e = ["alt", "data-rotate180", "src"];
function _sfc_render$1t(_ctx, _cache, $props, $setup, $data, $options) {
  return !_ctx.isIconRight && _ctx.icon ? (openBlock(), createElementBlock("img", {
    key: 0,
    alt: _ctx.icon.alt,
    class: normalizeClass(["button-component-icon", _ctx.iconClass]),
    "data-rotate180": _ctx.boolToString(_ctx.iconRotate180),
    src: _ctx.icon.src,
    style: normalizeStyle([{ marginRight: _ctx.hasContent ? "4px" : void 0 }, _ctx.iconStyle])
  }, null, 14, _hoisted_1$1e)) : createCommentVNode("", true);
}
var ButtonIconComponent = /* @__PURE__ */ _export_sfc(_sfc_main$1t, [["render", _sfc_render$1t]]);
var ButtonComponent_vue_vue_type_style_index_0_lang = "";
const _sfc_main$1s = defineComponent({
  name: "ButtonComponent",
  components: { ButtonIconComponent },
  props: {
    class: {
      required: false
    },
    icon: {
      type: Object,
      required: false
    },
    iconStyle: {
      type: TVuePropTypes.style,
      required: false,
      default: () => ({})
    },
    iconClass: {
      type: String,
      required: false
    },
    iconRotate180: {
      type: Boolean,
      default: false
    },
    isIconRight: {
      type: Boolean,
      default: false
    },
    tabindex: {
      required: false
    }
  },
  setup() {
    return {
      boolToString
    };
  },
  computed: {
    hasContent() {
      return !!this.$slots.default;
    }
  },
  methods: {}
});
const _hoisted_1$1d = ["data-icon-rotate180", "tabindex"];
function _sfc_render$1s(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ButtonIconComponent = resolveComponent("ButtonIconComponent");
  return openBlock(), createElementBlock("button", {
    class: normalizeClass(this.class),
    "data-icon-rotate180": _ctx.iconRotate180 ? "true" : void 0,
    tabindex: _ctx.tabindex
  }, [
    !_ctx.isIconRight && _ctx.icon ? (openBlock(), createBlock(_component_ButtonIconComponent, {
      key: 0,
      "has-content": _ctx.hasContent,
      icon: _ctx.icon,
      "icon-class": _ctx.iconClass,
      "icon-rotate180": _ctx.iconRotate180,
      "icon-style": _ctx.iconStyle
    }, null, 8, ["has-content", "icon", "icon-class", "icon-rotate180", "icon-style"])) : createCommentVNode("", true),
    renderSlot(_ctx.$slots, "default"),
    _ctx.isIconRight && _ctx.icon ? (openBlock(), createBlock(_component_ButtonIconComponent, {
      key: 1,
      "has-content": _ctx.hasContent,
      icon: _ctx.icon,
      "icon-class": _ctx.iconClass,
      "icon-rotate180": _ctx.iconRotate180,
      "icon-style": _ctx.iconStyle
    }, null, 8, ["has-content", "icon", "icon-class", "icon-rotate180", "icon-style"])) : createCommentVNode("", true)
  ], 10, _hoisted_1$1d);
}
var ButtonComponent = /* @__PURE__ */ _export_sfc(_sfc_main$1s, [["render", _sfc_render$1s]]);
var ModalComponent_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$1r = defineComponent({
  name: "ModalComponent",
  components: { ButtonComponent },
  emits: [
    "close",
    "content-on-key-down"
  ],
  props: {
    visible: {
      type: Boolean,
      required: false
    },
    title: {
      type: String,
      required: false
    },
    style: {
      type: TVuePropTypes.style,
      required: false
    },
    contentStyle: {
      type: TVuePropTypes.style,
      required: false
    },
    bodyStyle: {
      type: TVuePropTypes.style,
      required: false
    },
    isShowBodyCloseButton: {
      type: Boolean,
      default: false
    },
    buttonCloseStyle: TVuePropTypes.style,
    autofocus: {
      type: Boolean,
      default: true
    }
  },
  setup() {
    return {
      ICONS
    };
  },
  mounted() {
    this.onAutoFocus();
  },
  computed: {
    buttonCloseStyleComputed() {
      return ["position: absolute; right: 25px; top: 25px", this.buttonCloseStyle].filter(Boolean);
    }
  },
  methods: {
    onAutoFocus() {
      if (this.autofocus) {
        this.focusContent();
      }
    },
    focusContent() {
      this.$nextTick(() => {
        if (this.visible) {
          this.$refs.content.focus();
        }
      });
    },
    close() {
      this.$emit("close");
    },
    onKeyDown(event) {
      if (event.code === "Escape") {
        this.close();
        return;
      }
      this.$emit("content-on-key-down", event);
    },
    onMouseDownOutside(event) {
      if (event.clientX + 22 > document.body.clientWidth) {
        return;
      }
      this.$emit("close");
    }
  },
  watch: {
    visible() {
      this.onAutoFocus();
    }
  }
});
const _hoisted_1$1c = {
  key: 0,
  class: "modal-header"
};
const _hoisted_2$Z = { class: "modal-title" };
function _sfc_render$1r(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ButtonComponent = resolveComponent("ButtonComponent");
  return openBlock(), createBlock(Teleport, { to: "#modals" }, [
    withDirectives(createElementVNode("div", {
      class: "modal",
      onMousedown: _cache[3] || (_cache[3] = withModifiers((...args) => _ctx.onMouseDownOutside && _ctx.onMouseDownOutside(...args), ["stop", "prevent"])),
      onScroll: _cache[4] || (_cache[4] = withModifiers(() => {
      }, ["prevent", "stop"]))
    }, [
      createElementVNode("div", {
        style: normalizeStyle(_ctx.style),
        class: "modal-dialog"
      }, [
        createElementVNode("div", {
          ref: "content",
          style: normalizeStyle(_ctx.contentStyle),
          class: "modal-content",
          tabindex: "0",
          onKeydown: _cache[1] || (_cache[1] = withModifiers((...args) => _ctx.onKeyDown && _ctx.onKeyDown(...args), ["stop"])),
          onMousedown: _cache[2] || (_cache[2] = withModifiers(() => {
          }, ["stop"]))
        }, [
          _ctx.title ? (openBlock(), createElementBlock("div", _hoisted_1$1c, [
            createElementVNode("h3", _hoisted_2$Z, toDisplayString(_ctx.title), 1),
            createElementVNode("button", {
              class: "close",
              onClick: _cache[0] || (_cache[0] = (...args) => _ctx.close && _ctx.close(...args))
            }, "\xD7")
          ])) : createCommentVNode("", true),
          createElementVNode("div", {
            style: normalizeStyle(_ctx.bodyStyle),
            class: "modal-body"
          }, [
            _ctx.isShowBodyCloseButton ? (openBlock(), createBlock(_component_ButtonComponent, {
              key: 0,
              icon: _ctx.ICONS.closeBlue,
              class: "button-close",
              style: normalizeStyle(_ctx.buttonCloseStyleComputed),
              onClick: _ctx.close
            }, null, 8, ["icon", "style", "onClick"])) : createCommentVNode("", true),
            renderSlot(_ctx.$slots, "body", { close: _ctx.close }, void 0, true)
          ], 4)
        ], 36)
      ], 4)
    ], 544), [
      [vShow, _ctx.visible]
    ])
  ]);
}
var ModalComponent = /* @__PURE__ */ _export_sfc(_sfc_main$1r, [["render", _sfc_render$1r], ["__scopeId", "data-v-945815ca"]]);
var TableHelp_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$1q = defineComponent({
  name: "TableHelp",
  props: {
    modelValue: Array
  },
  data() {
    return {};
  }
});
const _withScopeId$j = (n) => (pushScopeId("data-v-9974929e"), n = n(), popScopeId(), n);
const _hoisted_1$1b = { class: "table-help" };
const _hoisted_2$Y = /* @__PURE__ */ _withScopeId$j(() => /* @__PURE__ */ createElementVNode("thead", null, [
  /* @__PURE__ */ createElementVNode("tr", null, [
    /* @__PURE__ */ createElementVNode("th", null, "\u041A\u043E\u043C\u0431\u0438\u043D\u0430\u0446\u0438\u044F \u043A\u043B\u0430\u0432\u0438\u0448"),
    /* @__PURE__ */ createElementVNode("th", null, "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F")
  ])
], -1));
const _hoisted_3$Q = { style: { "text-align": "end" } };
function _sfc_render$1q(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$1b, [
    createElementVNode("table", null, [
      _hoisted_2$Y,
      createElementVNode("tbody", null, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.modelValue, (k) => {
          return openBlock(), createElementBlock("tr", {
            key: k.key
          }, [
            createElementVNode("td", _hoisted_3$Q, toDisplayString(k.key), 1),
            createElementVNode("td", null, toDisplayString(k.text), 1)
          ]);
        }), 128))
      ])
    ])
  ]);
}
var TableHelp = /* @__PURE__ */ _export_sfc(_sfc_main$1q, [["render", _sfc_render$1q], ["__scopeId", "data-v-9974929e"]]);
function stringToFormInfoDataDto(text, pointer) {
  if (text.trim() === "") {
    return void 0;
  }
  return {
    value: { text },
    pointer
  };
}
var TablePasteNote_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$1p = defineComponent({
  name: "TablePasteNote",
  emits: ["close", "update:cell"],
  props: {
    tableDataSet: {
      type: Object,
      required: true
    },
    pointers: {
      type: Array,
      required: true
    },
    modeField: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      newValue: ""
    };
  },
  mounted() {
    var _a;
    setTimeout(() => {
      this.focusTextArea();
    });
    this.newValue = ((_a = this.tableDataSet.info.getByPointer(
      this.modeField,
      firstOrDefault(this.pointers)
    )) == null ? void 0 : _a.value.text) || "";
  },
  methods: {
    focusContainer() {
      this.$nextTick(() => {
        var _a;
        (_a = this.$refs.container) == null ? void 0 : _a.focus();
      });
    },
    focusTextArea() {
      this.$nextTick(() => {
        var _a;
        (_a = this.$refs.textarea) == null ? void 0 : _a.focus();
      });
    },
    onSave() {
      const firstPointer = firstOrDefault(this.pointers);
      if (PointerHelper.isRowPointer(firstPointer)) {
        const updates = [];
        for (const pointer of this.pointers) {
          const update = this.tableDataSet.getEmitUpdateRow({
            newValue: {
              [this.modeField]: stringToFormInfoDataDto(this.newValue, pointer)
            },
            pointer,
            changes: [this.modeField]
          });
          updates.push(update);
        }
        this.tableDataSet.updateRows(updates);
        this.$emit("close");
        return;
      }
      if (typeof firstPointer !== "object") {
        NotificationsService$1.send({
          type: "error",
          title: "\u041E\u0448\u0438\u0431\u043A\u0430",
          text: "\u041D\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0443\u043A\u0430\u0437\u0430\u0442\u0435\u043B\u044C \u043D\u0430 \u044F\u0447\u0435\u0439\u043A\u0443."
        });
        return;
      }
      if (PointerHelper.isCellPointer(firstPointer)) {
        const updates = [];
        this.pointers.forEach((pointer) => {
          const update = this.tableDataSet.getEmitUpdateCell({
            newValue: {
              value: void 0,
              info: {
                [this.modeField]: stringToFormInfoDataDto(
                  this.newValue,
                  pointer
                )
              }
            },
            pointer,
            changes: [this.modeField]
          });
          updates.push(update);
        });
        this.tableDataSet.updateCells(updates);
      }
      this.$emit("close");
    },
    onKeyDown(event) {
      const eventHelper = new KeyboardEventHelper(event);
      if (eventHelper.keyEscape.isAllTrue) {
        return;
      }
      if (eventHelper.keyEnter.isAllTrue && eventHelper.pressShift.isAllFalse) {
        this.onSave();
      }
      event.stopPropagation();
    }
  }
});
const _hoisted_1$1a = ["disabled"];
function _sfc_render$1p(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    ref: "container",
    class: "form-container",
    onKeydown: _cache[2] || (_cache[2] = (...args) => _ctx.onKeyDown && _ctx.onKeyDown(...args))
  }, [
    withDirectives(createElementVNode("textarea", {
      ref: "textarea",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.newValue = $event),
      class: "textarea"
    }, null, 512), [
      [vModelText, _ctx.newValue]
    ]),
    createElementVNode("button", {
      disabled: !_ctx.tableDataSet.getEdit(_ctx.modeField),
      class: "form-button",
      "data-type": "accent",
      onClick: _cache[1] || (_cache[1] = (...args) => _ctx.onSave && _ctx.onSave(...args))
    }, " \u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C ", 8, _hoisted_1$1a)
  ], 544);
}
var TablePasteNote = /* @__PURE__ */ _export_sfc(_sfc_main$1p, [["render", _sfc_render$1p], ["__scopeId", "data-v-418238fa"]]);
var TableFooter_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$1o = defineComponent({
  name: "TableFooter",
  components: {
    ButtonComponent
  },
  emits: [],
  props: {
    tableDataSet: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      edit: false
    };
  },
  mounted() {
    this.edit = this.tableDataSet.getEdit("edit");
    watch(
      () => this.edit,
      () => {
        const editMode = this.edit !== void 0 ? {
          edit: this.edit,
          comment: this.edit,
          hint: this.edit,
          remark: this.edit,
          rowCreate: this.edit,
          rowDelete: this.edit,
          rowMove: this.edit,
          warning: this.edit
        } : void 0;
        this.tableDataSet.options.editModePriority = editMode;
      }
    );
  },
  watch: {},
  methods: {
    async onFormValidate() {
      if (!this.tableDataSet.options.form_id) {
        Logger$1.warn("onFormValidate: form_id undefined");
        return;
      }
      try {
        const errors = (await ApiService$1.formValidate(this.tableDataSet.options.form_id)).json;
        this.tableDataSet.info.clearByDataKey("error");
        this.tableDataSet.info.setInfoArray(
          "error",
          errors[this.tableDataSet.tableName] || []
        );
        const count = Object.keys(
          this.tableDataSet.info.dataSet.getByDataKey("error")
        ).length;
        const title = "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442 \u0432\u0430\u043B\u0438\u0434\u0430\u0446\u0438\u0438 \u043E\u0442\u0447\u0451\u0442\u043D\u043E\u0439 \u0444\u043E\u0440\u043C\u044B";
        if (count === 0) {
          NotificationsService$1.send({
            type: "success",
            html: `
          <div style="display: flex; align-items: center;">
            <img src="${ICONS.check.src}" alt="${ICONS.check.alt}" style="margin-right: 5px; width: 24px;">
            <span>\u041E\u0448\u0438\u0431\u043E\u043A \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E</span>
          </div>
          `,
            title
          });
        } else {
          NotificationsService$1.send({
            type: "error",
            html: `
          <div style="display: flex; align-items: center;">
            <img src="${ICONS.error.src}" alt="${ICONS.error.alt}" style="margin-right: 5px; width: 24px;">
            <span>\u041E\u0448\u0438\u0431\u043E\u043A: ${count}</span>
          </div>
          `,
            title
          });
        }
      } catch (e) {
        NotificationsService$1.send({
          type: "error",
          title: "\u041F\u0440\u0438 \u0432\u0430\u043B\u0438\u0434\u0430\u0446\u0438\u0438 \u043E\u0442\u0447\u0451\u0442\u043D\u043E\u0439 \u0444\u043E\u0440\u043C\u044B \u043F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430",
          text: "\u041D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u0430\u044F \u043E\u0448\u0438\u0431\u043A\u0430"
        });
        Logger$1.error({ e });
      }
    }
  }
});
const _withScopeId$i = (n) => (pushScopeId("data-v-758b39e4"), n = n(), popScopeId(), n);
const _hoisted_1$19 = { class: "table-footer" };
const _hoisted_2$X = { class: "table-footer-indicators" };
const _hoisted_3$P = { style: { "display": "flex", "justify-content": "center" } };
const _hoisted_4$G = /* @__PURE__ */ _withScopeId$i(() => /* @__PURE__ */ createElementVNode("span", null, "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435", -1));
const _hoisted_5$u = { style: { "display": "flex", "justify-content": "center" } };
function _sfc_render$1o(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ButtonComponent = resolveComponent("ButtonComponent");
  return openBlock(), createElementBlock("div", _hoisted_1$19, [
    createElementVNode("div", _hoisted_2$X, [
      createElementVNode("div", {
        style: normalizeStyle({
          color: _ctx.tableDataSet.repository.queue.length > 0 ? "#E36464 " : "#707070",
          width: "250px"
        })
      }, [
        _ctx.tableDataSet.repository._lastError ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          createTextVNode(" \u041E\u0448\u0438\u0431\u043A\u0430. \u041F\u043E\u0432\u0442\u043E\u0440\u043D\u0430\u044F \u043F\u043E\u043F\u044B\u0442\u043A\u0430 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F.. ")
        ], 64)) : _ctx.tableDataSet.repository.queue.length > 0 ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
          createTextVNode(toDisplayString(_ctx.tableDataSet.repository.queue.length) + " \u0441\u0435\u0439\u0447\u0430\u0441 \u0441\u043E\u0445\u0440\u0430\u043D\u044F\u0435\u0442\u0441\u044F.. ", 1)
        ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 2 }, [
          createTextVNode(" \u0421\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u043E.")
        ], 64))
      ], 4)
    ]),
    createElementVNode("label", _hoisted_3$P, [
      _hoisted_4$G,
      withDirectives(createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.edit = $event),
        style: { "margin": "0 100px 0 5px" },
        type: "checkbox"
      }, null, 512), [
        [vModelCheckbox, _ctx.edit]
      ])
    ]),
    createElementVNode("label", _hoisted_5$u, [
      createVNode(_component_ButtonComponent, {
        class: "button-opacity",
        style: { "font-size": "13px" },
        onClick: _ctx.onFormValidate
      }, {
        default: withCtx(() => [
          createTextVNode(" \u041F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C ")
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]);
}
var TableFooter = /* @__PURE__ */ _export_sfc(_sfc_main$1o, [["render", _sfc_render$1o], ["__scopeId", "data-v-758b39e4"]]);
var ConfirmationComponent_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$1n = defineComponent({
  name: "ConfirmationComponent",
  emits: ["success", "cancel"],
  props: {
    maxWidth: String,
    title: {
      type: String,
      default: "\u26A0 \u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435"
    },
    message: {
      type: String,
      required: true
    },
    visible: {
      type: Boolean
    },
    buttons: {
      type: Object,
      default: () => copy(DEFAULT_CONFIRMATION_HELPER_BUTTONS)
    }
  },
  components: { ModalComponent },
  methods: {
    onVisibleFocus() {
      if (this.visible) {
        this.$nextTick().then(() => {
          this.$refs.successBtn.focus();
        });
      }
    }
  },
  watch: {
    visible() {
      this.onVisibleFocus();
    }
  },
  created() {
  },
  mounted() {
    this.onVisibleFocus();
  }
});
const _hoisted_1$18 = {
  class: "confirmation-message",
  tabindex: "-1"
};
const _hoisted_2$W = { class: "confirmation-footer" };
function _sfc_render$1n(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ModalComponent = resolveComponent("ModalComponent");
  return openBlock(), createBlock(_component_ModalComponent, {
    autofocus: false,
    style: normalizeStyle({ maxWidth: _ctx.maxWidth || "350px" }),
    title: _ctx.title,
    visible: _ctx.visible,
    onClose: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("cancel"))
  }, {
    body: withCtx(() => [
      createElementVNode("div", _hoisted_1$18, toDisplayString(_ctx.message), 1),
      createElementVNode("div", _hoisted_2$W, [
        createElementVNode("button", {
          ref: "successBtn",
          class: "form-button",
          "data-type": "accent",
          tabindex: "0",
          onClick: _cache[0] || (_cache[0] = withModifiers(($event) => _ctx.$emit("success"), ["stop"]))
        }, toDisplayString(_ctx.buttons.success.title), 513),
        createElementVNode("button", {
          class: "form-button",
          tabindex: "0",
          onClick: _cache[1] || (_cache[1] = withModifiers(($event) => _ctx.$emit("cancel"), ["stop"]))
        }, toDisplayString(_ctx.buttons.cancel.title), 1)
      ])
    ]),
    _: 1
  }, 8, ["style", "title", "visible"]);
}
var ConfirmationComponent = /* @__PURE__ */ _export_sfc(_sfc_main$1n, [["render", _sfc_render$1n], ["__scopeId", "data-v-7fba6dd4"]]);
function getAllowedSide(clientX, clientY, elHeight) {
  const downPx = window.innerHeight - clientY;
  const upPx = window.innerHeight - downPx;
  let side;
  if (downPx > elHeight) {
    side = "bottom";
  } else if (upPx > elHeight) {
    side = "top";
  } else if (elHeight >= window.innerHeight) {
    side = "overflow";
  } else {
    side = "center";
  }
  return {
    side,
    downPx,
    upPx
  };
}
function setAllowedSide(style, side, clientY, elHeight, downPx, upPx) {
  if (side === "bottom") {
    style.top = `${clientY}px`;
  } else if (side === "top") {
    const top = upPx - elHeight;
    style.top = `${top}px`;
  } else if (side === "overflow") {
    style.top = "0px";
    style.overflow = "scroll";
    style.height = "100vh";
  } else {
    const paddingTop = (window.innerHeight - elHeight) / 2;
    style.top = paddingTop + "px";
  }
}
function getSideHorizontal(clientX, elWidth) {
  if (elWidth + clientX >= window.innerWidth) {
    return "right";
  } else {
    return "left";
  }
}
function setAllowedSideAndLeft(style, clientX, clientY, elHeight, elWidth) {
  if (getSideHorizontal(clientX, elWidth) === "right") {
    style.left = clientX - elWidth + "px";
  } else {
    style.left = clientX + "px";
  }
  const { side, downPx, upPx } = getAllowedSide(clientX, clientY, elHeight);
  setAllowedSide(style, side, clientY, elHeight, downPx, upPx);
}
function getClientBySideAndRect(side, targetRect, sideHorizontal) {
  if (side === "bottom") {
    return {
      clientX: targetRect[sideHorizontal],
      clientY: targetRect.bottom
    };
  }
  if (side === "top") {
    return {
      clientX: targetRect[sideHorizontal],
      clientY: targetRect.bottom
    };
  }
}
function isAllowSide(side, targetRect, elHeight, sideHorizontal) {
  const client = getClientBySideAndRect(side, targetRect, sideHorizontal);
  if (!client) {
    return false;
  }
  return getAllowedSide(client.clientX, client.clientY, elHeight).side === side;
}
var TooltipComponent_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$1m = defineComponent({
  name: "TooltipComponent",
  emits: ["hide"],
  props: {
    outsideStyle: {}
  },
  data() {
    return {
      id: "tooltip-" + makeId(10),
      visible: false,
      tooltipContentStyle: {},
      isMounted: false
    };
  },
  mounted() {
    this.isMounted = true;
  },
  methods: {
    show(event, opts = {}) {
      const { target } = opts;
      this.visible = true;
      this.$nextTick(() => {
        let el = document.getElementById(this.id);
        if (!el) {
          throw Error("not found menu container");
        }
        let elHeight = el.offsetHeight;
        let elWidth = el.scrollWidth;
        if (elHeight < 1 || elWidth < 1) {
          el.style.display = "block";
          elHeight = el.offsetHeight;
          elWidth = el.scrollWidth;
        }
        let { clientX, clientY } = event;
        if (target instanceof HTMLElement) {
          const targetRect = target.getBoundingClientRect();
          const checkSide = ["bottom", "top"];
          const sideHorizontal = getSideHorizontal(clientX, elWidth);
          for (const side of checkSide) {
            if (isAllowSide(side, targetRect, elHeight, sideHorizontal)) {
              const client = getClientBySideAndRect(
                side,
                targetRect,
                sideHorizontal
              );
              clientX = client.clientX;
              clientY = client.clientY;
              break;
            }
          }
        }
        setAllowedSideAndLeft(
          this.tooltipContentStyle,
          clientX,
          clientY,
          elHeight,
          elWidth
        );
      });
    },
    hide(emit = false) {
      this.visible = false;
      this.tooltipContentStyle = {};
      if (emit === true) {
        this.$emit("hide");
      }
    }
  }
});
const _hoisted_1$17 = ["id"];
function _sfc_render$1m(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.isMounted ? (openBlock(), createBlock(Teleport, {
    key: 0,
    to: "#modals"
  }, [
    _ctx.visible ? (openBlock(), createElementBlock("div", {
      key: 0,
      style: normalizeStyle(_ctx.outsideStyle),
      class: "tooltip-component-outside"
    }, null, 4)) : createCommentVNode("", true),
    _ctx.visible ? (openBlock(), createElementBlock("div", {
      key: 1,
      class: "tooltip-container",
      onMousedown: [
        _cache[1] || (_cache[1] = withModifiers(($event) => _ctx.hide(true), ["stop", "left"])),
        _cache[2] || (_cache[2] = withModifiers(($event) => _ctx.hide(true), ["prevent", "stop"]))
      ]
    }, [
      createElementVNode("div", {
        id: _ctx.id,
        style: normalizeStyle(_ctx.tooltipContentStyle),
        class: "tooltip-content",
        onMousedown: _cache[0] || (_cache[0] = withModifiers(() => {
        }, ["stop"]))
      }, [
        renderSlot(_ctx.$slots, "default", {}, void 0, true)
      ], 44, _hoisted_1$17)
    ], 32)) : createCommentVNode("", true)
  ])) : createCommentVNode("", true);
}
var TooltipComponent = /* @__PURE__ */ _export_sfc(_sfc_main$1m, [["render", _sfc_render$1m], ["__scopeId", "data-v-43e686a4"]]);
const _sfc_main$1l = defineComponent({
  name: "TableIndicatorsComponent",
  props: {
    classes: {
      type: Object,
      required: true
    },
    tableInfo: {
      type: Object,
      required: true
    },
    pointer: {
      type: Object,
      required: true
    }
  },
  emits: ["open"],
  computed: {
    infoDataComputed() {
      const infoData = this.tableInfo.getAllByPointer(this.pointer);
      return Object.keys(infoData).reduce(
        (value, key) => {
          const infoKey = this.tableInfo.keysDict[key];
          if (!infoKey) {
            Logger$1.warn(`not found key`, key);
            return value;
          }
          const info = infoData[key];
          if (typeof info.pointer !== "object") {
            return value;
          }
          value[key] = {
            info,
            infoKey,
            title: `${infoKey.name}: ${info.value.text}`,
            click: () => this.onOpen(infoKey),
            style: { backgroundColor: infoKey.backgroundColor }
          };
          return value;
        },
        {}
      );
    },
    infoDataLength() {
      return Object.keys(this.infoDataComputed).length;
    }
  },
  methods: {
    onOpen(infoKey) {
      if (infoKey.readonly) {
        return;
      }
      this.$emit("open", {
        key: infoKey.key,
        pointer: this.pointer
      });
    }
  }
});
const _hoisted_1$16 = ["title", "onClick"];
function _sfc_render$1l(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.infoDataLength ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: normalizeClass(_ctx.classes.cellIndicators)
  }, [
    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.infoDataComputed, (infoComputed) => {
      return openBlock(), createElementBlock("div", {
        key: infoComputed.infoKey.key,
        class: normalizeClass(_ctx.classes.cellIndicatorsCircle),
        style: normalizeStyle(infoComputed.style),
        title: infoComputed.title,
        onClick: withModifiers(infoComputed.click, ["stop"])
      }, null, 14, _hoisted_1$16);
    }), 128))
  ], 2)) : createCommentVNode("", true);
}
var TableIndicatorsComponent = /* @__PURE__ */ _export_sfc(_sfc_main$1l, [["render", _sfc_render$1l]]);
const _sfc_main$1k = defineComponent({
  name: "TableRowComponent",
  emits: [
    "click-column-select",
    "show-context-menu",
    "cell-edit-key-down",
    "cell-click",
    "cell-dbl-click",
    "cell-keydown",
    "update:cells",
    "update:rows",
    "open",
    "focus-table",
    "set-current-edit",
    "selected-row",
    "click-group"
  ],
  components: {
    TableIndicatorsComponent,
    CheckboxComponent
  },
  props: {
    tableRow: {
      type: Object,
      required: true
    },
    classes: {
      type: Object,
      default: TABLE_CLASSES
    },
    selectionMode: {
      type: String,
      required: false
    },
    isViewColumnNumber: {
      type: Boolean,
      default: false
    },
    tableRowSlotsRegister: {
      type: Array,
      required: true
    },
    tableId: {
      type: String,
      required: true
    },
    currentEdit: {
      type: Object,
      required: false
    },
    tableSelected: {
      type: TableSelected,
      required: true
    },
    types: {
      type: Object,
      required: true
    },
    uniqueId: {
      type: String,
      required: true
    },
    displayDateFormat: {
      type: String,
      required: false
    },
    cellEditMode: {
      type: Object,
      required: true
    },
    getEdit: {
      type: Function,
      required: true
    },
    displayRowIndex: {
      type: Number,
      required: false
    },
    modelArray: {
      type: Array,
      required: true
    },
    tableInfo: {
      type: TableInfo,
      required: true
    },
    serverDateFormat: {
      type: String,
      default: "YYYY-MM-DD"
    },
    validationHandlers: {
      type: Object,
      required: true
    },
    globalHandlers: { type: Object },
    wordWrap: Boolean
  },
  setup() {
    return {
      TableDataSet,
      TableRow,
      TableCell
    };
  },
  created() {
  },
  watch: {},
  methods: {
    onFocusTable() {
      this.$emit("focus-table");
    },
    onUpdateCell(data) {
      this.$emit("update:cells", [data]);
    },
    onCellEditKeyDown(event) {
      this.$emit("cell-edit-key-down", event);
    },
    onCellClick(event, cellComponent) {
      this.$emit("cell-click", event, cellComponent);
    },
    onShowCellContextMenu(value) {
      this.$emit("show-context-menu", { type: "cell", ...value });
    },
    onShowRowContextMenu(event) {
      this.$emit("show-context-menu", {
        type: "row",
        event,
        pointer: { row: this.tableRow.row }
      });
    },
    onOpen(event) {
      this.$emit("open", event);
    },
    onCellDblClick(event) {
      this.$emit("cell-dbl-click", event);
    },
    onCellKeyDown(event) {
      this.$emit("cell-keydown", event);
    },
    onClickGroup(event) {
      this.$emit("click-group", event);
    }
  },
  computed: {
    systemAttrs() {
      return TableRow.getSystemAttrs(this.tableRow);
    },
    rowComment() {
      return this.tableInfo.dataSet.getByDataKey("comment")[this.rowPointerKey];
    },
    rowPointer() {
      return { row: this.tableRow.row };
    },
    rowPointerKey() {
      return PointerHelper.getKey(this.rowPointer);
    },
    classComputed() {
      return {
        [this.classes.row]: true,
        [this.classes.selectedRow]: this.tableSelected.isSelectedRow(
          this.tableRow.row
        )
      };
    },
    trStyle() {
      var _a, _b;
      return {
        color: (_a = this.systemAttrs) == null ? void 0 : _a.color,
        background: (_b = this.systemAttrs) == null ? void 0 : _b.background
      };
    }
  }
});
function _sfc_render$1k(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CheckboxComponent = resolveComponent("CheckboxComponent");
  const _component_TableIndicatorsComponent = resolveComponent("TableIndicatorsComponent");
  const _component_TableCellComponent = resolveComponent("TableCellComponent");
  return openBlock(), createElementBlock("tr", {
    class: normalizeClass(_ctx.classComputed),
    style: normalizeStyle(_ctx.trStyle),
    onContextmenu: _cache[4] || (_cache[4] = withModifiers((...args) => _ctx.onShowRowContextMenu && _ctx.onShowRowContextMenu(...args), ["stop", "prevent"]))
  }, [
    _ctx.selectionMode === "multiple" ? (openBlock(), createElementBlock("td", {
      key: 0,
      class: normalizeClass([_ctx.classes.cell, _ctx.classes.selectCell]),
      onClick: _cache[0] || (_cache[0] = withModifiers(($event) => _ctx.TableRow.isSelectable(_ctx.tableRow) && _ctx.$emit("click-column-select", _ctx.tableRow), ["stop"]))
    }, [
      createElementVNode("label", {
        class: normalizeClass(_ctx.classes.cellDiv)
      }, [
        createVNode(_component_CheckboxComponent, {
          checked: _ctx.tableRow.select,
          disabled: !_ctx.TableRow.isSelectable(_ctx.tableRow),
          size: `var(${_ctx.classes.cellCheckboxSizeCssVariable}, 24px)`
        }, null, 8, ["checked", "disabled", "size"])
      ], 2)
    ], 2)) : createCommentVNode("", true),
    _ctx.isViewColumnNumber ? (openBlock(), createElementBlock("td", {
      key: 1,
      class: normalizeClass([_ctx.classes.cell, _ctx.classes.numCell]),
      onClick: _cache[2] || (_cache[2] = withModifiers(($event) => _ctx.$emit("selected-row", _ctx.tableRow.row), ["stop"]))
    }, [
      createVNode(_component_TableIndicatorsComponent, {
        classes: _ctx.classes,
        pointer: _ctx.rowPointer,
        "table-info": _ctx.tableInfo,
        onOpen: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("open", $event))
      }, null, 8, ["classes", "pointer", "table-info"]),
      createElementVNode("div", {
        class: normalizeClass(_ctx.classes.cellDiv)
      }, [
        createElementVNode("span", null, toDisplayString(_ctx.displayRowIndex), 1)
      ], 2)
    ], 2)) : createCommentVNode("", true),
    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.modelArray, (modelCell, col) => {
      return openBlock(), createBlock(_component_TableCellComponent, {
        key: modelCell.field,
        id: _ctx.TableDataSet.getCellId(_ctx.tableId, _ctx.tableRow.row, modelCell.field),
        classes: _ctx.classes,
        "col-index": col,
        "current-edit": _ctx.currentEdit,
        data: _ctx.tableRow.cells[modelCell.field],
        "system-attrs": _ctx.TableCell.getSystemAttrs(_ctx.tableRow, modelCell.field),
        "display-date-format": _ctx.displayDateFormat,
        "edit-mode": _ctx.cellEditMode.mode,
        "get-edit": _ctx.getEdit,
        "global-handlers": _ctx.globalHandlers,
        model: modelCell,
        original: _ctx.tableRow.original,
        "row-index": _ctx.tableRow.row,
        "server-date-format": _ctx.serverDateFormat,
        "table-info": _ctx.tableInfo,
        "table-row": _ctx.tableRow,
        "table-selected": _ctx.tableSelected,
        type: _ctx.TableDataSet.getTypeModel(_ctx.types, modelCell),
        types: _ctx.types,
        "unique-id": _ctx.uniqueId,
        "validation-handlers": _ctx.validationHandlers,
        "word-wrap": _ctx.wordWrap,
        onClick: _ctx.onCellClick,
        onOpen: _ctx.onOpen,
        "onUpdate:cell": _ctx.onUpdateCell,
        onCellEditKeyDown: _ctx.onCellEditKeyDown,
        onOpenContextMenu: _ctx.onShowCellContextMenu,
        onDblClick: _ctx.onCellDblClick,
        onKeyDown: _ctx.onCellKeyDown,
        onSetCurrentEdit: _cache[3] || (_cache[3] = ($event) => _ctx.$emit("set-current-edit", $event)),
        onFocusTable: _ctx.onFocusTable,
        onClickGroup: _ctx.onClickGroup
      }, createSlots({ _: 2 }, [
        renderList(_ctx.tableRowSlotsRegister, (slotName) => {
          return {
            name: slotName,
            fn: withCtx((payload) => [
              renderSlot(_ctx.$slots, slotName, normalizeProps(guardReactiveProps(payload)))
            ])
          };
        })
      ]), 1032, ["id", "classes", "col-index", "current-edit", "data", "system-attrs", "display-date-format", "edit-mode", "get-edit", "global-handlers", "model", "original", "row-index", "server-date-format", "table-info", "table-row", "table-selected", "type", "types", "unique-id", "validation-handlers", "word-wrap", "onClick", "onOpen", "onUpdate:cell", "onCellEditKeyDown", "onOpenContextMenu", "onDblClick", "onKeyDown", "onFocusTable", "onClickGroup"]);
    }), 128))
  ], 38);
}
var TableRowComponent = /* @__PURE__ */ _export_sfc(_sfc_main$1k, [["render", _sfc_render$1k]]);
var TableVisibilityColumns_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$1j = defineComponent({
  name: "TableVisibilityColumns",
  components: {
    CheckboxComponent,
    ModalComponent
  },
  props: {
    tableDataSet: {
      type: TableDataSet,
      required: true
    }
  },
  emits: ["close"],
  setup() {
    return {};
  },
  data() {
    return {};
  },
  computed: {
    visibleColumnsCount() {
      return this.tableDataSet.modelUnref.filter((x) => !x.hide).length;
    }
  },
  watch: {},
  created() {
  },
  methods: {
    async setHideByModel(model) {
      if (!model.hide && this.visibleColumnsCount === 1) {
        NotificationsService$1.send({
          type: "error",
          title: "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0441\u043A\u0440\u044B\u0442\u0438\u0438 \u0441\u0442\u043E\u043B\u0431\u0446\u0430",
          text: "\u0417\u0430\u043F\u0440\u0435\u0449\u0435\u043D\u043E \u0441\u043A\u0440\u044B\u0432\u0430\u0442\u044C \u0432\u0441\u0435 \u0441\u0442\u043E\u043B\u0431\u0446\u044B \u043E\u0434\u043D\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E",
          duration: 5e3
        });
        return;
      }
      await this.tableDataSet.setHideColumn(model, !model.hide, false, true);
    }
  }
});
const _hoisted_1$15 = { class: "visibility-column-fields" };
function _sfc_render$1j(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CheckboxComponent = resolveComponent("CheckboxComponent");
  const _component_ModalComponent = resolveComponent("ModalComponent");
  return openBlock(), createBlock(_component_ModalComponent, {
    visible: true,
    "body-style": "padding: 0;",
    style: { "width": "100vw" },
    title: "\u0412\u0438\u0434\u0438\u043C\u043E\u0441\u0442\u044C \u0441\u0442\u043E\u043B\u0431\u0446\u043E\u0432",
    onClose: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("close"))
  }, {
    body: withCtx(({ close }) => [
      createElementVNode("div", _hoisted_1$15, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.tableDataSet.modelUnref, (model) => {
          return openBlock(), createElementBlock("div", {
            key: model.field,
            class: "visibility-column-field"
          }, [
            createVNode(_component_CheckboxComponent, {
              checked: !model.hide,
              label: `${_ctx.tableDataSet.getDisplayColIndex(model.field)}. ${model.caption}`,
              onClick: ($event) => _ctx.setHideByModel(model)
            }, null, 8, ["checked", "label", "onClick"])
          ]);
        }), 128))
      ])
    ]),
    _: 1
  });
}
var TableVisibilityColumns = /* @__PURE__ */ _export_sfc(_sfc_main$1j, [["render", _sfc_render$1j], ["__scopeId", "data-v-47a983d8"]]);
var CircleLoader_vue_vue_type_style_index_0_scoped_true_lang = "";
const __default__$5 = defineComponent({
  name: "CircleLoader",
  props: {
    class: {},
    style: TVuePropTypes.style,
    zoom: {
      type: [Number, String],
      default: 0.3
    },
    size: { type: Number },
    progress: Number,
    progressClass: String,
    progressStyle: String
  },
  setup() {
    return {
      isNumeric
    };
  },
  computed: {
    sizePx() {
      var _a;
      return (_a = this.size) != null ? _a : toNumberOrDefault(this.zoom) * 80;
    },
    sizeTransformPx() {
      return `${this.sizePx / 2}px`;
    },
    afterWidth() {
      return `${this.sizePx / 13.3333333}px`;
    },
    afterHeight() {
      return `${this.sizePx / 4.44444444}px`;
    },
    afterLeft() {
      return `${this.sizePx / 2.16216216}px`;
    }
  }
});
const __injectCSSVars__$5 = () => {
  useCssVars((_ctx) => ({
    "0e4c6789": _ctx.sizePx + "px",
    "a3df00d0": _ctx.sizeTransformPx,
    "666d3265": _ctx.afterWidth,
    "4d6a2068": _ctx.afterHeight,
    "24510b88": _ctx.afterLeft
  }));
};
const __setup__$5 = __default__$5.setup;
__default__$5.setup = __setup__$5 ? (props, ctx) => {
  __injectCSSVars__$5();
  return __setup__$5(props, ctx);
} : __injectCSSVars__$5;
const _sfc_main$1i = __default__$5;
function _sfc_render$1i(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass([this.class, "lds-spinner-root"]),
    style: normalizeStyle({ style: _ctx.style })
  }, [
    createElementVNode("div", {
      class: normalizeClass([this.class, "lds-spinner"])
    }, [
      (openBlock(), createElementBlock(Fragment, null, renderList(12, (i) => {
        return createElementVNode("div", { key: i });
      }), 64))
    ], 2),
    _ctx.isNumeric(_ctx.progress) ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: normalizeClass([_ctx.progressClass, "lds-spinner__progress"]),
      style: normalizeStyle(_ctx.progressStyle)
    }, toDisplayString(_ctx.progress) + "% ", 7)) : createCommentVNode("", true)
  ], 6);
}
var CircleLoader = /* @__PURE__ */ _export_sfc(_sfc_main$1i, [["render", _sfc_render$1i], ["__scopeId", "data-v-ea08f40c"]]);
var ScreenSpinner_vue_vue_type_style_index_0_lang = "";
const __default__$4 = defineComponent({
  name: "ScreenSpinner",
  components: { CircleLoader },
  props: {
    zoom: {
      type: [Number, String],
      default: 1.5
    },
    size: { type: Number },
    progress: { type: Number },
    progressClass: String,
    progressStyle: String,
    dimming: {
      type: [Boolean, String],
      default: true
    },
    absolute: {
      type: Boolean,
      default: true
    }
  },
  emits: [],
  setup() {
    return {
      isNumeric
    };
  },
  data() {
    return {};
  },
  computed: {
    backgroundColor() {
      if (typeof this.dimming === "string") {
        return this.dimming;
      }
      return this.dimming ? "rgba(0, 0, 0, 0.03)" : "transparent";
    },
    position() {
      return this.absolute ? "absolute" : "relative";
    }
  },
  watch: {},
  created() {
  },
  methods: {}
});
const __injectCSSVars__$4 = () => {
  useCssVars((_ctx) => ({
    "5615f5ac": _ctx.backgroundColor,
    "7711d074": _ctx.position
  }));
};
const __setup__$4 = __default__$4.setup;
__default__$4.setup = __setup__$4 ? (props, ctx) => {
  __injectCSSVars__$4();
  return __setup__$4(props, ctx);
} : __injectCSSVars__$4;
const _sfc_main$1h = __default__$4;
const _hoisted_1$14 = { class: "screen-spinner" };
function _sfc_render$1h(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CircleLoader = resolveComponent("CircleLoader");
  return openBlock(), createElementBlock("div", _hoisted_1$14, [
    createVNode(_component_CircleLoader, {
      progress: _ctx.progress,
      "progress-class": _ctx.progressClass,
      "progress-style": _ctx.progressStyle,
      size: _ctx.size,
      zoom: _ctx.zoom
    }, null, 8, ["progress", "progress-class", "progress-style", "size", "zoom"])
  ]);
}
var ScreenSpinner = /* @__PURE__ */ _export_sfc(_sfc_main$1h, [["render", _sfc_render$1h]]);
var TableEnterModal_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$1g = defineComponent({
  name: "TableEnterModal",
  components: {
    ModalComponent
  },
  props: {
    propsObj: {
      type: Object,
      required: true
    }
  },
  emits: ["close"],
  setup() {
    return {};
  },
  data() {
    return {
      newValue: ""
    };
  },
  computed: {},
  watch: {},
  created() {
  },
  methods: {
    focusContainer() {
      this.$nextTick(() => {
        var _a;
        (_a = this.$refs.container) == null ? void 0 : _a.focus();
      });
    },
    focusTextArea() {
      this.$nextTick(() => {
        var _a;
        (_a = this.$refs.textarea) == null ? void 0 : _a.focus();
      });
    },
    onKeyDown(event) {
      const eventHelper = new KeyboardEventHelper(event);
      if (eventHelper.keyEscape.isAllTrue) {
        return;
      }
      if (eventHelper.keyEnter.isAllTrue && eventHelper.pressShift.isAllFalse) {
        event.preventDefault();
        event.stopPropagation();
        this.propsObj.onConfirm && this.propsObj.onConfirm(this.newValue);
      }
      event.stopPropagation();
    }
  }
});
const _hoisted_1$13 = ["placeholder"];
function _sfc_render$1g(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ModalComponent = resolveComponent("ModalComponent");
  return openBlock(), createBlock(_component_ModalComponent, {
    title: _ctx.propsObj.title,
    visible: true,
    "body-style": "width: 1000px",
    style: { "max-width": "1000px" },
    onClose: _cache[4] || (_cache[4] = ($event) => _ctx.$emit("close")),
    onContentOnKeyDown: _cache[5] || (_cache[5] = ($event) => _ctx.$emit("close"))
  }, {
    body: withCtx(() => [
      createElementVNode("div", {
        ref: "container",
        class: "form-container",
        onKeydown: _cache[3] || (_cache[3] = (...args) => _ctx.onKeyDown && _ctx.onKeyDown(...args))
      }, [
        withDirectives(createElementVNode("textarea", {
          ref: "textarea",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.newValue = $event),
          placeholder: _ctx.propsObj.placeholder,
          autocomplete: "false",
          class: "textarea",
          onPaste: _cache[1] || (_cache[1] = (...args) => _ctx.propsObj.onPaste && _ctx.propsObj.onPaste(...args))
        }, null, 40, _hoisted_1$13), [
          [vModelText, _ctx.newValue]
        ]),
        _ctx.propsObj.confirmButtonVisible === void 0 || _ctx.propsObj.confirmButtonVisible ? (openBlock(), createElementBlock("button", {
          key: 0,
          class: "form-button",
          "data-type": "accent",
          onClick: _cache[2] || (_cache[2] = ($event) => _ctx.propsObj.onConfirm(_ctx.newValue))
        }, toDisplayString(_ctx.propsObj.confirmButtonTitle), 1)) : createCommentVNode("", true)
      ], 544)
    ]),
    _: 1
  }, 8, ["title"]);
}
var TableEnterModal = /* @__PURE__ */ _export_sfc(_sfc_main$1g, [["render", _sfc_render$1g], ["__scopeId", "data-v-dd090f76"]]);
const ESCAPED_HTML_CHARS = {
  "&nbsp;": " ",
  "&amp;": "&",
  "&lt;": "<",
  "&gt;": ">"
};
new RegExp(
  Object.keys(ESCAPED_HTML_CHARS).map((key) => `(${key})`).join("|"),
  "gi"
);
const _sfc_main$1f = defineComponent({
  name: "TableExternalEditor",
  components: {
    ModalComponent
  },
  props: {
    model: {
      type: TableModel,
      required: true
    },
    type: {
      type: Object,
      required: true
    },
    tableCell: {
      type: Object,
      required: true
    },
    tableDataSet: {
      type: Object,
      required: true
    },
    pointer: {
      type: Object,
      required: true
    }
  },
  emits: ["close", "update:cells"],
  setup() {
    return {};
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {
  },
  methods: {
    createExternalEditorForIframe() {
      return {
        onClose: () => {
          this.$emit("close");
        },
        onUpdateCells: this.onUpdateCells,
        params: {
          tableCell: this.tableCell,
          pointer: this.pointer,
          tableDataSet: this.tableDataSet
        }
      };
    },
    getIframeRef() {
      return this.$refs.iframeRef;
    },
    onLoad(event) {
      const iframeRef = this.getIframeRef();
      iframeRef.focus();
      try {
        const externalEditor = this.createExternalEditorForIframe();
        iframeRef.contentWindow.externalEditor = externalEditor;
        iframeRef.contentDocument.body.addEventListener("keydown", (e) => {
          const eventHelper = new KeyboardEventHelper(e);
          if (eventHelper.keyEscape.isAllTrue) {
            externalEditor.onClose();
          }
        });
      } catch (e) {
        Logger$1.error("\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0432\u043D\u0435\u0434\u0440\u0438\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0432 iframe. ", toStr(e));
      }
    },
    onUpdateCells(data) {
      this.$emit("update:cells", data);
    }
  }
});
const _hoisted_1$12 = ["src"];
function _sfc_render$1f(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ModalComponent = resolveComponent("ModalComponent");
  return openBlock(), createBlock(_component_ModalComponent, {
    "content-style": { height: "100%" },
    visible: true,
    "body-style": "padding: 0px; height: 100%;",
    style: { "width": "100%", "height": "100%", "margin": "0" },
    title: `\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u044F\u0447\u0435\u0439\u043A\u0438 ${_ctx.tableDataSet.selected.getText(
      _ctx.tableDataSet,
      _ctx.pointer
    )}`,
    onClose: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("close"))
  }, {
    body: withCtx(({ close }) => [
      createElementVNode("iframe", {
        ref: "iframeRef",
        src: _ctx.type.external_editor.src,
        style: { "height": "100%", "width": "100%", "box-sizing": "border-box" },
        onLoad: _cache[0] || (_cache[0] = ($event) => _ctx.onLoad($event))
      }, null, 40, _hoisted_1$12)
    ]),
    _: 1
  }, 8, ["title"]);
}
var TableExternalEditor = /* @__PURE__ */ _export_sfc(_sfc_main$1f, [["render", _sfc_render$1f]]);
var SearchComponent_vue_vue_type_style_index_0_lang = "";
const _sfc_main$1e = defineComponent({
  name: "SearchComponent",
  emits: ["update:modelValue", "enter", "reset", "change", "input", "keydown"],
  props: {
    classContainer: String,
    disabled: Boolean,
    placeholder: String,
    modelValue: String,
    autofocus: Boolean,
    showReset: Boolean,
    isOriginalEnterEvent: Boolean
  },
  components: {
    ButtonComponent
  },
  data() {
    return {
      ICONS
    };
  },
  mounted() {
    if (this.autofocus) {
      this.focus();
    }
  },
  watch: {
    autofocus() {
      this.focus();
    }
  },
  methods: {
    boolToString,
    onKeyDown(event) {
      this.$emit("keydown", event);
      if (new KeyboardEventHelper(event).keyEnter.isAllTrue) {
        if (!this.isOriginalEnterEvent) {
          event.stopPropagation();
          event.preventDefault();
        }
        this.$emit("enter", this.modelValue);
      }
    },
    focus() {
      this.$refs.inputRef.focus();
    }
  }
});
const _hoisted_1$11 = ["data-disabled"];
const _hoisted_2$V = ["alt", "src"];
const _hoisted_3$O = ["disabled", "placeholder", "value"];
function _sfc_render$1e(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ButtonComponent = resolveComponent("ButtonComponent");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["search-component-container", _ctx.classContainer]),
    "data-disabled": _ctx.boolToString(_ctx.disabled),
    onClick: _cache[4] || (_cache[4] = (...args) => _ctx.focus && _ctx.focus(...args))
  }, [
    createElementVNode("img", {
      alt: _ctx.ICONS.magnify.alt,
      src: _ctx.ICONS.magnify.src,
      class: "search-component-container-icon"
    }, null, 8, _hoisted_2$V),
    createElementVNode("input", {
      ref: "inputRef",
      disabled: _ctx.disabled,
      placeholder: _ctx.placeholder,
      value: _ctx.modelValue,
      onChange: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("change", $event)),
      onInput: _cache[1] || (_cache[1] = ($event) => {
        _ctx.$emit("update:modelValue", $event.target.value);
        _ctx.$emit("input", $event);
      }),
      onKeydown: _cache[2] || (_cache[2] = (...args) => _ctx.onKeyDown && _ctx.onKeyDown(...args))
    }, null, 40, _hoisted_3$O),
    _ctx.showReset ? (openBlock(), createBlock(_component_ButtonComponent, {
      key: 0,
      icon: _ctx.ICONS.closeBlue,
      class: "button-opacity search-component-container-icon-reset",
      onClick: _cache[3] || (_cache[3] = withModifiers(($event) => _ctx.$emit("reset"), ["stop"]))
    }, null, 8, ["icon"])) : createCommentVNode("", true)
  ], 10, _hoisted_1$11);
}
var SearchComponent = /* @__PURE__ */ _export_sfc(_sfc_main$1e, [["render", _sfc_render$1e]]);
var TDatePicker_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$1d = defineComponent({
  name: "TDatePicker",
  props: {
    modelValue: String,
    forceChangeModelValue: {},
    format: {
      type: String,
      default: "YYYY-MM-DD"
    },
    displayFormat: {
      type: String,
      default: "DD.MM.YYYY"
    },
    inputClass: {
      required: false
    },
    inputStyle: {
      type: TVuePropTypes.style,
      required: false
    },
    class: {
      required: false
    },
    placeholder: {
      type: String,
      default: ""
    },
    autofocus: Boolean,
    required: Boolean,
    title: {
      type: String,
      default: ""
    },
    readonly: Boolean,
    disabled: Boolean,
    list: String
  },
  emits: ["update:modelValue", "keydown", "blur", "focusout", "focus"],
  data() {
    return {
      newValue: "",
      newDate: ""
    };
  },
  created() {
    this.onChangeNewValue(this.getNewValueByModelValue());
  },
  mounted() {
    if (this.autofocus) {
      this.focus();
    }
  },
  watch: {
    modelValue() {
      if (this.readonly || this.disabled) {
        this.onChangeNewValue(this.getNewValueByModelValue());
      }
    },
    forceChangeModelValue() {
      this.forceUpdateNewValue();
    }
  },
  computed: {
    inputFormatsComputed() {
      return unique(
        [this.displayFormat, this.format, ...INPUT_FORMATS].filter(
          (x) => !isNullOrUndefined(x)
        )
      );
    },
    formatNewValueDate() {
      return getFormatDate(this.newValue, this.inputFormatsComputed);
    },
    isValidNewValueDate() {
      return this.formatNewValueDate !== void 0;
    }
  },
  methods: {
    onAnyFocus(event) {
      this.$emit("focus", event);
    },
    forceUpdateNewValue() {
      const newValue = this.getNewValueByModelValue(true);
      return this.onChangeNewValue(newValue);
    },
    forceUpdateEmitNewValue() {
      const newValue = this.newValue;
      if (!this.forceUpdateNewValue()) {
        return false;
      }
      if (this.newValue === newValue) {
        return false;
      }
      this.onEmitNewValue();
      return true;
    },
    onBlur(event) {
      if ((event == null ? void 0 : event.target) === this.$refs.inputText) {
        this.forceUpdateEmitNewValue();
      }
      if (event && [this.$refs.inputRef, this.$refs.inputDate, this.$refs.rootDiv].some(
        (x) => x === event.relatedTarget
      )) {
        return;
      }
      this.$emit("blur");
    },
    onInputInput(event) {
      this.onChangeNewValue(event.target.value);
      this.onEmitNewValue();
    },
    onInputKeyDown(event) {
      if (new KeyboardEventHelper(event).keyEnter.keyTab.isAnyTrue) {
        this.forceUpdateEmitNewValue();
      }
      this.$emit("keydown", event);
    },
    onFocusOut(event) {
      event.relatedTarget;
      if (event.relatedTarget !== this.$refs.inputText && event.relatedTarget !== this.$refs.inputDate) {
        this.$emit("focusout", event);
      }
    },
    focus() {
      var _a;
      (_a = this.$refs.inputText) == null ? void 0 : _a.focus();
    },
    onChangeNewValue(value) {
      this.newValue = value;
      if (!this.isValidNewValueDate) {
        return false;
      }
      return this.onChangeNewDate();
    },
    onChangeNewDate() {
      if (!this.formatNewValueDate) {
        return false;
      }
      const date = dateTransform(
        this.newValue,
        this.formatNewValueDate,
        this.format
      );
      if (!isValidAnyDate(date)) {
        return false;
      }
      this.newDate = date;
      return true;
    },
    getModelValueByNewValue() {
      if (!isValidAnyDate(this.newValue)) {
        return "";
      }
      return dateTransform(this.newValue, this.displayFormat, this.format);
    },
    onEmitNewValue() {
      const newModelValue = this.getModelValueByNewValue();
      this.$emit("update:modelValue", newModelValue);
    },
    onChangeInputDate(event) {
      const value = event.target.value;
      if (value === "") {
        this.newDate = "";
        return;
      }
      const newDate = dateTransform(value, "YYYY-MM-DD", this.format);
      if (!isValidAnyDate(newDate)) {
        return;
      }
      this.newDate = newDate;
      this.newValue = dateTransform(
        this.newDate,
        this.format,
        this.displayFormat
      );
    },
    getNewValueByModelValue(originalIfNotValid = false) {
      const defaultReturnValue = originalIfNotValid ? this.modelValue || "" : "";
      if (!isValidAnyDate(this.modelValue)) {
        return defaultReturnValue;
      }
      return dateTransform(this.modelValue, this.format, this.displayFormat) || defaultReturnValue;
    }
  }
});
const _hoisted_1$10 = ["title"];
const _hoisted_2$U = { class: "t-date-picker-inputs-container" };
const _hoisted_3$N = ["disabled", "list", "placeholder", "readonly", "required", "value"];
const _hoisted_4$F = {
  key: 0,
  class: "t-date-picker-date-root"
};
const _hoisted_5$t = ["disabled", "readonly", "required", "value"];
function _sfc_render$1d(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    ref: "rootDiv",
    class: normalizeClass([this.class, "t-date-picker"]),
    title: _ctx.title,
    onBlur: _cache[5] || (_cache[5] = ($event) => _ctx.onBlur($event)),
    onFocusout: _cache[6] || (_cache[6] = (...args) => _ctx.onFocusOut && _ctx.onFocusOut(...args))
  }, [
    createElementVNode("div", _hoisted_2$U, [
      createElementVNode("input", {
        ref: "inputText",
        class: normalizeClass([_ctx.inputClass, "t-date-picker-text"]),
        disabled: _ctx.disabled,
        list: _ctx.list,
        placeholder: _ctx.placeholder,
        readonly: _ctx.readonly,
        required: _ctx.required,
        style: normalizeStyle(_ctx.inputStyle),
        value: _ctx.newValue,
        type: "text",
        onFocus: _cache[0] || (_cache[0] = (...args) => _ctx.onAnyFocus && _ctx.onAnyFocus(...args)),
        onFocusout: _cache[1] || (_cache[1] = ($event) => _ctx.onBlur($event)),
        onInput: _cache[2] || (_cache[2] = (...args) => _ctx.onInputInput && _ctx.onInputInput(...args)),
        onKeydown: _cache[3] || (_cache[3] = (...args) => _ctx.onInputKeyDown && _ctx.onInputKeyDown(...args))
      }, null, 46, _hoisted_3$N),
      !_ctx.readonly ? (openBlock(), createElementBlock("div", _hoisted_4$F, [
        createElementVNode("input", {
          ref: "inputDate",
          disabled: _ctx.disabled,
          readonly: _ctx.readonly,
          required: _ctx.required,
          value: _ctx.newDate,
          tabindex: "-1",
          type: "date",
          onChange: _cache[4] || (_cache[4] = ($event) => {
            _ctx.onChangeInputDate($event);
            _ctx.onEmitNewValue();
            this.onBlur();
            this.focus();
          })
        }, null, 40, _hoisted_5$t)
      ])) : createCommentVNode("", true)
    ])
  ], 42, _hoisted_1$10);
}
var TDatePicker = /* @__PURE__ */ _export_sfc(_sfc_main$1d, [["render", _sfc_render$1d], ["__scopeId", "data-v-8d547840"]]);
var TInputComponent_vue_vue_type_style_index_0_lang = "";
const _sfc_main$1c = defineComponent({
  name: "TInputComponent",
  components: {
    TDatePicker,
    ButtonComponent
  },
  emits: ["update:modelValue", "reset"],
  props: {
    invalid: Boolean,
    saving: Boolean,
    title: {
      type: String,
      default: ""
    },
    caption: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    help: {
      type: String,
      default: ""
    },
    modelValue: {
      type: [String, Number],
      default: ""
    },
    required: Boolean,
    error: String,
    type: {
      type: String,
      default: "text"
    },
    minlength: Number,
    maxlength: Number,
    size: {
      type: Number,
      default: 20
    },
    inputStyle: {
      type: TVuePropTypes.style,
      required: false
    },
    labelContainerStyle: {
      type: TVuePropTypes.style,
      required: false
    },
    forceChangeModelValue: {
      type: Object
    },
    readonly: Boolean,
    disabled: Boolean,
    isHideReset: Boolean,
    replaceLength: { type: Number },
    replaceEmptySymbol: { type: String },
    list: String
  },
  setup() {
    return {
      ICONS,
      isNullOrUndefined,
      boolToString
    };
  },
  data() {
    return {
      forceChangeModelValueLocal: {},
      selectionStart: void 0
    };
  },
  watch: {
    modelValue() {
      if (this.selectionStart !== void 0) {
        const selectionStart = this.selectionStart;
        this.selectionStart = void 0;
        this.$nextTick(() => {
          const inputEl = this.getInputEl();
          inputEl.selectionStart = selectionStart;
          inputEl.selectionEnd = selectionStart;
        });
      }
    }
  },
  computed: {
    forceChangeModelValueComputed() {
      return [this.forceChangeModelValue, this.forceChangeModelValueLocal];
    },
    inputTitleComputed() {
      return this.error ? this.error : this.invalid ? this.help : this.captionComputed;
    },
    captionComputed() {
      return this.caption + (this.required ? "*" : "");
    },
    isEmptyModelValue() {
      return isNullOrUndefined(this.modelValue) || this.modelValue === "";
    },
    isViewCaption() {
      return this.captionComputed && (!this.isEmptyModelValue || this.placeholder || this.type === "color");
    }
  },
  methods: {
    onReset() {
      if (this.readonly) {
        return;
      }
      this.$emit("reset");
      this.$nextTick(() => this.forceChangeModelValueLocal = {});
    },
    replaceLengthAndFillEEmptySymbol(event) {
      const inputEl = event.target;
      let value = inputEl.value;
      if (this.replaceLength !== void 0) {
        if (value.length > this.replaceLength) {
          value = value.slice(0, this.replaceLength);
        } else if (this.replaceEmptySymbol) {
          value = value.padEnd(this.replaceLength, this.replaceEmptySymbol);
        }
        if (value !== inputEl.value) {
          const selectionStart = inputEl.selectionStart;
          inputEl.value = value;
          inputEl.selectionStart = selectionStart;
          inputEl.selectionEnd = selectionStart;
        }
      }
      return value;
    },
    getInputEl() {
      return this.$refs.inputRef;
    },
    onInput(event) {
      let value = this.replaceLengthAndFillEEmptySymbol(event);
      this.$emit("update:modelValue", value);
    },
    focus() {
      if (this.type === "date") {
        this.$refs.datePickerRef.focus();
      } else {
        this.$refs.inputRef.focus();
      }
    }
  }
});
const _hoisted_1$$ = ["data-invalid", "title"];
const _hoisted_2$T = { class: "input-component-container__indicators" };
const _hoisted_3$M = {
  key: 0,
  class: "input-component-container__indicator",
  style: { "color": "blue" }
};
const _hoisted_4$E = { class: "input-component-label-container-input-label" };
const _hoisted_5$s = ["disabled", "list", "maxlength", "minlength", "placeholder", "readonly", "required", "size", "title", "type", "value"];
const _hoisted_6$n = { class: "input-component-label-container-toolbox" };
function _sfc_render$1c(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TDatePicker = resolveComponent("TDatePicker");
  const _component_ButtonComponent = resolveComponent("ButtonComponent");
  return openBlock(), createElementBlock("div", {
    "data-invalid": _ctx.boolToString(_ctx.error || _ctx.invalid),
    title: _ctx.error || _ctx.title,
    class: "input-component-container",
    onClick: _cache[2] || (_cache[2] = (...args) => _ctx.focus && _ctx.focus(...args))
  }, [
    createElementVNode("div", _hoisted_2$T, [
      _ctx.saving ? (openBlock(), createElementBlock("div", _hoisted_3$M, " \u2022 ")) : createCommentVNode("", true)
    ]),
    createElementVNode("div", {
      style: normalizeStyle(_ctx.labelContainerStyle),
      class: "input-component-label-container"
    }, [
      createElementVNode("label", _hoisted_4$E, [
        createElementVNode("span", {
          style: normalizeStyle({
            opacity: _ctx.isViewCaption ? "1" : "0"
          }),
          class: "input-component-label-container-input-caption"
        }, toDisplayString(_ctx.captionComputed), 5),
        _ctx.type === "date" ? (openBlock(), createBlock(_component_TDatePicker, {
          key: 0,
          ref: "datePickerRef",
          disabled: _ctx.disabled,
          "force-change-model-value": _ctx.forceChangeModelValueComputed,
          inputStyle: _ctx.inputStyle,
          list: _ctx.list,
          "model-value": _ctx.modelValue,
          placeholder: _ctx.placeholder || _ctx.captionComputed,
          readonly: _ctx.readonly,
          required: _ctx.required,
          title: _ctx.inputTitleComputed,
          class: "input-component-label-container-input-input",
          inputClass: "input-component-label-container-input-date",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.$emit("update:modelValue", $event))
        }, null, 8, ["disabled", "force-change-model-value", "inputStyle", "list", "model-value", "placeholder", "readonly", "required", "title"])) : (openBlock(), createElementBlock("input", {
          key: 1,
          ref: "inputRef",
          disabled: _ctx.disabled,
          list: _ctx.list,
          maxlength: _ctx.maxlength,
          minlength: _ctx.minlength,
          placeholder: _ctx.placeholder || _ctx.captionComputed,
          readonly: _ctx.readonly,
          required: _ctx.required,
          size: _ctx.size,
          style: normalizeStyle(_ctx.inputStyle),
          title: _ctx.inputTitleComputed,
          type: _ctx.type,
          value: _ctx.modelValue,
          class: "input-component-label-container-input-input",
          onInput: _cache[1] || (_cache[1] = (...args) => _ctx.onInput && _ctx.onInput(...args))
        }, null, 44, _hoisted_5$s))
      ]),
      createElementVNode("div", _hoisted_6$n, [
        !_ctx.isHideReset && !_ctx.readonly ? (openBlock(), createBlock(_component_ButtonComponent, {
          key: 0,
          icon: _ctx.ICONS.closeBlue,
          class: "button-opacity",
          tabindex: "-1",
          onClick: withModifiers(_ctx.onReset, ["stop"])
        }, null, 8, ["icon", "onClick"])) : createCommentVNode("", true)
      ])
    ], 4)
  ], 8, _hoisted_1$$);
}
var TInputComponent = /* @__PURE__ */ _export_sfc(_sfc_main$1c, [["render", _sfc_render$1c]]);
var TableFilterComponent_vue_vue_type_style_index_0_lang = "";
const _sfc_main$1b = defineComponent({
  name: "TableFilterComponent",
  components: {
    TooltipComponent,
    SearchComponent,
    ButtonComponent,
    TInputComponent
  },
  props: {
    tableDataSet: {
      type: TableDataSet,
      required: true
    }
  },
  emits: ["close"],
  setup() {
    return {
      ICONS,
      boolToString
    };
  },
  data() {
    return {
      field: null,
      newWidth: "",
      lastModel: null,
      forceUpdateWhenClosing: false,
      changesExecuteAfterClose: {}
    };
  },
  created() {
    this.$watch(
      () => this.tooltipFilterEvent,
      async () => {
        if (!this.tooltipComponent) {
          Logger$1.warn("tooltipComponent is undefined");
          return;
        }
        await this.$nextTick().then(() => {
          var _a;
          if (this.tooltipFilterEvent) {
            this.tooltipComponent.show(this.tooltipFilterEvent, {
              target: (_a = this.tooltipFilterEvent) == null ? void 0 : _a.target
            });
          } else {
            this.tooltipComponent.hide(true);
          }
        });
      }
    );
    this.$watch(
      () => this.isView,
      async () => {
        var _a, _b;
        if (this.isView) {
          this.lastModel = this.model;
          (_b = (_a = this.model) == null ? void 0 : _a.vocDataSet) == null ? void 0 : _b.getCacheOrLoad();
        } else {
          this.executeChangesAfterClose();
          this.$emit("close", this.lastModel);
        }
      }
    );
  },
  computed: {
    isSort() {
      return Boolean(
        !this.tableDataSet.isServerFilterAndSort || TableModel.isSupportServerSort(this.model)
      );
    },
    isView() {
      return this.field !== null && this.tooltipComponent.visible;
    },
    model() {
      var _a;
      if (!this.tableDataSet || this.field === null) {
        return null;
      }
      return (_a = this.tableDataSet.getModelOrUndefined(this.field)) != null ? _a : null;
    },
    tooltipComponent() {
      return this.$refs.tooltipFilter;
    },
    tooltipFilterEvent() {
      return this.tableDataSet.tooltip.getEvent("filter");
    },
    activeSortAsc() {
      return this.tableDataSet.sort.model === this.model && this.tableDataSet.sort.sort === "ASC";
    },
    activeSortDesc() {
      return this.tableDataSet.sort.model === this.model && this.tableDataSet.sort.sort === "DESC";
    },
    isGrouping() {
      return this.model && this.tableDataSet.groupsManager.isGrouped(this.model.field);
    }
  },
  methods: {
    hide() {
      this.tableDataSet.tooltip.hide();
      this.onHide();
    },
    onHide() {
      this.setField(null);
    },
    setField(field) {
      if (this.field !== field) {
        this.field = field;
        this.updateNewWidth();
      }
    },
    async hideColumn() {
      if (this.model === null) {
        return;
      }
      await this.tableDataSet.setHideColumn(this.model, true, false, true);
      this.hide();
    },
    addFilter() {
      this.tableDataSet.addEmptyFilter(this.model);
      this.hide();
    },
    onChangeWidth(value) {
      this.newWidth = toStr(value);
      const width = ModelHelper.getWidth(this.newWidth);
      if (!this.model) {
        return;
      }
      const col_name = this.model.field;
      const emitObj = {
        width,
        prev_width: this.model.width,
        col_name
      };
      if (width === this.model.width) {
        return;
      }
      this.changesExecuteAfterClose["colResize"] = () => {
        this.tableDataSet.colResize(emitObj, true);
      };
    },
    onChangeWidthKeyDown(event) {
      const eventHelper = new KeyboardEventHelper(event);
      if (eventHelper.keyEnter.isAllTrue) {
        this.executeChangesAfterClose();
      }
    },
    executeChangesAfterClose() {
      Object.keys(this.changesExecuteAfterClose).forEach((key) => {
        this.changesExecuteAfterClose[key]();
        delete this.changesExecuteAfterClose[key];
      });
    },
    updateNewWidth() {
      var _a;
      this.newWidth = toStr((_a = this.model) == null ? void 0 : _a.width).replace("px", "");
    },
    onSort(sort) {
      if (sort === "ASC" && this.activeSortAsc || sort === "DESC" && this.activeSortDesc) {
        this.tableDataSet.sort.clear(this.tableDataSet);
        return;
      }
      this.tableDataSet.sort.setSort(this.tableDataSet, this.model, sort);
    },
    switchGrouping() {
      if (!this.model) {
        return;
      }
      if (this.isGrouping) {
        this.tableDataSet.groupsManager.ungroup(
          this.tableDataSet,
          this.model.field
        );
        return;
      }
      this.tableDataSet.groupsManager.addGrouping(
        this.tableDataSet,
        this.model
      );
    }
  }
});
const _hoisted_1$_ = {
  key: 0,
  class: "table-filter-container"
};
function _sfc_render$1b(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TInputComponent = resolveComponent("TInputComponent");
  const _component_ButtonComponent = resolveComponent("ButtonComponent");
  const _component_TooltipComponent = resolveComponent("TooltipComponent");
  return openBlock(), createBlock(_component_TooltipComponent, {
    ref: "tooltipFilter",
    onHide: _ctx.onHide
  }, {
    default: withCtx(() => [
      _ctx.isView ? (openBlock(), createElementBlock("div", _hoisted_1$_, [
        createVNode(_component_TInputComponent, {
          "model-value": _ctx.newWidth,
          caption: "\u0420\u0430\u0437\u043C\u0435\u0440 \u043A\u043E\u043B\u043E\u043D\u043A\u0438",
          onKeydown: _ctx.onChangeWidthKeyDown,
          onReset: _cache[0] || (_cache[0] = ($event) => _ctx.onChangeWidth(_ctx.model.modelDto.width)),
          "onUpdate:modelValue": _ctx.onChangeWidth
        }, null, 8, ["model-value", "onKeydown", "onUpdate:modelValue"]),
        _ctx.isSort ? (openBlock(), createBlock(_component_ButtonComponent, {
          key: 0,
          "data-active": _ctx.boolToString(_ctx.activeSortAsc),
          disabled: _ctx.tableDataSet.groupsManager.isGrouping,
          icon: _ctx.ICONS.sortNumericAscending,
          class: "button-opacity table-filter-button",
          onClick: _cache[1] || (_cache[1] = ($event) => _ctx.onSort("ASC"))
        }, {
          default: withCtx(() => [
            createTextVNode(" \u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430 \u043F\u043E \u0432\u043E\u0437\u0440\u0430\u0441\u0442\u0430\u043D\u0438\u044E ")
          ]),
          _: 1
        }, 8, ["data-active", "disabled", "icon"])) : createCommentVNode("", true),
        _ctx.isSort ? (openBlock(), createBlock(_component_ButtonComponent, {
          key: 1,
          "data-active": _ctx.boolToString(_ctx.activeSortDesc),
          disabled: _ctx.tableDataSet.groupsManager.isGrouping,
          icon: _ctx.ICONS.sortNumericDescending,
          class: "button-opacity table-filter-button",
          onClick: _cache[2] || (_cache[2] = ($event) => _ctx.onSort("DESC"))
        }, {
          default: withCtx(() => [
            createTextVNode(" \u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430 \u043F\u043E \u0443\u0431\u044B\u0432\u0430\u043D\u0438\u044E ")
          ]),
          _: 1
        }, 8, ["data-active", "disabled", "icon"])) : createCommentVNode("", true),
        createVNode(_component_ButtonComponent, {
          disabled: _ctx.tableDataSet.groupsManager.isGrouping,
          icon: _ctx.ICONS.eyeOff,
          class: "button-opacity table-filter-button",
          onClick: _cache[3] || (_cache[3] = ($event) => _ctx.hideColumn())
        }, {
          default: withCtx(() => [
            createTextVNode(" \u0421\u043A\u0440\u044B\u0442\u044C \u0441\u0442\u043E\u043B\u0431\u0435\u0446 ")
          ]),
          _: 1
        }, 8, ["disabled", "icon"]),
        createVNode(_component_ButtonComponent, {
          icon: _ctx.ICONS.plus,
          class: "button-opacity table-filter-button",
          onClick: _ctx.addFilter
        }, {
          default: withCtx(() => [
            createTextVNode(" \u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0444\u0438\u043B\u044C\u0442\u0440 ")
          ]),
          _: 1
        }, 8, ["icon", "onClick"]),
        createVNode(_component_ButtonComponent, {
          icon: _ctx.isGrouping ? _ctx.ICONS.expandOutline : _ctx.ICONS.contractOutline,
          class: "button-opacity table-filter-button",
          onClick: _ctx.switchGrouping
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(_ctx.isGrouping ? "\u0420\u0430\u0437\u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C" : "\u0413\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C"), 1)
          ]),
          _: 1
        }, 8, ["icon", "onClick"])
      ])) : createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["onHide"]);
}
var TableFilterComponent = /* @__PURE__ */ _export_sfc(_sfc_main$1b, [["render", _sfc_render$1b]]);
const _sfc_main$1a = defineComponent({
  name: "TableCellSimple",
  components: {},
  props: {
    numCell: Boolean,
    classes: {
      type: Object,
      required: true
    }
  }
});
function _sfc_render$1a(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("td", {
    class: normalizeClass([_ctx.classes.cell, _ctx.numCell ? _ctx.classes.numCell : void 0])
  }, [
    createElementVNode("div", {
      class: normalizeClass(_ctx.classes.cellDiv)
    }, [
      createElementVNode("span", null, [
        renderSlot(_ctx.$slots, "default")
      ])
    ], 2)
  ], 2);
}
var TableCellSimple = /* @__PURE__ */ _export_sfc(_sfc_main$1a, [["render", _sfc_render$1a]]);
var TableComponent_vue_vue_type_style_index_0_scoped_true_lang = "";
const __default__$3 = defineComponent({
  name: "TableComponent",
  components: {
    TableCellSimple,
    TableExternalEditor,
    ScreenSpinner,
    TableRowComponent,
    TooltipComponent,
    ConfirmationComponent,
    TableFooter,
    TablePasteNote,
    ModalComponent,
    TableHelp,
    TableVisibilityColumns,
    ResizeComponent,
    TableEnterModal,
    TableFilterComponent
  },
  emits: [
    "update:cells",
    "update:rows",
    "update:cursor",
    "row-insert",
    "row-append",
    "row-delete",
    "row-duplicate",
    "row-up",
    "row-down",
    "click-column-select",
    "cell-dbl-click",
    "cell-click",
    "cell-keydown",
    "table-keydown",
    "close:filter"
  ],
  props: {
    header: {
      type: Array
    },
    tableDataSet: {
      type: TableDataSet,
      required: true
    },
    classes: {
      type: Object,
      default: TABLE_CLASSES
    },
    containerStyle: TVuePropTypes.style,
    containerClass: {},
    isViewColumnNumber: {
      type: Boolean,
      default: false
    },
    isShowInfo: {
      type: Boolean,
      default: true
    },
    selectionMode: {
      type: String,
      default: "single",
      required: false
    },
    autofocus: {
      type: Boolean,
      default: true
    },
    initCursor: {
      type: [Object, Boolean]
    },
    screenSpinner: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    return {
      TABLE_HOTKEYS
    };
  },
  data() {
    return {
      copyData: null,
      intervals: []
    };
  },
  created() {
    watch(
      () => this.tableDataSet,
      () => {
        return this.initTableDataSet();
      }
    );
  },
  async mounted() {
    await this.initTableDataSet();
    setTimeout(() => {
      if (this.tableDataSet.isDestroyed) {
        return;
      }
      this.setTheadHeight();
      if (this.autofocus) {
        this.focusTable();
      }
    }, 300);
    this.intervals.push(
      setInterval(() => {
        var _a;
        return (_a = this.tableDataSet.virtualScroll) == null ? void 0 : _a.onScroll(this.tableDataSet);
      }, 150)
    );
  },
  unmounted() {
    this.tableDataSet.destroy();
  },
  methods: {
    tableDestroy() {
      this.intervals.forEach((interval) => clearInterval(interval));
    },
    async initTableDataSet() {
      if (this.initCursor !== void 0) {
        if (typeof this.initCursor === "object") {
          this.tableDataSet.setCursor(this.initCursor);
        } else {
          this.tableDataSet.setCursorStart();
        }
      }
      await this.tableDataSet.mounted(this, [
        {
          type: "resize",
          handler: () => {
            this.setTheadHeight();
          }
        }
      ]);
    },
    focusTable() {
      return this.$nextTick().then(async () => {
        const isFocusCell = await this.focusCurrentCell();
        if (!isFocusCell) {
          this.focusRefTable();
        }
      });
    },
    focusRefTable() {
      var _a;
      if (document.activeElement === this.$refs.table) {
        return void 0;
      }
      (_a = this.$refs.table) == null ? void 0 : _a.focus();
    },
    setCursor(pointer) {
      Logger$1.debug("table setCursor");
      this.tableDataSet.setCursor(pointer || null);
    },
    onSelectedCell(pointer) {
      Logger$1.debug("table onSelectedCell");
      this.setCursor(pointer);
    },
    rowDeleteEmit(selectedRows) {
      this.$emit("row-delete", selectedRows);
    },
    onRowAppend() {
      this.tableDataSet.selected.disableSelectedMode();
      this.$emit("row-append");
    },
    async onTableKeyDown(event) {
      Logger$1.debug("table onTableKeyDown", event);
      this.$emit("table-keydown", event);
      this.tableDataSet.keyboard.setTableEvent(event);
      if (event.shiftKey || event.altKey || event.code !== "ControlLeft" && event.code !== "ControlRight" && event.code !== "KeyC" && event.code !== "Delete" && event.ctrlKey) {
        this.onSelectedMode();
      }
      if (event.code === "KeyC" && event.ctrlKey) {
        await this.copyCurrentSelected();
        return;
      }
      if (this.tableDataSet.getEdit("edit") && event.code === "KeyV" && event.ctrlKey) {
        await this.pasteCurrentSelected(true);
        return;
      }
      if (event.code === "KeyF" && event.altKey) {
        event.preventDefault();
        await this.tableDataSet.setFullScreenMode();
        return;
      }
      if (event.code === "KeyY" && event.ctrlKey || event.code === "KeyZ" && event.ctrlKey && event.shiftKey) {
        this.setCursor(
          await this.tableDataSet.changes.returnCanceledLast(this.tableDataSet)
        );
        return;
      }
      if (event.code === "KeyZ" && event.ctrlKey) {
        this.setCursor(
          await this.tableDataSet.changes.returnLast(this.tableDataSet, true)
        );
        await this.focusTable();
        return;
      }
      if (this.tableDataSet.isAllowRowCreate && event.code === "Insert" && event.shiftKey) {
        this.onRowAppend();
        return;
      }
      if (event.code === "Delete" && event.ctrlKey) {
        if (!this.tableDataSet.isAllowRowDelete) {
          return;
        }
        if (this.tableDataSet.selected.cursor && this.tableDataSet.rows.length > this.tableDataSet.selected.cursor.row) {
          this.tableDataSet.onRowDelete(
            this.tableDataSet.getSelectedCellsPointers()
          );
          return;
        }
      }
      if (event.code === "KeyD" && event.ctrlKey) {
        event.preventDefault();
        if (this.tableDataSet.isAllowRowCreate && this.tableDataSet.selected.cursor) {
          this.tableDataSet.emitRowDuplicate(this.tableDataSet.selected.cursor);
        }
        return;
      }
      if (event.code === "KeyA" && event.ctrlKey) {
        event.preventDefault();
        this.tableDataSet.selectedAll();
        return;
      }
      if (event.code === "ArrowUp" && event.shiftKey && event.altKey) {
        if (!this.tableDataSet.isAllowRowMove) {
          return;
        }
        this.tableDataSet.selected.disableSelectedMode();
        this.$emit("row-up", this.tableDataSet.selected.cursor);
        await this.focusTable();
        return;
      }
      if (event.code === "ArrowDown" && event.shiftKey && event.altKey) {
        event.preventDefault();
        event.stopPropagation();
        if (!this.tableDataSet.isAllowRowMove) {
          return;
        }
        this.tableDataSet.selected.disableSelectedMode();
        this.$emit("row-down", this.tableDataSet.selected.cursor);
        await this.focusTable();
        return;
      }
      if (event.code === "F2" && event.ctrlKey && event.shiftKey) {
        event.preventDefault();
        if (!this.tableDataSet.getEdit("comment")) {
          return;
        }
        const pointers = this.tableDataSet.getSelectedCellsPointers();
        if (pointers.length) {
          this.tableDataSet.setOpenByAssign({ comment: { pointers } });
        }
        return;
      }
      if (this.tableDataSet.getEdit("remark") && event.code === "F2" && event.shiftKey) {
        event.preventDefault();
        if (!this.tableDataSet.getEdit("remark")) {
          return;
        }
        const pointers = this.tableDataSet.getSelectedCellsPointers();
        if (pointers.length) {
          this.tableDataSet.setOpenByAssign({ remark: { pointers } });
        }
        return;
      }
      switch (event.key) {
        case "Meta": {
          return;
        }
      }
      switch (event.code) {
        case "Escape": {
          this.tableDataSet.setCurrentEdit(null);
          return;
        }
        case "Enter":
        case "NumpadEnter": {
          event.preventDefault();
          if (this.tableDataSet.selected.onSelectNextRow(this.tableDataSet) === false && this.tableDataSet.isAllowRowCreate) {
            this.onRowAppend();
          }
          return;
        }
        case "ArrowDown": {
          this.tableDataSet.setCursorStartIfNull();
          event.preventDefault();
          if (!event.shiftKey) {
            this.tableDataSet.selected.disableSelectedMode();
          }
          this.tableDataSet.selected.onSelectNextRow(this.tableDataSet);
          return;
        }
        case "ArrowRight": {
          this.tableDataSet.setCursorStartIfNull();
          event.preventDefault();
          if (!event.shiftKey) {
            this.tableDataSet.selected.disableSelectedMode();
          }
          this.tableDataSet.selected.onSelectNextCol(this.tableDataSet);
          return;
        }
        case "ArrowUp": {
          this.tableDataSet.setCursorStartIfNull();
          event.preventDefault();
          if (!event.shiftKey) {
            this.tableDataSet.selected.disableSelectedMode();
          }
          this.tableDataSet.selected.onSelectPrevRow(this.tableDataSet);
          return;
        }
        case "ArrowLeft": {
          this.tableDataSet.setCursorStartIfNull();
          event.preventDefault();
          if (!event.shiftKey) {
            this.tableDataSet.selected.disableSelectedMode();
          }
          this.tableDataSet.selected.onSelectPrevCol(this.tableDataSet);
          return;
        }
        case "Tab": {
          event.preventDefault();
          this.tableDataSet.selected.disableSelectedMode();
          if (event.shiftKey) {
            this.tableDataSet.selected.onSelectedPrev(this.tableDataSet);
          } else {
            this.tableDataSet.selected.onSelectedNext(this.tableDataSet);
          }
          return;
        }
        case "Home": {
          if (!event.shiftKey) {
            this.tableDataSet.selected.disableSelectedMode();
          }
          event.preventDefault();
          this.tableDataSet.setCursorStartCurrentRow();
          return;
        }
        case "End": {
          if (!event.shiftKey) {
            this.tableDataSet.selected.disableSelectedMode();
          }
          event.preventDefault();
          this.tableDataSet.setCursorEndCurrentRow();
          return;
        }
        case "Insert": {
          event.preventDefault();
          if (!this.tableDataSet.isAllowRowCreate || !this.tableDataSet.selected.cursor) {
            return;
          }
          this.$emit(
            "row-insert",
            TableRow.getEmptyChange(
              this.tableDataSet,
              this.tableDataSet.selected.cursor
            )
          );
          return;
        }
        case "Delete": {
          if (this.tableDataSet.getEdit("edit")) {
            this.tableDataSet.clearCurrentSelected();
          }
          await this.focusTable();
          return;
        }
        case "ShiftLeft":
        case "ShiftRight": {
          return;
        }
        case "F1": {
          this.tableDataSet.setOpenByAssign({
            help: !this.tableDataSet.open.help
          });
          event.preventDefault();
          return;
        }
        case "AltLeft":
        case "AltRight":
        case "ControlLeft":
        case "CapsLock":
        case "F3":
        case "F4":
        case "F5":
        case "F6":
        case "F8":
        case "F9":
        case "F10":
        case "F11":
        case "F12":
        case "ControlRight": {
          return;
        }
        default: {
          if (this.tableDataSet.getEdit("edit") && this.tableDataSet.selected.cursor) {
            const cellEditMode = event.code === "F2" ? CellEditMode.Edit : CellEditMode.Reset;
            this.tableDataSet.setCurrentEdit(
              this.tableDataSet.selected.cursor,
              cellEditMode
            );
          }
        }
      }
    },
    async onCellEditKeyDown(event) {
      Logger$1.debug("table onCellEditKeyDown");
      this.tableDataSet.keyboard.setCellEditEvent(event);
      const eventHelper = new KeyboardEventHelper(event);
      if (eventHelper.prevent.keyEscape.keyTab.keyEnter.isAnyTrue) {
        await this.focusCurrentCell();
        return;
      }
      eventHelper.prevent.keyAlt.isAllTrue;
      event.stopPropagation();
    },
    onCellClick(event, cellComponent) {
      Logger$1.debug("table onCellClick");
      this.$emit("cell-click", {
        event,
        pointer: cellComponent.pointer
      });
      this.tableDataSet.keyboard.setKeys(event);
      if (cellComponent.isSelectedCell && isEqualCellPointers(
        cellComponent.currentProperty,
        this.tableDataSet.selected.cursor
      )) {
        return;
      }
      this.onSelectedCell({
        col_name: cellComponent.model.field,
        row: cellComponent.rowIndex
      });
    },
    onBlur(event) {
    },
    onClick(event) {
      event.stopPropagation();
      Logger$1.debug("table onClick");
      this.tableDataSet.keyboard.setTablePointerEvent(event);
      if (!isEqualCellPointers(
        this.tableDataSet.currentEdit,
        this.tableDataSet.selected.cursor
      )) {
        this.tableDataSet.setCurrentEdit(null);
      }
      this.onSelectedMode();
    },
    onMouseMove(event) {
      this.tableDataSet.keyboard.setTableMouse(event);
    },
    onSelectedMode() {
      if (this.tableDataSet.keyboard.shiftKey && (!this.tableDataSet.selected.isSelectedMode || !this.tableDataSet.selected.start) && !this.tableDataSet.keyboard.tableEvent.ctrlKey && !this.tableDataSet.keyboard.tableEvent.altKey) {
        if (this.tableDataSet.selected.cursor) {
          this.tableDataSet.selected.enableSelectedMode(
            this.tableDataSet.selected.cursor
          );
        }
      } else if (this.tableDataSet.selected.isSelectedMode && !this.tableDataSet.keyboard.shiftKey) {
        if (this.tableDataSet.keyboard.isCtrlV) {
          return;
        }
        this.tableDataSet.selected.disableSelectedMode();
      }
    },
    onCloseHelp(event) {
      if (event) {
        if (event.code === "F1") {
          event.preventDefault();
        } else {
          return;
        }
      }
      this.tableDataSet.setOpenByAssign({ help: false });
      this.focusTable();
    },
    onUpdateCells(data) {
      this.$emit("update:cells", data);
    },
    onUpdateRows(data) {
      this.$emit("update:rows", data);
    },
    onOpen(event) {
      this.tableDataSet.setOpenByAssign({
        [event.key]: { pointers: [event.pointer] }
      });
    },
    onCloseFilter(tableModel) {
      this.$emit("close:filter", tableModel);
    },
    async onClickContainer(event) {
      await this.focusTable();
    },
    getCopySelectedCells(cells) {
      if (!cells) {
        return null;
      }
      return cells.map((x) => {
        return x.map((selectedCell) => {
          return TableCell.getRepository(selectedCell.data);
        });
      });
    },
    getCellElByPointer() {
      const pointer = this.tableDataSet.selected.cursor;
      if (!pointer) {
        return null;
      }
      return this.tableDataSet.getCellEl(pointer.row, pointer.col_name);
    },
    focusCurrentCell() {
      return this.$nextTick().then(() => {
        const cellEl = this.getCellElByPointer();
        if (!cellEl) {
          return false;
        }
        if (document.activeElement !== cellEl) {
          cellEl.focus();
        }
        return true;
      });
    },
    async copyCurrentSelected() {
      const selectedCells = this.tableDataSet.getSelectedCells();
      const copyString = await this.tableDataSet.getStringSelectedCells(
        selectedCells
      );
      const copyData = this.getCopySelectedCells(selectedCells);
      this.copyData = copyData;
      await copyToClipboard(copyString);
    },
    async pasteCurrentSelected(useCopyData) {
      var _a;
      const useFill = (rows) => {
        const selectedCells = this.tableDataSet.getSelectedCells();
        if (rows.length === 1 && rows[0].length === 1 && (selectedCells.length > 1 || selectedCells.length === 0 && selectedCells[0].length > 1)) {
          const value = rows[0][0];
          return selectedCells.map((row) => row.map((cell) => value));
        }
        return rows;
      };
      const valueToTableCell = (value) => {
        return { value };
      };
      const getRowsByText = (text) => {
        if (!text) {
          return void 0;
        }
        let rowsArray = text.split(/\r\n|\r|\n/g);
        if (rowsArray.length > 1 && lastOrDefault(rowsArray) === "") {
          rowsArray.length--;
        }
        return rowsArray.map((row) => row.split("	").map(valueToTableCell));
      };
      const setRows = (rows) => {
        this.tableDataSet.setDataInVisibleRows(useFill(rows));
      };
      const setText = (text) => {
        const rows = getRowsByText(text);
        if (rows) {
          setRows(rows);
          return true;
        }
        return false;
      };
      if ((_a = navigator.clipboard) == null ? void 0 : _a.readText) {
        const text = await navigator.clipboard.readText();
        setText(text);
        return;
      }
      if (useCopyData) {
        const copyData = this.copyData;
        if (!copyData) {
          return;
        }
        this.tableDataSet.setDataInVisibleRows(useFill(copyData));
        await this.focusTable();
        return;
      }
      this.tableDataSet.setOpenByAssign({
        enterModal: {
          title: "\u0412\u0441\u0442\u0430\u0432\u043A\u0430 \u0432 \u0442\u0430\u0431\u043B\u0438\u0446\u0443",
          confirmButtonTitle: "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C",
          confirmButtonVisible: false,
          placeholder: "\u0412\u0441\u0442\u0430\u0432\u044C\u0442\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u0432 \u044D\u0442\u0443 \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
          onPaste: async (event) => {
            var _a2;
            const text = (_a2 = event.clipboardData) == null ? void 0 : _a2.getData("Text");
            if (setText(text)) {
              this.tableDataSet.setOpenByAssign({ enterModal: null });
              await this.focusTable();
            }
          }
        }
      });
    },
    onClickColumnSelect(tableRow) {
      this.$emit("click-column-select", tableRow.row, tableRow);
    },
    onCellDblClick(value) {
      this.$emit("cell-dbl-click", value);
    },
    onCellKeyDown(value) {
      this.$emit("cell-keydown", value);
    },
    setTheadHeight() {
      this.$nextTick(() => {
        const theadRef = this.$refs.theadRef;
        if (isNullOrUndefined(theadRef)) {
          this.tableDataSet.destroy();
          return;
        }
        this.tableDataSet.setHeaderHeight(theadRef.clientHeight);
      });
    }
  },
  watch: {
    "tableDataSet.selected.cursor"() {
      const cursor = this.tableDataSet.selected.cursor;
      if (cursor && (cursor.visual_row === void 0 || cursor.visual_row === -1)) {
        this.$nextTick(() => {
          this.tableDataSet.setCursor(this.tableDataSet.selected.cursor);
          const visual_row = this.tableDataSet.selected.cursor.visual_row;
          if (!this.tableDataSet.selected.cursor && visual_row === void 0 || visual_row === -1) {
            this.tableDataSet.setCursorStart();
          }
        });
      }
      this.tableDataSet.updateGlobalContext();
      this.$emit("update:cursor", this.tableDataSet.selected.cursor);
    },
    currentEditCellComputed() {
      if (!this.tableDataSet.currentEdit) {
        this.focusTable();
      }
    },
    "tableDataSet.modelVisible": {
      handler() {
        this.setTheadHeight();
      }
    }
  },
  computed: {
    containerStyleComputed() {
      const styles = [this.containerStyle];
      if (this.tableDataSet.options.display.fullScreen) {
        styles.push({
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 3
        });
      }
      return styles;
    },
    currentEditCellComputed() {
      if (!this.tableDataSet.currentEdit) {
        return void 0;
      }
      const pointer = PointerHelper.getRequired(
        this.tableDataSet,
        this.tableDataSet.currentEdit
      );
      const tableCell = this.tableDataSet.getTableCell(pointer);
      if (!tableCell) {
        return void 0;
      }
      const model = this.tableDataSet.getModelOrUndefined(pointer.col_name);
      if (!model) {
        return void 0;
      }
      return {
        type: this.tableDataSet.getTypeModel(model),
        model,
        tableCell,
        pointer
      };
    },
    virtualScrollStyle() {
      var _a;
      (_a = this.tableDataSet.virtualScroll) == null ? void 0 : _a.start;
      this.tableDataSet.visibleRows;
      return {
        topHeight: this.tableDataSet.virtualScroll ? `${this.tableDataSet.virtualScroll.getTopHeight()}px` : void 0,
        bottomHeight: this.tableDataSet.virtualScroll ? `${this.tableDataSet.virtualScroll.getBottomHeight()}px` : void 0
      };
    },
    scrollMarginTop() {
      if (!this.tableDataSet.headerHeight) {
        return void 0;
      }
      return `${this.tableDataSet.headerHeight}px`;
    },
    openModalParams() {
      let openKey = this.tableDataSet.info.keysEditable.find(
        (key2) => Boolean(this.tableDataSet.open[key2])
      );
      if (!openKey) {
        return void 0;
      }
      const infoKey = this.tableDataSet.info.keysDict[openKey];
      const { key } = infoKey;
      const show = key && Boolean(this.tableDataSet.open[key]);
      let name = infoKey.name.toLowerCase();
      const pointers = key ? this.tableDataSet.open[key].pointers : void 0;
      let something;
      if (pointers === void 0) {
        something = "\u043A \u0444\u043E\u0440\u043C\u0435 ";
      } else {
        if (pointers.length > 1) {
          something = "";
        } else {
          if (pointers.find((x) => PointerHelper.isCellPointer(x))) {
            something = "\u043A \u044F\u0447\u0435\u0439\u043A\u0435 ";
          } else {
            something = "\u043A \u0441\u0442\u0440\u043E\u043A\u0435 ";
          }
        }
      }
      const title = pointers ? `\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C ${name} ${something}${this.tableDataSet.selected.getText(
        this.tableDataSet,
        pointers
      )}` : void 0;
      return {
        key,
        show,
        title,
        pointers,
        onClose: () => {
          if (!key) {
            return;
          }
          this.tableDataSet.setOpenByAssign({ [key]: null });
          this.focusTable();
        },
        closeModal: () => {
          if (!key) {
            return;
          }
          this.tableDataSet.setOpenByAssign({ [key]: null });
          this.focusTable();
        }
      };
    },
    tableRowSlotsRegister() {
      const initialSlots = ["voc-header-toolbar-start"];
      const modelSlots = this.tableDataSet.modelUnref.filter((x) => x.modelDto.slot).map((x) => x.modelDto.slot);
      return [...initialSlots, ...modelSlots];
    },
    modelDict() {
      return this.tableDataSet.modelUnref.reduce((value, currentValue) => {
        value[currentValue.field] = currentValue;
        return value;
      }, {});
    },
    visibleRows() {
      const visibleRows = this.tableDataSet.getVisibleRows();
      const virtualScroll = this.tableDataSet.virtualScroll;
      if (!virtualScroll || !virtualScroll.isEnabled()) {
        return visibleRows;
      }
      const virtualScrollState = virtualScroll.updateState();
      return visibleRows.slice(
        virtualScroll.start,
        virtualScroll.start + virtualScrollState.size
      );
    },
    columnNumberWidth() {
      const len = this.tableDataSet.rows.length;
      if (len > 1e3) {
        return 70;
      }
      if (len > 100) {
        return 60;
      }
      return 50;
    }
  }
});
const __injectCSSVars__$3 = () => {
  useCssVars((_ctx) => ({
    "59e7016a": _ctx.scrollMarginTop
  }));
};
const __setup__$3 = __default__$3.setup;
__default__$3.setup = __setup__$3 ? (props, ctx) => {
  __injectCSSVars__$3();
  return __setup__$3(props, ctx);
} : __injectCSSVars__$3;
const _sfc_main$19 = __default__$3;
const _hoisted_1$Z = ["id"];
const _hoisted_2$S = ["id"];
const _hoisted_3$L = ["id", "data-word-wrap"];
const _hoisted_4$D = {
  key: 0,
  style: { "width": "50px" }
};
const _hoisted_5$r = { ref: "theadRef" };
const _hoisted_6$m = ["onClick"];
const _hoisted_7$h = ["id"];
function _sfc_render$19(_ctx, _cache, $props, $setup, $data, $options) {
  var _a, _b, _c;
  const _component_ScreenSpinner = resolveComponent("ScreenSpinner");
  const _component_TableCellSimple = resolveComponent("TableCellSimple");
  const _component_TableRowComponent = resolveComponent("TableRowComponent");
  const _component_TableFooter = resolveComponent("TableFooter");
  const _component_TableHelp = resolveComponent("TableHelp");
  const _component_ModalComponent = resolveComponent("ModalComponent");
  const _component_TablePasteNote = resolveComponent("TablePasteNote");
  const _component_TableEnterModal = resolveComponent("TableEnterModal");
  const _component_ConfirmationComponent = resolveComponent("ConfirmationComponent");
  const _component_TableFilterComponent = resolveComponent("TableFilterComponent");
  const _component_TableVisibilityColumns = resolveComponent("TableVisibilityColumns");
  const _component_TableExternalEditor = resolveComponent("TableExternalEditor");
  return openBlock(), createElementBlock(Fragment, null, [
    createElementVNode("div", {
      id: _ctx.tableDataSet.idContainer,
      ref: "containerRef",
      class: normalizeClass([_ctx.classes.container, _ctx.containerClass]),
      style: normalizeStyle(_ctx.containerStyleComputed),
      onClick: _cache[12] || (_cache[12] = (...args) => _ctx.onClickContainer && _ctx.onClickContainer(...args))
    }, [
      createElementVNode("div", {
        id: _ctx.tableDataSet.idContainerDivUp,
        "data-div-up": "true",
        onClick: _cache[0] || (_cache[0] = withModifiers(() => {
        }, ["stop"]))
      }, null, 8, _hoisted_2$S),
      _ctx.screenSpinner || _ctx.tableDataSet.screenSpinner ? (openBlock(), createBlock(_component_ScreenSpinner, { key: 0 })) : createCommentVNode("", true),
      createElementVNode("div", {
        ref: "virtualScrollDiv",
        class: normalizeClass(_ctx.classes.virtualScroll)
      }, [
        createElementVNode("table", {
          id: _ctx.tableDataSet.id,
          ref: "table",
          class: normalizeClass(_ctx.classes.table),
          "data-word-wrap": _ctx.tableDataSet.wordWrap ? true : void 0,
          style: normalizeStyle({ opacity: _ctx.tableDataSet.isTableMounted ? void 0 : 0 }),
          onBlur: _cache[7] || (_cache[7] = (...args) => _ctx.onBlur && _ctx.onBlur(...args)),
          onClick: _cache[8] || (_cache[8] = (...args) => _ctx.onClick && _ctx.onClick(...args)),
          onKeydown: _cache[9] || (_cache[9] = (...args) => _ctx.onTableKeyDown && _ctx.onTableKeyDown(...args)),
          onMousemove: _cache[10] || (_cache[10] = (...args) => _ctx.onMouseMove && _ctx.onMouseMove(...args))
        }, [
          createElementVNode("colgroup", null, [
            _ctx.selectionMode === "multiple" ? (openBlock(), createElementBlock("col", _hoisted_4$D)) : createCommentVNode("", true),
            _ctx.isViewColumnNumber ? (openBlock(), createElementBlock("col", {
              key: 1,
              style: normalizeStyle(`width: ${_ctx.columnNumberWidth}px`)
            }, null, 4)) : createCommentVNode("", true),
            (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.tableDataSet.modelUnref, (modelTh) => {
              return withDirectives((openBlock(), createElementBlock("col", {
                key: modelTh.field,
                style: normalizeStyle({ width: modelTh.width }),
                span: "1"
              }, null, 4)), [
                [vShow, !modelTh.hide]
              ]);
            }), 128))
          ]),
          createElementVNode("thead", _hoisted_5$r, [
            renderSlot(_ctx.$slots, "headers", {
              classes: _ctx.classes,
              tableDataSet: _ctx.tableDataSet
            }, void 0, true)
          ], 512),
          createElementVNode("tbody", null, [
            _ctx.tableDataSet.virtualScroll ? (openBlock(), createElementBlock("tr", {
              key: 0,
              style: normalizeStyle({ height: _ctx.virtualScrollStyle.topHeight })
            }, null, 4)) : createCommentVNode("", true),
            ((_a = _ctx.tableDataSet.options.display) == null ? void 0 : _a.rowIndexCol) ? (openBlock(), createElementBlock("tr", {
              key: 1,
              class: normalizeClass(_ctx.classes.row),
              "data-num-row": "true"
            }, [
              _ctx.selectionMode === "multiple" && _ctx.tableDataSet.options.display.rowIndexCol ? (openBlock(), createBlock(_component_TableCellSimple, {
                key: 0,
                classes: _ctx.classes,
                "num-cell": ""
              }, null, 8, ["classes"])) : createCommentVNode("", true),
              _ctx.isViewColumnNumber ? (openBlock(), createBlock(_component_TableCellSimple, {
                key: 1,
                classes: _ctx.classes,
                "num-cell": ""
              }, {
                default: withCtx(() => [
                  createTextVNode(" 1 ")
                ]),
                _: 1
              }, 8, ["classes"])) : createCommentVNode("", true),
              (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.tableDataSet.modelUnref, (model) => {
                return withDirectives((openBlock(), createElementBlock("td", {
                  key: model.field,
                  class: normalizeClass([_ctx.classes.cell, _ctx.classes.numCell]),
                  onClick: withModifiers(($event) => _ctx.tableDataSet.selected.selectedCol(_ctx.tableDataSet, model.field), ["stop"])
                }, [
                  createElementVNode("div", {
                    class: normalizeClass(_ctx.classes.cellDiv)
                  }, [
                    createElementVNode("span", null, toDisplayString(_ctx.tableDataSet.getDisplayColIndex(model.field)), 1)
                  ], 2)
                ], 10, _hoisted_6$m)), [
                  [vShow, !model.hide]
                ]);
              }), 128))
            ], 2)) : createCommentVNode("", true),
            (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.visibleRows, (tableRow) => {
              return openBlock(), createBlock(_component_TableRowComponent, {
                key: tableRow.row,
                "cell-edit-mode": _ctx.tableDataSet.cellEditMode,
                classes: _ctx.classes,
                "current-edit": _ctx.tableDataSet.currentEdit,
                "display-date-format": _ctx.tableDataSet.displayDateFormat,
                "display-row-index": _ctx.tableDataSet.getDisplayRowIndex(tableRow.row),
                "get-edit": _ctx.tableDataSet.getEdit,
                "global-handlers": _ctx.tableDataSet.options.globalHandlers,
                "is-view-column-number": _ctx.isViewColumnNumber,
                "model-array": _ctx.tableDataSet.modelUnref,
                "selection-mode": _ctx.selectionMode,
                "server-date-format": _ctx.tableDataSet.serverDateFormat,
                "table-id": _ctx.tableDataSet.id,
                "table-info": _ctx.tableDataSet.info,
                "table-row": tableRow,
                "table-row-slots-register": _ctx.tableRowSlotsRegister,
                "table-selected": _ctx.tableDataSet.selected,
                types: _ctx.tableDataSet.types,
                "unique-id": _ctx.tableDataSet.uniqueId,
                "validation-handlers": _ctx.tableDataSet.options.validationHandlers,
                "word-wrap": _ctx.tableDataSet.wordWrap,
                onOpen: _ctx.onOpen,
                onShowContextMenu: _cache[1] || (_cache[1] = ($event) => _ctx.tableDataSet.showContextMenu($event)),
                onCellEditKeyDown: _ctx.onCellEditKeyDown,
                onCellClick: _ctx.onCellClick,
                "onUpdate:cells": _cache[2] || (_cache[2] = ($event) => _ctx.onUpdateCells($event)),
                "onUpdate:rows": _cache[3] || (_cache[3] = ($event) => _ctx.onUpdateRows($event)),
                onClickColumnSelect: ($event) => _ctx.onClickColumnSelect(tableRow),
                onCellDblClick: _ctx.onCellDblClick,
                onCellKeydown: _ctx.onCellKeyDown,
                onFocusTable: _ctx.focusRefTable,
                onSetCurrentEdit: _cache[4] || (_cache[4] = ($event) => _ctx.tableDataSet.setCurrentEdit($event.pointer, $event.mode)),
                onSelectedRow: _cache[5] || (_cache[5] = ($event) => _ctx.tableDataSet.selectedRow($event)),
                onClickGroup: _cache[6] || (_cache[6] = ($event) => _ctx.tableDataSet.groupsManager.switchOpen(_ctx.tableDataSet, $event))
              }, createSlots({ _: 2 }, [
                renderList(_ctx.tableRowSlotsRegister, (slotName) => {
                  return {
                    name: slotName,
                    fn: withCtx((payload) => [
                      renderSlot(_ctx.$slots, slotName, normalizeProps(guardReactiveProps(payload)), void 0, true)
                    ])
                  };
                })
              ]), 1032, ["cell-edit-mode", "classes", "current-edit", "display-date-format", "display-row-index", "get-edit", "global-handlers", "is-view-column-number", "model-array", "selection-mode", "server-date-format", "table-id", "table-info", "table-row", "table-row-slots-register", "table-selected", "types", "unique-id", "validation-handlers", "word-wrap", "onOpen", "onCellEditKeyDown", "onCellClick", "onClickColumnSelect", "onCellDblClick", "onCellKeydown", "onFocusTable"]);
            }), 128)),
            _ctx.tableDataSet.virtualScroll ? (openBlock(), createElementBlock("tr", {
              key: 2,
              style: normalizeStyle({ height: _ctx.virtualScrollStyle.bottomHeight })
            }, null, 4)) : createCommentVNode("", true)
          ])
        ], 46, _hoisted_3$L)
      ], 2),
      renderSlot(_ctx.$slots, "bottom", {}, void 0, true),
      _ctx.isShowInfo ? (openBlock(), createBlock(_component_TableFooter, {
        key: 1,
        "table-data-set": _ctx.tableDataSet
      }, null, 8, ["table-data-set"])) : createCommentVNode("", true),
      createElementVNode("div", {
        id: _ctx.tableDataSet.idContainerDivBottom,
        "data-div-bottom": "true",
        onClick: _cache[11] || (_cache[11] = withModifiers(() => {
        }, ["stop"]))
      }, null, 8, _hoisted_7$h)
    ], 14, _hoisted_1$Z),
    createVNode(_component_ModalComponent, {
      visible: _ctx.tableDataSet.open.help,
      "body-style": "margin: 0; padding: 0;",
      style: { "max-width": "max-content" },
      title: "\u0411\u044B\u0441\u0442\u0440\u044B\u0435 \u043A\u043B\u0430\u0432\u0438\u0448\u0438",
      onClose: _ctx.onCloseHelp,
      onContentOnKeyDown: _ctx.onCloseHelp
    }, {
      body: withCtx(() => {
        var _a2;
        return [
          createVNode(_component_TableHelp, {
            "model-value": (_a2 = _ctx.tableDataSet.options.hotkeysHelp) != null ? _a2 : _ctx.TABLE_HOTKEYS
          }, null, 8, ["model-value"])
        ];
      }),
      _: 1
    }, 8, ["visible", "onClose", "onContentOnKeyDown"]),
    ((_b = _ctx.openModalParams) == null ? void 0 : _b.show) ? (openBlock(), createBlock(_component_ModalComponent, {
      key: 0,
      title: _ctx.openModalParams.title,
      visible: true,
      style: { "max-width": "600px" },
      onClose: _ctx.openModalParams.onClose,
      onContentOnKeyDown: _ctx.openModalParams.closeModal
    }, {
      body: withCtx(() => [
        createVNode(_component_TablePasteNote, {
          "mode-field": _ctx.openModalParams.key,
          pointers: _ctx.openModalParams.pointers,
          "table-data-set": _ctx.tableDataSet,
          onClose: _ctx.openModalParams.closeModal,
          "onUpdate:cell": _cache[13] || (_cache[13] = ($event) => _ctx.onUpdateCells([$event]))
        }, null, 8, ["mode-field", "pointers", "table-data-set", "onClose"])
      ]),
      _: 1
    }, 8, ["title", "onClose", "onContentOnKeyDown"])) : createCommentVNode("", true),
    _ctx.tableDataSet.open.enterModal ? (openBlock(), createBlock(_component_TableEnterModal, {
      key: 1,
      "props-obj": _ctx.tableDataSet.open.enterModal,
      onClose: _cache[14] || (_cache[14] = ($event) => _ctx.tableDataSet.setOpenByAssign({ enterModal: null }))
    }, null, 8, ["props-obj"])) : createCommentVNode("", true),
    createVNode(_component_ConfirmationComponent, {
      buttons: _ctx.tableDataSet.confirmation.buttons,
      message: _ctx.tableDataSet.confirmation.message,
      title: _ctx.tableDataSet.confirmation.title,
      visible: _ctx.tableDataSet.confirmation.visible,
      onCancel: _ctx.tableDataSet.confirmation.cancel,
      onSuccess: _ctx.tableDataSet.confirmation.success
    }, null, 8, ["buttons", "message", "title", "visible", "onCancel", "onSuccess"]),
    _ctx.tableDataSet ? (openBlock(), createBlock(_component_TableFilterComponent, {
      key: 2,
      ref: "filterComponent",
      "table-data-set": _ctx.tableDataSet,
      onClose: _ctx.onCloseFilter
    }, null, 8, ["table-data-set", "onClose"])) : createCommentVNode("", true),
    _ctx.tableDataSet.open.visibilityColumns ? (openBlock(), createBlock(_component_TableVisibilityColumns, {
      key: 3,
      "table-data-set": _ctx.tableDataSet,
      onClose: _cache[15] || (_cache[15] = ($event) => _ctx.tableDataSet.setOpenByAssign({ visibilityColumns: false }))
    }, null, 8, ["table-data-set"])) : createCommentVNode("", true),
    ((_c = _ctx.currentEditCellComputed) == null ? void 0 : _c.type.external_editor) ? (openBlock(), createBlock(_component_TableExternalEditor, {
      key: 4,
      model: _ctx.currentEditCellComputed.model,
      pointer: _ctx.currentEditCellComputed.pointer,
      "table-cell": _ctx.currentEditCellComputed.tableCell,
      "table-data-set": _ctx.tableDataSet,
      type: _ctx.currentEditCellComputed.type,
      onClose: _cache[16] || (_cache[16] = ($event) => {
        _ctx.tableDataSet.setCurrentEdit(null);
        _ctx.focusTable();
      }),
      "onUpdate:cells": _cache[17] || (_cache[17] = ($event) => _ctx.onUpdateCells($event))
    }, null, 8, ["model", "pointer", "table-cell", "table-data-set", "type"])) : createCommentVNode("", true)
  ], 64);
}
var TableComponent = /* @__PURE__ */ _export_sfc(_sfc_main$19, [["render", _sfc_render$19], ["__scopeId", "data-v-16494c00"]]);
function declension(oneNominative, severalGenitive, severalNominative, number) {
  number = number % 100;
  return number <= 14 && number >= 11 ? severalGenitive : (number %= 10) < 5 ? number > 2 ? severalNominative : number === 1 ? oneNominative : number === 0 ? severalGenitive : severalNominative : severalGenitive;
}
function getArrayHeaders(headers) {
  if (isNullOrUndefined(headers)) {
    Logger$1.warn("\u0417\u0430\u0433\u043E\u043B\u043E\u0432\u043A\u0438 \u0442\u0430\u0431\u043B\u0438\u0446\u044B \u043D\u0435 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u044B.", headers);
    return [];
  }
  if (typeof headers === "string") {
    return [headers];
  }
  if (!Array.isArray(headers)) {
    const firstKey = Object.keys(headers)[0];
    return getArrayHeaders(headers[firstKey]);
  }
  if (Array.isArray(headers)) {
    return headers.map((header) => {
      return getArrayHeaders(header);
    }).flat();
  }
  return getArrayHeaders(headers);
}
function getModelDtoDict(modelDtoArray) {
  return modelDtoArray.reduce((v, c) => {
    v[c.field] = c;
    return v;
  }, {});
}
function getModelDtoSort(headers, model) {
  const modelDtoDict = getModelDtoDict(model);
  const modelKeys = getArrayHeaders(headers);
  return modelKeys.map((field) => {
    return modelDtoDict[field] || {
      field,
      caption: field
    };
  });
}
var SwitchComponent_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$18 = defineComponent({
  name: "SwitchComponent",
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: false
    },
    labelStyle: {
      type: TVuePropTypes.style,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false
    }
  },
  emits: ["click"],
  setup() {
    return {
      boolToString
    };
  },
  data() {
    return {};
  },
  methods: {}
});
const _withScopeId$h = (n) => (pushScopeId("data-v-60fd9b80"), n = n(), popScopeId(), n);
const _hoisted_1$Y = ["data-disabled"];
const _hoisted_2$R = ["data-checked"];
const _hoisted_3$K = /* @__PURE__ */ _withScopeId$h(() => /* @__PURE__ */ createElementVNode("div", { class: "switch-circle" }, null, -1));
const _hoisted_4$C = [
  _hoisted_3$K
];
function _sfc_render$18(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    "data-disabled": _ctx.boolToString(_ctx.disabled),
    class: "switch-container",
    onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("click", $event))
  }, [
    createElementVNode("div", {
      "data-checked": _ctx.boolToString(_ctx.checked),
      class: "switch-container-2"
    }, _hoisted_4$C, 8, _hoisted_2$R),
    _ctx.label ? (openBlock(), createElementBlock("label", {
      key: 0,
      style: normalizeStyle(_ctx.labelStyle),
      class: "switch-label"
    }, toDisplayString(_ctx.label), 5)) : createCommentVNode("", true),
    renderSlot(_ctx.$slots, "default", {}, void 0, true)
  ], 8, _hoisted_1$Y);
}
var SwitchComponent = /* @__PURE__ */ _export_sfc(_sfc_main$18, [["render", _sfc_render$18], ["__scopeId", "data-v-60fd9b80"]]);
async function getTableModelArrayByFormRepository(headers, model, types, getSystemField, isSelection = false) {
  const modelKeys = getArrayHeaders(headers);
  const modelDtoDict = getModelDtoDict(model);
  const modelResult = modelKeys.map((key, index) => {
    var _a;
    const modelDto = modelDtoDict[key] || {
      field: key,
      caption: key
    };
    const hide = modelDto.hide_selection && isSelection || modelDto.hide;
    return new TableModel({
      field: key,
      caption: modelDto.caption,
      type: (_a = modelDto.type) != null ? _a : void 0,
      modelDto,
      width: ModelHelper.getWidth(modelDto.width),
      index,
      systemField: getSystemField ? getSystemField(modelDto) : void 0,
      hide
    });
  });
  for (const tableModel of modelResult) {
    if (tableModel.type == void 0) {
      continue;
    }
    await TableModel.initVoc(tableModel, types);
  }
  return modelResult;
}
class TableLocalRepository {
  constructor() {
    this.intervals = [];
    this._executeFree = true;
    this._lastError = false;
    this.queue = [];
    this._bufferingData = void 0;
  }
  runSaveInterval(tableDataSet) {
    this.intervals.push(
      setInterval(() => {
        if (this.queue.length === 0 || !this._executeFree) {
          return;
        }
        this._executeFree = false;
        const task = this.queue.shift();
        this.execute(tableDataSet, task).then(() => {
          this._lastError = false;
        }).catch(() => {
          this.queue.unshift(task);
          this._lastError = true;
        }).finally(() => {
          this._executeFree = true;
        });
      }, 100)
    );
  }
  destroy() {
    this.intervals.forEach((x) => clearInterval(x));
  }
  async execute(tableDataSet, queueOnly) {
    return true;
  }
  queuePush(queueOnly, isBuffer = false) {
    if (this._bufferingData !== void 0 && !isBuffer) {
      this._bufferingData.push(queueOnly);
      return;
    }
    this.queue.push(queueOnly);
  }
  addRow({ changeEvents, tableDataSet }, rowChange) {
    const queueOnly = {
      type: "add_row",
      data: {
        pointer: {
          row: rowChange.row
        },
        table_row: TableRow.getRepositoryFormat(rowChange.data),
        row_cells: rowChange.changeCells.map((changeCellAndPointer) => {
          return TableCell.getRepositoryTableCellAndPointerFormatByChangeCellAndPointer(
            changeCellAndPointer
          );
        })
      },
      changeEvents
    };
    this.queuePush(queueOnly);
  }
  changeTableCells({ changeEvents, tableDataSet }, tableCellAndPointerArray) {
    const table_cells = tableCellAndPointerArray.map(
      (x) => TableCell.getRepositoryTableCellAndPointerFormatByChangeCellAndPointer(
        x
      )
    );
    const queueOnly = {
      type: "change_cells",
      data: {
        table_cells
      },
      changeEvents
    };
    this.queuePush(queueOnly);
  }
  changeTableRows({ changeEvents, tableDataSet }, table_rows) {
    const queueOnly = {
      type: "change_rows",
      data: {
        table_rows
      },
      changeEvents
    };
    this.queuePush(queueOnly);
  }
  deleteRow({ changeEvents, tableDataSet }, pointersAndRows) {
    const queueOnly = {
      type: "delete_rows",
      data: {
        pointers: pointersAndRows.map((x) => x.pointer)
      },
      changeEvents
    };
    this.queuePush(queueOnly);
  }
  moveRow({ changeEvents, tableDataSet }, pointer, move_mode) {
    const queueOnly = {
      type: "move_row",
      data: {
        pointer,
        move_mode
      },
      changeEvents
    };
    this.queuePush(queueOnly);
  }
  combineQueue(queue) {
    return combineQueue(queue);
  }
  startBuffering() {
    this._bufferingData = [];
  }
  finishBuffering() {
    if (this._bufferingData === void 0) {
      return;
    }
    const queue = [];
    let changeCells = [];
    let deleteRows = [];
    const addSpecTasks = () => {
      if (changeCells.length > 0) {
        queue.push(...this.combineQueue(changeCells));
        changeCells = [];
      }
      if (deleteRows.length > 0) {
        queue.push(...this.combineQueue(deleteRows));
        deleteRows = [];
      }
    };
    this._bufferingData.forEach((bufferQueue) => {
      if (queueIsChangeCells(bufferQueue)) {
        changeCells.push(bufferQueue);
        return;
      }
      if (queueIsDeleteRows(bufferQueue)) {
        deleteRows.push(bufferQueue);
        return;
      }
      addSpecTasks();
      queue.push(bufferQueue);
    });
    addSpecTasks();
    queue.forEach((x) => this.queuePush(x, true));
    this._bufferingData = void 0;
  }
  updateRowIndexes({ changeEvents, tableDataSet }, indexes) {
    this.queuePush({
      type: "update_row_indexes",
      data: {
        indexes
      }
    });
  }
}
function getTableRowsByFormRead(values, modelArray, originalArray, getUUID = DEFAULT_GET_UUID) {
  return values.map((x, row) => {
    const keys2 = unique([...modelArray.map((x2) => x2.field), ...Object.keys(x)]);
    const data = keys2.reduce((data2, field) => {
      data2[field] = { value: x[field] };
      return data2;
    }, {});
    const original = originalArray ? originalArray[row] : void 0;
    return TableRow.getTableRowObj(
      {
        row,
        data,
        original
      },
      modelArray,
      getUUID
    );
  });
}
class PanelFiltersSet {
  constructor(save) {
    this.save = save;
    this.open = false;
    this.data = PanelFiltersFactory.getInitialData();
    this.subject = new Subject();
  }
  setOpen(open) {
    if (open === void 0) {
      open = !this.open;
    }
    this.open = open;
    return this;
  }
  setData(data) {
    this.data = data;
    return this;
  }
  setCurrentFilter(currentFilter) {
    var _a;
    if (!this.save) {
      return this;
    }
    this.save.currentFilter = currentFilter;
    if ((_a = this.save) == null ? void 0 : _a.currentFilter) {
      this.setData(copy(this.save.currentFilter.data));
    } else {
      this.setData(PanelFiltersFactory.getInitialData());
    }
    return this;
  }
  setFilters(filters) {
    if (!this.save) {
      return this;
    }
    this.save.filters = filters;
    return this;
  }
  execute() {
    this.subject.next(this.data);
    return this;
  }
  addItem(item = PanelFiltersFactory.getInitialDataItem()) {
    PanelFiltersFactory.addDataItem(this.data, item);
    return this;
  }
  removeItem(dataItem) {
    delete this.data.items[dataItem.id];
    return this;
  }
}
class TableDataSetFactory {
  constructor(options) {
    this.options = options;
    this.modelDtoSort = getModelDtoSort(
      this.options.headers,
      this.options.modelDtoArray
    );
  }
  async create() {
    var _a;
    const modelArray = await this.getModel();
    if (modelArray.length !== uniqBy(modelArray, (x) => x.field).length) {
      Logger$1.warn(
        "\u041F\u0440\u0438 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0438 \u0442\u0430\u0431\u043B\u0438\u0446\u044B \u043E\u0431\u043D\u0430\u0440\u0443\u0436\u0435\u043D\u044B \u0434\u0443\u0431\u043B\u0438\u043A\u0430\u0442\u044B \u0441\u0442\u043E\u043B\u0431\u0446\u043E\u0432. \u0412\u043E\u0437\u043C\u043E\u0436\u043D\u0430 \u043D\u0435\u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u0430\u044F \u0440\u0430\u0431\u043E\u0442\u0430."
      );
    }
    const tableRows = this.getTableRows(modelArray);
    const opts = (_a = this.options.tableDataSetOptions) != null ? _a : {};
    if (opts.headers === void 0) {
      opts.headers = this.options.headers;
    }
    if (!opts.filtersSet) {
      opts.filtersSet = new PanelFiltersSet();
    }
    const dataSet = reactive(
      new TableDataSet(
        this.options.tableName,
        this.options.uniqId,
        tableRows,
        modelArray,
        this.options.types,
        this.options.repository || new TableLocalRepository(),
        opts
      )
    );
    if (this.options.edit) {
      dataSet.setEditMode(this.options.edit);
    }
    if (this.options.enableAutoSaveSettings) {
      await GlobalTableSettingsService.useSaveSettingsInTableDataSet(dataSet);
    }
    return dataSet;
  }
  getModel() {
    return getTableModelArrayByFormRepository(
      this.options.headers,
      this.modelDtoSort,
      this.options.types,
      this.options.getSystemField,
      this.options.isSelection
    );
  }
  getTableRows(modelArray) {
    return getTableRowsByFormRead(
      this.options.rows,
      modelArray,
      Array.isArray(this.options.rowsOriginal) ? this.options.rowsOriginal : this.options.rows
    );
  }
  setRows(rows, rowsOriginal) {
    this.options.rows = rows;
    this.options.rowsOriginal = rowsOriginal;
    return this;
  }
}
var TablePaginationBottom_vue_vue_type_style_index_0_lang = "";
const _sfc_main$17 = defineComponent({
  name: "TablePaginationBottom",
  components: {
    ButtonComponent
  },
  props: {
    tableDataSet: {
      type: TableDataSet,
      required: true
    }
  },
  emits: [
    "pagination",
    "pagination-load-next",
    "pagination-load-all"
  ],
  setup() {
    return {
      PaginationHelper
    };
  },
  data() {
    return {};
  },
  computed: {
    disableButtons() {
      var _a;
      return Boolean(
        !((_a = this.tableDataSet.options.pagination) == null ? void 0 : _a.valuesRemain) || this.tableDataSet.groupsManager.isGrouping
      );
    },
    isPagination() {
      var _a;
      return PaginationHelper.isPagination(
        (_a = this.tableDataSet.options.pagination) == null ? void 0 : _a.params
      );
    }
  },
  watch: {},
  created() {
  },
  methods: {}
});
const _hoisted_1$X = {
  key: 0,
  class: "table-pagination"
};
function _sfc_render$17(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ButtonComponent = resolveComponent("ButtonComponent");
  return _ctx.isPagination ? (openBlock(), createElementBlock("div", _hoisted_1$X, [
    createVNode(_component_ButtonComponent, {
      disabled: _ctx.disableButtons,
      class: "button-blue",
      onClick: _cache[0] || (_cache[0] = ($event) => {
        _ctx.$emit("pagination-load-next");
        _ctx.$emit("pagination", "next");
      })
    }, {
      default: withCtx(() => [
        createTextVNode(" \u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0435\u0449\u0451 ")
      ]),
      _: 1
    }, 8, ["disabled"]),
    createVNode(_component_ButtonComponent, {
      disabled: _ctx.disableButtons,
      class: "button-blue",
      onClick: _cache[1] || (_cache[1] = ($event) => {
        _ctx.$emit("pagination-load-all");
        _ctx.$emit("pagination", "all");
      })
    }, {
      default: withCtx(() => [
        createTextVNode(" \u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0432\u0441\u0451 ")
      ]),
      _: 1
    }, 8, ["disabled"])
  ])) : createCommentVNode("", true);
}
var TablePaginationBottom = /* @__PURE__ */ _export_sfc(_sfc_main$17, [["render", _sfc_render$17]]);
const _sfc_main$16 = defineComponent({
  name: "TableCellLabelComponent",
  components: {},
  props: {
    label: String,
    class: {},
    beforeLabel: { type: Array },
    isValid: Boolean,
    help: String
  },
  emits: [],
  setup() {
    return {};
  },
  data() {
    return {};
  },
  computed: {
    labelComputed() {
      let label = this.label;
      if (this.beforeLabel) {
        TableHandlersHelper.executeBeforeLabel(
          this.beforeLabel,
          label,
          (newValue) => {
            label = newValue;
          }
        );
      }
      return label;
    }
  },
  watch: {},
  created() {
  },
  methods: {}
});
const _hoisted_1$W = ["title"];
function _sfc_render$16(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("span", {
    class: normalizeClass(this.class),
    title: _ctx.isValid ? _ctx.labelComputed : _ctx.help
  }, toDisplayString(_ctx.labelComputed), 11, _hoisted_1$W);
}
var TableCellLabelComponent = /* @__PURE__ */ _export_sfc(_sfc_main$16, [["render", _sfc_render$16]]);
const _sfc_main$15 = defineComponent({
  name: "CloseIcon"
});
const _hoisted_1$V = {
  fill: "none",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$Q = /* @__PURE__ */ createElementVNode("path", {
  d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3$J = [
  _hoisted_2$Q
];
function _sfc_render$15(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1$V, _hoisted_3$J);
}
var CloseIcon = /* @__PURE__ */ _export_sfc(_sfc_main$15, [["render", _sfc_render$15]]);
var DropdownItem_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$14 = defineComponent({
  name: "DropdownItem",
  components: { ButtonComponent },
  emits: ["option:click"],
  props: {
    option: {
      type: Object,
      required: true
    }
  },
  setup() {
    return {
      boolToString
    };
  },
  methods: {
    onOptionClick(event, option) {
      const clickEvent = {
        event,
        option
      };
      this.$emit("option:click", clickEvent);
      option.onClick && option.onClick();
    }
  }
});
const _hoisted_1$U = { class: "dropdown-item-root" };
const _hoisted_2$P = {
  key: 0,
  class: "dropdown-container"
};
function _sfc_render$14(_ctx, _cache, $props, $setup, $data, $options) {
  var _a;
  const _component_ButtonComponent = resolveComponent("ButtonComponent");
  const _component_DropdownItem = resolveComponent("DropdownItem", true);
  return openBlock(), createElementBlock("div", _hoisted_1$U, [
    createVNode(_component_ButtonComponent, mergeProps(_ctx.option.props, {
      class: ((_a = _ctx.option.props) == null ? void 0 : _a.class) ? _ctx.option.props.class : "option",
      "data-disabled": _ctx.boolToString(_ctx.option.disabled),
      icon: _ctx.option.icon,
      onClick: _cache[0] || (_cache[0] = withModifiers(($event) => _ctx.onOptionClick($event, _ctx.option), ["stop"]))
    }), {
      default: withCtx(() => [
        createTextVNode(toDisplayString(_ctx.option.title), 1)
      ]),
      _: 1
    }, 16, ["class", "data-disabled", "icon"]),
    _ctx.option.children ? (openBlock(), createElementBlock("div", _hoisted_2$P, [
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.option.children, (optionChild, i) => {
        var _a2;
        return openBlock(), createBlock(_component_DropdownItem, {
          key: i + optionChild.title + ((_a2 = _ctx.option.icon) == null ? void 0 : _a2.src),
          option: optionChild,
          onClick: withModifiers(($event) => _ctx.onOptionClick($event, optionChild), ["stop"])
        }, null, 8, ["option", "onClick"]);
      }), 128))
    ])) : createCommentVNode("", true)
  ]);
}
var DropdownItem = /* @__PURE__ */ _export_sfc(_sfc_main$14, [["render", _sfc_render$14], ["__scopeId", "data-v-e16e3da6"]]);
var DropdownContainer_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$13 = defineComponent({
  name: "DropdownContainer",
  emits: ["option:click", "close"],
  components: {
    DropdownItem
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    open: {
      type: Boolean,
      required: false
    },
    width: {
      type: String,
      required: false
    },
    mode: {
      type: String,
      default: "left"
    },
    gap: { type: String },
    containerProps: {
      type: Object
    }
  },
  data() {
    return {
      current: null,
      heights: {
        dropdownContainer: 300
      }
    };
  },
  watch: {},
  computed: {},
  methods: {
    onOptionClick(clickEvent) {
      this.$emit("option:click", clickEvent);
    }
  }
});
function _sfc_render$13(_ctx, _cache, $props, $setup, $data, $options) {
  var _a;
  const _component_DropdownItem = resolveComponent("DropdownItem");
  return openBlock(), createElementBlock(Fragment, null, [
    _ctx.open ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: "dropdown-exit",
      onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("close")),
      onContextmenu: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("close"))
    }, null, 32)) : createCommentVNode("", true),
    _ctx.open ? (openBlock(), createElementBlock("div", mergeProps({
      key: 1,
      ref: "dropdownContainer"
    }, _ctx.containerProps, {
      style: {
        width: _ctx.width,
        right: _ctx.mode === "right" ? "0" : void 0,
        maxHeight: `${_ctx.heights.dropdownContainer}px`,
        gap: _ctx.gap,
        ...((_a = _ctx.containerProps) == null ? void 0 : _a.style) || {}
      },
      class: "dropdown-container"
    }), [
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.options, (option, i) => {
        return openBlock(), createBlock(_component_DropdownItem, {
          key: i,
          option,
          "onOption:click": _ctx.onOptionClick
        }, null, 8, ["option", "onOption:click"]);
      }), 128))
    ], 16)) : createCommentVNode("", true)
  ], 64);
}
var DropdownContainer = /* @__PURE__ */ _export_sfc(_sfc_main$13, [["render", _sfc_render$13], ["__scopeId", "data-v-841396fe"]]);
const _sfc_main$12 = defineComponent({
  name: "ChevronDownIcon"
});
const _hoisted_1$T = {
  fill: "none",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$O = /* @__PURE__ */ createElementVNode("path", {
  d: "M7.41 8.58L12 13.17L16.59 8.58L18 10L12 16L6 10L7.41 8.58Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3$I = [
  _hoisted_2$O
];
function _sfc_render$12(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1$T, _hoisted_3$I);
}
var ChevronDownIcon = /* @__PURE__ */ _export_sfc(_sfc_main$12, [["render", _sfc_render$12]]);
var DropdownComponent_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$11 = defineComponent({
  name: "DropdownComponent",
  components: {
    ChevronDownIcon,
    DropdownContainer
  },
  emits: ["option:click", "option:default"],
  props: {
    options: {
      type: Array,
      required: true
    },
    classButton: {
      required: false
    },
    containerWidth: {
      type: String,
      required: false
    },
    containerProps: {
      type: Object
    },
    mode: {
      type: String,
      default: "left"
    },
    style: TVuePropTypes.style,
    styleButton: TVuePropTypes.style,
    class: String,
    sort: String
  },
  data() {
    return {
      open: false,
      width: null,
      ICONS
    };
  },
  computed: {
    optionsSortComputed() {
      if (!this.sort) {
        return this.options;
      }
      const funcSort = (label1, label2) => {
        return toStr(label1).localeCompare(toStr(label2));
      };
      return [...this.options].sort(
        (opt1, opt2) => this.sort === "ASC" ? funcSort(opt1.title, opt2.title) : funcSort(opt2.title, opt1.title)
      );
    }
  },
  created() {
    this.$watch(
      () => this.options,
      () => {
        this.initOptions();
      },
      { immediate: true }
    );
  },
  mounted() {
    this.width = `${this.$refs.container.clientWidth}px`;
  },
  methods: {
    onOptionClick(clickEvent) {
      this.open = false;
      this.$emit("option:click", clickEvent);
    },
    initOptions() {
      const defaultOption = this.options.find((x) => x.default);
      if (defaultOption) {
        this.$emit("option:default", defaultOption);
      }
    }
  }
});
function _sfc_render$11(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ChevronDownIcon = resolveComponent("ChevronDownIcon");
  const _component_DropdownContainer = resolveComponent("DropdownContainer");
  return openBlock(), createElementBlock("div", {
    ref: "container",
    class: normalizeClass([this.class, "dropdown-component"]),
    style: normalizeStyle(_ctx.style)
  }, [
    createElementVNode("button", {
      class: normalizeClass(_ctx.classButton),
      style: normalizeStyle(_ctx.styleButton),
      onClick: _cache[0] || (_cache[0] = ($event) => _ctx.open = !_ctx.open)
    }, [
      renderSlot(_ctx.$slots, "default", {}, void 0, true),
      createVNode(_component_ChevronDownIcon, {
        style: normalizeStyle({ transform: _ctx.open ? "rotate(180deg)" : void 0 })
      }, null, 8, ["style"])
    ], 6),
    createVNode(_component_DropdownContainer, {
      "container-props": _ctx.containerProps,
      mode: _ctx.mode,
      open: _ctx.open,
      options: _ctx.optionsSortComputed,
      width: _ctx.containerWidth || _ctx.width,
      onClose: _cache[1] || (_cache[1] = ($event) => _ctx.open = false),
      "onOption:click": _ctx.onOptionClick
    }, null, 8, ["container-props", "mode", "open", "options", "width", "onOption:click"])
  ], 6);
}
var DropdownComponent = /* @__PURE__ */ _export_sfc(_sfc_main$11, [["render", _sfc_render$11], ["__scopeId", "data-v-cb8da7fc"]]);
var AttrInputList_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$10 = defineComponent({
  name: "AttrInputList",
  props: {
    value: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => []
    },
    isStrict: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    "change",
    "input",
    "blur",
    "keydown",
    "focus"
  ],
  data() {
    return {
      id: makeId(5)
    };
  },
  methods: {
    focus() {
      this.$nextTick(() => {
        this.$refs.inputRef.focus();
      });
    },
    onChange(value) {
      this.$emit("change", value);
    },
    onInput(value) {
      this.$emit("input", value);
    },
    onKeyDown(event) {
      event.stopPropagation();
    }
  }
});
const _hoisted_1$S = {
  key: 0,
  class: "attr-input-list"
};
const _hoisted_2$N = ["list", "placeholder", "title", "value"];
const _hoisted_3$H = ["id"];
const _hoisted_4$B = ["value"];
function _sfc_render$10(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock(Fragment, null, [
    _ctx.readOnly ? (openBlock(), createElementBlock("div", _hoisted_1$S, toDisplayString(_ctx.value), 1)) : createCommentVNode("", true),
    !_ctx.readOnly ? (openBlock(), createElementBlock("input", {
      key: 1,
      ref: "inputRef",
      list: _ctx.id,
      placeholder: _ctx.placeholder,
      title: _ctx.title,
      value: _ctx.value,
      class: "attr-input-list",
      onBlur: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("blur", $event)),
      onChange: _cache[1] || (_cache[1] = ($event) => _ctx.onChange($event.target.value)),
      onFocus: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("focus", $event)),
      onInput: _cache[3] || (_cache[3] = ($event) => _ctx.onInput($event.target.value)),
      onKeydown: _cache[4] || (_cache[4] = (...args) => _ctx.onKeyDown && _ctx.onKeyDown(...args))
    }, null, 40, _hoisted_2$N)) : createCommentVNode("", true),
    createElementVNode("datalist", { id: _ctx.id }, [
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.options, (option) => {
        return openBlock(), createElementBlock("option", {
          key: option,
          value: option
        }, null, 8, _hoisted_4$B);
      }), 128))
    ], 8, _hoisted_3$H)
  ], 64);
}
var AttrInputList = /* @__PURE__ */ _export_sfc(_sfc_main$10, [["render", _sfc_render$10], ["__scopeId", "data-v-432fba90"]]);
const CALC_PARAMS = {
  RecalcActivityRadionuclides: {
    header: "\u041F\u0435\u0440\u0435\u0441\u0447\u0451\u0442 \u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u0438 \u0440\u0430\u0434\u0438\u043E\u043D\u0443\u043A\u043B\u0438\u0434\u043E\u0432"
  },
  CalcCodeTerritory: {
    header: "\u041A\u043E\u0434 \u0437\u0430\u0433\u0440\u044F\u0437\u043D\u0451\u043D\u043D\u043E\u0433\u043E \u0440\u0430\u0434\u0438\u043E\u043D\u0443\u043A\u043B\u0438\u0434\u0430\u043C\u0438 \u0443\u0447\u0430\u0441\u0442\u043A\u0430 \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u0438",
    maxSymbols: 6
  },
  CalcCodeStorage: {
    header: "\u041A\u043E\u0434 \u043F\u0443\u043D\u043A\u0442\u0430 \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F",
    maxSymbols: 8
  },
  CalcCodeRao: {
    header: "\u041A\u043E\u0434 \u0420\u0410\u041E",
    maxSymbols: 11
  },
  CalcCodeOyat: {
    header: "\u041A\u043E\u0434 \u041E\u042F\u0422",
    maxSymbols: 5
  },
  CalcCodeWasteWaterReceiver: {
    header: "\u041A\u043E\u0434 \u0442\u0438\u043F\u0430 \u043F\u0440\u0438\u0451\u043C\u043D\u0438\u043A\u0430 \u0441\u0442\u043E\u0447\u043D\u044B\u0445 \u0432\u043E\u0434",
    maxSymbols: 3
  },
  CalcTotalActivityRaoDepletedUraniumProducts: {
    header: "\u0421\u0443\u043C\u043C\u0430\u0440\u043D\u0430\u044F \u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u044C \u0420\u0410\u041E \u0432 \u0432\u0438\u0434\u0435 \u0418\u041E\u0423"
  },
  CalcCategoryRao: {
    header: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F \u0420\u0410\u041E"
  },
  CalcCategoryZri: {
    header: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F \u0417\u0420\u0418",
    maxSymbols: 1
  },
  CalcPeriodPotentialDanger: {
    header: "\u041F\u0435\u0440\u0438\u043E\u0434 \u043F\u043E\u0442\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0439 \u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438 \u0420\u0410\u041E"
  }
};
function getCalcHeader(componentName) {
  var _a, _b, _c, _d;
  return (_d = (_c = (_a = CALC_PARAMS[componentName]) == null ? void 0 : _a.header) != null ? _c : (_b = CALC_PARAMS[componentName.replace("Demo", "")]) == null ? void 0 : _b.header) != null ? _d : componentName;
}
const INIT_CODE_SYMBOL = "_";
var TableCellCalcComponent_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$$ = defineComponent({
  name: "TableCellCalcComponent",
  components: {
    TableCellLabelComponent,
    SearchComponent,
    ModalComponent,
    TableComponent,
    TableMultiHeaders,
    ButtonComponent
  },
  emits: [
    "change",
    "blur",
    "keydown",
    "close",
    "update:modelValue",
    "focus"
  ],
  inheritAttrs: false,
  props: {
    inputClass: {},
    containerClass: {},
    type: {
      type: Object,
      required: true
    },
    modelDto: {
      type: Object,
      required: true
    },
    value: {
      type: [String, Number],
      default: ""
    },
    isEditedCell: {
      type: Boolean,
      default: false
    },
    classes: {
      type: Object,
      default: TABLE_CLASSES
    },
    autofocus: Boolean,
    handlers: { type: Object },
    isValid: Boolean,
    help: String,
    list: String
  },
  setup() {
    return {
      ICONS,
      CALC_PARAMS
    };
  },
  data() {
    return {
      init: false,
      show: {
        modal: false
      },
      modelValue: this.value || ""
    };
  },
  created() {
    this.onInit();
  },
  mounted() {
  },
  methods: {
    onOpenComponent(componentName) {
      TDynamicModalService.show({
        inject: ["api"],
        template: `<component is="${componentName}" @close="api.modal.close(this)"/>`
      });
    },
    onAnyFocus(event) {
      this.$emit("focus", event);
    },
    onCellEditInput(event) {
      const el = event.target;
      this.$emit("update:modelValue", el.value);
      this.modelValue = el.value;
    },
    focusInput() {
      this.$refs.inputRef.focus();
    },
    focus() {
      return this.focusInput();
    },
    onFocusOut(event) {
      var _a;
      if (!this.isEditedCell) {
        return;
      }
      if (event.relatedTarget !== ((_a = this.$refs.calcButton) == null ? void 0 : _a.$el)) {
        this.$emit("blur");
      }
    },
    async onInit() {
      this.show.modal = false;
      this.modelValue = this.value || "";
    },
    confirm() {
      this.$emit("change", this.modelValue);
    },
    onClose() {
      this.modelValue = this.value || "";
      this.$emit("close");
    },
    hideModal() {
      this.show.modal = false;
    },
    setShowModal(modal) {
      this.show.modal = modal;
    }
  },
  computed: {},
  watch: {
    value() {
      if (this.value === this.modelValue) {
        return;
      }
      this.modelValue = this.value || "";
    },
    isEditedCell() {
      if (this.isEditedCell) {
        this.modelValue = this.value || "";
        this.onInit();
        if (this.autofocus) {
          this.$nextTick(() => {
            if (!this.show.modal) {
              this.focusInput();
            }
          });
        }
      }
    }
  }
});
const _hoisted_1$R = ["list", "maxlength", "value"];
const _hoisted_2$M = { style: { "width": "calc(100vw - 50px)" } };
const _hoisted_3$G = { class: "cell-calc-header" };
const _hoisted_4$A = { class: "cell-calc-header-name" };
const _hoisted_5$q = { class: "cell-calc-header-toolbar" };
const _hoisted_6$l = {
  key: 1,
  class: "calc-label-block"
};
function _sfc_render$$(_ctx, _cache, $props, $setup, $data, $options) {
  var _a;
  const _component_ButtonComponent = resolveComponent("ButtonComponent");
  const _component_ModalComponent = resolveComponent("ModalComponent");
  const _component_TableCellLabelComponent = resolveComponent("TableCellLabelComponent");
  return openBlock(), createElementBlock(Fragment, null, [
    _ctx.isEditedCell ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
      createElementVNode("div", {
        class: normalizeClass(_ctx.containerClass),
        style: { "display": "flex", "gap": "5px" }
      }, [
        createElementVNode("input", {
          ref: "inputRef",
          class: normalizeClass(_ctx.inputClass),
          list: _ctx.list,
          maxlength: _ctx.CALC_PARAMS[_ctx.type.calc_type].maxSymbols,
          value: _ctx.modelValue,
          onFocus: _cache[0] || (_cache[0] = (...args) => _ctx.onAnyFocus && _ctx.onAnyFocus(...args)),
          onFocusout: _cache[1] || (_cache[1] = (...args) => _ctx.onFocusOut && _ctx.onFocusOut(...args)),
          onInput: _cache[2] || (_cache[2] = (...args) => _ctx.onCellEditInput && _ctx.onCellEditInput(...args)),
          onKeydown: _cache[3] || (_cache[3] = ($event) => _ctx.$emit("keydown", $event)),
          onPaste: _cache[4] || (_cache[4] = withModifiers(() => {
          }, ["stop"]))
        }, null, 42, _hoisted_1$R),
        createVNode(_component_ButtonComponent, {
          ref: "calcButton",
          icon: _ctx.ICONS.calculatorVariantOutline,
          class: "button-opacity",
          tabindex: "-1",
          onClick: _cache[5] || (_cache[5] = ($event) => _ctx.show.modal = true)
        }, null, 8, ["icon"])
      ], 2),
      _ctx.show.modal ? (openBlock(), createBlock(_component_ModalComponent, {
        key: 0,
        "is-show-body-close-button": true,
        visible: _ctx.init,
        "body-style": "padding: 0; max-height: calc(100vh - 25px);",
        onClose: _ctx.onClose
      }, {
        body: withCtx(({ close }) => [
          createElementVNode("div", _hoisted_2$M, [
            createElementVNode("div", _hoisted_3$G, [
              createElementVNode("div", _hoisted_4$A, toDisplayString(_ctx.CALC_PARAMS[_ctx.type.calc_type].header), 1),
              createElementVNode("div", _hoisted_5$q, [
                createElementVNode("button", {
                  class: "form-button",
                  "data-type": "accent",
                  style: { "min-width": "167px" },
                  onClick: _cache[6] || (_cache[6] = (...args) => _ctx.confirm && _ctx.confirm(...args))
                }, " \u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C \u0432\u0432\u043E\u0434 ")
              ])
            ])
          ]),
          (openBlock(), createBlock(resolveDynamicComponent(_ctx.type.calc_type), {
            ref: "calcComponent",
            modelValue: _ctx.modelValue,
            "show-confirm-button": "",
            onClose: close,
            onInit: _cache[7] || (_cache[7] = ($event) => _ctx.init = true),
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => _ctx.modelValue = $event),
            "onOpen:component": _ctx.onOpenComponent
          }, null, 40, ["modelValue", "onClose", "onOpen:component"]))
        ]),
        _: 1
      }, 8, ["visible", "onClose"])) : createCommentVNode("", true)
    ], 64)) : createCommentVNode("", true),
    !_ctx.isEditedCell ? (openBlock(), createElementBlock("div", _hoisted_6$l, [
      createVNode(_component_TableCellLabelComponent, {
        "before-label": (_a = _ctx.handlers) == null ? void 0 : _a.before_label,
        help: _ctx.help,
        "is-valid": _ctx.isValid,
        label: _ctx.value
      }, null, 8, ["before-label", "help", "is-valid", "label"])
    ])) : createCommentVNode("", true)
  ], 64);
}
var TableCellCalcComponent = /* @__PURE__ */ _export_sfc(_sfc_main$$, [["render", _sfc_render$$], ["__scopeId", "data-v-d5e2649c"]]);
var TableCellModalComponent_vue_vue_type_style_index_0_lang = "";
const _sfc_main$_ = defineComponent({
  name: "TableCellModalComponent",
  components: {
    CircleLoader,
    SearchComponent,
    ModalComponent,
    TableComponent,
    TableMultiHeaders,
    SwitchComponent,
    TablePaginationBottom,
    TableCellLabelComponent,
    ButtonComponent,
    CloseIcon
  },
  emits: [
    "change",
    "blur",
    "keydown",
    "focus",
    "update:inputValue"
  ],
  props: {
    inputClass: {},
    containerClass: {},
    inputStyle: TVuePropTypes.style,
    model: {
      type: Object,
      required: true
    },
    value: {
      type: String,
      default: ""
    },
    isEditedCell: {
      type: Boolean,
      default: false
    },
    isTableCell: {
      type: Boolean,
      default: false
    },
    types: {
      type: Object,
      required: true
    },
    autofocus: Boolean,
    handlers: {
      type: Object
    },
    validationHandlers: {
      type: Object,
      default: VALIDATION_HANDLERS
    },
    globalHandlers: { type: Object },
    isValid: Boolean,
    help: String,
    readOnly: Boolean
  },
  setup() {
    return {
      ICONS,
      declension,
      inputListId: makeId(10),
      boolToString,
      Logger: Logger$1
    };
  },
  data() {
    return {
      show: {
        modal: false
      },
      inputValue: ""
    };
  },
  async created() {
    this.$watch(
      () => this.show.modal,
      () => {
        if (this.show.modal) {
          this.init();
        }
      }
    );
    this.$watch(
      () => this.isEditedCell,
      () => {
        if (this.isEditedCell) {
          this.initInput();
          if (this.show.modal) {
            this.init();
          }
          if (this.autofocus) {
            this.$nextTick(() => this.focus());
          }
        }
      }
    );
    this.$watch(
      () => this.value,
      () => {
        var _a, _b;
        if (((_a = this.value) != null ? _a : "") !== this.inputValue) {
          this.inputValue = (_b = this.value) != null ? _b : "";
        }
      }
    );
  },
  deactivated() {
  },
  async mounted() {
  },
  computed: {
    inputStyleComputed() {
      return [{ lineHeight: "100%" }, this.inputStyle];
    },
    labelBlockClass() {
      const classObj = {};
      classObj["voc-label-block-readonly"] = this.readOnly;
      if (this.containerClass) {
        if (typeof this.containerClass === "string") {
          classObj[this.containerClass] = true;
        } else {
          classObj.containerClass = this.containerClass;
        }
      }
      return classObj;
    },
    label() {
      return TableCell.getLabelByValue(
        this.value,
        this.type,
        this.model
      );
    },
    type() {
      return this.types[this.model.type];
    }
  },
  methods: {
    onAnyFocus(event) {
      this.$emit("focus", event);
    },
    async init() {
      const modalName = this.type.modal_name;
      const modalUrl = this.type.modal_url;
      if (!modalName && !modalUrl) {
        return;
      }
      try {
        const context = {
          model: this.model,
          type: this.type,
          globalHandlers: this.globalHandlers,
          validationHandlers: this.validationHandlers
        };
        const result = await TDynamicModalService.show(modalUrl != null ? modalUrl : `/api/modals?name=${modalName}`, context);
        if (result) {
          this.inputValue = toStr(result.value);
        }
        this.confirmAndFocusInput();
      } catch (ex) {
        Logger$1.error(
          `\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043E\u0436\u0438\u0434\u0430\u043D\u0438\u0438 \u043C\u043E\u0434\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u043E\u043A\u043D\u0430 "${this.type.modal_name}", \u0430\u0442\u0440\u0438\u0431\u0443\u0442 "${this.model.field}"`,
          ex
        );
      }
      this.show.modal = false;
    },
    focus() {
      var _a;
      (_a = this.$refs.inputRef) == null ? void 0 : _a.focus();
    },
    confirm() {
      this.$emit("change", {
        value: this.inputValue
      });
    },
    confirmAndFocusInput() {
      this.confirm();
      this.focus();
    },
    initInput() {
      this.show.modal = false;
    },
    setShowModal(modal) {
      this.show.modal = modal;
    },
    onInputFocus(event) {
      this.onAnyFocus(event);
      if (this.show.modal) {
        return;
      }
    },
    onFocusOut(event) {
      var _a;
      if (!this.isEditedCell) {
        return;
      }
      if (this.show.modal) {
        event.stopPropagation();
        return;
      }
      if (event.relatedTarget !== ((_a = this.$refs.modalButton) == null ? void 0 : _a.$el)) {
        event.stopPropagation();
        this.$nextTick(() => {
          this.confirm();
        });
      }
    },
    onCellEditInput(event) {
      const el = event.target;
      this.inputValue = el.value;
      this.$emit("update:inputValue", this.inputValue);
    },
    onCellEditKeyDown(event) {
      const eventHelper = new KeyboardEventHelper(event);
      if (eventHelper.keyTab.keyEnter.isAnyTrue) {
        this.confirmAndFocusInput();
      }
      this.$emit("keydown", event);
    }
  }
});
const _hoisted_1$Q = ["list", "value"];
function _sfc_render$_(_ctx, _cache, $props, $setup, $data, $options) {
  var _a;
  const _component_ButtonComponent = resolveComponent("ButtonComponent");
  const _component_TableCellLabelComponent = resolveComponent("TableCellLabelComponent");
  return openBlock(), createElementBlock(Fragment, null, [
    withDirectives(createElementVNode("div", {
      class: normalizeClass([_ctx.containerClass, "table-cell-voc-container"])
    }, [
      createElementVNode("input", {
        ref: "inputRef",
        class: normalizeClass(_ctx.inputClass),
        list: _ctx.inputListId,
        style: normalizeStyle(_ctx.inputStyleComputed),
        value: _ctx.inputValue,
        onFocus: _cache[0] || (_cache[0] = (...args) => _ctx.onInputFocus && _ctx.onInputFocus(...args)),
        onFocusout: _cache[1] || (_cache[1] = (...args) => _ctx.onFocusOut && _ctx.onFocusOut(...args)),
        onInput: _cache[2] || (_cache[2] = (...args) => _ctx.onCellEditInput && _ctx.onCellEditInput(...args)),
        onKeydown: _cache[3] || (_cache[3] = (...args) => _ctx.onCellEditKeyDown && _ctx.onCellEditKeyDown(...args)),
        onPaste: _cache[4] || (_cache[4] = withModifiers(() => {
        }, ["stop"]))
      }, null, 46, _hoisted_1$Q),
      createVNode(_component_ButtonComponent, {
        ref: "modalButton",
        icon: _ctx.ICONS.chevronDownAccent,
        class: "button-opacity",
        style: { "width": "24px", "height": "24px" },
        tabindex: "-1",
        onClick: _cache[5] || (_cache[5] = ($event) => _ctx.show.modal = true)
      }, null, 8, ["icon"])
    ], 2), [
      [vShow, _ctx.isEditedCell]
    ]),
    !_ctx.isEditedCell ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: normalizeClass([_ctx.labelBlockClass, "voc-label-block"])
    }, [
      createVNode(_component_TableCellLabelComponent, {
        "before-label": (_a = _ctx.handlers) == null ? void 0 : _a.before_label,
        help: _ctx.help,
        "is-valid": _ctx.isValid,
        label: _ctx.label,
        class: "table-div-span"
      }, null, 8, ["before-label", "help", "is-valid", "label"])
    ], 2)) : createCommentVNode("", true)
  ], 64);
}
var TableCellModalComponent = /* @__PURE__ */ _export_sfc(_sfc_main$_, [["render", _sfc_render$_]]);
var AttrInputBase_vue_vue_type_style_index_0_lang = "";
const _sfc_main$Z = defineComponent({
  name: "AttrInputBase",
  components: {
    TableCellModalComponent,
    AttrInputList,
    TDatePicker,
    TableCellCalcComponent,
    ButtonComponent,
    CircleLoader
  },
  props: {
    value: {
      required: false
    },
    model: {
      type: Object,
      required: true
    },
    type: {
      type: Object,
      required: false,
      default: DEFAULT_REPOSITORY_READ_TYPE_DTO
    },
    types: {
      type: Object,
      required: false,
      default: () => ({})
    },
    isSaving: {
      type: Boolean,
      required: false
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    isHideReset: {
      type: Boolean,
      default: false
    },
    isHideCaption: {
      type: Boolean,
      default: false
    },
    style: {
      type: TVuePropTypes.style,
      required: false
    },
    class: {
      type: TVuePropTypes.class,
      required: false
    },
    priorityStyle: {
      type: TVuePropTypes.style,
      required: false
    },
    defaultStyle: {
      type: TVuePropTypes.style,
      required: false
    },
    forceUpdateValueProp: {
      required: false
    },
    changeDebounce: {
      type: Number,
      default: 0
    },
    uniqueId: {
      type: String,
      required: false,
      default: "default"
    },
    caption: {
      type: String,
      required: false
    },
    customHelp: Boolean,
    emptyHelp: {
      type: String,
      required: false
    },
    validationHandlers: {
      type: Object,
      default: VALIDATION_HANDLERS
    },
    list: String,
    globalHandlers: { type: Object },
    serverDateFormat: {
      type: String,
      default: SERVER_DATE_FORMAT
    },
    displayDateFormat: {
      type: String,
      default: DISPLAY_DATE_FORMAT
    },
    autofocus: Boolean
  },
  emits: [
    "change",
    "reset",
    "click-help",
    "focus",
    "update:inputValue"
  ],
  setup() {
    return {
      ICONS,
      isNullOrUndefined
    };
  },
  data() {
    return {
      newValue: null,
      forceNewValue: {},
      modelVoc: null,
      isInputFocus: false
    };
  },
  async created() {
    if (this.changeDebounce > 0) {
      this.onChange = debounce(this.onChange, this.changeDebounce);
    }
    this.setNewValue(this.value, false);
    this.$watch(
      () => this.model,
      async () => {
        this.modelVoc = null;
        await this.initVoc();
      },
      { immediate: true }
    );
  },
  async mounted() {
    if (this.autofocus) {
      this.focus();
    }
  },
  computed: {
    inputSelectStyle() {
      return {
        background: `url('${ICONS.chevronDownAccent.src}') no-repeat right transparent`
      };
    },
    beforeLabel() {
      return this.handlers.before_label;
    },
    labelComputed() {
      let label = this.label;
      if (this.beforeLabel) {
        TableHandlersHelper.executeBeforeLabel(
          this.beforeLabel,
          label,
          (newValue) => {
            label = newValue;
          }
        );
      }
      return label;
    },
    captionComputed() {
      return this.caption || this.model.caption;
    },
    heightComputed() {
      const height = this.model.height;
      if (!height) {
        return void 0;
      }
      if (isNumeric(height)) {
        return `${height}px`;
      }
      return height;
    },
    isShowCaption() {
      if (this.isHideCaption) {
        return false;
      }
      return !this.isEmptyNewValue || ["DICT", "VOC", "CALC", "MODAL"].includes(this.baseType);
    },
    isEmptyNewValue() {
      return this.newValue === "" || isNullOrUndefined(this.newValue);
    },
    handlersDto() {
      return ModelHelper.getHandlers(
        this.model,
        this.type,
        this.globalHandlers
      );
    },
    handlers() {
      return TableHandlersHelper.getHandlers(this.handlersDto);
    },
    styleComputed() {
      const style = [];
      if (this.style || this.defaultStyle) {
        style.push(this.style || this.defaultStyle);
      }
      if (this.heightComputed !== void 0) {
        style.push({
          gridColumnStart: 1,
          gridColumnEnd: -1,
          width: "100%"
        });
      }
      if (this.model.width) {
        style.push({ width: this.model.width });
      }
      if (this.model.style) {
        style.push(this.model.style);
      }
      if (this.priorityStyle) {
        style.push(this.priorityStyle);
      }
      return style;
    },
    validError() {
      return getValidError(
        this.model,
        this.type,
        this.newValue,
        this.validationHandlers
      );
    },
    isValid() {
      return this.validError.type === ValidErrorEnum.Ok;
    },
    baseType() {
      return this.type.base_type || "BASE";
    },
    help() {
      return this.model.help || this.validError.label || this.type.help || this.emptyHelp;
    },
    dateFormat() {
      var _a;
      return ((_a = this.type.validation) == null ? void 0 : _a.date_format) || SERVER_DATE_FORMAT;
    },
    displayDateFormatComputed() {
      var _a;
      return ((_a = this.type.display) == null ? void 0 : _a.date_format) || this.displayDateFormat;
    },
    serverDateFormatComputed() {
      var _a, _b;
      return ((_b = (_a = this.type) == null ? void 0 : _a.validation) == null ? void 0 : _b.date_format) || this.serverDateFormat;
    },
    labelOpts() {
      var _a;
      return {
        vocDataSet: (_a = this.modelVoc) == null ? void 0 : _a.vocDataSet,
        displayDateFormat: this.displayDateFormatComputed,
        serverDateFormat: this.serverDateFormatComputed
      };
    },
    label() {
      return TableCell.getLabelByValue(
        this.newValue,
        this.type,
        this.model,
        this.labelOpts
      );
    }
  },
  watch: {
    forceUpdateValueProp() {
      this.forceNewValue = {};
    },
    value() {
      if (this.newValue !== this.value) {
        this.newValue = this.value;
      }
    }
  },
  methods: {
    setNewValue(newValue, emit) {
      this.newValue = newValue;
      if (emit && this.newValue !== this.value) {
        this.onChange(this.newValue);
      }
    },
    onAnyFocus(event) {
      this.$emit("focus", event);
    },
    async initVoc() {
      if (this.type.base_type !== "VOC") {
        return;
      }
      if (!(this.type.voc_type || this.type.select_form)) {
        Logger$1.error("\u041D\u0435 \u0443\u043A\u0430\u0437\u0430\u043D voc_type \u0438\u043B\u0438 select_form.", this.type);
        return;
      }
      if (this.model) {
        const vocDto = this.type.voc_type ? (await ApiService$1.getVocDict()).json[this.type.voc_type] : void 0;
        const vocDataSet = new VocDataSet(vocDto, this.type, this.uniqueId);
        this.modelVoc = {
          vocDataSet,
          type: this.model.type,
          modelDto: this.model
        };
      }
    },
    onChange(value) {
      if (this.value === value) {
        return;
      }
      this.$emit("change", value);
    },
    onInput(event) {
      this.setNewValue(event.target.value, false);
    },
    onBlur(event) {
      this.isInputFocus = false;
      if (this.readOnly) {
        return;
      }
      this.onBeforeSave(event.target.value, (value) => {
        event.target.value = value;
      });
      this.onChange(event.target.value);
    },
    onFocus(event) {
      this.isInputFocus = true;
      this.onAnyFocus(event);
    },
    onBeforeSave(value, setValue) {
      if (this.readOnly) {
        return;
      }
      TableHandlersHelper.executeBeforeSave(
        this.handlers.before_save,
        value,
        (newValue) => {
          this.newValue = newValue;
          setValue(newValue);
        }
      );
    },
    onChangeSelect(event) {
      const target = event.target;
      const value = target.value;
      this.$emit("change", value);
    },
    onInputList(value) {
      this.$emit("change", value);
    },
    onHelp(title, text) {
      if (this.customHelp) {
        const getHelp = () => this.help;
        this.$emit("click-help", {
          model: this.model,
          get help() {
            return getHelp();
          }
        });
        return;
      }
      NotificationsService$1.send({
        title,
        text,
        duration: 1e4,
        type: "warn"
      });
    },
    onKeyDown(event) {
      if (new KeyboardEventHelper(event).keyArrowDown.pressAlt.isAllTrue) {
        const typeComponent = this.getRefByType();
        if (typeComponent == null ? void 0 : typeComponent.setShowModal) {
          typeComponent.setShowModal(true);
        }
      }
    },
    getVocComponent() {
      return this.$refs.vocRef;
    },
    getModalComponent() {
      return this.$refs.modalRef;
    },
    getCalcComponent() {
      return this.$refs.calcRef;
    },
    getRefByType() {
      var _a;
      switch ((_a = this.type) == null ? void 0 : _a.base_type) {
        case "BASE":
        case void 0:
        case null:
          return this.$refs.inputRef;
        case "LIST":
          return this.$refs.listRef;
        case "VOC":
          return this.$refs.vocRef;
        case "DICT":
          return this.$refs.dictRef;
        case "JSON":
          break;
        case "DATE": {
          return this.$refs.inputDate;
        }
        case "CALC":
          return this.$refs.calcRef;
        case "MODAL":
          return this.$refs.modalRef;
      }
      return void 0;
    },
    focus() {
      const refByType = this.getRefByType();
      if (refByType && refByType.focus) {
        refByType.focus();
      }
    }
  }
});
const _hoisted_1$P = ["data-invalid", "title"];
const _hoisted_2$L = ["data-field"];
const _hoisted_3$F = ["list", "placeholder", "readonly", "title", "value"];
const _hoisted_4$z = ["list", "placeholder", "readonly", "title", "value"];
const _hoisted_5$p = {
  key: 2,
  class: "attr-container-select"
};
const _hoisted_6$k = ["disabled", "title"];
const _hoisted_7$g = ["selected"];
const _hoisted_8$b = ["selected", "value"];
const _hoisted_9$b = { class: "attr-input-container__indicators" };
const _hoisted_10$b = {
  key: 0,
  class: "attr-input-container__indicator",
  style: { "color": "blue" }
};
function _sfc_render$Z(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TDatePicker = resolveComponent("TDatePicker");
  const _component_AttrInputList = resolveComponent("AttrInputList");
  const _component_TableCellVocComponent = resolveComponent("TableCellVocComponent");
  const _component_CircleLoader = resolveComponent("CircleLoader");
  const _component_TableCellModalComponent = resolveComponent("TableCellModalComponent");
  const _component_TableCellCalcComponent = resolveComponent("TableCellCalcComponent");
  const _component_ButtonComponent = resolveComponent("ButtonComponent");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass([this.class, "attr-input-container"]),
    "data-invalid": !_ctx.isValid,
    style: normalizeStyle(_ctx.styleComputed),
    title: _ctx.help
  }, [
    createElementVNode("label", {
      "data-field": _ctx.model.field,
      class: "attr-input-label"
    }, [
      createElementVNode("span", {
        style: normalizeStyle({
          opacity: _ctx.isShowCaption ? "1" : "0"
        }),
        class: "caption"
      }, toDisplayString(_ctx.captionComputed), 5),
      _ctx.type.base_type === "BASE" ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        _ctx.heightComputed === void 0 ? (openBlock(), createElementBlock("input", {
          key: 0,
          ref: "inputRef",
          list: _ctx.list,
          placeholder: _ctx.captionComputed,
          readonly: _ctx.readOnly,
          title: _ctx.captionComputed,
          value: _ctx.readOnly || !_ctx.isInputFocus ? _ctx.labelComputed : _ctx.newValue,
          class: "attr-input-input",
          onBlur: _cache[0] || (_cache[0] = (...args) => _ctx.onBlur && _ctx.onBlur(...args)),
          onFocus: _cache[1] || (_cache[1] = (...args) => _ctx.onFocus && _ctx.onFocus(...args)),
          onInput: _cache[2] || (_cache[2] = (...args) => _ctx.onInput && _ctx.onInput(...args))
        }, null, 40, _hoisted_3$F)) : (openBlock(), createElementBlock("textarea", {
          key: 1,
          ref: "textareaRef",
          list: _ctx.list,
          placeholder: _ctx.captionComputed,
          readonly: _ctx.readOnly,
          style: normalizeStyle({ height: _ctx.heightComputed }),
          title: _ctx.captionComputed,
          value: _ctx.newValue,
          class: "attr-input-input",
          onFocus: _cache[3] || (_cache[3] = (...args) => _ctx.onAnyFocus && _ctx.onAnyFocus(...args)),
          onInput: _cache[4] || (_cache[4] = (...args) => _ctx.onInput && _ctx.onInput(...args))
        }, null, 44, _hoisted_4$z))
      ], 64)) : _ctx.type.base_type === "DATE" ? (openBlock(), createBlock(_component_TDatePicker, {
        key: 1,
        ref: "inputDate",
        "display-format": _ctx.displayDateFormatComputed,
        forceChangeModelValue: _ctx.forceNewValue,
        format: _ctx.dateFormat,
        list: _ctx.list,
        modelValue: _ctx.newValue,
        placeholder: _ctx.captionComputed,
        readonly: _ctx.readOnly,
        class: "attr-input-date",
        inputClass: "attr-input-input",
        onFocus: _ctx.onAnyFocus,
        onFocusout: _cache[5] || (_cache[5] = ($event) => _ctx.forceNewValue = {}),
        onPaste: _cache[6] || (_cache[6] = withModifiers(() => {
        }, ["stop"])),
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => _ctx.setNewValue($event, false)),
        onBlur: _cache[8] || (_cache[8] = ($event) => _ctx.setNewValue(_ctx.newValue, true)),
        onKeydown: _cache[9] || (_cache[9] = withKeys(($event) => _ctx.forceNewValue = {}, ["enter"]))
      }, null, 8, ["display-format", "forceChangeModelValue", "format", "list", "modelValue", "placeholder", "readonly", "onFocus"])) : _ctx.type.base_type === "DICT" ? (openBlock(), createElementBlock("div", _hoisted_5$p, [
        createElementVNode("select", {
          ref: "dictRef",
          disabled: _ctx.readOnly,
          style: normalizeStyle(_ctx.inputSelectStyle),
          title: _ctx.captionComputed,
          class: "attr-input-select",
          onFocus: _cache[10] || (_cache[10] = (...args) => _ctx.onAnyFocus && _ctx.onAnyFocus(...args)),
          onChange: _cache[11] || (_cache[11] = (...args) => _ctx.onChangeSelect && _ctx.onChangeSelect(...args))
        }, [
          createElementVNode("option", {
            selected: !_ctx.newValue || _ctx.newValue === "",
            value: ""
          }, " -- \u043D\u0435 \u0432\u044B\u0431\u0440\u0430\u043D\u043E -- ", 8, _hoisted_7$g),
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.type.data_source, (valueLabel, valueKey) => {
            return openBlock(), createElementBlock("option", {
              key: valueKey,
              selected: _ctx.isNullOrUndefined(_ctx.newValue) ? false : "" + _ctx.newValue === valueKey,
              value: valueKey
            }, toDisplayString(valueLabel), 9, _hoisted_8$b);
          }), 128))
        ], 44, _hoisted_6$k)
      ])) : _ctx.type.base_type === "LIST" ? (openBlock(), createBlock(_component_AttrInputList, {
        key: 3,
        ref: "listRef",
        "is-strict": _ctx.type.strict,
        options: _ctx.type.data_source,
        placeholder: _ctx.captionComputed,
        "read-only": _ctx.readOnly,
        title: _ctx.captionComputed,
        value: _ctx.readOnly ? _ctx.labelComputed : _ctx.newValue,
        onFocus: _ctx.onAnyFocus,
        onInput: _ctx.onInputList
      }, null, 8, ["is-strict", "options", "placeholder", "read-only", "title", "value", "onFocus", "onInput"])) : _ctx.type.base_type === "VOC" ? (openBlock(), createElementBlock(Fragment, { key: 4 }, [
        _ctx.modelVoc ? (openBlock(), createBlock(_component_TableCellVocComponent, {
          key: 0,
          ref: "vocRef",
          "global-handlers": _ctx.globalHandlers,
          handlers: _ctx.handlers,
          help: _ctx.help,
          "is-edited-cell": !_ctx.readOnly,
          "is-valid": _ctx.isValid,
          model: _ctx.modelVoc,
          "read-only": _ctx.readOnly,
          types: _ctx.types,
          "unique-id": _ctx.uniqueId + "_" + _ctx.model.field,
          "validation-handlers": _ctx.validationHandlers,
          value: _ctx.newValue,
          "force-change-model-value": _ctx.forceNewValue,
          containerClass: "attr-container-voc",
          inputClass: "attr-input-input attr-input-voc",
          onChange: _cache[12] || (_cache[12] = ($event) => {
            var _a, _b;
            _ctx.setNewValue($event.value, true);
            (_a = _ctx.$refs.vocRef) == null ? void 0 : _a.setShowModal(false);
            (_b = _ctx.$refs.vocRef) == null ? void 0 : _b.updateInputValue();
          }),
          onClose: _cache[13] || (_cache[13] = ($event) => {
            var _a;
            return (_a = _ctx.$refs.vocRef) == null ? void 0 : _a.setShowModal(false);
          }),
          onFocus: _ctx.onAnyFocus,
          onKeydown: _ctx.onKeyDown
        }, {
          "voc-header-toolbar-start": withCtx((payload) => [
            renderSlot(_ctx.$slots, "voc-header-toolbar-start", normalizeProps(guardReactiveProps(payload)))
          ]),
          _: 3
        }, 8, ["global-handlers", "handlers", "help", "is-edited-cell", "is-valid", "model", "read-only", "types", "unique-id", "validation-handlers", "value", "force-change-model-value", "onFocus", "onKeydown"])) : (openBlock(), createBlock(_component_CircleLoader, {
          key: 1,
          style: { "padding-left": "2px", "padding-bottom": "2px" }
        }))
      ], 64)) : _ctx.type.base_type === "MODAL" ? (openBlock(), createBlock(_component_TableCellModalComponent, {
        key: 5,
        ref: "modalRef",
        "global-handlers": _ctx.globalHandlers,
        handlers: _ctx.handlers,
        help: _ctx.help,
        "is-edited-cell": !_ctx.readOnly,
        "is-valid": _ctx.isValid,
        model: _ctx.model,
        "read-only": _ctx.readOnly,
        types: _ctx.types,
        "validation-handlers": _ctx.validationHandlers,
        value: _ctx.newValue,
        containerClass: "attr-container-voc",
        inputClass: "attr-input-input attr-input-voc",
        onChange: _cache[14] || (_cache[14] = ($event) => _ctx.setNewValue($event.value, true)),
        onFocus: _ctx.onAnyFocus,
        onKeydown: _ctx.onKeyDown,
        "onUpdate:inputValue": _cache[15] || (_cache[15] = ($event) => _ctx.$emit("update:inputValue", $event))
      }, null, 8, ["global-handlers", "handlers", "help", "is-edited-cell", "is-valid", "model", "read-only", "types", "validation-handlers", "value", "onFocus", "onKeydown"])) : _ctx.type.base_type === "CALC" ? (openBlock(), createBlock(_component_TableCellCalcComponent, {
        key: 6,
        ref: "calcRef",
        modelValue: _ctx.newValue,
        "onUpdate:modelValue": [
          _cache[16] || (_cache[16] = ($event) => _ctx.newValue = $event),
          _cache[20] || (_cache[20] = ($event) => _ctx.setNewValue($event, false))
        ],
        handlers: _ctx.handlers,
        help: _ctx.help,
        "is-valid": _ctx.isValid,
        isEditedCell: !_ctx.readOnly,
        list: _ctx.list,
        "model-dto": _ctx.model,
        type: _ctx.type,
        value: _ctx.value,
        containerClass: "attr-container-calc",
        inputClass: "attr-input-input attr-input-calc",
        onChange: _cache[17] || (_cache[17] = ($event) => {
          var _a;
          _ctx.setNewValue($event, true);
          (_a = _ctx.$refs.calcRef) == null ? void 0 : _a.setShowModal(false);
        }),
        onClose: _cache[18] || (_cache[18] = ($event) => _ctx.getCalcComponent().setShowModal(false)),
        onFocus: _ctx.onAnyFocus,
        onKeydown: _ctx.onKeyDown,
        onBlur: _cache[19] || (_cache[19] = ($event) => _ctx.setNewValue(_ctx.newValue, true))
      }, null, 8, ["modelValue", "handlers", "help", "is-valid", "isEditedCell", "list", "model-dto", "type", "value", "onFocus", "onKeydown"])) : (openBlock(), createElementBlock(Fragment, { key: 7 }, [
        createTextVNode(" \u0422\u0438\u043F '" + toDisplayString(_ctx.baseType) + "' \u043D\u0435 \u0440\u0435\u0430\u043B\u0438\u0437\u043E\u0432\u0430\u043D", 1)
      ], 64))
    ], 8, _hoisted_2$L),
    !_ctx.isHideReset && !_ctx.model.hide_reset && !_ctx.readOnly ? (openBlock(), createBlock(_component_ButtonComponent, {
      key: 0,
      disabled: _ctx.readOnly,
      icon: _ctx.ICONS.arrowULeftTop,
      class: "button-opacity attr-input-container__reset",
      tabindex: "-1",
      onClick: _cache[21] || (_cache[21] = ($event) => {
        _ctx.$emit("reset");
        _ctx.forceNewValue = {};
      })
    }, null, 8, ["disabled", "icon"])) : createCommentVNode("", true),
    createElementVNode("div", _hoisted_9$b, [
      _ctx.isSaving ? (openBlock(), createElementBlock("div", _hoisted_10$b, " \u2022 ")) : createCommentVNode("", true),
      _ctx.help ? (openBlock(), createBlock(_component_ButtonComponent, {
        key: 1,
        icon: _ctx.ICONS.faq,
        title: _ctx.help,
        class: "button-opacity",
        style: { "pointer-events": "auto" },
        tabindex: "-1",
        onClick: _cache[22] || (_cache[22] = ($event) => _ctx.onHelp(_ctx.captionComputed, _ctx.help))
      }, null, 8, ["icon", "title"])) : createCommentVNode("", true)
    ])
  ], 14, _hoisted_1$P);
}
var AttrInputBase = /* @__PURE__ */ _export_sfc(_sfc_main$Z, [["render", _sfc_render$Z]]);
var TSelectComponent_vue_vue_type_style_index_0_lang = "";
const _sfc_main$Y = defineComponent({
  name: "TSelectComponent",
  components: {
    SearchComponent,
    ButtonComponent
  },
  emits: ["update:modelValue", "reset", "options-url:loaded", "delete"],
  props: {
    invalid: Boolean,
    saving: Boolean,
    title: String,
    modelValue: {
      type: [String, Number, Object],
      required: false
    },
    placeholder: String,
    help: String,
    footerHelp: String,
    caption: String,
    required: Boolean,
    options: {
      default: () => {
      }
    },
    optionsGroup: {
      type: Object,
      default: void 0
    },
    optionsUrl: {
      type: String,
      required: false
    },
    optionsUrlDefaultKey: String,
    excludedValues: {
      type: Array,
      default: () => []
    },
    error: String,
    isValueView: Boolean,
    multiselect: Boolean,
    reselectInitValue: Boolean,
    autoselectIfNotExist: Boolean,
    sort: String,
    autoselect: Boolean,
    autoselectMaxCount: {
      type: Number,
      default: void 0
    },
    includeFilter: {
      type: String,
      default: ""
    },
    readonly: Boolean,
    showSearch: {
      type: Boolean,
      default: true
    },
    showReset: {
      type: Boolean,
      default: true
    },
    showDelete: {
      type: Boolean
    }
  },
  setup() {
    return {
      ICONS,
      toStr,
      boolToString
    };
  },
  data() {
    return {
      show: {
        options: false
      },
      optionsLoaded: null,
      search: ""
    };
  },
  async created() {
    await this.loadOptionsUrl();
    this.executeAutoSelect();
    this.executeReselectInitValue();
    watch(
      () => this.options,
      () => {
        if (this.autoselectIfNotExist && !this.multiselect && this.modelValueComputed && this.optionsSortAndFilterComputed.length) {
          const currentFindValue = this.optionsSortAndFilterComputed.find(
            (x) => x.value === this.modelValueComputed.value
          );
          if (!currentFindValue) {
            this.onSelectValue(this.optionsSortAndFilterComputed[0]);
          }
        }
      }
    );
  },
  watch: {
    "show.options"() {
      this.search = "";
      if (this.show.options) {
        this.$nextTick(() => {
          const optionsContainer = this.getRefs().optionsContainer;
          if (optionsContainer) {
            optionsContainer.scrollIntoView({
              behavior: "smooth",
              block: "nearest"
            });
          }
        });
      }
    },
    async optionsUrl() {
      this.optionsLoaded = null;
      await this.loadOptionsUrl();
      this.executeAutoSelect();
      this.executeReselectInitValue();
    }
  },
  computed: {
    excludedValuesDict() {
      return this.excludedValues.reduce((value, currentValue) => {
        if (typeof currentValue === "object" && "value" in currentValue) {
          value[currentValue.value] = true;
        } else {
          value[currentValue] = true;
        }
        return value;
      }, {});
    },
    optionsComputed() {
      if (isNullOrUndefined(this.options) || Array.isArray(this.options)) {
        const options = this.optionsLoaded && this.optionsUrl ? this.optionsLoaded : this.options || [];
        return options.filter((x) => this.excludedValuesDict[x.value] !== true);
      }
      if (typeof this.options === "object") {
        return Object.keys(this.options).map((key) => ({
          value: key,
          label: this.options[key]
        }));
      }
      return [];
    },
    optionsSortAndFilterComputed() {
      if (!this.sort) {
        return this.optionsFilterComputed;
      }
      const funcSort = (label1, label2) => {
        return label1.localeCompare(label2);
      };
      return [...this.optionsFilterComputed].sort(
        (opt1, opt2) => this.sort === "ASC" ? funcSort(opt1.label, opt2.label) : funcSort(opt2.label, opt1.label)
      );
    },
    optionsFilterComputed() {
      var _a;
      const search = this.search.toLowerCase();
      let optionsFiltered = this.optionsComputed;
      if (search.length) {
        optionsFiltered = optionsFiltered.filter((x) => {
          var _a2, _b, _c, _d;
          if (((_a2 = x.label) == null ? void 0 : _a2.toLowerCase) && ((_b = x.label) == null ? void 0 : _b.toLowerCase().includes(search))) {
            return true;
          }
          if (((_c = x.value) == null ? void 0 : _c.includes) && ((_d = x.value) == null ? void 0 : _d.includes(search))) {
            return true;
          }
          return false;
        });
      }
      const includeFilter = (_a = this.includeFilter) == null ? void 0 : _a.toLowerCase();
      if (includeFilter.length) {
        optionsFiltered = optionsFiltered.filter(
          (x) => {
            var _a2, _b;
            return ((_a2 = x.value) == null ? void 0 : _a2.toLowerCase().includes(includeFilter)) || ((_b = x.label) == null ? void 0 : _b.toLowerCase().includes(includeFilter));
          }
        );
      }
      return optionsFiltered;
    },
    optionsDict() {
      return this.optionsComputed.reduce((value, currentValue) => {
        value[currentValue.value] = currentValue;
        return value;
      }, {});
    },
    optionsDictSortAndFilter() {
      return this.optionsSortAndFilterComputed.reduce((value, currentValue) => {
        value[currentValue.value] = currentValue;
        return value;
      }, {});
    },
    optionsGroupComputed() {
      if (!this.optionsGroup) {
        return this.optionsSortAndFilterComputed;
      }
      const headers = Object.keys(this.optionsGroup);
      const result = [];
      headers.forEach((header) => {
        const options = this.optionsGroup[header].map(
          (key) => this.optionsDictSortAndFilter[key]
        ).filter(Boolean);
        if (options.length) {
          result.push(header);
          result.push(...options);
        }
      });
      return result;
    },
    modelValueComputed() {
      if (!this.modelValue) {
        if (this.multiselect) {
          return [];
        }
        return void 0;
      }
      if (typeof this.modelValue === "object") {
        return this.modelValue;
      }
      if (Array.isArray(this.modelValue)) {
        if (this.modelValue.length === 0) {
          return this.modelValue;
        }
        if (typeof this.modelValue[0] === "string") {
          return this.modelValue.map((x) => ({
            value: x,
            label: x in this.optionsDict ? this.optionsDict[x].label : x
          }));
        }
        if ("value" in this.modelValue[0] && "label" in this.modelValue[0]) {
          return this.modelValue;
        }
        throw new Error("Unknown ModelValue type in TSelectComponent");
      }
      if (typeof this.modelValue === "string") {
        return {
          value: this.modelValue,
          label: this.modelValue in this.optionsDict ? this.optionsDict[this.modelValue].label : this.modelValue
        };
      }
      return void 0;
    },
    modelValueArrayComputed() {
      if (!this.modelValueComputed) {
        return [];
      }
      if (Array.isArray(this.modelValueComputed)) {
        return this.modelValueComputed;
      }
      return [this.modelValueComputed];
    },
    isModelValueEmpty() {
      if (!this.modelValueComputed) {
        return true;
      }
      if (this.multiselect && this.modelValueComputed.length === 0) {
        return true;
      }
      return false;
    }
  },
  methods: {
    getRefs() {
      return this.$refs;
    },
    getSelectContainerDiv() {
      return this.getRefs().selectContainerDiv;
    },
    onClickSelectContainerDiv(e) {
      const el = e.target instanceof Element ? e.target : void 0;
      const div = this.getRefs().optionsContainer;
      if (!this.readonly && el && !(div == null ? void 0 : div.contains(el))) {
        this.show.options = !this.show.options;
      }
    },
    onFocusOut(e) {
      const div = this.getSelectContainerDiv();
      const el = e.relatedTarget instanceof Element ? e.relatedTarget : void 0;
      if (!el || !(div == null ? void 0 : div.contains(el)) && div !== el && el !== this.getRefs().selectContainerDiv) {
        this.show.options = false;
      }
    },
    onKeyDown(e) {
      const event = new KeyboardEventHelper(e);
      const { menuDownButton, selectContainerDiv, resetButton } = this.getRefs();
      const menuDownEl = menuDownButton.$el;
      const resetButtonEl = resetButton == null ? void 0 : resetButton.$el;
      if ([selectContainerDiv, menuDownEl].includes(e.target) && event.stop.prevent.codeSpace.isAllTrue) {
        this.show.options = !this.show.options;
      }
      if ([selectContainerDiv, resetButtonEl].filter(Boolean).includes(e.target) && event.stop.prevent.codeDelete.isAllTrue) {
        selectContainerDiv.focus();
        this.$emit("reset");
      }
      if (event.stop.prevent.keyEscape.isAllTrue) {
        selectContainerDiv.focus();
        this.show.options = false;
      }
    },
    onOptionKeyDown(e, option) {
      const event = new KeyboardEventHelper(e);
      if (event.stop.prevent.codeSpace.isAllTrue) {
        this.onSelectValue(option);
        !this.multiselect ? this.show.options = false : void 0;
        this.getSelectContainerDiv().focus();
      }
    },
    executeAutoSelect() {
      if (this.autoselect && this.isModelValueEmpty && this.optionsSortAndFilterComputed.length > 0) {
        if (this.autoselectMaxCount !== void 0 && this.optionsSortAndFilterComputed.length > this.autoselectMaxCount) {
          return;
        }
        this.onSelectValue(this.optionsComputed[0]);
      }
    },
    executeReselectInitValue() {
      if (this.reselectInitValue && this.modelValueArrayComputed.length > 0) {
        this.onEmitSelectValues(
          this.modelValueArrayComputed.map(
            (x) => this.optionsDict[x.value] || x
          )
        );
      }
    },
    onEmitSelectValues(options) {
      if (this.multiselect) {
        this.$emit("update:modelValue", options);
      } else {
        this.$emit("update:modelValue", options[0]);
      }
    },
    onSelectValue(option) {
      if (!this.multiselect) {
        this.$emit("update:modelValue", option);
        return;
      }
      let selectedOptions = Array.isArray(
        this.modelValueComputed
      ) ? this.modelValueComputed : [];
      if (selectedOptions.some((x) => x.value === option.value)) {
        selectedOptions = selectedOptions.filter(
          (x) => x.value !== option.value
        );
      } else {
        selectedOptions.push(option);
      }
      this.$emit("update:modelValue", selectedOptions);
    },
    onDeleteValue(option) {
      this.$emit("delete", option);
    },
    getOptionLabel(option) {
      if ((option == null ? void 0 : option.label) === void 0) {
        return "";
      }
      return `${this.isValueView ? `${option.value} - ` : ""}${option.label}`;
    },
    isSelectedOption(option) {
      if (!this.modelValueComputed) {
        return false;
      }
      if (this.multiselect && Array.isArray(this.modelValueComputed)) {
        return this.modelValueComputed.some((x) => x.value === option.value);
      }
      return this.modelValueComputed.value === option.value;
    },
    async loadOptionsUrl() {
      if (!this.optionsUrl) {
        return;
      }
      const result = await ApiService$1.getSelectValues(this.optionsUrl).catch(
        async (e) => {
          await ApiHelper.wrapNotifyError(e, {
            title: `\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0435 \u0434\u0430\u043D\u043D\u044B\u0445 \u0434\u043B\u044F \u0432\u044B\u0431\u043E\u0440\u0430 '${this.caption}'`,
            isError: true
          });
          return void 0;
        }
      );
      this.optionsLoaded = (() => {
        if (isNullOrUndefined(result == null ? void 0 : result.json)) {
          return [];
        }
        if (Array.isArray(result.json)) {
          return result.json;
        }
        if (Array.isArray(result.json.result)) {
          return result.json.result;
        }
        return [];
      })();
      if (this.optionsUrlDefaultKey) {
        const defaultValues = this.optionsLoaded.filter(
          (x) => x[this.optionsUrlDefaultKey]
        );
        if (defaultValues.length) {
          this.onEmitSelectValues(defaultValues);
        }
      }
      this.$emit("options-url:loaded", {
        options: this.optionsLoaded,
        result
      });
    }
  }
});
const _hoisted_1$O = ["data-invalid", "title"];
const _hoisted_2$K = { class: "select-container__indicators" };
const _hoisted_3$E = {
  key: 0,
  class: "select-container__indicator",
  style: { "color": "blue" }
};
const _hoisted_4$y = { class: "select-label-container" };
const _hoisted_5$o = { class: "select-label" };
const _hoisted_6$j = { class: "select-caption" };
const _hoisted_7$f = ["title"];
const _hoisted_8$a = { class: "select-input-text" };
const _hoisted_9$a = { key: 0 };
const _hoisted_10$a = {
  key: 1,
  class: "select-input-multiple-values"
};
const _hoisted_11$a = { class: "select-input-multiple-values-list" };
const _hoisted_12$9 = { class: "select-input-multiple-values-counter" };
const _hoisted_13$8 = { key: 2 };
const _hoisted_14$7 = { key: 1 };
const _hoisted_15$7 = { key: 2 };
const _hoisted_16$6 = {
  key: 0,
  class: "select-input-right-toolbox"
};
const _hoisted_17$6 = {
  key: 0,
  style: { "position": "relative" }
};
const _hoisted_18$5 = {
  ref: "optionsContainer",
  class: "select-options-container"
};
const _hoisted_19$5 = ["data-selected", "data-value", "onKeydown", "onClick"];
const _hoisted_20$4 = {
  key: 1,
  class: "select-options-container-option-header"
};
const _hoisted_21$4 = {
  key: 2,
  class: "select-options-container-option-header"
};
const _hoisted_22$3 = {
  key: 1,
  class: "app-label-s12-h14",
  style: { "margin-top": "7px" }
};
function _sfc_render$Y(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ButtonComponent = resolveComponent("ButtonComponent");
  const _component_SearchComponent = resolveComponent("SearchComponent");
  return openBlock(), createElementBlock("div", null, [
    createElementVNode("div", {
      ref: "selectContainerDiv",
      "data-invalid": _ctx.boolToString(_ctx.error || _ctx.invalid),
      title: _ctx.error || _ctx.title,
      class: "select-container",
      tabindex: "0",
      onFocusout: _cache[4] || (_cache[4] = (...args) => _ctx.onFocusOut && _ctx.onFocusOut(...args)),
      onKeydown: _cache[5] || (_cache[5] = (...args) => _ctx.onKeyDown && _ctx.onKeyDown(...args)),
      onClick: _cache[6] || (_cache[6] = (...args) => _ctx.onClickSelectContainerDiv && _ctx.onClickSelectContainerDiv(...args))
    }, [
      createElementVNode("div", _hoisted_2$K, [
        _ctx.saving ? (openBlock(), createElementBlock("div", _hoisted_3$E, " \u2022 ")) : createCommentVNode("", true)
      ]),
      createElementVNode("div", _hoisted_4$y, [
        createElementVNode("div", _hoisted_5$o, [
          createElementVNode("span", _hoisted_6$j, toDisplayString(_ctx.toStr(_ctx.caption) + (_ctx.required ? "*" : "")), 1),
          createElementVNode("div", {
            title: _ctx.invalid ? _ctx.help : _ctx.caption,
            class: "select-input"
          }, [
            createElementVNode("div", _hoisted_8$a, [
              _ctx.modelValueComputed ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                !Array.isArray(_ctx.modelValueComputed) ? (openBlock(), createElementBlock("span", _hoisted_9$a, toDisplayString(_ctx.getOptionLabel(_ctx.modelValueComputed)), 1)) : _ctx.modelValueComputed.length > 0 ? (openBlock(), createElementBlock("div", _hoisted_10$a, [
                  createElementVNode("div", _hoisted_11$a, [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.modelValueComputed, (modelValueOnly) => {
                      return openBlock(), createElementBlock("div", {
                        key: modelValueOnly.value,
                        class: "select-input-multiple-values-value"
                      }, [
                        createElementVNode("span", null, toDisplayString(_ctx.getOptionLabel(modelValueOnly)), 1),
                        createVNode(_component_ButtonComponent, {
                          icon: _ctx.ICONS.closeCircle,
                          class: "button-opacity select-input-multiple-value-remove-icon",
                          onClick: withModifiers(($event) => _ctx.onSelectValue(modelValueOnly), ["stop"])
                        }, null, 8, ["icon", "onClick"])
                      ]);
                    }), 128))
                  ]),
                  createElementVNode("div", _hoisted_12$9, " (" + toDisplayString(_ctx.modelValueComputed.length) + ") ", 1)
                ])) : (openBlock(), createElementBlock("span", _hoisted_13$8, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F"))
              ], 64)) : _ctx.placeholder !== void 0 ? (openBlock(), createElementBlock("span", _hoisted_14$7, toDisplayString(_ctx.placeholder), 1)) : (openBlock(), createElementBlock("span", _hoisted_15$7, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435"))
            ])
          ], 8, _hoisted_7$f)
        ]),
        !_ctx.readonly ? (openBlock(), createElementBlock("div", _hoisted_16$6, [
          _ctx.showReset ? (openBlock(), createBlock(_component_ButtonComponent, {
            key: 0,
            ref: "resetButton",
            icon: _ctx.ICONS.closeBlue,
            class: "button-opacity",
            tabindex: "-1",
            onClick: _cache[0] || (_cache[0] = withModifiers(($event) => _ctx.$emit("reset"), ["stop"])),
            onKeydown: _cache[1] || (_cache[1] = withKeys(($event) => {
              _ctx.getSelectContainerDiv().focus();
              _ctx.$emit("reset");
            }, ["space"]))
          }, null, 8, ["icon"])) : createCommentVNode("", true),
          createVNode(_component_ButtonComponent, {
            ref: "menuDownButton",
            icon: _ctx.ICONS.menuDown,
            "icon-rotate-180": _ctx.show.options,
            class: "button-opacity",
            tabindex: "-1"
          }, null, 8, ["icon", "icon-rotate-180"])
        ])) : createCommentVNode("", true)
      ]),
      _ctx.show.options ? (openBlock(), createElementBlock("div", _hoisted_17$6, [
        createElementVNode("div", _hoisted_18$5, [
          _ctx.showSearch ? (openBlock(), createBlock(_component_SearchComponent, {
            key: 0,
            modelValue: _ctx.search,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.search = $event),
            autofocus: _ctx.show.options,
            class: "select-options-container__search",
            placeholder: "\u041F\u043E\u0438\u0441\u043A",
            onClick: _cache[3] || (_cache[3] = withModifiers(() => {
            }, ["stop"]))
          }, null, 8, ["modelValue", "autofocus"])) : createCommentVNode("", true),
          _ctx.optionsComputed.length > 0 ? (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList(_ctx.optionsGroupComputed, (option) => {
            return openBlock(), createElementBlock(Fragment, {
              key: typeof option === "string" ? option : option.value
            }, [
              typeof option === "object" ? (openBlock(), createElementBlock("div", {
                key: 0,
                "data-selected": _ctx.boolToString(_ctx.isSelectedOption(option)),
                "data-value": option.value,
                class: "button-opacity select-options-container-option",
                tabindex: "0",
                onKeydown: ($event) => _ctx.onOptionKeyDown($event, option),
                onClick: withModifiers(($event) => {
                  _ctx.onSelectValue(option);
                  !_ctx.multiselect ? _ctx.show.options = false : void 0;
                }, ["stop"])
              }, [
                createElementVNode("span", null, toDisplayString(_ctx.getOptionLabel(option)), 1),
                _ctx.showDelete ? (openBlock(), createBlock(_component_ButtonComponent, {
                  key: 0,
                  icon: _ctx.ICONS.trashCanOutline,
                  class: "button-opacity",
                  onClick: withModifiers(($event) => _ctx.onDeleteValue(option), ["stop"])
                }, null, 8, ["icon", "onClick"])) : createCommentVNode("", true)
              ], 40, _hoisted_19$5)) : (openBlock(), createElementBlock("div", _hoisted_20$4, toDisplayString(option), 1))
            ], 64);
          }), 128)) : (openBlock(), createElementBlock("div", _hoisted_21$4, " \u0417\u043D\u0430\u0447\u0435\u043D\u0438\u044F \u0434\u043B\u044F \u0432\u044B\u0431\u043E\u0440\u0430 \u043E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u044E\u0442 "))
        ], 512)
      ])) : createCommentVNode("", true),
      _ctx.footerHelp ? (openBlock(), createElementBlock("div", _hoisted_22$3, toDisplayString(_ctx.footerHelp), 1)) : createCommentVNode("", true)
    ], 40, _hoisted_1$O)
  ]);
}
var TSelectComponent = /* @__PURE__ */ _export_sfc(_sfc_main$Y, [["render", _sfc_render$Y]]);
var PanelFiltersItem_vue_vue_type_style_index_0_lang = "";
const _sfc_main$X = defineComponent({
  name: "PanelFiltersItem",
  components: {
    DropdownComponent,
    TInputComponent,
    ButtonComponent,
    CheckboxComponent,
    TSelectComponent,
    AttrInputBase
  },
  props: {
    tableDataSet: {
      type: Object
    },
    modelArray: {
      type: Array,
      required: true
    },
    types: {
      type: Object,
      required: true
    },
    data: {
      type: Object,
      required: true
    },
    validationHandlers: {
      type: Object,
      default: VALIDATION_HANDLERS
    },
    globalHandlers: { type: Object }
  },
  emits: [
    "disabled:click",
    "data:rules:assign",
    "data:rules:modifiers:assign",
    "remove"
  ],
  setup() {
    return {
      ICONS
    };
  },
  data() {
    return {
      dataListValues: []
    };
  },
  computed: {
    isCreateInput() {
      return this.comparisonObj && FILTER_COMPARISON_OPERATION__CREATE_INPUT.has(this.comparisonObj.value);
    },
    isAttrInputBase() {
      var _a, _b;
      return this.typeDto && this.tableModel && isSupportFilterAttrInput(
        (_b = (_a = this.typeDto) == null ? void 0 : _a.base_type) != null ? _b : "BASE",
        this.comparisonObj
      );
    },
    dataListId() {
      return this.data.id + "_data-list";
    },
    comparisonObj() {
      const comparisonObj = strToFilterComparisonOption(this.data.rules.comparison);
      return comparisonObj;
    },
    comparisonOperationOptions() {
      var _a;
      const allowOperations = (_a = this.tableModel) == null ? void 0 : _a.getFilter();
      if (allowOperations === true || allowOperations === void 0) {
        return FILTER_COMPARISON_OPERATION_OPTIONS;
      }
      if (allowOperations === false) {
        return [];
      }
      const allowOperationsSet = new Set(
        allowOperations
      );
      return FILTER_COMPARISON_OPERATION_OPTIONS.filter(
        (x) => allowOperationsSet.has(strToFilterComparisonOption(x.value).value)
      );
    },
    modelOptions() {
      return this.modelArray.map((x) => ({
        label: x.caption,
        value: x.systemField || x.field
      }));
    },
    tableModel() {
      return this.modelArray.find(
        (x) => (x.systemField || x.field) === this.data.rules.field
      );
    },
    typeDto() {
      if (!this.tableModel) {
        return void 0;
      }
      return TableDataSet.getTypeModel(this.types, this.tableModel);
    }
  },
  watch: {},
  created() {
    this.$watch(
      () => this.data.rules.field,
      () => {
        this.dataListValues = this.getDataListValues();
      },
      { immediate: true }
    );
  },
  mounted() {
    this.$watch(
      () => this.data.autofocus,
      () => {
        if (!this.data.autofocus) {
          return;
        }
        delete this.data.autofocus;
        setTimeout(() => {
          const currentInputRef = [
            this.$refs.inputRef,
            this.$refs.attrInputRef
          ].filter(Boolean)[0];
          currentInputRef == null ? void 0 : currentInputRef.focus();
        }, 100);
      },
      { immediate: true }
    );
  },
  methods: {
    onDataRulesAssign(rules) {
      if (rules.comparison) {
        this.onDataRulesModifiersAssign({
          complete_match: false,
          not_ignore_case: false
        });
      }
      if (rules.field !== void 0) {
        rules.comparisonValue = "";
      }
      this.$emit("data:rules:assign", rules);
    },
    onDataRulesModifiersAssign(modifiers) {
      this.$emit("data:rules:modifiers:assign", modifiers);
    },
    getDataListValues() {
      if (!this.tableDataSet) {
        return [];
      }
      const model = this.tableDataSet.getModelBySystem(
        this.data.rules.field
      );
      if (!model) {
        return [];
      }
      let list = unique(
        this.tableDataSet.rows.map(
          (tableRow) => {
            var _a;
            return toStr((_a = tableRow.cells[model.field]) == null ? void 0 : _a.value);
          }
        )
      );
      const typeDto = this.tableDataSet.getTypeModel(model);
      if ((typeDto == null ? void 0 : typeDto.base_type) === "DATE") {
        const { serverDateFormat, displayDateFormat } = this.tableDataSet;
        list = list.map(
          (value) => {
            var _a;
            return (_a = dateTransform(value, serverDateFormat, displayDateFormat)) != null ? _a : value;
          }
        );
      }
      return list;
    }
  }
});
const _hoisted_1$N = { class: "panel-filters-item" };
const _hoisted_2$J = ["id"];
function _sfc_render$X(_ctx, _cache, $props, $setup, $data, $options) {
  var _a;
  const _component_ButtonComponent = resolveComponent("ButtonComponent");
  const _component_CheckboxComponent = resolveComponent("CheckboxComponent");
  const _component_TSelectComponent = resolveComponent("TSelectComponent");
  const _component_AttrInputBase = resolveComponent("AttrInputBase");
  const _component_TInputComponent = resolveComponent("TInputComponent");
  return openBlock(), createElementBlock("div", _hoisted_1$N, [
    createVNode(_component_ButtonComponent, {
      icon: _ctx.ICONS.closeBlue,
      class: "button-opacity",
      style: { "justify-self": "flex-end" },
      onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("remove", $event))
    }, null, 8, ["icon"]),
    createVNode(_component_CheckboxComponent, {
      checked: !_ctx.data.disabled,
      onClick: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("disabled:click", $event))
    }, null, 8, ["checked"]),
    createVNode(_component_TSelectComponent, {
      autoselect: true,
      "model-value": _ctx.data.rules.field,
      options: _ctx.modelOptions,
      "show-reset": false,
      "show-search": false,
      class: "panel-filters-item-bottom",
      style: { "min-width": "250px" },
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.onDataRulesAssign({ field: $event.value }))
    }, null, 8, ["model-value", "options"]),
    createVNode(_component_TSelectComponent, {
      autoselect: true,
      "autoselect-if-not-exist": true,
      "model-value": _ctx.data.rules.comparison,
      options: _ctx.comparisonOperationOptions,
      "show-reset": false,
      "show-search": false,
      class: "panel-filters-item-bottom",
      style: { "min-width": "190px" },
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => _ctx.onDataRulesAssign({ comparison: $event.value }))
    }, null, 8, ["model-value", "options"]),
    _ctx.isCreateInput ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
      _ctx.isAttrInputBase ? (openBlock(), createBlock(_component_AttrInputBase, {
        key: 0,
        ref: "attrInputRef",
        "is-hide-reset": true,
        list: _ctx.dataListId,
        model: _ctx.tableModel.modelDto,
        type: _ctx.typeDto,
        types: _ctx.types,
        "validation-handlers": _ctx.validationHandlers,
        "global-handlers": _ctx.globalHandlers,
        value: _ctx.data.rules.comparisonValue,
        caption: "\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435",
        class: "panel-filters-item-bottom",
        "priority-style": "margin-bottom: 0px; min-width: 250px;",
        onChange: _cache[4] || (_cache[4] = ($event) => _ctx.onDataRulesAssign({ comparisonValue: $event })),
        onReset: _cache[5] || (_cache[5] = ($event) => _ctx.onDataRulesAssign({ comparisonValue: "" }))
      }, null, 8, ["list", "model", "type", "types", "validation-handlers", "global-handlers", "value"])) : (openBlock(), createBlock(_component_TInputComponent, {
        key: 1,
        ref: "inputRef",
        "is-hide-reset": true,
        list: _ctx.dataListId,
        "model-value": _ctx.data.rules.comparisonValue,
        caption: "\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435",
        style: { "min-width": "250px" },
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => _ctx.onDataRulesAssign({ comparisonValue: $event }))
      }, null, 8, ["list", "model-value"])),
      createElementVNode("datalist", { id: _ctx.dataListId }, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.dataListValues, (value) => {
          return openBlock(), createElementBlock("option", { key: value }, toDisplayString(value), 1);
        }), 128))
      ], 8, _hoisted_2$J)
    ], 64)) : createCommentVNode("", true),
    ((_a = _ctx.comparisonObj) == null ? void 0 : _a.value) === "like" ? (openBlock(), createBlock(_component_CheckboxComponent, {
      key: 1,
      checked: _ctx.data.rules.modifiers.not_ignore_case,
      label: "\u0423\u0447\u0438\u0442\u044B\u0432\u0430\u0442\u044C \u0440\u0435\u0433\u0438\u0441\u0442\u0440",
      onClick: _cache[7] || (_cache[7] = ($event) => _ctx.onDataRulesModifiersAssign({
        not_ignore_case: !_ctx.data.rules.modifiers.not_ignore_case
      }))
    }, null, 8, ["checked"])) : createCommentVNode("", true)
  ]);
}
var PanelFiltersItem = /* @__PURE__ */ _export_sfc(_sfc_main$X, [["render", _sfc_render$X]]);
var EnterModalComponent_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$W = defineComponent({
  name: "EnterModalComponent",
  emits: ["close", "update:modelValue"],
  props: {
    modelValue: String,
    title: String,
    readonly: Boolean,
    placeholder: String,
    style: {
      type: TVuePropTypes.style,
      default: () => ({ width: "700px" })
    },
    required: Boolean,
    titleSaveButton: {
      type: String,
      default: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C"
    }
  },
  components: {
    ModalComponent
  },
  data() {
    return {
      newValue: ""
    };
  },
  mounted() {
    setTimeout(() => {
      this.focusTextArea();
    });
    this.newValue = this.modelValue || "";
  },
  methods: {
    focusContainer() {
      this.$nextTick(() => {
        var _a;
        (_a = this.$refs.container) == null ? void 0 : _a.focus();
      });
    },
    focusTextArea() {
      this.$nextTick(() => {
        var _a;
        (_a = this.$refs.textarea) == null ? void 0 : _a.focus();
      });
    },
    onSave() {
      this.$emit("update:modelValue", this.newValue);
    },
    onKeyDown(event) {
      const eventHelper = new KeyboardEventHelper(event);
      if (eventHelper.keyEscape.isAllTrue) {
        return;
      }
      if (eventHelper.keyEnter.isAllTrue && eventHelper.pressShift.isAllFalse) {
        this.onSave();
      }
      event.stopPropagation();
    }
  }
});
const _hoisted_1$M = ["placeholder"];
const _hoisted_2$I = ["disabled"];
function _sfc_render$W(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ModalComponent = resolveComponent("ModalComponent");
  return openBlock(), createBlock(_component_ModalComponent, {
    key: 0,
    style: normalizeStyle(_ctx.style),
    title: _ctx.title,
    visible: true,
    onClose: _cache[3] || (_cache[3] = ($event) => _ctx.$emit("close")),
    onContentOnKeyDown: _ctx.onKeyDown
  }, {
    body: withCtx(() => [
      createElementVNode("div", {
        ref: "container",
        class: "form-container",
        onKeydown: _cache[2] || (_cache[2] = (...args) => _ctx.onKeyDown && _ctx.onKeyDown(...args))
      }, [
        withDirectives(createElementVNode("textarea", {
          ref: "textarea",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.newValue = $event),
          placeholder: _ctx.placeholder,
          class: "textarea"
        }, null, 8, _hoisted_1$M), [
          [vModelText, _ctx.newValue]
        ]),
        createElementVNode("button", {
          disabled: _ctx.readonly || _ctx.required && _ctx.newValue === "",
          class: "form-button",
          "data-type": "accent",
          onClick: _cache[1] || (_cache[1] = (...args) => _ctx.onSave && _ctx.onSave(...args))
        }, toDisplayString(_ctx.titleSaveButton), 9, _hoisted_2$I)
      ], 544)
    ]),
    _: 1
  }, 8, ["style", "title", "onContentOnKeyDown"]);
}
var EnterModalComponent = /* @__PURE__ */ _export_sfc(_sfc_main$W, [["render", _sfc_render$W], ["__scopeId", "data-v-6b41f39e"]]);
var PanelFilters_vue_vue_type_style_index_0_lang = "";
const _sfc_main$V = defineComponent({
  name: "PanelFilters",
  components: {
    PanelFiltersItem,
    DropdownComponent,
    ButtonComponent,
    TSelectComponent,
    EnterModalComponent
  },
  props: {
    style: TVuePropTypes.style,
    class: {},
    modelArray: {
      type: Array,
      required: true
    },
    types: {
      type: Object,
      required: true
    },
    validationHandlers: {
      type: Object,
      default: VALIDATION_HANDLERS
    },
    globalHandlers: { type: Object },
    dataSet: {
      type: PanelFiltersSet,
      required: true
    },
    tableDataSet: {
      type: Object
    },
    urlSync: [Boolean, String]
  },
  emits: [
    "keydown",
    "execute",
    "filter:save",
    "filter:delete"
  ],
  setup() {
    return {
      ICONS,
      rule1Options: [
        {
          label: "\u0412\u044B\u043F\u043E\u043B\u043D\u044F\u044E\u0442\u0441\u044F \u0432\u0441\u0435 \u0443\u0441\u043B\u043E\u0432\u0438\u044F \u043E\u0434\u043D\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E",
          value: "and"
        },
        {
          label: "\u0412\u044B\u043F\u043E\u043B\u043D\u044F\u0435\u0442\u0441\u044F \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u043D\u043E \u0443\u0441\u043B\u043E\u0432\u0438\u0435",
          value: "or"
        }
      ]
    };
  },
  data() {
    return {
      open: {
        saveModal: void 0
      }
    };
  },
  computed: {
    urlParamName() {
      if (this.urlSync === true) {
        return "filter";
      }
      return typeof this.urlSync === "string" ? this.urlSync : void 0;
    },
    urlFilterString() {
      var _a;
      if (!this.urlParamName) {
        return void 0;
      }
      return (_a = this.$route.query[this.urlParamName]) != null ? _a : "";
    },
    urlFilter() {
      const obj = FilterFactory.parseString(this.urlFilterString);
      if (obj && FilterFactory.isLogicalObj(obj)) {
        return obj;
      }
      return void 0;
    },
    urlFilterParse() {
      return this.urlFilter ? FilterFactory.parseLogicalObj(this.urlFilter) : void 0;
    },
    currentFilterObj() {
      return PanelFiltersFactory.toFilterLogical(this.dataSet.data);
    },
    currentFilterString() {
      return FilterFactory.getString(this.currentFilterObj);
    },
    allowModelArray() {
      return this.modelArray.filter((x) => x.getFilter() && x.caption);
    },
    filtersOptions() {
      if (!this.dataSet.save) {
        return [];
      }
      return this.dataSet.save.filters.map((filter) => ({
        label: filter.caption,
        value: filter.caption
      }));
    }
  },
  watch: {},
  created() {
    if (this.urlFilterParse) {
      this.updateCurrentFilterByUrl();
      this.onExecute();
      this.dataSet.setOpen(true);
    } else {
      this.updateUrlByCurrentFilter();
    }
  },
  methods: {
    onResetFilters() {
      if (this.tableDataSet) {
        this.tableDataSet.removeInitialFilters(["panel", "search"]);
      }
      this.updateUrlFilter(void 0);
    },
    onSelectFilter(caption) {
      if (!this.dataSet.save) {
        return;
      }
      this.dataSet.setCurrentFilter(
        this.dataSet.save.filters.find((x) => x.caption === caption)
      );
    },
    onDeleteFilter(caption) {
      if (!this.dataSet.save) {
        return;
      }
      const filter = this.dataSet.save.filters.find(
        (x) => x.caption === caption
      );
      if (filter) {
        this.dataSet.save.deleteFilter(filter);
        this.$emit("filter:delete", filter);
      }
    },
    onSaveFilter(caption) {
      var _a;
      if (!this.dataSet.save) {
        return;
      }
      caption = caption.trim();
      const captionLowerCase = caption.toLowerCase();
      const currentFilter = this.dataSet.save.filters.find(
        (x) => x.caption.toLowerCase() === captionLowerCase
      );
      if (currentFilter && ((_a = this.open.saveModal) == null ? void 0 : _a.rewrite) !== caption) {
        NotificationsService$1.send({
          title: "\u0412\u043D\u0438\u043C\u0430\u043D\u0438\u0435",
          text: "\u0424\u0438\u043B\u044C\u0442\u0440 \u0441 \u0442\u0430\u043A\u0438\u043C \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435\u043C \u0443\u0436\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442! \n\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0435\u0449\u0451 \u0440\u0430\u0437, \u0435\u0441\u043B\u0438 \u0445\u043E\u0442\u0438\u0442\u0435 \u043F\u0435\u0440\u0435\u0437\u0430\u043F\u0438\u0441\u0430\u0442\u044C \u0435\u0433\u043E.",
          duration: 1e4
        });
        this.open.saveModal.rewrite = caption;
        return;
      }
      const dataSave = {
        caption,
        data: copy(this.dataSet.data)
      };
      this.dataSet.save.saveFilter(dataSave);
      this.$emit("filter:save", dataSave);
      this.open.saveModal = void 0;
    },
    onExecute() {
      this.dataSet.execute();
      this.updateUrlByCurrentFilter();
      if (isDev) {
        Logger$1.log("\u0424\u0438\u043B\u044C\u0442\u0440:", FilterFactory.getString(PanelFiltersFactory.toFilterLogical(this.dataSet.data)));
      }
      this.$emit("execute", this.dataSet.data);
    },
    updateUrlByCurrentFilter() {
      this.updateUrlFilter(this.currentFilterString);
    },
    updateUrlFilter(filter) {
      if (!this.urlParamName) {
        return;
      }
      let query = Object.assign({}, this.$route.query);
      query[this.urlParamName] = filter;
      this.$router.replace({ query });
    },
    updateCurrentFilterByUrl() {
      const data = PanelFiltersFactory.getData(this.urlFilterParse);
      this.dataSet.setData(data);
    }
  }
});
const _hoisted_1$L = { style: { "display": "flex", "gap": "10px", "flex-direction": "row", "justify-content": "space-between", "flex-wrap": "wrap" } };
const _hoisted_2$H = /* @__PURE__ */ createElementVNode("div", { style: { "flex-grow": "1" } }, null, -1);
function _sfc_render$V(_ctx, _cache, $props, $setup, $data, $options) {
  var _a;
  const _component_PanelFiltersItem = resolveComponent("PanelFiltersItem");
  const _component_ButtonComponent = resolveComponent("ButtonComponent");
  const _component_TSelectComponent = resolveComponent("TSelectComponent");
  const _component_EnterModalComponent = resolveComponent("EnterModalComponent");
  return openBlock(), createElementBlock(Fragment, null, [
    _ctx.dataSet.open ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: normalizeClass([this.class, "panel-filters"]),
      style: normalizeStyle(_ctx.style),
      onKeydown: _cache[5] || (_cache[5] = ($event) => _ctx.$emit("keydown", $event))
    }, [
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.dataSet.data.items, (dataItem) => {
        return openBlock(), createBlock(_component_PanelFiltersItem, {
          key: dataItem.id,
          data: dataItem,
          "global-handlers": _ctx.globalHandlers,
          "model-array": _ctx.allowModelArray,
          "table-data-set": _ctx.tableDataSet,
          types: _ctx.types,
          "validation-handlers": _ctx.validationHandlers,
          onRemove: ($event) => _ctx.dataSet.removeItem(dataItem),
          "onDisabled:click": ($event) => dataItem.disabled = !dataItem.disabled,
          "onData:rules:assign": ($event) => Object.assign(dataItem.rules, $event),
          "onData:rules:modifiers:assign": ($event) => Object.assign(dataItem.rules.modifiers, $event)
        }, null, 8, ["data", "global-handlers", "model-array", "table-data-set", "types", "validation-handlers", "onRemove", "onDisabled:click", "onData:rules:assign", "onData:rules:modifiers:assign"]);
      }), 128)),
      createElementVNode("div", _hoisted_1$L, [
        createVNode(_component_ButtonComponent, {
          icon: _ctx.ICONS.plusBlue,
          class: "button-opacity",
          onClick: _cache[0] || (_cache[0] = ($event) => _ctx.dataSet.addItem())
        }, null, 8, ["icon"]),
        _ctx.dataSet.save ? (openBlock(), createBlock(_component_TSelectComponent, {
          key: 0,
          "model-value": (_a = _ctx.dataSet.save.currentFilter) == null ? void 0 : _a.caption,
          options: _ctx.filtersOptions,
          "show-delete": true,
          caption: "\u0421\u043E\u0445\u0440\u0430\u043D\u0451\u043D\u043D\u044B\u0435 \u0444\u0438\u043B\u044C\u0442\u0440\u044B",
          style: { "margin-left": "24px", "min-width": "250px", "flex-grow": "1" },
          onDelete: _cache[1] || (_cache[1] = ($event) => _ctx.onDeleteFilter($event == null ? void 0 : $event.value)),
          onReset: _cache[2] || (_cache[2] = ($event) => _ctx.dataSet.setCurrentFilter(void 0)),
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => _ctx.onSelectFilter($event == null ? void 0 : $event.value))
        }, null, 8, ["model-value", "options"])) : createCommentVNode("", true),
        _hoisted_2$H,
        _ctx.tableDataSet ? (openBlock(), createBlock(_component_ButtonComponent, {
          key: 1,
          icon: _ctx.ICONS.restoreBlue,
          class: "form-button",
          onClick: _ctx.onResetFilters
        }, {
          default: withCtx(() => [
            createTextVNode(" \u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C \u0444\u0438\u043B\u044C\u0442\u0440\u044B ")
          ]),
          _: 1
        }, 8, ["icon", "onClick"])) : createCommentVNode("", true),
        _ctx.dataSet.save ? (openBlock(), createBlock(_component_ButtonComponent, {
          key: 2,
          class: "form-button",
          onClick: _cache[4] || (_cache[4] = ($event) => _ctx.open.saveModal = { caption: "" })
        }, {
          default: withCtx(() => [
            createTextVNode(" \u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C ")
          ]),
          _: 1
        })) : createCommentVNode("", true),
        createVNode(_component_ButtonComponent, {
          class: "form-button",
          "data-type": "accent",
          onClick: _ctx.onExecute
        }, {
          default: withCtx(() => [
            createTextVNode(" \u041F\u0440\u0438\u043C\u0435\u043D\u0438\u0442\u044C ")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ], 38)) : createCommentVNode("", true),
    _ctx.open.saveModal ? (openBlock(), createBlock(_component_EnterModalComponent, {
      key: 1,
      "model-value": _ctx.open.saveModal.caption,
      required: true,
      placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0444\u0438\u043B\u044C\u0442\u0440\u0430",
      title: "\u0421\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0435 \u0442\u0435\u043A\u0443\u0449\u0435\u0433\u043E \u0444\u0438\u043B\u044C\u0442\u0440\u0430",
      onClose: _cache[6] || (_cache[6] = ($event) => _ctx.open.saveModal = null),
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => _ctx.onSaveFilter($event))
    }, null, 8, ["model-value"])) : createCommentVNode("", true)
  ], 64);
}
var PanelFilters = /* @__PURE__ */ _export_sfc(_sfc_main$V, [["render", _sfc_render$V]]);
var TableActionsComponent_vue_vue_type_style_index_0_lang = "";
const _sfc_main$U = defineComponent({
  name: "TableActionsComponent",
  components: { ButtonComponent },
  props: {
    class: {},
    style: TVuePropTypes.style,
    iconsStyle: TVuePropTypes.style,
    tableDataSet: {
      type: TableDataSet,
      required: true
    },
    rowAppend: {
      type: Function,
      required: false
    },
    rowAppendState: {
      type: String,
      required: false,
      default: "auto"
    },
    filterState: {
      type: String,
      required: false,
      default: "hide"
    },
    changesState: {
      type: String,
      required: false,
      default: "auto"
    },
    updateIndexesState: {
      type: String,
      required: false,
      default: "hide"
    },
    wordWrapState: {
      type: String,
      required: false,
      default: "auto"
    },
    autoWidthState: {
      type: String,
      required: false,
      default: "auto"
    },
    fullScreenState: {
      type: String,
      required: false,
      default: "auto"
    }
  },
  emits: [],
  setup() {
    return {
      ICONS
    };
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {
  },
  methods: {
    getDisabled(state, autoValue) {
      if (state === "auto") {
        return autoValue;
      }
      if (state === "disable") {
        return true;
      }
      if (state === "enable") {
        return false;
      }
      throw new Error(`getDisabled state not implemented: ${state}`);
    }
  }
});
const _hoisted_1$K = ["alt", "src"];
const _hoisted_2$G = ["src"];
const _hoisted_3$D = /* @__PURE__ */ createElementVNode("div", { class: "table-actions__buttons" }, null, -1);
function _sfc_render$U(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ButtonComponent = resolveComponent("ButtonComponent");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass([this.class, "table-actions"]),
    style: normalizeStyle(_ctx.style)
  }, [
    createElementVNode("div", {
      style: normalizeStyle(_ctx.iconsStyle),
      class: "table-actions__icons"
    }, [
      renderSlot(_ctx.$slots, "left"),
      _ctx.fullScreenState !== "hide" ? (openBlock(), createBlock(_component_ButtonComponent, {
        key: 0,
        disabled: _ctx.getDisabled(_ctx.fullScreenState, false),
        icon: _ctx.tableDataSet.options.display.fullScreen ? _ctx.ICONS.contractOutline : _ctx.ICONS.expandOutline,
        class: "button-opacity",
        title: "\u041F\u043E\u043B\u043D\u043E\u044D\u043A\u0440\u0430\u043D\u043D\u044B\u0439 \u0440\u0435\u0436\u0438\u043C",
        onClick: _cache[0] || (_cache[0] = ($event) => _ctx.tableDataSet.setFullScreenMode())
      }, null, 8, ["disabled", "icon"])) : createCommentVNode("", true),
      _ctx.rowAppendState !== "hide" ? (openBlock(), createBlock(_component_ButtonComponent, {
        key: 1,
        disabled: _ctx.getDisabled(_ctx.rowAppendState, !_ctx.tableDataSet.getEdit("edit")),
        icon: _ctx.ICONS.plus,
        class: "button-opacity",
        title: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043D\u043E\u0432\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C \u0432 \u043A\u043E\u043D\u0435\u0446 \u0442\u0430\u0431\u043B\u0438\u0446\u044B",
        onClick: _cache[1] || (_cache[1] = ($event) => _ctx.rowAppend ? _ctx.rowAppend() : _ctx.tableDataSet.rowAppend())
      }, null, 8, ["disabled", "icon"])) : createCommentVNode("", true),
      _ctx.changesState !== "hide" ? (openBlock(), createBlock(_component_ButtonComponent, {
        key: 2,
        disabled: _ctx.getDisabled(
          _ctx.changesState,
          _ctx.tableDataSet.changes.changes.length === 0 || !_ctx.tableDataSet.getEdit("edit")
        ),
        class: "button-opacity",
        title: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435",
        onClick: _cache[2] || (_cache[2] = ($event) => _ctx.tableDataSet.changes.returnLast(_ctx.tableDataSet, true))
      }, {
        default: withCtx(() => [
          createElementVNode("img", {
            alt: _ctx.ICONS.arrowULeftBottom.alt,
            src: _ctx.ICONS.arrowULeftBottom.src
          }, null, 8, _hoisted_1$K)
        ]),
        _: 1
      }, 8, ["disabled"])) : createCommentVNode("", true),
      _ctx.changesState !== "hide" ? (openBlock(), createBlock(_component_ButtonComponent, {
        key: 3,
        disabled: _ctx.getDisabled(
          _ctx.changesState,
          _ctx.tableDataSet.changes.cancelledChanges.length === 0 || !_ctx.tableDataSet.getEdit("edit")
        ),
        class: "button-opacity",
        title: "\u0412\u0435\u0440\u043D\u0443\u0442\u044C \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435",
        onClick: _cache[3] || (_cache[3] = ($event) => _ctx.tableDataSet.changes.returnCanceledLast(_ctx.tableDataSet))
      }, {
        default: withCtx(() => [
          createElementVNode("img", {
            src: _ctx.ICONS.arrowULeftBottom.src,
            alt: "\u2192",
            style: { "transform": "rotate(180deg)" }
          }, null, 8, _hoisted_2$G)
        ]),
        _: 1
      }, 8, ["disabled"])) : createCommentVNode("", true),
      createVNode(_component_ButtonComponent, {
        icon: _ctx.ICONS.eyeOff,
        class: "button-opacity",
        title: "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0443 \u0432\u0438\u0434\u0438\u043C\u043E\u0441\u0442\u0438 \u0441\u0442\u043E\u043B\u0431\u0446\u043E\u0432",
        onClick: _cache[4] || (_cache[4] = ($event) => _ctx.tableDataSet.setOpenByAssign({ visibilityColumns: true }))
      }, null, 8, ["icon"]),
      _ctx.updateIndexesState !== "hide" ? (openBlock(), createBlock(_component_ButtonComponent, {
        key: 4,
        disabled: _ctx.getDisabled(_ctx.updateIndexesState, !_ctx.tableDataSet.getEdit("edit")),
        icon: _ctx.ICONS.sortNumericAscending,
        class: "button-opacity",
        title: "\u041F\u0440\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043D\u0443\u043C\u0435\u0440\u0430\u0446\u0438\u044E",
        onClick: _cache[5] || (_cache[5] = ($event) => _ctx.tableDataSet.updateRowIndexesBySort())
      }, null, 8, ["disabled", "icon"])) : createCommentVNode("", true),
      _ctx.filterState !== "hide" ? (openBlock(), createBlock(_component_ButtonComponent, {
        key: 5,
        disabled: _ctx.getDisabled(_ctx.filterState, false),
        icon: _ctx.ICONS.filterOutline,
        class: "button-opacity",
        title: "\u0424\u0438\u043B\u044C\u0442\u0440",
        onClick: _cache[6] || (_cache[6] = ($event) => _ctx.tableDataSet.options.filtersSet.setOpen())
      }, null, 8, ["disabled", "icon"])) : createCommentVNode("", true),
      _ctx.autoWidthState !== "hide" ? (openBlock(), createBlock(_component_ButtonComponent, {
        key: 6,
        icon: _ctx.ICONS.autoWidthBlue,
        class: "button-opacity",
        style: { "cursor": "pointer" },
        title: "\u0410\u0432\u0442\u043E\u043F\u043E\u0434\u0431\u043E\u0440 \u0448\u0438\u0440\u0438\u043D\u044B \u0441\u0442\u043E\u043B\u0431\u0446\u043E\u0432",
        onClick: _cache[7] || (_cache[7] = ($event) => _ctx.tableDataSet.executeAutoWidth())
      }, null, 8, ["icon"])) : createCommentVNode("", true),
      _ctx.wordWrapState !== "hide" ? (openBlock(), createBlock(_component_ButtonComponent, {
        key: 7,
        "data-pseudo-disabled": !_ctx.tableDataSet.wordWrap ? "true" : void 0,
        icon: _ctx.ICONS.wordWrapBlue,
        class: "button-opacity",
        style: { "cursor": "pointer" },
        title: "\u041F\u0435\u0440\u0435\u043D\u043E\u0441\u0438\u0442\u044C \u0442\u0435\u043A\u0441\u0442 \u043F\u043E \u0441\u0442\u0440\u043E\u043A\u0430\u043C",
        onClick: _cache[8] || (_cache[8] = ($event) => _ctx.tableDataSet.setWordWrap())
      }, null, 8, ["data-pseudo-disabled", "icon"])) : createCommentVNode("", true),
      renderSlot(_ctx.$slots, "right")
    ], 4),
    _hoisted_3$D
  ], 6);
}
var TableActionsComponent = /* @__PURE__ */ _export_sfc(_sfc_main$U, [["render", _sfc_render$U]]);
var TableCellVocComponent_vue_vue_type_style_index_0_lang = "";
const __default__$2 = defineComponent({
  name: "TableCellVocComponent",
  components: {
    TableActionsComponent,
    CircleLoader,
    SearchComponent,
    ModalComponent,
    TableComponent,
    TableMultiHeaders,
    SwitchComponent,
    TablePaginationBottom,
    TableCellLabelComponent,
    ButtonComponent,
    CloseIcon,
    PanelFilters
  },
  emits: [
    "change",
    "blur",
    "keydown",
    "close",
    "focus"
  ],
  props: {
    inputClass: {},
    containerClass: {},
    inputStyle: TVuePropTypes.style,
    uniqueId: {
      type: String,
      required: true
    },
    model: {
      type: Object,
      required: true
    },
    value: {
      type: String,
      default: ""
    },
    isEditedCell: {
      type: Boolean,
      default: false
    },
    isTableCell: {
      type: Boolean,
      default: false
    },
    types: {
      type: Object,
      required: true
    },
    autofocus: Boolean,
    handlers: {
      type: Object
    },
    validationHandlers: {
      type: Object,
      default: VALIDATION_HANDLERS
    },
    globalHandlers: { type: Object },
    isValid: Boolean,
    help: String,
    readOnly: Boolean,
    forceChangeModelValue: {}
  },
  setup() {
    return {
      ICONS,
      declension,
      inputListId: makeId(10),
      boolToString,
      Logger: Logger$1
    };
  },
  data() {
    return {
      vocTableDataSet: null,
      tableDataSetFactory: null,
      newValue: {},
      inputValue: "",
      show: {
        footer: true,
        modal: false
      },
      updatePromptsDebounce: debounce(this.updatePrompts, 300),
      updateSearchDebounce: debounce(this.updateSearch, 300)
    };
  },
  async created() {
    this.$watch(
      () => this.forceChangeModelValue,
      () => {
        this.initInput();
      }
    );
    this.$watch(
      () => this.value,
      () => {
        if (!this.model.vocDataSet) {
          return;
        }
        this.model.vocDataSet.setValue(this.value);
      },
      { immediate: true }
    );
    this.$watch(
      () => this.show.modal,
      () => {
        if (this.show.modal) {
          this.init();
        } else {
          this.modalDeactivated();
        }
      }
    );
    this.$watch(
      () => this.isEditedCell,
      () => {
        if (this.isEditedCell) {
          this.initInput();
          if (this.show.modal) {
            this.init();
          }
          if (this.autofocus) {
            this.$nextTick(() => this.focus());
          }
        }
      }
    );
    this.$watch(
      () => this.model.vocDataSet.data.search,
      () => {
        if (!this.vocTableDataSet) {
          return;
        }
        this.updateSearchDebounce();
      }
    );
    this.$watch(
      () => this.initialFilters,
      () => {
        const vocTableDataSet = this.vocTableDataSet;
        if (!vocTableDataSet) {
          return;
        }
        vocTableDataSet.setInitialFilters(this.initialFilters);
        vocTableDataSet.getVisibleRows();
      },
      { immediate: true }
    );
    if (this.isEditedCell) {
      this.initInput();
      if (this.show.modal) {
        await this.init();
      } else {
        await this.updatePrompts();
      }
    }
  },
  deactivated() {
    this.modalDeactivated();
  },
  async mounted() {
  },
  computed: {
    initialFilters() {
      const filters = [
        ...this.model.vocDataSet.data.searchFilters.map((filter) => ({
          key: "search",
          filter
        })),
        ...this.model.vocDataSet.data.panelFilters.map((filter) => ({
          key: "panel",
          filter
        }))
      ];
      if (this.modelVocFilter) {
        filters.push({
          key: "model",
          filter: this.modelVocFilter
        });
      }
      return filters.filter(
        (x) => Boolean(x.filter)
      );
    },
    modelVocFilter() {
      var _a;
      return FilterFactory.parseString((_a = this.model.modelDto) == null ? void 0 : _a.voc_filter);
    },
    inputStyleComputed() {
      return [{ lineHeight: "100%" }, this.inputStyle];
    },
    vocLabelBlockClass() {
      const classObj = {};
      classObj["voc-label-block-readonly"] = this.readOnly;
      if (this.containerClass) {
        if (typeof this.containerClass === "string") {
          classObj[this.containerClass] = true;
        } else {
          classObj.containerClass = this.containerClass;
        }
      }
      return classObj;
    },
    isReadonlyInput() {
      return this.model.vocDataSet.typeOrRepository.translate_value_id;
    },
    newValueByValue() {
      return getVocValuesIdByCellValue(this.value).reduce(
        (newValue, valueId) => {
          newValue[valueId] = {};
          return newValue;
        },
        {}
      );
    },
    valueByNewValue() {
      return Object.keys(this.newValue).join(`${VOC_JOIN_SEPARATOR} `);
    },
    inputValueByNewValue() {
      return Object.keys(this.newValue).join(`${VOC_JOIN_SEPARATOR} `);
    },
    newValueByInputValue() {
      if (!this.inputValue) {
        return {};
      }
      return this.inputValue.split(VOC_JOIN_SEPARATOR).reduce((newValue, valueId) => {
        newValue[valueId.trim()] = {};
        return newValue;
      }, {});
    },
    rowsSelected() {
      return Object.keys(this.newValue).length;
    },
    valuesValueIdDict() {
      if (!this.vocTableDataSet) {
        return {};
      }
      return this.vocTableDataSet.rows.reduce((value, tableRow, row) => {
        const vocValue = tableRow.original;
        value[toStr(vocValue.value_id)] = {
          voc: vocValue,
          tableRow,
          row
        };
        return value;
      }, {});
    },
    vocLabel() {
      return TableCell.getLabelByVocType(
        this.model.vocDataSet,
        this.value,
        "default"
      );
    },
    vocLabelComputed() {
      var _a;
      let label = this.vocLabel;
      if ((_a = this.handlers) == null ? void 0 : _a.before_label) {
        TableHandlersHelper.executeBeforeLabel(
          this.handlers.before_label,
          label,
          (newValue) => {
            label = newValue;
          }
        );
      }
      return label;
    },
    selectionMode() {
      return ModelHelper.getSelectionMode(this.model.modelDto, this.type);
    },
    type() {
      return this.types[this.model.type];
    },
    serverFilterSort() {
      var _a, _b, _c;
      return (_c = (_b = (_a = this.model.vocDataSet.typeOrRepository.form) == null ? void 0 : _a.table.options) == null ? void 0 : _b.server_filter_sort) != null ? _c : true;
    },
    modelSort() {
      if (!this.vocTableDataSet || !this.model.vocDataSet.cachedVoc) {
        return [];
      }
      const { headers, model } = this.model.vocDataSet.cachedVoc.dto.form.table;
      return getModelDtoSort(headers, model);
    },
    isShowFooter() {
      return this.selectionMode === "multiple" && this.show.footer;
    }
  },
  methods: {
    modalDeactivated() {
      var _a;
      (_a = this.vocTableDataSet) == null ? void 0 : _a.destroy();
      this.vocTableDataSet = null;
    },
    onAnyFocus(event) {
      this.$emit("focus", event);
    },
    focus() {
      var _a;
      (_a = this.$refs.inputRef) == null ? void 0 : _a.focus();
    },
    async onUpdateVoc() {
      if (!this.vocTableDataSet || !this.tableDataSetFactory) {
        throw new Error("not found data");
      }
      this.model.vocDataSet.clearCache();
      await this.model.vocDataSet.onLoad(
        this.vocTableDataSet,
        this.tableDataSetFactory
      );
    },
    async updatePrompts() {
      var _a, _b, _c;
      if (this.inputValue === this.model.vocDataSet.data.promptsValue || !this.serverFilterSort && ((_a = this.model.modelDto) == null ? void 0 : _a.voc_filter)) {
        return;
      }
      this.model.vocDataSet.setDataAssign({
        promptsValue: this.inputValue
      });
      try {
        const { json: newPrompts } = await ApiService$1.getVocsSearchByValueId(
          (_b = this.model.vocDataSet.type) == null ? void 0 : _b.voc_type,
          this.inputValue || "",
          150,
          true,
          (_c = this.model.modelDto) == null ? void 0 : _c.voc_filter,
          this.value,
          this.type.data_url,
          GlobalContext.get()
        );
        if (this.model.vocDataSet.data.prompts.size >= 150) {
          this.model.vocDataSet.data.prompts.clear();
        }
        for (const newPrompt of newPrompts.result) {
          this.model.vocDataSet.data.prompts.add(newPrompt);
        }
      } catch (e) {
        await ApiHelper.wrapNotifyError(e, {
          isError: true,
          title: "\u041F\u043E\u0438\u0441\u043A \u0432 \u0441\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A\u0435"
        });
        Logger$1.error({ e });
      }
    },
    updateSearch() {
      const vocTableDataSet = this.vocTableDataSet;
      if (!vocTableDataSet) {
        this.model.vocDataSet.setDataAssign({
          search: "",
          searchFilters: []
        });
        return;
      }
      const filter = FilterFactory.createSearchFilter(
        this.model.vocDataSet.data.search,
        vocTableDataSet.getSystemFields()
      );
      this.model.vocDataSet.setDataAssign({
        searchFilters: [filter]
      });
    },
    focusSearch(event) {
      const searchComponent = this.$refs.searchRef;
      if ((event == null ? void 0 : event.target) === searchComponent.$refs.inputRef) {
        return;
      }
      searchComponent.focus();
    },
    onPanelFiltersExecute(data) {
      const vocTableDataSet = this.vocTableDataSet;
      if (!vocTableDataSet) {
        Logger$1.warn("onPanelFiltersExecute return");
        return;
      }
      const filterLogical = PanelFiltersFactory.toFilterLogical(data);
      this.model.vocDataSet.setDataAssign({
        panelFilters: [filterLogical]
      });
    },
    focusTable() {
      var _a, _b;
      (_b = (_a = this.vocTableDataSet) == null ? void 0 : _a.getTableEl()) == null ? void 0 : _b.focus();
    },
    getTableDataSetFactory(voc) {
      var _a, _b, _c, _d;
      const formRepository = voc.dto;
      const filtersSet = new PanelFiltersSet();
      filtersSet.subject.subscribe(this.onPanelFiltersExecute);
      const tableDto = formRepository.form.table;
      return new TableDataSetFactory({
        tableName: "voc-select-table",
        uniqId: toNormaliseDomId(
          `${(_c = (_b = (_a = voc.type) == null ? void 0 : _a.voc_type) != null ? _b : voc.repositoryType.data_url) != null ? _c : this.uniqueId}`
        ),
        headers: tableDto.headers,
        modelDtoArray: tableDto.model,
        rows: voc.values.map((x) => VocDataSet.getAttrs(x, formRepository)),
        rowsOriginal: voc.values,
        types: formRepository.types,
        edit: {},
        repository: new TableDefaultRepository(),
        getSystemField: (model) => `attrs.${model.field}`,
        enableAutoSaveSettings: true,
        tableDataSetOptions: {
          listeners: {
            destroy: {
              next: () => {
                this.model.vocDataSet.tableDataSetDestroy(
                  this.vocTableDataSet
                );
              }
            },
            changeFilters: {
              next: async () => {
                if (!this.tableDataSetFactory) {
                  return;
                }
                await this.model.vocDataSet.onChangeFilters(
                  this.vocTableDataSet,
                  this.tableDataSetFactory
                );
              }
            },
            changeSort: {
              next: async () => {
                if (!this.tableDataSetFactory) {
                  return;
                }
                await this.model.vocDataSet.onChangeSort(
                  this.vocTableDataSet,
                  this.tableDataSetFactory
                );
              }
            }
          },
          extra: {
            voc_type: (_d = voc.type) == null ? void 0 : _d.voc_type
          },
          filtersSet,
          uniqueWordWrapSave: true,
          optionsDto: tableDto.options
        },
        isSelection: true
      });
    },
    async updateValuesRemain(dataSetData, dataSet, tableDataSet) {
      if (!dataSetData.lazyPaginationState) {
        return;
      }
      const pagination = dataSet.pagination;
      pagination.setValuesRemain(dataSetData.lazyPaginationState.values_remain);
      tableDataSet.options.pagination = pagination;
    },
    getDataSetData() {
      return this.model.vocDataSet.getCacheOrLoad();
    },
    async initVocTableDataSet() {
      const dataSetData = await this.getDataSetData();
      const factory = this.getTableDataSetFactory(dataSetData);
      let tableDataSet;
      if (this.vocTableDataSet) {
        tableDataSet = this.vocTableDataSet;
        const tableRows = factory.getTableRows(await factory.getModel());
        tableDataSet.setTableRows(tableRows);
      } else {
        tableDataSet = await factory.create();
      }
      tableDataSet.setInitialFilters(this.initialFilters);
      tableDataSet.options.pagination = this.model.vocDataSet.pagination;
      await this.model.vocDataSet.updateValuesRemain(dataSetData, tableDataSet);
      this.tableDataSetFactory = factory;
      this.vocTableDataSet = tableDataSet;
    },
    initInput() {
      this.newValue = this.newValueByValue;
      this.updateInputValue();
      this.show.modal = false;
    },
    async init() {
      this.model.vocDataSet.setContext(
        GlobalContext.get()
      );
      if (this.serverFilterSort) {
        const filter = this.initialFilters.length ? FilterFactory.createLogical(
          "and",
          this.initialFilters.map((x) => x.filter)
        ) : void 0;
        this.model.vocDataSet.setFilter(filter);
      }
      await this.model.vocDataSet.get();
      if (this.vocTableDataSet === null) {
        await this.initVocTableDataSet();
      }
      this.updateSearch();
      this.initCurrentSelectedRows();
    },
    initCurrentSelectedRows() {
      if (!this.vocTableDataSet) {
        Logger$1.error("vocTableDataSet === ", this.vocTableDataSet);
        return;
      }
      let newCursor = null;
      this.vocTableDataSet.rows.forEach((tableRow, row) => {
        const vocValue = tableRow.original;
        tableRow.select = Boolean(this.newValue[toStr(vocValue.value_id)]);
        if (tableRow.select && newCursor === null) {
          newCursor = {
            row,
            col_name: this.vocTableDataSet.getFirstColNameVisible()
          };
        }
      });
      this.vocTableDataSet.setCursor(
        newCursor || this.vocTableDataSet.getFirstVisibleCellPointer()
      );
    },
    updateInputValue() {
      this.inputValue = this.inputValueByNewValue;
    },
    updateNewValue() {
      this.newValue = this.newValueByInputValue;
    },
    hideModal() {
      this.show.modal = false;
    },
    setShowModal(modal) {
      this.show.modal = modal;
    },
    onClickColumnRow(row) {
      if (this.selectionMode === "single") {
        this.onSelectOnly(row);
      } else {
        this.onSwitchRow(row);
      }
    },
    onClickRemoveByValueId(value_id) {
      if (toStr(value_id) in this.valuesValueIdDict) {
        return this.onClickColumnRow(
          this.valuesValueIdDict[toStr(value_id)].row
        );
      }
      delete this.newValue[toStr(value_id)];
    },
    onSwitchRow(row) {
      var _a;
      const tableRow = (_a = this.vocTableDataSet) == null ? void 0 : _a.getRowOrUndefined(row);
      if (!tableRow || !TableRow.isSelectable(tableRow)) {
        return;
      }
      tableRow.select = !tableRow.select;
      this.updateNewValueByRow(row);
    },
    onSelectOnly(row) {
      this.onSelectedAll("clear");
      this.onSwitchRow(row);
      return;
    },
    confirm() {
      this.$emit("change", {
        value: this.valueByNewValue,
        vocNewValueDict: this.newValue
      });
    },
    confirmAndFocusInput() {
      this.confirm();
      this.focus();
    },
    sendNotSelectable() {
      NotificationsService$1.send({
        title: "\u041E\u0448\u0438\u0431\u043A\u0430 \u0432\u044B\u0431\u043E\u0440\u0430",
        text: "\u0422\u0435\u043A\u0443\u0449\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C \u043D\u0435\u043B\u044C\u0437\u044F \u0432\u044B\u0431\u0440\u0430\u0442\u044C",
        type: "error",
        duration: 5e3
      });
    },
    onConfirmInput() {
      const isCursorSelectable = this.isCursorSelectable();
      if (this.selectionMode === "single") {
        if (isCursorSelectable === false) {
          this.sendNotSelectable();
          return;
        } else if (isCursorSelectable) {
          this.onSelectOnly(this.vocTableDataSet.selected.cursor.row);
        }
      }
      this.confirmAndFocusInput();
    },
    isPointerSelectable(pointer) {
      const vocTableDataSet = this.vocTableDataSet;
      if (!vocTableDataSet) {
        return false;
      }
      if (!pointer) {
        return false;
      }
      const rowObj = vocTableDataSet.rows[pointer.row];
      return TableRow.isSelectable(rowObj);
    },
    isCursorSelectable() {
      var _a;
      if (!((_a = this.vocTableDataSet) == null ? void 0 : _a.selected.cursor)) {
        return void 0;
      }
      return this.isPointerSelectable(this.vocTableDataSet.selected.cursor);
    },
    onSelectedAll(mode = "") {
      if (!this.vocTableDataSet) {
        return;
      }
      const isSelectedAll = this.vocTableDataSet.isSelectedAll;
      if (mode === "clear" || isSelectedAll) {
        this.newValue = {};
        this.vocTableDataSet.rows.forEach((x) => x.select = false);
      } else {
        this.newValue = this.vocTableDataSet.visibleRows.reduce(
          (value, tableRow) => {
            const vocValue = tableRow.original;
            if (TableRow.isSelectable(tableRow)) {
              value[toStr(vocValue.value_id)] = { value: vocValue };
              tableRow.select = true;
            }
            return value;
          },
          {}
        );
      }
    },
    onCellEditKeyDown(event) {
      const eventHelper = new KeyboardEventHelper(event);
      if (eventHelper.keyTab.keyEnter.isAnyTrue) {
        this.confirmAndFocusInput();
      }
      if (this.isReadonlyInput && eventHelper.codeDelete.prevent.isAllTrue) {
        this.onClear();
      }
      this.$emit("keydown", event);
    },
    onTableKeyDown(event) {
      var _a, _b;
      const eventHelper = new KeyboardEventHelper(event);
      if (eventHelper.codeDelete.isAnyTrue) {
        this.onSelectedAll("clear");
      } else if (eventHelper.keyTab.keyArrow.keyEnter.codeSpace.pressShift.pressCtrl.isAllFalse) {
        if (!event.altKey && !((_a = this.vocTableDataSet.options.display) == null ? void 0 : _a.fullScreen)) {
          (_b = this.vocTableDataSet) == null ? void 0 : _b.setCursor(null);
          this.focusSearch();
        }
      }
    },
    onSearchKeyDown(event) {
      const eventHelper = new KeyboardEventHelper(event);
      if (!this.vocTableDataSet) {
        return;
      }
      if (eventHelper.keyArrowVertical.keyEnter.isAnyTrue) {
        const tableRow = this.vocTableDataSet.visibleRows[0];
        if (tableRow) {
          TableRow.focusFirstCell(
            this.vocTableDataSet,
            tableRow
          );
        }
        this.focusTable();
      } else {
        this.vocTableDataSet.setCursor(null);
      }
    },
    onModalKeyDown(event) {
      const searchComponent = this.$refs.searchRef;
      const tableComponent = this.$refs.tableRef;
      if (!searchComponent || !tableComponent || !this.vocTableDataSet) {
        return;
      }
      if ([searchComponent.$refs.inputRef, tableComponent.$refs.table].includes(
        event.target
      ) || event.target.classList.contains(
        this.vocTableDataSet.classes.cell
      )) {
        return;
      }
      if (event.code !== "alt") {
        this.focusSearch(event);
      }
    },
    onCellEditInput(event) {
      const el = event.target;
      const eventHelper = new KeyboardEventHelper(event);
      if (this.isReadonlyInput) {
        el.value = this.inputValue;
        if (eventHelper.codeDelete.isAllFalse) {
          this.setShowModal(true);
        }
        return;
      }
      this.inputValue = el.value;
      this.updateNewValue();
      this.updatePromptsDebounce();
    },
    onFocusOut(event) {
      var _a;
      if (!this.isEditedCell) {
        return;
      }
      if (this.show.modal) {
        event.stopPropagation();
        return;
      }
      if (event.relatedTarget !== ((_a = this.$refs.modalButton) == null ? void 0 : _a.$el)) {
        event.stopPropagation();
        this.$nextTick(() => {
          this.updateInputValue();
          this.confirm();
        });
      }
    },
    onInputFocus(event) {
      this.onAnyFocus(event);
      if (this.show.modal) {
        return;
      }
      if (this.isTableCell && this.isReadonlyInput) {
        this.setShowModal(true);
      }
      this.updatePrompts();
    },
    onClose() {
      this.setShowModal(false);
      this.$emit("close");
      this.$nextTick(this.focus);
    },
    onClear() {
      this.inputValue = "";
      this.updateNewValue();
      this.confirmAndFocusInput();
    },
    onSelectedAndConfirm(pointer) {
      this.onSelectedAll("clear");
      this.onSwitchRow(pointer.row);
      this.confirmAndFocusInput();
    },
    updateNewValueByRow(row) {
      var _a;
      const tableRow = (_a = this.vocTableDataSet) == null ? void 0 : _a.getRowOrUndefined(row);
      if (!tableRow) {
        return;
      }
      const vocValue = tableRow.original;
      const value_id = toStr(vocValue.value_id);
      if (tableRow.select) {
        this.newValue[value_id] = { value: vocValue };
      } else {
        delete this.newValue[value_id];
      }
    },
    onCellDblClick(value) {
      if (!this.isPointerSelectable(value.pointer)) {
        this.sendNotSelectable();
        return;
      }
      this.onClickColumnRow(value.pointer.row);
      if (this.selectionMode === "single") {
        this.confirmAndFocusInput();
      }
    },
    onCellKeyDown({
      event,
      pointer
    }) {
      const eventHelper = new KeyboardEventHelper(event);
      if (eventHelper.keyEnter.isAllTrue && eventHelper.pressCtrl.pressShift.pressAlt.isAllFalse) {
        if (this.selectionMode === "single") {
          if (!this.isPointerSelectable(pointer)) {
            this.sendNotSelectable();
            setTimeout(() => {
              var _a;
              (_a = this.vocTableDataSet) == null ? void 0 : _a.setCursor(pointer);
            });
            return;
          }
          this.onSelectedAndConfirm(pointer);
        } else {
          this.confirmAndFocusInput();
          return;
        }
      }
      if (eventHelper.stop.prevent.codeSpace.isAllTrue) {
        this.onClickColumnRow(pointer.row);
      }
    },
    onPagination(mode) {
      if (!this.vocTableDataSet || !this.tableDataSetFactory) {
        throw new Error("not found data");
      }
      const tableDataSet = this.vocTableDataSet;
      const factory = this.tableDataSetFactory;
      return this.model.vocDataSet.paginationLoad(mode, tableDataSet, factory);
    }
  }
});
const __injectCSSVars__$2 = () => {
  useCssVars((_ctx) => ({
    "7d25f194": `url("${_ctx.ICONS.menuDownBlack.src}") right center no-repeat`
  }));
};
const __setup__$2 = __default__$2.setup;
__default__$2.setup = __setup__$2 ? (props, ctx) => {
  __injectCSSVars__$2();
  return __setup__$2(props, ctx);
} : __injectCSSVars__$2;
const _sfc_main$T = __default__$2;
const _hoisted_1$J = ["list", "readonly", "value"];
const _hoisted_2$F = ["id"];
const _hoisted_3$C = ["value"];
const _hoisted_4$x = {
  key: 0,
  class: "flex-full-center"
};
const _hoisted_5$n = { style: { "display": "flex", "width": "calc(100% - 30px)" } };
const _hoisted_6$i = { class: "voc-header" };
const _hoisted_7$e = { class: "voc-header-name" };
const _hoisted_8$9 = { class: "voc-header-toolbar" };
const _hoisted_9$9 = {
  key: 1,
  class: "flex-full-center"
};
const _hoisted_10$9 = {
  key: 2,
  class: "voc-footer"
};
const _hoisted_11$9 = { class: "voc-footer-top" };
const _hoisted_12$8 = { class: "voc-footer-top-labels" };
const _hoisted_13$7 = /* @__PURE__ */ createElementVNode("div", { class: "label-s18-c333" }, "\u0412\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F", -1);
const _hoisted_14$6 = { class: "label-gray" };
const _hoisted_15$6 = { class: "voc-footer-top-buttons" };
const _hoisted_16$5 = ["alt", "src"];
const _hoisted_17$5 = /* @__PURE__ */ createElementVNode("span", null, "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C", -1);
const _hoisted_18$4 = /* @__PURE__ */ createElementVNode("span", null, "\u0421\u043A\u0440\u044B\u0442\u044C", -1);
const _hoisted_19$4 = { class: "voc-footer-content" };
const _hoisted_20$3 = ["data-not-found"];
const _hoisted_21$3 = { class: "voc-footer-content-value__title" };
function _sfc_render$T(_ctx, _cache, $props, $setup, $data, $options) {
  var _a;
  const _component_ButtonComponent = resolveComponent("ButtonComponent");
  const _component_CircleLoader = resolveComponent("CircleLoader");
  const _component_TableActionsComponent = resolveComponent("TableActionsComponent");
  const _component_SearchComponent = resolveComponent("SearchComponent");
  const _component_PanelFilters = resolveComponent("PanelFilters");
  const _component_TableMultiHeaders = resolveComponent("TableMultiHeaders");
  const _component_TableComponent = resolveComponent("TableComponent");
  const _component_TablePaginationBottom = resolveComponent("TablePaginationBottom");
  const _component_CloseIcon = resolveComponent("CloseIcon");
  const _component_ModalComponent = resolveComponent("ModalComponent");
  const _component_TableCellLabelComponent = resolveComponent("TableCellLabelComponent");
  return openBlock(), createElementBlock(Fragment, null, [
    withDirectives(createElementVNode("div", {
      class: normalizeClass([_ctx.containerClass, "table-cell-voc-container"])
    }, [
      createElementVNode("input", {
        ref: "inputRef",
        class: normalizeClass(_ctx.inputClass),
        list: _ctx.inputListId,
        readonly: _ctx.isReadonlyInput,
        style: normalizeStyle(_ctx.inputStyleComputed),
        value: _ctx.isReadonlyInput ? _ctx.vocLabelComputed : _ctx.inputValue,
        onFocus: _cache[0] || (_cache[0] = (...args) => _ctx.onInputFocus && _ctx.onInputFocus(...args)),
        onFocusout: _cache[1] || (_cache[1] = (...args) => _ctx.onFocusOut && _ctx.onFocusOut(...args)),
        onInput: _cache[2] || (_cache[2] = (...args) => _ctx.onCellEditInput && _ctx.onCellEditInput(...args)),
        onKeydown: _cache[3] || (_cache[3] = (...args) => _ctx.onCellEditKeyDown && _ctx.onCellEditKeyDown(...args)),
        onPaste: _cache[4] || (_cache[4] = withModifiers(() => {
        }, ["stop"]))
      }, null, 46, _hoisted_1$J),
      !_ctx.isReadonlyInput ? (openBlock(), createElementBlock("datalist", {
        key: 0,
        id: _ctx.inputListId
      }, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.model.vocDataSet.data.prompts, (promt) => {
          return openBlock(), createElementBlock("option", {
            key: promt,
            value: promt
          }, null, 8, _hoisted_3$C);
        }), 128))
      ], 8, _hoisted_2$F)) : createCommentVNode("", true),
      createVNode(_component_ButtonComponent, {
        ref: "modalButton",
        icon: _ctx.ICONS.chevronDownAccent,
        class: "button-opacity",
        style: { "width": "24px", "height": "24px" },
        tabindex: "-1",
        onClick: _cache[5] || (_cache[5] = ($event) => _ctx.show.modal = true)
      }, null, 8, ["icon"])
    ], 2), [
      [vShow, _ctx.isEditedCell]
    ]),
    _ctx.isEditedCell && _ctx.show.modal ? (openBlock(), createBlock(_component_ModalComponent, {
      key: 0,
      "is-show-body-close-button": true,
      "body-style": "padding: 0;",
      "content-style": "flex-grow: 1; overflow: auto;",
      style: { "display": "flex", "flex-direction": "column", "flex-grow": "1", "overflow": "auto", "max-width": "100vw" },
      visible: "",
      onClose: _ctx.onClose,
      onContentOnKeyDown: _ctx.onModalKeyDown
    }, {
      body: withCtx(({ close }) => {
        var _a2;
        return [
          !_ctx.model.vocDataSet.cachedVoc ? (openBlock(), createElementBlock("div", _hoisted_4$x, [
            createVNode(_component_CircleLoader, { zoom: "1" })
          ])) : (openBlock(), createElementBlock("div", {
            key: 1,
            style: { "display": "flex", "flex-direction": "column", "flex-grow": "1", "overflow": "auto" },
            onKeydown: _cache[11] || (_cache[11] = (...args) => _ctx.onModalKeyDown && _ctx.onModalKeyDown(...args))
          }, [
            createElementVNode("div", _hoisted_5$n, [
              createElementVNode("div", _hoisted_6$i, [
                createElementVNode("div", _hoisted_7$e, toDisplayString((_a2 = _ctx.model.vocDataSet.cachedVoc.type) == null ? void 0 : _a2.voc_name), 1),
                createElementVNode("div", _hoisted_8$9, [
                  renderSlot(_ctx.$slots, "voc-header-toolbar-start", normalizeProps(guardReactiveProps(this))),
                  _ctx.vocTableDataSet ? (openBlock(), createBlock(_component_TableActionsComponent, {
                    key: 0,
                    "table-data-set": _ctx.vocTableDataSet,
                    "changes-state": "hide",
                    "filter-state": "enable",
                    "full-screen-state": "hide",
                    "icons-style": "gap: 20px;",
                    "row-append-state": "hide",
                    "update-indexes-state": "hide"
                  }, null, 8, ["table-data-set"])) : createCommentVNode("", true),
                  createVNode(_component_SearchComponent, {
                    ref: "searchRef",
                    "is-original-enter-event": true,
                    "model-value": _ctx.model.vocDataSet.data.search,
                    classContainer: "voc-input-search",
                    onKeydown: _ctx.onSearchKeyDown,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => _ctx.model.vocDataSet.setDataAssign({ search: $event }))
                  }, null, 8, ["model-value", "onKeydown"]),
                  createVNode(_component_ButtonComponent, {
                    icon: _ctx.ICONS.autorenew,
                    class: "button-blue",
                    onClick: _ctx.onUpdateVoc
                  }, {
                    default: withCtx(() => [
                      createTextVNode(" \u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C ")
                    ]),
                    _: 1
                  }, 8, ["icon", "onClick"]),
                  createElementVNode("button", {
                    class: "form-button",
                    "data-type": "accent",
                    style: { "min-width": "167px" },
                    onClick: _cache[7] || (_cache[7] = (...args) => _ctx.onConfirmInput && _ctx.onConfirmInput(...args))
                  }, " \u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C \u0432\u0432\u043E\u0434 ")
                ])
              ])
            ]),
            _ctx.vocTableDataSet ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
              _ctx.vocTableDataSet.options.filtersSet.open ? (openBlock(), createBlock(_component_PanelFilters, {
                key: 0,
                "data-set": _ctx.vocTableDataSet.options.filtersSet,
                "global-handlers": _ctx.globalHandlers,
                "model-array": _ctx.vocTableDataSet.modelUnref,
                "table-data-set": _ctx.vocTableDataSet,
                types: _ctx.vocTableDataSet.types,
                "validation-handlers": _ctx.validationHandlers,
                style: { "margin-inline": "20px", "margin-bottom": "10px" },
                onKeydown: _cache[8] || (_cache[8] = withModifiers(() => {
                }, ["stop"]))
              }, null, 8, ["data-set", "global-handlers", "model-array", "table-data-set", "types", "validation-handlers"])) : createCommentVNode("", true),
              createVNode(_component_TableComponent, {
                ref: "tableRef",
                "init-cursor": void 0,
                isShowInfo: false,
                "screen-spinner": _ctx.model.vocDataSet.pagination.loading,
                "selection-mode": _ctx.selectionMode,
                "table-data-set": _ctx.vocTableDataSet,
                "container-class": "table-scroll-container",
                "container-style": "flex-grow: 1; height: initial; overflow: auto;",
                onClickColumnSelect: _ctx.onClickColumnRow,
                onCellDblClick: _ctx.onCellDblClick,
                onCellKeydown: _ctx.onCellKeyDown,
                onTableKeydown: _ctx.onTableKeyDown
              }, {
                headers: withCtx(({ classes }) => [
                  createVNode(_component_TableMultiHeaders, {
                    classes,
                    "left-col": _ctx.selectionMode === "multiple" ? "checkbox" : void 0,
                    "table-data-set": _ctx.vocTableDataSet,
                    onClickLeftCol: _ctx.onSelectedAll
                  }, null, 8, ["classes", "left-col", "table-data-set", "onClickLeftCol"])
                ]),
                _: 1
              }, 8, ["screen-spinner", "selection-mode", "table-data-set", "onClickColumnSelect", "onCellDblClick", "onCellKeydown", "onTableKeydown"]),
              createVNode(_component_TablePaginationBottom, {
                "table-data-set": _ctx.vocTableDataSet,
                onPagination: _ctx.onPagination
              }, null, 8, ["table-data-set", "onPagination"])
            ], 64)) : (openBlock(), createElementBlock("div", _hoisted_9$9, [
              createVNode(_component_CircleLoader, { zoom: "1" })
            ])),
            _ctx.isShowFooter ? (openBlock(), createElementBlock("div", _hoisted_10$9, [
              createElementVNode("div", _hoisted_11$9, [
                createElementVNode("div", _hoisted_12$8, [
                  _hoisted_13$7,
                  createElementVNode("div", _hoisted_14$6, " \u0412\u044B\u0431\u0440\u0430\u043D\u043E " + toDisplayString(_ctx.rowsSelected) + " " + toDisplayString(_ctx.declension("\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435", "\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439", "\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F", _ctx.rowsSelected)), 1)
                ]),
                createElementVNode("div", _hoisted_15$6, [
                  createElementVNode("button", {
                    class: "button-blue",
                    onClick: _cache[9] || (_cache[9] = ($event) => _ctx.onSelectedAll("clear"))
                  }, [
                    createElementVNode("img", {
                      alt: _ctx.ICONS.restoreBlue.alt,
                      src: _ctx.ICONS.restoreBlue.src,
                      style: { "margin-right": "8px" }
                    }, null, 8, _hoisted_16$5),
                    _hoisted_17$5
                  ]),
                  createElementVNode("button", {
                    class: "button-blue",
                    onClick: _cache[10] || (_cache[10] = ($event) => _ctx.show.footer = false)
                  }, [
                    createVNode(_component_CloseIcon, { style: { "margin-right": "8px" } }),
                    _hoisted_18$4
                  ])
                ])
              ]),
              createElementVNode("div", _hoisted_19$4, [
                _ctx.vocTableDataSet ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(_ctx.newValue, (v, key) => {
                  return openBlock(), createElementBlock("div", {
                    key,
                    "data-not-found": _ctx.boolToString(!(key in _ctx.valuesValueIdDict)),
                    class: "voc-footer-content-value"
                  }, [
                    createElementVNode("div", _hoisted_21$3, toDisplayString(key in _ctx.valuesValueIdDict ? _ctx.valuesValueIdDict[key].voc.label : key), 1),
                    createVNode(_component_ButtonComponent, {
                      icon: _ctx.ICONS.closeBlue,
                      class: "button-close",
                      style: { "margin": "4px" },
                      onClick: ($event) => _ctx.onClickRemoveByValueId(key)
                    }, null, 8, ["icon", "onClick"])
                  ], 8, _hoisted_20$3);
                }), 128)) : createCommentVNode("", true)
              ])
            ])) : createCommentVNode("", true)
          ], 32))
        ];
      }),
      _: 3
    }, 8, ["onClose", "onContentOnKeyDown"])) : createCommentVNode("", true),
    !_ctx.isEditedCell ? (openBlock(), createElementBlock("div", {
      key: 1,
      class: normalizeClass([_ctx.vocLabelBlockClass, "voc-label-block"])
    }, [
      createVNode(_component_TableCellLabelComponent, {
        "before-label": (_a = _ctx.handlers) == null ? void 0 : _a.before_label,
        help: _ctx.help,
        "is-valid": _ctx.isValid,
        label: _ctx.vocLabel,
        class: "table-div-span"
      }, null, 8, ["before-label", "help", "is-valid", "label"])
    ], 2)) : createCommentVNode("", true)
  ], 64);
}
var TableCellVocComponent = /* @__PURE__ */ _export_sfc(_sfc_main$T, [["render", _sfc_render$T]]);
const _sfc_main$S = defineComponent({
  name: "TEditableSpan",
  components: {},
  props: {
    style: {},
    modelValue: String,
    autoSize: Boolean,
    tabindex: Number
  },
  emits: ["update:modelValue", "keyup", "input"],
  setup() {
    return {};
  },
  data() {
    return {
      content: ""
    };
  },
  computed: {
    contentComputed() {
      var _a;
      return (_a = this.modelValue) != null ? _a : "";
    },
    styleComputed() {
      return [this.style].filter(Boolean);
    }
  },
  watch: {},
  created() {
  },
  mounted() {
    this.updateInnerText();
    this.$nextTick(() => {
      this.collapseToEnd();
    });
  },
  methods: {
    updateInnerText() {
      this.getSpan().innerText = this.contentComputed;
    },
    getSpan() {
      return this.$refs.spanRef;
    },
    focus() {
      var _a;
      (_a = this.getSpan()) == null ? void 0 : _a.focus();
    },
    collapseToEnd() {
      var _a;
      const span = this.getSpan();
      if (!span || document.activeElement !== span) {
        return;
      }
      document.execCommand("selectAll", false);
      (_a = document.getSelection()) == null ? void 0 : _a.collapseToEnd();
    },
    onInput(event) {
      const value = event.target.innerText;
      this.content = value;
      this.$emit("update:modelValue", value);
      this.$emit("input", event);
    },
    onKeyUp(event) {
      this.$emit("keyup", event);
    }
  }
});
const _hoisted_1$I = ["tabindex"];
function _sfc_render$S(_ctx, _cache, $props, $setup, $data, $options) {
  var _a;
  return openBlock(), createElementBlock("span", {
    ref: "spanRef",
    style: normalizeStyle(_ctx.styleComputed),
    contenteditable: "",
    tabindex: (_a = _ctx.tabindex) != null ? _a : 0,
    onInput: _cache[0] || (_cache[0] = (...args) => _ctx.onInput && _ctx.onInput(...args)),
    onKeyup: _cache[1] || (_cache[1] = (...args) => _ctx.onKeyUp && _ctx.onKeyUp(...args))
  }, null, 44, _hoisted_1$I);
}
var TEditableSpan = /* @__PURE__ */ _export_sfc(_sfc_main$S, [["render", _sfc_render$S]]);
function getKeys(obj) {
  if (!obj) {
    return [];
  }
  return Object.keys(obj);
}
const _sfc_main$R = defineComponent({
  name: "TableCellComponent",
  components: {
    TEditableSpan,
    TableCellModalComponent,
    TableIndicatorsComponent,
    TableCellLabelComponent,
    TableCellCalcComponent,
    TableCellVocComponent,
    TableCellDictComponent,
    TableCellListComponent,
    TDatePicker,
    ButtonComponent
  },
  emits: [
    "update:cell",
    "cell-edit-key-down",
    "key-down",
    "click",
    "dbl-click",
    "open-context-menu",
    "close-context-menu",
    "open",
    "set-current-edit",
    "focus-table",
    "click-group"
  ],
  props: {
    classes: {
      type: Object,
      required: true
    },
    colIndex: {
      type: Number,
      required: true
    },
    currentEdit: { type: Object },
    data: {
      type: Object,
      required: true
    },
    systemAttrs: {
      type: Object,
      required: false
    },
    displayDateFormat: {
      type: String,
      default: DISPLAY_DATE_FORMAT
    },
    tableRow: {
      type: Object,
      required: true
    },
    tableSelected: {
      type: Object,
      required: false
    },
    type: {
      type: Object,
      required: true
    },
    types: {
      type: Object,
      required: true
    },
    uniqueId: {
      type: String,
      required: true
    },
    getEdit: {
      type: Function,
      required: true
    },
    editMode: {
      type: Number,
      required: true
    },
    id: String,
    model: {
      type: Object,
      required: true
    },
    original: {},
    rowIndex: {
      type: Number,
      required: true
    },
    tableInfo: {
      type: Object,
      required: true
    },
    serverDateFormat: {
      type: String,
      default: SERVER_DATE_FORMAT
    },
    validationHandlers: {
      type: Object,
      required: true
    },
    globalHandlers: { type: Object },
    wordWrap: Boolean
  },
  setup() {
    return {
      TableCell,
      TableDataSet
    };
  },
  data() {
    return {
      newValue: toStr(this.data.value),
      vocNewValueDict: void 0,
      lastInputKey: "",
      lastClickEvent: null
    };
  },
  created() {
    this.$watch(
      () => this.data.value,
      () => {
        const value = toStr(this.data.value);
        if (toStr(this.newValue) !== value) {
          this.newValue = value;
          this.vocNewValueDict = void 0;
        }
      }
    );
    this.$watch(
      () => this.isSelectedCellAndIsAllowFocus,
      () => {
        this.$nextTick(() => {
          if (this.isSelectedCellAndIsAllowFocus) {
            this.focusCell();
          }
        });
      },
      { immediate: true }
    );
    this.$watch(
      () => this.isEditedCell,
      () => {
        if (this.isEditedCell) {
          this.focusInput();
          const mode = this.editMode;
          switch (mode) {
            case CellEditMode.Edit:
              this.newValue = toStr(this.data.value);
              break;
            case CellEditMode.Reset:
              this.newValue = TableCell.getEmptyValue(this.type);
              break;
            case CellEditMode.Default:
              this.newValue = TableCell.getDefaultValue(this.type);
              break;
          }
        }
      }
    );
  },
  mounted() {
  },
  methods: {
    onChange(value, vocNewValueDict, force = false) {
      value = toStr(value);
      Logger$1.debug("cell onChange", value);
      if (!this.getEdit("edit")) {
        return false;
      }
      TableHandlersHelper.executeBeforeSave(
        this.handlers.before_save,
        value,
        (newValue) => {
          value = newValue;
        }
      );
      if (toStr(this.data.value) !== value || getKeys(this.vocNewValueDict).length > 0 && !force) {
        this.onUpdateCellValue(value, vocNewValueDict);
      }
      return true;
    },
    onDblClick(event) {
      Logger$1.debug("cell onEditStart");
      this.$emit("dbl-click", {
        pointer: this.pointer,
        event
      });
      if (!this.getEdit("edit")) {
        return;
      }
      this.onChangeCurrentEdit(this.pointer, CellEditMode.Edit);
    },
    focusInput() {
      this.$nextTick(() => {
        var _a;
        (_a = this.$refs.editableSpanRef) == null ? void 0 : _a.focus();
      });
    },
    focusCell() {
      this.$nextTick(() => {
        const cellRef = this.$refs.cellRef;
        if (!cellRef) {
          this.onFocusTable();
          return;
        }
        cellRef.scrollIntoView(SCROLL_INTO_VIEW_PARAMS);
        cellRef.focus();
      });
    },
    onFocusTable() {
      this.$emit("focus-table");
    },
    onCellEditEnd(save, force = false) {
      if (save) {
        if (!this.onChange(this.newValue, this.vocNewValueDict, force)) {
          return false;
        }
      } else {
        this.vocNewValueDict = void 0;
        this.newValue = this.data.value;
      }
      this.onChangeCurrentEdit(null);
      return true;
    },
    onCellEditBlur() {
      if (this.type.external_editor) {
        return;
      }
      Logger$1.debug("cell onCellEditBlur", this.lastInputKey);
      const lastInputKey = this.lastInputKey;
      this.lastInputKey = "";
      if (lastInputKey === "Escape" || lastInputKey === "Enter" || lastInputKey === "Tab") {
        return;
      }
      if (this.onChange(this.newValue)) {
        this.onChangeCurrentEdit(null);
      }
    },
    onContextMenu(event) {
      this.$emit("open-context-menu", {
        event,
        pointer: this.pointer
      });
    },
    onUpdateCell(data) {
      this.$emit("update:cell", data);
    },
    onUpdateCellValue(value, vocNewValueDict) {
      this.onUpdateCell({
        pointer: PointerHelper.getServerFormat(this.pointer),
        newValue: {
          value,
          info: void 0
        },
        vocNewValueDict,
        changes: ["value"],
        original: this.original
      });
    },
    onChangeCurrentEdit(currentEdit, mode) {
      this.$emit("set-current-edit", {
        pointer: currentEdit,
        mode
      });
    },
    onClick(event) {
      this.$emit("click", event, this);
    },
    onKeyDown(event) {
      this.$emit("key-down", {
        pointer: this.pointer,
        event
      });
      const eventHelper = new KeyboardEventHelper(event);
      if (this.isGroupHeader && eventHelper.prevent.codeSpace.isAllTrue) {
        this.onClickGroup();
      }
      if (!this.getEdit("edit")) {
        return;
      }
      if (eventHelper.pressAlt.keyArrowDown.isAllTrue && eventHelper.pressCtrl.pressShift.isAllFalse) {
        this.onChangeCurrentEdit(this.pointer, CellEditMode.Edit);
        event.stopPropagation();
        const typeComponent = this.getRefByType();
        if (typeComponent == null ? void 0 : typeComponent.setShowModal) {
          this.$nextTick(() => typeComponent.setShowModal(true));
        }
      }
      eventHelper.prevent.keyAlt.isAllTrue;
    },
    onCellEditKeyDown(event) {
      Logger$1.debug("cell onCellEditKeyDown");
      this.lastInputKey = event.key;
      const eventHelper = new KeyboardEventHelper(event);
      if (eventHelper.keyEnter.keyTab.isAnyTrue && this.type.base_type !== "VOC") {
        if (!this.onCellEditEnd(true, true)) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }
      }
      if (eventHelper.prevent.keyEscape.isAllTrue) {
        this.onCellEditEnd(false);
        this.focusCell();
        return;
      }
      eventHelper.prevent.keyAlt.isAllTrue;
      this.$emit("cell-edit-key-down", event);
    },
    onClickGroup() {
      this.$emit("click-group", this.tableRow.group);
    },
    getRefByType() {
      var _a;
      switch ((_a = this.type) == null ? void 0 : _a.base_type) {
        case "LIST":
          return this.$refs.listRef;
        case "BASE":
          return this.$refs.editableSpanRef;
        case "VOC":
          return this.$refs.vocRef;
        case "DICT":
          return this.$refs.dictRef;
        case "JSON":
          break;
        case "DATE":
          return this.$refs.inputDate;
        case "CALC":
          return this.$refs.calcRef;
        case "MODAL":
          return this.$refs.modalRef;
      }
      return void 0;
    }
  },
  computed: {
    isGroupAndTargetCell() {
      if (!this.tableRow.cacheGroup) {
        return void 0;
      }
      for (let group of this.tableRow.cacheGroup.groups) {
        if (group.field === this.model.field) {
          return true;
        }
      }
      return false;
    },
    isGroupHeader() {
      var _a;
      return Boolean(
        this.tableRow.group && this.tableRow.group.field === ((_a = this.group) == null ? void 0 : _a.field)
      );
    },
    isGroupHeaderTargetCell() {
      return Boolean(
        this.tableRow.group && this.tableRow.group.field === this.model.field
      );
    },
    group() {
      if (!this.tableRow.cacheGroup) {
        return void 0;
      }
      for (let group of this.tableRow.cacheGroup.groups) {
        if (group.field === this.model.field) {
          return group;
        }
      }
      return void 0;
    },
    labelOpts() {
      return {
        vocDataSet: this.model.vocDataSet,
        serverDateFormat: this.serverDateFormatComputed,
        displayDateFormat: this.displayDateFormatComputed
      };
    },
    label() {
      return TableCell.getLabelByValue(
        this.data.value,
        this.type,
        this.model.modelDto,
        this.labelOpts
      );
    },
    tdClassesComputed() {
      return {
        [this.classes.cell]: true,
        [this.classes.selectedCell]: this.isSelectedCell > 0,
        [this.classes.selectedCell2]: this.isSelectedCell > 1,
        [this.classes.editedCell]: this.isEditedCell
      };
    },
    tsStyleComputed() {
      var _a;
      const style = [];
      if (this.type.style) {
        style.push(this.type.style);
      }
      if (this.systemAttrs) {
        style.push({
          color: this.systemAttrs.color,
          background: this.systemAttrs.background
        });
      }
      if (this.isGroupHeader) {
        style.push({
          fontWeight: "bold"
        });
      }
      if (((_a = this.group) == null ? void 0 : _a.color) !== void 0) {
        style.push({
          background: this.group.color
        });
      }
      return style;
    },
    isEditedCell() {
      var _a, _b;
      return ((_a = this.currentEdit) == null ? void 0 : _a.row) === this.pointer.row && ((_b = this.currentEdit) == null ? void 0 : _b.col_name) === this.pointer.col_name;
    },
    isSelectedCell() {
      return this.tableSelected ? this.tableSelected.isSelectedCell(this.pointer) : 0;
    },
    isFocusedCell() {
      return this.tableSelected ? this.tableSelected.isFocusedCell(this.pointer) : true;
    },
    handlersDto() {
      return ModelHelper.getHandlers(
        this.model.modelDto,
        this.type,
        this.globalHandlers
      );
    },
    handlers() {
      return TableHandlersHelper.getHandlers(this.handlersDto);
    },
    pointer() {
      return {
        row: this.rowIndex,
        col: this.colIndex,
        col_name: this.model.field,
        visual_row: this.tableRow.visualRow
      };
    },
    serverDateFormatComputed() {
      var _a;
      return ((_a = this.type.validation) == null ? void 0 : _a.date_format) || this.serverDateFormat;
    },
    displayDateFormatComputed() {
      var _a;
      return ((_a = this.type.display) == null ? void 0 : _a.date_format) || this.displayDateFormat;
    },
    currentProperty() {
      return {
        col_name: this.model.field,
        row: this.rowIndex
      };
    },
    validError() {
      return getValidError(
        this.model.modelDto,
        this.type,
        this.newValue,
        this.validationHandlers
      );
    },
    isValid() {
      return Boolean(
        this.validError.type === ValidErrorEnum.Ok || this.tableRow.group
      );
    },
    help() {
      var _a;
      return this.validError.label || ((_a = this.type) == null ? void 0 : _a.help) || "\u041D\u0435\u0432\u0430\u043B\u0438\u0434\u043D\u043E\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435";
    },
    isSelectedCellAndIsAllowFocus() {
      return this.isSelectedCell && this.isFocusedCell;
    }
  }
});
const _hoisted_1$H = ["id", "data-type"];
const _hoisted_2$E = ["title"];
const _hoisted_3$B = {
  key: 0,
  style: { "position": "absolute", "top": "2px", "left": "2px" }
};
function _sfc_render$R(_ctx, _cache, $props, $setup, $data, $options) {
  var _a;
  const _component_ButtonComponent = resolveComponent("ButtonComponent");
  const _component_TableIndicatorsComponent = resolveComponent("TableIndicatorsComponent");
  const _component_TEditableSpan = resolveComponent("TEditableSpan");
  const _component_TableCellLabelComponent = resolveComponent("TableCellLabelComponent");
  const _component_TDatePicker = resolveComponent("TDatePicker");
  const _component_TableCellListComponent = resolveComponent("TableCellListComponent");
  const _component_TableCellDictComponent = resolveComponent("TableCellDictComponent");
  const _component_TableCellVocComponent = resolveComponent("TableCellVocComponent");
  const _component_TableCellModalComponent = resolveComponent("TableCellModalComponent");
  const _component_TableCellCalcComponent = resolveComponent("TableCellCalcComponent");
  return _ctx.data ? withDirectives((openBlock(), createElementBlock("td", {
    key: 0,
    id: _ctx.id,
    ref: "cellRef",
    class: normalizeClass(_ctx.tdClassesComputed),
    "data-type": (_a = _ctx.type.validation) == null ? void 0 : _a.type,
    style: normalizeStyle(_ctx.tsStyleComputed),
    tabindex: "0",
    onClick: _cache[13] || (_cache[13] = (...args) => _ctx.onClick && _ctx.onClick(...args)),
    onDblclick: _cache[14] || (_cache[14] = (...args) => _ctx.onDblClick && _ctx.onDblClick(...args)),
    onKeydown: _cache[15] || (_cache[15] = (...args) => _ctx.onKeyDown && _ctx.onKeyDown(...args)),
    onContextmenu: _cache[16] || (_cache[16] = withModifiers((...args) => _ctx.onContextMenu && _ctx.onContextMenu(...args), ["prevent", "stop"]))
  }, [
    createElementVNode("div", {
      class: normalizeClass({
        [_ctx.classes.cellDiv]: true,
        [_ctx.classes.cellInvalid]: !_ctx.isValid && !_ctx.tableRow.cacheGroup
      }),
      title: _ctx.isValid ? "" : _ctx.help
    }, [
      !_ctx.isGroupHeader || _ctx.isGroupHeader && _ctx.isGroupAndTargetCell === true ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        _ctx.isGroupHeader ? (openBlock(), createElementBlock("div", _hoisted_3$B, [
          createVNode(_component_ButtonComponent, {
            class: "button-opacity",
            onClick: withModifiers(_ctx.onClickGroup, ["stop"])
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(_ctx.group.open ? "-" : "+"), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])) : createCommentVNode("", true),
        createVNode(_component_TableIndicatorsComponent, {
          classes: _ctx.classes,
          pointer: _ctx.pointer,
          "table-info": _ctx.tableInfo,
          onOpen: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("open", $event))
        }, null, 8, ["classes", "pointer", "table-info"]),
        _ctx.type.base_type === "BASE" || !_ctx.type.base_type ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
          _ctx.isEditedCell ? (openBlock(), createBlock(_component_TEditableSpan, {
            key: 0,
            ref: "editableSpanRef",
            modelValue: _ctx.newValue,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.newValue = $event),
            "auto-size": _ctx.wordWrap,
            onBlur: _ctx.onCellEditBlur,
            onKeydown: _ctx.onCellEditKeyDown,
            onPaste: _cache[2] || (_cache[2] = withModifiers(() => {
            }, ["stop"]))
          }, null, 8, ["modelValue", "auto-size", "onBlur", "onKeydown"])) : (openBlock(), createBlock(_component_TableCellLabelComponent, {
            key: 1,
            "before-label": _ctx.handlers.before_label,
            help: _ctx.help,
            "is-valid": _ctx.isValid,
            label: _ctx.label
          }, null, 8, ["before-label", "help", "is-valid", "label"]))
        ], 64)) : _ctx.type.base_type === "DATE" ? (openBlock(), createElementBlock(Fragment, { key: 2 }, [
          _ctx.isEditedCell ? (openBlock(), createBlock(_component_TDatePicker, {
            key: 0,
            ref: "inputDate",
            modelValue: _ctx.newValue,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => _ctx.newValue = $event),
            "display-format": _ctx.displayDateFormatComputed,
            format: _ctx.serverDateFormatComputed,
            autofocus: "",
            onBlur: _ctx.onCellEditBlur,
            onKeydown: _ctx.onCellEditKeyDown,
            onPaste: _cache[4] || (_cache[4] = withModifiers(() => {
            }, ["stop"]))
          }, null, 8, ["modelValue", "display-format", "format", "onBlur", "onKeydown"])) : (openBlock(), createBlock(_component_TableCellLabelComponent, {
            key: 1,
            "before-label": _ctx.handlers.before_label,
            help: _ctx.help,
            "is-valid": _ctx.isValid,
            label: _ctx.label
          }, null, 8, ["before-label", "help", "is-valid", "label"]))
        ], 64)) : _ctx.type.base_type === "LIST" ? (openBlock(), createElementBlock(Fragment, { key: 3 }, [
          _ctx.isEditedCell ? (openBlock(), createBlock(_component_TableCellListComponent, {
            key: 0,
            "is-strict": _ctx.type.strict,
            options: _ctx.type.data_source,
            value: _ctx.newValue,
            onChange: _cache[5] || (_cache[5] = ($event) => _ctx.newValue = $event),
            onKeydown: _ctx.onCellEditKeyDown,
            onBlur: _ctx.onCellEditBlur
          }, null, 8, ["is-strict", "options", "value", "onKeydown", "onBlur"])) : (openBlock(), createBlock(_component_TableCellLabelComponent, {
            key: 1,
            "before-label": _ctx.handlers.before_label,
            help: _ctx.help,
            "is-valid": _ctx.isValid,
            label: _ctx.label
          }, null, 8, ["before-label", "help", "is-valid", "label"]))
        ], 64)) : _ctx.type.base_type === "DICT" ? (openBlock(), createElementBlock(Fragment, { key: 4 }, [
          _ctx.isEditedCell ? (openBlock(), createBlock(_component_TableCellDictComponent, {
            key: 0,
            options: _ctx.type.data_source,
            value: _ctx.newValue,
            onChange: _cache[6] || (_cache[6] = ($event) => {
              _ctx.newValue = $event;
              _ctx.onCellEditEnd(true);
              _ctx.focusCell();
            }),
            onKeydown: _ctx.onCellEditKeyDown,
            onBlur: _ctx.onCellEditBlur
          }, null, 8, ["options", "value", "onKeydown", "onBlur"])) : (openBlock(), createBlock(_component_TableCellLabelComponent, {
            key: 1,
            "before-label": _ctx.handlers.before_label,
            help: _ctx.help,
            "is-valid": _ctx.isValid,
            label: _ctx.label
          }, null, 8, ["before-label", "help", "is-valid", "label"]))
        ], 64)) : _ctx.type.base_type === "VOC" && _ctx.model.vocDataSet ? (openBlock(), createBlock(_component_TableCellVocComponent, {
          key: 5,
          ref: "vocRef",
          "global-handlers": _ctx.globalHandlers,
          handlers: _ctx.handlers,
          help: _ctx.help,
          "is-edited-cell": _ctx.isEditedCell,
          "is-table-cell": true,
          "is-valid": _ctx.isValid,
          model: _ctx.model,
          "read-only": !_ctx.getEdit("edit"),
          types: _ctx.types,
          "unique-id": _ctx.uniqueId,
          "validation-handlers": _ctx.validationHandlers,
          value: _ctx.newValue,
          autofocus: "",
          onChange: _cache[7] || (_cache[7] = ($event) => {
            _ctx.newValue = $event.value;
            _ctx.vocNewValueDict = $event.vocNewValueDict;
            _ctx.onCellEditEnd(true);
            _ctx.focusCell();
          }),
          onClose: _cache[8] || (_cache[8] = ($event) => {
            _ctx.onChangeCurrentEdit(null);
            _ctx.focusCell();
          }),
          onKeydown: _ctx.onCellEditKeyDown,
          onBlur: _ctx.onCellEditBlur
        }, {
          "voc-header-toolbar-start": withCtx((payload) => [
            renderSlot(_ctx.$slots, "voc-header-toolbar-start", normalizeProps(guardReactiveProps(payload)))
          ]),
          _: 3
        }, 8, ["global-handlers", "handlers", "help", "is-edited-cell", "is-valid", "model", "read-only", "types", "unique-id", "validation-handlers", "value", "onKeydown", "onBlur"])) : _ctx.type.base_type === "MODAL" ? (openBlock(), createBlock(_component_TableCellModalComponent, {
          key: 6,
          ref: "modalRef",
          "global-handlers": _ctx.globalHandlers,
          handlers: _ctx.handlers,
          help: _ctx.help,
          "is-edited-cell": _ctx.isEditedCell,
          "is-table-cell": true,
          "is-valid": _ctx.isValid,
          model: _ctx.model.modelDto,
          "read-only": !_ctx.getEdit("edit"),
          types: _ctx.types,
          "validation-handlers": _ctx.validationHandlers,
          value: _ctx.newValue,
          autofocus: "",
          onChange: _cache[9] || (_cache[9] = ($event) => {
            _ctx.newValue = $event.value;
            _ctx.onCellEditEnd(true);
            _ctx.focusCell();
          }),
          onKeydown: _ctx.onCellEditKeyDown,
          onBlur: _ctx.onCellEditBlur
        }, null, 8, ["global-handlers", "handlers", "help", "is-edited-cell", "is-valid", "model", "read-only", "types", "validation-handlers", "value", "onKeydown", "onBlur"])) : _ctx.type.base_type === "CALC" ? (openBlock(), createBlock(_component_TableCellCalcComponent, {
          key: 7,
          ref: "calcRef",
          classes: _ctx.classes,
          handlers: _ctx.handlers,
          help: _ctx.help,
          "is-valid": _ctx.isValid,
          isEditedCell: _ctx.isEditedCell,
          "model-dto": _ctx.model.modelDto,
          type: _ctx.type,
          value: _ctx.data.value,
          autofocus: "",
          onBlur: _ctx.onCellEditBlur,
          onChange: _cache[10] || (_cache[10] = ($event) => {
            _ctx.newValue = $event;
            _ctx.onCellEditEnd(true);
          }),
          onClose: _cache[11] || (_cache[11] = ($event) => {
            _ctx.onChangeCurrentEdit(null);
            _ctx.focusCell();
          }),
          onKeydown: _ctx.onCellEditKeyDown,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => _ctx.newValue = $event)
        }, null, 8, ["classes", "handlers", "help", "is-valid", "isEditedCell", "model-dto", "type", "value", "onBlur", "onKeydown"])) : _ctx.type.base_type === "SLOT" && _ctx.model.modelDto.slot ? renderSlot(_ctx.$slots, _ctx.model.modelDto.slot, {
          key: 8,
          classes: _ctx.classes,
          colIndex: _ctx.colIndex,
          data: _ctx.data,
          model: _ctx.model,
          original: _ctx.original,
          rowIndex: _ctx.rowIndex,
          tableRow: _ctx.tableRow,
          type: _ctx.TableDataSet.getTypeModel(_ctx.types, _ctx.model)
        }) : createCommentVNode("", true)
      ], 64)) : createCommentVNode("", true)
    ], 10, _hoisted_2$E)
  ], 46, _hoisted_1$H)), [
    [vShow, !_ctx.model.hide]
  ]) : createCommentVNode("", true);
}
var TableCellComponent = /* @__PURE__ */ _export_sfc(_sfc_main$R, [["render", _sfc_render$R]]);
var ContextMenu_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$Q = defineComponent({
  name: "ContextMenu",
  components: {
    TooltipComponent
  },
  props: {
    minWidth: {
      type: String,
      default: "1em"
    },
    maxWidth: {
      type: String
    },
    backgroundColor: {
      type: String,
      default: "#fbfbfb"
    },
    fontSize: {
      type: String,
      default: "15px"
    },
    borderRadius: {
      type: String,
      default: "0.1em"
    },
    iconColor: {
      type: String,
      default: "#41b883"
    },
    textColor: {
      type: String,
      default: "#35495e"
    }
  },
  data() {
    return {
      items: []
    };
  },
  methods: {
    parseFuncs(items) {
      for (let i in items) {
        if (items[i].autoClose === void 0) {
          items[i].autoClose = true;
        }
        items[i].textColor = this.textColor;
        if (typeof items[i].click != "function") {
          items[i].click = () => null;
        }
        if (items[i].disabled) {
          items[i].click = () => null;
          items[i].cursor = "not-allowed";
          items[i].textColor = "#9b9b9b";
        }
        if (items[i].divider) {
          items[i].divider = "1px solid #ebebeb";
        }
      }
      return items;
    },
    show(event, items, opts = {}) {
      this.items = this.parseFuncs(items);
      this.getTooltipComponent().show(event, opts);
    },
    hide() {
      if (this.getTooltipComponent().visible) {
        this.getTooltipComponent().hide();
      }
    },
    getTooltipComponent() {
      return this.$refs.tooltipFilter;
    }
  }
});
const _hoisted_1$G = { class: "context-menu-container" };
const _hoisted_2$D = ["onClick"];
const _hoisted_3$A = { class: "item-left" };
const _hoisted_4$w = ["alt", "src"];
const _hoisted_5$m = {
  key: 0,
  class: "item-right"
};
const _hoisted_6$h = { class: "item-right-text" };
function _sfc_render$Q(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TooltipComponent = resolveComponent("TooltipComponent");
  return openBlock(), createBlock(_component_TooltipComponent, {
    ref: "tooltipFilter",
    onHide: _ctx.hide
  }, {
    default: withCtx(() => [
      createElementVNode("div", _hoisted_1$G, [
        createElementVNode("ul", {
          style: normalizeStyle({
            minWidth: _ctx.minWidth,
            maxWidth: _ctx.maxWidth,
            backgroundColor: _ctx.backgroundColor,
            fontSize: _ctx.fontSize,
            borderRadius: _ctx.borderRadius
          }),
          class: "context-menu-container__menu"
        }, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.items, (i, idx) => {
            return openBlock(), createElementBlock("li", {
              key: idx,
              class: normalizeClass(!i.icon && !i.text ? void 0 : "item"),
              style: normalizeStyle({
                borderBottom: i.divider,
                cursor: i.cursor
              }),
              onClick: withModifiers(($event) => {
                i.click();
                i.autoClose ? _ctx.hide() : void 0;
              }, ["stop"])
            }, [
              createElementVNode("div", _hoisted_3$A, [
                i.icon ? (openBlock(), createElementBlock("img", {
                  key: 0,
                  alt: i.icon.alt,
                  src: i.icon.src,
                  style: normalizeStyle(i.iconStyle),
                  class: "item-icon"
                }, null, 12, _hoisted_4$w)) : createCommentVNode("", true),
                createElementVNode("span", {
                  style: normalizeStyle({ color: i.textColor }),
                  class: "item-text"
                }, toDisplayString(i.text), 5)
              ]),
              i.rightText ? (openBlock(), createElementBlock("div", _hoisted_5$m, [
                createElementVNode("span", _hoisted_6$h, toDisplayString(i.rightText), 1)
              ])) : createCommentVNode("", true)
            ], 14, _hoisted_2$D);
          }), 128))
        ], 4)
      ])
    ]),
    _: 1
  }, 8, ["onHide"]);
}
var ContextMenu = /* @__PURE__ */ _export_sfc(_sfc_main$Q, [["render", _sfc_render$Q], ["__scopeId", "data-v-c942626c"]]);
let isRegistered$1 = false;
const _sfc_main$P = defineComponent({
  name: "ContextMenuGlobal",
  components: {
    ContextMenu
  },
  props: {},
  emits: [],
  setup() {
    return {
      ContextMenuService
    };
  },
  data() {
    return {
      unsubs: []
    };
  },
  computed: {},
  watch: {},
  created() {
    if (isRegistered$1) {
      Logger$1.warn(
        "\u041A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442 \u043A\u043E\u043D\u0442\u0435\u043A\u0441\u0442\u043D\u043E\u0433\u043E \u043C\u0435\u043D\u044E \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D \u0431\u043E\u043B\u0435\u0435 \u043E\u0434\u043D\u043E\u0433\u043E \u0440\u0430\u0437\u0430. \u041A\u043E\u043D\u0442\u0435\u043A\u0441\u0442\u043D\u044B\u0435 \u043C\u0435\u043D\u044E \u0431\u0443\u0434\u0443\u0442 \u0434\u0443\u0431\u043B\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u044F."
      );
    }
    isRegistered$1 = true;
    this.unsubs.push(
      ContextMenuService.eventSubject.subscribe((event) => {
        const contextMenu = this.getContextMenu();
        if (contextMenu) {
          contextMenu.show(event.event, event.options);
        }
      })
    );
  },
  deactivated() {
    this.unsubs.forEach((x) => x());
  },
  methods: {
    getContextMenu() {
      return this.$refs.contextMenu;
    }
  }
});
function _sfc_render$P(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ContextMenu = resolveComponent("ContextMenu");
  return openBlock(), createBlock(_component_ContextMenu, {
    ref: "contextMenu",
    backgroundColor: "#fbfbfb",
    borderRadius: "0.1em",
    fontSize: "15px",
    iconColor: "#41b883",
    minWidth: "1em",
    textColor: "#35495e"
  }, null, 512);
}
var ContextMenuGlobal = /* @__PURE__ */ _export_sfc(_sfc_main$P, [["render", _sfc_render$P]]);
const _sfc_main$O = defineComponent({
  name: "PlusIcon"
});
const _hoisted_1$F = {
  fill: "none",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$C = /* @__PURE__ */ createElementVNode("path", {
  d: "M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3$z = [
  _hoisted_2$C
];
function _sfc_render$O(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1$F, _hoisted_3$z);
}
var PlusIcon = /* @__PURE__ */ _export_sfc(_sfc_main$O, [["render", _sfc_render$O]]);
const _sfc_main$N = defineComponent({
  name: "MenuDownIcon"
});
const _hoisted_1$E = {
  fill: "none",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$B = /* @__PURE__ */ createElementVNode("path", {
  d: "M7 10L12 15L17 10H7Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3$y = [
  _hoisted_2$B
];
function _sfc_render$N(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1$E, _hoisted_3$y);
}
var MenuDownIcon = /* @__PURE__ */ _export_sfc(_sfc_main$N, [["render", _sfc_render$N]]);
var BlueHelpComponent_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$M = defineComponent({
  name: "BlueHelpComponent",
  emits: ["close"],
  props: {
    classContainer: String,
    styleContainer: {
      required: false
    }
  },
  components: {
    ButtonComponent
  },
  data() {
    return {
      ICONS
    };
  }
});
const _hoisted_1$D = ["alt", "src"];
function _sfc_render$M(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ButtonComponent = resolveComponent("ButtonComponent");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["blue-help", _ctx.classContainer]),
    style: normalizeStyle(_ctx.styleContainer)
  }, [
    createElementVNode("img", {
      alt: _ctx.ICONS.informationOutline.alt,
      src: _ctx.ICONS.informationOutline.src,
      class: "blue-help-icon"
    }, null, 8, _hoisted_1$D),
    createVNode(_component_ButtonComponent, {
      icon: _ctx.ICONS.close,
      class: "button-opacity blue-help-close",
      onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("close"))
    }, null, 8, ["icon"]),
    renderSlot(_ctx.$slots, "default", {}, void 0, true)
  ], 6);
}
var BlueHelpComponent = /* @__PURE__ */ _export_sfc(_sfc_main$M, [["render", _sfc_render$M], ["__scopeId", "data-v-3f42f4d6"]]);
var RecalcActivityRadionuclidesList_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$L = defineComponent({
  name: "RecalcActivityRadionuclidesList",
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      searchText: ""
    };
  },
  computed: {
    searchResults() {
      const search = this.searchText.trim().toLowerCase();
      if (!search) {
        return this.list;
      }
      return this.list.filter((item) => {
        return [item.Name_RN, item.Name_RN_Lat].some(
          (x) => toStr(x).toLowerCase().includes(search)
        );
      });
    }
  },
  methods: {
    listItemClickHandler(item) {
      this.$emit("add-item", item);
    }
  }
});
const _hoisted_1$C = { class: "list calc-section" };
const _hoisted_2$A = { class: "search-input-container" };
const _hoisted_3$x = { class: "search-results" };
const _hoisted_4$v = ["onClick"];
function _sfc_render$L(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$C, [
    createElementVNode("div", _hoisted_2$A, [
      withDirectives(createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.searchText = $event),
        type: "text"
      }, null, 512), [
        [vModelText, _ctx.searchText]
      ])
    ]),
    createElementVNode("div", _hoisted_3$x, [
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.searchResults, (item) => {
        return openBlock(), createElementBlock("div", {
          key: "list_item_" + item.Name_RN + item.ID,
          class: "list-item",
          onClick: ($event) => _ctx.listItemClickHandler(item)
        }, [
          createElementVNode("span", null, toDisplayString(item.Name_RN), 1),
          createElementVNode("span", null, toDisplayString(item.Name_RN_Lat), 1)
        ], 8, _hoisted_4$v);
      }), 128))
    ])
  ]);
}
var RecalcActivityRadionuclidesList = /* @__PURE__ */ _export_sfc(_sfc_main$L, [["render", _sfc_render$L], ["__scopeId", "data-v-d8af1e36"]]);
const UNITS_ACTIVITY = [
  "\u0411\u043A",
  "\u043A\u0411\u043A",
  "\u041C\u0411\u043A",
  "\u0413\u0411\u043A",
  "\u0422\u0411\u043A"
];
function activityToUnit(activity, unitActivity, minus = false) {
  if (!activity) {
    return 0;
  }
  const multMinus = minus ? -1 : 1;
  let mult;
  switch (unitActivity) {
    case "\u0411\u043A":
      return toNumberOrDefault(activity);
    case "\u043A\u0411\u043A":
      mult = 10 ** (3 * multMinus);
      break;
    case "\u041C\u0411\u043A":
      mult = 10 ** (6 * multMinus);
      break;
    case "\u0413\u0411\u043A":
      mult = 10 ** (9 * multMinus);
      break;
    case "\u0422\u0411\u043A":
      mult = 10 ** (12 * multMinus);
      break;
    default:
      throw new Error(`unitActivity not existing: '${unitActivity}'`);
  }
  return toNumberOrDefault(activity) * mult;
}
var RecalcActivityRadionuclidesSetup_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$K = defineComponent({
  name: "RecalcActivityRadionuclidesSetup",
  props: {
    percentOk: Boolean,
    aFormat: { type: String, required: true }
  },
  emits: ["update:aFormat", "calculate"],
  components: {
    AttrInputBase
  },
  setup() {
    return {
      ATTRS_TYPES,
      models: {
        exponential: {
          caption: "\u041D\u0430\u0447\u0430\u043B\u044C\u043D\u0430\u044F \u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u044C",
          field: "activity",
          type: "exponential"
        }
      }
    };
  },
  data() {
    return {
      dateFrom: null,
      dateTo: null,
      time: null,
      timeFormat: "\u0441\u0443\u0442\u043E\u043A",
      a0: null
    };
  },
  computed: {
    aBk() {
      return activityToUnit(this.a0, this.aFormat);
    },
    setupOk() {
      return this.time && toNumberOrDefault(this.a0) > 0;
    }
  },
  methods: {
    dateChangeHandler() {
      if (this.dateFrom && this.dateTo) {
        this.time = (new Date(this.dateTo).getTime() - new Date(this.dateFrom).getTime()) / (1e3 * 3600 * 24);
        this.timeFormat = "\u0441\u0443\u0442\u043E\u043A";
      }
    },
    timeInputHandler(e) {
      this.resetDates();
      this.time = e.target.value;
    },
    timeFormatChangeHandler(e) {
      this.resetDates();
      this.timeFormat = e.target.value;
    },
    resetDates() {
      this.dateFrom = null;
      this.dateTo = null;
    },
    aFormatChangeHandler(e) {
      this.$emit("update:aFormat", e.target.value);
    },
    calculateClickHandler() {
      this.$emit("calculate", this.aBk, this.time, this.timeFormat);
    }
  }
});
const _withScopeId$g = (n) => (pushScopeId("data-v-35359dcd"), n = n(), popScopeId(), n);
const _hoisted_1$B = { class: "setup calc-section" };
const _hoisted_2$z = /* @__PURE__ */ _withScopeId$g(() => /* @__PURE__ */ createElementVNode("span", { class: "title" }, "\u041F\u043E \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D\u0443 \u0434\u0430\u0442", -1));
const _hoisted_3$w = ["max"];
const _hoisted_4$u = ["min"];
const _hoisted_5$l = /* @__PURE__ */ _withScopeId$g(() => /* @__PURE__ */ createElementVNode("span", { class: "title" }, "\u041F\u043E \u043E\u0442\u0440\u0435\u0437\u043A\u0443 \u0432\u0440\u0435\u043C\u0435\u043D\u0438", -1));
const _hoisted_6$g = /* @__PURE__ */ _withScopeId$g(() => /* @__PURE__ */ createElementVNode("option", null, "\u043C\u0438\u043D\u0443\u0442", -1));
const _hoisted_7$d = /* @__PURE__ */ _withScopeId$g(() => /* @__PURE__ */ createElementVNode("option", null, "\u0447\u0430\u0441\u043E\u0432", -1));
const _hoisted_8$8 = /* @__PURE__ */ _withScopeId$g(() => /* @__PURE__ */ createElementVNode("option", null, "\u0441\u0443\u0442\u043E\u043A", -1));
const _hoisted_9$8 = /* @__PURE__ */ _withScopeId$g(() => /* @__PURE__ */ createElementVNode("option", null, "\u043B\u0435\u0442", -1));
const _hoisted_10$8 = [
  _hoisted_6$g,
  _hoisted_7$d,
  _hoisted_8$8,
  _hoisted_9$8
];
const _hoisted_11$8 = /* @__PURE__ */ _withScopeId$g(() => /* @__PURE__ */ createElementVNode("span", { class: "title" }, null, -1));
const _hoisted_12$7 = ["value"];
const _hoisted_13$6 = /* @__PURE__ */ _withScopeId$g(() => /* @__PURE__ */ createElementVNode("option", null, "\u0411\u043A", -1));
const _hoisted_14$5 = /* @__PURE__ */ _withScopeId$g(() => /* @__PURE__ */ createElementVNode("option", null, "\u043A\u0411\u043A", -1));
const _hoisted_15$5 = /* @__PURE__ */ _withScopeId$g(() => /* @__PURE__ */ createElementVNode("option", null, "\u041C\u0411\u043A", -1));
const _hoisted_16$4 = /* @__PURE__ */ _withScopeId$g(() => /* @__PURE__ */ createElementVNode("option", null, "\u0413\u0411\u043A", -1));
const _hoisted_17$4 = /* @__PURE__ */ _withScopeId$g(() => /* @__PURE__ */ createElementVNode("option", null, "\u0422\u0411\u043A", -1));
const _hoisted_18$3 = [
  _hoisted_13$6,
  _hoisted_14$5,
  _hoisted_15$5,
  _hoisted_16$4,
  _hoisted_17$4
];
const _hoisted_19$3 = ["disabled"];
function _sfc_render$K(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_AttrInputBase = resolveComponent("AttrInputBase");
  return openBlock(), createElementBlock("div", _hoisted_1$B, [
    _hoisted_2$z,
    withDirectives(createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.dateFrom = $event),
      max: _ctx.dateTo,
      type: "date",
      onChange: _cache[1] || (_cache[1] = (...args) => _ctx.dateChangeHandler && _ctx.dateChangeHandler(...args))
    }, null, 40, _hoisted_3$w), [
      [vModelText, _ctx.dateFrom]
    ]),
    withDirectives(createElementVNode("input", {
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.dateTo = $event),
      min: _ctx.dateFrom,
      type: "date",
      onChange: _cache[3] || (_cache[3] = (...args) => _ctx.dateChangeHandler && _ctx.dateChangeHandler(...args))
    }, null, 40, _hoisted_4$u), [
      [vModelText, _ctx.dateTo]
    ]),
    _hoisted_5$l,
    withDirectives(createElementVNode("input", {
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => _ctx.time = $event),
      type: "number",
      onInput: _cache[5] || (_cache[5] = (...args) => _ctx.timeInputHandler && _ctx.timeInputHandler(...args))
    }, null, 544), [
      [vModelText, _ctx.time]
    ]),
    withDirectives(createElementVNode("select", {
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => _ctx.timeFormat = $event),
      onChange: _cache[7] || (_cache[7] = (...args) => _ctx.timeFormatChangeHandler && _ctx.timeFormatChangeHandler(...args))
    }, _hoisted_10$8, 544), [
      [vModelSelect, _ctx.timeFormat]
    ]),
    _hoisted_11$8,
    createVNode(_component_AttrInputBase, {
      model: _ctx.models.exponential,
      type: _ctx.ATTRS_TYPES.exponential,
      value: _ctx.a0,
      style: { "margin-bottom": "0" },
      onChange: _cache[8] || (_cache[8] = ($event) => _ctx.a0 = $event),
      onReset: _cache[9] || (_cache[9] = ($event) => _ctx.a0 = "")
    }, null, 8, ["model", "type", "value"]),
    createElementVNode("select", {
      value: _ctx.aFormat,
      onChange: _cache[10] || (_cache[10] = (...args) => _ctx.aFormatChangeHandler && _ctx.aFormatChangeHandler(...args))
    }, _hoisted_18$3, 40, _hoisted_12$7),
    createElementVNode("button", {
      disabled: !_ctx.percentOk || !_ctx.setupOk,
      class: "calculate-btn",
      onClick: _cache[11] || (_cache[11] = (...args) => _ctx.calculateClickHandler && _ctx.calculateClickHandler(...args))
    }, " \u0420\u0430\u0441\u0441\u0447\u0438\u0442\u0430\u0442\u044C ", 8, _hoisted_19$3)
  ]);
}
var RecalcActivityRadionuclidesSetup = /* @__PURE__ */ _export_sfc(_sfc_main$K, [["render", _sfc_render$K], ["__scopeId", "data-v-35359dcd"]]);
var RecalcActivityRadionuclidesResult_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$J = defineComponent({
  name: "RecalcActivityRadionuclidesResult",
  props: {
    active: Array,
    percentOk: Boolean,
    aFormat: String
  },
  emits: ["remove-item", "percent-input"],
  data() {
    return {};
  },
  methods: {
    removeClickHandler(i) {
      this.$emit("remove-item", i);
    },
    percentInputHandler(e, i) {
      const value = e.target.value;
      this.$emit("percent-input", i, value);
    }
  }
});
const _withScopeId$f = (n) => (pushScopeId("data-v-5ba0bba6"), n = n(), popScopeId(), n);
const _hoisted_1$A = { class: "result calc-section" };
const _hoisted_2$y = { class: "stats" };
const _hoisted_3$v = { class: "active-stat" };
const _hoisted_4$t = { class: "name" };
const _hoisted_5$k = { class: "active-stat" };
const _hoisted_6$f = { class: "active-stat" };
const _hoisted_7$c = {
  key: 0,
  class: "active-input-container"
};
const _hoisted_8$7 = ["value", "onInput"];
const _hoisted_9$7 = {
  key: 1,
  class: "active-input-container result-container"
};
const _hoisted_10$7 = ["value"];
const _hoisted_11$7 = /* @__PURE__ */ _withScopeId$f(() => /* @__PURE__ */ createElementVNode("div", { class: "active-result" }, null, -1));
const _hoisted_12$6 = ["onClick"];
function _sfc_render$J(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$A, [
    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.active, (item, i) => {
      return openBlock(), createElementBlock("div", {
        key: "active_item_" + item.ID,
        class: "active-item"
      }, [
        createElementVNode("div", _hoisted_2$y, [
          createElementVNode("span", _hoisted_3$v, [
            createTextVNode("\u041D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435: "),
            createElementVNode("span", _hoisted_4$t, toDisplayString(item.item.Name_RN), 1)
          ]),
          createElementVNode("span", _hoisted_5$k, toDisplayString("\u041E\u0431\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435: " + item.item.Name_RN_Lat), 1),
          createElementVNode("span", _hoisted_6$f, toDisplayString("\u041F\u0435\u0440\u0438\u043E\u0434 \u043F\u043E\u043B\u0443\u0440\u0430\u0441\u043F\u0430\u0434\u0430: " + item.item.Period_p_r + " " + item.item.Edinica_izmer_p_r), 1)
        ]),
        this.active.length > 1 ? (openBlock(), createElementBlock("div", _hoisted_7$c, [
          createElementVNode("input", {
            class: normalizeClass(["active-input", { error: !_ctx.percentOk }]),
            value: Number(item.percent.toFixed(2)),
            type: "number",
            onInput: ($event) => _ctx.percentInputHandler($event, i)
          }, null, 42, _hoisted_8$7),
          createTextVNode(" % ")
        ])) : createCommentVNode("", true),
        item.result != void 0 ? (openBlock(), createElementBlock("div", _hoisted_9$7, [
          createElementVNode("input", {
            value: item.formatResult,
            class: "active-input result",
            readonly: "",
            type: "text"
          }, null, 8, _hoisted_10$7),
          createTextVNode(" " + toDisplayString(item.aFormat), 1)
        ])) : createCommentVNode("", true),
        _hoisted_11$7,
        createElementVNode("button", {
          class: "remove-btn",
          onClick: ($event) => _ctx.removeClickHandler(i)
        }, "X", 8, _hoisted_12$6)
      ]);
    }), 128))
  ]);
}
var RecalcActivityRadionuclidesResult = /* @__PURE__ */ _export_sfc(_sfc_main$J, [["render", _sfc_render$J], ["__scopeId", "data-v-5ba0bba6"]]);
function periodToMinutes(time, format) {
  if (!time) {
    return 0;
  }
  let mult;
  switch (format.slice(0, 3)) {
    case "\u043C\u0438\u043D":
      mult = 1;
      break;
    case "\u0447\u0430\u0441":
      mult = 60;
      break;
    case "\u0441\u0443\u0442":
      mult = 1440;
      break;
    case "\u043B\u0435\u0442":
      mult = 525948.768;
      break;
    default:
      return 0;
  }
  return time * mult;
}
function periodToYears(time, format) {
  let mult;
  switch (format.slice(0, 3)) {
    case "\u043C\u0438\u043D":
      mult = 1;
      break;
    case "\u0447\u0430\u0441":
      mult = 60;
      break;
    case "\u0441\u0443\u0442":
      mult = 1440;
      break;
    case "\u043B\u0435\u0442":
      mult = 525948.768;
      break;
    default:
      return 0;
  }
  return time * mult / 525948.768;
}
var RecalcActivityRadionuclides_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$I = defineComponent({
  name: "RecalcActivityRadionuclides",
  emits: ["init"],
  components: {
    RecalcActivityRadionuclidesList,
    RecalcActivityRadionuclidesSetup,
    RecalcActivityRadionuclidesResult
  },
  data() {
    return {
      list: [],
      active: [],
      radionuclides: [],
      modelValue: "",
      aFormat: "\u0411\u043A"
    };
  },
  async created() {
    const radionuclidesVoc = await ApiService$1.getVocValues(
      VOC_NAMES_DICT.radionuclide_voc,
      void 0,
      true,
      void 0,
      void 0
    );
    this.radionuclides = radionuclidesVoc.json.result.map((x) => {
      return {
        ...x.attrs,
        ID: x.record_id
      };
    });
    this.list = this.radionuclides.filter((item) => {
      return item.Name_RN && item.Period_p_r && item.Name_RN_Lat && item.Edinica_izmer_p_r;
    });
    this.$emit("init");
  },
  computed: {
    filteredList() {
      const activeIds = this.active.map((item) => item.item.ID);
      return this.list.filter((item) => !activeIds.includes(item.ID));
    },
    totalPercent() {
      let totalPercent = this.active.reduce((p, c) => p + c.percent, 0);
      totalPercent = Number(totalPercent.toFixed(12));
      return totalPercent;
    },
    percentOk() {
      return this.active.length != 0 && this.totalPercent == 100;
    }
  },
  methods: {
    addItem(item) {
      let percent;
      if (this.totalPercent == 100) {
        if (this.active.filter((i) => i.percent == 100 / this.active.length).length == this.active.length) {
          percent = 100 / (this.active.length + 1);
          this.active.forEach((i) => i.percent = percent);
        } else {
          percent = 0;
        }
      } else {
        percent = 100 - this.totalPercent;
      }
      this.active.push({
        item,
        percent
      });
      this.resetCalculations();
    },
    removeItem(i) {
      const percent = this.active.splice(i, 1)[0].percent;
      if (this.active.length) {
        if (this.active.length == 1) {
          this.active[0].percent = 100;
        } else {
          this.active[0].percent += percent;
        }
      }
      this.resetCalculations();
    },
    percentInput(i, value) {
      value = parseFloat(value) || 0;
      if (!value) {
        this.active[i].percent = 1;
      }
      this.active[i].percent = value;
      this.resetCalculations();
    },
    calculate(a0, time, timeFormat) {
      this.active.forEach((item) => {
        item.result = a0 * 2 ** (-periodToMinutes(time, timeFormat) / periodToMinutes(
          item.item.Period_p_r,
          item.item.Edinica_izmer_p_r
        ));
        item.result *= item.percent * 0.01;
        item.aFormat = this.aFormat;
        item.formatResult = getExponential(2, toStr(item.result)).value;
      });
    },
    resetCalculations() {
      this.active.forEach((item) => delete item.result);
    }
  }
});
const _hoisted_1$z = { class: "calc" };
const _hoisted_2$x = { class: "right" };
function _sfc_render$I(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RecalcActivityRadionuclidesList = resolveComponent("RecalcActivityRadionuclidesList");
  const _component_RecalcActivityRadionuclidesSetup = resolveComponent("RecalcActivityRadionuclidesSetup");
  const _component_RecalcActivityRadionuclidesResult = resolveComponent("RecalcActivityRadionuclidesResult");
  return withDirectives((openBlock(), createElementBlock("div", _hoisted_1$z, [
    createVNode(_component_RecalcActivityRadionuclidesList, {
      list: _ctx.filteredList,
      onAddItem: _ctx.addItem
    }, null, 8, ["list", "onAddItem"]),
    createElementVNode("div", _hoisted_2$x, [
      createVNode(_component_RecalcActivityRadionuclidesSetup, {
        "a-format": _ctx.aFormat,
        "percent-ok": _ctx.percentOk,
        onCalculate: _ctx.calculate,
        "onUpdate:aFormat": _cache[0] || (_cache[0] = ($event) => _ctx.aFormat = $event)
      }, null, 8, ["a-format", "percent-ok", "onCalculate"]),
      createVNode(_component_RecalcActivityRadionuclidesResult, {
        "a-format": _ctx.aFormat,
        active: _ctx.active,
        "percent-ok": _ctx.percentOk,
        onRemoveItem: _ctx.removeItem,
        onPercentInput: _ctx.percentInput
      }, null, 8, ["a-format", "active", "percent-ok", "onRemoveItem", "onPercentInput"])
    ])
  ], 512)), [
    [vShow, _ctx.radionuclides.length]
  ]);
}
var RecalcActivityRadionuclides = /* @__PURE__ */ _export_sfc(_sfc_main$I, [["render", _sfc_render$I], ["__scopeId", "data-v-505adaac"]]);
var RecalcActivityRadionuclidesDemo_vue_vue_type_style_index_0_lang = "";
const _sfc_main$H = defineComponent({
  name: "RecalcActivityRadionuclidesDemo",
  components: {
    ModalComponent,
    ButtonComponent,
    ScreenSpinner,
    RecalcActivityRadionuclides
  },
  emits: ["close", "open:component"],
  data() {
    return {
      radionuclides: null
    };
  },
  async created() {
    const radionuclidesVoc = await ApiService$1.getVocValues(
      VOC_NAMES_DICT.radionuclide_voc,
      void 0,
      false,
      void 0,
      void 0
    );
    this.radionuclides = radionuclidesVoc.json.result.map((x) => {
      return {
        ...x.attrs,
        ID: x.record_id
      };
    });
  }
});
const _hoisted_1$y = { class: "light-blue-modal-container" };
const _hoisted_2$w = /* @__PURE__ */ createElementVNode("div", { class: "light-blue-modal-container-title" }, " \u041F\u0435\u0440\u0435\u0441\u0447\u0451\u0442 \u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u0438 \u0440\u0430\u0434\u0438\u043E\u043D\u0443\u043A\u043B\u0438\u0434\u043E\u0432 ", -1);
const _hoisted_3$u = {
  class: "light-blue-modal-container-content recalc-activity-radionuclides-demo",
  style: { "padding": "0" }
};
const _hoisted_4$s = { class: "light-blue-modal-container-footer" };
const _hoisted_5$j = /* @__PURE__ */ createElementVNode("div", null, null, -1);
function _sfc_render$H(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ScreenSpinner = resolveComponent("ScreenSpinner");
  const _component_RecalcActivityRadionuclides = resolveComponent("RecalcActivityRadionuclides");
  const _component_ButtonComponent = resolveComponent("ButtonComponent");
  const _component_ModalComponent = resolveComponent("ModalComponent");
  return openBlock(), createBlock(_component_ModalComponent, {
    isShowBodyCloseButton: true,
    visible: true,
    "body-style": "padding: 0;",
    style: { "width": "100vw" },
    "button-close-style": "right: 10px; top: 10px",
    onClose: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("close"))
  }, {
    body: withCtx(({ close }) => [
      _ctx.radionuclides === null ? (openBlock(), createBlock(_component_ScreenSpinner, {
        key: 0,
        dimming: false
      })) : createCommentVNode("", true),
      createElementVNode("div", _hoisted_1$y, [
        _hoisted_2$w,
        createElementVNode("div", _hoisted_3$u, [
          _ctx.radionuclides !== null ? (openBlock(), createBlock(_component_RecalcActivityRadionuclides, {
            key: 0,
            radionuclides: _ctx.radionuclides
          }, null, 8, ["radionuclides"])) : createCommentVNode("", true)
        ]),
        createElementVNode("div", _hoisted_4$s, [
          _hoisted_5$j,
          createVNode(_component_ButtonComponent, {
            class: "form-button",
            "data-type": "accent",
            onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("close"))
          }, {
            default: withCtx(() => [
              createTextVNode(" \u0417\u0430\u043A\u0440\u044B\u0442\u044C ")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  });
}
var RecalcActivityRadionuclidesDemo = /* @__PURE__ */ _export_sfc(_sfc_main$H, [["render", _sfc_render$H]]);
var TRadioButton_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$G = defineComponent({
  name: "TRadioButton",
  props: {
    modelValue: [String, Number],
    data: {
      type: [Array, Object],
      required: true
    },
    footerHelp: String,
    isViewKey: Boolean,
    emitProp: {
      type: String,
      default: "key"
    }
  },
  emits: ["update:modelValue"],
  setup() {
    return {
      toStr
    };
  },
  computed: {
    dataComputed() {
      if (Array.isArray(this.data)) {
        return this.data.reduce((value, currentValue, i) => {
          value[i] = currentValue;
          return value;
        }, {});
      }
      if (typeof this.data === "object") {
        return this.data;
      }
      throw new Error("RadioButton prop 'data' must be an object or an array");
    }
  },
  methods: {
    onUpdateModelValue(key, value) {
      this.$emit("update:modelValue", this.emitProp === "key" ? key : value);
    },
    isChecked(key, value) {
      return (this.emitProp === "key" ? key : value) === this.modelValue;
    }
  }
});
const _hoisted_1$x = { class: "root-radio-button-input" };
const _hoisted_2$v = { class: "radio-button-input" };
const _hoisted_3$t = ["onClick", "onKeydown"];
const _hoisted_4$r = ["checked"];
const _hoisted_5$i = {
  key: 0,
  class: "app-label-s12-h14",
  style: { "margin-top": "10px" }
};
function _sfc_render$G(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$x, [
    createElementVNode("div", _hoisted_2$v, [
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.dataComputed, (v, key) => {
        return openBlock(), createElementBlock("div", {
          key,
          class: "radio-button-input-value",
          tabindex: "0",
          onClick: ($event) => _ctx.onUpdateModelValue(key, v),
          onKeydown: withKeys(($event) => _ctx.onUpdateModelValue(key, v), ["space"])
        }, [
          createElementVNode("input", {
            tabindex: "-1",
            checked: _ctx.isChecked(key, v),
            type: "radio"
          }, null, 8, _hoisted_4$r),
          createElementVNode("div", null, toDisplayString(_ctx.isViewKey ? `${key} - ` : "") + toDisplayString(v), 1)
        ], 40, _hoisted_3$t);
      }), 128))
    ]),
    _ctx.footerHelp ? (openBlock(), createElementBlock("div", _hoisted_5$i, toDisplayString(_ctx.footerHelp), 1)) : createCommentVNode("", true)
  ]);
}
var TRadioButton = /* @__PURE__ */ _export_sfc(_sfc_main$G, [["render", _sfc_render$G], ["__scopeId", "data-v-afe822e0"]]);
const CODE_RAO_DATA = {
  stateAggregation: {
    label: "\u0410\u0433\u0440\u0435\u0433\u0430\u0442\u043D\u043E\u0435 \u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0435",
    symbol: [1],
    explanations: {},
    data: {
      1: "\u0436\u0438\u0434\u043A\u0438\u0435",
      2: "\u0442\u0432\u0451\u0440\u0434\u044B\u0435",
      3: "\u0433\u0430\u0437\u043E\u043E\u0431\u0440\u0430\u0437\u043D\u044B\u0435"
    }
  },
  categoryRao: {
    label: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F \u0420\u0410\u041E",
    symbol: [2],
    explanation: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F \u0420\u0410\u041E \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u044F\u0435\u0442\u0441\u044F \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0421\u0430\u043D\u0438\u0442\u0430\u0440\u043D\u044B\u043C\u0438 \u043F\u0440\u0430\u0432\u0438\u043B\u0430\u043C\u0438 \u0438 \u043D\u043E\u0440\u043C\u0430\u0442\u0438\u0432\u0430\u043C\u0438 \u0421\u041F 2.6.1.2612-10 \xAB\u041E\u0441\u043D\u043E\u0432\u043D\u044B\u0435 \u0441\u0430\u043D\u0438\u0442\u0430\u0440\u043D\u044B\u0435 \u043F\u0440\u0430\u0432\u0438\u043B\u0430 \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u044F \u0440\u0430\u0434\u0438\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439 \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438 (\u041E\u0421\u041F\u041E\u0420\u0411-99/2010)\xBB, \u0443\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u043D\u044B\u043C\u0438 \u043F\u043E\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435\u043C \u0413\u043B\u0430\u0432\u043D\u043E\u0433\u043E \u0433\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0433\u043E \u0441\u0430\u043D\u0438\u0442\u0430\u0440\u043D\u043E\u0433\u043E \u0432\u0440\u0430\u0447\u0430 \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438 \u043E\u0442 26.04.2010 N 40 (\u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043E \u041C\u0438\u043D\u044E\u0441\u0442\u043E\u043C \u0420\u043E\u0441\u0441\u0438\u0438 11.08.2010, \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 18115), \u0441 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F\u043C\u0438, \u0432\u043D\u0435\u0441\u0435\u043D\u043D\u044B\u043C\u0438 \u043F\u043E\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435\u043C \u0413\u043B\u0430\u0432\u043D\u043E\u0433\u043E \u0433\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0433\u043E \u0441\u0430\u043D\u0438\u0442\u0430\u0440\u043D\u043E\u0433\u043E \u0432\u0440\u0430\u0447\u0430 \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438 \u043E\u0442 16.09.2013 N 43 (\u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043E \u041C\u0438\u043D\u044E\u0441\u0442\u043E\u043C \u0420\u043E\u0441\u0441\u0438\u0438 05.11.2013, \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 30309). \u041F\u0440\u0438 \u044D\u0442\u043E\u043C \u043A\u043E\u0434 4 \xAB\u043E\u0442\u0440\u0430\u0431\u043E\u0442\u0430\u0432\u0448\u0438\u0435 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0438 \u0438\u043E\u043D\u0438\u0437\u0438\u0440\u0443\u044E\u0449\u0435\u0433\u043E \u0438\u0437\u043B\u0443\u0447\u0435\u043D\u0438\u044F\xBB \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442\u0441\u044F \u0434\u043B\u044F \u0420\u0410\u041E, \u043E\u0431\u0440\u0430\u0437\u043E\u0432\u0430\u0432\u0448\u0438\u0445\u0441\u044F \u0438\u0437 \u0417\u0420\u0418.",
    explanations: {
      9: "\u041F\u0440\u0438 \u0432\u044B\u0431\u043E\u0440\u0435 \u044D\u0442\u043E\u0433\u043E \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0430 \u0432 \u043F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0438 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0443\u043A\u0430\u0437\u0430\u0442\u044C \u043F\u0440\u0438\u0447\u0438\u043D\u0443 \u043D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0438 \u043E\u0442\u043D\u0435\u0441\u0435\u043D\u0438\u044F \u0420\u0410\u041E \u043A \u043A\u0430\u043A\u043E\u0439-\u043B\u0438\u0431\u043E \u0438\u0437 \u0432\u044B\u0448\u0435\u043F\u0435\u0440\u0435\u0447\u0438\u0441\u043B\u0435\u043D\u043D\u044B\u0445 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u0439."
    },
    data: {
      0: "\u043E\u0447\u0435\u043D\u044C \u043D\u0438\u0437\u043A\u043E\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0435",
      1: "\u043D\u0438\u0437\u043A\u043E\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0435",
      2: "\u0441\u0440\u0435\u0434\u043D\u0435\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0435",
      3: "\u0432\u044B\u0441\u043E\u043A\u043E\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0435",
      4: "\u043E\u0442\u0440\u0430\u0431\u043E\u0442\u0430\u0432\u0448\u0438\u0435 \u0437\u0430\u043A\u0440\u044B\u0442\u044B\u0435 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0438 \u0438\u043E\u043D\u0438\u0437\u0438\u0440\u0443\u044E\u0449\u0435\u0433\u043E \u0438\u0437\u043B\u0443\u0447\u0435\u043D\u0438\u044F",
      9: "\u043F\u0440\u043E\u0447\u0438\u0435"
    }
  },
  radionuclideCompositionRao: {
    label: "\u0420\u0430\u0434\u0438\u043E\u043D\u0443\u043A\u043B\u0438\u0434\u043D\u044B\u0439 \u0441\u043E\u0441\u0442\u0430\u0432 \u0420\u0410\u041E",
    symbol: [3],
    explanation: "\u0412\u044B\u0431\u0438\u0440\u0430\u0435\u0442\u0441\u044F \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u0432 \u043D\u0430\u0438\u0431\u043E\u043B\u044C\u0448\u0435\u0439 \u043C\u0435\u0440\u0435 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u0435\u0442 \u043F\u0435\u0440\u0435\u0447\u043D\u044E \u0432\u0438\u0434\u043E\u0432 \u0440\u0430\u0434\u0438\u043E\u043D\u0443\u043A\u043B\u0438\u0434\u043E\u0432, \u043F\u0440\u0438\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0445 \u0432 \u0420\u0410\u041E.",
    explanations: {},
    data: {
      0: "\u0441\u043E\u0441\u0442\u0430\u0432 \u043D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u0435\u043D",
      1: "\u0442\u0440\u0430\u043D\u0441\u0443\u0440\u0430\u043D\u043E\u0432\u044B\u0435 \u0440\u0430\u0434\u0438\u043E\u043D\u0443\u043A\u043B\u0438\u0434\u044B",
      2: "\u0430\u043B\u044C\u0444\u0430-\u0438\u0437\u043B\u0443\u0447\u0430\u044E\u0449\u0438\u0435 \u0440\u0430\u0434\u0438\u043E\u043D\u0443\u043A\u043B\u0438\u0434\u044B \u0431\u0435\u0437 \u0442\u0440\u0430\u043D\u0441\u0443\u0440\u0430\u043D\u043E\u0432\u044B\u0445",
      3: "\u0430\u043B\u044C\u0444\u0430-\u0438\u0437\u043B\u0443\u0447\u0430\u044E\u0449\u0438\u0435 \u0440\u0430\u0434\u0438\u043E\u043D\u0443\u043A\u043B\u0438\u0434\u044B \u0441 \u0442\u0440\u0430\u043D\u0441\u0443\u0440\u0430\u043D\u043E\u0432\u044B\u043C\u0438",
      4: "\u0431\u0435\u0442\u0430-, \u0433\u0430\u043C\u043C\u0430-\u0438\u0437\u043B\u0443\u0447\u0430\u044E\u0449\u0438\u0435 \u0440\u0430\u0434\u0438\u043E\u043D\u0443\u043A\u043B\u0438\u0434\u044B",
      5: "\u0430\u043B\u044C\u0444\u0430-, \u0431\u0435\u0442\u0430-, \u0433\u0430\u043C\u043C\u0430-\u0438\u0437\u043B\u0443\u0447\u0430\u044E\u0449\u0438\u0435 \u0440\u0430\u0434\u0438\u043E\u043D\u0443\u043A\u043B\u0438\u0434\u044B \u0431\u0435\u0437 \u0442\u0440\u0430\u043D\u0441\u0443\u0440\u0430\u043D\u043E\u0432\u044B\u0445",
      6: "\u0430\u043B\u044C\u0444\u0430-, \u0431\u0435\u0442\u0430-, \u0433\u0430\u043C\u043C\u0430-\u0438\u0437\u043B\u0443\u0447\u0430\u044E\u0449\u0438\u0435 \u0440\u0430\u0434\u0438\u043E\u043D\u0443\u043A\u043B\u0438\u0434\u044B \u0441 \u0442\u0440\u0430\u043D\u0441\u0443\u0440\u0430\u043D\u043E\u0432\u044B\u043C\u0438"
    }
  },
  contentNuclearMaterials: {
    label: "\u0421\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u0438\u0435 \u044F\u0434\u0435\u0440\u043D\u044B\u0445 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u043E\u0432",
    symbol: [4],
    explanations: {
      2: "\u0415\u0441\u043B\u0438 \u0434\u043E \u043F\u0435\u0440\u0435\u0432\u043E\u0434\u0430 \u0432 \u0420\u0410\u041E \u0443\u0447\u0435\u0442\u043D\u0430\u044F \u0435\u0434\u0438\u043D\u0438\u0446\u0430 \u0441\u0442\u043E\u044F\u043B\u0430 \u043D\u0430 \u0443\u0447\u0435\u0442\u0435 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0435 \u0433\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0433\u043E \u0443\u0447\u0435\u0442\u0430 \u0438 \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u044F \u044F\u0434\u0435\u0440\u043D\u044B\u0445 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u043E\u0432 (\u043E\u0442\u043D\u043E\u0441\u0438\u043B\u0430\u0441\u044C \u043A \u044F\u0434\u0435\u0440\u043D\u044B\u043C \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u0430\u043C)."
    },
    data: {
      1: "\u043D\u0435 \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0449\u0438\u0435 \u044F\u0434\u0435\u0440\u043D\u044B\u0435 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u044B",
      2: "\u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0449\u0438\u0435 \u044F\u0434\u0435\u0440\u043D\u044B\u0435 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u044B"
    }
  },
  halfLife: {
    label: "\u041F\u0435\u0440\u0438\u043E\u0434 \u043F\u043E\u043B\u0443\u0440\u0430\u0441\u043F\u0430\u0434\u0430",
    symbol: [5],
    explanation: "\u041F\u0440\u0438 \u0432\u044B\u0431\u043E\u0440\u0435 \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440\u0430 \u0434\u043B\u044F \u0420\u0410\u041E, \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0449\u0438\u0445 \u0440\u0430\u0437\u043B\u0438\u0447\u043D\u044B\u0435 \u0440\u0430\u0434\u0438\u043E\u043D\u0443\u043A\u043B\u0438\u0434\u044B (\u0441 \u0440\u0430\u0437\u043D\u044B\u043C\u0438 \u043F\u0435\u0440\u0438\u043E\u0434\u0430\u043C\u0438 \u043F\u043E\u043B\u0443\u0440\u0430\u0441\u043F\u0430\u0434\u0430), \u0432\u044B\u0431\u0438\u0440\u0430\u0435\u0442\u0441\u044F \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440\u0430, \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u0435 \u043F\u0435\u0440\u0438\u043E\u0434\u0443 \u043F\u043E\u043B\u0443\u0440\u0430\u0441\u043F\u0430\u0434\u0430 \u0442\u0435\u0445 \u0440\u0430\u0434\u0438\u043E\u043D\u0443\u043A\u043B\u0438\u0434\u043E\u0432, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u044F\u044E\u0442 \u043F\u0435\u0440\u0438\u043E\u0434 \u043F\u043E\u0442\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0439 \u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438 \u0420\u0410\u041E.",
    explanations: {},
    data: {
      1: "\u0434\u043E\u043B\u0433\u043E\u0436\u0438\u0432\u0443\u0449\u0438\u0435 (\u043F\u0435\u0440\u0438\u043E\u0434 \u043F\u043E\u043B\u0443\u0440\u0430\u0441\u043F\u0430\u0434\u0430 \u0431\u043E\u043B\u0435\u0435 31 \u0433\u043E\u0434\u0430)",
      2: "\u043A\u043E\u0440\u043E\u0442\u043A\u043E\u0436\u0438\u0432\u0443\u0449\u0438\u0435 (\u043F\u0435\u0440\u0438\u043E\u0434 \u043F\u043E\u043B\u0443\u0440\u0430\u0441\u043F\u0430\u0434\u0430 31 \u0433\u043E\u0434 \u0438 \u043C\u0435\u043D\u0435\u0435)"
    }
  },
  periodPotentialDangerRao: {
    label: "\u041F\u0435\u0440\u0438\u043E\u0434 \u043F\u043E\u0442\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0439 \u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438 \u0420\u0410\u041E",
    symbol: [6],
    explanation: "\u041F\u0435\u0440\u0438\u043E\u0434 \u043F\u043E\u0442\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0439 \u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438 \u0420\u0410\u041E - \u0441\u0440\u043E\u043A, \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 \u043A\u043E\u0442\u043E\u0440\u043E\u0433\u043E \u0443\u0440\u043E\u0432\u043D\u0438 \u0440\u0430\u0434\u0438\u043E\u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u0438 \u0440\u0430\u0434\u0438\u043E\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0445 \u043E\u0442\u0445\u043E\u0434\u043E\u0432 \u0441\u043D\u0438\u0436\u0430\u044E\u0442\u0441\u044F \u0434\u043E \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u0435\u043B\u0435\u0439, \u043F\u0440\u0438 \u043A\u043E\u0442\u043E\u0440\u044B\u0445 \u043D\u0435 \u0442\u0440\u0435\u0431\u0443\u0435\u0442\u0441\u044F \u0440\u0430\u0434\u0438\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u044C, \u0441\u043E\u0433\u043B\u0430\u0441\u043D\u043E \u0441\u0442\u0430\u0442\u044C\u0435 3 \u0424\u0435\u0434\u0435\u0440\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0437\u0430\u043A\u043E\u043D\u0430 \u043E\u0442 11.07.2011  \u2116 190-\u0424\u0417 \xAB\u041E\u0431 \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u0438 \u0441 \u0440\u0430\u0434\u0438\u043E\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u043C\u0438 \u043E\u0442\u0445\u043E\u0434\u0430\u043C\u0438 \u0438 \u043E \u0432\u043D\u0435\u0441\u0435\u043D\u0438\u0438 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0439 \u0432 \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u044B\u0435 \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0430\u043A\u0442\u044B \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438\xBB.",
    explanations: {
      0: "\u041F\u0440\u0438 \u0432\u044B\u0431\u043E\u0440\u0435 \u044D\u0442\u043E\u0433\u043E \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0430 \u0432 \u043F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0438 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0443\u043A\u0430\u0437\u0430\u0442\u044C \u043F\u0440\u0438\u0447\u0438\u043D\u044B \u043D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0438 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u044F \u043F\u0435\u0440\u0438\u043E\u0434\u0430 \u043F\u043E\u0442\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0439 \u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438."
    },
    data: {
      0: "\u043D\u0435 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D",
      1: "\u043C\u0435\u043D\u0435\u0435 100 \u043B\u0435\u0442",
      2: "\u043E\u0442 100 \u0434\u043E 500 \u043B\u0435\u0442",
      3: "\u0431\u043E\u043B\u0435\u0435 500 \u043B\u0435\u0442"
    }
  },
  methodRecycling: {
    label: "\u0421\u043F\u043E\u0441\u043E\u0431 \u043F\u0435\u0440\u0435\u0440\u0430\u0431\u043E\u0442\u043A\u0438",
    symbol: [7],
    explanation: "\u0414\u043B\u044F \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440\u043E\u0432 1-9 \u0432 \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u0435 \u0442\u0438\u043F\u0430 \u0420\u0410\u041E \u0443\u043A\u0430\u0437\u044B\u0432\u0430\u0435\u0442\u0441\u044F \u0442\u0438\u043F \u0420\u0410\u041E, \u043F\u043E\u0441\u0442\u0443\u043F\u0438\u0432\u0448\u0438\u0445 \u043D\u0430 \u043F\u0435\u0440\u0435\u0440\u0430\u0431\u043E\u0442\u043A\u0443.",
    explanations: (() => {
      const text = "\u0414\u043B\u044F \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440\u043E\u0432 1-9 \u0432 \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u0435 \u0442\u0438\u043F\u0430 \u0420\u0410\u041E \u0443\u043A\u0430\u0437\u044B\u0432\u0430\u0435\u0442\u0441\u044F \u0442\u0438\u043F \u0420\u0410\u041E, \u043F\u043E\u0441\u0442\u0443\u043F\u0438\u0432\u0448\u0438\u0445 \u043D\u0430 \u043F\u0435\u0440\u0435\u0440\u0430\u0431\u043E\u0442\u043A\u0443.";
      return {
        1: text,
        2: text,
        3: text,
        4: text,
        9: "\u041F\u0440\u0438 \u0432\u044B\u0431\u043E\u0440\u0435 \u044D\u0442\u043E\u0433\u043E \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0430 \u0432 \u043F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0438 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0443\u043A\u0430\u0437\u0430\u0442\u044C \u0441\u043F\u043E\u0441\u043E\u0431 \u043F\u0435\u0440\u0435\u0440\u0430\u0431\u043E\u0442\u043A\u0438."
      };
    })(),
    data: {
      0: "\u043D\u0435 \u043F\u043E\u0434\u0432\u0435\u0440\u0433\u0430\u0432\u0448\u0438\u0435\u0441\u044F \u043F\u0435\u0440\u0435\u0440\u0430\u0431\u043E\u0442\u043A\u0435 \u0441\u043F\u043E\u0441\u043E\u0431\u0430\u043C\u0438, \u043F\u0435\u0440\u0435\u0447\u0438\u0441\u043B\u0435\u043D\u043D\u044B\u043C\u0438 \u043D\u0438\u0436\u0435",
      1: "\u0441\u043F\u0440\u0435\u0441\u0441\u043E\u0432\u0430\u043D\u043D\u044B\u0435 (\u043A\u043E\u043C\u043F\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0435)",
      2: "\u0431\u0438\u0442\u0443\u043C\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0435",
      3: "\u0446\u0435\u043C\u0435\u043D\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0435",
      4: "\u043E\u0441\u0442\u0435\u043A\u043B\u043E\u0432\u0430\u043D\u043D\u044B\u0435",
      9: "\u043E\u043C\u043E\u043D\u043E\u043B\u0438\u0447\u0435\u043D\u043D\u044B\u0435 (\u043E\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u043D\u044B\u0435) \u0434\u0440\u0443\u0433\u0438\u043C \u0441\u043F\u043E\u0441\u043E\u0431\u043E\u043C"
    }
  },
  classRao: {
    label: "\u041A\u043B\u0430\u0441\u0441 \u0420\u0410\u041E",
    symbol: [8],
    explanation: "\u041E\u043F\u0440\u0435\u0434\u0435\u043B\u044F\u0435\u0442\u0441\u044F \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u043A\u0440\u0438\u0442\u0435\u0440\u0438\u044F\u043C\u0438, \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044B\u043C\u0438 \u043F\u043E\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435\u043C \u041F\u0440\u0430\u0432\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438 \u2116 1069.",
    explanations: (() => {
      const text = "\u041E\u043F\u0440\u0435\u0434\u0435\u043B\u044F\u0435\u0442\u0441\u044F \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u043A\u0440\u0438\u0442\u0435\u0440\u0438\u044F\u043C\u0438, \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044B\u043C\u0438 \u043F\u043E\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435\u043C \u041F\u0440\u0430\u0432\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438 \u2116 1069.";
      return {
        0: "\u041F\u0440\u0438\u043C\u0435\u043D\u044F\u0435\u0442\u0441\u044F \u0434\u043B\u044F \u043D\u0435\u043A\u043E\u043D\u0434\u0438\u0446\u0438\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0445 \u0420\u0410\u041E",
        1: text,
        2: text,
        3: text,
        4: text,
        5: text,
        6: text,
        7: text,
        9: "\u0420\u0410\u041E, \u043F\u043E \u043A\u043E\u0442\u043E\u0440\u044B\u043C \u0432 \u0445\u043E\u0434\u0435 \u043F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u044F \u043F\u0435\u0440\u0432\u0438\u0447\u043D\u043E\u0439 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0420\u0410\u041E \u0438 \u043C\u0435\u0441\u0442 \u0438\u0445 \u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u0438\u044F \u043E\u0442\u043B\u043E\u0436\u0435\u043D\u043E \u043F\u0440\u0438\u043D\u044F\u0442\u0438\u0435 \u0440\u0435\u0448\u0435\u043D\u0438\u044F \u043F\u043E \u043E\u0442\u043D\u0435\u0441\u0435\u043D\u0438\u044E \u0438\u0445 \u043A \u0443\u0434\u0430\u043B\u044F\u0435\u043C\u044B\u043C \u0438\u043B\u0438 \u043E\u0441\u043E\u0431\u044B\u043C."
      };
    })(),
    data: {
      0: "\u0443\u0434\u0430\u043B\u044F\u0435\u043C\u044B\u0435, \u043A\u043B\u0430\u0441\u0441 \u043A\u043E\u0442\u043E\u0440\u044B\u0445 \u043D\u0435 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D",
      1: "\u0443\u0434\u0430\u043B\u044F\u0435\u043C\u044B\u0435 1-\u0433\u043E \u043A\u043B\u0430\u0441\u0441\u0430",
      2: "\u0443\u0434\u0430\u043B\u044F\u0435\u043C\u044B\u0435 2-\u0433\u043E \u043A\u043B\u0430\u0441\u0441\u0430",
      3: "\u0443\u0434\u0430\u043B\u044F\u0435\u043C\u044B\u0435 3-\u0433\u043E \u043A\u043B\u0430\u0441\u0441\u0430",
      4: "\u0443\u0434\u0430\u043B\u044F\u0435\u043C\u044B\u0435 4-\u0433\u043E \u043A\u043B\u0430\u0441\u0441\u0430",
      5: "\u0443\u0434\u0430\u043B\u044F\u0435\u043C\u044B\u0435 5-\u0433\u043E \u043A\u043B\u0430\u0441\u0441\u0430",
      6: "\u0443\u0434\u0430\u043B\u044F\u0435\u043C\u044B\u0435 6-\u0433\u043E \u043A\u043B\u0430\u0441\u0441\u0430",
      7: "\u043E\u0441\u043E\u0431\u044B\u0435 \u0420\u0410\u041E",
      9: "\u0440\u0435\u0448\u0435\u043D\u0438\u0435 \u043E\u0442\u043B\u043E\u0436\u0435\u043D\u043E"
    }
  },
  codeTypeRao: {
    label: "\u041A\u043E\u0434 \u0442\u0438\u043F\u0430 \u0420\u0410\u041E",
    symbol: [9, 10],
    explanations: {
      "19": "\u041F\u0440\u0438 \u0432\u044B\u0431\u043E\u0440\u0435 \u044D\u0442\u043E\u0433\u043E \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0430 \u0432 \u043F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0438 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0443\u043A\u0430\u0437\u0430\u0442\u044C \u043D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435, \u0442\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043F\u0440\u043E\u0438\u0441\u0445\u043E\u0436\u0434\u0435\u043D\u0438\u0435 \u0436\u0438\u0434\u043A\u043E\u0441\u0442\u0438.",
      "29": "\u041F\u0440\u0438 \u0432\u044B\u0431\u043E\u0440\u0435 \u044D\u0442\u043E\u0433\u043E \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0430 \u0432 \u043F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0438 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0443\u043A\u0430\u0437\u0430\u0442\u044C \u043D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435, \u0442\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043F\u0440\u043E\u0438\u0441\u0445\u043E\u0436\u0434\u0435\u043D\u0438\u0435 \u0436\u0438\u0434\u043A\u043E\u0441\u0442\u0438.",
      "32": "\u0414\u0430\u043D\u043D\u044B\u0439 \u0432\u0430\u0440\u0438\u0430\u043D\u0442 \u0432\u044B\u0431\u0438\u0440\u0430\u0435\u0442\u0441\u044F, \u0435\u0441\u043B\u0438 \u0441\u043C\u043E\u043B\u044B \u0445\u0440\u0430\u043D\u044F\u0442\u0441\u044F \u043F\u043E\u0434 \u0441\u043B\u043E\u0435\u043C \u0432\u043E\u0434\u044B.",
      "33": "\u0414\u0430\u043D\u043D\u044B\u0439 \u0432\u0430\u0440\u0438\u0430\u043D\u0442 \u0432\u044B\u0431\u0438\u0440\u0430\u0435\u0442\u0441\u044F, \u0435\u0441\u043B\u0438 \u0441\u043E\u0440\u0431\u0435\u043D\u0442\u044B \u0445\u0440\u0430\u043D\u044F\u0442\u0441\u044F \u043F\u043E\u0434 \u0441\u043B\u043E\u0435\u043C \u0432\u043E\u0434\u044B.",
      "39": "\u041F\u0440\u0438 \u0432\u044B\u0431\u043E\u0440\u0435 \u044D\u0442\u043E\u0433\u043E \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0430 \u0432 \u043F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0438 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0443\u043A\u0430\u0437\u0430\u0442\u044C \u0438\u0445 \u043D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435 \u0438 \u0442\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043F\u0440\u043E\u0438\u0441\u0445\u043E\u0436\u0434\u0435\u043D\u0438\u0435.",
      "41": "\u0420\u0430\u0437\u043C\u0435\u0440\u044B \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u044B\u0445 \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432 \u043F\u0440\u0435\u0432\u044B\u0448\u0430\u044E\u0442 350\u0445350\u0445400 \u043C\u043C \u0438\u043B\u0438 \u043F\u0440\u0435\u0432\u044B\u0448\u0430\u044E\u0442 2 \u043C \u0432 \u043E\u0434\u043D\u043E\u043C \u0438\u0437\u043C\u0435\u0440\u0435\u043D\u0438\u0438.",
      "43": "\u0420\u0430\u0437\u043C\u0435\u0440\u044B \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u044B\u0445 \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432 \u043F\u0440\u0435\u0432\u044B\u0448\u0430\u044E\u0442 350\u0445350\u0445400 \u043C\u043C \u0438\u043B\u0438 \u043F\u0440\u0435\u0432\u044B\u0448\u0430\u044E\u0442 2 \u043C \u0432 \u043E\u0434\u043D\u043E\u043C \u0438\u0437\u043C\u0435\u0440\u0435\u043D\u0438\u0438.",
      "45": "\u0412\u044B\u0431\u0438\u0440\u0430\u0435\u0442\u0441\u044F \u0432 \u0442\u0435\u0445 \u0441\u043B\u0443\u0447\u0430\u044F\u0445, \u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u0432\u044B\u0431\u0440\u0430\u043D\u044B \u0442\u0438\u043F\u044B \u0441 \u043A\u043E\u0434\u0430\u043C\u0438 41-44.",
      "57": "\u0412 \u043F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0438 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0443\u043A\u0430\u0437\u0430\u0442\u044C \u043D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435 \u043C\u0435\u0442\u0430\u043B\u043B\u0430.",
      "58": "\u041D\u0435\u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u043B\u043E\u043C \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u0438\u0445 \u0446\u0432\u0435\u0442\u043D\u044B\u0445 \u043C\u0435\u0442\u0430\u043B\u043B\u043E\u0432.",
      "59": "\u041C\u0435\u0442\u0430\u043B\u043B\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u043E\u0442\u0445\u043E\u0434\u044B, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043D\u0435 \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u043A\u043B\u0430\u0441\u0441\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u043D\u044B \u043F\u043E \u043F\u0440\u0438\u0432\u0435\u0434\u0435\u043D\u043D\u044B\u043C \u0432\u044B\u0448\u0435 \u043F\u043E\u0437\u0438\u0446\u0438\u044F\u043C, \u0432 \u0442. \u0447. \u043D\u0435\u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u043B\u043E\u043C \u0447\u0435\u0440\u043D\u044B\u0445 \u0438 \u0446\u0432\u0435\u0442\u043D\u044B\u0445 \u043C\u0435\u0442\u0430\u043B\u043B\u043E\u0432.",
      "61": "\u0414\u0430\u043D\u043D\u044B\u0439 \u0432\u0430\u0440\u0438\u0430\u043D\u0442 \u0432\u044B\u0431\u0438\u0440\u0430\u0435\u0442\u0441\u044F, \u0435\u0441\u043B\u0438 \u043E\u0442\u0440\u0430\u0431\u043E\u0442\u0430\u043D\u043D\u044B\u0435 \u0441\u043E\u0440\u0431\u0435\u043D\u0442\u044B \u043D\u0430\u0445\u043E\u0434\u044F\u0442\u0441\u044F \u0432 \u0441\u0443\u0445\u043E\u043C \u0432\u0438\u0434\u0435.",
      "69": "\u0412 \u043F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0438 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0443\u043A\u0430\u0437\u0430\u0442\u044C \u043D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435 (\u0441\u043E\u0441\u0442\u0430\u0432) \u0438 \u0442\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043F\u0440\u043E\u0438\u0441\u0445\u043E\u0436\u0434\u0435\u043D\u0438\u0435 \u0420\u0410\u041E.",
      "71": "\u0414\u0430\u043D\u043D\u044B\u0439 \u0432\u0430\u0440\u0438\u0430\u043D\u0442 \u0432\u044B\u0431\u0438\u0440\u0430\u0435\u0442\u0441\u044F, \u0435\u0441\u043B\u0438 \u043E\u0442\u0440\u0430\u0431\u043E\u0442\u0430\u043D\u043D\u044B\u0435 \u0441\u043E\u0440\u0431\u0435\u043D\u0442\u044B \u043D\u0430\u0445\u043E\u0434\u044F\u0442\u0441\u044F \u0432 \u0441\u0443\u0445\u043E\u043C \u0432\u0438\u0434\u0435.",
      "73": "\u0418\u0437\u0434\u0435\u043B\u0438\u044F \u0438\u0437 \u043F\u043E\u043B\u0438\u044D\u0442\u0438\u043B\u0435\u043D\u0430, \u043F\u043E\u043B\u0438\u0445\u043B\u043E\u0440\u0432\u0438\u043D\u0438\u043B\u0430, \u0440\u0435\u0437\u0438\u043D\u044B.",
      "75": "\u041A\u0440\u043E\u043C\u0435 \u0430\u043D\u0430\u043B\u043E\u0433\u0438\u0447\u043D\u044B\u0445 \u0438\u0437\u0434\u0435\u043B\u0438\u0439 \u0438\u0437 \u043D\u0435\u043E\u0440\u0433\u0430\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0445 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u043E\u0432.",
      "78": "\u0412 \u043F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0438 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0443\u043A\u0430\u0437\u0430\u0442\u044C \u043D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435 (\u0441\u043E\u0441\u0442\u0430\u0432).",
      "79": "\u0412 \u043F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0438 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0443\u043A\u0430\u0437\u0430\u0442\u044C \u043D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435 (\u0441\u043E\u0441\u0442\u0430\u0432).",
      "89": "\u041F\u0440\u0438 \u0432\u044B\u0431\u043E\u0440\u0435 \u044D\u0442\u043E\u0433\u043E \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F \u0432 \u043F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0438 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0443\u043A\u0430\u0437\u0430\u0442\u044C \u043D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0435\u0434\u0438\u043D\u0438\u0446\u044B.",
      "95": "\u0418\u041A, \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0449\u0438\u0435 \u041E\u0417\u0418\u0418\u0418, \u043E\u0431\u043E\u0437\u043D\u0430\u0447\u0430\u044E\u0442\u0441\u044F (\u0432 \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0442 \u043C\u0430\u0441\u0441\u044B) \u043A\u043E\u0434\u0430\u043C\u0438 87 \u0438\u043B\u0438 88.",
      "97": "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442\u0441\u044F \u0441\u043E\u043A\u0440\u0430\u0449\u0435\u043D\u043D\u043E\u0435 \u043D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435: \u041F\u042D\u041B\u044B (\u0421\u041F).",
      "98": "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442\u0441\u044F \u0441\u043E\u043A\u0440\u0430\u0449\u0435\u043D\u043D\u043E\u0435 \u043D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435: \u041A\u041D\u0418\u0418\u0422.",
      "99": "\u041D\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442\u0441\u044F \u0434\u043B\u044F \u0420\u0410\u041E, \u043E\u0431\u0440\u0430\u0437\u043E\u0432\u0430\u043D\u043D\u044B\u0445 \u043F\u043E\u0441\u043B\u0435 \u0432\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u044F \u0432 \u0441\u0438\u043B\u0443 \u0424\u0435\u0434\u0435\u0440\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0437\u0430\u043A\u043E\u043D\u0430 \u043E\u0442 11.07.2011 \u2116 190-\u0424\u0417 \xAB\u041E\u0431 \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u0438 \u0441 \u0440\u0430\u0434\u0438\u043E\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u043C\u0438 \u043E\u0442\u0445\u043E\u0434\u0430\u043C\u0438 \u0438 \u043E \u0432\u043D\u0435\u0441\u0435\u043D\u0438\u0438 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0439 \u0432 \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u044B\u0435 \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0430\u043A\u0442\u044B \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438\xBB.\n\n\u0414\u0430\u043D\u043D\u044B\u0439 \u0432\u0430\u0440\u0438\u0430\u043D\u0442 \u0432\u044B\u0431\u0438\u0440\u0430\u0435\u0442\u0441\u044F, \u0435\u0441\u043B\u0438 \u0420\u0410\u041E \u043D\u0435 \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u043A\u043B\u0430\u0441\u0441\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u043D\u044B \u043F\u043E \u043F\u043E\u0437\u0438\u0446\u0438\u044F\u043C, \u043F\u0440\u0438\u0432\u0435\u0434\u0435\u043D\u043D\u044B\u043C \u0432\u044B\u0448\u0435. \u041F\u0440\u0438 \u0432\u044B\u0431\u043E\u0440\u0435 \u044D\u0442\u043E\u0433\u043E \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F \u0432 \u043F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0438 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0443\u043A\u0430\u0437\u0430\u0442\u044C \u043D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435 \u0438 \u043F\u0440\u043E\u0438\u0441\u0445\u043E\u0436\u0434\u0435\u043D\u0438\u0435 \u0420\u0410\u041E."
    },
    data: {
      "01": "\u0433\u0430\u0437\u044B, \u0430\u044D\u0440\u043E\u0437\u043E\u043B\u0438",
      "11": "\u0432\u043E\u0434\u044B \u0437\u0430\u0433\u0440\u044F\u0437\u043D\u0435\u043D\u043D\u044B\u0435 \u043F\u043E\u0434\u0437\u0435\u043C\u043D\u044B\u0435, \u0432 \u0442\u043E\u043C \u0447\u0438\u0441\u043B\u0435 \u0433\u0440\u0443\u043D\u0442\u043E\u0432\u044B\u0435 \u0438 \u0434\u0440\u0435\u043D\u0430\u0436\u043D\u044B\u0445 \u0441\u0438\u0441\u0442\u0435\u043C",
      "12": "\u0432\u043E\u0434\u044B \u043E\u0445\u043B\u0430\u0436\u0434\u0435\u043D\u0438\u044F \u0440\u0435\u0430\u043A\u0442\u043E\u0440\u043D\u043E\u0433\u043E \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0441\u0442\u0432\u0430, \u043A\u043E\u043D\u0442\u0443\u0440\u043D\u044B\u0435 \u0432\u043E\u0434\u044B, \u0432\u043E\u0434\u044B \u0446\u0438\u0441\u0442\u0435\u0440\u043D \u0431\u0438\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u043E\u0439 \u0437\u0430\u0449\u0438\u0442\u044B, \u0432\u043E\u0434\u044B \u0431\u0430\u0441\u0441\u0435\u0439\u043D\u043E\u0432 \u0432\u044B\u0434\u0435\u0440\u0436\u043A\u0438 \u041E\u042F\u0422",
      "13": "\u0440\u0430\u0441\u0442\u0432\u043E\u0440\u044B \u0445\u0432\u043E\u0441\u0442\u043E\u0432\u044B\u0435",
      "14": "\u043A\u043E\u043D\u0434\u0435\u043D\u0441\u0430\u0442\u044B \u043F\u043E\u0441\u043B\u0435 \u0443\u043F\u0430\u0440\u0438\u0432\u0430\u043D\u0438\u044F, \u0433\u0430\u0437\u043E\u043E\u0447\u0438\u0441\u0442\u043A\u0438, \u043A\u043E\u043D\u0434\u0435\u043D\u0441\u0430\u0442\u044B \u0442\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u043F\u0440\u043E\u0447\u0438\u0435",
      "15": "\u0440\u0430\u0441\u0442\u0432\u043E\u0440\u044B \u0440\u0435\u0433\u0435\u043D\u0435\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0435 (\u0441\u043B\u0438\u0432\u044B), \u0440\u0430\u0441\u0442\u0432\u043E\u0440\u044B \u043F\u0440\u043E\u043C\u044B\u0432\u043A\u0438 \u044D\u043A\u0441\u0442\u0440\u0430\u0433\u0435\u043D\u0442\u043E\u0432, \u0441\u043E\u0440\u0431\u0435\u043D\u0442\u043E\u0432",
      "16": "\u0432\u043E\u0434\u044B \u043B\u0430\u0431\u043E\u0440\u0430\u0442\u043E\u0440\u0438\u0439, \u0442\u0440\u0430\u043F\u043D\u044B\u0435, \u043E\u0431\u043C\u044B\u0432\u043E\u0447\u043D\u044B\u0435 \u0432\u043E\u0434\u044B, \u0440\u0430\u0441\u0442\u0432\u043E\u0440\u044B \u043F\u043E\u0441\u043B\u0435 \u0434\u0435\u0437\u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438, \u0432\u043A\u043B\u044E\u0447\u0430\u044F \u0432\u043E\u0434\u044B \u0441\u0430\u043D\u043F\u0440\u043E\u043F\u0443\u0441\u043A\u043D\u0438\u043A\u043E\u0432 \u0438 \u0441\u043F\u0435\u0446\u043F\u0440\u0430\u0447\u0435\u0447\u043D\u044B\u0445, \u0441\u0442\u043E\u0447\u043D\u044B\u0435 \u0432\u043E\u0434\u044B \u043F\u0440\u043E\u0447\u0438\u0435",
      "17": "\u0432\u043E\u0434\u044B (\u0434\u0435\u043A\u0430\u043D\u0442\u0430\u0442\u044B) \u0431\u0430\u0441\u0441\u0435\u0439\u043D\u043E\u0432-\u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0435\u043C\u043A\u043E\u0441\u0442\u0435\u0439 \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u043F\u0443\u043B\u044C\u043F, \u0444\u0438\u043B\u044C\u0442\u0440\u0430\u0442\u043E\u0432",
      "18": "\u0432\u043E\u0434\u044B \u043F\u0440\u043E\u043C\u044B\u0441\u043B\u043E\u0432\u044B\u0435",
      "19": "\u0436\u0438\u0434\u043A\u043E\u0441\u0442\u0438 \u043D\u0435\u043E\u0440\u0433\u0430\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u043F\u0440\u043E\u0447\u0438\u0435",
      "21": "\u044D\u043A\u0441\u0442\u0440\u0430\u0433\u0435\u043D\u0442\u044B",
      "22": "\u043C\u0430\u0441\u043B\u0430",
      "23": "\u044D\u043C\u0443\u043B\u044C\u0441\u0438\u0438 \u0441\u043C\u0430\u0437\u043E\u0447\u043D\u043E-\u043E\u0445\u043B\u0430\u0436\u0434\u0430\u044E\u0449\u0438\u0445 \u0436\u0438\u0434\u043A\u043E\u0441\u0442\u0435\u0439 (\u0421\u041E\u0416)",
      "24": "\u043C\u043E\u044E\u0449\u0438\u0435 \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430 (\u0434\u0435\u0442\u0435\u0440\u0433\u0435\u043D\u0442\u044B) \u0437\u0430 \u0438\u0441\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435\u043C \u0441\u043F\u0438\u0440\u0442\u043E\u0432",
      "25": "\u0441\u043F\u0438\u0440\u0442\u044B",
      "26": "\u0441\u0446\u0438\u043D\u0446\u0438\u043B\u043B\u044F\u0442\u043E\u0440\u044B \u043E\u0440\u0433\u0430\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0436\u0438\u0434\u043A\u043E\u0441\u0442\u043D\u044B\u0435",
      "29": "\u0436\u0438\u0434\u043A\u043E\u0441\u0442\u0438 \u043E\u0440\u0433\u0430\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u043F\u0440\u043E\u0447\u0438\u0435",
      "31": "\u0445\u0432\u043E\u0441\u0442\u044B \u0433\u0438\u0434\u0440\u043E\u043C\u0435\u0442\u0430\u043B\u043B\u0443\u0440\u0433\u0438\u0447\u0435\u0441\u043A\u043E\u0433\u043E, \u0445\u0438\u043C\u0438\u043A\u043E-\u043C\u0435\u0442\u0430\u043B\u043B\u0443\u0440\u0433\u0438\u0447\u0435\u0441\u043A\u043E\u0433\u043E, \u0440\u0430\u0437\u0434\u0435\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0433\u043E \u0438 \u0441\u0443\u0431\u043B\u0438\u043C\u0430\u0442\u043D\u043E\u0433\u043E \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0441\u0442\u0432, \u043F\u0443\u043B\u044C\u043F\u044B, \u043E\u0431\u0440\u0430\u0437\u0443\u044E\u0449\u0438\u0435\u0441\u044F \u043F\u043E\u0441\u043B\u0435 \u043D\u0435\u0439\u0442\u0440\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0438",
      "32": "\u043F\u0443\u043B\u044C\u043F\u044B \u043E\u0442\u0440\u0430\u0431\u043E\u0442\u0430\u0432\u0448\u0438\u0445 \u0438\u043E\u043D\u043E\u043E\u0431\u043C\u0435\u043D\u043D\u044B\u0445 \u0441\u043C\u043E\u043B \u0438 \u043F\u0440\u043E\u0447\u0438\u0445 \u0441\u043E\u0440\u0431\u0435\u043D\u0442\u043E\u0432 \u043E\u0440\u0433\u0430\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0445",
      "33": "\u0448\u043B\u0430\u043C\u044B \u0438 \u043F\u0443\u043B\u044C\u043F\u044B \u043E\u0442\u0440\u0430\u0431\u043E\u0442\u0430\u0432\u0448\u0438\u0445 \u0441\u043E\u0440\u0431\u0435\u043D\u0442\u043E\u0432 \u043D\u0435\u043E\u0440\u0433\u0430\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0445, \u0444\u0438\u043B\u044C\u0442\u0440\u0443\u044E\u0449\u0438\u0445 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u043E\u0432",
      "34": "\u0441\u043E\u043B\u0435\u0432\u043E\u0439 \u043E\u0441\u0442\u0430\u0442\u043E\u043A \u0441 \u0441\u043E\u043B\u0435\u0441\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u0438\u0435\u043C \u0434\u043E 250 \u0433/\u043B, \u043A\u0443\u0431\u043E\u0432\u044B\u0439 \u043E\u0441\u0442\u0430\u0442\u043E\u043A",
      "35": "\u043A\u0443\u0431\u043E\u0432\u044B\u0439 \u043E\u0441\u0442\u0430\u0442\u043E\u043A \u043F\u043E\u0441\u043B\u0435 \u0443\u043F\u0430\u0440\u0438\u0432\u0430\u043D\u0438\u044F \u0441 \u0441\u043E\u043B\u0435\u0441\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u0438\u0435\u043C \u0431\u043E\u043B\u0435\u0435 250 \u0433/\u043B, \u043A\u043E\u043D\u0446\u0435\u043D\u0442\u0440\u0430\u0442 \u0441\u043E\u043B\u0435\u0432\u043E\u0439",
      "36": "\u0432\u0437\u0432\u0435\u0441\u0438, \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0449\u0438\u0435 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u044B \u043A\u043E\u0440\u0440\u043E\u0437\u0438\u0438",
      "37": "\u0438\u043B\u044B, \u0438\u043B\u043E\u0432\u044B\u0435 \u043E\u0441\u0430\u0434\u043A\u0438 \u0432\u043E\u0434\u043E\u0435\u043C\u043E\u0432-\u043D\u0430\u043A\u043E\u043F\u0438\u0442\u0435\u043B\u0435\u0439, \u043E\u0441\u0430\u0434\u043A\u0438, \u043A\u0435\u043A\u0438",
      "38": "\u0448\u043B\u0430\u043C\u044B \u043F\u043E\u0441\u043B\u0435 \u043E\u0447\u0438\u0441\u0442\u043A\u0438 \u0442\u0440\u0430\u043F\u043D\u044B\u0445 \u0432\u043E\u0434",
      "39": "\u043F\u0440\u043E\u0447\u0438\u0435 \u043F\u0443\u043B\u044C\u043F\u044B, \u0448\u043B\u0430\u043C\u044B \u0442\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0438\u0435",
      "41": "\u0441\u0442\u0430\u043B\u044C \u043D\u0435\u0440\u0436\u0430\u0432\u0435\u044E\u0449\u0430\u044F: \u043A\u0440\u0443\u043F\u043D\u043E\u0433\u0430\u0431\u0430\u0440\u0438\u0442\u043D\u044B\u0435 \u0438\u0437\u0434\u0435\u043B\u0438\u044F \u0438 \u043E\u0431\u043E\u0440\u0443\u0434\u043E\u0432\u0430\u043D\u0438\u0435",
      "42": "\u0441\u0442\u0430\u043B\u044C \u043D\u0435\u0440\u0436\u0430\u0432\u0435\u044E\u0449\u0430\u044F, \u043A\u0440\u043E\u043C\u0435 \u043A\u0440\u0443\u043F\u043D\u043E\u0433\u0430\u0431\u0430\u0440\u0438\u0442\u043D\u044B\u0445 \u0438\u0437\u0434\u0435\u043B\u0438\u0439",
      "43": "\u043C\u0435\u0442\u0430\u043B\u043B\u044B \u0447\u0435\u0440\u043D\u044B\u0435, \u043A\u0440\u043E\u043C\u0435 \u043D\u0435\u0440\u0436\u0430\u0432\u0435\u044E\u0449\u0435\u0439 \u0441\u0442\u0430\u043B\u0438: \u043A\u0440\u0443\u043F\u043D\u043E\u0433\u0430\u0431\u0430\u0440\u0438\u0442\u043D\u044B\u0435 \u0438\u0437\u0434\u0435\u043B\u0438\u044F \u0438 \u043E\u0431\u043E\u0440\u0443\u0434\u043E\u0432\u0430\u043D\u0438\u0435",
      "44": "\u043C\u0435\u0442\u0430\u043B\u043B\u044B \u0447\u0435\u0440\u043D\u044B\u0435, \u043A\u0440\u043E\u043C\u0435 \u043D\u0435\u0440\u0436\u0430\u0432\u0435\u044E\u0449\u0435\u0439 \u0441\u0442\u0430\u043B\u0438 \u0438 \u043A\u0440\u0443\u043F\u043D\u043E\u0433\u0430\u0431\u0430\u0440\u0438\u0442\u043D\u044B\u0445 \u0438\u0437\u0434\u0435\u043B\u0438\u0439",
      "45": "\u043B\u043E\u043C \u0447\u0435\u0440\u043D\u044B\u0445 \u043C\u0435\u0442\u0430\u043B\u043B\u043E\u0432",
      "46": "\u043C\u0435\u0442\u0430\u043B\u043B\u044B \u0449\u0435\u043B\u043E\u0447\u043D\u044B\u0435, \u0432 \u0442\u043E\u043C \u0447\u0438\u0441\u043B\u0435 \u043E\u0442\u0440\u0430\u0431\u043E\u0442\u0430\u0432\u0448\u0438\u0439 \u0442\u0435\u043F\u043B\u043E\u043D\u043E\u0441\u0438\u0442\u0435\u043B\u044C",
      "51": "\u0430\u043B\u044E\u043C\u0438\u043D\u0438\u0439 \u0438 \u0435\u0433\u043E \u0441\u043F\u043B\u0430\u0432\u044B, \u0438\u0437\u0434\u0435\u043B\u0438\u044F \u0438 \u043E\u0431\u043E\u0440\u0443\u0434\u043E\u0432\u0430\u043D\u0438\u0435 \u0438\u0437 \u0430\u043B\u044E\u043C\u0438\u043D\u0438\u044F \u0438 \u0435\u0433\u043E \u0441\u043F\u043B\u0430\u0432\u043E\u0432",
      "52": "\u0443\u0440\u0430\u043D \u043C\u0435\u0442\u0430\u043B\u043B\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u043E\u0431\u0435\u0434\u043D\u0435\u043D\u043D\u044B\u0439 \u0438 \u0438\u0437\u0434\u0435\u043B\u0438\u044F \u0438\u0437 \u043D\u0435\u0433\u043E",
      "53": "\u043C\u0435\u0434\u044C \u0438 \u0441\u043F\u043B\u0430\u0432\u044B \u043C\u0435\u0434\u0438",
      "54": "\u043D\u0438\u043A\u0435\u043B\u044C \u0438 \u0435\u0433\u043E \u0441\u043F\u043B\u0430\u0432\u044B, \u043A\u0440\u043E\u043C\u0435 \u043C\u0435\u0434\u043D\u043E-\u043D\u0438\u043A\u0435\u043B\u0435\u0432\u044B\u0445 \u0441\u043F\u043B\u0430\u0432\u043E\u0432, \u043E\u0442\u043D\u0435\u0441\u0435\u043D\u043D\u044B\u0445 \u043A \u043A\u043E\u0434\u0443 53",
      "55": "\u0441\u0432\u0438\u043D\u0435\u0446 \u0438 \u0435\u0433\u043E \u0441\u043F\u043B\u0430\u0432\u044B",
      "56": "\u0446\u0438\u0440\u043A\u043E\u043D\u0438\u0439 \u0438 \u0435\u0433\u043E \u0441\u043F\u043B\u0430\u0432\u044B",
      "57": "\u043B\u043E\u043C \u0446\u0432\u0435\u0442\u043D\u044B\u0445 \u043C\u0435\u0442\u0430\u043B\u043B\u043E\u0432 \u043F\u0440\u043E\u0447\u0438\u0445, \u043D\u0435 \u043F\u0435\u0440\u0435\u0447\u0438\u0441\u043B\u0435\u043D\u043D\u044B\u0445 \u0432 \u043F\u0443\u043D\u043A\u0442\u0430\u0445 51-57",
      "58": "\u043B\u043E\u043C \u0446\u0432\u0435\u0442\u043D\u044B\u0445 \u043C\u0435\u0442\u0430\u043B\u043B\u043E\u0432 \u043D\u0435\u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439",
      "59": "\u043C\u0435\u0442\u0430\u043B\u043B\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u043B\u043E\u043C \u043F\u0440\u043E\u0447\u0438\u0439",
      "61": "\u0441\u043E\u0440\u0431\u0435\u043D\u0442\u044B \u0438 \u0444\u0438\u043B\u044C\u0442\u0440\u043E\u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u044B \u043D\u0435\u043E\u0440\u0433\u0430\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0435",
      "62": "\u043F\u0435\u0441\u043E\u043A",
      "63": "\u0442\u0435\u043F\u043B\u043E\u0438\u0437\u043E\u043B\u044F\u0446\u0438\u043E\u043D\u043D\u044B\u0435 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u044B \u043D\u0435\u043E\u0440\u0433\u0430\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0435",
      "64": "\u0438\u0437\u0434\u0435\u043B\u0438\u044F \u0438\u0437 \u0441\u0442\u0435\u043A\u043B\u0430 \u0438 \u043A\u0435\u0440\u0430\u043C\u0438\u043A\u0438, \u043B\u0430\u0431\u043E\u0440\u0430\u0442\u043E\u0440\u043D\u0430\u044F \u043F\u043E\u0441\u0443\u0434\u0430",
      "65": "\u043E\u0442\u0445\u043E\u0434\u044B \u043F\u043B\u0430\u0432\u0438\u043B\u044C\u043D\u043E\u0433\u043E \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0441\u0442\u0432\u0430 (\u0432\u043A\u043B\u044E\u0447\u0430\u044F \u0448\u043B\u0430\u043A\u0438, \u0444\u0443\u0442\u0435\u0440\u043E\u0432\u043A\u0443.)",
      "66": "\u0437\u043E\u043B\u0430",
      "67": "\u043F\u043B\u0430\u0432 \u0441\u043E\u043B\u0435\u0432\u043E\u0439",
      "68": "\u0440\u0443\u0434\u043D\u044B\u0435 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u044B",
      "69": "\u0422\u0432\u0435\u0440\u0434\u044B\u0435 \u0420\u0410\u041E \u043D\u0435\u043E\u0440\u0433\u0430\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u043F\u0440\u043E\u0447\u0438\u0435",
      "71": "\u0441\u043C\u043E\u043B\u044B \u043E\u0442\u0440\u0430\u0431\u043E\u0442\u0430\u043D\u043D\u044B\u0435 \u0438\u043E\u043D\u043E\u043E\u0431\u043C\u0435\u043D\u043D\u044B\u0435",
      "72": "\u0443\u0433\u043E\u043B\u044C \u0430\u043A\u0442\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439, \u0441\u0443\u043B\u044C\u0444\u043E\u0443\u0433\u043E\u043B\u044C",
      "73": "\u043F\u043E\u043B\u0438\u043C\u0435\u0440\u044B",
      "74": "\u0441\u0430\u0436\u0430",
      "75": "\u0441\u043F\u0435\u0446\u043E\u0434\u0435\u0436\u0434\u0430 \u0438 \u0434\u0440\u0443\u0433\u0438\u0435 \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430 \u0438\u043D\u0434\u0438\u0432\u0438\u0434\u0443\u0430\u043B\u044C\u043D\u043E\u0439 \u0437\u0430\u0449\u0438\u0442\u044B, \u043E\u0431\u0443\u0432\u044C, \u043E\u0431\u0442\u0438\u0440\u043E\u0447\u043D\u044B\u0435 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u044B, \u0432\u0435\u0442\u043E\u0448\u044C, \u0432\u0430\u0442\u0430, \u0444\u0438\u043B\u044C\u0442\u0440\u043E\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u044B (\u0444\u0438\u043B\u044C\u0442\u0440\u043E\u0432\u0430\u043B\u044C\u043D\u0430\u044F \u0442\u043A\u0430\u043D\u044C) \u0444\u0438\u043B\u044C\u0442\u0440\u043E\u0432 \u0432\u0435\u043D\u0442\u0438\u043B\u044F\u0446\u0438\u0438",
      "76": "\u0433\u0440\u0430\u0444\u0438\u0442",
      "77": "\u0434\u0440\u0435\u0432\u0435\u0441\u0438\u043D\u0430, \u0431\u0443\u043C\u0430\u0433\u0430, \u043A\u0430\u0440\u0442\u043E\u043D",
      "78": "\u0422\u0432\u0435\u0440\u0434\u044B\u0435 \u0420\u0410\u041E \u0431\u0438\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0438\u0435",
      "79": "\u0422\u0432\u0435\u0440\u0434\u044B\u0435 \u0420\u0410\u041E \u043E\u0440\u0433\u0430\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u043F\u0440\u043E\u0447\u0438\u0435",
      "81": "\u041E\u0417\u0418\u0418\u0418 \u0431\u0435\u0437 \u0437\u0430\u0449\u0438\u0442\u043D\u043E\u0433\u043E \u043A\u043E\u043D\u0442\u0435\u0439\u043D\u0435\u0440\u0430",
      "82": "\u041E\u0417\u0418\u0418\u0418 \u0432 \u0437\u0430\u0449\u0438\u0442\u043D\u043E\u043C \u043A\u043E\u043D\u0442\u0435\u0439\u043D\u0435\u0440\u0435",
      "83": "\u0438\u0437\u0434\u0435\u043B\u0438\u044F \u0441 \u0440\u0430\u0434\u0438\u043E\u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0439 \u0441\u0432\u0435\u0442\u043E\u043C\u0430\u0441\u0441\u043E\u0439 \u043F\u043E\u0441\u0442\u043E\u044F\u043D\u043D\u043E\u0433\u043E \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F (\u0430\u043C\u043F\u0443\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0435 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0438 \u0434\u043B\u044F \u043D\u043E\u0447\u043D\u043E\u0433\u043E \u043E\u0431\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F \u0433\u0430\u0431\u0430\u0440\u0438\u0442\u043E\u0432, \u0430\u0432\u0430\u0440\u0438\u0439\u043D\u044B\u0435 \u0438 \u0430\u0432\u0442\u043E\u043D\u043E\u043C\u043D\u044B\u0435 \u043E\u0441\u0432\u0435\u0442\u0438\u0442\u0435\u043B\u0438, \u0443\u043A\u0430\u0437\u0430\u0442\u0435\u043B\u0438, \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0438 \u0441\u0432\u0435\u0442\u0430 \u0434\u043B\u044F \u0448\u043A\u0430\u043B \u0438 \u0446\u0438\u0444\u0435\u0440\u0431\u043B\u0430\u0442\u043E\u0432 \u043F\u0440\u0438\u0431\u043E\u0440\u043E\u0432, \u043F\u043E\u0434\u0441\u0432\u0435\u0442\u043A\u0438 \u043E\u0440\u0443\u0436\u0435\u0439\u043D\u044B\u0445 \u043F\u0440\u0438\u0446\u0435\u043B\u043E\u0432 \u0438 \u043F\u043E\u0434\u043E\u0431\u043D\u043E\u0435)",
      "84": "\u043E\u0442\u043A\u0440\u044B\u0442\u044B\u0435 \u0440\u0430\u0434\u0438\u043E\u043D\u0443\u043A\u043B\u0438\u0434\u043D\u044B\u0435 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0438 \u0432 \u0432\u0438\u0434\u0435 \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u044B\u0445 \u0438\u0437\u0434\u0435\u043B\u0438\u0439",
      "85": "\u0440\u0430\u0434\u0438\u043E\u0438\u0437\u043E\u0442\u043E\u043F\u043D\u044B\u0435 \u0442\u0435\u0440\u043C\u043E\u044D\u043B\u0435\u043A\u0442\u0440\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0433\u0435\u043D\u0435\u0440\u0430\u0442\u043E\u0440\u044B (\u0420\u0418\u0422\u042D\u0413)",
      "86": "\u0434\u044B\u043C\u043E-, \u043F\u043E\u0436\u0430\u0440\u043E\u0438\u0437\u0432\u0435\u0449\u0430\u0442\u0435\u043B\u0438",
      "87": "\u043F\u0440\u0438\u0431\u043E\u0440\u044B \u0438 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0438 \u0441 \u043C\u0430\u0441\u0441\u043E\u0439 \u043C\u0435\u043D\u0435\u0435 30 \u043A\u0433, \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0449\u0438\u0435 \u041E\u0417\u0418\u0418\u0418",
      "88": "\u043F\u0440\u0438\u0431\u043E\u0440\u044B \u0438 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0438 \u0441 \u043C\u0430\u0441\u0441\u043E\u0439 30 \u043A\u0433 \u0438 \u0431\u043E\u043B\u0435\u0435, \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0449\u0438\u0435 \u041E\u0417\u0418\u0418\u0418",
      "89": "\u043F\u0440\u043E\u0447\u0438\u0435 \u0443\u0447\u0435\u0442\u043D\u044B\u0435 \u0435\u0434\u0438\u043D\u0438\u0446\u044B, \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0449\u0438\u0435 \u041E\u0417\u0418\u0418\u0418",
      "91": "\u0444\u0438\u043B\u044C\u0442\u0440\u044B \u0432\u0435\u043D\u0442\u0438\u043B\u044F\u0446\u0438\u043E\u043D\u043D\u044B\u0435 \u0432 \u0441\u0431\u043E\u0440\u0435",
      "92": "\u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043A\u0430\u0431\u0435\u043B\u0438",
      "94": "\u0436\u0438\u0434\u043A\u0438\u0435 \u0420\u0410\u041E, \u043F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u043B\u0435\u043D\u043D\u044B\u0435 \u043A \u043F\u0435\u0440\u0435\u0434\u0430\u0447\u0435 \u043D\u0430\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u043C\u0443 \u043E\u043F\u0435\u0440\u0430\u0442\u043E\u0440\u0443",
      "93": "\u0441\u0442\u0440\u043E\u0439\u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u044B, \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0438 \u043F\u0440\u043E\u0447\u0438\u0439 \u043C\u0443\u0441\u043E\u0440",
      "95": "\u0438\u043E\u043D\u0438\u0437\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0435 \u043A\u0430\u043C\u0435\u0440\u044B (\u0418\u041A), \u043D\u0435 \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0449\u0438\u0435 \u041E\u0417\u0418\u0418\u0418",
      "96": "\u0437\u0430\u0433\u0440\u044F\u0437\u043D\u0435\u043D\u043D\u044B\u0439 \u0433\u0440\u0443\u043D\u0442, \u0432\u043A\u043B\u044E\u0447\u0430\u044F \u043A\u0435\u0440\u043D\u044B",
      "97": "\u043F\u043E\u0433\u043B\u043E\u0449\u0430\u044E\u0449\u0438\u0435 \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u044B (\u0441\u0442\u0435\u0440\u0436\u043D\u0438-\u043F\u043E\u0433\u043B\u043E\u0442\u0438\u0442\u0435\u043B\u0438)",
      "98": "\u043A\u0430\u043D\u0430\u043B \u0438\u0437\u043C\u0435\u0440\u0435\u043D\u0438\u044F \u043D\u0435\u0439\u0442\u0440\u043E\u043D\u043D\u043E\u0433\u043E \u043F\u043E\u0442\u043E\u043A\u0430 \u0438 \u0442\u0435\u043C\u043F\u0435\u0440\u0430\u0442\u0443\u0440\u044B",
      "99": "\u043F\u0440\u043E\u0447\u0438\u0435 \u0442\u0438\u043F\u044B \u0420\u0410\u041E"
    },
    dataGroup: {
      \u0413\u0430\u0437\u043E\u043E\u0431\u0440\u0430\u0437\u043D\u044B\u0435: ["01"],
      "\u0416\u0438\u0434\u043A\u043E\u0441\u0442\u0438 \u043D\u0435\u043E\u0440\u0433\u0430\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0435": [
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19"
      ],
      "\u0416\u0438\u0434\u043A\u043E\u0441\u0442\u0438 \u043E\u0440\u0433\u0430\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0435": ["21", "22", "23", "24", "25", "26", "29"],
      "\u041F\u0443\u043B\u044C\u043F\u044B, \u0448\u043B\u0430\u043C\u044B": ["31", "32", "33", "34", "35", "36", "37", "38", "39"],
      "\u041E\u0442\u0445\u043E\u0434\u044B \u043C\u0435\u0442\u0430\u043B\u043B\u0438\u0447\u0435\u0441\u043A\u0438\u0435": [
        "41",
        "42",
        "43",
        "44",
        "45",
        "46",
        "51",
        "52",
        "53",
        "54",
        "55",
        "56",
        "57",
        "58",
        "59"
      ],
      "\u041D\u0435\u043E\u0440\u0433\u0430\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0442\u0432\u0435\u0440\u0434\u044B\u0435 \u0420\u0410\u041E, \u043A\u0440\u043E\u043C\u0435 \u043E\u0442\u0445\u043E\u0434\u043E\u0432 \u043C\u0435\u0442\u0430\u043B\u043B\u0438\u0447\u0435\u0441\u043A\u0438\u0445": [
        "61",
        "62",
        "63",
        "64",
        "65",
        "66",
        "67",
        "68",
        "69"
      ],
      "\u041E\u0440\u0433\u0430\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0438 \u0431\u0438\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0442\u0432\u0435\u0440\u0434\u044B\u0435 \u0420\u0410\u041E": [
        "71",
        "72",
        "73",
        "74",
        "75",
        "76",
        "77",
        "78",
        "79"
      ],
      "\u041E\u0442\u0440\u0430\u0431\u043E\u0442\u0430\u0432\u0448\u0438\u0435 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0438 \u0438 \u043F\u0440\u0438\u0431\u043E\u0440\u044B, \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430, \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0449\u0438\u0435 \u043E\u0442\u0440\u0430\u0431\u043E\u0442\u0430\u0432\u0448\u0438\u0435 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0438": ["81", "82", "83", "84", "85", "86", "87", "88", "89"],
      "\u041F\u0440\u043E\u0447\u0438\u0435 \u0442\u0438\u043F\u044B \u043E\u0442\u0445\u043E\u0434\u043E\u0432": [
        "91",
        "92",
        "93",
        "94",
        "95",
        "96",
        "97",
        "98",
        "99"
      ]
    }
  },
  combustible: {
    label: "\u0413\u043E\u0440\u044E\u0447\u0435\u0441\u0442\u044C",
    symbol: [11],
    explanations: {},
    data: {
      1: "\u0433\u043E\u0440\u044E\u0447\u0438\u0435",
      2: "\u043D\u0435\u0433\u043E\u0440\u044E\u0447\u0438\u0435"
    }
  }
};
const CODE_RAO_DATA_ARRAY = Object.values(
  CODE_RAO_DATA
);
function setCharAt(str, index, chr) {
  if (index > str.length - 1) {
    return str;
  }
  return str.substring(0, index) + chr + str.substring(index + 1);
}
function getCalcCode(code, length, calcCodeInfo, newValue, initSymbol = INIT_CODE_SYMBOL) {
  newValue = toStr(newValue);
  if (typeof code === "object") {
    code = "";
  }
  code = toStr(code).padEnd(length, initSymbol);
  calcCodeInfo.symbol.forEach((s, i) => {
    code = setCharAt(code, getCalcCodeInfoSymbolIndex(s), newValue[i]);
  });
  return {
    formData: {
      code,
      [getCalcCodeInfoKey(calcCodeInfo)]: newValue
    }
  };
}
function getCalcCodeInfoKey(codeRaoInfo) {
  return codeRaoInfo.symbol.join("_");
}
function getCalcCodeInfoSymbolIndex(symbol) {
  return symbol - 1;
}
function getCalcCodeByFormDataAndCalcCodeInfo(calcCodeInfo, formData, codeInitSymbol = INIT_CODE_SYMBOL) {
  let newCalcCode = formData.code;
  const key = getCalcCodeInfoKey(calcCodeInfo);
  calcCodeInfo.symbol.forEach((symbol, i) => {
    const currentValueIndex = formData[key][i] || codeInitSymbol;
    newCalcCode = setCharAt(
      newCalcCode,
      getCalcCodeInfoSymbolIndex(symbol),
      currentValueIndex
    );
  });
  return newCalcCode;
}
function updateFormDataByCalcCode(dataArray, code, formData) {
  dataArray.forEach((codeRaoInfo) => {
    let currentValue = "";
    codeRaoInfo.symbol.forEach((symbol) => {
      currentValue += code[getCalcCodeInfoSymbolIndex(symbol)] || "";
    });
    const formDataKey = getCalcCodeInfoKey(codeRaoInfo);
    formData[formDataKey] = currentValue;
  });
}
function getInitFormDataCalcCodeInfo(dataArray, codeLength, codeInitSymbol = INIT_CODE_SYMBOL) {
  const values = dataArray.reduce((value, currentValue) => {
    value[getCalcCodeInfoKey(currentValue)] = "";
    return value;
  }, {});
  return {
    code: "".padEnd(codeLength, codeInitSymbol),
    ...values
  };
}
function getFormDataKey(calcCodeInfo) {
  return calcCodeInfo.symbol.join("_");
}
function getFormDataValueOrUndefined(calcCodeInfo, formData, codeInitSymbol = INIT_CODE_SYMBOL) {
  const key = getFormDataKey(calcCodeInfo);
  if (toStr(formData[key])[0] === codeInitSymbol) {
    return void 0;
  }
  return formData[key];
}
var StateAggregation = /* @__PURE__ */ ((StateAggregation2) => {
  StateAggregation2[StateAggregation2["Liquid"] = 1] = "Liquid";
  StateAggregation2[StateAggregation2["Solid"] = 2] = "Solid";
  return StateAggregation2;
})(StateAggregation || {});
const TYPES_RADIATION = {
  notFilled: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0434\u0430\u043D\u043D\u044B\u0435",
  notRao: "\u041D\u0435 \u0420\u0410\u041E",
  veryLowActive: {
    i: 0,
    label: "\u041E\u0447\u0435\u043D\u044C \u043D\u0438\u0437\u043A\u043E\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0435"
  },
  lowActive: {
    i: 1,
    label: "\u041D\u0438\u0437\u043A\u043E\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0435"
  },
  intermediate: {
    i: 2,
    label: "\u0421\u0440\u0435\u0434\u043D\u0435\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0435"
  },
  highActive: {
    i: 3,
    label: "\u0412\u044B\u0441\u043E\u043A\u043E\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0435"
  }
};
const TYPE_RADIATION_DICT = Object.values(TYPES_RADIATION).reduce(
  (dict, v) => {
    if (typeof v === "object" && "i" in v) {
      dict[v.label] = v.i;
    }
    return dict;
  },
  {}
);
function getMaxTypeRadiation(results) {
  var _a;
  return (_a = results.reduce((maxValue, currentValue) => {
    if (typeof maxValue === "string") {
      return maxValue;
    }
    if (typeof currentValue === "string") {
      return currentValue;
    }
    if (currentValue.i > maxValue.i) {
      return currentValue;
    }
    return maxValue;
  }, results[0])) != null ? _a : TYPES_RADIATION.notRao;
}
function getTypeRadiationLabel(typeRadiation) {
  if (typeof typeRadiation === "string") {
    return typeRadiation;
  }
  return typeRadiation.label;
}
function getTypeRadiationByCodeGroup(codeGroup, stateAggregation, value) {
  if (value === Infinity) {
    return TYPES_RADIATION.notFilled;
  }
  if (stateAggregation === 2) {
    if (codeGroup === "\u0422\u0440\u0438\u0442\u0438\u0439") {
      if (value < 10 ** 7) {
        return TYPES_RADIATION.veryLowActive;
      }
      if (value < 10 ** 8) {
        return TYPES_RADIATION.lowActive;
      }
      if (value < 10 ** 11) {
        return TYPES_RADIATION.intermediate;
      }
      return TYPES_RADIATION.highActive;
    }
    if (codeGroup === "\u0431") {
      if (value < 10 ** 3) {
        return TYPES_RADIATION.veryLowActive;
      }
      if (value < 10 ** 4) {
        return TYPES_RADIATION.lowActive;
      }
      if (value < 10 ** 7) {
        return TYPES_RADIATION.intermediate;
      }
      return TYPES_RADIATION.highActive;
    }
    if (codeGroup === "\u0430") {
      if (value < 10 ** 2) {
        return TYPES_RADIATION.veryLowActive;
      }
      if (value < 10 ** 3) {
        return TYPES_RADIATION.lowActive;
      }
      if (value < 10 ** 6) {
        return TYPES_RADIATION.intermediate;
      }
      return TYPES_RADIATION.highActive;
    }
    if (codeGroup === "\u0422\u0440\u0430\u043D\u0441\u0443\u0440\u0430\u043D\u043E\u0432\u044B\u0439") {
      if (value < 10 ** 1) {
        return TYPES_RADIATION.veryLowActive;
      }
      if (value < 10 ** 2) {
        return TYPES_RADIATION.lowActive;
      }
      if (value < 10 ** 5) {
        return TYPES_RADIATION.intermediate;
      }
      return TYPES_RADIATION.highActive;
    }
  }
  if (stateAggregation === 1) {
    if (codeGroup === "\u0422\u0440\u0438\u0442\u0438\u0439") {
      if (value < 10 ** 4) {
        return TYPES_RADIATION.lowActive;
      }
      if (value < 10 ** 8) {
        return TYPES_RADIATION.intermediate;
      }
      return TYPES_RADIATION.highActive;
    }
    if (codeGroup === "\u0431") {
      if (value < 10 ** 3) {
        return TYPES_RADIATION.lowActive;
      }
      if (value < 10 ** 7) {
        return TYPES_RADIATION.intermediate;
      }
      return TYPES_RADIATION.highActive;
    }
    if (codeGroup === "\u0430") {
      if (value < 10 ** 2) {
        return TYPES_RADIATION.lowActive;
      }
      if (value < 10 ** 6) {
        return TYPES_RADIATION.intermediate;
      }
      return TYPES_RADIATION.highActive;
    }
    if (codeGroup === "\u0422\u0440\u0430\u043D\u0441\u0443\u0440\u0430\u043D\u043E\u0432\u044B\u0439") {
      if (value < 10 ** 1) {
        return TYPES_RADIATION.lowActive;
      }
      if (value < 10 ** 5) {
        return TYPES_RADIATION.intermediate;
      }
      return TYPES_RADIATION.highActive;
    }
  }
  throw new Error(
    "getTypeRadiationByCategory not found:\n " + JSON.stringify({
      codeGroup,
      value,
      stateAggregation
    })
  );
}
function getLowSpecificActivity(stateAggregation, radionuclide, specificActivity) {
  return specificActivity / getUdA(stateAggregation, radionuclide);
}
function getUdA(stateAggregation, radionuclide) {
  let UdAKey;
  if (stateAggregation === 1) {
    UdAKey = "UdA_GRO";
  } else if (stateAggregation === 2) {
    UdAKey = "UdA_TRO";
  } else {
    throw new Error("getUdA, stateAggregation = " + stateAggregation);
  }
  return radionuclide[UdAKey];
}
function getTypeRadiationByData(stateAggregation, data) {
  if (stateAggregation === 1) {
    if (data.alpha <= 0.05 && data.beta <= 0.5) {
      return TYPES_RADIATION.notRao;
    }
  }
  if (stateAggregation === 2) {
    if (data.alpha <= 1 && data.beta <= 100) {
      return TYPES_RADIATION.notRao;
    }
  }
  const results = [
    getTypeRadiationByCodeGroup("\u0430", stateAggregation, data.alpha),
    getTypeRadiationByCodeGroup("\u0431", stateAggregation, data.beta)
  ];
  return getMaxTypeRadiation(results);
}
function getTypeRadiationByMassRao(stateAggregation, massRao, data) {
  const results = [
    getTypeRadiationByCodeGroup(
      "\u0430",
      stateAggregation,
      toNumberOrDefault(data.alpha / massRao)
    ),
    getTypeRadiationByCodeGroup(
      "\u0431",
      stateAggregation,
      toNumberOrDefault(data.beta / massRao)
    ),
    getTypeRadiationByCodeGroup(
      "\u0422\u0440\u0438\u0442\u0438\u0439",
      stateAggregation,
      toNumberOrDefault(data.tritium / massRao)
    ),
    getTypeRadiationByCodeGroup(
      "\u0422\u0440\u0430\u043D\u0441\u0443\u0440\u0430\u043D\u043E\u0432\u044B\u0439",
      stateAggregation,
      toNumberOrDefault(data.transuran / massRao)
    )
  ];
  return getMaxTypeRadiation(results);
}
function getTypeRadiationByMethod4(stateAggregation, _data) {
  if (stateAggregation === 2) {
    const data = _data;
    const result = data.ARa226 + 1.3 * data.ATh232 + 0.09 * data.AK40;
    if (result < 10) {
      return void 0;
    }
    return TYPES_RADIATION.veryLowActive;
  } else if (stateAggregation === 1) {
    const data = _data;
    const result = data.AU238 + 2.14 * data.ATh232;
    if (result < 0.13) {
      return void 0;
    }
    return TYPES_RADIATION.lowActive;
  }
  throw new Error(
    "getTypeRadiationByMethod4 not found stateAggregation =  " + stateAggregation
  );
}
const CATEGORY_RAO_DATA = {
  stateAggregation: {
    label: "\u0410\u0433\u0440\u0435\u0433\u0430\u0442\u043D\u043E\u0435 \u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0435",
    method: void 0,
    explanations: {},
    data: {
      1: "\u0436\u0438\u0434\u043A\u0438\u0435",
      2: "\u0442\u0432\u0451\u0440\u0434\u044B\u0435"
    }
  },
  methodCalculation: {
    label: "\u0421\u043F\u043E\u0441\u043E\u0431 \u0440\u0430\u0441\u0447\u0451\u0442\u0430",
    method: void 0,
    explanations: {},
    data: {
      1: "\u0420\u0410\u041E \u0441 \u0438\u0437\u0432\u0435\u0441\u0442\u043D\u043E\u0439 \u0443\u0434\u0435\u043B\u044C\u043D\u043E\u0439 \u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u044C\u044E \u0434\u043B\u044F \u043A\u0430\u0436\u0434\u043E\u0433\u043E \u0440\u0430\u0434\u0438\u043E\u043D\u0443\u043A\u043B\u0438\u0434\u0430",
      2: "\u0420\u0410\u041E \u0441 \u0438\u0437\u0432\u0435\u0441\u0442\u043D\u043E\u0439 \u0441\u0443\u043C\u043C\u0430\u0440\u043D\u043E\u0439 \u0443\u0434\u0435\u043B\u044C\u043D\u043E\u0439 \u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u044C\u044E \u043F\u043E \u043A\u0430\u0436\u0434\u043E\u043C\u0443 \u0432\u0438\u0434\u0443 \u0438\u0437\u043B\u0443\u0447\u0435\u043D\u0438\u0439 \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u041E\u0421\u041F\u041E\u0420\u0411\u201399/2010",
      3: "\u0420\u0410\u041E \u0441 \u043D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u044B\u043C \u0440\u0430\u0434\u0438\u043E\u043D\u0443\u043A\u043B\u0438\u0434\u043D\u044B\u043C \u0441\u043E\u0441\u0442\u0430\u0432\u043E\u043C \u043F\u043E \u0438\u0437\u0432\u0435\u0441\u0442\u043D\u043E\u0439 \u0441\u0443\u043C\u043C\u0430\u0440\u043D\u043E\u0439 \u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u0438 \u0440\u0430\u0434\u0438\u043E\u043D\u0443\u043A\u043B\u0438\u0434\u043E\u0432 \u0440\u0430\u0437\u043D\u044B\u0445 \u0432\u0438\u0434\u043E\u0432 \u0438\u0437\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0438 \u043C\u0430\u0441\u0441\u0435 \u0420\u0410\u041E",
      4: "\u0420\u0410\u041E, \u043E\u0431\u0440\u0430\u0437\u0443\u044E\u0449\u0438\u0445\u0441\u044F \u043F\u0440\u0438 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u0435\u043D\u0438\u0438 \u043D\u0435 \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0445 \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u0430\u0442\u043E\u043C\u043D\u043E\u0439 \u044D\u043D\u0435\u0440\u0433\u0438\u0438 \u0432\u0438\u0434\u043E\u0432 \u0434\u0435\u044F\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0438 \u043F\u043E \u0434\u043E\u0431\u044B\u0447\u0435 \u0438 \u043F\u0435\u0440\u0435\u0440\u0430\u0431\u043E\u0442\u043A\u0435 \u043C\u0438\u043D\u0435\u0440\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0438 \u043E\u0440\u0433\u0430\u043D\u0438\u0447\u0435\u0441\u043A\u043E\u0433\u043E \u0441\u044B\u0440\u044C\u044F \u0441 \u043F\u043E\u0432\u044B\u0448\u0435\u043D\u043D\u044B\u043C \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u0438\u0435\u043C \u043F\u0440\u0438\u0440\u043E\u0434\u043D\u044B\u0445 \u0440\u0430\u0434\u0438\u043E\u043D\u0443\u043A\u043B\u0438\u0434\u043E\u0432"
    }
  },
  radionuclides: {
    label: "\u0420\u0430\u0434\u0438\u043E\u043D\u0443\u043A\u043B\u0438\u0434\u044B",
    method: 1,
    explanations: {},
    multiselect: true,
    data: {},
    dataVoc: {},
    initValue: []
  },
  specificActivity: {
    label: "\u0423\u0434\u0435\u043B\u044C\u043D\u0430\u044F \u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u044C",
    method: 1,
    explanations: {},
    data: {},
    initValue: {}
  },
  totalSpecificActivity: {
    label: "C\u0443\u043C\u043C\u0430\u0440\u043D\u0430\u044F \u0443\u0434\u0435\u043B\u044C\u043D\u0430\u044F \u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u044C (\u0432 \u0411\u043A/\u0433)",
    method: 2,
    explanations: {},
    data: {},
    initValue: {
      alpha: "0",
      beta: "0"
    },
    inputs: {
      alpha: {
        type: "number",
        caption: "\u0410\u043B\u044C\u0444\u0430"
      },
      beta: {
        type: "number",
        caption: "\u0411\u0435\u0442\u0430"
      }
    }
  },
  totalActivity: {
    label: "\u0421\u0443\u043C\u043C\u0430\u0440\u043D\u0430\u044F \u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u044C (\u0432 \u043A\u0411\u043A)",
    method: 3,
    explanations: {},
    data: {},
    initValue: {
      alpha: "0",
      beta: "0",
      tritium: "0",
      transuran: "0"
    },
    inputs: {
      alpha: {
        type: "number",
        caption: "\u0410\u043B\u044C\u0444\u0430 \u0438\u0437\u043B\u0443\u0447\u0435\u043D\u0438\u0435"
      },
      beta: {
        type: "number",
        caption: "\u0411\u0435\u0442\u0430 \u0438\u0437\u043B\u0443\u0447\u0435\u043D\u0438\u0435"
      },
      tritium: {
        type: "number",
        caption: "\u0422\u0440\u0438\u0442\u0438\u0439"
      },
      transuran: {
        type: "number",
        caption: "\u0422\u0440\u0430\u043D\u0441\u0443\u0440\u0430\u043D\u043E\u0432\u043E\u0435"
      }
    }
  },
  massRao: {
    label: "\u041C\u0430\u0441\u0441\u0430 \u0420\u0410\u041E \u0432 \u043A\u0433",
    method: 3,
    initValue: "",
    data: {},
    explanations: {}
  },
  specificActivityRadionuclides: {
    label: "\u0423\u0434\u0435\u043B\u044C\u043D\u0430\u044F \u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u044C \u0440\u0430\u0434\u0438\u043E\u043D\u0443\u043A\u043B\u0438\u0434\u043E\u0432 (\u0411\u043A/\u0433)",
    method: 4,
    initValue: {
      solid: {
        ARa226: "0",
        ATh232: "0",
        AK40: "0"
      },
      liquid: {
        AU238: "0",
        ATh232: "0"
      }
    },
    data: {},
    explanations: {},
    inputs: {
      solid: {
        ARa226: {
          type: "number",
          caption: "Ra-226"
        },
        ATh232: {
          type: "number",
          caption: "Th-232 "
        },
        AK40: {
          type: "number",
          caption: "K-40"
        }
      },
      liquid: {
        AU238: {
          type: "number",
          caption: "U-238"
        },
        ATh232: {
          type: "number",
          caption: "Th-232"
        }
      }
    }
  }
};
function getNumbersByObject(obj) {
  return Object.keys(obj).reduce((value, currentKey) => {
    const currentValue = obj[currentKey];
    const num = toNumberOrUndefined(currentValue);
    if (num !== void 0) {
      value[currentKey] = num;
    }
    return value;
  }, {});
}
function fillObject(obj, target, value) {
  Object.keys(obj).forEach((key) => {
    if (obj[key] === target) {
      obj[key] = value;
    }
  });
  return obj;
}
var CalcCategoryRao_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$F = defineComponent({
  name: "CalcCategoryRao",
  emits: ["close", "update:modelValue"],
  components: {
    ButtonComponent,
    TRadioButton,
    TInputComponent,
    ModalComponent,
    TSelectComponent,
    AttrInputBase
  },
  props: {
    showConfirmButton: Boolean
  },
  setup() {
    return {
      ICONS,
      toStr,
      StateAggregation,
      ATTRS_TYPES,
      models: {
        exponential: {
          caption: "",
          field: "activity",
          type: "exponential"
        }
      },
      UNITS_ACTIVITY
    };
  },
  data() {
    return {
      formData: {},
      radionuclides: [],
      radionuclidesVoc: [],
      categoryRaoData: CATEGORY_RAO_DATA,
      unitActivity: "\u0411\u043A"
    };
  },
  methods: {
    async initRadionuclides() {
      this.radionuclidesVoc = (await ApiService$1.getVocValues(
        VOC_NAMES_DICT.radionuclide_voc,
        void 0,
        false,
        void 0,
        void 0
      )).json.result;
      this.radionuclides = this.radionuclidesVoc.map((x) => x.attrs);
      this.categoryRaoData.radionuclides.data = this.radionuclidesVoc.filter((x) => isNumeric(x.attrs.UdA_GRO) && isNumeric(x.attrs.UdA_TRO)).reduce((value, currentValue) => {
        value[currentValue.record_id] = currentValue.attrs.Name_RN;
        return value;
      }, {});
      this.categoryRaoData.radionuclides.dataVoc = this.radionuclidesVoc.reduce(
        (value, currentValue) => {
          value[currentValue.record_id] = currentValue.attrs;
          return value;
        },
        {}
      );
    },
    onSelected(categoryRaoInfo, value) {
      const formDataKey = this.getFormDataKey(categoryRaoInfo);
      this.formData[formDataKey] = value;
    },
    onResetValue(categoryRaoInfo) {
      const key = this.getFormDataKey(categoryRaoInfo);
      this.formData[key] = this.getInitFormData()[key];
    },
    onHelp(categoryRaoInfo) {
      NotificationsService$1.send({
        type: "info",
        title: categoryRaoInfo.label,
        text: categoryRaoInfo.explanation
      });
    },
    getInitFormData() {
      const currentStateAggregation = this.getFormDataValue(
        this.categoryRaoData.stateAggregation
      );
      const currentMethodCalculation = this.getFormDataValue(
        this.categoryRaoData.methodCalculation
      );
      const initValue = {};
      Object.values(this.categoryRaoData).filter(
        (x) => x.method === this.methodCalculation || isNullOrUndefined(x.method)
      ).forEach((form) => {
        if ("initValue" in form) {
          initValue[this.getFormDataKey(form)] = copy(form.initValue);
        }
      });
      initValue[this.getFormDataKey(this.categoryRaoData.stateAggregation)] = currentStateAggregation;
      initValue[this.getFormDataKey(this.categoryRaoData.methodCalculation)] = currentMethodCalculation;
      return initValue;
    },
    getFormDataKey(categoryRaoInfo) {
      return categoryRaoInfo.label;
    },
    getFormDataValue(categoryRaoInfo) {
      const key = this.getFormDataKey(categoryRaoInfo);
      return this.formData[key];
    },
    onResetRadionuclide(record_id) {
      this.formData[this.getFormDataKey(this.categoryRaoData.radionuclides)] = this.getFormDataValue(this.categoryRaoData.radionuclides).filter(
        (x) => x.value !== record_id
      );
    }
  },
  watch: {
    async methodCalculation() {
      if (this.methodCalculation === 1 && this.radionuclides.length === 0) {
        await this.initRadionuclides();
      }
      this.formData = this.getInitFormData();
    }
  },
  computed: {
    methodCalculation() {
      const method = this.getFormDataValue(
        this.categoryRaoData.methodCalculation
      );
      if (isNumeric(method)) {
        return Number(method);
      }
      return void 0;
    },
    stateAggregation() {
      const value = this.getFormDataValue(
        this.categoryRaoData.stateAggregation
      );
      return isNumeric(value) ? Number(value) : void 0;
    },
    selectedRadionuclides() {
      return this.getFormDataValue(this.categoryRaoData.radionuclides) || [];
    },
    selectedRadionuclidesExtended() {
      return this.selectedRadionuclides.map((x) => {
        const specificActivity = (this.getFormDataValue(
          this.categoryRaoData.specificActivity
        ) || {})[x.value];
        return {
          record_id: x.value,
          radionuclide: this.categoryRaoData.radionuclides.dataVoc[x.value],
          specificActivity: isNumeric(specificActivity) ? Number(specificActivity) : void 0
        };
      });
    },
    methodCalc1Sum() {
      const data = this.getFormDataValue(this.categoryRaoData.radionuclides).map(
        (x) => {
          const specificActivity = (this.getFormDataValue(
            this.categoryRaoData.specificActivity
          ) || {})[x.value];
          return {
            value: this.categoryRaoData.radionuclides.dataVoc[x.value],
            specificActivity: isNumeric(specificActivity) ? activityToUnit(
              toNumberOrDefault(specificActivity),
              this.unitActivity
            ) : void 0
          };
        }
      );
      if (data.length === 0) {
        return null;
      }
      if (data.some((x) => x.specificActivity === void 0)) {
        return null;
      }
      if (this.stateAggregation === void 0) {
        return null;
      }
      return data.reduce((value, currentValue) => {
        const specificActivity = currentValue.specificActivity;
        value += getLowSpecificActivity(
          this.stateAggregation,
          currentValue.value,
          specificActivity
        );
        return value;
      }, 0);
    },
    isRaoMethodCalc1Sum() {
      return (this.methodCalc1Sum || 0) >= 1;
    },
    categoryMethodCalc1() {
      if (this.stateAggregation === void 0 || this.selectedRadionuclides.length === 0 || this.selectedRadionuclidesExtended.some(
        (x) => x.specificActivity === void 0
      )) {
        return null;
      }
      if (!this.isRaoMethodCalc1Sum) {
        return TYPES_RADIATION.notRao;
      }
      const typesRadiation = this.selectedRadionuclidesExtended.map(
        (x) => getTypeRadiationByCodeGroup(
          x.radionuclide.Kod_gruppy,
          this.stateAggregation,
          activityToUnit(
            toNumberOrDefault(x.specificActivity),
            this.unitActivity
          )
        )
      );
      return getTypeRadiationLabel(getMaxTypeRadiation(typesRadiation));
    },
    categoryMethodCalc2() {
      const data = this.getFormDataValue(
        this.categoryRaoData.totalSpecificActivity
      );
      if (!isNumeric(data.alpha) || !isNumeric(data.beta) || this.stateAggregation === void 0) {
        return null;
      }
      const typeRadiation = getTypeRadiationByData(this.stateAggregation, {
        alpha: Number(data.alpha),
        beta: Number(data.beta)
      });
      return getTypeRadiationLabel(typeRadiation);
    },
    categoryMethodCalc3() {
      const data = fillObject(
        getNumbersByObject(
          this.getFormDataValue(this.categoryRaoData.totalActivity)
        ),
        void 0,
        0
      );
      const massRao = toNumberOrUndefined(
        this.getFormDataValue(this.categoryRaoData.massRao)
      );
      if (this.stateAggregation === void 0) {
        return null;
      }
      if (!isNumeric(massRao) || massRao === 0) {
        return TYPES_RADIATION.notFilled;
      }
      const typeRadiation = getTypeRadiationByMassRao(
        this.stateAggregation,
        massRao,
        data
      );
      return getTypeRadiationLabel(typeRadiation);
    },
    categoryMethodCalc4() {
      var _a;
      if (this.stateAggregation === void 0) {
        return null;
      }
      const data = this.getFormDataValue(
        this.categoryRaoData.specificActivityRadionuclides
      )[this.specificActivityRadionuclidesInputsKey];
      const dataNumbers = getNumbersByObject(data);
      if (Object.keys(data).length !== Object.keys(dataNumbers).length) {
        return null;
      }
      return ((_a = getTypeRadiationByMethod4(this.stateAggregation, dataNumbers)) == null ? void 0 : _a.label) || TYPES_RADIATION.notRao;
    },
    currentCategoryRao() {
      switch (this.methodCalculation) {
        case void 0:
          return null;
        case 1:
          return this.categoryMethodCalc1;
        case 2:
          return this.categoryMethodCalc2;
        case 3:
          return this.categoryMethodCalc3;
        case 4:
          return this.categoryMethodCalc4;
        default:
          return "\u041D\u0435\u0440\u0435\u0430\u043B\u0438\u0437\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u0441\u043F\u043E\u0441\u043E\u0431 \u043F\u043E\u0434\u0441\u0447\u0451\u0442\u0430";
      }
    },
    modelValue() {
      return TYPE_RADIATION_DICT[this.currentCategoryRao];
    },
    specificActivityRadionuclidesInputsKey() {
      if (this.stateAggregation === StateAggregation.Solid) {
        return "solid";
      }
      if (this.stateAggregation === StateAggregation.Liquid) {
        return "liquid";
      }
      return null;
    },
    specificActivityRadionuclidesInputs() {
      if (this.specificActivityRadionuclidesInputsKey === null) {
        return {};
      }
      return this.categoryRaoData.specificActivityRadionuclides.inputs[this.specificActivityRadionuclidesInputsKey];
    }
  }
});
const _withScopeId$e = (n) => (pushScopeId("data-v-37795019"), n = n(), popScopeId(), n);
const _hoisted_1$w = { class: "light-blue-modal-container rao-category-calc-modal" };
const _hoisted_2$u = /* @__PURE__ */ _withScopeId$e(() => /* @__PURE__ */ createElementVNode("div", { class: "light-blue-modal-container-title" }, "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F \u0420\u0410\u041E", -1));
const _hoisted_3$s = { class: "light-blue-modal-container-content" };
const _hoisted_4$q = { class: "rao-calc-category-rao-value-container" };
const _hoisted_5$h = { class: "rao-calc-category-rao-value-container-header" };
const _hoisted_6$e = { class: "rao-calc-category-rao-value-container-content" };
const _hoisted_7$b = { class: "rao-calc-category-rao-value-container" };
const _hoisted_8$6 = { class: "rao-calc-category-rao-value-container-header" };
const _hoisted_9$6 = { class: "rao-calc-category-rao-value-container-header-left" };
const _hoisted_10$6 = { class: "rao-calc-category-rao-value-container-content" };
const _hoisted_11$6 = { class: "rao-calc-category-rao-value-container" };
const _hoisted_12$5 = { class: "rao-calc-category-rao-value-container-header" };
const _hoisted_13$5 = { class: "rao-calc-category-rao-value-container-header-left" };
const _hoisted_14$4 = { class: "rao-calc-category-rao-value-container-content" };
const _hoisted_15$4 = {
  key: 0,
  class: "rao-calc-category-rao-value-container"
};
const _hoisted_16$3 = { class: "rao-calc-category-rao-value-container-header" };
const _hoisted_17$3 = { class: "rao-calc-category-rao-value-container-header-left" };
const _hoisted_18$2 = { class: "rao-calc-category-rao-value-container-content" };
const _hoisted_19$2 = ["onClick"];
const _hoisted_20$2 = {
  key: 1,
  class: "rao-calc-category-rao-value-container"
};
const _hoisted_21$2 = { class: "rao-calc-category-rao-value-container-header" };
const _hoisted_22$2 = { class: "rao-calc-category-rao-value-container-header-left" };
const _hoisted_23$2 = { class: "rao-calc-category-rao-value-container-content" };
const _hoisted_24$2 = { class: "rao-calc-category-rao-value-container" };
const _hoisted_25$2 = { class: "rao-calc-category-rao-value-container-header" };
const _hoisted_26$1 = { class: "rao-calc-category-rao-value-container-header-left" };
const _hoisted_27$1 = { class: "rao-calc-category-rao-value-container-content" };
const _hoisted_28$1 = { class: "rao-calc-category-rao-value-container" };
const _hoisted_29$1 = { class: "rao-calc-category-rao-value-container-header" };
const _hoisted_30$1 = { class: "rao-calc-category-rao-value-container-header-left" };
const _hoisted_31$1 = { class: "rao-calc-category-rao-value-container-content" };
const _hoisted_32$1 = {
  key: 3,
  class: "rao-calc-category-rao-value-container"
};
const _hoisted_33$1 = { class: "rao-calc-category-rao-value-container-header" };
const _hoisted_34$1 = { class: "rao-calc-category-rao-value-container-header-left" };
const _hoisted_35$1 = { class: "rao-calc-category-rao-value-container-content" };
const _hoisted_36$1 = { key: 4 };
const _hoisted_37$1 = { class: "light-blue-modal-container-footer" };
const _hoisted_38$1 = /* @__PURE__ */ _withScopeId$e(() => /* @__PURE__ */ createElementVNode("div", null, null, -1));
const _hoisted_39$1 = { style: { "display": "flex", "gap": "10px" } };
function _sfc_render$F(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ButtonComponent = resolveComponent("ButtonComponent");
  const _component_TRadioButton = resolveComponent("TRadioButton");
  const _component_TSelectComponent = resolveComponent("TSelectComponent");
  const _component_AttrInputBase = resolveComponent("AttrInputBase");
  const _component_TInputComponent = resolveComponent("TInputComponent");
  const _component_ModalComponent = resolveComponent("ModalComponent");
  return openBlock(), createBlock(_component_ModalComponent, {
    isShowBodyCloseButton: true,
    visible: true,
    "body-style": "padding: 0px;",
    "content-style": "overflow: auto;",
    style: { "min-width": "780px", "width": "100vw" },
    "button-close-style": "right: 10px; top: 10px",
    onClose: _cache[17] || (_cache[17] = ($event) => _ctx.$emit("close"))
  }, {
    body: withCtx(() => {
      var _a;
      return [
        createElementVNode("div", _hoisted_1$w, [
          _hoisted_2$u,
          createElementVNode("div", _hoisted_3$s, [
            createElementVNode("div", _hoisted_4$q, [
              createElementVNode("div", _hoisted_5$h, [
                createElementVNode("div", null, toDisplayString(_ctx.categoryRaoData.stateAggregation.label), 1),
                _ctx.categoryRaoData.stateAggregation.explanation ? (openBlock(), createBlock(_component_ButtonComponent, {
                  key: 0,
                  icon: _ctx.ICONS.faq,
                  class: "button-opacity",
                  onClick: _cache[0] || (_cache[0] = ($event) => _ctx.onHelp(_ctx.categoryRaoData.stateAggregation))
                }, null, 8, ["icon"])) : createCommentVNode("", true)
              ]),
              createElementVNode("div", _hoisted_6$e, [
                createVNode(_component_TRadioButton, {
                  data: _ctx.categoryRaoData.stateAggregation.data,
                  footerHelp: _ctx.categoryRaoData.stateAggregation.explanations[_ctx.getFormDataValue(_ctx.categoryRaoData.stateAggregation)],
                  "model-value": _ctx.getFormDataValue(_ctx.categoryRaoData.stateAggregation),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.onSelected(_ctx.categoryRaoData.stateAggregation, $event))
                }, null, 8, ["data", "footerHelp", "model-value"])
              ])
            ]),
            createElementVNode("div", _hoisted_7$b, [
              createElementVNode("div", _hoisted_8$6, [
                createElementVNode("div", _hoisted_9$6, [
                  createElementVNode("div", null, toDisplayString(_ctx.categoryRaoData.methodCalculation.label), 1),
                  _ctx.categoryRaoData.methodCalculation.explanation ? (openBlock(), createBlock(_component_ButtonComponent, {
                    key: 0,
                    icon: _ctx.ICONS.faq,
                    class: "button-opacity",
                    onClick: _cache[2] || (_cache[2] = ($event) => _ctx.onHelp(_ctx.categoryRaoData.methodCalculation))
                  }, null, 8, ["icon"])) : createCommentVNode("", true)
                ])
              ]),
              createElementVNode("div", _hoisted_10$6, [
                createVNode(_component_TSelectComponent, {
                  footerHelp: _ctx.categoryRaoData.methodCalculation.explanations[_ctx.getFormDataValue(_ctx.categoryRaoData.methodCalculation)],
                  "model-value": _ctx.getFormDataValue(_ctx.categoryRaoData.methodCalculation),
                  options: _ctx.categoryRaoData.methodCalculation.data,
                  onReset: _cache[3] || (_cache[3] = ($event) => _ctx.onResetValue(_ctx.categoryRaoData.methodCalculation)),
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => _ctx.onSelected(_ctx.categoryRaoData.methodCalculation, $event.value))
                }, null, 8, ["footerHelp", "model-value", "options"])
              ])
            ]),
            _ctx.methodCalculation === 1 ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
              createElementVNode("div", _hoisted_11$6, [
                createElementVNode("div", _hoisted_12$5, [
                  createElementVNode("div", _hoisted_13$5, [
                    createElementVNode("div", null, toDisplayString(_ctx.categoryRaoData.radionuclides.label), 1),
                    _ctx.categoryRaoData.radionuclides.explanation ? (openBlock(), createBlock(_component_ButtonComponent, {
                      key: 0,
                      icon: _ctx.ICONS.faq,
                      class: "button-opacity",
                      onClick: _cache[5] || (_cache[5] = ($event) => _ctx.onHelp(_ctx.categoryRaoData.radionuclides))
                    }, null, 8, ["icon"])) : createCommentVNode("", true)
                  ])
                ]),
                createElementVNode("div", _hoisted_14$4, [
                  createVNode(_component_TSelectComponent, {
                    footerHelp: _ctx.categoryRaoData.radionuclides.explanations[_ctx.getFormDataValue(_ctx.categoryRaoData.radionuclides)],
                    "model-value": _ctx.getFormDataValue(_ctx.categoryRaoData.radionuclides),
                    multiselect: _ctx.categoryRaoData.radionuclides.multiselect,
                    options: _ctx.categoryRaoData.radionuclides.data,
                    sort: "ASC",
                    onReset: _cache[6] || (_cache[6] = ($event) => _ctx.onResetValue(_ctx.categoryRaoData.radionuclides)),
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => _ctx.onSelected(_ctx.categoryRaoData.radionuclides, $event))
                  }, null, 8, ["footerHelp", "model-value", "multiselect", "options"])
                ])
              ]),
              ((_a = _ctx.selectedRadionuclides) == null ? void 0 : _a.length) > 0 ? (openBlock(), createElementBlock("div", _hoisted_15$4, [
                createElementVNode("div", _hoisted_16$3, [
                  createElementVNode("div", _hoisted_17$3, [
                    createElementVNode("div", null, toDisplayString(_ctx.categoryRaoData.specificActivity.label) + " (" + toDisplayString(_ctx.unitActivity) + "/\u0433) ", 1),
                    _ctx.categoryRaoData.specificActivity.explanation ? (openBlock(), createBlock(_component_ButtonComponent, {
                      key: 0,
                      icon: _ctx.ICONS.faq,
                      class: "button-opacity",
                      onClick: _cache[8] || (_cache[8] = ($event) => _ctx.onHelp(_ctx.categoryRaoData.specificActivity))
                    }, null, 8, ["icon"])) : createCommentVNode("", true)
                  ])
                ]),
                createElementVNode("div", _hoisted_18$2, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.selectedRadionuclidesExtended, ({
                    radionuclide,
                    record_id
                  }) => {
                    return openBlock(), createElementBlock(Fragment, { key: record_id }, [
                      radionuclide.Kod_gruppy ? (openBlock(), createBlock(_component_AttrInputBase, {
                        key: 0,
                        caption: radionuclide.Name_RN,
                        model: _ctx.models.exponential,
                        type: _ctx.ATTRS_TYPES.exponential,
                        value: _ctx.getFormDataValue(_ctx.categoryRaoData.specificActivity)[record_id],
                        style: { "margin-bottom": "5px", "margin-top": "5px" },
                        onChange: ($event) => _ctx.getFormDataValue(_ctx.categoryRaoData.specificActivity)[record_id] = $event,
                        onReset: ($event) => _ctx.onResetRadionuclide(record_id)
                      }, null, 8, ["caption", "model", "type", "value", "onChange", "onReset"])) : (openBlock(), createElementBlock("div", {
                        key: 1,
                        class: "button-not-set-type-radioactive",
                        onClick: ($event) => _ctx.onResetRadionuclide(record_id)
                      }, [
                        createTextVNode(' \u041D\u0435 \u0437\u0430\u0434\u0430\u043D \u043A\u043E\u0434 \u0433\u0440\u0443\u043F\u043F\u044B \u0434\u043B\u044F \u0440\u0430\u0434\u0438\u043E\u043D\u0443\u043A\u043B\u0438\u0434\u0430 "' + toDisplayString(radionuclide.Name_RN) + '" \u0432 \u0441\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A\u0435 ', 1),
                        createVNode(_component_ButtonComponent, {
                          icon: _ctx.ICONS.closeBlue,
                          class: "button-opacity"
                        }, null, 8, ["icon"])
                      ], 8, _hoisted_19$2))
                    ], 64);
                  }), 128))
                ])
              ])) : createCommentVNode("", true)
            ], 64)) : createCommentVNode("", true),
            _ctx.methodCalculation === 2 ? (openBlock(), createElementBlock("div", _hoisted_20$2, [
              createElementVNode("div", _hoisted_21$2, [
                createElementVNode("div", _hoisted_22$2, [
                  createElementVNode("div", null, toDisplayString(_ctx.categoryRaoData.totalSpecificActivity.label), 1),
                  _ctx.categoryRaoData.totalSpecificActivity.explanation ? (openBlock(), createBlock(_component_ButtonComponent, {
                    key: 0,
                    icon: _ctx.ICONS.faq,
                    class: "button-opacity",
                    onClick: _cache[9] || (_cache[9] = ($event) => _ctx.onHelp(_ctx.categoryRaoData.totalSpecificActivity))
                  }, null, 8, ["icon"])) : createCommentVNode("", true)
                ])
              ]),
              createElementVNode("div", _hoisted_23$2, [
                (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.categoryRaoData.totalSpecificActivity.inputs, (input, key) => {
                  return openBlock(), createBlock(_component_AttrInputBase, {
                    key,
                    caption: input.caption,
                    model: _ctx.models.exponential,
                    type: _ctx.ATTRS_TYPES.exponential,
                    value: _ctx.getFormDataValue(_ctx.categoryRaoData.totalSpecificActivity)[key],
                    style: { "margin-bottom": "5px" },
                    onChange: ($event) => _ctx.getFormDataValue(_ctx.categoryRaoData.totalSpecificActivity)[key] = $event,
                    onReset: ($event) => _ctx.getFormDataValue(_ctx.categoryRaoData.totalSpecificActivity)[key] = "0"
                  }, null, 8, ["caption", "model", "type", "value", "onChange", "onReset"]);
                }), 128))
              ])
            ])) : createCommentVNode("", true),
            _ctx.methodCalculation === 3 ? (openBlock(), createElementBlock(Fragment, { key: 2 }, [
              createElementVNode("div", _hoisted_24$2, [
                createElementVNode("div", _hoisted_25$2, [
                  createElementVNode("div", _hoisted_26$1, [
                    createElementVNode("div", null, toDisplayString(_ctx.categoryRaoData.totalActivity.label), 1),
                    _ctx.categoryRaoData.totalActivity.explanation ? (openBlock(), createBlock(_component_ButtonComponent, {
                      key: 0,
                      icon: _ctx.ICONS.faq,
                      class: "button-opacity",
                      onClick: _cache[10] || (_cache[10] = ($event) => _ctx.onHelp(_ctx.categoryRaoData.totalActivity))
                    }, null, 8, ["icon"])) : createCommentVNode("", true)
                  ])
                ]),
                createElementVNode("div", _hoisted_27$1, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.categoryRaoData.totalActivity.inputs, (input, key) => {
                    return openBlock(), createBlock(_component_AttrInputBase, {
                      key,
                      caption: input.caption,
                      model: _ctx.models.exponential,
                      type: _ctx.ATTRS_TYPES.exponential,
                      value: _ctx.getFormDataValue(_ctx.categoryRaoData.totalActivity)[key],
                      style: { "margin-bottom": "5px" },
                      onChange: ($event) => _ctx.getFormDataValue(_ctx.categoryRaoData.totalActivity)[key] = $event,
                      onReset: ($event) => _ctx.getFormDataValue(_ctx.categoryRaoData.totalActivity)[key] = "0"
                    }, null, 8, ["caption", "model", "type", "value", "onChange", "onReset"]);
                  }), 128))
                ])
              ]),
              createElementVNode("div", _hoisted_28$1, [
                createElementVNode("div", _hoisted_29$1, [
                  createElementVNode("div", _hoisted_30$1, [
                    createElementVNode("div", null, toDisplayString(_ctx.categoryRaoData.massRao.label), 1),
                    _ctx.categoryRaoData.massRao.explanation ? (openBlock(), createBlock(_component_ButtonComponent, {
                      key: 0,
                      icon: _ctx.ICONS.faq,
                      class: "button-opacity",
                      onClick: _cache[11] || (_cache[11] = ($event) => _ctx.onHelp(_ctx.categoryRaoData.massRao))
                    }, null, 8, ["icon"])) : createCommentVNode("", true)
                  ])
                ]),
                createElementVNode("div", _hoisted_31$1, [
                  createVNode(_component_TInputComponent, {
                    caption: _ctx.categoryRaoData.massRao.label,
                    "model-value": _ctx.getFormDataValue(_ctx.categoryRaoData.massRao),
                    onReset: _cache[12] || (_cache[12] = ($event) => _ctx.formData[_ctx.getFormDataKey(_ctx.categoryRaoData.massRao)] = "0"),
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => _ctx.formData[_ctx.getFormDataKey(_ctx.categoryRaoData.massRao)] = $event)
                  }, null, 8, ["caption", "model-value"])
                ])
              ])
            ], 64)) : createCommentVNode("", true),
            _ctx.methodCalculation === 4 ? (openBlock(), createElementBlock("div", _hoisted_32$1, [
              createElementVNode("div", _hoisted_33$1, [
                createElementVNode("div", _hoisted_34$1, [
                  createElementVNode("div", null, toDisplayString(_ctx.categoryRaoData.specificActivityRadionuclides.label), 1),
                  _ctx.categoryRaoData.specificActivityRadionuclides.explanation ? (openBlock(), createBlock(_component_ButtonComponent, {
                    key: 0,
                    icon: _ctx.ICONS.faq,
                    class: "button-opacity",
                    onClick: _cache[14] || (_cache[14] = ($event) => _ctx.onHelp(_ctx.categoryRaoData.specificActivityRadionuclides))
                  }, null, 8, ["icon"])) : createCommentVNode("", true)
                ])
              ]),
              createElementVNode("div", _hoisted_35$1, [
                (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.specificActivityRadionuclidesInputs, (input, key) => {
                  return openBlock(), createBlock(_component_AttrInputBase, {
                    key,
                    caption: input.caption,
                    model: _ctx.models.exponential,
                    type: _ctx.ATTRS_TYPES.exponential,
                    value: _ctx.getFormDataValue(
                      _ctx.categoryRaoData.specificActivityRadionuclides
                    )[_ctx.specificActivityRadionuclidesInputsKey][key],
                    style: { "margin-bottom": "5px" },
                    onChange: ($event) => _ctx.getFormDataValue(
                      _ctx.categoryRaoData.specificActivityRadionuclides
                    )[_ctx.specificActivityRadionuclidesInputsKey][key] = $event,
                    onReset: ($event) => _ctx.getFormDataValue(
                      _ctx.categoryRaoData.specificActivityRadionuclides
                    )[_ctx.specificActivityRadionuclidesInputsKey][key] = "0"
                  }, null, 8, ["caption", "model", "type", "value", "onChange", "onReset"]);
                }), 128))
              ])
            ])) : createCommentVNode("", true),
            _ctx.currentCategoryRao !== null ? (openBlock(), createElementBlock("div", _hoisted_36$1, [
              createElementVNode("div", null, toDisplayString(_ctx.currentCategoryRao), 1)
            ])) : createCommentVNode("", true)
          ]),
          createElementVNode("div", _hoisted_37$1, [
            _hoisted_38$1,
            createElementVNode("div", _hoisted_39$1, [
              _ctx.showConfirmButton ? (openBlock(), createBlock(_component_ButtonComponent, {
                key: 0,
                disabled: _ctx.modelValue === void 0,
                class: "form-button",
                "data-type": "accent",
                onClick: _cache[15] || (_cache[15] = ($event) => {
                  _ctx.$emit("update:modelValue", _ctx.modelValue);
                  _ctx.$emit("close");
                })
              }, {
                default: withCtx(() => [
                  createTextVNode(" \u041F\u0440\u0438\u043C\u0435\u043D\u0438\u0442\u044C ")
                ]),
                _: 1
              }, 8, ["disabled"])) : createCommentVNode("", true),
              createVNode(_component_ButtonComponent, {
                class: "form-button",
                "data-type": "accent",
                onClick: _cache[16] || (_cache[16] = ($event) => _ctx.$emit("close"))
              }, {
                default: withCtx(() => [
                  createTextVNode(" \u0417\u0430\u043A\u0440\u044B\u0442\u044C ")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ];
    }),
    _: 1
  });
}
var CalcCategoryRao = /* @__PURE__ */ _export_sfc(_sfc_main$F, [["render", _sfc_render$F], ["__scopeId", "data-v-37795019"]]);
var CalcPeriodPotentialDangerList_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$E = defineComponent({
  name: "CalcPeriodPotentialDangerList",
  props: {
    list: { type: Array, default: () => [] }
  },
  data() {
    return {
      searchText: ""
    };
  },
  computed: {
    searchResults() {
      const search = this.searchText.trim().toLowerCase();
      if (!search) {
        return this.list;
      }
      return this.list.filter(
        (item) => {
          return [item.Name_RN, item.Name_RN_Lat].some(
            (x) => toStr(x).toLowerCase().includes(search)
          );
        }
      );
    }
  },
  methods: {
    listItemClickHandler(item) {
      this.$emit("add-item", item);
    }
  }
});
const _hoisted_1$v = { class: "list calc-section" };
const _hoisted_2$t = { class: "search-input-container" };
const _hoisted_3$r = { class: "search-results" };
const _hoisted_4$p = ["onClick"];
function _sfc_render$E(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$v, [
    createElementVNode("div", _hoisted_2$t, [
      withDirectives(createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.searchText = $event),
        type: "text"
      }, null, 512), [
        [vModelText, _ctx.searchText]
      ])
    ]),
    createElementVNode("div", _hoisted_3$r, [
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.searchResults, (item) => {
        return openBlock(), createElementBlock("div", {
          key: "list_item_" + item.Name_RN + item.ID,
          class: "list-item",
          onClick: ($event) => _ctx.listItemClickHandler(item)
        }, [
          createElementVNode("span", null, toDisplayString(item.Name_RN), 1),
          createElementVNode("span", null, toDisplayString(item.Name_RN_Lat), 1)
        ], 8, _hoisted_4$p);
      }), 128))
    ])
  ]);
}
var CalcPeriodPotentialDangerList = /* @__PURE__ */ _export_sfc(_sfc_main$E, [["render", _sfc_render$E], ["__scopeId", "data-v-515f0aac"]]);
var CalcPeriodPotentialDangerSetup_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$D = defineComponent({
  name: "CalcPeriodPotentialDangerSetup",
  props: {
    percentOk: Boolean,
    rnType: String,
    massOk: Boolean,
    countOk: Boolean,
    massUnit: String,
    rawMass: String,
    agrState: String,
    notFoundUdAProp: Boolean
  },
  components: {
    AttrInputBase,
    ButtonComponent
  },
  setup() {
    return {
      ATTRS_TYPES,
      models: {
        exponential: {
          caption: "\u0410\u043A\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u044C",
          field: "activity",
          type: "exponential"
        }
      },
      optionsMass: ["\u0433", "\u043A\u0433", "\u0442"],
      toNumberOrDefault
    };
  },
  data() {
    return {
      activity: null,
      aFormat: "\u0411\u043A",
      shakeType: false
    };
  },
  computed: {
    allOk() {
      return Boolean(this.percentOk && this.setupOk && this.massOk);
    },
    aBk() {
      if (!this.activity) {
        return 0;
      }
      let mult;
      switch (this.aFormat) {
        case "\u0411\u043A":
          return this.activity;
        case "\u043A\u0411\u043A":
          mult = 10 ** 3;
          break;
        case "\u041C\u0411\u043A":
          mult = 10 ** 6;
          break;
        case "\u0413\u0411\u043A":
          mult = 10 ** 9;
          break;
        case "\u0422\u0411\u043A":
          mult = 10 ** 12;
          break;
      }
      return this.activity * mult;
    },
    setupOk() {
      return toNumberOrDefault(this.activity) > 0;
    }
  },
  methods: {
    massInputHandler(value) {
      this.$emit("update:rawMass", value);
    },
    massUnitChangeHandler(e) {
      this.$emit("update:massUnit", e.target.value);
    },
    agrStateButtonClickHandler(e) {
      if (this.agrState == e.target.value) {
        return;
      }
      this.$emit("update:agrState", e.target.value);
    },
    rnTypeStateButtonClickHandler(e) {
      if (this.rnType == e.target.value) {
        return;
      }
      this.$emit("rnTypeChange", e.target.value);
    },
    calculateClickHandler() {
      if (this.allOk && this.countOk) {
        this.$emit("calculate", this.aBk);
      } else if (this.allOk && !this.countOk) {
        this.shakeTypeSelector();
      }
    },
    shakeTypeSelector() {
      this.shakeType = true;
      setTimeout(() => {
        this.shakeType = false;
      }, 1e3);
    }
  }
});
const _withScopeId$d = (n) => (pushScopeId("data-v-a3c61994"), n = n(), popScopeId(), n);
const _hoisted_1$u = { class: "setup calc-section" };
const _hoisted_2$s = { class: "setup-col-2" };
const _hoisted_3$q = /* @__PURE__ */ _withScopeId$d(() => /* @__PURE__ */ createElementVNode("span", { class: "title" }, "\u0421\u043E\u0441\u0442\u0430\u0432 \u0420\u0410\u041E", -1));
const _hoisted_4$o = { class: "agr-state-buttons-container" };
const _hoisted_5$g = ["value"];
const _hoisted_6$d = { class: "center" };
const _hoisted_7$a = /* @__PURE__ */ _withScopeId$d(() => /* @__PURE__ */ createElementVNode("span", { class: "title" }, "\u0410\u0433\u0440\u0435\u0433\u0430\u0442\u043D\u043E\u0435 \u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0435 \u0420\u0410\u041E", -1));
const _hoisted_8$5 = { class: "agr-state-buttons-container" };
const _hoisted_9$5 = ["value"];
const _hoisted_10$5 = { style: { "display": "flex", "justify-content": "space-between", "column-gap": "20px" } };
const _hoisted_11$5 = { style: { "display": "flex", "gap": "10px", "flex-grow": "1", "justify-content": "flex-start" } };
const _hoisted_12$4 = {
  class: "calc-period__active-input-container",
  style: { "flex-grow": "1" }
};
const _hoisted_13$4 = /* @__PURE__ */ _withScopeId$d(() => /* @__PURE__ */ createElementVNode("option", null, "\u0411\u043A", -1));
const _hoisted_14$3 = /* @__PURE__ */ _withScopeId$d(() => /* @__PURE__ */ createElementVNode("option", null, "\u043A\u0411\u043A", -1));
const _hoisted_15$3 = /* @__PURE__ */ _withScopeId$d(() => /* @__PURE__ */ createElementVNode("option", null, "\u041C\u0411\u043A", -1));
const _hoisted_16$2 = /* @__PURE__ */ _withScopeId$d(() => /* @__PURE__ */ createElementVNode("option", null, "\u0413\u0411\u043A", -1));
const _hoisted_17$2 = /* @__PURE__ */ _withScopeId$d(() => /* @__PURE__ */ createElementVNode("option", null, "\u0422\u0411\u043A", -1));
const _hoisted_18$1 = [
  _hoisted_13$4,
  _hoisted_14$3,
  _hoisted_15$3,
  _hoisted_16$2,
  _hoisted_17$2
];
const _hoisted_19$1 = {
  class: "calc-period__active-input-container",
  style: { "flex-grow": "1" }
};
const _hoisted_20$1 = ["value"];
const _hoisted_21$1 = /* @__PURE__ */ _withScopeId$d(() => /* @__PURE__ */ createElementVNode("option", null, "\u0433", -1));
const _hoisted_22$1 = /* @__PURE__ */ _withScopeId$d(() => /* @__PURE__ */ createElementVNode("option", null, "\u043A\u0433", -1));
const _hoisted_23$1 = /* @__PURE__ */ _withScopeId$d(() => /* @__PURE__ */ createElementVNode("option", null, "\u0442", -1));
const _hoisted_24$1 = [
  _hoisted_21$1,
  _hoisted_22$1,
  _hoisted_23$1
];
const _hoisted_25$1 = { style: { "display": "flex", "flex-direction": "column", "justify-content": "flex-end", "align-content": "flex-end" } };
function _sfc_render$D(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_AttrInputBase = resolveComponent("AttrInputBase");
  const _component_ButtonComponent = resolveComponent("ButtonComponent");
  return openBlock(), createElementBlock("div", _hoisted_1$u, [
    createElementVNode("div", _hoisted_2$s, [
      createElementVNode("div", {
        class: normalizeClass(["center", { shake: _ctx.shakeType }])
      }, [
        _hoisted_3$q,
        createElementVNode("div", _hoisted_4$o, [
          (openBlock(), createElementBlock(Fragment, null, renderList(["\u041C\u043E\u043D\u043E\u043D\u0443\u043A\u043B\u0438\u0434\u043D\u044B\u0439", "\u041F\u043E\u043B\u0438\u043D\u0443\u043A\u043B\u0438\u0434\u043D\u044B\u0439"], (state) => {
            return createElementVNode("button", {
              key: "rnTypeStateButton_" + state,
              class: normalizeClass(["agr-state-button", { pressed: _ctx.rnType === state }]),
              value: state,
              onClick: _cache[0] || (_cache[0] = (...args) => _ctx.rnTypeStateButtonClickHandler && _ctx.rnTypeStateButtonClickHandler(...args))
            }, toDisplayString(state), 11, _hoisted_5$g);
          }), 64))
        ])
      ], 2),
      createElementVNode("div", _hoisted_6$d, [
        _hoisted_7$a,
        createElementVNode("div", _hoisted_8$5, [
          (openBlock(), createElementBlock(Fragment, null, renderList(["\u0422\u0432\u0435\u0440\u0434\u043E\u0435", "\u0416\u0438\u0434\u043A\u043E\u0435"], (state) => {
            return createElementVNode("button", {
              key: "agrStateButton_" + state,
              class: normalizeClass(["agr-state-button", { pressed: _ctx.agrState === state }]),
              value: state,
              onClick: _cache[1] || (_cache[1] = (...args) => _ctx.agrStateButtonClickHandler && _ctx.agrStateButtonClickHandler(...args))
            }, toDisplayString(state), 11, _hoisted_9$5);
          }), 64))
        ])
      ])
    ]),
    createElementVNode("div", _hoisted_10$5, [
      createElementVNode("div", _hoisted_11$5, [
        createElementVNode("div", _hoisted_12$4, [
          createVNode(_component_AttrInputBase, {
            caption: `${_ctx.rnType === "\u041F\u043E\u043B\u0438\u043D\u0443\u043A\u043B\u0438\u0434\u043D\u044B\u0439" ? "\u0421\u0443\u043C\u043C\u0430\u0440\u043D\u0430\u044F \u0430" : "\u0410"}\u043A\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u044C`,
            "is-hide-reset": true,
            model: _ctx.models.exponential,
            type: _ctx.ATTRS_TYPES.exponential,
            value: _ctx.activity,
            style: { "margin-bottom": "0", "flex-grow": "1" },
            onChange: _cache[2] || (_cache[2] = ($event) => _ctx.activity = $event),
            onReset: _cache[3] || (_cache[3] = ($event) => _ctx.activity = "")
          }, null, 8, ["caption", "model", "type", "value"]),
          withDirectives(createElementVNode("select", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => _ctx.aFormat = $event),
            style: { "min-width": "50px", "height": "100%" }
          }, _hoisted_18$1, 512), [
            [vModelSelect, _ctx.aFormat]
          ])
        ]),
        createElementVNode("div", _hoisted_19$1, [
          createVNode(_component_AttrInputBase, {
            caption: `\u041C\u0430\u0441\u0441\u0430`,
            "is-hide-reset": true,
            model: _ctx.models.exponential,
            type: _ctx.ATTRS_TYPES.exponential,
            value: _ctx.rawMass,
            style: { "margin-bottom": "0", "flex-grow": "1" },
            onChange: _cache[5] || (_cache[5] = ($event) => _ctx.massInputHandler($event)),
            onReset: _cache[6] || (_cache[6] = ($event) => _ctx.massInputHandler(""))
          }, null, 8, ["model", "type", "value"]),
          createElementVNode("select", {
            value: _ctx.massUnit,
            style: { "min-width": "50px", "height": "100%" },
            onChange: _cache[7] || (_cache[7] = ($event) => _ctx.massUnitChangeHandler($event))
          }, _hoisted_24$1, 40, _hoisted_20$1)
        ])
      ]),
      createElementVNode("div", _hoisted_25$1, [
        createVNode(_component_ButtonComponent, {
          disabled: !_ctx.allOk || !_ctx.countOk || _ctx.notFoundUdAProp,
          class: "form-button",
          "data-type": "accent",
          style: { "width": "150px" },
          onClick: _ctx.calculateClickHandler
        }, {
          default: withCtx(() => [
            createTextVNode(" \u0420\u0430\u0441\u0441\u0447\u0438\u0442\u0430\u0442\u044C ")
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ])
  ]);
}
var CalcPeriodPotentialDangerSetup = /* @__PURE__ */ _export_sfc(_sfc_main$D, [["render", _sfc_render$D], ["__scopeId", "data-v-a3c61994"]]);
var CalcPeriodPotentialDangerResult_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$C = defineComponent({
  name: "CalcPeriodPotentialDangerResult",
  props: {
    active: Array,
    percentOk: Boolean,
    result: String,
    rnType: String,
    udAProp: String
  },
  emits: ["remove-item", "percent-input"],
  components: {
    AttrInputBase
  },
  setup() {
    return {};
  },
  data() {
    return {};
  },
  methods: {
    removeClickHandler(i) {
      this.$emit("remove-item", i);
    },
    percentInputHandler(e, i) {
      const value = e.target.value;
      this.$emit("percent-input", i, value);
    }
  }
});
const _withScopeId$c = (n) => (pushScopeId("data-v-74c14b64"), n = n(), popScopeId(), n);
const _hoisted_1$t = { class: "result calc-section" };
const _hoisted_2$r = {
  key: 0,
  class: "result-container"
};
const _hoisted_3$p = { class: "calc-result" };
const _hoisted_4$n = { class: "stats" };
const _hoisted_5$f = { class: "active-stat" };
const _hoisted_6$c = { class: "name" };
const _hoisted_7$9 = { class: "active-stat" };
const _hoisted_8$4 = { class: "active-stat" };
const _hoisted_9$4 = {
  key: 0,
  style: { "color": "red" }
};
const _hoisted_10$4 = {
  key: 0,
  class: "calc-period__active-input-container"
};
const _hoisted_11$4 = /* @__PURE__ */ _withScopeId$c(() => /* @__PURE__ */ createElementVNode("span", null, "\u0414\u043E\u043B\u044F \u0432 \u0441\u0443\u043C\u043C\u0430\u0440\u043D\u043E\u0439 \u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u0438, %", -1));
const _hoisted_12$3 = ["value", "onInput"];
const _hoisted_13$3 = ["onClick"];
function _sfc_render$C(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$t, [
    _ctx.result ? (openBlock(), createElementBlock("div", _hoisted_2$r, [
      createTextVNode(" \u041F\u0435\u0440\u0438\u043E\u0434 \u043F\u043E\u0442\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0439 \u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438 \u0420\u0410\u041E: "),
      createElementVNode("div", _hoisted_3$p, toDisplayString(_ctx.result), 1)
    ])) : createCommentVNode("", true),
    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.active, (item, i) => {
      return openBlock(), createElementBlock("div", {
        key: "active_item_" + item.ID,
        class: "active-item"
      }, [
        createElementVNode("div", _hoisted_4$n, [
          createElementVNode("span", _hoisted_5$f, [
            createTextVNode(" \u041D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435 \u0440\u0430\u0434\u0438\u043E\u043D\u0443\u043A\u043B\u0438\u0434\u0430: "),
            createElementVNode("span", _hoisted_6$c, toDisplayString(item.item.Name_RN), 1)
          ]),
          createElementVNode("span", _hoisted_7$9, toDisplayString("\u041E\u0431\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435: " + item.item.Name_RN_Lat), 1),
          createElementVNode("span", _hoisted_8$4, toDisplayString("\u041F\u0435\u0440\u0438\u043E\u0434 \u043F\u043E\u043B\u0443\u0440\u0430\u0441\u043F\u0430\u0434\u0430: " + item.item.Period_p_r + " " + item.item.Edinica_izmer_p_r), 1),
          typeof item.item[_ctx.udAProp] !== "number" ? (openBlock(), createElementBlock("span", _hoisted_9$4, " \u041E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u0435\u0442 \u043A\u043E\u044D\u0444\u0444\u0438\u0446\u0438\u0435\u043D\u0442. \u0420\u0430\u0441\u0447\u0451\u0442 \u043D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u0435\u043D. ")) : createCommentVNode("", true)
        ]),
        _ctx.rnType == "\u041F\u043E\u043B\u0438\u043D\u0443\u043A\u043B\u0438\u0434\u043D\u044B\u0439" ? (openBlock(), createElementBlock("div", _hoisted_10$4, [
          _hoisted_11$4,
          createElementVNode("input", {
            class: normalizeClass(["active-input", { error: !_ctx.percentOk }]),
            value: Number(item.percent.toFixed(2)),
            type: "number",
            onInput: ($event) => _ctx.percentInputHandler($event, i)
          }, null, 42, _hoisted_12$3)
        ])) : createCommentVNode("", true),
        createElementVNode("button", {
          class: "remove-btn",
          onClick: ($event) => _ctx.removeClickHandler(i)
        }, "X", 8, _hoisted_13$3)
      ]);
    }), 128))
  ]);
}
var CalcPeriodPotentialDangerResult = /* @__PURE__ */ _export_sfc(_sfc_main$C, [["render", _sfc_render$C], ["__scopeId", "data-v-74c14b64"]]);
var CalcPeriodPotentialDanger_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$B = defineComponent({
  name: "CalcPeriodPotentialDanger",
  components: {
    CalcPeriodPotentialDangerList,
    CalcPeriodPotentialDangerSetup,
    CalcPeriodPotentialDangerResult
  },
  emits: ["update:modelValue"],
  props: {},
  setup() {
    return {};
  },
  data() {
    return {
      rnType: "\u041C\u043E\u043D\u043E\u043D\u0443\u043A\u043B\u0438\u0434\u043D\u044B\u0439",
      list: [],
      active: [],
      result: "",
      resultModelValue: void 0,
      massUnit: "\u0433",
      rawMass: "",
      radionuclides: [],
      agrState: "\u0422\u0432\u0435\u0440\u0434\u043E\u0435"
    };
  },
  computed: {
    rawMassNum() {
      return toNumberOrDefault(this.rawMass);
    },
    notFoundUdAProp() {
      return this.active.some(
        (x) => typeof x.item[this.udAProp] !== "number"
      );
    },
    filteredList() {
      const activeIds = this.active.map((item) => item.item.ID);
      return this.list.filter((item) => !activeIds.includes(item.ID));
    },
    totalPercent() {
      let totalPercent = this.active.reduce(
        (p, c) => p + c.percent,
        0
      );
      totalPercent = Number(totalPercent.toFixed(12));
      return totalPercent;
    },
    percentOk() {
      return this.active.length != 0 && this.totalPercent <= 100 && this.totalPercent >= 0;
    },
    massOk() {
      return this.rawMassNum > 0;
    },
    countOk() {
      return !(this.rnType == "\u041F\u043E\u043B\u0438\u043D\u0443\u043A\u043B\u0438\u0434\u043D\u044B\u0439" && this.active.length == 1);
    },
    massG() {
      let unitMap = {
        \u0433: 1,
        \u043A\u0433: 1e3,
        \u0442: 1e6
      };
      return this.rawMassNum * unitMap[this.massUnit];
    },
    udAProp() {
      return this.agrState == "\u0422\u0432\u0435\u0440\u0434\u043E\u0435" ? "MOI" : "UdA_GRO";
    }
  },
  async created() {
    watch(
      () => this.resultModelValue,
      () => {
        this.$emit("update:modelValue", this.resultModelValue);
      }
    );
    watch(
      () => [this.rawMassNum, this.massUnit],
      () => {
        this.resetCalculations();
      }
    );
    const radionuclidesVoc = await ApiService$1.getVocValues(
      VOC_NAMES_DICT.radionuclide_voc,
      void 0,
      true,
      void 0,
      void 0
    );
    this.radionuclides = radionuclidesVoc.json.result.map((x) => {
      const result = copy(x.attrs);
      result.ID = x.record_id;
      return result;
    });
    this.list = this.radionuclides.filter((item) => {
      return item.Name_RN && item.Period_p_r && item.Name_RN_Lat && item.Edinica_izmer_p_r;
    });
  },
  methods: {
    addItem(item) {
      if (this.rnType == "\u041C\u043E\u043D\u043E\u043D\u0443\u043A\u043B\u0438\u0434\u043D\u044B\u0439" && this.active.length > 0) {
        this.$refs.setup.shakeTypeSelector();
        return;
      }
      let percent;
      if (this.totalPercent == 100) {
        if (this.active.filter((x) => x.percent == 100 / this.active.length).length == this.active.length) {
          percent = 100 / (this.active.length + 1);
          this.active.forEach((x) => x.percent = percent);
        } else {
          percent = 0;
        }
      } else {
        percent = 100 - this.totalPercent;
      }
      this.active.push({
        item,
        percent
      });
      this.resetCalculations();
    },
    removeItem(i) {
      const percent = this.active.splice(i, 1)[0].percent;
      if (this.active.length) {
        if (this.active.length == 1) {
          this.active[0].percent = 100;
        } else {
          this.active[0].percent += percent;
        }
      }
      this.resetCalculations();
    },
    percentInput(i, value) {
      value = parseFloat(value) || 0;
      if (!value) {
        this.active[i].percent = 1;
      }
      this.active[i].percent = value;
      this.resetCalculations();
    },
    rnTypeChangeHandler(val) {
      this.rnType = val;
      if (val == "\u041C\u043E\u043D\u043E\u043D\u0443\u043A\u043B\u0438\u0434\u043D\u044B\u0439" && this.active.length > 1) {
        this.active = [this.active[0]];
        this.active[0].percent = 100;
      }
    },
    calculate(aBk) {
      this.resultModelValue = void 0;
      aBk = toNumberOrDefault(aBk, aBk);
      const agrState = this.agrState;
      const rnType = this.rnType;
      if (rnType == "\u041C\u043E\u043D\u043E\u043D\u0443\u043A\u043B\u0438\u0434\u043D\u044B\u0439") {
        const item = this.active[0];
        const massG = this.massG;
        const a = agrState == "\u0422\u0432\u0435\u0440\u0434\u043E\u0435" ? item.item.MOI : item.item.UdA_GRO * 0.1;
        const T = periodToYears(
          item.item.Period_p_r,
          item.item.Edinica_izmer_p_r
        );
        const result = 1.44 * T * Math.log(aBk / massG / a);
        this.result = result + " \u043B\u0435\u0442";
        this.resultModelValue = this.getModelValueByYears(result);
      } else {
        const udActivityIn = (years, item) => {
          const arn = aBk * (item.percent / 100);
          const currentUda = arn / this.massG;
          const nextUda = currentUda * 2 ** (-years / periodToYears(
            item.item.Period_p_r,
            item.item.Edinica_izmer_p_r
          ));
          return nextUda;
        };
        this.active.forEach((item) => {
          item.udA100 = udActivityIn(100, item);
        });
        this.active.forEach((item) => {
          item.udA500 = udActivityIn(500, item);
        });
        const udAProp = agrState == "\u0422\u0432\u0435\u0440\u0434\u043E\u0435" ? "MOI" : "UdA_GRO";
        const t100 = this.active.map((item) => item.udA100 / item.item[udAProp]).reduce((p, c2) => p + c2);
        const t500 = this.active.map((item) => item.udA500 / item.item[udAProp]).reduce((p, c2) => p + c2);
        const c = agrState == "\u0422\u0432\u0435\u0440\u0434\u043E\u0435" ? 1 : 0.1;
        if (t500 > c) {
          this.result = "\u0431\u043E\u043B\u0435\u0435 500 \u043B\u0435\u0442";
          this.resultModelValue = 3;
        } else if (t100 >= c && t500 <= c) {
          this.result = "\u043E\u0442 100 \u0434\u043E 500 \u043B\u0435\u0442";
          this.resultModelValue = 2;
        } else if (t100 < c) {
          this.result = "\u043C\u0435\u043D\u0435\u0435 100 \u043B\u0435\u0442";
          this.resultModelValue = 1;
        }
      }
    },
    resetCalculations() {
      this.resultModelValue = void 0;
      this.result = "";
    },
    getModelValueByYears(years) {
      if (years > 500) {
        return 3;
      }
      if (years <= 500 && years >= 100) {
        return 2;
      }
      return 1;
    }
  }
});
const _hoisted_1$s = { class: "calc-period-potential-danger" };
const _hoisted_2$q = { class: "right" };
function _sfc_render$B(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CalcPeriodPotentialDangerList = resolveComponent("CalcPeriodPotentialDangerList");
  const _component_CalcPeriodPotentialDangerSetup = resolveComponent("CalcPeriodPotentialDangerSetup");
  const _component_CalcPeriodPotentialDangerResult = resolveComponent("CalcPeriodPotentialDangerResult");
  return openBlock(), createElementBlock("div", _hoisted_1$s, [
    createVNode(_component_CalcPeriodPotentialDangerList, {
      list: _ctx.filteredList,
      onAddItem: _ctx.addItem
    }, null, 8, ["list", "onAddItem"]),
    createElementVNode("div", _hoisted_2$q, [
      createVNode(_component_CalcPeriodPotentialDangerSetup, {
        ref: "setup",
        agrState: _ctx.agrState,
        "onUpdate:agrState": _cache[0] || (_cache[0] = ($event) => _ctx.agrState = $event),
        massUnit: _ctx.massUnit,
        "onUpdate:massUnit": _cache[1] || (_cache[1] = ($event) => _ctx.massUnit = $event),
        rawMass: _ctx.rawMass,
        "onUpdate:rawMass": _cache[2] || (_cache[2] = ($event) => _ctx.rawMass = $event),
        countOk: _ctx.countOk,
        massOk: _ctx.massOk,
        notFoundUdAProp: _ctx.notFoundUdAProp,
        percentOk: _ctx.percentOk,
        rnType: _ctx.rnType,
        onCalculate: _ctx.calculate,
        onRnTypeChange: _ctx.rnTypeChangeHandler
      }, null, 8, ["agrState", "massUnit", "rawMass", "countOk", "massOk", "notFoundUdAProp", "percentOk", "rnType", "onCalculate", "onRnTypeChange"]),
      createVNode(_component_CalcPeriodPotentialDangerResult, {
        active: _ctx.active,
        percentOk: _ctx.percentOk,
        result: _ctx.result,
        rnType: _ctx.rnType,
        udAProp: _ctx.udAProp,
        onRemoveItem: _ctx.removeItem,
        onPercentInput: _ctx.percentInput
      }, null, 8, ["active", "percentOk", "result", "rnType", "udAProp", "onRemoveItem", "onPercentInput"])
    ])
  ]);
}
var CalcPeriodPotentialDanger = /* @__PURE__ */ _export_sfc(_sfc_main$B, [["render", _sfc_render$B], ["__scopeId", "data-v-2de93578"]]);
const _sfc_main$A = defineComponent({
  name: "CalcPeriodPotentialDangerDemo",
  components: {
    CalcPeriodPotentialDanger,
    ModalComponent,
    ButtonComponent
  },
  props: {
    showConfirmButton: Boolean
  },
  data() {
    return {
      modelValue: void 0
    };
  }
});
const _hoisted_1$r = { class: "light-blue-modal-container" };
const _hoisted_2$p = /* @__PURE__ */ createElementVNode("div", { class: "light-blue-modal-container-title" }, " \u041F\u0435\u0440\u0438\u043E\u0434 \u043F\u043E\u0442\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0439 \u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438 ", -1);
const _hoisted_3$o = {
  class: "light-blue-modal-container-content recalc-activity-radionuclides-demo",
  style: { "padding": "0" }
};
const _hoisted_4$m = { class: "light-blue-modal-container-footer" };
const _hoisted_5$e = /* @__PURE__ */ createElementVNode("div", null, null, -1);
const _hoisted_6$b = { style: { "display": "flex", "gap": "10px" } };
function _sfc_render$A(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CalcPeriodPotentialDanger = resolveComponent("CalcPeriodPotentialDanger");
  const _component_ButtonComponent = resolveComponent("ButtonComponent");
  const _component_ModalComponent = resolveComponent("ModalComponent");
  return openBlock(), createBlock(_component_ModalComponent, {
    isShowBodyCloseButton: true,
    visible: true,
    "body-style": "padding: 0;",
    style: { "width": "100vw" },
    "button-close-style": "right: 10px; top: 10px",
    onClose: _cache[3] || (_cache[3] = ($event) => _ctx.$emit("close"))
  }, {
    body: withCtx(({ close }) => [
      createElementVNode("div", _hoisted_1$r, [
        _hoisted_2$p,
        createElementVNode("div", _hoisted_3$o, [
          createVNode(_component_CalcPeriodPotentialDanger, {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.modelValue = $event)
          })
        ]),
        createElementVNode("div", _hoisted_4$m, [
          _hoisted_5$e,
          createElementVNode("div", _hoisted_6$b, [
            _ctx.showConfirmButton ? (openBlock(), createBlock(_component_ButtonComponent, {
              key: 0,
              disabled: _ctx.modelValue === void 0,
              class: "form-button",
              "data-type": "accent",
              onClick: _cache[1] || (_cache[1] = ($event) => {
                _ctx.$emit("update:modelValue", _ctx.modelValue);
                _ctx.$emit("close");
              })
            }, {
              default: withCtx(() => [
                createTextVNode(" \u041F\u0440\u0438\u043C\u0435\u043D\u0438\u0442\u044C ")
              ]),
              _: 1
            }, 8, ["disabled"])) : createCommentVNode("", true),
            createVNode(_component_ButtonComponent, {
              class: "form-button",
              "data-type": "accent",
              onClick: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("close"))
            }, {
              default: withCtx(() => [
                createTextVNode(" \u0417\u0430\u043A\u0440\u044B\u0442\u044C ")
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _: 1
  });
}
var CalcPeriodPotentialDangerDemo = /* @__PURE__ */ _export_sfc(_sfc_main$A, [["render", _sfc_render$A]]);
var CalcCodeRao_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$z = defineComponent({
  name: "CalcCodeRao",
  props: {
    modelValue: String
  },
  emits: ["close", "init", "update:modelValue", "open:component"],
  components: {
    TRadioButton,
    TInputComponent,
    TSelectComponent,
    ButtonComponent
  },
  setup() {
    return {
      CALC_CODE_INFO_DATA: CODE_RAO_DATA,
      CALC_CODE_INFO_DATA_ARRAY: CODE_RAO_DATA_ARRAY,
      ICONS,
      toStr,
      INIT_CODE_SYMBOL,
      CalcCategoryRaoName: CalcCategoryRao.name,
      CalcPeriodPotentialDangerDemoName: CalcPeriodPotentialDangerDemo.name
    };
  },
  data() {
    return {
      formData: this.getInitFormData(),
      codeLength: CALC_PARAMS.CalcCodeRao.maxSymbols
    };
  },
  created() {
    this.formData.code = this.modelValue || this.formData.code;
    this.updateCalcCode();
    this.$emit("init");
  },
  methods: {
    openCalc(componentName, param) {
      const onUpdateModelValue = (value) => {
        this.onSelected(this.CALC_CODE_INFO_DATA[param], value);
      };
      TDynamicModalService.show({
        inject: ["api"],
        template: `
          <component is="${componentName}" show-confirm-button @update:modelValue="onUpdateModelValue" @close="api.modal.close(this)" />`,
        methods: {
          onUpdateModelValue
        }
      });
    },
    openCalcCategoryRaoName() {
      this.openCalc(CalcCategoryRao.name, "categoryRao");
    },
    openCalcPeriodPotentialDangerDemoName() {
      this.openCalc(
        CalcPeriodPotentialDangerDemo.name,
        "periodPotentialDangerRao"
      );
    },
    getInitFormData() {
      return getInitFormDataCalcCodeInfo(
        this.CALC_CODE_INFO_DATA_ARRAY,
        this.codeLength
      );
    },
    onSelected(calcCodeInfo, _key) {
      const result = getCalcCode(
        this.formData.code,
        this.codeLength,
        calcCodeInfo,
        _key
      );
      Object.assign(this.formData, result.formData);
    },
    onResetValue(calcCodeInfo) {
      const key = this.getFormDataKey(calcCodeInfo);
      this.formData[key] = this.getInitFormData()[key];
      this.formData.code = getCalcCodeByFormDataAndCalcCodeInfo(
        calcCodeInfo,
        this.formData,
        this.INIT_CODE_SYMBOL
      );
    },
    onHelp(calcCodeInfo) {
      NotificationsService$1.send({
        type: "info",
        title: calcCodeInfo.label,
        text: calcCodeInfo.explanation
      });
    },
    updateCalcCode() {
      updateFormDataByCalcCode(
        this.CALC_CODE_INFO_DATA_ARRAY,
        this.formData.code,
        this.formData
      );
    },
    getFormDataKey(calcCodeInfo) {
      return calcCodeInfo.symbol.join("_");
    },
    getFormDataValue(calcCodeInfo) {
      return getFormDataValueOrUndefined(
        calcCodeInfo,
        this.formData,
        this.INIT_CODE_SYMBOL
      );
    },
    updateModelValue() {
      this.$emit("update:modelValue", this.newModelValue);
    }
  },
  watch: {
    "formData.code"(code, prevCode) {
      if (this.formData.code.length === this.codeLength && code !== prevCode) {
        this.updateCalcCode();
      }
      if (this.modelValue !== code) {
        this.updateModelValue();
      }
    },
    modelValue(modelValue, prevModelValue) {
      if (modelValue !== prevModelValue && this.formData.code !== modelValue) {
        this.formData.code = this.modelValue || "";
      }
    }
  },
  computed: {
    newModelValue() {
      return this.formData.code;
    }
  }
});
const _withScopeId$b = (n) => (pushScopeId("data-v-eea14152"), n = n(), popScopeId(), n);
const _hoisted_1$q = { class: "light-blue-modal-container-content" };
const _hoisted_2$o = { style: { "display": "flex", "gap": "24px", "align-items": "center" } };
const _hoisted_3$n = /* @__PURE__ */ _withScopeId$b(() => /* @__PURE__ */ createElementVNode("div", {
  class: "app-label-s14-h20-c828",
  style: { "max-width": "200px" }
}, " \u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0434 \u0420\u0410\u041E \u0432\u0440\u0443\u0447\u043D\u0443\u044E \u0438\u043B\u0438 \u0440\u0430\u0441\u0441\u0447\u0438\u0442\u0430\u0439\u0442\u0435 \u043F\u043E \u0444\u043E\u0440\u043C\u0435 \u043D\u0438\u0436\u0435. ", -1));
const _hoisted_4$l = { class: "rao-calc-value-container" };
const _hoisted_5$d = { class: "rao-calc-value-container-header" };
const _hoisted_6$a = { class: "rao-calc-value-container-header-left" };
const _hoisted_7$8 = { class: "rao-calc-value-container-content" };
const _hoisted_8$3 = { class: "rao-calc-value-container" };
const _hoisted_9$3 = { class: "rao-calc-value-container-header" };
const _hoisted_10$3 = { class: "rao-calc-value-container-header-left" };
const _hoisted_11$3 = { class: "rao-calc-value-container-content" };
const _hoisted_12$2 = { class: "rao-calc-value-container" };
const _hoisted_13$2 = { class: "rao-calc-value-container-header" };
const _hoisted_14$2 = { class: "rao-calc-value-container-header-left" };
const _hoisted_15$2 = { class: "rao-calc-value-container-content" };
const _hoisted_16$1 = { class: "rao-calc-value-container" };
const _hoisted_17$1 = { class: "rao-calc-value-container-header" };
const _hoisted_18 = { class: "rao-calc-value-container-header-left" };
const _hoisted_19 = { class: "rao-calc-value-container-content" };
const _hoisted_20 = { class: "rao-calc-value-container" };
const _hoisted_21 = { class: "rao-calc-value-container-header" };
const _hoisted_22 = { class: "rao-calc-value-container-header-left" };
const _hoisted_23 = { class: "rao-calc-value-container-content" };
const _hoisted_24 = { class: "rao-calc-value-container" };
const _hoisted_25 = { class: "rao-calc-value-container-header" };
const _hoisted_26 = { class: "rao-calc-value-container-header-left" };
const _hoisted_27 = { class: "rao-calc-value-container-content" };
const _hoisted_28 = { class: "rao-calc-value-container" };
const _hoisted_29 = { class: "rao-calc-value-container-header" };
const _hoisted_30 = { class: "rao-calc-value-container-header-left" };
const _hoisted_31 = { class: "rao-calc-value-container-content" };
const _hoisted_32 = { class: "rao-calc-value-container" };
const _hoisted_33 = { class: "rao-calc-value-container-header" };
const _hoisted_34 = { class: "rao-calc-value-container-header-left" };
const _hoisted_35 = { class: "rao-calc-value-container-content" };
const _hoisted_36 = { class: "rao-calc-value-container" };
const _hoisted_37 = { class: "rao-calc-value-container-header" };
const _hoisted_38 = { class: "rao-calc-value-container-header-left" };
const _hoisted_39 = { class: "rao-calc-value-container-content" };
const _hoisted_40 = { class: "rao-calc-value-container" };
const _hoisted_41 = { class: "rao-calc-value-container-header" };
const _hoisted_42 = { class: "rao-calc-value-container-header-left" };
const _hoisted_43 = { class: "rao-calc-value-container-content" };
function _sfc_render$z(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TInputComponent = resolveComponent("TInputComponent");
  const _component_ButtonComponent = resolveComponent("ButtonComponent");
  const _component_TRadioButton = resolveComponent("TRadioButton");
  const _component_TSelectComponent = resolveComponent("TSelectComponent");
  return openBlock(), createElementBlock("div", _hoisted_1$q, [
    createElementVNode("div", _hoisted_2$o, [
      createVNode(_component_TInputComponent, {
        modelValue: _ctx.formData.code,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.formData.code = $event),
        "input-style": { width: "120px" },
        "replace-empty-symbol": _ctx.INIT_CODE_SYMBOL,
        "replace-length": _ctx.codeLength,
        caption: "\u041A\u043E\u0434 \u0420\u0410\u041E",
        onReset: _cache[1] || (_cache[1] = ($event) => _ctx.formData.code = _ctx.getInitFormData().code)
      }, null, 8, ["modelValue", "replace-empty-symbol", "replace-length"]),
      _hoisted_3$n
    ]),
    createElementVNode("div", _hoisted_4$l, [
      createElementVNode("div", _hoisted_5$d, [
        createElementVNode("div", _hoisted_6$a, [
          createElementVNode("div", null, "1. " + toDisplayString(_ctx.CALC_CODE_INFO_DATA.stateAggregation.label), 1),
          _ctx.CALC_CODE_INFO_DATA.stateAggregation.explanation ? (openBlock(), createBlock(_component_ButtonComponent, {
            key: 0,
            icon: _ctx.ICONS.faq,
            class: "button-opacity",
            onClick: _cache[2] || (_cache[2] = ($event) => _ctx.onHelp(_ctx.CALC_CODE_INFO_DATA.stateAggregation))
          }, null, 8, ["icon"])) : createCommentVNode("", true)
        ])
      ]),
      createElementVNode("div", _hoisted_7$8, [
        createVNode(_component_TRadioButton, {
          data: _ctx.CALC_CODE_INFO_DATA.stateAggregation.data,
          footerHelp: _ctx.CALC_CODE_INFO_DATA.stateAggregation.explanations[_ctx.getFormDataValue(_ctx.CALC_CODE_INFO_DATA.stateAggregation)],
          "is-view-key": true,
          "model-value": _ctx.getFormDataValue(_ctx.CALC_CODE_INFO_DATA.stateAggregation),
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => _ctx.onSelected(_ctx.CALC_CODE_INFO_DATA.stateAggregation, $event))
        }, null, 8, ["data", "footerHelp", "model-value"])
      ])
    ]),
    createElementVNode("div", _hoisted_8$3, [
      createElementVNode("div", _hoisted_9$3, [
        createElementVNode("div", _hoisted_10$3, [
          createElementVNode("div", null, "2. " + toDisplayString(_ctx.CALC_CODE_INFO_DATA.categoryRao.label), 1),
          _ctx.CALC_CODE_INFO_DATA.categoryRao.explanation ? (openBlock(), createBlock(_component_ButtonComponent, {
            key: 0,
            icon: _ctx.ICONS.faq,
            class: "button-opacity",
            onClick: _cache[4] || (_cache[4] = ($event) => _ctx.onHelp(_ctx.CALC_CODE_INFO_DATA.categoryRao))
          }, null, 8, ["icon"])) : createCommentVNode("", true)
        ]),
        createVNode(_component_ButtonComponent, {
          icon: _ctx.ICONS.calculatorVariantOutline,
          class: "button-blue",
          onClick: _ctx.openCalcCategoryRaoName
        }, {
          default: withCtx(() => [
            createTextVNode(" \u0420\u0430\u0441\u0441\u0447\u0438\u0442\u0430\u0442\u044C ")
          ]),
          _: 1
        }, 8, ["icon", "onClick"])
      ]),
      createElementVNode("div", _hoisted_11$3, [
        createVNode(_component_TSelectComponent, {
          footerHelp: _ctx.CALC_CODE_INFO_DATA.categoryRao.explanations[_ctx.getFormDataValue(_ctx.CALC_CODE_INFO_DATA.categoryRao)],
          "is-value-view": true,
          "model-value": _ctx.getFormDataValue(_ctx.CALC_CODE_INFO_DATA.categoryRao),
          options: _ctx.CALC_CODE_INFO_DATA.categoryRao.data,
          onReset: _cache[5] || (_cache[5] = ($event) => _ctx.onResetValue(_ctx.CALC_CODE_INFO_DATA.categoryRao)),
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => _ctx.onSelected(_ctx.CALC_CODE_INFO_DATA.categoryRao, $event.value))
        }, null, 8, ["footerHelp", "model-value", "options"])
      ])
    ]),
    createElementVNode("div", _hoisted_12$2, [
      createElementVNode("div", _hoisted_13$2, [
        createElementVNode("div", _hoisted_14$2, [
          createElementVNode("div", null, " 3. " + toDisplayString(_ctx.CALC_CODE_INFO_DATA.radionuclideCompositionRao.label), 1),
          _ctx.CALC_CODE_INFO_DATA.radionuclideCompositionRao.explanation ? (openBlock(), createBlock(_component_ButtonComponent, {
            key: 0,
            icon: _ctx.ICONS.faq,
            class: "button-opacity",
            onClick: _cache[7] || (_cache[7] = ($event) => _ctx.onHelp(_ctx.CALC_CODE_INFO_DATA.radionuclideCompositionRao))
          }, null, 8, ["icon"])) : createCommentVNode("", true)
        ])
      ]),
      createElementVNode("div", _hoisted_15$2, [
        createVNode(_component_TSelectComponent, {
          footerHelp: _ctx.CALC_CODE_INFO_DATA.radionuclideCompositionRao.explanations[_ctx.getFormDataValue(_ctx.CALC_CODE_INFO_DATA.radionuclideCompositionRao)],
          "is-value-view": true,
          "model-value": _ctx.getFormDataValue(_ctx.CALC_CODE_INFO_DATA.radionuclideCompositionRao),
          options: _ctx.CALC_CODE_INFO_DATA.radionuclideCompositionRao.data,
          onReset: _cache[8] || (_cache[8] = ($event) => _ctx.onResetValue(_ctx.CALC_CODE_INFO_DATA.radionuclideCompositionRao)),
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => _ctx.onSelected(
            _ctx.CALC_CODE_INFO_DATA.radionuclideCompositionRao,
            $event.value
          ))
        }, null, 8, ["footerHelp", "model-value", "options"])
      ])
    ]),
    createElementVNode("div", _hoisted_16$1, [
      createElementVNode("div", _hoisted_17$1, [
        createElementVNode("div", _hoisted_18, [
          createElementVNode("div", null, "4. " + toDisplayString(_ctx.CALC_CODE_INFO_DATA.contentNuclearMaterials.label), 1),
          _ctx.CALC_CODE_INFO_DATA.contentNuclearMaterials.explanation ? (openBlock(), createBlock(_component_ButtonComponent, {
            key: 0,
            icon: _ctx.ICONS.faq,
            class: "button-opacity",
            onClick: _cache[10] || (_cache[10] = ($event) => _ctx.onHelp(_ctx.CALC_CODE_INFO_DATA.contentNuclearMaterials))
          }, null, 8, ["icon"])) : createCommentVNode("", true)
        ])
      ]),
      createElementVNode("div", _hoisted_19, [
        createVNode(_component_TRadioButton, {
          data: _ctx.CALC_CODE_INFO_DATA.contentNuclearMaterials.data,
          footerHelp: _ctx.CALC_CODE_INFO_DATA.contentNuclearMaterials.explanations[_ctx.getFormDataValue(_ctx.CALC_CODE_INFO_DATA.contentNuclearMaterials)],
          "is-view-key": true,
          "model-value": _ctx.getFormDataValue(_ctx.CALC_CODE_INFO_DATA.contentNuclearMaterials),
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => _ctx.onSelected(_ctx.CALC_CODE_INFO_DATA.contentNuclearMaterials, $event))
        }, null, 8, ["data", "footerHelp", "model-value"])
      ])
    ]),
    createElementVNode("div", _hoisted_20, [
      createElementVNode("div", _hoisted_21, [
        createElementVNode("div", _hoisted_22, [
          createElementVNode("div", null, "5. " + toDisplayString(_ctx.CALC_CODE_INFO_DATA.halfLife.label), 1),
          _ctx.CALC_CODE_INFO_DATA.halfLife.explanation ? (openBlock(), createBlock(_component_ButtonComponent, {
            key: 0,
            icon: _ctx.ICONS.faq,
            class: "button-opacity",
            onClick: _cache[12] || (_cache[12] = ($event) => _ctx.onHelp(_ctx.CALC_CODE_INFO_DATA.halfLife))
          }, null, 8, ["icon"])) : createCommentVNode("", true)
        ])
      ]),
      createElementVNode("div", _hoisted_23, [
        createVNode(_component_TRadioButton, {
          data: _ctx.CALC_CODE_INFO_DATA.halfLife.data,
          footerHelp: _ctx.CALC_CODE_INFO_DATA.halfLife.explanations[_ctx.getFormDataValue(_ctx.CALC_CODE_INFO_DATA.halfLife)],
          "is-view-key": true,
          "model-value": _ctx.getFormDataValue(_ctx.CALC_CODE_INFO_DATA.halfLife),
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => _ctx.onSelected(_ctx.CALC_CODE_INFO_DATA.halfLife, $event))
        }, null, 8, ["data", "footerHelp", "model-value"])
      ])
    ]),
    createElementVNode("div", _hoisted_24, [
      createElementVNode("div", _hoisted_25, [
        createElementVNode("div", _hoisted_26, [
          createElementVNode("div", null, "6. " + toDisplayString(_ctx.CALC_CODE_INFO_DATA.periodPotentialDangerRao.label), 1),
          _ctx.CALC_CODE_INFO_DATA.periodPotentialDangerRao.explanation ? (openBlock(), createBlock(_component_ButtonComponent, {
            key: 0,
            icon: _ctx.ICONS.faq,
            class: "button-opacity",
            onClick: _cache[14] || (_cache[14] = ($event) => _ctx.onHelp(_ctx.CALC_CODE_INFO_DATA.periodPotentialDangerRao))
          }, null, 8, ["icon"])) : createCommentVNode("", true)
        ]),
        createVNode(_component_ButtonComponent, {
          icon: _ctx.ICONS.calculatorVariantOutline,
          class: "button-blue",
          onClick: _ctx.openCalcPeriodPotentialDangerDemoName
        }, {
          default: withCtx(() => [
            createTextVNode(" \u0420\u0430\u0441\u0441\u0447\u0438\u0442\u0430\u0442\u044C ")
          ]),
          _: 1
        }, 8, ["icon", "onClick"])
      ]),
      createElementVNode("div", _hoisted_27, [
        createVNode(_component_TRadioButton, {
          data: _ctx.CALC_CODE_INFO_DATA.periodPotentialDangerRao.data,
          footerHelp: _ctx.CALC_CODE_INFO_DATA.periodPotentialDangerRao.explanations[_ctx.getFormDataValue(_ctx.CALC_CODE_INFO_DATA.periodPotentialDangerRao)],
          "is-view-key": true,
          "model-value": _ctx.getFormDataValue(_ctx.CALC_CODE_INFO_DATA.periodPotentialDangerRao),
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => _ctx.onSelected(_ctx.CALC_CODE_INFO_DATA.periodPotentialDangerRao, $event))
        }, null, 8, ["data", "footerHelp", "model-value"])
      ])
    ]),
    createElementVNode("div", _hoisted_28, [
      createElementVNode("div", _hoisted_29, [
        createElementVNode("div", _hoisted_30, [
          createElementVNode("div", null, "7. " + toDisplayString(_ctx.CALC_CODE_INFO_DATA.methodRecycling.label), 1),
          _ctx.CALC_CODE_INFO_DATA.methodRecycling.explanation ? (openBlock(), createBlock(_component_ButtonComponent, {
            key: 0,
            icon: _ctx.ICONS.faq,
            class: "button-opacity",
            onClick: _cache[16] || (_cache[16] = ($event) => _ctx.onHelp(_ctx.CALC_CODE_INFO_DATA.methodRecycling))
          }, null, 8, ["icon"])) : createCommentVNode("", true)
        ])
      ]),
      createElementVNode("div", _hoisted_31, [
        createVNode(_component_TSelectComponent, {
          footerHelp: _ctx.CALC_CODE_INFO_DATA.methodRecycling.explanations[_ctx.getFormDataValue(_ctx.CALC_CODE_INFO_DATA.methodRecycling)],
          "is-value-view": true,
          "model-value": _ctx.getFormDataValue(_ctx.CALC_CODE_INFO_DATA.methodRecycling),
          options: _ctx.CALC_CODE_INFO_DATA.methodRecycling.data,
          onReset: _cache[17] || (_cache[17] = ($event) => _ctx.onResetValue(_ctx.CALC_CODE_INFO_DATA.methodRecycling)),
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => _ctx.onSelected(_ctx.CALC_CODE_INFO_DATA.methodRecycling, $event.value))
        }, null, 8, ["footerHelp", "model-value", "options"])
      ])
    ]),
    createElementVNode("div", _hoisted_32, [
      createElementVNode("div", _hoisted_33, [
        createElementVNode("div", _hoisted_34, [
          createElementVNode("div", null, "8. " + toDisplayString(_ctx.CALC_CODE_INFO_DATA.classRao.label), 1),
          _ctx.CALC_CODE_INFO_DATA.classRao.explanation ? (openBlock(), createBlock(_component_ButtonComponent, {
            key: 0,
            icon: _ctx.ICONS.faq,
            class: "button-opacity",
            onClick: _cache[19] || (_cache[19] = ($event) => _ctx.onHelp(_ctx.CALC_CODE_INFO_DATA.classRao))
          }, null, 8, ["icon"])) : createCommentVNode("", true)
        ])
      ]),
      createElementVNode("div", _hoisted_35, [
        createVNode(_component_TSelectComponent, {
          footerHelp: _ctx.CALC_CODE_INFO_DATA.classRao.explanations[_ctx.getFormDataValue(_ctx.CALC_CODE_INFO_DATA.classRao)],
          "is-value-view": true,
          "model-value": _ctx.getFormDataValue(_ctx.CALC_CODE_INFO_DATA.classRao),
          options: _ctx.CALC_CODE_INFO_DATA.classRao.data,
          onReset: _cache[20] || (_cache[20] = ($event) => _ctx.onResetValue(_ctx.CALC_CODE_INFO_DATA.classRao)),
          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => _ctx.onSelected(_ctx.CALC_CODE_INFO_DATA.classRao, $event.value))
        }, null, 8, ["footerHelp", "model-value", "options"])
      ])
    ]),
    createElementVNode("div", _hoisted_36, [
      createElementVNode("div", _hoisted_37, [
        createElementVNode("div", _hoisted_38, [
          createElementVNode("div", null, toDisplayString(_ctx.CALC_CODE_INFO_DATA.codeTypeRao.symbol.join("-")) + ". " + toDisplayString(_ctx.CALC_CODE_INFO_DATA.codeTypeRao.label), 1),
          _ctx.CALC_CODE_INFO_DATA.codeTypeRao.explanation ? (openBlock(), createBlock(_component_ButtonComponent, {
            key: 0,
            icon: _ctx.ICONS.faq,
            class: "button-opacity",
            onClick: _cache[22] || (_cache[22] = ($event) => _ctx.onHelp(_ctx.CALC_CODE_INFO_DATA.codeTypeRao))
          }, null, 8, ["icon"])) : createCommentVNode("", true)
        ])
      ]),
      createElementVNode("div", _hoisted_39, [
        createVNode(_component_TSelectComponent, {
          footerHelp: _ctx.CALC_CODE_INFO_DATA.codeTypeRao.explanations[_ctx.getFormDataValue(_ctx.CALC_CODE_INFO_DATA.codeTypeRao)],
          "is-value-view": true,
          "model-value": _ctx.getFormDataValue(_ctx.CALC_CODE_INFO_DATA.codeTypeRao),
          options: _ctx.CALC_CODE_INFO_DATA.codeTypeRao.data,
          "options-group": _ctx.CALC_CODE_INFO_DATA.codeTypeRao.dataGroup,
          onReset: _cache[23] || (_cache[23] = ($event) => _ctx.onResetValue(_ctx.CALC_CODE_INFO_DATA.codeTypeRao)),
          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event) => _ctx.onSelected(_ctx.CALC_CODE_INFO_DATA.codeTypeRao, $event.value))
        }, null, 8, ["footerHelp", "model-value", "options", "options-group"])
      ])
    ]),
    createElementVNode("div", _hoisted_40, [
      createElementVNode("div", _hoisted_41, [
        createElementVNode("div", _hoisted_42, [
          createElementVNode("div", null, toDisplayString(_ctx.CALC_CODE_INFO_DATA.combustible.symbol.join("-")) + ". " + toDisplayString(_ctx.CALC_CODE_INFO_DATA.combustible.label), 1),
          _ctx.CALC_CODE_INFO_DATA.combustible.explanation ? (openBlock(), createBlock(_component_ButtonComponent, {
            key: 0,
            icon: _ctx.ICONS.faq,
            class: "button-opacity",
            onClick: _cache[25] || (_cache[25] = ($event) => _ctx.onHelp(_ctx.CALC_CODE_INFO_DATA.combustible))
          }, null, 8, ["icon"])) : createCommentVNode("", true)
        ])
      ]),
      createElementVNode("div", _hoisted_43, [
        createVNode(_component_TRadioButton, {
          data: _ctx.CALC_CODE_INFO_DATA.combustible.data,
          footerHelp: _ctx.CALC_CODE_INFO_DATA.combustible.explanations[_ctx.getFormDataValue(_ctx.CALC_CODE_INFO_DATA.combustible)],
          "is-view-key": true,
          "model-value": _ctx.getFormDataValue(_ctx.CALC_CODE_INFO_DATA.combustible),
          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event) => _ctx.onSelected(_ctx.CALC_CODE_INFO_DATA.combustible, $event))
        }, null, 8, ["data", "footerHelp", "model-value"])
      ])
    ])
  ]);
}
var CalcCodeRao = /* @__PURE__ */ _export_sfc(_sfc_main$z, [["render", _sfc_render$z], ["__scopeId", "data-v-eea14152"]]);
var CalcCodeRaoDemo_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$y = defineComponent({
  name: "CalcCodeRaoDemo",
  emits: ["close", "open:component"],
  components: {
    TRadioButton,
    TInputComponent,
    ModalComponent,
    TSelectComponent,
    CalcCodeRao,
    ButtonComponent
  },
  setup() {
    return {};
  },
  data() {
    return {};
  },
  created() {
  },
  methods: {},
  watch: {},
  computed: {}
});
const _withScopeId$a = (n) => (pushScopeId("data-v-27f937c2"), n = n(), popScopeId(), n);
const _hoisted_1$p = { class: "light-blue-modal-container rao-calc-modal" };
const _hoisted_2$n = /* @__PURE__ */ _withScopeId$a(() => /* @__PURE__ */ createElementVNode("div", { class: "light-blue-modal-container-title" }, "\u041A\u043E\u0434 \u0420\u0410\u041E", -1));
const _hoisted_3$m = { class: "light-blue-modal-container-footer" };
const _hoisted_4$k = /* @__PURE__ */ _withScopeId$a(() => /* @__PURE__ */ createElementVNode("div", null, null, -1));
function _sfc_render$y(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CalcCodeRao = resolveComponent("CalcCodeRao");
  const _component_ButtonComponent = resolveComponent("ButtonComponent");
  const _component_ModalComponent = resolveComponent("ModalComponent");
  return openBlock(), createBlock(_component_ModalComponent, {
    isShowBodyCloseButton: true,
    visible: true,
    "body-style": "padding: 0px;",
    "content-style": "overflow: auto;",
    style: { "min-width": "780px", "width": "100vw" },
    "button-close-style": "right: 10px; top: 10px",
    onClose: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("close"))
  }, {
    body: withCtx(() => [
      createElementVNode("div", _hoisted_1$p, [
        _hoisted_2$n,
        createVNode(_component_CalcCodeRao, {
          "onOpen:component": _cache[0] || (_cache[0] = ($event) => _ctx.$emit("open:component", $event))
        }),
        createElementVNode("div", _hoisted_3$m, [
          _hoisted_4$k,
          createVNode(_component_ButtonComponent, {
            class: "form-button",
            "data-type": "accent",
            onClick: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("close"))
          }, {
            default: withCtx(() => [
              createTextVNode(" \u0417\u0430\u043A\u0440\u044B\u0442\u044C ")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  });
}
var CalcCodeRaoDemo = /* @__PURE__ */ _export_sfc(_sfc_main$y, [["render", _sfc_render$y], ["__scopeId", "data-v-27f937c2"]]);
var CalcCategoryZri_vue_vue_type_style_index_0_scoped_true_lang = "";
function rnSortCompare(a, b) {
  return toStr(a.Name_RN).localeCompare(toStr(b.Name_RN));
}
const _sfc_main$x = defineComponent({
  name: "CalcCategoryZri",
  props: {},
  emit: ["init", "update:modelValue"],
  components: {
    SearchComponent,
    ButtonComponent,
    AttrInputBase,
    TRadioButton
  },
  setup() {
    return {
      ICONS,
      ATTRS_TYPES,
      UNITS_ACTIVITY,
      UNITS_ACTIVITY_SELECT: UNITS_ACTIVITY.map(
        (x) => ({
          label: x,
          value: x
        })
      ),
      models: {
        exponential: {
          caption: "\u0420\u0430\u0434\u0438\u043E\u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u044C",
          field: "activity",
          type: "exponential"
        }
      },
      isNullOrUndefined,
      toNumberOrUndefined
    };
  },
  data() {
    return {
      listSorted: [],
      rnCount: 0,
      rnCalc: [],
      rnValue: "",
      rnAct: 0,
      messages: {
        5: "<div style='color: #57D9A3'>\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F \u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438 5: \u041E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u044C \u0434\u043B\u044F \u0447\u0435\u043B\u043E\u0432\u0435\u043A\u0430 \u043E\u0447\u0435\u043D\u044C \u043C\u0430\u043B\u043E\u0432\u0435\u0440\u043E\u044F\u0442\u043D\u0430</div>",
        4: "<div style='color: #79E2F2'>\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F \u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438 4: \u041E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u044C \u0434\u043B\u044F \u0447\u0435\u043B\u043E\u0432\u0435\u043A\u0430 \u043C\u0430\u043B\u043E\u0432\u0435\u0440\u043E\u044F\u0442\u043D\u0430</div>",
        3: "<div style='color: #FF8F73'>\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F \u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438 3: \u041E\u043F\u0430\u0441\u043D\u043E \u0434\u043B\u044F \u0447\u0435\u043B\u043E\u0432\u0435\u043A\u0430</div>",
        2: "<div style='color: #FFC400'>\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F \u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438 2: \u041E\u0447\u0435\u043D\u044C \u043E\u043F\u0430\u0441\u043D\u043E \u0434\u043B\u044F \u0447\u0435\u043B\u043E\u0432\u0435\u043A\u0430</div>",
        1: "<div style='color: #FF0000'>\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F \u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438 1: \u0427\u0440\u0435\u0437\u0432\u044B\u0447\u0430\u0439\u043D\u043E \u043E\u043F\u0430\u0441\u043D\u043E \u0434\u043B\u044F \u0447\u0435\u043B\u043E\u0432\u0435\u043A\u0430</div>",
        0: "<div style='color: red;'>\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u044C \u0417\u0420\u0418 \u043C\u0435\u043D\u044C\u0448\u0435 \u041C\u0417\u0410</div><br><div>\u0417\u0420\u0418 \u0443\u0447\u0435\u0442\u0443 \u0432 \u0421\u0413\u0423\u041A \u0420\u0412 \u0438 \u0420\u0410\u041E \u043D\u0435 \u043F\u043E\u0434\u043B\u0435\u0436\u0438\u0442</div>"
      },
      message: "",
      danger: null,
      list: null
    };
  },
  async mounted() {
    const radionuclidesVoc = await ApiService$1.getVocValues(
      VOC_NAMES_DICT.radionuclide_voc,
      void 0,
      false,
      void 0,
      void 0
    );
    this.list = radionuclidesVoc.json.result.map((x) => {
      return {
        ...x.attrs,
        unitActivity: "\u0411\u043A",
        ID: x.record_id
      };
    });
    this.$emit("init");
  },
  computed: {
    sortRn() {
      if (this.list === null) {
        return [];
      }
      this.listSorted = [...this.list];
      return this.listSorted.sort(rnSortCompare);
    },
    isEveryLessMza() {
      return this.rnCalc.every((rn) => this.isLessMza(rn));
    },
    isContainsNullD() {
      return this.rnCalc.some((rn) => !rn.D_val || toNumberOrUndefined(rn.D_val) === 0);
    },
    isEnterActivity() {
      return !this.rnCalc.some((x) => toNumberOrDefault(x.activity) <= 0);
    }
  },
  methods: {
    isLessMza(rn) {
      return isNumeric(rn.activity) && isNumeric(rn.MZA) && toNumberOrDefault(
        activityToUnit(toNumberOrDefault(rn.activity), rn.unitActivity)
      ) < rn.MZA;
    },
    onCalcActivity() {
      if (this.isEveryLessMza) {
        this.message = this.messages[0];
        return void 0;
      }
      this.rnAct = 0;
      for (let i = 0; i < this.rnCalc.length; i++) {
        const rn = this.rnCalc[i];
        let D = rn.D_val;
        if (D === "\u043D\u0435\u043E\u0433\u0440\u0430\u043D." || !D) {
          continue;
        }
        const dBk = toNumberOrDefault(D) * 10 ** 12;
        const A = activityToUnit(
          toNumberOrDefault(rn.activity),
          rn.unitActivity
        );
        if (isNumeric(rn.MZA) && A <= rn.MZA) {
          continue;
        }
        let rnMZ = A / dBk;
        if (isNumeric(rnMZ)) {
          this.rnAct += rnMZ;
        }
      }
      if (this.rnAct < 0.01) {
        this.danger = 5;
      } else if (this.rnAct < 1) {
        this.danger = 4;
      } else if (this.rnAct < 10) {
        this.danger = 3;
      } else if (this.rnAct < 1e3) {
        this.danger = 2;
      } else {
        this.danger = 1;
      }
      this.message = this.messages[this.danger];
      return this.rnAct;
    },
    isVisible(item) {
      const rnValue = this.rnValue.toLowerCase();
      if (!rnValue.length) {
        return true;
      }
      return [item.Name_RN, item.Name_RN_Lat].some(
        (x) => toStr(x).toLowerCase().includes(rnValue)
      );
    },
    addRn(item) {
      this.rnCalc.push(copy(item));
      this.rnValue = "";
    },
    removeRn(value) {
      const index = this.rnCalc.findIndex((x) => x.Name_RN_Lat === value);
      if (index !== -1) {
        this.rnCalc.splice(index, 1);
      }
      if (this.rnCalc.length === 0) {
        this.message = "";
      }
    },
    displayResult() {
      this.onCalcActivity();
      copyToClipboard(this.message);
      this.$emit("update:modelValue", this.danger);
    },
    resetCalc() {
      this.rnCalc = [];
      this.rnAct = null;
      this.rnValue = "";
      this.message = "";
    }
  }
});
const _withScopeId$9 = (n) => (pushScopeId("data-v-7537b205"), n = n(), popScopeId(), n);
const _hoisted_1$o = {
  key: 0,
  class: "calc-category-zri"
};
const _hoisted_2$m = { class: "left" };
const _hoisted_3$l = { class: "head" };
const _hoisted_4$j = { class: "list" };
const _hoisted_5$c = ["onClick"];
const _hoisted_6$9 = { class: "right" };
const _hoisted_7$7 = {
  key: 0,
  class: "rn-right-block"
};
const _hoisted_8$2 = { class: "rn-list-block" };
const _hoisted_9$2 = { class: "rn" };
const _hoisted_10$2 = { class: "nuc" };
const _hoisted_11$2 = { style: { "display": "flex", "gap": "3px", "align-items": "center", "height": "100%" } };
const _hoisted_12$1 = { style: { "display": "flex", "gap": "3px", "align-items": "flex-end", "height": "100%" } };
const _hoisted_13$1 = {
  key: 0,
  style: { "margin-top": "10px", "color": "red" }
};
const _hoisted_14$1 = { style: { "display": "flex", "justify-content": "center", "margin-bottom": "10px" } };
const _hoisted_15$1 = {
  key: 0,
  class: "calc-zri-block",
  style: { "display": "flex", "justify-content": "center", "flex-direction": "column", "align-items": "center", "margin-bottom": "10px", "background-color": "#bbd6ee", "border-color": "#002060" }
};
const _hoisted_16 = /* @__PURE__ */ _withScopeId$9(() => /* @__PURE__ */ createElementVNode("h4", { style: { "margin-top": "0" } }, "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442 \u0440\u0430\u0441\u0447\u0435\u0442\u0430 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u0438 \u0417\u0420\u0418", -1));
const _hoisted_17 = ["innerHTML"];
function _sfc_render$x(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ButtonComponent = resolveComponent("ButtonComponent");
  const _component_SearchComponent = resolveComponent("SearchComponent");
  const _component_AttrInputBase = resolveComponent("AttrInputBase");
  const _component_TSelectComponent = resolveComponent("TSelectComponent");
  return _ctx.list !== null ? (openBlock(), createElementBlock("div", _hoisted_1$o, [
    createElementVNode("div", _hoisted_2$m, [
      createElementVNode("div", _hoisted_3$l, [
        createVNode(_component_ButtonComponent, {
          icon: _ctx.ICONS.restoreBlue,
          class: "button-opacity",
          onClick: _ctx.resetCalc
        }, null, 8, ["icon", "onClick"]),
        createVNode(_component_SearchComponent, {
          modelValue: _ctx.rnValue,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.rnValue = $event),
          modelModifiers: { trim: true },
          class: "element",
          "show-reset": "",
          onReset: _cache[1] || (_cache[1] = ($event) => _ctx.rnValue = "")
        }, null, 8, ["modelValue"])
      ]),
      createElementVNode("div", _hoisted_4$j, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.sortRn, (item) => {
          return withDirectives((openBlock(), createElementBlock("p", {
            key: item.Name_RN_Lat,
            class: "nucList",
            onClick: ($event) => _ctx.addRn(item)
          }, [
            createElementVNode("span", null, toDisplayString(item.Name_RN), 1),
            createTextVNode(),
            createElementVNode("span", null, toDisplayString(item.Name_RN_Lat), 1)
          ], 8, _hoisted_5$c)), [
            [vShow, _ctx.isVisible(item)]
          ]);
        }), 128))
      ])
    ]),
    createElementVNode("div", _hoisted_6$9, [
      this.rnCalc.length ? (openBlock(), createElementBlock("div", _hoisted_7$7, [
        createElementVNode("div", _hoisted_8$2, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.rnCalc, (item) => {
            return openBlock(), createElementBlock("div", {
              key: item.ID,
              class: "calc-zri-block rn-root"
            }, [
              createElementVNode("div", _hoisted_9$2, [
                createElementVNode("p", _hoisted_10$2, [
                  createElementVNode("span", null, toDisplayString(item.Name_RN_Lat), 1)
                ]),
                createElementVNode("div", _hoisted_11$2, [
                  createElementVNode("div", _hoisted_12$1, [
                    createVNode(_component_AttrInputBase, {
                      model: _ctx.models.exponential,
                      type: _ctx.ATTRS_TYPES.exponential,
                      value: item.activity,
                      caption: "\u0410\u043A\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u044C",
                      class: "activity",
                      onChange: ($event) => item.activity = $event,
                      onReset: ($event) => item.activity = ""
                    }, null, 8, ["model", "type", "value", "onChange", "onReset"]),
                    createVNode(_component_TSelectComponent, {
                      "model-value": item.unitActivity,
                      options: _ctx.UNITS_ACTIVITY_SELECT,
                      caption: "\u0415\u0434\u0438\u043D\u0438\u0446\u0430 \u0438\u0437\u043C\u0435\u0440\u0435\u043D\u0438\u044F",
                      style: { "width": "190px" },
                      onReset: ($event) => item.unitActivity = "\u0411\u043A",
                      "onUpdate:modelValue": ($event) => item.unitActivity = $event.value
                    }, null, 8, ["model-value", "options", "onReset", "onUpdate:modelValue"])
                  ]),
                  createVNode(_component_ButtonComponent, {
                    icon: _ctx.ICONS.trashCanOutline,
                    class: "button-opacity blue-help-close",
                    onClick: ($event) => _ctx.removeRn(item.Name_RN_Lat)
                  }, null, 8, ["icon", "onClick"])
                ])
              ]),
              !item.D_val || _ctx.toNumberOrUndefined(item.D_val) === 0 ? (openBlock(), createElementBlock("div", _hoisted_13$1, " \u0440\u0430\u0441\u0447\u0451\u0442 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u0438 \u0417\u0420\u0418 \u043D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u0435\u043D ")) : createCommentVNode("", true)
            ]);
          }), 128))
        ]),
        createElementVNode("div", _hoisted_14$1, [
          createVNode(_component_ButtonComponent, {
            disabled: _ctx.isContainsNullD || !_ctx.isEnterActivity,
            class: "form-button",
            "data-type": "accent",
            onClick: _ctx.displayResult
          }, {
            default: withCtx(() => [
              createTextVNode(" \u0420\u0430\u0441\u0441\u0447\u0438\u0442\u0430\u0442\u044C \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044E \u0417\u0420\u0418 ")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]),
        this.message ? (openBlock(), createElementBlock("div", _hoisted_15$1, [
          _hoisted_16,
          createElementVNode("div", {
            style: { "border-radius": "3px", "padding": "1px", "background": "white" },
            innerHTML: this.message
          }, null, 8, _hoisted_17)
        ])) : createCommentVNode("", true)
      ])) : createCommentVNode("", true)
    ])
  ])) : createCommentVNode("", true);
}
var CalcCategoryZri = /* @__PURE__ */ _export_sfc(_sfc_main$x, [["render", _sfc_render$x], ["__scopeId", "data-v-7537b205"]]);
var CalcCategoryZriDemo_vue_vue_type_style_index_0_lang = "";
const _sfc_main$w = defineComponent({
  name: "CalcCategoryZriDemo",
  components: {
    ScreenSpinner,
    ModalComponent,
    CalcCategoryZri,
    CircleLoader,
    ButtonComponent
  },
  data() {
    return {
      init: false
    };
  },
  async created() {
  }
});
const _hoisted_1$n = { class: "light-blue-modal-container rao-category-calc-modal" };
const _hoisted_2$l = /* @__PURE__ */ createElementVNode("div", { class: "light-blue-modal-container-title" }, "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F \u0417\u0420\u0418", -1);
const _hoisted_3$k = { class: "light-blue-modal-container-content calc-category-zri-demo" };
const _hoisted_4$i = { class: "light-blue-modal-container-footer" };
const _hoisted_5$b = /* @__PURE__ */ createElementVNode("div", null, null, -1);
function _sfc_render$w(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ScreenSpinner = resolveComponent("ScreenSpinner");
  const _component_CalcCategoryZri = resolveComponent("CalcCategoryZri");
  const _component_ButtonComponent = resolveComponent("ButtonComponent");
  const _component_ModalComponent = resolveComponent("ModalComponent");
  return openBlock(), createBlock(_component_ModalComponent, {
    isShowBodyCloseButton: true,
    visible: true,
    "body-style": "padding: 0;",
    style: { "width": "100vw" },
    "button-close-style": "right: 10px; top: 10px",
    onClose: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("close"))
  }, {
    body: withCtx(({ close }) => [
      !_ctx.init ? (openBlock(), createBlock(_component_ScreenSpinner, {
        key: 0,
        dimming: false
      })) : createCommentVNode("", true),
      createElementVNode("div", _hoisted_1$n, [
        _hoisted_2$l,
        createElementVNode("div", _hoisted_3$k, [
          withDirectives(createVNode(_component_CalcCategoryZri, {
            onInit: _cache[0] || (_cache[0] = ($event) => _ctx.init = true)
          }, null, 512), [
            [vShow, _ctx.init]
          ])
        ]),
        createElementVNode("div", _hoisted_4$i, [
          _hoisted_5$b,
          createVNode(_component_ButtonComponent, {
            class: "form-button",
            "data-type": "accent",
            onClick: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("close"))
          }, {
            default: withCtx(() => [
              createTextVNode(" \u0417\u0430\u043A\u0440\u044B\u0442\u044C ")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  });
}
var CalcCategoryZriDemo = /* @__PURE__ */ _export_sfc(_sfc_main$w, [["render", _sfc_render$w]]);
const CODE_OYAT_DATA = {
  fuelType: {
    label: "\u0422\u0438\u043F \u0442\u043E\u043F\u043B\u0438\u0432\u0430",
    symbol: [1, 2],
    explanations: {
      "99": "\u043F\u0440\u0438 \u0432\u044B\u0431\u043E\u0440\u0435 \u044D\u0442\u043E\u0433\u043E \u043A\u043E\u0434\u0430 \u0441\u043B\u0435\u0434\u0443\u0435\u0442 \u0432 \u043F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0438 \u0443\u043A\u0430\u0437\u0430\u0442\u044C \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0442\u0438\u043F\u0430 \u041E\u042F\u0422"
    },
    data: {
      "11": "\u041E\u042F\u0422 \u0440\u0435\u0430\u043A\u0442\u043E\u0440\u043E\u0432 \u0420\u0411\u041C\u041A",
      "21": "\u041E\u042F\u0422 \u0440\u0435\u0430\u043A\u0442\u043E\u0440\u043E\u0432 \u0412\u0412\u042D\u0420-440",
      "22": "\u041E\u042F\u0422 \u0440\u0435\u0430\u043A\u0442\u043E\u0440\u043E\u0432 \u0412\u0412\u042D\u0420-1000",
      "23": "\u041E\u042F\u0422 \u0440\u0435\u0430\u043A\u0442\u043E\u0440\u043E\u0432 \u0412\u0412\u042D\u0420-1000 \u0442\u0438\u043F\u0430 \u0422\u0412\u0421\u0410",
      "24": "\u041E\u042F\u0422 \u0440\u0435\u0430\u043A\u0442\u043E\u0440\u043E\u0432 \u0412\u0412\u042D\u0420-1200",
      "31": "\u041E\u042F\u0422 \u0440\u0435\u0430\u043A\u0442\u043E\u0440\u043E\u0432 \u0410\u041C\u0411",
      "41": "\u041E\u042F\u0422 \u0440\u0435\u0430\u043A\u0442\u043E\u0440\u043E\u0432 \u042D\u0413\u041F-6",
      "51": "\u041E\u042F\u0422 \u0438\u0437 \u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0439 \u0437\u043E\u043D\u044B \u0440\u0435\u0430\u043A\u0442\u043E\u0440\u0430 \u0411\u041D-600",
      "52": "\u041E\u042F\u0422 \u0438\u0437 \u0437\u043E\u043D\u044B \u0432\u043E\u0441\u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0441\u0442\u0432\u0430 \u0440\u0435\u0430\u043A\u0442\u043E\u0440\u0430 \u0411\u041D-600",
      "53": "\u041E\u042F\u0422 \u0438\u0437 \u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0439 \u0437\u043E\u043D\u044B \u0440\u0435\u0430\u043A\u0442\u043E\u0440\u0430 \u0411\u041D-800",
      "54": "\u041E\u042F\u0422 \u0438\u0437 \u0437\u043E\u043D\u044B \u0432\u043E\u0441\u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0441\u0442\u0432\u0430 \u0440\u0435\u0430\u043A\u0442\u043E\u0440\u0430 \u0411\u041D-800",
      "61": "\u041E\u042F\u0422 \u0440\u0435\u0430\u043A\u0442\u043E\u0440\u043E\u0432 \u0410\u041F\u041B",
      "62": "\u041E\u042F\u0422 \u0440\u0435\u0430\u043A\u0442\u043E\u0440\u043E\u0432 \u043D\u0430\u0434\u0432\u043E\u0434\u043D\u044B\u0445 \u043A\u043E\u0440\u0430\u0431\u043B\u0435\u0439, \u043B\u0435\u0434\u043E\u043A\u043E\u043B\u043E\u0432",
      "71": "\u041E\u042F\u0422 \u0438\u0441\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u0438\u0445 \u0440\u0435\u0430\u043A\u0442\u043E\u0440\u043E\u0432",
      "99": "\u043F\u0440\u043E\u0447\u0438\u0442\u0435 \u0442\u0438\u043F\u044B \u041E\u042F\u0422"
    }
  },
  fuelCompound: {
    label: "\u0421\u043E\u0441\u0442\u0430\u0432 \u0442\u043E\u043F\u043B\u0438\u0432\u0430",
    symbol: [3],
    explanation: "",
    explanations: {
      "9": "\u043F\u0440\u0438 \u0432\u044B\u0431\u043E\u0440\u0435 \u044D\u0442\u043E\u0433\u043E \u043A\u043E\u0434\u0430 \u0441\u043B\u0435\u0434\u0443\u0435\u0442 \u0432 \u043F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0438 \u0443\u043A\u0430\u0437\u0430\u0442\u044C \u043E\u0442\u043B\u0438\u0447\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u0441\u043E\u0441\u0442\u0430\u0432\u0430 \u041E\u042F\u0422"
    },
    data: {
      "1": "\u0414\u0438\u043E\u043A\u0441\u0438\u0434 \u0443\u0440\u0430\u043D\u0430",
      "2": "\u0423\u0440\u0430\u043D-\u044D\u0440\u0431\u0438\u0435\u0432\u043E\u0435 \u0442\u043E\u043F\u043B\u0438\u0432\u043E",
      "3": "\u0414\u0438\u043E\u043A\u0441\u0438\u0434 \u0443\u0440\u0430\u043D\u0430 \u0441 \u0438\u043D\u0442\u0435\u0433\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u043C\u0438 \u0432\u044B\u0433\u043E\u0440\u0430\u044E\u0449\u0438\u043C \u043F\u043E\u0433\u043B\u043E\u0442\u0438\u0442\u0435\u043B\u0435\u043C \u0432 \u0432\u0438\u0434\u0435 \u043E\u043A\u0441\u0438\u0434\u0430 \u0433\u0430\u0434\u043E\u043B\u0438\u043D\u0438\u044F (\u0422\u0412\u042D\u0413)",
      "4": "\u0421\u043C\u0435\u0448\u0430\u043D\u043D\u044B\u0435 \u0443\u0440\u0430\u043D-\u043F\u043B\u0443\u0442\u043E\u043D\u0438\u0435\u0432\u043E\u0435 \u0442\u043E\u043F\u043B\u0438\u0432\u043E",
      "5": "\u0421\u043F\u043B\u0430\u0432 \u0443\u0440\u0430\u043D\u0430 \u0441 \u0430\u043B\u044E\u043C\u0438\u043D\u0438\u0435\u043C",
      "6": "\u0414\u0438\u043E\u043A\u0441\u0438\u0434 \u0443\u0440\u0430\u043D\u0430 \u0432 \u0430\u043B\u044E\u043C\u0438\u043D\u0438\u0435\u0432\u043E\u0439 \u043C\u0430\u0442\u0440\u0438\u0446\u0435",
      "7": "\u0421\u043F\u043B\u0430\u0432 \u0443\u0440\u0430\u043D\u0430 \u0441 \u043C\u043E\u043B\u0438\u0431\u0434\u0435\u043D\u043E\u043C",
      "8": "\u0414\u0438\u043E\u043A\u0441\u0438\u0434 \u0443\u0440\u0430\u043D\u0430 \u0432 \u043C\u0430\u0442\u0440\u0438\u0446\u0435 \u043C\u0430\u0433\u043D\u0438\u044F",
      "9": "\u0421\u043E\u0441\u0442\u0430\u0432 \u0442\u043E\u043F\u043B\u0438\u0432\u0430, \u043D\u0435 \u043F\u0435\u0440\u0435\u0447\u0438\u0441\u043B\u0435\u043D\u043D\u044B\u0439 \u0432\u044B\u0448\u0435"
    }
  },
  storageType: {
    label: "\u0424\u043E\u0440\u043C\u0430 \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F",
    symbol: [4],
    explanation: "",
    explanations: {
      "9": "\u043F\u0440\u0438 \u0432\u044B\u0431\u043E\u0440\u0435 \u044D\u0442\u043E\u0433\u043E \u043A\u043E\u0434\u0430 \u0441\u043B\u0435\u0434\u0443\u0435\u0442 \u0432 \u043F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0438 \u0434\u0430\u0442\u044C \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0444\u043E\u0440\u043C\u044B \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u041E\u042F\u0422"
    },
    data: {
      "1": "\u041E\u0422\u0412\u0421",
      "2": "\u0424\u0440\u0430\u0433\u043C\u0435\u043D\u0442 \u041E\u0422\u0412\u0421, \u043F\u0443\u0447\u043E\u043A \u0422\u0412\u042D\u041B (\u041F\u0422) \u0420\u0411\u041C\u041A",
      "3": "\u0410\u043A\u0442\u0438\u0432\u043D\u0430\u044F \u0437\u043E\u043D\u0430 \u0432 \u0441\u0431\u043E\u0440\u0435, \u043D\u0435\u0440\u0430\u0437\u0431\u043E\u0440\u043D\u0430\u044F \u0432\u044B\u0435\u043C\u043D\u0430\u044F \u0447\u0430\u0441\u0442\u044C",
      "4": "\u041E\u0442\u0434\u0435\u043B\u044C\u043D\u044B\u0439 \u043E\u0442\u0440\u0430\u0431\u043E\u0442\u0430\u0432\u0448\u0438\u0439 \u0422\u0412\u042D\u041B",
      "5": "\u041E\u0442\u0434\u0435\u043B\u044C\u043D\u044B\u0435 \u0447\u0430\u0441\u0442\u0438 \u0422\u0412\u042D\u041B \u0438\u043B\u0438 \u0438\u0437\u043C\u0435\u043B\u044C\u0447\u0451\u043D\u043D\u044B\u0435 \u0422\u0412\u042D\u041B \u0432 \u043F\u0435\u043D\u0430\u043B\u0435",
      "9": "\u0424\u043E\u0440\u043C\u0430 \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u041E\u042F\u0422, \u043D\u0435 \u043F\u0435\u0440\u0435\u0447\u0438\u0441\u043B\u0435\u043D\u043D\u044B\u0435 \u0432\u044B\u0448\u0435"
    }
  },
  StorageState: {
    label: "\u0421\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0435 \u041E\u0422\u0412\u0421, \u0422\u0412\u042D\u041B, \u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0439 \u0437\u043E\u043D\u044B \u0432 \u0441\u0431\u043E\u0440\u0435",
    symbol: [5],
    explanation: "",
    explanations: {},
    data: {
      "1": "\u0413\u0435\u0440\u043C\u0435\u0442\u0438\u0447\u043D\u043E\u0435",
      "2": "\u041D\u0435\u0433\u0435\u0440\u043C\u0435\u0442\u0438\u0447\u043D\u043E\u0435"
    }
  }
};
const CODE_OYAT_DATA_ARRAY = Object.values(
  CODE_OYAT_DATA
);
var CalcCodeOyat_vue_vue_type_style_index_0_lang = "";
const _sfc_main$v = defineComponent({
  name: "CalcCodeOyat",
  props: {
    modelValue: String
  },
  emits: ["close", "init", "update:modelValue"],
  components: {
    TRadioButton,
    TInputComponent,
    ModalComponent,
    TSelectComponent
  },
  setup() {
    return {
      CALC_CODE_INFO_DATA: CODE_OYAT_DATA,
      CALC_CODE_INFO_DATA_ARRAY: CODE_OYAT_DATA_ARRAY,
      ICONS,
      toStr,
      INIT_CODE_SYMBOL
    };
  },
  data() {
    return {
      formData: this.getInitFormData(),
      codeLength: CALC_PARAMS.CalcCodeOyat.maxSymbols
    };
  },
  created() {
    this.formData.code = this.modelValue || this.formData.code;
    this.updateCalcCode();
    this.$emit("init");
  },
  methods: {
    getInitFormData() {
      return getInitFormDataCalcCodeInfo(
        this.CALC_CODE_INFO_DATA_ARRAY,
        this.codeLength
      );
    },
    onSelected(calcCodeInfo, _key) {
      const result = getCalcCode(
        this.formData.code,
        this.codeLength,
        calcCodeInfo,
        _key
      );
      Object.assign(this.formData, result.formData);
    },
    onResetValue(calcCodeInfo) {
      const key = this.getFormDataKey(calcCodeInfo);
      this.formData[key] = this.getInitFormData()[key];
      this.formData.code = getCalcCodeByFormDataAndCalcCodeInfo(
        calcCodeInfo,
        this.formData,
        this.INIT_CODE_SYMBOL
      );
    },
    onHelp(calcCodeInfo) {
      NotificationsService$1.send({
        type: "info",
        title: calcCodeInfo.label,
        text: calcCodeInfo.explanation
      });
    },
    updateCalcCode() {
      updateFormDataByCalcCode(
        this.CALC_CODE_INFO_DATA_ARRAY,
        this.formData.code,
        this.formData
      );
    },
    getFormDataKey(calcCodeInfo) {
      return calcCodeInfo.symbol.join("_");
    },
    getFormDataValue(calcCodeInfo) {
      return getFormDataValueOrUndefined(
        calcCodeInfo,
        this.formData,
        this.INIT_CODE_SYMBOL
      );
    },
    updateModelValue() {
      this.$emit("update:modelValue", this.newModelValue);
    }
  },
  watch: {
    "formData.code"(code, prevCode) {
      if (this.formData.code.length === this.codeLength && code !== prevCode) {
        this.updateCalcCode();
      }
      if (this.modelValue !== code) {
        this.updateModelValue();
      }
    },
    modelValue(modelValue, prevModelValue) {
      if (modelValue !== prevModelValue && this.formData.code !== modelValue) {
        this.formData.code = this.modelValue || "";
      }
    }
  },
  computed: {
    newModelValue() {
      return this.formData.code;
    }
  }
});
const _hoisted_1$m = { class: "light-blue-modal-container-content" };
const _hoisted_2$k = { style: { "display": "flex", "gap": "24px", "align-items": "center" } };
const _hoisted_3$j = /* @__PURE__ */ createElementVNode("div", {
  class: "app-label-s14-h20-c828",
  style: { "max-width": "200px" }
}, " \u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0434 \u041E\u042F\u0422 \u0432\u0440\u0443\u0447\u043D\u0443\u044E \u0438\u043B\u0438 \u0440\u0430\u0441\u0441\u0447\u0438\u0442\u0430\u0439\u0442\u0435 \u043F\u043E \u0444\u043E\u0440\u043C\u0435 \u043D\u0438\u0436\u0435. ", -1);
const _hoisted_4$h = { class: "root-calc-code-oyat" };
const _hoisted_5$a = { class: "calc-code-oyat-header" };
const _hoisted_6$8 = { style: { "display": "inline-block", "margin-right": "10px" } };
const _hoisted_7$6 = { class: "calc-code-oyat-content" };
function _sfc_render$v(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TInputComponent = resolveComponent("TInputComponent");
  const _component_ButtonComponent = resolveComponent("ButtonComponent");
  const _component_TRadioButton = resolveComponent("TRadioButton");
  return openBlock(), createElementBlock("div", _hoisted_1$m, [
    createElementVNode("div", _hoisted_2$k, [
      createVNode(_component_TInputComponent, {
        modelValue: _ctx.formData.code,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.formData.code = $event),
        "input-style": { width: "150px" },
        "replace-empty-symbol": _ctx.INIT_CODE_SYMBOL,
        "replace-length": _ctx.codeLength,
        caption: "\u041A\u043E\u0434 \u041E\u042F\u0422",
        onReset: _cache[1] || (_cache[1] = ($event) => _ctx.formData.code = _ctx.getInitFormData().code)
      }, null, 8, ["modelValue", "replace-empty-symbol", "replace-length"]),
      _hoisted_3$j
    ]),
    createElementVNode("div", _hoisted_4$h, [
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.CALC_CODE_INFO_DATA_ARRAY, (calcCodeInfo, i) => {
        return openBlock(), createElementBlock("div", {
          key: calcCodeInfo.label,
          class: "calc-code-oyat"
        }, [
          createElementVNode("div", _hoisted_5$a, [
            createElementVNode("div", null, [
              createElementVNode("span", _hoisted_6$8, toDisplayString(calcCodeInfo.symbol.join(", ")) + " \u0441\u0438\u043C\u0432\u043E\u043B:", 1),
              createTextVNode(" " + toDisplayString(calcCodeInfo.label), 1)
            ]),
            calcCodeInfo.explanation ? (openBlock(), createBlock(_component_ButtonComponent, {
              key: 0,
              icon: _ctx.ICONS.faq,
              class: "button-opacity",
              onClick: ($event) => _ctx.onHelp(calcCodeInfo)
            }, null, 8, ["icon", "onClick"])) : createCommentVNode("", true)
          ]),
          createElementVNode("div", _hoisted_7$6, [
            createVNode(_component_TRadioButton, {
              data: calcCodeInfo.data,
              footerHelp: calcCodeInfo.explanations[_ctx.getFormDataValue(calcCodeInfo)],
              "is-view-key": true,
              "model-value": _ctx.getFormDataValue(calcCodeInfo),
              "onUpdate:modelValue": ($event) => _ctx.onSelected(calcCodeInfo, $event)
            }, null, 8, ["data", "footerHelp", "model-value", "onUpdate:modelValue"])
          ])
        ]);
      }), 128))
    ])
  ]);
}
var CalcCodeOyat = /* @__PURE__ */ _export_sfc(_sfc_main$v, [["render", _sfc_render$v]]);
var CalcCodeOyatDemo_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$u = defineComponent({
  name: "CalcCodeOyatDemo",
  emits: ["close"],
  components: {
    TRadioButton,
    TInputComponent,
    ModalComponent,
    CalcCodeOyat,
    TSelectComponent
  },
  setup() {
    return {
      CALC_PARAMS
    };
  },
  data() {
    return {};
  },
  created() {
  },
  methods: {},
  watch: {},
  computed: {}
});
const _withScopeId$8 = (n) => (pushScopeId("data-v-eaf29402"), n = n(), popScopeId(), n);
const _hoisted_1$l = { class: "light-blue-modal-container calc-oyat-modal" };
const _hoisted_2$j = { class: "light-blue-modal-container-title" };
const _hoisted_3$i = { class: "light-blue-modal-container-footer" };
const _hoisted_4$g = /* @__PURE__ */ _withScopeId$8(() => /* @__PURE__ */ createElementVNode("div", null, null, -1));
function _sfc_render$u(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CalcCodeOyat = resolveComponent("CalcCodeOyat");
  const _component_ButtonComponent = resolveComponent("ButtonComponent");
  const _component_ModalComponent = resolveComponent("ModalComponent");
  return openBlock(), createBlock(_component_ModalComponent, {
    isShowBodyCloseButton: true,
    visible: true,
    "content-style": "overflow: auto;",
    "body-style": "padding: 0px;",
    style: { "min-width": "600px", "width": "100vw" },
    "button-close-style": "right: 10px; top: 10px",
    onClose: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("close"))
  }, {
    body: withCtx(() => [
      createElementVNode("div", _hoisted_1$l, [
        createElementVNode("div", _hoisted_2$j, toDisplayString(_ctx.CALC_PARAMS.CalcCodeOyat.header), 1),
        createVNode(_component_CalcCodeOyat)
      ]),
      createElementVNode("div", _hoisted_3$i, [
        _hoisted_4$g,
        createVNode(_component_ButtonComponent, {
          class: "form-button",
          "data-type": "accent",
          onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("close"))
        }, {
          default: withCtx(() => [
            createTextVNode(" \u0417\u0430\u043A\u0440\u044B\u0442\u044C ")
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  });
}
var CalcCodeOyatDemo = /* @__PURE__ */ _export_sfc(_sfc_main$u, [["render", _sfc_render$u], ["__scopeId", "data-v-eaf29402"]]);
const CODE_TERRITORY_DATA = {
  territoryType: {
    label: "\u0412\u0438\u0434",
    symbol: [1],
    explanations: {},
    data: {
      "1": "\u0423\u0447\u0430\u0441\u0442\u043E\u043A \u0437\u0435\u043C\u043B\u0438",
      "2": "\u0412\u043E\u0434\u043D\u044B\u0439 \u043E\u0431\u044A\u0435\u043A\u0442"
    }
  },
  territoryZone: {
    label: "\u0417\u043E\u043D\u0430 \u043D\u0430\u0445\u043E\u0436\u0434\u0435\u043D\u0438\u044F",
    symbol: [2],
    explanation: "",
    explanations: {},
    data: {
      "1": "\u041F\u0440\u043E\u043C\u043F\u043B\u043E\u0449\u0430\u0434\u043A\u0430",
      "2": "C\u0430\u043D\u0438\u0442\u0430\u0440\u043D\u043E-\u0437\u0430\u0449\u0438\u0442\u043D\u0430\u044F \u0437\u043E\u043D\u0430",
      "3": "\u0417\u043E\u043D\u0430 \u043D\u0430\u0431\u043B\u044E\u0434\u0435\u043D\u0438\u044F"
    }
  },
  territoryDozeRate: {
    label: "\u0414\u0438\u0430\u043F\u0430\u0437\u043E\u043D \u043F\u043E \u043C\u043E\u0449\u043D\u043E\u0441\u0442\u0438 \u0434\u043E\u0437\u044B",
    symbol: [3],
    explanation: "",
    explanations: {},
    data: {
      "0": "\u0434\u043E 0,3 \u043C\u0417\u0432/\u0433\u043E\u0434 \u0432\u043A\u043B\u044E\u0447\u0438\u0442\u0435\u043B\u044C\u043D\u043E (\u2264 0,036 \u043C\u043A\u0417\u0432/\u0447\u0430\u0441)",
      "1": "\u043E\u0442 0,3 \u0434\u043E 1,0 \u043C\u0417\u0432 /\u0433\u043E\u0434 \u0432\u043A\u043B\u044E\u0447\u0438\u0442\u0435\u043B\u044C\u043D\u043E (\u043E\u0442 0,036 \u0434\u043E \u2264 0,12 \u043C\u043A\u0417\u0432/\u0447\u0430\u0441)",
      "2": "\u043E\u0442 1,0 \u0434\u043E 5,0 \u043C\u0417\u0432/\u0433\u043E\u0434 \u0432\u043A\u043B\u044E\u0447\u0438\u0442\u0435\u043B\u044C\u043D\u043E (\u043E\u0442 0,12 \u0434\u043E \u2264 0,6 \u043C\u043A\u0417\u0432/\u0447\u0430\u0441)",
      "3": "\u043E\u0442 5,0 \u0434\u043E 20,0 \u043C\u0417\u0432/\u0433\u043E\u0434 \u0432\u043A\u043B\u044E\u0447\u0438\u0442\u0435\u043B\u044C\u043D\u043E (\u043E\u0442 0,6 \u0434\u043E \u2264 2,4 \u043C\u043A\u0417\u0432/\u0447\u0430\u0441)",
      "4": "\u043E\u0442 20,0 \u0434\u043E 50,0 \u043C\u0417\u0432/\u0433\u043E\u0434 \u0432\u043A\u043B\u044E\u0447\u0438\u0442\u0435\u043B\u044C\u043D\u043E (\u043E\u0442 2,4 \u0434\u043E \u2264 6,0 \u043C\u043A\u0417\u0432/\u0447\u0430\u0441)",
      "5": "\u043E\u0442 50 (\u0431\u043E\u043B\u0435\u0435 6.0 \u043C\u043A\u0417\u0432/\u0447\u0430\u0441)"
    }
  },
  territoryCategory: {
    label: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u0438 \u0437\u0435\u043C\u0435\u043B\u044C \u043F\u043E \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044E",
    symbol: [4],
    explanation: "",
    explanations: {
      "9": "\u043F\u0440\u0438 \u0432\u044B\u0431\u043E\u0440\u0435 \u044D\u0442\u043E\u0433\u043E \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0430 \u0441\u043B\u0435\u0434\u0443\u0435\u0442 \u0434\u0430\u0442\u044C \u043F\u043E\u044F\u0441\u043D\u0435\u043D\u0438\u044F \u0432 \u043F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0438 \u043E\u0442\u043D\u043E\u0441\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F \u0437\u0435\u043C\u0435\u043B\u044C"
    },
    data: {
      "1": "\u0417\u0435\u043C\u043B\u0438 \u043F\u0440\u043E\u043C\u044B\u0448\u043B\u0435\u043D\u043D\u043E\u0441\u0442\u0438, \u044D\u043D\u0435\u0440\u0433\u0435\u0442\u0438\u043A\u0438, \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0430, \u0441\u0432\u044F\u0437\u0438, \u0440\u0430\u0434\u0438\u043E\u0432\u0435\u0449\u0430\u043D\u0438\u044F, \u0442\u0435\u043B\u0435\u0432\u0438\u0434\u0435\u043D\u0438\u044F, \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0442\u0438\u043A\u0438, \u0437\u0435\u043C\u043B\u0438 \u0434\u043B\u044F \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u044F \u043A\u043E\u0441\u043C\u0438\u0447\u0435\u0441\u043A\u043E\u0439 \u0434\u0435\u044F\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0438, \u0437\u0435\u043C\u043B\u0438 \u043E\u0431\u043E\u0440\u043E\u043D\u044B, \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438 \u0438 \u0437\u0435\u043C\u043B\u0438 \u0438\u043D\u043E\u0433\u043E \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F",
      "2": "\u0417\u0435\u043C\u043B\u0438 \u043D\u0430\u0441\u0435\u043B\u0451\u043D\u043D\u044B\u0445 \u043F\u0443\u043D\u043A\u0442\u043E\u0432",
      "3": "\u0417\u0435\u043C\u043B\u0438 \u0441\u0435\u043B\u044C\u0441\u043A\u043E\u0445\u043E\u0437\u044F\u0439\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0433\u043E \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F",
      "4": "\u0417\u0435\u043C\u043B\u0438 \u043B\u0435\u0441\u043D\u043E\u0433\u043E \u0444\u043E\u043D\u0434\u0430",
      "5": "\u0417\u0435\u043C\u043B\u0438 \u0432\u043E\u0434\u043D\u043E\u0433\u043E \u0444\u043E\u043D\u0434\u0430",
      "6": "\u0417\u0435\u043C\u043B\u0438 \u043F\u0440\u0438\u0440\u043E\u0434\u043E\u043E\u0445\u0440\u0430\u043D\u043D\u043E\u0433\u043E \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F",
      "7": "\u0417\u0435\u043C\u043B\u0438 \u0437\u0430\u043F\u0430\u0441\u0430",
      "9": "\u041F\u0440\u043E\u0447\u0435\u0435"
    }
  },
  dirtReason: {
    label: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430 \u0432\u043E\u0437\u043D\u0438\u043A\u043D\u043E\u0432\u0435\u043D\u0438\u044F \u0437\u0430\u0433\u0440\u044F\u0437\u043D\u0435\u043D\u043D\u043E\u0439 \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u0438",
    symbol: [5],
    explanation: "",
    explanations: {
      "9": "\u043F\u0440\u0438 \u0432\u044B\u0431\u043E\u0440\u0435 \u044D\u0442\u043E\u0433\u043E \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0430 \u0441\u043B\u0435\u0434\u0443\u0435\u0442 \u0434\u0430\u0442\u044C \u043F\u043E\u044F\u0441\u043D\u0435\u043D\u0438\u044F \u0432 \u043F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0438"
    },
    data: {
      "0": "\u041D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u0430\u044F (\u043D\u0435 \u0432\u044B\u044F\u0441\u043D\u0435\u043D\u043D\u0430\u044F \u0434\u043E \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0432\u0440\u0435\u043C\u0435\u043D\u0438)",
      "1": "\u0420\u0435\u0433\u043B\u0430\u043C\u0435\u043D\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u0430\u044F \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0441\u0442\u0432\u0435\u043D\u043D\u0430\u044F \u0434\u0435\u044F\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C",
      "2": "\u041D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u044F \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u043E\u043C \u043F\u0440\u0430\u0432\u0438\u043B \u0440\u0430\u0431\u043E\u0442\u044B (\u044D\u043A\u0441\u043F\u043B\u0443\u0430\u0442\u0430\u0446\u0438\u0438 \u043E\u0431\u043E\u0440\u0443\u0434\u043E\u0432\u0430\u043D\u0438\u044F)",
      "3": "\u0410\u0432\u0430\u0440\u0438\u044F",
      "4": "\u0418\u0441\u043F\u044B\u0442\u0430\u043D\u0438\u044F, \u0432\u0437\u0440\u044B\u0432\u044B",
      "5": "\u0412\u044B\u044F\u0432\u043B\u0435\u043D\u043D\u044B\u0435 \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u0438 \u0441\u0442\u0430\u0440\u044B\u0445 \u0437\u0430\u0445\u043E\u0440\u043E\u043D\u0435\u043D\u0438\u0439",
      "6": "\u0414\u0435\u0444\u0435\u043A\u0442\u044B \u0438\u043B\u0438 \u0441\u0442\u0430\u0440\u0435\u043D\u0438\u0435 \u043E\u0431\u043E\u0440\u0443\u0434\u043E\u0432\u0430\u043D\u0438\u044F",
      "9": "\u041F\u0440\u043E\u0447\u0435\u0435"
    }
  },
  recovery: {
    label: "\u0420\u0435\u0430\u0431\u0438\u043B\u0438\u0442\u0430\u0446\u0438\u0438",
    symbol: [6],
    explanation: "",
    explanations: {
      "9": "\u043F\u0440\u0438 \u0432\u044B\u0431\u043E\u0440\u0435 \u044D\u0442\u043E\u0433\u043E \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0430 \u0441\u043B\u0435\u0434\u0443\u0435\u0442 \u0434\u0430\u0442\u044C \u043F\u043E\u044F\u0441\u043D\u0435\u043D\u0438\u044F \u0432 \u043F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0438 \u043E\u0442\u043D\u043E\u0441\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0446\u0435\u043B\u0435\u0439 \u0440\u0435\u0430\u0431\u0438\u043B\u0438\u0442\u0430\u0446\u0438\u0438"
    },
    data: {
      "0": "\u0420\u0435\u0430\u0431\u0438\u043B\u0438\u0442\u0430\u0446\u0438\u044F \u043D\u0435 \u043F\u0440\u043E\u0432\u043E\u0434\u0438\u043B\u0430\u0441\u044C",
      "1": "\u0420\u0435\u0430\u0431\u0438\u043B\u0438\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u043E \u043F\u043E\u0434 \u0441\u0435\u043B\u044C\u0441\u043A\u043E\u0445\u043E\u0437\u044F\u0439\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0435 \u0443\u0433\u043E\u0434\u044C\u044F",
      "2": "\u0420\u0435\u0430\u0431\u0438\u043B\u0438\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u043E \u043F\u043E\u0434 \u043B\u0435\u0441\u043D\u044B\u0435 \u043D\u0430\u0441\u0430\u0436\u0434\u0435\u043D\u0438\u044F",
      "3": "\u0420\u0435\u0430\u0431\u0438\u043B\u0438\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u043E \u043F\u043E\u0434 \u043F\u0440\u043E\u043C\u044B\u0448\u043B\u0435\u043D\u043D\u043E\u0435 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E",
      "4": "\u0420\u0435\u0430\u0431\u0438\u043B\u0438\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u043E \u043F\u043E\u0434 \u0441\u0435\u043B\u044C\u0441\u043A\u043E\u0445\u043E\u0437\u044F\u0439\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0435 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E",
      "5": "\u0420\u0435\u0430\u0431\u0438\u043B\u0438\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u043E \u043F\u043E\u0434 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E \u0434\u043E\u0440\u043E\u0433",
      "6": "\u0420\u0435\u0430\u0431\u0438\u043B\u0438\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u043E \u0434\u043B\u044F \u0441\u0430\u043D\u0438\u0442\u0430\u0440\u043D\u043E-\u0433\u0438\u0433\u0438\u0435\u043D\u0438\u0447\u0435\u0441\u043A\u043E\u0433\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F",
      "7": "\u041D\u0430\u0445\u043E\u0434\u0438\u0442\u0441\u044F \u0432 \u0441\u0442\u0430\u0434\u0438\u0438 \u0440\u0435\u0430\u0431\u0438\u043B\u0438\u0442\u0430\u0446\u0438\u0438",
      "8": "\u0420\u0435\u0430\u0431\u0438\u043B\u0438\u0442\u0430\u0446\u0438\u044F \u043D\u0435 \u043F\u0440\u043E\u0432\u043E\u0434\u0438\u043B\u0430\u0441\u044C, \u043D\u043E \u0432 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0435 \u043E\u0431\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u043D\u0438\u0439 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u044B \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0441\u0442\u0435\u043F\u0435\u043D\u0438 \u0437\u0430\u0433\u0440\u044F\u0437\u043D\u0435\u043D\u0438\u044F",
      "9": "\u0420\u0435\u0430\u0431\u0438\u043B\u0438\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u043E \u0434\u043B\u044F \u0434\u0440\u0443\u0433\u0438\u0445 \u0446\u0435\u043B\u0435\u0439"
    }
  }
};
const CODE_TERRITORY_DATA_ARRAY = Object.values(
  CODE_TERRITORY_DATA
);
var CalcCodeTerritory_vue_vue_type_style_index_0_lang = "";
const _sfc_main$t = defineComponent({
  name: "CalcCodeTerritory",
  props: {
    modelValue: Object
  },
  emits: ["init", "close", "update:modelValue"],
  components: {
    TRadioButton,
    TInputComponent,
    TSelectComponent
  },
  setup() {
    return {
      CALC_CODE_INFO_DATA: CODE_TERRITORY_DATA,
      CALC_CODE_INFO_DATA_ARRAY: CODE_TERRITORY_DATA_ARRAY,
      ICONS,
      toStr,
      INIT_CODE_SYMBOL
    };
  },
  data() {
    return {
      formData: this.getInitFormData(),
      codeLength: CALC_PARAMS.CalcCodeTerritory.maxSymbols,
      initSymbol: "_"
    };
  },
  created() {
    this.formData.code = this.modelValue || this.formData.code;
    this.updateCalcCode();
    this.$emit("init");
  },
  methods: {
    getInitFormData() {
      return getInitFormDataCalcCodeInfo(
        this.CALC_CODE_INFO_DATA_ARRAY,
        this.codeLength,
        this.initSymbol
      );
    },
    onSelected(calcCodeInfo, _key) {
      const result = getCalcCode(
        this.formData.code,
        this.codeLength,
        calcCodeInfo,
        _key,
        this.initSymbol
      );
      Object.assign(this.formData, result.formData);
    },
    onResetValue(calcCodeInfo) {
      const key = this.getFormDataKey(calcCodeInfo);
      this.formData[key] = this.getInitFormData()[key];
      this.formData.code = getCalcCodeByFormDataAndCalcCodeInfo(
        calcCodeInfo,
        this.formData,
        this.INIT_CODE_SYMBOL
      );
    },
    onHelp(calcCodeInfo) {
      NotificationsService$1.send({
        type: "info",
        title: calcCodeInfo.label,
        text: calcCodeInfo.explanation
      });
    },
    updateCalcCode() {
      updateFormDataByCalcCode(
        this.CALC_CODE_INFO_DATA_ARRAY,
        this.formData.code,
        this.formData
      );
    },
    getFormDataKey(calcCodeInfo) {
      return calcCodeInfo.symbol.join("_");
    },
    getFormDataValue(calcCodeInfo) {
      return getFormDataValueOrUndefined(
        calcCodeInfo,
        this.formData,
        this.INIT_CODE_SYMBOL
      );
    },
    updateModelValue() {
      this.$emit("update:modelValue", this.newModelValue);
    }
  },
  watch: {
    "formData.code"(code, prevCode) {
      if (this.formData.code.length === this.codeLength && code !== prevCode) {
        this.updateCalcCode();
      }
      if (this.modelValue !== code) {
        this.updateModelValue();
      }
    },
    modelValue(modelValue, prevModelValue) {
      if (modelValue !== prevModelValue && this.formData.code !== modelValue) {
        this.formData.code = this.modelValue || "";
      }
    }
  },
  computed: {
    newModelValue() {
      return this.formData.code;
    }
  }
});
const _hoisted_1$k = { class: "light-blue-modal-container-content" };
const _hoisted_2$i = { style: { "display": "flex", "gap": "24px", "align-items": "center" } };
const _hoisted_3$h = /* @__PURE__ */ createElementVNode("div", {
  class: "app-label-s14-h20-c828",
  style: { "max-width": "200px" }
}, " \u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0434 \u0443\u0447\u0430\u0441\u0442\u043A\u0430 \u0432\u0440\u0443\u0447\u043D\u0443\u044E \u0438\u043B\u0438 \u0440\u0430\u0441\u0441\u0447\u0438\u0442\u0430\u0439\u0442\u0435 \u043F\u043E \u0444\u043E\u0440\u043C\u0435 \u043D\u0438\u0436\u0435. ", -1);
const _hoisted_4$f = { class: "root-calc-code-territory" };
const _hoisted_5$9 = { class: "calc-code-territory-header" };
const _hoisted_6$7 = { style: { "display": "inline-block", "margin-right": "10px" } };
const _hoisted_7$5 = { class: "calc-code-territory-content" };
function _sfc_render$t(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TInputComponent = resolveComponent("TInputComponent");
  const _component_ButtonComponent = resolveComponent("ButtonComponent");
  const _component_TRadioButton = resolveComponent("TRadioButton");
  return openBlock(), createElementBlock("div", _hoisted_1$k, [
    createElementVNode("div", _hoisted_2$i, [
      createVNode(_component_TInputComponent, {
        modelValue: _ctx.formData.code,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.formData.code = $event),
        "input-style": { width: "150px" },
        "replace-empty-symbol": _ctx.INIT_CODE_SYMBOL,
        "replace-length": _ctx.codeLength,
        caption: "\u041A\u043E\u0434 \u0443\u0447\u0430\u0441\u0442\u043A\u0430",
        onReset: _cache[1] || (_cache[1] = ($event) => _ctx.formData.code = _ctx.getInitFormData().code)
      }, null, 8, ["modelValue", "replace-empty-symbol", "replace-length"]),
      _hoisted_3$h
    ]),
    createElementVNode("div", _hoisted_4$f, [
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.CALC_CODE_INFO_DATA_ARRAY, (calcCodeInfo, i) => {
        return openBlock(), createElementBlock("div", {
          key: calcCodeInfo.label,
          class: "calc-code-territory"
        }, [
          createElementVNode("div", _hoisted_5$9, [
            createElementVNode("div", null, [
              createElementVNode("span", _hoisted_6$7, toDisplayString(calcCodeInfo.symbol.join(", ")) + " \u0441\u0438\u043C\u0432\u043E\u043B:", 1),
              createTextVNode(" " + toDisplayString(calcCodeInfo.label), 1)
            ]),
            calcCodeInfo.explanation ? (openBlock(), createBlock(_component_ButtonComponent, {
              key: 0,
              icon: _ctx.ICONS.faq,
              class: "button-opacity",
              onClick: ($event) => _ctx.onHelp(calcCodeInfo)
            }, null, 8, ["icon", "onClick"])) : createCommentVNode("", true)
          ]),
          createElementVNode("div", _hoisted_7$5, [
            createVNode(_component_TRadioButton, {
              data: calcCodeInfo.data,
              footerHelp: calcCodeInfo.explanations[_ctx.getFormDataValue(calcCodeInfo)],
              "is-view-key": true,
              "model-value": _ctx.getFormDataValue(calcCodeInfo),
              "onUpdate:modelValue": ($event) => _ctx.onSelected(calcCodeInfo, $event)
            }, null, 8, ["data", "footerHelp", "model-value", "onUpdate:modelValue"])
          ])
        ]);
      }), 128))
    ])
  ]);
}
var CalcCodeTerritory = /* @__PURE__ */ _export_sfc(_sfc_main$t, [["render", _sfc_render$t]]);
var CalcCodeTerritoryDemo_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$s = defineComponent({
  name: "CalcCodeTerritoryDemo",
  emits: ["close"],
  components: {
    ModalComponent,
    CalcCodeTerritory
  }
});
const _withScopeId$7 = (n) => (pushScopeId("data-v-023a4e89"), n = n(), popScopeId(), n);
const _hoisted_1$j = { class: "light-blue-modal-container calc-territory-modal" };
const _hoisted_2$h = /* @__PURE__ */ _withScopeId$7(() => /* @__PURE__ */ createElementVNode("div", { class: "light-blue-modal-container-title" }, " \u041A\u043E\u0434 \u0437\u0430\u0433\u0440\u044F\u0437\u043D\u0451\u043D\u043D\u043E\u0433\u043E \u0440\u0430\u0434\u0438\u043E\u043D\u0443\u043A\u043B\u0438\u0434\u0430\u043C\u0438 \u0443\u0447\u0430\u0441\u0442\u043A\u0430 \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u0438 ", -1));
const _hoisted_3$g = { class: "light-blue-modal-container-footer" };
const _hoisted_4$e = /* @__PURE__ */ _withScopeId$7(() => /* @__PURE__ */ createElementVNode("div", null, null, -1));
function _sfc_render$s(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CalcCodeTerritory = resolveComponent("CalcCodeTerritory");
  const _component_ButtonComponent = resolveComponent("ButtonComponent");
  const _component_ModalComponent = resolveComponent("ModalComponent");
  return openBlock(), createBlock(_component_ModalComponent, {
    isShowBodyCloseButton: true,
    visible: true,
    "content-style": "overflow: auto;",
    "body-style": "padding: 0px;",
    style: { "min-width": "600px", "width": "100vw" },
    "button-close-style": "right: 10px; top: 10px",
    onClose: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("close"))
  }, {
    body: withCtx(() => [
      createElementVNode("div", _hoisted_1$j, [
        _hoisted_2$h,
        createVNode(_component_CalcCodeTerritory)
      ]),
      createElementVNode("div", _hoisted_3$g, [
        _hoisted_4$e,
        createVNode(_component_ButtonComponent, {
          class: "form-button",
          "data-type": "accent",
          onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("close"))
        }, {
          default: withCtx(() => [
            createTextVNode(" \u0417\u0430\u043A\u0440\u044B\u0442\u044C ")
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  });
}
var CalcCodeTerritoryDemo = /* @__PURE__ */ _export_sfc(_sfc_main$s, [["render", _sfc_render$s], ["__scopeId", "data-v-023a4e89"]]);
const CODE_RECEIVER_DATA = {
  receiverType: {
    label: "\u0412\u0438\u0434 \u043F\u0440\u0438\u0451\u043C\u043D\u0438\u043A\u0430",
    symbol: [1, 2],
    explanations: {
      "99": "\u043F\u0440\u0438 \u0432\u044B\u0431\u043E\u0440\u0435 \u044D\u0442\u043E\u0433\u043E \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0430 \u0441\u043B\u0435\u0434\u0443\u0435\u0442 \u0434\u0430\u0442\u044C \u043F\u043E\u044F\u0441\u043D\u0435\u043D\u0438\u044F \u0432 \u043F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0438"
    },
    data: {
      "10": "\u041E\u043A\u0435\u0430\u043D, \u043C\u043E\u0440\u0435",
      "20": "\u0420\u0435\u043A\u0430",
      "21": "\u0420\u0435\u043A\u0430 \u043F\u0435\u0440\u0435\u0441\u044B\u0445\u0430\u044E\u0449\u0430\u044F",
      "30": "\u041E\u0437\u0435\u0440\u043E",
      "31": "\u0411\u043E\u043B\u043E\u0442\u043E",
      "40": "\u0412\u043E\u0434\u043E\u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0435 \u0440\u0443\u0441\u043B\u043E\u0432\u043E\u0435, \u043F\u0440\u0443\u0434 \u0440\u0443\u0441\u043B\u043E\u0432\u043E\u0439",
      "41": "\u0412\u043E\u0434\u043E\u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0435 \u043D\u0430\u043B\u0438\u0432\u043D\u043E\u0435, \u043F\u0440\u0443\u0434 \u043D\u0430\u043B\u0438\u0432\u043D\u043E\u0439",
      "50": "\u041A\u0430\u043D\u0430\u043B \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441\u043D\u043E\u0433\u043E \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F",
      "60": "\u041F\u043E\u0434\u0437\u0435\u043C\u043D\u044B\u0439 \u0432\u043E\u0434\u043D\u044B\u0439 \u043E\u0431\u044A\u0435\u043A\u0442",
      "61": "\u0428\u0430\u0445\u0442\u0430, \u0440\u0443\u0434\u043D\u0438\u043A, \u043D\u0435\u0444\u0442\u0435\u043F\u0440\u043E\u043C\u044B\u0441\u0435\u043B, \u043A\u0430\u0440\u044C\u0435\u0440",
      "81": "\u041D\u0430\u043A\u043E\u043F\u0438\u0442\u0435\u043B\u0438",
      "82": "\u0420\u0435\u043B\u044C\u0435\u0444 \u043C\u0435\u0441\u0442\u043D\u043E\u0441\u0442\u0438",
      "83": "\u041F\u043E\u043B\u044F \u0444\u0438\u043B\u044C\u0442\u0440\u0430\u0446\u0438\u0438",
      "91": "\u0421\u0435\u0442\u0438 \u043A\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0438",
      "92": "\u041B\u0438\u0432\u043D\u0435\u0432\u043E\u0439 \u043A\u043E\u043B\u043B\u0435\u043A\u0442\u043E\u0440",
      "99": "\u041F\u0440\u043E\u0447\u0435\u0435"
    }
  },
  isolation: {
    label: "\u0418\u0437\u043E\u043B\u044F\u0446\u0438\u044F \u043E\u0442 \u043F\u0440\u043E\u0447\u0438\u0445 \u0432\u043E\u0434\u043D\u044B\u0445 \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432",
    symbol: [3],
    explanation: "",
    explanations: {
      "1": "\u0432\u043E\u0434\u043D\u044B\u0439 \u043E\u0431\u044A\u0435\u043A\u0442, \u0438\u0437 \u043A\u043E\u0442\u043E\u0440\u043E\u0433\u043E \u043D\u0435 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0441\u0442\u043E\u043A \u0447\u0435\u0440\u0435\u0437 \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0435 \u0432\u043E\u0434\u043E\u0435\u043C\u044B \u0438 \u0432\u043E\u0434\u043E\u0442\u043E\u043A\u0438 \u0432 \u043C\u043E\u0440\u0435 \u0438\u043B\u0438 \u043E\u0437\u0435\u0440\u043E",
      "2": "\u0432\u043E\u0434\u043D\u044B\u0439 \u043E\u0431\u044A\u0435\u043A\u0442, \u0438\u0437 \u043A\u043E\u0442\u043E\u0440\u043E\u0433\u043E \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0441\u0442\u043E\u043A \u0447\u0435\u0440\u0435\u0437 \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0435 \u0432\u043E\u0434\u043E\u0435\u043C\u044B \u0438 \u0432\u043E\u0434\u043E\u0442\u043E\u043A\u0438 \u0432 \u043C\u043E\u0440\u0435 \u0438\u043B\u0438 \u043E\u0437\u0435\u0440\u043E",
      "9": "\u043F\u0440\u0438 \u0432\u044B\u0431\u043E\u0440\u0435 \u044D\u0442\u043E\u0433\u043E \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0430 \u0441\u043B\u0435\u0434\u0443\u0435\u0442 \u0434\u0430\u0442\u044C \u043F\u043E\u044F\u0441\u043D\u0435\u043D\u0438\u044F \u0432 \u043F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0438"
    },
    data: {
      "1": "\u0418\u0437\u043E\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u0432\u043E\u0434\u043D\u044B\u0439 \u043E\u0431\u044A\u0435\u043A\u0442",
      "2": "\u041D\u0435\u0438\u0437\u043E\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u043E\u0431\u044A\u0435\u043A\u0442",
      "9": "\u041F\u0440\u043E\u0447\u0435\u0435"
    }
  }
};
const CODE_RECEIVER_DATA_ARRAY = Object.values(
  CODE_RECEIVER_DATA
);
var CalcCodeWasteWaterReceiver_vue_vue_type_style_index_0_lang = "";
const _sfc_main$r = defineComponent({
  name: "CalcCodeWasteWaterReceiver",
  props: {
    modelValue: String
  },
  emits: ["close", "init", "update:modelValue"],
  components: {
    TRadioButton,
    TInputComponent,
    ModalComponent,
    TSelectComponent
  },
  setup() {
    return {
      CALC_CODE_INFO_DATA: CODE_RECEIVER_DATA,
      CALC_CODE_INFO_DATA_ARRAY: CODE_RECEIVER_DATA_ARRAY,
      ICONS,
      toStr,
      INIT_CODE_SYMBOL
    };
  },
  data() {
    return {
      formData: this.getInitFormData(),
      codeLength: CALC_PARAMS.CalcCodeWasteWaterReceiver.maxSymbols
    };
  },
  created() {
    this.formData.code = this.modelValue || this.formData.code;
    this.updateCalcCode();
    this.$emit("init");
  },
  methods: {
    getInitFormData() {
      return getInitFormDataCalcCodeInfo(
        this.CALC_CODE_INFO_DATA_ARRAY,
        this.codeLength
      );
    },
    onSelected(calcCodeInfo, _key) {
      const result = getCalcCode(
        this.formData.code,
        this.codeLength,
        calcCodeInfo,
        _key
      );
      Object.assign(this.formData, result.formData);
    },
    onResetValue(calcCodeInfo) {
      const key = this.getFormDataKey(calcCodeInfo);
      this.formData[key] = this.getInitFormData()[key];
      this.formData.code = getCalcCodeByFormDataAndCalcCodeInfo(
        calcCodeInfo,
        this.formData,
        this.INIT_CODE_SYMBOL
      );
    },
    onHelp(calcCodeInfo) {
      NotificationsService$1.send({
        type: "info",
        title: calcCodeInfo.label,
        text: calcCodeInfo.explanation
      });
    },
    updateCalcCode() {
      updateFormDataByCalcCode(
        this.CALC_CODE_INFO_DATA_ARRAY,
        this.formData.code,
        this.formData
      );
    },
    getFormDataKey(calcCodeInfo) {
      return calcCodeInfo.symbol.join("_");
    },
    getFormDataValue(calcCodeInfo) {
      return getFormDataValueOrUndefined(
        calcCodeInfo,
        this.formData,
        this.INIT_CODE_SYMBOL
      );
    },
    updateModelValue() {
      this.$emit("update:modelValue", this.newModelValue);
    }
  },
  watch: {
    "formData.code"(code, prevCode) {
      if (this.formData.code.length === this.codeLength && code !== prevCode) {
        this.updateCalcCode();
      }
      if (this.modelValue !== code) {
        this.updateModelValue();
      }
    },
    modelValue(modelValue, prevModelValue) {
      if (modelValue !== prevModelValue && this.formData.code !== modelValue) {
        this.formData.code = this.modelValue || "";
      }
    }
  },
  computed: {
    newModelValue() {
      return this.formData.code;
    }
  }
});
const _hoisted_1$i = { class: "light-blue-modal-container-content" };
const _hoisted_2$g = { style: { "display": "flex", "gap": "24px", "align-items": "center" } };
const _hoisted_3$f = /* @__PURE__ */ createElementVNode("div", {
  class: "app-label-s14-h20-c828",
  style: { "max-width": "200px" }
}, " \u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0434 \u0442\u0438\u043F\u0430 \u043F\u0440\u0438\u0435\u043C\u043D\u0438\u043A\u0430 \u0432\u0440\u0443\u0447\u043D\u0443\u044E \u0438\u043B\u0438 \u0440\u0430\u0441\u0441\u0447\u0438\u0442\u0430\u0439\u0442\u0435 \u043F\u043E \u0444\u043E\u0440\u043C\u0435 \u043D\u0438\u0436\u0435. ", -1);
const _hoisted_4$d = { class: "calc-code-receiver-container-header" };
const _hoisted_5$8 = { style: { "display": "inline-block", "margin-right": "10px" } };
const _hoisted_6$6 = { class: "calc-code-receiver-container-content" };
function _sfc_render$r(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TInputComponent = resolveComponent("TInputComponent");
  const _component_ButtonComponent = resolveComponent("ButtonComponent");
  const _component_TRadioButton = resolveComponent("TRadioButton");
  return openBlock(), createElementBlock("div", _hoisted_1$i, [
    createElementVNode("div", _hoisted_2$g, [
      createVNode(_component_TInputComponent, {
        modelValue: _ctx.formData.code,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.formData.code = $event),
        "input-style": { width: "150px" },
        "replace-empty-symbol": _ctx.INIT_CODE_SYMBOL,
        "replace-length": _ctx.codeLength,
        caption: "\u041A\u043E\u0434 \u0442\u0438\u043F\u0430 \u043F\u0440\u0438\u0435\u043C\u043D\u0438\u043A\u0430",
        onReset: _cache[1] || (_cache[1] = ($event) => _ctx.formData.code = _ctx.getInitFormData().code)
      }, null, 8, ["modelValue", "replace-empty-symbol", "replace-length"]),
      _hoisted_3$f
    ]),
    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.CALC_CODE_INFO_DATA_ARRAY, (calcCodeInfo, i) => {
      return openBlock(), createElementBlock("div", {
        key: calcCodeInfo.label,
        class: "calc-code-receiver-container"
      }, [
        createElementVNode("div", _hoisted_4$d, [
          createElementVNode("div", null, [
            createElementVNode("span", _hoisted_5$8, toDisplayString(calcCodeInfo.symbol.join(", ")) + " \u0441\u0438\u043C\u0432\u043E\u043B:", 1),
            createTextVNode(" " + toDisplayString(calcCodeInfo.label), 1)
          ]),
          calcCodeInfo.explanation ? (openBlock(), createBlock(_component_ButtonComponent, {
            key: 0,
            icon: _ctx.ICONS.faq,
            class: "button-opacity",
            onClick: ($event) => _ctx.onHelp(calcCodeInfo)
          }, null, 8, ["icon", "onClick"])) : createCommentVNode("", true)
        ]),
        createElementVNode("div", _hoisted_6$6, [
          createVNode(_component_TRadioButton, {
            data: calcCodeInfo.data,
            footerHelp: calcCodeInfo.explanations[_ctx.getFormDataValue(calcCodeInfo)],
            "is-view-key": true,
            "model-value": _ctx.getFormDataValue(calcCodeInfo),
            "onUpdate:modelValue": ($event) => _ctx.onSelected(calcCodeInfo, $event)
          }, null, 8, ["data", "footerHelp", "model-value", "onUpdate:modelValue"])
        ])
      ]);
    }), 128))
  ]);
}
var CalcCodeWasteWaterReceiver = /* @__PURE__ */ _export_sfc(_sfc_main$r, [["render", _sfc_render$r]]);
const CODE_STORAGE_DATA = {
  viewItem: {
    label: "\u0432\u0438\u0434 \u043F\u0443\u043D\u043A\u0442\u0430",
    type: "combobox",
    symbol: [1],
    explanations: {
      "1": "\u041F\u0443\u043D\u043A\u0442 \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u0443\u0434\u0430\u043B\u044F\u0435\u043C\u044B\u0445 \u0420\u0410\u041E, \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u043C \u043A\u043E\u0442\u043E\u0440\u043E\u0433\u043E \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D \u0441\u0440\u043E\u043A \u0435\u0433\u043E \u044D\u043A\u0441\u043F\u043B\u0443\u0430\u0442\u0430\u0446\u0438\u0438 \u0438 \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u044B \u043F\u043E\u0440\u044F\u0434\u043E\u043A \u0432\u044B\u0432\u043E\u0434\u0430 \u0438\u0437 \u044D\u043A\u0441\u043F\u043B\u0443\u0430\u0442\u0430\u0446\u0438\u0438 \u0438 \u043C\u0435\u0440\u044B \u043F\u043E \u0432\u044B\u0432\u043E\u0434\u0443 \u0435\u0433\u043E \u0438\u0437 \u044D\u043A\u0441\u043F\u043B\u0443\u0430\u0442\u0430\u0446\u0438\u0438.",
      "2": "\u041F\u0443\u043D\u043A\u0442 \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u0420\u0410\u041E, \u0441\u0440\u043E\u043A \u044D\u043A\u0441\u043F\u043B\u0443\u0430\u0442\u0430\u0446\u0438\u0438 \u043A\u043E\u0442\u043E\u0440\u043E\u0433\u043E \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u043C, \u043D\u043E \u043F\u043E\u0440\u044F\u0434\u043E\u043A \u0432\u044B\u0432\u043E\u0434\u0430 \u0438\u0437 \u044D\u043A\u0441\u043F\u043B\u0443\u0430\u0442\u0430\u0446\u0438\u0438 \u0438 \u043C\u0435\u0440\u044B \u043F\u043E \u0432\u044B\u0432\u043E\u0434\u0443 \u0438\u0437 \u044D\u043A\u0441\u043F\u043B\u0443\u0430\u0442\u0430\u0446\u0438\u0438 \u043A\u043E\u0442\u043E\u0440\u043E\u0433\u043E \u043D\u0435 \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u044B.",
      "3": "\u041F\u0443\u043D\u043A\u0442 \u0437\u0430\u0445\u043E\u0440\u043E\u043D\u0435\u043D\u0438\u044F \u0420\u0410\u041E, \u0432\u043A\u043B\u044E\u0447\u0430\u044E\u0449\u0438\u0439 \u0432 \u0441\u0435\u0431\u044F \u0441\u043E\u043E\u0440\u0443\u0436\u0435\u043D\u0438\u0435, \u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u043D\u043E\u0435 \u043D\u0430 \u043E\u0434\u043D\u043E\u043C \u0443\u0440\u043E\u0432\u043D\u0435 \u0441 \u043F\u043E\u0432\u0435\u0440\u0445\u043D\u043E\u0441\u0442\u044C\u044E \u0437\u0435\u043C\u043B\u0438 \u0438\u043B\u0438 \u043D\u0430 \u0433\u043B\u0443\u0431\u0438\u043D\u0435 \u0434\u043E \u0441\u0442\u0430 \u043C\u0435\u0442\u0440\u043E\u0432 \u043E\u0442 \u043F\u043E\u0432\u0435\u0440\u0445\u043D\u043E\u0441\u0442\u0438 \u0437\u0435\u043C\u043B\u0438. ",
      "4": "\u041F\u0443\u043D\u043A\u0442 \u0437\u0430\u0445\u043E\u0440\u043E\u043D\u0435\u043D\u0438\u044F \u0420\u0410\u041E, \u0432\u043A\u043B\u044E\u0447\u0430\u044E\u0449\u0438\u0439 \u0432 \u0441\u0435\u0431\u044F \u0441\u043E\u043E\u0440\u0443\u0436\u0435\u043D\u0438\u0435, \u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u043D\u043E\u0435 \u043D\u0430 \u0433\u043B\u0443\u0431\u0438\u043D\u0435 \u0431\u043E\u043B\u0435\u0435 \u0441\u0442\u0430 \u043C\u0435\u0442\u0440\u043E\u0432 \u043E\u0442 \u043F\u043E\u0432\u0435\u0440\u0445\u043D\u043E\u0441\u0442\u0438 \u0437\u0435\u043C\u043B\u0438.",
      "5": "\u041F\u0440\u0438\u0440\u043E\u0434\u043D\u044B\u0439 \u043E\u0431\u044A\u0435\u043A\u0442 \u0438\u043B\u0438 \u043E\u0431\u044A\u0435\u043A\u0442 \u0442\u0435\u0445\u043D\u043E\u0433\u0435\u043D\u043D\u043E\u0433\u043E \u043F\u0440\u043E\u0438\u0441\u0445\u043E\u0436\u0434\u0435\u043D\u0438\u044F, \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0449\u0438\u0435 \u043E\u0441\u043E\u0431\u044B\u0435 \u0420\u0410\u041E, \u043D\u0435 \u0438\u0437\u043E\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0435 \u043E\u0442 \u043E\u043A\u0440\u0443\u0436\u0430\u044E\u0449\u0435\u0439 \u0441\u0440\u0435\u0434\u044B, \u043B\u0438\u0431\u043E \u043E\u0431\u044A\u0435\u043A\u0442, \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0449\u0438\u0439 \u043E\u0441\u043E\u0431\u044B\u0435 \u0440\u0430\u0434\u0438\u043E\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0435 \u043E\u0442\u0445\u043E\u0434\u044B, \u0441\u0440\u043E\u043A \u0438\u0437\u043E\u043B\u044F\u0446\u0438\u0438 \u043A\u043E\u0442\u043E\u0440\u044B\u0445 \u043E\u0442 \u043E\u043A\u0440\u0443\u0436\u0430\u044E\u0449\u0435\u0439 \u0441\u0440\u0435\u0434\u044B \u043D\u0435 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D.",
      "6": "\u041F\u0440\u0438\u0440\u043E\u0434\u043D\u044B\u0439 \u043E\u0431\u044A\u0435\u043A\u0442 \u0438\u043B\u0438 \u043E\u0431\u044A\u0435\u043A\u0442 \u0442\u0435\u0445\u043D\u043E\u0433\u0435\u043D\u043D\u043E\u0433\u043E \u043F\u0440\u043E\u0438\u0441\u0445\u043E\u0436\u0434\u0435\u043D\u0438\u044F, \u0432 \u043A\u043E\u0442\u043E\u0440\u044B\u0445 \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0442\u0441\u044F \u043E\u0441\u043E\u0431\u044B\u0435 \u0420\u0410\u041E, \u0438\u043C\u0435\u044E\u0442\u0441\u044F \u0431\u0430\u0440\u044C\u0435\u0440\u044B \u0434\u043B\u044F \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u044F \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438, \u0438\u0437\u043E\u043B\u0438\u0440\u0443\u044E\u0449\u0438\u0435 \u0440\u0430\u0434\u0438\u043E\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0435 \u043E\u0442\u0445\u043E\u0434\u044B \u043E\u0442 \u043E\u043A\u0440\u0443\u0436\u0430\u044E\u0449\u0435\u0439 \u0441\u0440\u0435\u0434\u044B \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u043E\u0433\u043E \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u043C \u0441\u0440\u043E\u043A\u0430 \u044D\u043A\u0441\u043F\u043B\u0443\u0430\u0442\u0430\u0446\u0438\u0438 \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0445 \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432.",
      "9": "\u041F\u0443\u043D\u043A\u0442 \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F, \u0432\u0438\u0434 \u043A\u043E\u0442\u043E\u0440\u043E\u0433\u043E \u043D\u0435\u0442 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0438 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C (\u043D\u0435 \u0443\u0434\u043E\u0432\u043B\u0435\u0442\u0432\u043E\u0440\u044F\u0435\u0442 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u044F\u043C, \u043F\u0440\u0438\u0432\u0435\u0434\u0435\u043D\u043D\u044B\u043C \u0432\u044B\u0448\u0435). \u041F\u0440\u0438 \u0432\u044B\u0431\u043E\u0440\u0435 \u044D\u0442\u043E\u0433\u043E \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0430 \u0432 \u043F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0438 \u043A \u044F\u0447\u0435\u0439\u043A\u0435 \u0441 \u043A\u043E\u0434\u043E\u043C \u043F\u0443\u043D\u043A\u0442\u0430 \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u043F\u0440\u0438\u0432\u0435\u0441\u0442\u0438 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u043F\u0443\u043D\u043A\u0442\u0430, \u0443\u043A\u0430\u0437\u0430\u0442\u044C \u043F\u0440\u0438\u0447\u0438\u043D\u0443, \u043F\u043E \u043A\u043E\u0442\u043E\u0440\u043E\u0439 \u0435\u0433\u043E \u043D\u0435\u043B\u044C\u0437\u044F \u043E\u0442\u043D\u0435\u0441\u0442\u0438 \u043A \u043F\u0435\u0440\u0435\u0447\u0438\u0441\u043B\u0435\u043D\u043D\u044B\u043C \u0432\u044B\u0448\u0435 \u0432\u0438\u0434\u0430\u043C."
    },
    data: {
      "1": "\u043F\u0443\u043D\u043A\u0442 \u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E\u0433\u043E \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u0420\u0410\u041E",
      "2": "\u043F\u0443\u043D\u043A\u0442 \u0434\u043E\u043B\u0433\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E\u0433\u043E \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u0420\u0410\u041E",
      "3": "\u043F\u0443\u043D\u043A\u0442 \u043F\u0440\u0438\u043F\u043E\u0432\u0435\u0440\u0445\u043D\u043E\u0441\u0442\u043D\u043E\u0433\u043E \u0437\u0430\u0445\u043E\u0440\u043E\u043D\u0435\u043D\u0438\u044F \u0420\u0410\u041E",
      "4": "\u043F\u0443\u043D\u043A\u0442 \u0433\u043B\u0443\u0431\u0438\u043D\u043D\u043E\u0433\u043E \u0437\u0430\u0445\u043E\u0440\u043E\u043D\u0435\u043D\u0438\u044F \u0420\u0410\u041E",
      "5": "\u043F\u0443\u043D\u043A\u0442 \u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u0438\u044F \u043E\u0441\u043E\u0431\u044B\u0445 \u0420\u0410\u041E",
      "6": "\u043F\u0443\u043D\u043A\u0442 \u043A\u043E\u043D\u0441\u0435\u0440\u0432\u0430\u0446\u0438\u0438 \u043E\u0441\u043E\u0431\u044B\u0445 \u0420\u0410\u041E",
      "7": "\u043F\u0443\u043D\u043A\u0442 \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u041E\u042F\u0422",
      "9": "\u043F\u0440\u043E\u0447\u0438\u0439"
    }
  },
  stateItem: {
    label: "\u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0435 \u043F\u0443\u043D\u043A\u0442\u0430",
    type: "combobox",
    symbol: [2],
    explanation: "",
    explanations: {
      "2": "\u0417\u0430\u043A\u043E\u043D\u0441\u0435\u0440\u0432\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u043C \u0441\u0447\u0438\u0442\u0430\u0435\u0442\u0441\u044F \u043F\u0443\u043D\u043A\u0442 \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F, \u0432 \u043A\u043E\u0442\u043E\u0440\u043E\u043C \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u044B \u0442\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u0438 \u043F\u043E \u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u0438\u044E \u0420\u0410\u041E \u0438 \u0440\u0435\u0430\u043B\u0438\u0437\u043E\u0432\u0430\u043D\u044B \u043F\u0440\u043E\u0435\u043A\u0442\u043D\u044B\u0435 \u043C\u0435\u0440\u043E\u043F\u0440\u0438\u044F\u0442\u0438\u044F \u043F\u043E \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u044E \u0431\u0430\u0440\u044C\u0435\u0440\u043E\u0432 \u0434\u043B\u044F \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u044F \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438.",
      "3": "\u0417\u0430\u043A\u0440\u044B\u0442\u044B\u043C \u0441\u0447\u0438\u0442\u0430\u0435\u0442\u0441\u044F \u043F\u0443\u043D\u043A\u0442 \u0437\u0430\u0445\u043E\u0440\u043E\u043D\u0435\u043D\u0438\u044F, \u0432 \u043A\u043E\u0442\u043E\u0440\u043E\u043C \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u044B \u0442\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u0438 \u043F\u043E \u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u0438\u044E \u0420\u0410\u041E, \u0438 \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u043F\u0440\u0438\u0432\u0435\u0434\u0435\u043D \u0432 \u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0435, \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0438\u0432\u0430\u044E\u0449\u0435\u0435 \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u044C \u043D\u0430\u0441\u0435\u043B\u0435\u043D\u0438\u044F \u0438 \u043E\u043A\u0440\u0443\u0436\u0430\u044E\u0449\u0435\u0439 \u0441\u0440\u0435\u0434\u044B \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 \u043F\u0435\u0440\u0438\u043E\u0434\u0430 \u043F\u043E\u0442\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0439 \u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438 \u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u043D\u044B\u0445 \u0432 \u043D\u0435\u043C \u0440\u0430\u0434\u0438\u043E\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0445 \u043E\u0442\u0445\u043E\u0434\u043E\u0432."
    },
    data: {
      "1": "\u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0439",
      "2": "\u0437\u0430\u043A\u043E\u043D\u0441\u0435\u0440\u0432\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439",
      "3": "\u0437\u0430\u043A\u0440\u044B\u0442\u044B\u0439"
    }
  },
  environmentalInsulation: {
    label: "\u0438\u0437\u043E\u043B\u044F\u0446\u0438\u044F \u043E\u0442 \u043E\u043A\u0440\u0443\u0436\u0430\u044E\u0449\u0435\u0439 \u0441\u0440\u0435\u0434\u044B",
    type: "combobox",
    symbol: [3],
    explanation: "",
    explanations: {
      "1": "\u0418\u0437\u043E\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u043C \u0441\u0447\u0438\u0442\u0430\u0435\u0442\u0441\u044F \u043F\u0443\u043D\u043A\u0442, \u0438\u0437 \u043A\u043E\u0442\u043E\u0440\u043E\u0433\u043E \u043D\u0435 \u0432\u043E\u0437\u043C\u043E\u0436\u0435\u043D \u043D\u0435\u043A\u043E\u043D\u0442\u0440\u043E\u043B\u0438\u0440\u0443\u0435\u043C\u044B\u0439 \u0432\u044B\u0445\u043E\u0434 \u0440\u0430\u0434\u0438\u043E\u043D\u0443\u043A\u043B\u0438\u0434\u043E\u0432 \u0432 \u043E\u043A\u0440\u0443\u0436\u0430\u044E\u0449\u0443\u044E \u0441\u0440\u0435\u0434\u0443."
    },
    data: {
      "1": "\u0438\u0437\u043E\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u043E\u0442 \u043E\u043A\u0440\u0443\u0436\u0430\u044E\u0449\u0435\u0439 \u0441\u0440\u0435\u0434\u044B",
      "2": "\u043D\u0435\u0438\u0437\u043E\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u043E\u0442 \u043E\u043A\u0440\u0443\u0436\u0430\u044E\u0449\u0435\u0439 \u0441\u0440\u0435\u0434\u044B"
    }
  },
  zoneFindingItem: {
    label: "\u0437\u043E\u043D\u0430 \u043D\u0430\u0445\u043E\u0436\u0434\u0435\u043D\u0438\u044F \u043F\u0443\u043D\u043A\u0442\u0430",
    type: "combobox",
    symbol: [4],
    explanation: "",
    explanations: {
      "9": "\u041F\u0440\u0438 \u0432\u044B\u0431\u043E\u0440\u0435 \u044D\u0442\u043E\u0433\u043E \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0430 \u0432 \u043F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0438 \u043A \u044F\u0447\u0435\u0439\u043A\u0435 \u0441 \u043A\u043E\u0434\u043E\u043C \u043F\u0443\u043D\u043A\u0442\u0430 \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0443\u043A\u0430\u0437\u0430\u0442\u044C \u0437\u043E\u043D\u0443 \u043D\u0430\u0445\u043E\u0436\u0434\u0435\u043D\u0438\u044F \u043F\u0443\u043D\u043A\u0442\u0430."
    },
    data: {
      "1": "\u043F\u0440\u043E\u043C\u043F\u043B\u043E\u0449\u0430\u0434\u043A\u0430",
      "2": "\u0441\u0430\u043D\u0438\u0442\u0430\u0440\u043D\u043E-\u0437\u0430\u0449\u0438\u0442\u043D\u0430\u044F \u0437\u043E\u043D\u0430",
      "3": "\u0437\u043E\u043D\u0430 \u043D\u0430\u0431\u043B\u044E\u0434\u0435\u043D\u0438\u044F",
      "4": "\u0441\u043F\u0435\u0446\u043F\u0440\u0438\u0447\u0430\u043B \u043F\u043E\u0440\u0442\u0430",
      "5": "\u043E\u0442\u043A\u0440\u044B\u0442\u043E\u0435 \u043C\u043E\u0440\u0435",
      "9": "\u043F\u0440\u043E\u0447\u0430\u044F"
    }
  },
  valueItem: {
    label: "\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u043F\u0443\u043D\u043A\u0442\u0430",
    type: "combobox",
    symbol: [5],
    explanation: "",
    explanations: {
      "2": "\u041E\u0431\u044A\u0435\u043A\u0442, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u043F\u043E \u0443\u0441\u043B\u043E\u0432\u0438\u044E \u043F\u0440\u0438\u043D\u044F\u0442\u0438\u044F \u0440\u0435\u0448\u0435\u043D\u0438\u044F \u043E \u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u0438\u0438 \u0438 \u0441\u043E\u043E\u0440\u0443\u0436\u0435\u043D\u0438\u0438 \u0431\u044B\u043B \u0437\u0430\u044F\u0432\u043B\u0435\u043D, \u043A\u0430\u043A \u0438\u043C\u0435\u044E\u0449\u0438\u0439 \u0440\u0435\u0433\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435.",
      "3": "\u0412 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0440\u0435\u0448\u0435\u043D\u0438\u0435\u043C \u043E\u0440\u0433\u0430\u043D\u0430 \u0433\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0433\u043E \u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u0432 \u043E\u0431\u043B\u0430\u0441\u0442\u0438 \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u044F \u0441 \u0420\u0410\u041E, \u043F\u0440\u0438\u043D\u044F\u0442\u044B\u043C \u043D\u0430 \u043E\u0441\u043D\u043E\u0432\u0430\u043D\u0438\u0438 \u043F\u0443\u043D\u043A\u0442\u0430 9 \u0441\u0442\u0430\u0442\u044C\u0438 23 \u0424\u0435\u0434\u0435\u0440\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0437\u0430\u043A\u043E\u043D\u0430 \u043E\u0442 11.07.2011  \u2116 190-\u0424\u0417 \xAB\u041E\u0431 \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u0438 \u0441 \u0440\u0430\u0434\u0438\u043E\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u043C\u0438 \u043E\u0442\u0445\u043E\u0434\u0430\u043C\u0438 \u0438 \u043E \u0432\u043D\u0435\u0441\u0435\u043D\u0438\u0438 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0439 \u0432 \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u044B\u0435 \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0430\u043A\u0442\u044B \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438\xBB.",
      "4": "\u0412 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0440\u0435\u0448\u0435\u043D\u0438\u0435\u043C \u043E\u0440\u0433\u0430\u043D\u0430 \u0433\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0433\u043E \u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u0432 \u043E\u0431\u043B\u0430\u0441\u0442\u0438 \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u044F \u0441 \u0420\u0410\u041E, \u043F\u0440\u0438\u043D\u044F\u0442\u044B\u043C \u043D\u0430 \u043E\u0441\u043D\u043E\u0432\u0430\u043D\u0438\u0438 \u043F\u0443\u043D\u043A\u0442\u0430 9 \u0441\u0442\u0430\u0442\u044C\u0438 23 \u0424\u0435\u0434\u0435\u0440\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0437\u0430\u043A\u043E\u043D\u0430 \u043E\u0442 11.07.2011  \u2116 190-\u0424\u0417 \xAB\u041E\u0431 \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u0438 \u0441 \u0440\u0430\u0434\u0438\u043E\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u043C\u0438 \u043E\u0442\u0445\u043E\u0434\u0430\u043C\u0438 \u0438 \u043E \u0432\u043D\u0435\u0441\u0435\u043D\u0438\u0438 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0439 \u0432 \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u044B\u0435 \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0430\u043A\u0442\u044B \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438\xBB."
    },
    data: {
      "0": "\u043D\u0435 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043E",
      "1": "\u043F\u0443\u043D\u043A\u0442 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438",
      "2": "\u0440\u0435\u0433\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0439",
      "3": "\u043C\u0435\u0436\u0440\u0435\u0433\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0439",
      "4": "\u0444\u0435\u0434\u0435\u0440\u0430\u043B\u044C\u043D\u044B\u0439"
    }
  },
  placementStorageItemRelativeSurfaceEarth: {
    label: "\u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u0438\u0435 \u043F\u0443\u043D\u043A\u0442\u0430 \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u043E\u0442\u043D\u043E\u0441\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u043F\u043E\u0432\u0435\u0440\u0445\u043D\u043E\u0441\u0442\u0438 \u0437\u0435\u043C\u043B\u0438",
    type: "combobox",
    symbol: [6],
    explanation: "",
    explanations: {
      "1": "\u041F\u0443\u043D\u043A\u0442 \u043F\u0440\u0438\u043F\u043E\u0432\u0435\u0440\u0445\u043D\u043E\u0441\u0442\u043D\u043E\u0433\u043E \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u0440\u0430\u0434\u0438\u043E\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0445 \u043E\u0442\u0445\u043E\u0434\u043E\u0432 - \u043F\u0443\u043D\u043A\u0442 \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u0440\u0430\u0434\u0438\u043E\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0445 \u043E\u0442\u0445\u043E\u0434\u043E\u0432, \u0432\u043A\u043B\u044E\u0447\u0430\u044E\u0449\u0438\u0439 \u0432 \u0441\u0435\u0431\u044F \u0441\u043E\u043E\u0440\u0443\u0436\u0435\u043D\u0438\u0435, \u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u043D\u043E\u0435 \u043D\u0430 \u043E\u0434\u043D\u043E\u043C \u0443\u0440\u043E\u0432\u043D\u0435 \u0441 \u043F\u043E\u0432\u0435\u0440\u0445\u043D\u043E\u0441\u0442\u044C\u044E \u0437\u0435\u043C\u043B\u0438 \u0438\u043B\u0438 \u043D\u0430 \u0433\u043B\u0443\u0431\u0438\u043D\u0435 \u0434\u043E \u0441\u0442\u0430 \u043C\u0435\u0442\u0440\u043E\u0432 \u043E\u0442 \u043F\u043E\u0432\u0435\u0440\u0445\u043D\u043E\u0441\u0442\u0438 \u0437\u0435\u043C\u043B\u0438.",
      "2": "\u041F\u0443\u043D\u043A\u0442 \u043F\u0440\u0438\u043F\u043E\u0432\u0435\u0440\u0445\u043D\u043E\u0441\u0442\u043D\u043E\u0433\u043E \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u0440\u0430\u0434\u0438\u043E\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0445 \u043E\u0442\u0445\u043E\u0434\u043E\u0432 - \u043F\u0443\u043D\u043A\u0442 \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u0440\u0430\u0434\u0438\u043E\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0445 \u043E\u0442\u0445\u043E\u0434\u043E\u0432, \u0432\u043A\u043B\u044E\u0447\u0430\u044E\u0449\u0438\u0439 \u0432 \u0441\u0435\u0431\u044F \u0441\u043E\u043E\u0440\u0443\u0436\u0435\u043D\u0438\u0435, \u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u043D\u043E\u0435 \u043D\u0430 \u043E\u0434\u043D\u043E\u043C \u0443\u0440\u043E\u0432\u043D\u0435 \u0441 \u043F\u043E\u0432\u0435\u0440\u0445\u043D\u043E\u0441\u0442\u044C\u044E \u0437\u0435\u043C\u043B\u0438 \u0438\u043B\u0438 \u043D\u0430 \u0433\u043B\u0443\u0431\u0438\u043D\u0435 \u0434\u043E \u0441\u0442\u0430 \u043C\u0435\u0442\u0440\u043E\u0432 \u043E\u0442 \u043F\u043E\u0432\u0435\u0440\u0445\u043D\u043E\u0441\u0442\u0438 \u0437\u0435\u043C\u043B\u0438.",
      "3": "\u041F\u0443\u043D\u043A\u0442 \u043F\u0440\u0438\u043F\u043E\u0432\u0435\u0440\u0445\u043D\u043E\u0441\u0442\u043D\u043E\u0433\u043E \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u0440\u0430\u0434\u0438\u043E\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0445 \u043E\u0442\u0445\u043E\u0434\u043E\u0432, \u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u043D\u044B\u0445 \u0432 \u0441\u043A\u0430\u043B\u044C\u043D\u044B\u0445 \u0432\u044B\u0440\u0430\u0431\u043E\u0442\u043A\u0430\u0445.",
      "4": "\u041F\u0443\u043D\u043A\u0442 \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u0440\u0430\u0434\u0438\u043E\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0445 \u043E\u0442\u0445\u043E\u0434\u043E\u0432, \u0432\u043A\u043B\u044E\u0447\u0430\u044E\u0449\u0438\u0439 \u0432 \u0441\u0435\u0431\u044F \u0441\u043E\u043E\u0440\u0443\u0436\u0435\u043D\u0438\u0435, \u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u043D\u043E\u0435 \u043D\u0430 \u0433\u043B\u0443\u0431\u0438\u043D\u0435 \u0431\u043E\u043B\u0435\u0435 \u0441\u0442\u0430 \u043C\u0435\u0442\u0440\u043E\u0432 \u043E\u0442 \u043F\u043E\u0432\u0435\u0440\u0445\u043D\u043E\u0441\u0442\u0438 \u0437\u0435\u043C\u043B\u0438.",
      "9": "\u041F\u0440\u0438\u043C\u0435\u043D\u044F\u0435\u0442\u0441\u044F \u0434\u043B\u044F \u043A\u043E\u0434\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u0443\u043D\u043A\u0442\u043E\u0432 \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F, \u0434\u043B\u044F \u043A\u043E\u0442\u043E\u0440\u044B\u0445 \u043D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u043E\u0434\u043D\u043E\u0437\u043D\u0430\u0447\u043D\u043E\u0435 \u043E\u0442\u043D\u0435\u0441\u0435\u043D\u0438\u0435 \u043A \u043F\u0440\u0438\u043F\u043E\u0432\u0435\u0440\u0445\u043D\u043E\u0441\u0442\u043D\u044B\u043C \u0438\u043B\u0438 \u0433\u043B\u0443\u0431\u0438\u043D\u043D\u044B\u043C; \n\u043F\u0440\u0438 \u0432\u044B\u0431\u043E\u0440\u0435 \u044D\u0442\u043E\u0433\u043E \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0430 \u0432 \u043F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0438 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0434\u0430\u0442\u044C \u043F\u043E\u044F\u0441\u043D\u0435\u043D\u0438\u0435 \u043E \u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u0438\u0438 \u043F\u0443\u043D\u043A\u0442\u0430 \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F."
    },
    data: {
      "1": "\u043F\u0440\u0438\u043F\u043E\u0432\u0435\u0440\u0445\u043D\u043E\u0441\u0442\u043D\u044B\u0439, \u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u043D\u044B\u0439 \u0432\u044B\u0448\u0435 \u0443\u0440\u043E\u0432\u043D\u044F \u043F\u043E\u0432\u0435\u0440\u0445\u043D\u043E\u0441\u0442\u0438 \u0437\u0435\u043C\u043B\u0438",
      "2": "\u043F\u0440\u0438\u043F\u043E\u0432\u0435\u0440\u0445\u043D\u043E\u0441\u0442\u043D\u044B\u0435 \u043F\u0440\u043E\u0447\u0438\u0435",
      "3": "\u0441\u043A\u0430\u043B\u044C\u043D\u044B\u0435 \u0432\u044B\u0440\u0430\u0431\u043E\u0442\u043A\u0438",
      "4": "\u0433\u043B\u0443\u0431\u0438\u043D\u043D\u044B\u0439",
      "9": "\u043F\u0440\u043E\u0447\u0435\u0435 \u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u0438\u0435"
    }
  },
  codeTypeStorage: {
    label: "\u043A\u043E\u0434 \u0442\u0438\u043F\u0430 \u043F\u0443\u043D\u043A\u0442\u0430 \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F",
    type: "select",
    symbol: [7, 8],
    explanation: "",
    explanations: {
      "19": "\u041F\u0440\u0438 \u0432\u044B\u0431\u043E\u0440\u0435 \u044D\u0442\u043E\u0433\u043E \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0430 \u0432 \u043F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0438 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0434\u0430\u0442\u044C \u043F\u043E\u044F\u0441\u043D\u0435\u043D\u0438\u0435 \u043E \u043F\u0443\u043D\u043A\u0442\u0435 \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F.",
      "29": "\u041F\u0440\u0438 \u0432\u044B\u0431\u043E\u0440\u0435 \u044D\u0442\u043E\u0433\u043E \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0430 \u0432 \u043F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0438 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u043F\u0440\u0438\u0432\u0435\u0441\u0442\u0438 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0435\u043C\u043A\u043E\u0441\u0442\u0438 \u0438 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u0430, \u0438\u0437 \u043A\u043E\u0442\u043E\u0440\u043E\u0433\u043E \u043E\u043D\u0430 \u0438\u0437\u0433\u043E\u0442\u043E\u0432\u043B\u0435\u043D\u0430.",
      "49": "\u041F\u0440\u0438 \u0432\u044B\u0431\u043E\u0440\u0435 \u044D\u0442\u043E\u0433\u043E \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0430 \u0432 \u043F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0438 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0434\u0430\u0442\u044C \u043F\u043E\u044F\u0441\u043D\u0435\u043D\u0438\u0435 \u043E\u0431 \u0438\u0437\u043E\u043B\u044F\u0446\u0438\u0438 \u043E\u0441\u043D\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u043B\u043E\u0449\u0430\u0434\u043A\u0438.",
      "59": "\u041F\u0440\u0438 \u0432\u044B\u0431\u043E\u0440\u0435 \u044D\u0442\u043E\u0433\u043E \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0430 \u0432 \u043F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0438 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0434\u0430\u0442\u044C \u043F\u043E\u044F\u0441\u043D\u0435\u043D\u0438\u0435 \u043E \u043F\u0443\u043D\u043A\u0442\u0435 \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F.",
      "79": "\u041F\u0440\u0438 \u0432\u044B\u0431\u043E\u0440\u0435 \u044D\u0442\u043E\u0433\u043E \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0430 \u0432 \u043F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0438 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0434\u0430\u0442\u044C \u043F\u043E\u044F\u0441\u043D\u0435\u043D\u0438\u0435 \u043E \u043F\u0443\u043D\u043A\u0442\u0435 \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F.",
      "89": "\u041F\u0440\u0438 \u0432\u044B\u0431\u043E\u0440\u0435 \u044D\u0442\u043E\u0433\u043E \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0430 \u0432 \u043F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0438 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0434\u0430\u0442\u044C \u043F\u043E\u044F\u0441\u043D\u0435\u043D\u0438\u0435 \u043E \u043F\u0443\u043D\u043A\u0442\u0435 \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F.",
      "99": "\u041F\u0440\u0438 \u0432\u044B\u0431\u043E\u0440\u0435 \u044D\u0442\u043E\u0433\u043E \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0430 \u0432 \u043F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0438 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0434\u0430\u0442\u044C \u043F\u043E\u044F\u0441\u043D\u0435\u043D\u0438\u0435 \u043E \u043F\u0443\u043D\u043A\u0442\u0435 \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F."
    },
    data: {
      "11": "\u0437\u0434\u0430\u043D\u0438\u0435 \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0435",
      "12": "\u043F\u043E\u043C\u0435\u0449\u0435\u043D\u0438\u0435 \u0432\u043D\u0443\u0442\u0440\u0438\u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0435, \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u043E \u043E\u0431\u043E\u0440\u0443\u0434\u043E\u0432\u0430\u043D\u043D\u043E\u0435",
      "13": "\u0432\u043E\u0434\u043E\u0435\u043C \u0442\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0431\u0435\u0437 \u0438\u043D\u0436\u0435\u043D\u0435\u0440\u043D\u044B\u0445 \u0437\u0430\u0449\u0438\u0442\u043D\u044B\u0445 \u0431\u0430\u0440\u044C\u0435\u0440\u043E\u0432",
      "14": "\u0432\u043E\u0434\u043E\u0435\u043C \u0442\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0441 \u0438\u043D\u0436\u0435\u043D\u0435\u0440\u043D\u044B\u043C\u0438 \u0437\u0430\u0449\u0438\u0442\u043D\u044B\u043C\u0438 \u0431\u0430\u0440\u044C\u0435\u0440\u0430\u043C\u0438",
      "15": "\u043F\u0443\u043B\u044C\u043F\u043E\u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0435 (\u0445\u0432\u043E\u0441\u0442\u043E\u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0435, \u0448\u043B\u0430\u043C\u043E\u043D\u0430\u043A\u043E\u043F\u0438\u0442\u0435\u043B\u044C), \u043A\u0440\u043E\u043C\u0435 \u0435\u043C\u043A\u043E\u0441\u0442\u0435\u0439",
      "16": "\u0441\u043E\u043E\u0440\u0443\u0436\u0435\u043D\u0438\u0435 \u0442\u0440\u0430\u043D\u0448\u0435\u0439\u043D\u043E\u0433\u043E \u0442\u0438\u043F\u0430 \u0441 \u0438\u043D\u0436\u0435\u043D\u0435\u0440\u043D\u044B\u043C\u0438 \u0437\u0430\u0449\u0438\u0442\u043D\u044B\u043C\u0438 \u0431\u0430\u0440\u044C\u0435\u0440\u0430\u043C\u0438",
      "17": "\u0441\u043E\u043E\u0440\u0443\u0436\u0435\u043D\u0438\u0435 \u0431\u0443\u043D\u043A\u0435\u0440\u043D\u043E\u0433\u043E \u0442\u0438\u043F\u0430 \u0441 \u0438\u043D\u0436\u0435\u043D\u0435\u0440\u043D\u044B\u043C\u0438 \u0437\u0430\u0449\u0438\u0442\u043D\u044B\u043C\u0438 \u0431\u0430\u0440\u044C\u0435\u0440\u0430\u043C\u0438",
      "18": "\u0441\u043E\u043E\u0440\u0443\u0436\u0435\u043D\u0438\u044F \u043A\u043E\u0442\u043B\u043E\u0432\u0430\u043D\u043D\u043E\u0433\u043E \u0442\u0438\u043F\u0430 \u0441 \u0438\u043D\u0436\u0435\u043D\u0435\u0440\u043D\u044B\u043C\u0438 \u0437\u0430\u0449\u0438\u0442\u043D\u044B\u043C\u0438 \u0431\u0430\u0440\u044C\u0435\u0440\u0430\u043C\u0438",
      "19": "\u0437\u0434\u0430\u043D\u0438\u044F \u0438 \u0441\u043E\u043E\u0440\u0443\u0436\u0435\u043D\u0438\u044F \u043F\u0440\u043E\u0447\u0438\u0435",
      "21": "\u043A\u043E\u043D\u0442\u0435\u0439\u043D\u0435\u0440, \u0435\u043C\u043A\u043E\u0441\u0442\u044C \u0436\u0435\u043B\u0435\u0437\u043E\u0431\u0435\u0442\u043E\u043D\u043D\u0430\u044F \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u043E \u0441\u0442\u043E\u044F\u0449\u0430\u044F",
      "22": "\u043A\u043E\u043D\u0442\u0435\u0439\u043D\u0435\u0440, \u0435\u043C\u043A\u043E\u0441\u0442\u044C \u043C\u0435\u0442\u0430\u043B\u043B\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u043E \u0441\u0442\u043E\u044F\u0449\u0430\u044F",
      "23": "\u043A\u043E\u043D\u0442\u0435\u0439\u043D\u0435\u0440, \u0435\u043C\u043A\u043E\u0441\u0442\u044C \u0436\u0435\u043B\u0435\u0437\u043E\u0431\u0435\u0442\u043E\u043D\u043D\u0430\u044F, \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u0430\u044F \u0432 \u043A\u0430\u043D\u044C\u043E\u043D",
      "24": "\u043A\u043E\u043D\u0442\u0435\u0439\u043D\u0435\u0440, \u0435\u043C\u043A\u043E\u0441\u0442\u044C \u043C\u0435\u0442\u0430\u043B\u043B\u0438\u0447\u0435\u0441\u043A\u0430\u044F, \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u0430\u044F \u0432 \u043A\u0430\u043D\u044C\u043E\u043D",
      "26": "\u0435\u043C\u043A\u043E\u0441\u0442\u044C \u043F\u043B\u0430\u0432\u0443\u0447\u0430\u044F",
      "29": "\u0435\u043C\u043A\u043E\u0441\u0442\u0438 \u043F\u0440\u043E\u0447\u0438\u0435",
      "31": "\u043E\u0442\u0432\u0430\u043B\u044B, \u043A\u0443\u0440\u0433\u0430\u043D\u044B",
      "41": "\u043F\u043B\u043E\u0449\u0430\u0434\u043A\u0430 \u0430\u0441\u0444\u0430\u043B\u044C\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u0430\u044F",
      "42": "\u043F\u043B\u043E\u0449\u0430\u0434\u043A\u0430 \u0431\u0435\u0442\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u0430\u044F",
      "43": "\u043F\u043B\u043E\u0449\u0430\u0434\u043A\u0430 \u0433\u0440\u0443\u043D\u0442\u043E\u0432\u0430\u044F",
      "44": "\u043F\u043B\u043E\u0449\u0430\u0434\u043A\u0430 \u0441 \u043D\u0435\u0438\u0437\u043E\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u043C \u043E\u0441\u043D\u043E\u0432\u0430\u043D\u0438\u0435\u043C",
      "49": "\u043F\u043B\u043E\u0449\u0430\u0434\u043A\u0438 \u0441 \u0438\u0437\u043E\u043B\u044F\u0446\u0438\u0435\u0439 \u043E\u0441\u043D\u043E\u0432\u0430\u043D\u0438\u044F, \u043F\u0440\u043E\u0447\u0438\u0435",
      "51": "\u0441\u043A\u0432\u0430\u0436\u0438\u043D\u044B \u0431\u0443\u0440\u043E\u0432\u044B\u0435",
      "52": "\u0441\u0442\u0432\u043E\u043B\u044B, \u0448\u0443\u0440\u0444\u044B, \u043A\u043E\u043B\u043E\u0434\u0446\u044B",
      "53": "\u0448\u0442\u043E\u043B\u044C\u043D\u0438, \u0448\u0442\u0440\u0435\u043A\u0438",
      "54": "\u043A\u0430\u0440\u044C\u0435\u0440\u044B, \u043A\u043E\u0442\u043B\u043E\u0432\u0430\u043D\u044B",
      "55": "\u0442\u0440\u0430\u043D\u0448\u0435\u0438 (\u0431\u0435\u0437 \u0438\u043D\u0436\u0435\u043D\u0435\u0440\u043D\u044B\u0445 \u0437\u0430\u0449\u0438\u0442\u043D\u044B\u0445 \u0431\u0430\u0440\u044C\u0435\u0440\u043E\u0432)",
      "56": "\u043F\u043E\u043B\u043E\u0441\u0442\u044C, \u043E\u0431\u0440\u0430\u0437\u043E\u0432\u0430\u043D\u043D\u0430\u044F \u0432 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0438 \u044F\u0434\u0435\u0440\u043D\u044B\u0445 \u0437\u0430\u0440\u044F\u0434\u043E\u0432 \u0432 \u043C\u0438\u0440\u043D\u044B\u0445 \u0446\u0435\u043B\u044F\u0445",
      "59": "\u043F\u043E\u043B\u043E\u0441\u0442\u0438 \u043F\u0440\u043E\u0447\u0438\u0435",
      "61": "\u043F\u043B\u0430\u0441\u0442-\u043A\u043E\u043B\u043B\u0435\u043A\u0442\u043E\u0440 \u0433\u043B\u0443\u0431\u0438\u043D\u043D\u044B\u0439",
      "71": "\u0431\u043B\u043E\u043A \u0443\u0442\u0438\u043B\u0438\u0437\u0438\u0440\u0443\u0435\u043C\u043E\u0439 \u0410\u041F\u041B \u043D\u0430 \u043F\u043B\u0430\u0432\u0443",
      "73": "\u043F\u043B\u043E\u0449\u0430\u0434\u043A\u0430 \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u0440\u0435\u0430\u043A\u0442\u043E\u0440\u043D\u044B\u0445 \u043E\u0442\u0441\u0435\u043A\u043E\u0432 \u0410\u041F\u041B ",
      "74": "\u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0435 \u0420\u0410\u041E \u043D\u0430 \u0441\u0443\u0434\u043D\u0435, \u0432\u043A\u043B\u044E\u0447\u0430\u044F \u0441\u0443\u0434\u0430 \u0430\u0442\u043E\u043C\u043D\u043E-\u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u043E\u0433\u043E \u043E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u044F",
      "79": "\u043F\u0443\u043D\u043A\u0442\u044B \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u043D\u0430 \u0441\u0443\u0434\u0430\u0445 \u0438 \u0443\u0442\u0438\u043B\u0438\u0437\u0438\u0440\u0443\u0435\u043C\u044B\u0445 \u0410\u041F\u041B \u043F\u0440\u043E\u0447\u0438\u0435",
      "81": "\u043F\u0440\u0438\u0440\u0435\u0430\u043A\u0442\u043E\u0440\u043D\u043E\u0435 \u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0435 (\u043F\u0440\u0438\u0440\u0435\u0430\u043A\u0442\u043E\u0440\u043D\u044B\u0439 \u0431\u0430\u0441\u0441\u0435\u0439\u043D \u0432\u044B\u0434\u0435\u0440\u0436\u043A\u0438)",
      "82": "\u0432\u043D\u0435\u0440\u0435\u0430\u043A\u0442\u043E\u0440\u043D\u043E\u0435 \u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0435 \xAB\u043C\u043E\u043A\u0440\u043E\u0433\u043E\xBB \u0442\u0438\u043F\u0430",
      "83": "\u0441\u0443\u0445\u043E\u0435 \u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0435",
      "84": "\u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0435 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u043D\u044B\u0445 \u0440\u0435\u0430\u043A\u0442\u043E\u0440\u043E\u0432 \u043D\u0430 \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0445 \u0441\u0443\u0434\u0430\u0445",
      "85": "\u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0435 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u043D\u044B\u0445 \u0440\u0435\u0430\u043A\u0442\u043E\u0440\u043E\u0432 \u043D\u0430\u0437\u0435\u043C\u043D\u043E\u0435",
      "86": "\u043F\u043B\u043E\u0449\u0430\u0434\u043A\u0430 \u0434\u043B\u044F \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u041E\u042F\u0422 \u0432 \u043A\u043E\u043D\u0442\u0435\u0439\u043D\u0435\u0440\u0430\u0445",
      "89": "\u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0430 \u041E\u042F\u0422 \u043F\u0440\u043E\u0447\u0438\u0435",
      "99": "\u043F\u0443\u043D\u043A\u0442\u044B \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F, \u043D\u0435 \u043F\u0435\u0440\u0435\u0447\u0438\u0441\u043B\u0435\u043D\u043D\u044B\u0435 \u0432\u044B\u0448\u0435"
    },
    dataGroup: {
      "\u0417\u0434\u0430\u043D\u0438\u044F \u0438 \u0441\u043E\u043E\u0440\u0443\u0436\u0435\u043D\u0438\u044F": [
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19"
      ],
      "\u041A\u043E\u043D\u0442\u0435\u0439\u043D\u0435\u0440\u044B \u0438 \u0435\u043C\u043A\u043E\u0441\u0442\u0438 ": ["21", "22", "23", "24", "26", "29"],
      "\u041E\u0442\u0432\u0430\u043B\u044B, \u043A\u0443\u0440\u0433\u0430\u043D\u044B": ["31"],
      \u041F\u043B\u043E\u0449\u0430\u0434\u043A\u0438: ["41", "42", "43", "44", "49"],
      "\u041F\u043E\u043B\u043E\u0441\u0442\u0438 \u043D\u0430 \u043F\u043E\u0432\u0435\u0440\u0445\u043D\u043E\u0441\u0442\u0438 \u0438\u043B\u0438 \u0432 \u0442\u043E\u043B\u0449\u0435 \u0437\u0435\u043C\u043B\u0438": [
        "51",
        "52",
        "53",
        "54",
        "55",
        "56",
        "59"
      ],
      "\u041F\u0443\u043D\u043A\u0442\u044B \u0433\u043B\u0443\u0431\u0438\u043D\u043D\u043E\u0433\u043E \u0437\u0430\u0445\u043E\u0440\u043E\u043D\u0435\u043D\u0438\u044F \u0420\u0410\u041E": ["61"],
      "\u041F\u0443\u043D\u043A\u0442\u044B \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u043D\u0430 \u0441\u0443\u0434\u0430\u0445 \u0438 \u0443\u0442\u0438\u043B\u0438\u0437\u0438\u0440\u0443\u0435\u043C\u044B\u0445 \u0410\u041F\u041B": ["71", "73", "74", "79"],
      "\u041F\u0443\u043D\u043A\u0442\u044B \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u041E\u042F\u0422": ["81", "82", "83", "84", "85", "86", "89"],
      "\u041F\u0443\u043D\u043A\u0442\u044B \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u043F\u0440\u043E\u0447\u0438\u0435": ["99"]
    }
  }
};
const CODE_STORAGE_DATA_ARRAY = Object.values(
  CODE_STORAGE_DATA
);
var CalcCodeStorage_vue_vue_type_style_index_0_lang = "";
const _sfc_main$q = defineComponent({
  name: "CalcCodeStorage",
  props: {
    modelValue: Object
  },
  emits: ["init", "close", "update:modelValue"],
  components: {
    TRadioButton,
    TInputComponent,
    TSelectComponent
  },
  setup() {
    return {
      CALC_CODE_INFO_DATA: CODE_STORAGE_DATA,
      CALC_CODE_INFO_DATA_ARRAY: CODE_STORAGE_DATA_ARRAY,
      ICONS,
      toStr,
      INIT_CODE_SYMBOL
    };
  },
  data() {
    return {
      formData: this.getInitFormData(),
      codeLength: CALC_PARAMS.CalcCodeStorage.maxSymbols,
      initSymbol: "_"
    };
  },
  created() {
    this.formData.code = this.modelValue || this.formData.code;
    this.updateCalcCode();
    this.$emit("init");
  },
  methods: {
    getInitFormData() {
      return getInitFormDataCalcCodeInfo(
        this.CALC_CODE_INFO_DATA_ARRAY,
        this.codeLength,
        this.initSymbol
      );
    },
    onSelected(calcCodeInfo, _key) {
      const result = getCalcCode(
        this.formData.code,
        this.codeLength,
        calcCodeInfo,
        _key,
        this.initSymbol
      );
      Object.assign(this.formData, result.formData);
    },
    onResetValue(calcCodeInfo) {
      const key = this.getFormDataKey(calcCodeInfo);
      this.formData[key] = this.getInitFormData()[key];
      this.formData.code = getCalcCodeByFormDataAndCalcCodeInfo(
        calcCodeInfo,
        this.formData,
        this.INIT_CODE_SYMBOL
      );
    },
    onHelp(calcCodeInfo) {
      NotificationsService$1.send({
        type: "info",
        title: calcCodeInfo.label,
        text: calcCodeInfo.explanation
      });
    },
    updateCalcCode() {
      updateFormDataByCalcCode(
        this.CALC_CODE_INFO_DATA_ARRAY,
        this.formData.code,
        this.formData
      );
    },
    getFormDataKey(calcCodeInfo) {
      return calcCodeInfo.symbol.join("_");
    },
    getFormDataValue(calcCodeInfo) {
      return getFormDataValueOrUndefined(
        calcCodeInfo,
        this.formData,
        this.INIT_CODE_SYMBOL
      );
    },
    updateModelValue() {
      this.$emit("update:modelValue", this.newModelValue);
    }
  },
  watch: {
    "formData.code"(code, prevCode) {
      if (this.formData.code.length === this.codeLength && code !== prevCode) {
        this.updateCalcCode();
      }
      if (this.modelValue !== code) {
        this.updateModelValue();
      }
    },
    modelValue(modelValue, prevModelValue) {
      if (modelValue !== prevModelValue && this.formData.code !== modelValue) {
        this.formData.code = this.modelValue || "";
      }
    }
  },
  computed: {
    newModelValue() {
      return this.formData.code;
    }
  }
});
const _hoisted_1$h = { class: "light-blue-modal-container-content" };
const _hoisted_2$f = { style: { "display": "flex", "gap": "24px", "align-items": "center" } };
const _hoisted_3$e = /* @__PURE__ */ createElementVNode("div", {
  class: "app-label-s14-h20-c828",
  style: { "max-width": "200px" }
}, " \u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0434 \u043F\u0443\u043D\u043A\u0442\u0430 \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u0432\u0440\u0443\u0447\u043D\u0443\u044E \u0438\u043B\u0438 \u0440\u0430\u0441\u0441\u0447\u0438\u0442\u0430\u0439\u0442\u0435 \u043F\u043E \u0444\u043E\u0440\u043C\u0435 \u043D\u0438\u0436\u0435. ", -1);
const _hoisted_4$c = { class: "root-calc-code-storage" };
const _hoisted_5$7 = { class: "calc-code-storage-header" };
const _hoisted_6$5 = { style: { "display": "inline-block", "margin-right": "10px" } };
const _hoisted_7$4 = { class: "calc-code-storage-content" };
function _sfc_render$q(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TInputComponent = resolveComponent("TInputComponent");
  const _component_ButtonComponent = resolveComponent("ButtonComponent");
  const _component_TRadioButton = resolveComponent("TRadioButton");
  const _component_TSelectComponent = resolveComponent("TSelectComponent");
  return openBlock(), createElementBlock("div", _hoisted_1$h, [
    createElementVNode("div", _hoisted_2$f, [
      createVNode(_component_TInputComponent, {
        modelValue: _ctx.formData.code,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.formData.code = $event),
        "input-style": { width: "160px" },
        "replace-empty-symbol": _ctx.INIT_CODE_SYMBOL,
        "replace-length": _ctx.codeLength,
        caption: "\u041A\u043E\u0434 \u043F\u0443\u043D\u043A\u0442\u0430 \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F",
        onReset: _cache[1] || (_cache[1] = ($event) => _ctx.formData.code = _ctx.getInitFormData().code)
      }, null, 8, ["modelValue", "replace-empty-symbol", "replace-length"]),
      _hoisted_3$e
    ]),
    createElementVNode("div", _hoisted_4$c, [
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.CALC_CODE_INFO_DATA_ARRAY, (calcCodeInfo, i) => {
        return openBlock(), createElementBlock("div", {
          key: calcCodeInfo.label,
          class: "calc-code-storage"
        }, [
          createElementVNode("div", _hoisted_5$7, [
            createElementVNode("div", null, [
              createElementVNode("span", _hoisted_6$5, toDisplayString(calcCodeInfo.symbol.join(", ")) + " \u0441\u0438\u043C\u0432\u043E\u043B:", 1),
              createTextVNode(" " + toDisplayString(calcCodeInfo.label), 1)
            ]),
            calcCodeInfo.explanation ? (openBlock(), createBlock(_component_ButtonComponent, {
              key: 0,
              icon: _ctx.ICONS.faq,
              class: "button-opacity",
              onClick: ($event) => _ctx.onHelp(calcCodeInfo)
            }, null, 8, ["icon", "onClick"])) : createCommentVNode("", true)
          ]),
          createElementVNode("div", _hoisted_7$4, [
            calcCodeInfo.type === "combobox" ? (openBlock(), createBlock(_component_TRadioButton, {
              key: 0,
              data: calcCodeInfo.data,
              footerHelp: calcCodeInfo.explanations[_ctx.getFormDataValue(calcCodeInfo)],
              "is-view-key": true,
              "model-value": _ctx.getFormDataValue(calcCodeInfo),
              "onUpdate:modelValue": ($event) => _ctx.onSelected(calcCodeInfo, $event)
            }, null, 8, ["data", "footerHelp", "model-value", "onUpdate:modelValue"])) : calcCodeInfo.type === "select" ? (openBlock(), createBlock(_component_TSelectComponent, {
              key: 1,
              footerHelp: calcCodeInfo.explanations[_ctx.getFormDataValue(calcCodeInfo)],
              "is-value-view": true,
              "model-value": _ctx.getFormDataValue(calcCodeInfo),
              options: calcCodeInfo.data,
              optionsGroup: calcCodeInfo.dataGroup,
              onReset: ($event) => _ctx.onResetValue(calcCodeInfo),
              "onUpdate:modelValue": ($event) => _ctx.onSelected(calcCodeInfo, $event.value)
            }, null, 8, ["footerHelp", "model-value", "options", "optionsGroup", "onReset", "onUpdate:modelValue"])) : createCommentVNode("", true)
          ])
        ]);
      }), 128))
    ])
  ]);
}
var CalcCodeStorage = /* @__PURE__ */ _export_sfc(_sfc_main$q, [["render", _sfc_render$q]]);
var CalcCodeStorageDemo_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$p = defineComponent({
  name: "CalcCodeStorageDemo",
  emits: ["close", "open:component"],
  components: {
    ModalComponent,
    CalcCodeTerritory: CalcCodeStorage,
    ButtonComponent
  }
});
const _withScopeId$6 = (n) => (pushScopeId("data-v-5065f78c"), n = n(), popScopeId(), n);
const _hoisted_1$g = { class: "light-blue-modal-container calc-storage-modal" };
const _hoisted_2$e = /* @__PURE__ */ _withScopeId$6(() => /* @__PURE__ */ createElementVNode("div", { class: "light-blue-modal-container-title" }, "\u041A\u043E\u0434 \u043F\u0443\u043D\u043A\u0442\u0430 \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F", -1));
const _hoisted_3$d = { class: "light-blue-modal-container-footer" };
const _hoisted_4$b = /* @__PURE__ */ _withScopeId$6(() => /* @__PURE__ */ createElementVNode("div", null, null, -1));
function _sfc_render$p(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CalcCodeTerritory = resolveComponent("CalcCodeTerritory");
  const _component_ButtonComponent = resolveComponent("ButtonComponent");
  const _component_ModalComponent = resolveComponent("ModalComponent");
  return openBlock(), createBlock(_component_ModalComponent, {
    isShowBodyCloseButton: true,
    visible: true,
    "content-style": "overflow: auto;",
    "body-style": "padding: 0px;",
    style: { "min-width": "600px", "width": "100vw" },
    "button-close-style": "right: 10px; top: 10px",
    onClose: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("close"))
  }, {
    body: withCtx(() => [
      createElementVNode("div", _hoisted_1$g, [
        _hoisted_2$e,
        createVNode(_component_CalcCodeTerritory)
      ]),
      createElementVNode("div", _hoisted_3$d, [
        _hoisted_4$b,
        createVNode(_component_ButtonComponent, {
          class: "form-button",
          "data-type": "accent",
          onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("close"))
        }, {
          default: withCtx(() => [
            createTextVNode(" \u0417\u0430\u043A\u0440\u044B\u0442\u044C ")
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  });
}
var CalcCodeStorageDemo = /* @__PURE__ */ _export_sfc(_sfc_main$p, [["render", _sfc_render$p], ["__scopeId", "data-v-5065f78c"]]);
const y1 = 4.84 * 10 ** -18;
const y2 = 6.93 * 10 ** -7;
const y3 = 2.038 * 10 ** -2;
function getTotalActivityRaoDepletedUraniumProducts(M, t) {
  return 12.5 * 10 ** 3 * M * Math.exp(-y1 * t) + 12.5 * 10 ** 3 * M * y2 * (Math.exp(-y1 * t) / (y2 - y1) + Math.exp(-y2 * t) / (y1 - y2)) + 12.5 * 10 ** 3 * M * y2 * y3 * (Math.exp(-y1 * t) / ((y2 - y1) * (y3 - y1)) + Math.exp(-y2 * t) / ((y1 - y2) * (y3 - y2)) + Math.exp(-y3 * t) / ((y1 - y3) * (y2 - y3)));
}
var CalcTotalActivityRaoDepletedUraniumProducts_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$o = defineComponent({
  name: "CalcTotalActivityRaoDepletedUraniumProducts",
  props: {
    modelValue: String
  },
  emits: ["close", "init", "update:modelValue"],
  components: {
    TRadioButton,
    TInputComponent,
    TSelectComponent
  },
  setup() {
    return {
      unitsMass: ["\u0433", "\u043A\u0433", "\u0442\u043E\u043D\u043D\u0430"],
      unitsPeriod: ["\u0441\u0435\u043A", "\u043C\u0438\u043D", "\u0447\u0430\u0441", "\u0441\u0443\u0442\u043A", "\u043B\u0435\u0442"],
      UNITS_ACTIVITY
    };
  },
  data() {
    return {
      newValue: "",
      mass: null,
      unitMass: "\u0433",
      dateFrom: "",
      dateTo: "",
      period: null,
      unitPeriod: "\u0441\u0435\u043A",
      unitActivity: "\u0411\u043A",
      unitActivityNewValue: "\u0411\u043A"
    };
  },
  created() {
    this.newValue = this.modelValue || "";
    this.$emit("init");
  },
  methods: {
    onCalc() {
      const massGram = this.getMassGram(this.mass, this.unitMass);
      let periodSecond = this.getPeriodSecond(this.period, this.unitPeriod);
      if (periodSecond === 0) {
        const differenceSeconds = this.getDifferenceSeconds(
          this.dateFrom,
          this.dateTo
        );
        periodSecond = this.getPeriodSecond(Math.abs(differenceSeconds), "\u0441\u0435\u043A");
      }
      const newValueBk = getTotalActivityRaoDepletedUraniumProducts(
        massGram,
        periodSecond
      );
      const newValue = activityToUnit(newValueBk, this.unitActivity, true).toString();
      this.newValue = getExponential(6, toStr(newValue)).value;
      this.unitActivityNewValue = this.unitActivity;
      this.updateModelValue(newValueBk.toString());
    },
    getMassGram(mass, unit) {
      if (mass === null) {
        return 0;
      }
      switch (unit) {
        case "\u0433":
          return mass;
        case "\u043A\u0433":
          return mass * 1e3;
        case "\u0442\u043E\u043D\u043D\u0430":
          return mass * 1e3 * 1e3;
      }
    },
    getPeriodSecond(period, unit) {
      if (period === null) {
        return 0;
      }
      switch (unit) {
        case "\u0441\u0435\u043A":
          return period;
        case "\u043C\u0438\u043D":
          return period * 60;
        case "\u0447\u0430\u0441":
          return period * 60 * 60;
        case "\u0441\u0443\u0442\u043A":
          return period * 60 * 60 * 24;
        case "\u043B\u0435\u0442":
          return period * 60 * 60 * 24 * 365;
      }
    },
    getDifferenceSeconds(date1, date2) {
      if (!date1 || !date2) {
        return 0;
      }
      return (new Date(date1).valueOf() - new Date(date2).valueOf()) / 1e3;
    },
    updateModelValue(newValueBk) {
      this.$emit("update:modelValue", newValueBk);
    }
  },
  watch: {},
  computed: {}
});
const _withScopeId$5 = (n) => (pushScopeId("data-v-22f5e9f8"), n = n(), popScopeId(), n);
const _hoisted_1$f = { class: "calc-taraodup" };
const _hoisted_2$d = { class: "calc-taraodup_inputs" };
const _hoisted_3$c = { class: "calc-taraodup_inputs-row" };
const _hoisted_4$a = { class: "calc-taraodup_inputs-row" };
const _hoisted_5$6 = { class: "calc-taraodup_inputs-row" };
const _hoisted_6$4 = { style: { "display": "flex", "align-items": "center", "gap": "30px" } };
const _hoisted_7$3 = /* @__PURE__ */ _withScopeId$5(() => /* @__PURE__ */ createElementVNode("div", { class: "label-s18-c333" }, "\u0415\u0434\u0438\u043D\u0438\u0446\u0430 \u0438\u0437\u043C\u0435\u0440\u0435\u043D\u0438\u044F:", -1));
const _hoisted_8$1 = { style: { "display": "flex", "justify-content": "flex-end", "margin-bottom": "10px" } };
const _hoisted_9$1 = {
  key: 0,
  class: "calc-taraodup-result"
};
const _hoisted_10$1 = /* @__PURE__ */ _withScopeId$5(() => /* @__PURE__ */ createElementVNode("span", { class: "label-s18-c333" }, "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442 \u0440\u0430\u0441\u0447\u0451\u0442\u043E\u0432: ", -1));
const _hoisted_11$1 = { class: "calc-taraodup-result_value" };
function _sfc_render$o(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TInputComponent = resolveComponent("TInputComponent");
  const _component_TRadioButton = resolveComponent("TRadioButton");
  const _component_ButtonComponent = resolveComponent("ButtonComponent");
  return openBlock(), createElementBlock("div", _hoisted_1$f, [
    createElementVNode("div", _hoisted_2$d, [
      createElementVNode("div", _hoisted_3$c, [
        createVNode(_component_TInputComponent, {
          modelValue: _ctx.mass,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.mass = $event),
          modelModifiers: { number: true },
          caption: "\u041C\u0430\u0441\u0441\u0430",
          type: "number",
          onReset: _cache[1] || (_cache[1] = ($event) => _ctx.mass = null)
        }, null, 8, ["modelValue"]),
        createVNode(_component_TRadioButton, {
          modelValue: _ctx.unitMass,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.unitMass = $event),
          data: _ctx.unitsMass,
          "emit-prop": "value"
        }, null, 8, ["modelValue", "data"])
      ]),
      createElementVNode("div", _hoisted_4$a, [
        createVNode(_component_TInputComponent, {
          modelValue: _ctx.period,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => _ctx.period = $event),
          modelModifiers: { number: true },
          caption: "\u041F\u0435\u0440\u0438\u043E\u0434",
          type: "number",
          onReset: _cache[4] || (_cache[4] = ($event) => _ctx.period = null)
        }, null, 8, ["modelValue"]),
        createVNode(_component_TRadioButton, {
          modelValue: _ctx.unitPeriod,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => _ctx.unitPeriod = $event),
          data: _ctx.unitsPeriod,
          "emit-prop": "value"
        }, null, 8, ["modelValue", "data"])
      ]),
      createElementVNode("div", _hoisted_5$6, [
        createVNode(_component_TInputComponent, {
          modelValue: _ctx.dateFrom,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => _ctx.dateFrom = $event),
          caption: "\u0421",
          type: "date",
          onReset: _cache[7] || (_cache[7] = ($event) => _ctx.dateFrom = "")
        }, null, 8, ["modelValue"]),
        createVNode(_component_TInputComponent, {
          modelValue: _ctx.dateTo,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => _ctx.dateTo = $event),
          caption: "\u041F\u043E",
          type: "date",
          onReset: _cache[9] || (_cache[9] = ($event) => _ctx.dateTo = "")
        }, null, 8, ["modelValue"])
      ]),
      createElementVNode("div", _hoisted_6$4, [
        _hoisted_7$3,
        createVNode(_component_TRadioButton, {
          modelValue: _ctx.unitActivity,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => _ctx.unitActivity = $event),
          data: _ctx.UNITS_ACTIVITY,
          "emit-prop": "value"
        }, null, 8, ["modelValue", "data"])
      ])
    ]),
    createElementVNode("div", _hoisted_8$1, [
      createVNode(_component_ButtonComponent, {
        class: "form-button",
        onClick: _ctx.onCalc
      }, {
        default: withCtx(() => [
          createTextVNode(" \u0420\u0430\u0441\u0441\u0447\u0438\u0442\u0430\u0442\u044C ")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _ctx.newValue ? (openBlock(), createElementBlock("div", _hoisted_9$1, [
      _hoisted_10$1,
      createElementVNode("span", _hoisted_11$1, toDisplayString(_ctx.newValue), 1),
      createElementVNode("span", null, toDisplayString(" " + _ctx.unitActivityNewValue), 1)
    ])) : createCommentVNode("", true)
  ]);
}
var CalcTotalActivityRaoDepletedUraniumProducts = /* @__PURE__ */ _export_sfc(_sfc_main$o, [["render", _sfc_render$o], ["__scopeId", "data-v-22f5e9f8"]]);
var CalcTotalActivityRaoDepletedUraniumProductsDemo_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$n = defineComponent({
  name: "CalcTotalActivityRaoDepletedUraniumProductsDemo",
  emits: ["close", "open:component"],
  components: {
    TRadioButton,
    TInputComponent,
    ModalComponent,
    TSelectComponent,
    CalcTotalActivityRaoDepletedUraniumProducts,
    ButtonComponent
  },
  setup() {
    return { CALC_PARAMS };
  },
  data() {
    return {};
  },
  created() {
  },
  methods: {},
  watch: {},
  computed: {}
});
const _withScopeId$4 = (n) => (pushScopeId("data-v-155777a7"), n = n(), popScopeId(), n);
const _hoisted_1$e = { class: "light-blue-modal-container rao-calc-modal" };
const _hoisted_2$c = { class: "light-blue-modal-container-title" };
const _hoisted_3$b = { class: "light-blue-modal-container-footer" };
const _hoisted_4$9 = /* @__PURE__ */ _withScopeId$4(() => /* @__PURE__ */ createElementVNode("div", null, null, -1));
function _sfc_render$n(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CalcTotalActivityRaoDepletedUraniumProducts = resolveComponent("CalcTotalActivityRaoDepletedUraniumProducts");
  const _component_ButtonComponent = resolveComponent("ButtonComponent");
  const _component_ModalComponent = resolveComponent("ModalComponent");
  return openBlock(), createBlock(_component_ModalComponent, {
    isShowBodyCloseButton: true,
    visible: true,
    "body-style": "padding: 0px;",
    "content-style": "overflow: auto;",
    style: { "width": "100%", "max-width": "750px" },
    "button-close-style": "right: 10px; top: 10px",
    onClose: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("close"))
  }, {
    body: withCtx(() => [
      createElementVNode("div", _hoisted_1$e, [
        createElementVNode("div", _hoisted_2$c, toDisplayString(_ctx.CALC_PARAMS.CalcTotalActivityRaoDepletedUraniumProducts.header), 1),
        createVNode(_component_CalcTotalActivityRaoDepletedUraniumProducts),
        createElementVNode("div", _hoisted_3$b, [
          _hoisted_4$9,
          createVNode(_component_ButtonComponent, {
            class: "form-button",
            "data-type": "accent",
            onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("close"))
          }, {
            default: withCtx(() => [
              createTextVNode(" \u0417\u0430\u043A\u0440\u044B\u0442\u044C ")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  });
}
var CalcTotalActivityRaoDepletedUraniumProductsDemo = /* @__PURE__ */ _export_sfc(_sfc_main$n, [["render", _sfc_render$n], ["__scopeId", "data-v-155777a7"]]);
var CalcCodeWasteWaterReceiverDemo_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$m = defineComponent({
  name: "CalcCodeWasteWaterReceiverDemo",
  emits: ["close", "open:component"],
  components: {
    TRadioButton,
    TInputComponent,
    ModalComponent,
    TSelectComponent,
    CalcCodeWasteWaterReceiver
  },
  setup() {
    return {};
  },
  data() {
    return {};
  },
  created() {
  },
  methods: {},
  watch: {},
  computed: {}
});
const _withScopeId$3 = (n) => (pushScopeId("data-v-c54af2cc"), n = n(), popScopeId(), n);
const _hoisted_1$d = { class: "light-blue-modal-container calc-waste-water-modal" };
const _hoisted_2$b = /* @__PURE__ */ _withScopeId$3(() => /* @__PURE__ */ createElementVNode("div", { class: "light-blue-modal-container-title" }, " \u041A\u043E\u0434 \u0442\u0438\u043F\u0430 \u043F\u0440\u0438\u0451\u043C\u043D\u0438\u043A\u0430 \u0441\u0442\u043E\u0447\u043D\u044B\u0445 \u0432\u043E\u0434 ", -1));
const _hoisted_3$a = { class: "light-blue-modal-container-footer" };
const _hoisted_4$8 = /* @__PURE__ */ _withScopeId$3(() => /* @__PURE__ */ createElementVNode("div", null, null, -1));
function _sfc_render$m(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CalcCodeWasteWaterReceiver = resolveComponent("CalcCodeWasteWaterReceiver");
  const _component_ButtonComponent = resolveComponent("ButtonComponent");
  const _component_ModalComponent = resolveComponent("ModalComponent");
  return openBlock(), createBlock(_component_ModalComponent, {
    isShowBodyCloseButton: true,
    visible: true,
    "content-style": "overflow: auto;",
    "body-style": "padding: 0px;",
    style: { "min-width": "780px", "width": "100vw" },
    "button-close-style": "right: 10px; top: 10px",
    onClose: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("close"))
  }, {
    body: withCtx(() => [
      createElementVNode("div", _hoisted_1$d, [
        _hoisted_2$b,
        createVNode(_component_CalcCodeWasteWaterReceiver),
        createElementVNode("div", _hoisted_3$a, [
          _hoisted_4$8,
          createVNode(_component_ButtonComponent, {
            class: "form-button",
            "data-type": "accent",
            onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("close"))
          }, {
            default: withCtx(() => [
              createTextVNode(" \u0417\u0430\u043A\u0440\u044B\u0442\u044C ")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  });
}
var CalcCodeWasteWaterReceiverDemo = /* @__PURE__ */ _export_sfc(_sfc_main$m, [["render", _sfc_render$m], ["__scopeId", "data-v-c54af2cc"]]);
const _sfc_main$l = defineComponent({
  name: "DotsVerticalIcon"
});
const _hoisted_1$c = {
  fill: "none",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$a = /* @__PURE__ */ createElementVNode("path", {
  d: "M12 16C13.1 16 14 16.9 14 18C14 19.1 13.1 20 12 20C10.9 20 10 19.1 10 18C10 16.9 10.9 16 12 16ZM12 10C13.1 10 14 10.9 14 12C14 13.1 13.1 14 12 14C10.9 14 10 13.1 10 12C10 10.9 10.9 10 12 10ZM12 4C13.1 4 14 4.9 14 6C14 7.1 13.1 8 12 8C10.9 8 10 7.1 10 6C10 4.9 10.9 4 12 4Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3$9 = [
  _hoisted_2$a
];
function _sfc_render$l(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1$c, _hoisted_3$9);
}
var DotsVerticalIcon = /* @__PURE__ */ _export_sfc(_sfc_main$l, [["render", _sfc_render$l]]);
var AttrsComponent_vue_vue_type_style_index_0_lang = "";
const _sfc_main$k = defineComponent({
  name: "AttrsComponent",
  components: {
    AttrInputBase
  },
  props: {
    modelsDto: {
      type: Array,
      required: true
    },
    defaultInputContainerStyle: TVuePropTypes.style,
    types: {
      type: Object,
      required: true
    },
    readOnly: {
      type: Boolean,
      default: true
    },
    data: {
      type: Object,
      required: true
    },
    classAttrsContainer: {
      type: String,
      required: false
    },
    styleAttrsContainer: {
      type: TVuePropTypes.style,
      required: false
    },
    loadingObject: {
      type: Object,
      default: () => {
      }
    },
    changeAttrsDebounce: {
      type: Number
    },
    uniqueId: {
      type: String,
      required: true
    },
    customHelp: Boolean,
    emptyHelp: {
      type: String,
      required: false
    },
    getReadOnly: Function,
    validationHandlers: {
      type: Object,
      default: VALIDATION_HANDLERS
    },
    globalHandlers: { type: Object },
    autofocus: Boolean
  },
  emits: [
    "reset",
    "change-field",
    "click-help"
  ],
  data() {
    return {
      lastFocusModel: null,
      isDeactivated: false,
      inputValues: {}
    };
  },
  computed: {
    dataNotEmpty() {
      return this.data || {};
    },
    dataActual() {
      return { ...this.dataNotEmpty, ...this.inputValues };
    },
    loadingObjectComputed() {
      return this.loadingObject || {};
    }
  },
  methods: {
    onUpdateInputValue(model, value) {
      this.inputValues[model.field] = value;
    },
    onChangeField(model, value) {
      this.$emit("change-field", {
        model,
        value
      });
      delete this.inputValues[model.field];
      this.lastFocusModel = model;
    },
    onFocus(model, event) {
      this.lastFocusModel = model;
      this.updateGlobalContext();
    },
    getReadOnlyMethod(model) {
      const result = this.readOnly || model.readonly;
      if (this.getReadOnly) {
        return this.getReadOnly(model, result);
      }
      return result;
    },
    getType(model) {
      return this.types[model.type];
    },
    isShowAttr(model) {
      if (!model.hide_if_empty) {
        return true;
      }
      const value = this.dataNotEmpty[model.field];
      return toStr(value).length > 0;
    },
    updateGlobalContext() {
      const getThis = () => this;
      GlobalContext.setAssign({
        get selected_cell() {
          var _a;
          if (getThis().isDeactivated) {
            return void 0;
          }
          const model = getThis().lastFocusModel;
          if (!model) {
            return void 0;
          }
          return {
            field: model.field,
            value: (_a = getThis().dataActual[model.field]) != null ? _a : ""
          };
        },
        get selected_row() {
          if (getThis().isDeactivated) {
            return void 0;
          }
          return getThis().dataActual;
        }
      });
    }
  },
  deactivated() {
    this.isDeactivated = true;
  }
});
const _hoisted_1$b = { class: "attrs-component" };
function _sfc_render$k(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_AttrInputBase = resolveComponent("AttrInputBase");
  return openBlock(), createElementBlock("div", _hoisted_1$b, [
    createElementVNode("div", {
      class: normalizeClass(_ctx.classAttrsContainer),
      style: normalizeStyle(_ctx.styleAttrsContainer)
    }, [
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.modelsDto, (model, i) => {
        return openBlock(), createElementBlock(Fragment, {
          key: model.field
        }, [
          _ctx.isShowAttr(model) ? (openBlock(), createBlock(_component_AttrInputBase, {
            key: 0,
            autofocus: _ctx.autofocus && i === 0 ? true : void 0,
            "change-debounce": _ctx.changeAttrsDebounce,
            "custom-help": _ctx.customHelp,
            "default-style": _ctx.defaultInputContainerStyle,
            "empty-help": _ctx.emptyHelp,
            "global-handlers": _ctx.globalHandlers,
            "is-saving": _ctx.loadingObjectComputed[model.field] > 0,
            model,
            "read-only": _ctx.getReadOnlyMethod(model),
            type: _ctx.getType(model),
            types: _ctx.types,
            "unique-id": _ctx.uniqueId,
            "validation-handlers": _ctx.validationHandlers,
            value: _ctx.dataNotEmpty[model.field],
            onChange: ($event) => _ctx.onChangeField(model, $event),
            onFocus: ($event) => _ctx.onFocus(model, $event),
            onReset: ($event) => _ctx.$emit("reset", model),
            onClickHelp: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("click-help", $event)),
            "onUpdate:inputValue": ($event) => _ctx.onUpdateInputValue(model, $event)
          }, {
            "voc-header-toolbar-start": withCtx((payload) => [
              renderSlot(_ctx.$slots, "voc-header-toolbar-start", normalizeProps(guardReactiveProps(payload)))
            ]),
            _: 2
          }, 1032, ["autofocus", "change-debounce", "custom-help", "default-style", "empty-help", "global-handlers", "is-saving", "model", "read-only", "type", "types", "unique-id", "validation-handlers", "value", "onChange", "onFocus", "onReset", "onUpdate:inputValue"])) : createCommentVNode("", true)
        ], 64);
      }), 128))
    ], 6)
  ]);
}
var AttrsComponent = /* @__PURE__ */ _export_sfc(_sfc_main$k, [["render", _sfc_render$k]]);
var NotificationsComponent_vue_vue_type_style_index_0_scoped_true_lang = "";
let isRegistered = false;
const _sfc_main$j = defineComponent({
  name: "NotificationsComponent",
  data() {
    return {
      notifications: {},
      unsubs: []
    };
  },
  created() {
    if (isRegistered) {
      Logger$1.warn(
        "\u041A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442 \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0439 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D \u0431\u043E\u043B\u0435\u0435 \u043E\u0434\u043D\u043E\u0433\u043E \u0440\u0430\u0437\u0430. \u0423\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F \u0431\u0443\u0434\u0443\u0442 \u0434\u0443\u0431\u043B\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u044F."
      );
    }
    isRegistered = true;
    this.unsubs.push(
      NotificationsService$1.notificationsSubject.subscribe(
        (params) => {
          params.type = params.type || "default";
          params.duration = params.duration || 0;
          const id = makeId(10) + Date.now();
          this.notifications[id] = {
            id,
            params,
            unixDataClear: params.duration === 0 ? 0 : Date.now() + params.duration
          };
          if (params.duration !== 0) {
            sleep(params.duration).then(() => {
              this.removeNotification(id);
            });
          }
        }
      )
    );
  },
  deactivated() {
    this.unsubs.forEach((x) => x());
  },
  methods: {
    removeNotification(id) {
      delete this.notifications[id];
    },
    getText(notification) {
      const text = notification.params.text;
      return text === "string" ? text.trim() : text;
    }
  }
});
const _hoisted_1$a = { class: "notifications" };
const _hoisted_2$9 = ["data-type", "onClick"];
const _hoisted_3$8 = {
  key: 0,
  class: "notification__title"
};
const _hoisted_4$7 = {
  key: 1,
  class: "notification__text"
};
const _hoisted_5$5 = ["innerHTML"];
function _sfc_render$j(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$a, [
    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.notifications, (notification) => {
      return openBlock(), createElementBlock("div", {
        key: notification.id,
        "data-type": notification.params.type,
        style: normalizeStyle(notification.params.style),
        class: "notification",
        onClick: ($event) => _ctx.removeNotification(notification.id)
      }, [
        notification.params.title ? (openBlock(), createElementBlock("div", _hoisted_3$8, toDisplayString(notification.params.title), 1)) : createCommentVNode("", true),
        notification.params.text ? (openBlock(), createElementBlock("pre", _hoisted_4$7, toDisplayString(_ctx.getText(notification)), 1)) : createCommentVNode("", true),
        notification.params.html ? (openBlock(), createElementBlock("div", {
          key: 2,
          innerHTML: notification.params.html
        }, null, 8, _hoisted_5$5)) : createCommentVNode("", true)
      ], 12, _hoisted_2$9);
    }), 128))
  ]);
}
var NotificationsComponent = /* @__PURE__ */ _export_sfc(_sfc_main$j, [["render", _sfc_render$j], ["__scopeId", "data-v-bd05df46"]]);
var EditableHelpComponent_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$i = defineComponent({
  name: "EditableHelpComponent",
  components: { ButtonComponent },
  props: {
    style: TVuePropTypes.style,
    title: String,
    modelValue: String,
    editable: Boolean
  },
  emits: ["close", "click-edit"],
  setup() {
    return { ICONS };
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {
  },
  methods: {
    onEdit() {
      this.$emit("click-edit");
    }
  }
});
const _hoisted_1$9 = { class: "editable-help__div" };
const _hoisted_2$8 = { class: "editable-help__div-header" };
const _hoisted_3$7 = { style: { "display": "flex", "gap": "5px", "align-items": "flex-start", "overflow": "auto" } };
const _hoisted_4$6 = ["alt", "src"];
const _hoisted_5$4 = {
  key: 1,
  class: "app-label-s14-h20-c758 editable-help__div-header-value"
};
const _hoisted_6$3 = { class: "editable-help__value" };
function _sfc_render$i(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ButtonComponent = resolveComponent("ButtonComponent");
  return openBlock(), createBlock(Teleport, { to: "#modals" }, [
    createElementVNode("div", {
      style: normalizeStyle(_ctx.style),
      class: "editable-help"
    }, [
      createElementVNode("div", _hoisted_1$9, [
        createElementVNode("div", _hoisted_2$8, [
          createElementVNode("div", _hoisted_3$7, [
            createElementVNode("img", {
              alt: _ctx.ICONS.informationOutline.alt,
              src: _ctx.ICONS.informationOutline.src,
              class: "editable-help__div-icon"
            }, null, 8, _hoisted_4$6),
            _ctx.editable ? (openBlock(), createBlock(_component_ButtonComponent, {
              key: 0,
              icon: _ctx.ICONS.pencilOutline,
              class: "editable-help__div-icon button-opacity",
              style: { "zoom": "0.8" },
              onClick: _ctx.onEdit
            }, null, 8, ["icon", "onClick"])) : createCommentVNode("", true),
            _ctx.title ? (openBlock(), createElementBlock("div", _hoisted_5$4, toDisplayString(_ctx.title), 1)) : createCommentVNode("", true)
          ]),
          createVNode(_component_ButtonComponent, {
            icon: _ctx.ICONS.close,
            class: "button-opacity",
            onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("close"))
          }, null, 8, ["icon"])
        ]),
        createElementVNode("div", _hoisted_6$3, toDisplayString(_ctx.modelValue), 1)
      ])
    ], 4)
  ]);
}
var EditableHelpComponent = /* @__PURE__ */ _export_sfc(_sfc_main$i, [["render", _sfc_render$i], ["__scopeId", "data-v-2d00d174"]]);
function importDefault(path) {
  return import(
    /*webpackIgnore: true*/
    path
  ).then((x) => {
    if (isDev) {
      Logger$1.log("import", path, x);
    }
    return x.default;
  });
}
const RepoPartDefault = "default";
class RepoService {
  static async loadModel(url) {
    const repo = (await HttpService$1.get(url)).json;
    GlobalContext.setMerge({ repo });
    return repo;
  }
  static getRepo() {
    return GlobalContext.get("repo");
  }
  static setAttrType(typeName, typeDto) {
    GlobalContext.setMerge({
      repo: { attr_types: { [typeName]: void 0 } }
    });
    GlobalContext.setMerge({
      repo: { attr_types: { [typeName]: typeDto } }
    });
    return this;
  }
  static setAttrTypes(attr_types) {
    GlobalContext.setMutate((context) => {
      Object.keys(attr_types).forEach((attrName) => {
        if (!context.repo) {
          context.repo = {};
        }
        if (!context.repo.attr_types) {
          context.repo.attr_types = {};
        }
        context.repo.attr_types[attrName] = attr_types[attrName];
      });
    });
  }
  static getAttrType(typeName) {
    var _a, _b;
    return (_b = (_a = this.getRepo()) == null ? void 0 : _a.attr_types) == null ? void 0 : _b[typeName];
  }
  static getAttrTypes() {
    var _a, _b;
    return (_b = (_a = this.getRepo()) == null ? void 0 : _a.attr_types) != null ? _b : {};
  }
  static setAttr(attrName, attrModel, part = RepoPartDefault) {
    GlobalContext.setMerge({
      repo: {
        attrs: {
          [part]: { [attrName]: void 0 }
        }
      }
    });
    GlobalContext.setMutate((context) => {
      context.repo.attrs[part][attrName] = attrModel;
    });
    return this;
  }
  static updateAttr(attrName, key, value, part = RepoPartDefault) {
    GlobalContext.setMerge({
      repo: {
        attrs: {
          [part]: { [attrName]: { [key]: void 0 } }
        }
      }
    });
    GlobalContext.setMutate((context) => {
      context.repo.attrs[part][key] = value;
    });
  }
}
const modalApiObj = {
  commit: TDynamicModalService.commit.bind(TDynamicModalService),
  close: TDynamicModalService.close.bind(TDynamicModalService),
  show: TDynamicModalService.show.bind(TDynamicModalService)
};
function getApiDefaultPage(app, options, externalOptions) {
  var _a;
  let api = {
    ...(_a = externalOptions == null ? void 0 : externalOptions.api) != null ? _a : {},
    ...options,
    lib,
    app,
    importDefault,
    Router,
    Vue,
    modal: modalApiObj,
    context: GlobalContext,
    repo: RepoService
  };
  return api;
}
const PagePlugin = {
  install(app, options, externalOptions, provideDict) {
    if (provideDict) {
      Object.keys(provideDict).forEach(
        (key) => app.provide(key, provideDict[key])
      );
    }
    if (externalOptions == null ? void 0 : externalOptions.install) {
      externalOptions.install(app);
    }
    install(app);
    const api = getApiDefaultPage(app, options, externalOptions);
    app.provide("api", api);
    Logger$1.log("api", api);
  }
};
class PageService {
  static setExternalApi(externalApi) {
    this.externalOptions.api = externalApi;
  }
  static setExternalInstall(externalInstall) {
    this.externalOptions.install = externalInstall;
  }
  static setExternalOptions(externalOptions) {
    this.externalOptions = externalOptions;
  }
  static async createDefaultPage(rootContainer, componentOrUrl, route, options, params = {}, provideDict) {
    const url = "/api/repo/attr_types";
    const repo = await ApiService$1.useCache(
      url,
      () => HttpService$1.get(url).then((x) => x.json).catch((error) => {
        Logger$1.error(error);
        return null;
      })
    );
    GlobalContext.setMerge({ repo });
    const api2 = await importDefault(this.api2Url).catch((ex) => {
      Logger$1.warn("\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043F\u043E\u043F\u044B\u0442\u043A\u0435 \u0438\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C api2", { ex });
      return null;
    });
    const component = typeof componentOrUrl === "string" ? await importDefault(componentOrUrl) : componentOrUrl;
    const app = createApp(component, { route, ...params });
    const provideDictExtended = {
      ...provideDict != null ? provideDict : {},
      api2
    };
    PagePlugin.install(app, options, this.externalOptions, provideDictExtended);
    app.mount(rootContainer);
    return {
      app,
      component,
      api2
    };
  }
}
PageService.api2Url = `/api/frontend`;
PageService.externalOptions = {};
const _sfc_main$h = defineComponent({
  name: "TDynamicModal",
  components: {
    ScreenSpinner,
    ModalComponent
  },
  props: {},
  emits: [],
  setup() {
    return {};
  },
  data() {
    return {
      modals: {},
      modalsComponents: {},
      unsubs: []
    };
  },
  computed: {},
  watch: {},
  created() {
    this.unsubs.push(
      ...[
        TDynamicModalService.showSubject.subscribe((value) => {
          this.show(value);
        }),
        TDynamicModalService.closeSubject.subscribe((value) => {
          const modalId = this.getModalId(value.componentInstance);
          this.close(modalId);
        }),
        TDynamicModalService.commitSubject.subscribe((value) => {
          const modalId = this.getModalId(value.componentInstance);
          this.commit(modalId, value.result);
        })
      ]
    );
  },
  methods: {
    getModalId(componentInstance) {
      var _a;
      return (_a = componentInstance.__modalId) != null ? _a : componentInstance.api.__modalId;
    },
    async show(params) {
      const { componentOrUrl, resolve, reject, context } = params;
      const __modalId = toNormaliseDomId(componentOrUrl + makeId(8));
      this.modals[__modalId] = {
        __modalId,
        context,
        resolve,
        reject,
        loading: true,
        formProp: {
          set_caption: (caption) => {
            this.modals[__modalId].modalProps.title = caption;
          }
        },
        modalProps: {}
      };
      try {
        await this.$nextTick();
        await this.$nextTick();
        const root = document.getElementById(__modalId);
        if (!root) {
          debugger;
          throw new Error(`__modalId container not found: ${__modalId}`);
        }
        const defaultPage = await PageService.createDefaultPage(
          `#${__modalId}`,
          componentOrUrl,
          this.$route,
          {
            root,
            __modalId
          },
          {
            __modalId,
            context,
            form: this.modals[__modalId].formProp
          }
        );
        this.modals[__modalId].component = defaultPage.component;
        this.modals[__modalId].app = defaultPage.app;
        delete this.modals[__modalId].loading;
      } catch (ex) {
        this.modals[__modalId].errorMessage = await ApiHelper.getErrorMessage(
          ex
        );
        reject(ex);
        this.close(__modalId);
      }
    },
    commit(modalId, result) {
      const modal = this.modals[modalId];
      this.modalResolveAndClose(modal, result);
    },
    close(modalId) {
      const modal = this.modals[modalId];
      this.modalResolveAndClose(modal, void 0);
    },
    modalResolveAndClose(modal, result) {
      var _a;
      if (modal) {
        modal.resolve(result);
        (_a = modal.app) == null ? void 0 : _a.unmount();
        delete this.modals[modal.__modalId];
      }
    }
  },
  deactivated() {
    this.unsubs.forEach((unsub) => unsub());
    this.unsubs.length = 0;
  }
});
const _hoisted_1$8 = { class: "light-blue-modal-container flex-column-overflow-grow" };
const _hoisted_2$7 = {
  key: 0,
  class: "light-blue-modal-container-title"
};
const _hoisted_3$6 = ["id"];
const _hoisted_4$5 = {
  key: 1,
  class: "default-page-container default-page-padding-inline",
  style: { "font-size": "30px", "color": "#a80000" }
};
function _sfc_render$h(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ScreenSpinner = resolveComponent("ScreenSpinner");
  const _component_ModalComponent = resolveComponent("ModalComponent");
  return openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.modals, (m) => {
    return openBlock(), createBlock(_component_ModalComponent, {
      key: m.__modalId,
      "body-style": { padding: 0 },
      "content-style": { maxHeight: "100%" },
      isShowBodyCloseButton: true,
      visible: true,
      "button-close-style": "right: 10px; top: 10px",
      onClose: ($event) => _ctx.close(m.__modalId)
    }, {
      body: withCtx(({ close }) => [
        createElementVNode("div", _hoisted_1$8, [
          m.modalProps.title ? (openBlock(), createElementBlock("div", _hoisted_2$7, toDisplayString(m.modalProps.title), 1)) : createCommentVNode("", true),
          createElementVNode("div", {
            id: m.__modalId,
            class: "flex-column-overflow-grow"
          }, null, 8, _hoisted_3$6)
        ]),
        m.loading ? (openBlock(), createBlock(_component_ScreenSpinner, { key: 0 })) : createCommentVNode("", true),
        m.errorMessage ? (openBlock(), createElementBlock("div", _hoisted_4$5, toDisplayString(m.errorMessage), 1)) : createCommentVNode("", true)
      ]),
      _: 2
    }, 1032, ["onClose"]);
  }), 128);
}
var DynamicModal = /* @__PURE__ */ _export_sfc(_sfc_main$h, [["render", _sfc_render$h]]);
const _sfc_main$g = defineComponent({
  name: "ContextInput",
  components: {
    AttrInputBase
  },
  props: {
    field: String,
    part: {
      type: String,
      default: RepoPartDefault
    },
    modelValue: { type: String }
  },
  emits: ["update:modelValue"],
  setup() {
    return {};
  },
  data() {
    return {
      model: null,
      typesDto: null,
      isBeforeUnmount: false
    };
  },
  computed: {},
  watch: {},
  created() {
    watch(
      () => `${toStr(this.field)}_${toStr(this.part)}`,
      () => this.init(),
      { immediate: true }
    );
  },
  beforeUnmount() {
    this.isBeforeUnmount = true;
  },
  methods: {
    init() {
      var _a, _b, _c, _d;
      if (this.isBeforeUnmount) {
        return;
      }
      this.model = null;
      this.typesDto = null;
      const repo = this.getRepo();
      const model = (_b = (_a = repo == null ? void 0 : repo.attrs) == null ? void 0 : _a[this.part]) == null ? void 0 : _b[this.field];
      if (!repo || !model) {
        setTimeout(() => this.init(), 1e3);
        return;
      }
      this.model = model;
      if (this.model) {
        this.model.field = (_c = this.field) != null ? _c : this.model.field;
      }
      this.typesDto = (_d = repo.attr_types) != null ? _d : {};
    },
    getRepo() {
      return GlobalContext.get("repo");
    },
    onUpdateModelValue(value) {
      this.$emit("update:modelValue", value);
    }
  }
});
function _sfc_render$g(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_AttrInputBase = resolveComponent("AttrInputBase");
  return _ctx.model && _ctx.typesDto ? (openBlock(), createBlock(_component_AttrInputBase, {
    key: 0,
    model: _ctx.model,
    type: _ctx.typesDto[_ctx.model.type],
    types: _ctx.typesDto,
    value: _ctx.modelValue,
    onChange: _ctx.onUpdateModelValue,
    onReset: _cache[0] || (_cache[0] = ($event) => _ctx.onUpdateModelValue(""))
  }, null, 8, ["model", "type", "types", "value", "onChange"])) : createCommentVNode("", true);
}
var ContextInput = /* @__PURE__ */ _export_sfc(_sfc_main$g, [["render", _sfc_render$g]]);
var TActionProgress_vue_vue_type_style_index_0_lang = "";
const __default__$1 = defineComponent({
  name: "TActionProgress",
  components: {},
  props: {
    procId: {},
    progress: Number,
    message: String,
    status: String
  },
  emits: ["finish", "progress", "changed"],
  setup() {
    return {
      isNullOrUndefined,
      getStatusMessage(status) {
        var _a;
        if (!status) {
          return void 0;
        }
        const dict = {
          completed: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E",
          error: "\u041E\u0448\u0438\u0431\u043A\u0430",
          active: "\u0412\u044B\u043F\u043E\u043B\u043D\u044F\u0435\u0442\u0441\u044F"
        };
        return (_a = dict[status]) != null ? _a : status;
      }
    };
  },
  data() {
    return {
      actionProgress: null,
      timeouts: /* @__PURE__ */ new Set()
    };
  },
  computed: {
    progressComputed() {
      var _a, _b;
      return (_b = this.progress) != null ? _b : (_a = this.actionProgress) == null ? void 0 : _a.progress;
    },
    messageComputed() {
      var _a, _b;
      return (_b = this.message) != null ? _b : (_a = this.actionProgress) == null ? void 0 : _a.status_msg;
    },
    statusMessage() {
      var _a, _b;
      return this.getStatusMessage((_b = this.status) != null ? _b : (_a = this.actionProgress) == null ? void 0 : _a.status);
    }
  },
  watch: {},
  created() {
    watch(
      () => this.procId,
      async () => {
        if (this.procId !== void 0) {
          if (this.timeouts.has(this.procId)) {
            return;
          }
          this.timeouts.add(this.procId);
          this.actionProgress = null;
          await this.onUpdate();
        }
      },
      { immediate: true }
    );
    watch(() => this.progressComputed, () => {
      this.$emit("changed", this.actionProgress);
    });
  },
  methods: {
    async onUpdate() {
      var _a;
      if (isNullOrUndefined(this.procId)) {
        return;
      }
      if (this.actionProgress && this.actionProgress.status !== "active") {
        return;
      }
      try {
        this.actionProgress = (await HttpService$1.get(
          ApiService$1.getUrl(`/api/actions?`, {
            action: "progress",
            proc_id: this.procId
          })
        )).json;
      } catch (ex) {
        Logger$1.error("\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043F\u043E\u043F\u044B\u0442\u043A\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043F\u0440\u043E\u0433\u0440\u0435\u0441\u0441.", ex);
      }
      if (((_a = this.actionProgress) == null ? void 0 : _a.status) !== "active") {
        this.$emit("finish", this.actionProgress);
        this.timeouts.delete(this.procId);
        return;
      }
      this.$emit("progress", this.actionProgress);
      await sleep(500);
      return await this.onUpdate();
    }
  }
});
const __injectCSSVars__$1 = () => {
  useCssVars((_ctx) => ({
    "45ccf125": `${_ctx.progressComputed || 0}%`
  }));
};
const __setup__$1 = __default__$1.setup;
__default__$1.setup = __setup__$1 ? (props, ctx) => {
  __injectCSSVars__$1();
  return __setup__$1(props, ctx);
} : __injectCSSVars__$1;
const _sfc_main$f = __default__$1;
const _hoisted_1$7 = { class: "t-action-progress" };
const _hoisted_2$6 = { class: "t-action-progress__div" };
const _hoisted_3$5 = /* @__PURE__ */ createElementVNode("div", { class: "t-action-progress__progress-action" }, "\xA0", -1);
const _hoisted_4$4 = { class: "t-action-progress__progress-label" };
function _sfc_render$f(_ctx, _cache, $props, $setup, $data, $options) {
  return withDirectives((openBlock(), createElementBlock("div", _hoisted_1$7, [
    createElementVNode("div", _hoisted_2$6, [
      _hoisted_3$5,
      createElementVNode("div", _hoisted_4$4, [
        createElementVNode("div", null, toDisplayString(_ctx.progressComputed) + "%", 1)
      ])
    ])
  ], 512)), [
    [vShow, !_ctx.isNullOrUndefined(_ctx.progressComputed)]
  ]);
}
var TActionProgress = /* @__PURE__ */ _export_sfc(_sfc_main$f, [["render", _sfc_render$f]]);
var TInputFile_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$e = defineComponent({
  name: "TInputFile",
  components: {
    TActionProgress,
    ButtonComponent
  },
  props: {
    url: {
      type: String,
      default: "/api/files?action=upload"
    },
    dropzone: {
      type: Boolean,
      default: false
    }
  },
  emits: ["uploaded", "selected"],
  setup() {
    return {};
  },
  data() {
    return {
      progress: null,
      file: null,
      uploadProgress: "",
      unloaded: false,
      status: null
    };
  },
  computed: {
    fileSizeStr() {
      if (!this.file) {
        return "";
      }
      return this.getFileSizeStr(this.file.size);
    }
  },
  watch: {},
  created() {
  },
  methods: {
    getFileSizeStr(size) {
      if (size === null) {
        return "";
      }
      if (typeof size != "number") {
        size = size.size;
      }
      return `${Math.round(size / 1024 / 1024 * 10) / 10} \u041C\u0431`;
    },
    onDrop(ev) {
      var _a;
      ev.preventDefault();
      if ((_a = ev.dataTransfer) == null ? void 0 : _a.items) {
        const files = [...ev.dataTransfer.items].filter((item) => item.kind === "file").map((item) => item.getAsFile()).filter(Boolean);
        const dataTransfer = new DataTransfer();
        files.forEach((file) => dataTransfer.items.add(file));
        this.onFileSelected(dataTransfer.files, ev);
      } else {
        if (ev.dataTransfer) {
          this.onFileSelected(ev.dataTransfer.files, ev);
        }
      }
    },
    onInputFileSelected(event) {
      this.onFileSelected(this.$refs.file.files, event);
    },
    onFileSelected(files, originalEvent) {
      if (files.length > 1) {
        return;
      }
      this.$refs.file.files = files;
      this.file = files[0];
      this.status = "selected";
      this.uploadProgress = "";
      this.$emit("selected", this.file, originalEvent);
    },
    onProgress(event) {
      const progress = Math.round(event.loaded / event.total * 100);
      this.progress = progress;
    },
    async onUpload() {
      try {
        this.status = "loading";
        let file = this.file;
        let uploaded = await ApiService$1.uploadFile(
          file,
          this.url,
          this.onProgress
        );
        this.status = "uploaded";
        this.uploadProgress = "\u0417\u0430\u0433\u0440\u0443\u0436\u0435\u043D";
        this.$emit("uploaded", { uploaded });
      } catch (ex) {
        this.status = "error";
        this.progress = null;
      }
    }
  }
});
const _withScopeId$2 = (n) => (pushScopeId("data-v-0b81da87"), n = n(), popScopeId(), n);
const _hoisted_1$6 = { class: "t-input-file" };
const _hoisted_2$5 = { class: "t-input-file__buttons" };
const _hoisted_3$4 = { key: 0 };
const _hoisted_4$3 = {
  key: 1,
  style: { "color": "red" }
};
const _hoisted_5$3 = {
  key: 2,
  style: { "color": "green" }
};
const _hoisted_6$2 = /* @__PURE__ */ _withScopeId$2(() => /* @__PURE__ */ createElementVNode("div", null, "\u043F\u0435\u0440\u0435\u0442\u0430\u0449\u0438\u0442\u0435 \u0444\u0430\u0439\u043B \u0441\u044E\u0434\u0430", -1));
const _hoisted_7$2 = [
  _hoisted_6$2
];
function _sfc_render$e(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ButtonComponent = resolveComponent("ButtonComponent");
  const _component_TActionProgress = resolveComponent("TActionProgress");
  return openBlock(), createElementBlock("div", _hoisted_1$6, [
    createElementVNode("div", _hoisted_2$5, [
      createElementVNode("input", {
        ref: "file",
        type: "file",
        onChange: _cache[0] || (_cache[0] = (...args) => _ctx.onInputFileSelected && _ctx.onInputFileSelected(...args))
      }, null, 544),
      _ctx.fileSizeStr ? (openBlock(), createElementBlock("div", _hoisted_3$4, "\u0420\u0430\u0437\u043C\u0435\u0440: " + toDisplayString(_ctx.fileSizeStr), 1)) : createCommentVNode("", true),
      withDirectives(createVNode(_component_ButtonComponent, { onClick: _ctx.onUpload }, {
        default: withCtx(() => [
          createTextVNode(" \u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C ")
        ]),
        _: 1
      }, 8, ["onClick"]), [
        [vShow, _ctx.status === "selected" || _ctx.status === "error"]
      ]),
      _ctx.status === "error" ? (openBlock(), createElementBlock("div", _hoisted_4$3, "\u041E\u0428\u0418\u0411\u041A\u0410 \u0417\u0410\u0413\u0420\u0423\u0417\u041A\u0418")) : createCommentVNode("", true),
      _ctx.status === "uploaded" ? (openBlock(), createElementBlock("div", _hoisted_5$3, "\u0417\u0410\u0413\u0420\u0423\u0416\u0415\u041D")) : createCommentVNode("", true)
    ]),
    _ctx.dropzone ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: "t-input-file__drop_zone",
      onDragover: _cache[1] || (_cache[1] = withModifiers(() => {
      }, ["prevent"])),
      onDrop: _cache[2] || (_cache[2] = withModifiers((...args) => _ctx.onDrop && _ctx.onDrop(...args), ["prevent"]))
    }, _hoisted_7$2, 32)) : createCommentVNode("", true),
    _ctx.status === "loading" ? (openBlock(), createBlock(_component_TActionProgress, {
      key: 1,
      progress: _ctx.progress
    }, null, 8, ["progress"])) : createCommentVNode("", true)
  ]);
}
var TInputFile = /* @__PURE__ */ _export_sfc(_sfc_main$e, [["render", _sfc_render$e], ["__scopeId", "data-v-0b81da87"]]);
const _sfc_main$d = defineComponent({
  name: "TTable",
  components: {
    TableComponent,
    TableMultiHeaders,
    PanelFilters,
    TableActionsComponent
  },
  props: {
    headers: { type: Array },
    model: {
      type: Object
    },
    types: { type: Object },
    data: { type: Array },
    numCol: Boolean,
    numRow: {
      type: [String, Boolean],
      default: true
    },
    multiselect: Boolean
  },
  emits: [
    "row:update",
    "row:create",
    "row:delete",
    "row:check",
    "row:click",
    "row:dblclick",
    "row:keydown",
    "update:data",
    "update:data:event"
  ],
  setup() {
    return {};
  },
  data() {
    return {
      tableDataSet: null,
      factory: null
    };
  },
  computed: {
    rowsSelected() {
      if (!this.multiselect || !this.tableDataSet) {
        return [];
      }
      return this.tableDataSet.rows.filter((x) => x.select).map((x) => x.row);
    },
    leftColumnsComputed() {
      const result = [];
      if (this.multiselect) {
        result.push({
          key: "checkbox",
          type: "checkbox"
        });
      }
      if (this.numRow === true || typeof this.numRow === "string") {
        result.push({
          key: "numRow",
          caption: typeof this.numRow === "string" ? this.numRow : DEFAULT_LEFT_COLUMN_NAME
        });
      }
      return result;
    },
    currentData() {
      var _a, _b;
      return (_b = (_a = this.tableDataSet) == null ? void 0 : _a.rows.map((rowObj) => TableRow.getValue(rowObj))) != null ? _b : this.data;
    },
    modelArray() {
      const model = this.model;
      if (!model) {
        return [];
      }
      return Object.keys(model).map((field) => {
        if (model[field].field !== field) {
          model[field].field = field;
        }
        return model[field];
      });
    }
  },
  watch: {},
  async created() {
    await this.init();
    watch(
      () => [this.model, this.headers],
      async () => {
        this.tableDataSet = null;
        this.factory = null;
        await this.init();
        console.log(
          "TTable: \u041E\u0431\u043D\u043E\u0432\u0438\u043B\u0438\u0441\u044C model \u0438\u043B\u0438 headers, \u0442\u0430\u0431\u043B\u0438\u0446\u0430 \u0431\u0443\u0434\u0435\u0442 \u043F\u0435\u0440\u0435\u0441\u043E\u0437\u0434\u0430\u043D\u0430."
        );
      }
    );
    watch(
      () => this.data,
      async () => {
        if (!this.tableDataSet) {
          await this.init();
        }
      }
    );
    watch(
      () => this.numCol,
      () => {
        if (!this.tableDataSet) {
          return;
        }
        this.tableDataSet.options.display.rowIndexCol = Boolean(this.numCol);
      }
    );
  },
  methods: {
    async init() {
      var _a, _b;
      const rows = this.data;
      const headers = this.headers;
      if ([rows, headers, this.model].some(isNullOrUndefined)) {
        return;
      }
      const modelDtoArray = this.modelArray;
      const repo = GlobalContext.get("repo");
      const types = (_b = (_a = this.types) != null ? _a : repo == null ? void 0 : repo.attr_types) != null ? _b : {};
      const filtersSet = new PanelFiltersSet();
      filtersSet.subject.subscribe(this.onPanelFiltersExecute);
      const factory = new TableDataSetFactory({
        headers,
        modelDtoArray,
        tableName: "t-table",
        uniqId: `t-table_${makeId(5)}`,
        types,
        edit: {
          edit: true,
          rowMove: true,
          rowDelete: true,
          rowCreate: true,
          remark: false,
          hint: false,
          comment: false,
          warning: false
        },
        rows,
        repository: new TableLocalRepository(),
        tableDataSetOptions: {
          display: {
            incCol: 0,
            incRow: 0,
            rowIndexCol: Boolean(this.numCol)
          },
          filtersSet,
          listeners: {
            rowsAppend: {
              next: (e) => {
                this.onRowsAppend(e);
              }
            },
            updateCells: {
              next: (e) => {
                this.onUpdateCells(e);
              }
            },
            rowInsert: {
              next: (e) => {
                this.onRowInsert(e);
              }
            },
            rowDelete: {
              next: (e) => {
                this.onRowDelete(e);
              }
            },
            cellsClear: {
              next: (e) => {
                this.onCellsClear(e);
              }
            }
          }
        }
      });
      const tableDataSet = await factory.create();
      this.tableDataSet = tableDataSet;
      this.factory = factory;
    },
    setHelp(pointer) {
    },
    onPanelFiltersExecute(data) {
      var _a;
      const filterLogical = PanelFiltersFactory.toFilterLogical(data);
      (_a = this.tableDataSet) == null ? void 0 : _a.addOrReplaceInitialFilters([
        {
          key: "panel",
          filter: filterLogical
        }
      ]);
    },
    onUpdateData() {
      this.$emit("update:data", this.currentData);
    },
    onRowUpdate(event) {
      this.$emit("row:update", event);
      this.onUpdateDataEvent("row:update", event);
    },
    onRowCreate(event) {
      this.$emit("row:create", event);
      this.onUpdateDataEvent("row:create", event);
    },
    onRowDelete(e) {
      if (!e) {
        return;
      }
      this.$emit(
        "row:delete",
        e.pointers.map(({ row }) => this.getRowEmit({ row_no: row }))
      );
      this.onUpdateDataEvent("row:delete", e);
    },
    onCellsClear(e) {
      if (!e) {
        return;
      }
      const updates = [];
      e.pointers.forEach((pointer) => {
        updates.push(
          this.tableDataSet.getEmitUpdateValueCell(
            PointerHelper.getServerFormat(pointer),
            ""
          )
        );
      });
      this.onRowUpdate(this.getRowEmitsByUpdates(updates));
    },
    onRowCheck(row_no) {
      if (!this.multiselect || !this.tableDataSet) {
        return;
      }
      if (row_no !== void 0) {
        const rowObj = this.tableDataSet.getRowOrUndefined(row_no);
        if (rowObj) {
          rowObj.select = !rowObj.select;
        }
      } else {
        const newValue = !this.tableDataSet.isSelectedAll;
        this.tableDataSet.visibleRows.forEach((rowObj) => {
          rowObj.select = newValue;
        });
      }
      this.$emit("row:check", this.getRowEmit({ row_no }));
    },
    onRowClick(value) {
      this.$emit(
        "row:click",
        this.getRowEmit({
          row_no: value.pointer.row,
          col_name: value.pointer.col_name,
          event: value.event
        })
      );
    },
    onRowDblClick(value) {
      this.$emit(
        "row:dblclick",
        this.getRowEmit({
          row_no: value.pointer.row,
          col_name: value.pointer.col_name,
          event: value.event
        })
      );
    },
    onRowKeyDown(value) {
      this.$emit(
        "row:keydown",
        this.getRowEmit({
          row_no: value.pointer.row,
          col_name: value.pointer.col_name,
          event: value.event
        })
      );
    },
    groupUpdatesCellByRowNo(updates) {
      return groupBy(updates, (u) => u.pointer.row);
    },
    onUpdateCells(e) {
      if (!e) {
        return;
      }
      this.onRowUpdate(this.getRowEmitsByUpdates(e.updates));
    },
    onRowInsert(e) {
      if (!e) {
        return;
      }
      const updates = e.rowChange.changeCells.map(
        (changeCell) => this.getEmitUpdateCellByChangeCell(changeCell)
      );
      const rowEmit = this.getRowEmit({
        row_no: e.rowChange.row,
        updates
      });
      this.onRowCreate([rowEmit]);
    },
    onRowsAppend(e) {
      if (!e) {
        return;
      }
      e.onFinish.subscribe(({ rowChanges }) => {
        const rowEmits = [];
        rowChanges.forEach((rowChange) => {
          const rowEmit = this.getRowEmit({
            row_no: rowChange.row,
            updates: rowChange.changeCells.map(
              (changeCell) => this.getEmitUpdateCellByChangeCell(changeCell)
            )
          });
          rowEmits.push(rowEmit);
        });
        this.onRowCreate(rowEmits);
      });
    },
    onClickLeftColumn(value) {
      var _a;
      if (((_a = value.cell.leftColumn) == null ? void 0 : _a.key) === "checkbox") {
        this.onRowCheck();
        return;
      }
    },
    onUpdateDataEvent(event, value) {
      this.$nextTick(() => {
        this.onUpdateData();
      });
      this.$emit("update:data:event", {
        event,
        value
      });
    },
    getRowEmit({
      row_no,
      col_name,
      updates = [],
      event
    }) {
      const rowObj = this.tableDataSet.getRowOrUndefined(row_no);
      const attrs = rowObj ? TableRow.getValue(rowObj) : {};
      const check = Boolean(rowObj == null ? void 0 : rowObj.select);
      const updated = updates.reduce((updated2, update) => {
        const { col_name: col_name2 } = update.pointer;
        update.changes.forEach((change) => {
          if (change === "value") {
            updated2[col_name2] = {
              new: update.newValue.value,
              old: rowObj == null ? void 0 : rowObj.cells[col_name2].value
            };
          }
        });
        return updated2;
      }, {});
      return {
        row_no,
        col_name,
        attrs,
        check,
        this: this,
        updated,
        event,
        check_array: this.rowsSelected
      };
    },
    getRowEmitsByUpdates(updates) {
      const rowsUpdatesCell = this.groupUpdatesCellByRowNo(updates);
      return Object.keys(rowsUpdatesCell).map(
        (row_no) => this.getRowEmit({
          row_no: Number(row_no),
          updates: rowsUpdatesCell[row_no]
        })
      );
    },
    getEmitUpdateCellByChangeCell(changeCell) {
      return this.tableDataSet.getEmitUpdateCell({
        newValue: changeCell.changeCell,
        pointer: changeCell.pointer,
        changes: changeCell.changes
      });
    }
  }
});
const _hoisted_1$5 = {
  key: 0,
  ref: "rootDiv",
  class: "table-scroll-container"
};
const _hoisted_2$4 = {
  ref: "toolbarDiv",
  class: "default-page-padding-inline"
};
const _hoisted_3$3 = { class: "table-scroll-container" };
function _sfc_render$d(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TableActionsComponent = resolveComponent("TableActionsComponent");
  const _component_PanelFilters = resolveComponent("PanelFilters");
  const _component_TableMultiHeaders = resolveComponent("TableMultiHeaders");
  const _component_TableComponent = resolveComponent("TableComponent");
  return _ctx.tableDataSet && _ctx.factory ? (openBlock(), createElementBlock("div", _hoisted_1$5, [
    createElementVNode("div", _hoisted_2$4, [
      _ctx.tableDataSet.isTableMounted ? (openBlock(), createBlock(Teleport, {
        key: 0,
        disabled: !_ctx.tableDataSet.isFullScreenAndMounted,
        to: "#" + _ctx.tableDataSet.idContainerDivUp
      }, [
        createVNode(_component_TableActionsComponent, {
          ref: "tableActions",
          "table-data-set": _ctx.tableDataSet,
          "filter-state": "enable",
          style: { "padding-bottom": "5px" },
          "update-indexes-state": "hide"
        }, null, 8, ["table-data-set"]),
        _ctx.tableDataSet.options.filtersSet.open ? (openBlock(), createBlock(_component_PanelFilters, {
          key: 0,
          ref: "panelFilters",
          "data-set": _ctx.tableDataSet.options.filtersSet,
          "model-array": _ctx.tableDataSet.modelUnref,
          "table-data-set": _ctx.tableDataSet,
          types: _ctx.tableDataSet.types,
          style: { "padding-bottom": "5px" }
        }, null, 8, ["data-set", "model-array", "table-data-set", "types"])) : createCommentVNode("", true)
      ], 8, ["disabled", "to"])) : createCommentVNode("", true)
    ], 512),
    createElementVNode("div", _hoisted_3$3, [
      createVNode(_component_TableComponent, {
        ref: "table",
        "init-cursor": _ctx.tableDataSet.getFirstVisibleCellPointer(),
        "is-view-column-number": Boolean(_ctx.numRow),
        isShowInfo: false,
        "selection-mode": _ctx.multiselect ? "multiple" : void 0,
        "table-data-set": _ctx.tableDataSet,
        "onUpdate:cells": _cache[0] || (_cache[0] = ($event) => _ctx.tableDataSet.updateCells($event)),
        onRowAppend: _cache[1] || (_cache[1] = ($event) => _ctx.tableDataSet.rowAppend()),
        onRowInsert: _cache[2] || (_cache[2] = ($event) => _ctx.tableDataSet.rowInsert($event)),
        onRowDelete: _cache[3] || (_cache[3] = ($event) => _ctx.tableDataSet.rowDelete($event)),
        onRowDuplicate: _cache[4] || (_cache[4] = ($event) => _ctx.tableDataSet.rowDuplicate($event)),
        onRowDown: _cache[5] || (_cache[5] = ($event) => {
          _ctx.tableDataSet.rowMoveDown($event);
          _ctx.onUpdateDataEvent("row-down", $event);
        }),
        onRowUp: _cache[6] || (_cache[6] = ($event) => {
          _ctx.tableDataSet.rowMoveUp($event);
          _ctx.onUpdateDataEvent("row-up", $event);
        }),
        "onUpdate:cursor": _ctx.setHelp,
        onCellKeydown: _ctx.onRowKeyDown,
        onCellDblClick: _ctx.onRowDblClick,
        onCellClick: _ctx.onRowClick,
        onClickColumnSelect: _ctx.onRowCheck
      }, {
        headers: withCtx(({ classes, tableDataSet }) => [
          createVNode(_component_TableMultiHeaders, {
            classes,
            "left-columns": _ctx.leftColumnsComputed,
            "table-data-set": tableDataSet,
            onClickLeftColumn: _ctx.onClickLeftColumn,
            onClickLeftCol: ($event) => _ctx.multiselect ? _ctx.onRowCheck() : tableDataSet.selectedAll()
          }, null, 8, ["classes", "left-columns", "table-data-set", "onClickLeftColumn", "onClickLeftCol"])
        ]),
        _: 1
      }, 8, ["init-cursor", "is-view-column-number", "selection-mode", "table-data-set", "onUpdate:cursor", "onCellKeydown", "onCellDblClick", "onCellClick", "onClickColumnSelect"])
    ])
  ], 512)) : createCommentVNode("", true);
}
var TTable = /* @__PURE__ */ _export_sfc(_sfc_main$d, [["render", _sfc_render$d]]);
var TInputFiles_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$c = defineComponent({
  name: "TInputFiles",
  components: {
    TActionProgress,
    ButtonComponent
  },
  props: {
    url: {
      type: String,
      default: "/api/files?action=upload"
    },
    dropzone: {
      type: Boolean,
      default: false
    }
  },
  emits: ["uploaded", "selected"],
  setup() {
    return {};
  },
  data() {
    return {
      progress: null,
      files: null,
      unloaded: false,
      status: null,
      statusMap: /* @__PURE__ */ new Map()
    };
  },
  computed: {},
  watch: {},
  created() {
  },
  methods: {
    getRefs() {
      return {
        input: this.$refs.input
      };
    },
    getFileSizeStr(size) {
      if (size === null) {
        return "";
      }
      if (typeof size != "number") {
        size = size.size;
      }
      return `${Math.round(size / 1024 / 1024 * 10) / 10} \u041C\u0431`;
    },
    getFileStatus(file) {
      let status = this.getFileSizeStr(file.size);
      if (this.statusMap.has(file)) {
        status += `, ${this.statusMap.get(file)}`;
      }
      return status;
    },
    onDrop(ev) {
      var _a;
      ev.preventDefault();
      if ((_a = ev.dataTransfer) == null ? void 0 : _a.items) {
        const files = [...ev.dataTransfer.items].filter((item) => item.kind === "file").map((item) => item.getAsFile()).filter(Boolean);
        const dataTransfer = new DataTransfer();
        files.forEach((file) => dataTransfer.items.add(file));
        this.onFilesSelected(dataTransfer.files, ev);
      } else {
        if (ev.dataTransfer) {
          this.onFilesSelected(ev.dataTransfer.files, ev);
        }
      }
    },
    onInputFilesSelected(event) {
      this.onFilesSelected(this.getRefs().input.files, event);
    },
    onFilesSelected(files, originalEvent) {
      const { input } = this.getRefs();
      input.files = files;
      this.files = files;
      if (this.files) {
        this.status = "selected";
      } else {
        this.status = null;
      }
      this.$emit("selected", this.files, originalEvent);
    },
    getOnProgress(loaded, count) {
      return (event) => {
        const currentFileProgress = Math.round(
          event.loaded / event.total * 100
        );
        this.progress = (loaded * 100 + currentFileProgress) / count;
      };
    },
    async onUpload() {
      try {
        if (!this.files) {
          return;
        }
        this.statusMap.clear();
        this.status = "loading";
        const results = [];
        for (const file of this.files) {
          let result = await ApiService$1.uploadFile(
            file,
            this.url,
            this.getOnProgress(results.length, this.files.length)
          );
          results.push({ result });
          this.statusMap.set(file, "\u0437\u0430\u0433\u0440\u0443\u0436\u0435\u043D");
        }
        this.status = "uploaded";
        this.$emit("uploaded", results);
      } catch (ex) {
        this.status = "error";
        this.progress = null;
      }
    }
  }
});
const _withScopeId$1 = (n) => (pushScopeId("data-v-e802f83e"), n = n(), popScopeId(), n);
const _hoisted_1$4 = { class: "t-input-files" };
const _hoisted_2$3 = { class: "t-input-files__buttons" };
const _hoisted_3$2 = {
  key: 0,
  style: { "color": "red" }
};
const _hoisted_4$2 = {
  key: 1,
  style: { "color": "green" }
};
const _hoisted_5$2 = { class: "t-input-files__list" };
const _hoisted_6$1 = /* @__PURE__ */ _withScopeId$1(() => /* @__PURE__ */ createElementVNode("div", null, "\u043F\u0435\u0440\u0435\u0442\u0430\u0449\u0438\u0442\u0435 \u0444\u0430\u0439\u043B\u044B \u0441\u044E\u0434\u0430", -1));
const _hoisted_7$1 = [
  _hoisted_6$1
];
function _sfc_render$c(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ButtonComponent = resolveComponent("ButtonComponent");
  const _component_TActionProgress = resolveComponent("TActionProgress");
  return openBlock(), createElementBlock("div", _hoisted_1$4, [
    createElementVNode("div", _hoisted_2$3, [
      createElementVNode("input", {
        ref: "input",
        multiple: "",
        type: "file",
        onChange: _cache[0] || (_cache[0] = (...args) => _ctx.onInputFilesSelected && _ctx.onInputFilesSelected(...args))
      }, null, 544),
      withDirectives(createVNode(_component_ButtonComponent, { onClick: _ctx.onUpload }, {
        default: withCtx(() => [
          createTextVNode(" \u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C ")
        ]),
        _: 1
      }, 8, ["onClick"]), [
        [vShow, _ctx.status === "selected" || _ctx.status === "error"]
      ]),
      _ctx.status === "error" ? (openBlock(), createElementBlock("div", _hoisted_3$2, "\u041E\u0428\u0418\u0411\u041A\u0410 \u0417\u0410\u0413\u0420\u0423\u0417\u041A\u0418")) : createCommentVNode("", true),
      _ctx.status === "uploaded" ? (openBlock(), createElementBlock("div", _hoisted_4$2, "\u0417\u0410\u0413\u0420\u0423\u0416\u0415\u041D\u042B")) : createCommentVNode("", true)
    ]),
    createElementVNode("div", _hoisted_5$2, [
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.files, (file, i) => {
        return openBlock(), createElementBlock("div", {
          key: file.name + file.size
        }, toDisplayString(i + 1) + ". " + toDisplayString(file.name) + " (" + toDisplayString(_ctx.getFileStatus(file)) + ") ", 1);
      }), 128))
    ]),
    _ctx.dropzone ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: "t-input-files__drop_zone",
      onDragover: _cache[1] || (_cache[1] = withModifiers(() => {
      }, ["prevent"])),
      onDrop: _cache[2] || (_cache[2] = withModifiers((...args) => _ctx.onDrop && _ctx.onDrop(...args), ["prevent"]))
    }, _hoisted_7$1, 32)) : createCommentVNode("", true),
    _ctx.status === "loading" ? (openBlock(), createBlock(_component_TActionProgress, {
      key: 1,
      progress: _ctx.progress
    }, null, 8, ["progress"])) : createCommentVNode("", true)
  ]);
}
var TInputFiles = /* @__PURE__ */ _export_sfc(_sfc_main$c, [["render", _sfc_render$c], ["__scopeId", "data-v-e802f83e"]]);
var TCollapse_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$b = defineComponent({
  name: "TCollapse",
  components: {},
  props: {
    caption: String,
    contentStyle: TVuePropTypes.style,
    fixed: Boolean
  },
  emits: [],
  setup() {
    return {};
  },
  data() {
    return {
      open: true
    };
  },
  computed: {
    ICONS() {
      return ICONS;
    },
    openComputed() {
      return this.fixed || this.open;
    }
  },
  watch: {},
  created() {
  },
  methods: { boolToString }
});
const _hoisted_1$3 = { class: "t-collapse" };
const _hoisted_2$2 = ["data-open", "data-fixed"];
function _sfc_render$b(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ButtonComponent = resolveComponent("ButtonComponent");
  return openBlock(), createElementBlock("div", _hoisted_1$3, [
    createElementVNode("div", {
      "data-open": _ctx.boolToString(_ctx.openComputed),
      "data-fixed": _ctx.boolToString(_ctx.fixed),
      class: "t-collapse__header",
      onClick: _cache[0] || (_cache[0] = ($event) => _ctx.open = !_ctx.openComputed)
    }, [
      createTextVNode(toDisplayString(_ctx.caption) + " ", 1),
      renderSlot(_ctx.$slots, "header", {}, void 0, true),
      !_ctx.fixed ? (openBlock(), createBlock(_component_ButtonComponent, {
        key: 0,
        icon: _ctx.ICONS.chevronDown,
        iconRotate180: _ctx.openComputed,
        class: "button-opacity"
      }, null, 8, ["icon", "iconRotate180"])) : createCommentVNode("", true)
    ], 8, _hoisted_2$2),
    withDirectives(createElementVNode("div", {
      style: normalizeStyle(_ctx.contentStyle),
      class: "t-collapse__content"
    }, [
      renderSlot(_ctx.$slots, "default", {}, void 0, true)
    ], 4), [
      [vShow, _ctx.openComputed]
    ])
  ]);
}
var TCollapse = /* @__PURE__ */ _export_sfc(_sfc_main$b, [["render", _sfc_render$b], ["__scopeId", "data-v-5d910fa2"]]);
const tFlexProps = {
  column: Boolean,
  row: Boolean,
  end: Boolean,
  center: Boolean,
  gap: [Boolean, Number, String],
  grow: [Number, Boolean],
  alignItems: String,
  alignContent: String,
  justifyContent: String,
  justifyItems: String,
  padding: [Boolean, String, Number],
  margin: [Boolean, String, Number],
  width: [String, Number],
  maxWidth: [String, Number],
  minWidth: [String, Number],
  wrap: [Boolean, String, Number],
  basis: [Boolean, String, Number]
};
const tFlexProvideProps = {
  tCaptionWidth: [Number, String],
  formContext: Object
};
function getComputedTFlexProps(props) {
  return {
    justifyContentComputed: computed(() => {
      if (props.justifyContent) {
        return props.justifyContent;
      }
      if (props.end) {
        return "flex-end";
      }
      if (props.center) {
        return "center";
      }
      return void 0;
    }),
    justifyItemsComputed: computed(() => {
      if (props.justifyItems) {
        return props.justifyItems;
      }
      return void 0;
    }),
    alignItemsComputed: computed(() => {
      if (props.alignItems) {
        return props.alignItems;
      }
      return void 0;
    }),
    alignContentComputed: computed(() => {
      if (props.alignContent) {
        return props.alignContent;
      }
      return void 0;
    }),
    flexBasisComputed: computed(() => {
      if (props.basis === true) {
        return "0";
      }
      if (props.basis === false) {
        return void 0;
      }
      return props.basis;
    }),
    flexDirectionComputed: computed(() => {
      if (props.column) {
        return "column";
      }
      if (props.row) {
        return "row";
      }
      return void 0;
    }),
    flexGrowComputed: computed(() => {
      if (props.grow === true) {
        return 1;
      }
      if (isNullOrUndefined(props.grow) || props.grow === false) {
        return void 0;
      }
      return props.grow;
    }),
    flexWrapComputed: computed(() => {
      if (props.wrap === true) {
        return "wrap";
      }
      if (props.wrap === false) {
        return void 0;
      }
      return props.wrap;
    }),
    gapComputed: computed(() => {
      if (props.gap === true || props.gap === "") {
        return "5px";
      }
      if (props.gap === false || isNullOrUndefined(props.gap)) {
        return void 0;
      }
      if (isNumeric(props.gap)) {
        return `${props.gap}px`;
      }
      return props.gap;
    }),
    marginComputed: computed(() => {
      if (props.margin === true) {
        return "5px";
      }
      if (props.margin === false || isNullOrUndefined(props.margin)) {
        return void 0;
      }
      if (isNumeric(props.margin)) {
        return `${props.margin}px`;
      }
      return props.margin;
    }),
    paddingComputed: computed(() => {
      if (props.padding === true) {
        return "5px";
      }
      if (props.padding === false || isNullOrUndefined(props.padding)) {
        return void 0;
      }
      if (isNumeric(props.padding)) {
        return `${props.padding}px`;
      }
      return props.padding;
    }),
    widthComputed: computed(() => {
      if (isNumeric(props.width)) {
        return `${props.width}px`;
      }
      return props.width;
    }),
    maxWidthComputed: computed(() => {
      if (isNumeric(props.maxWidth)) {
        return `${props.maxWidth}px`;
      }
      return props.maxWidth;
    }),
    minWidthComputed: computed(() => {
      if (isNumeric(props.minWidth)) {
        return `${props.minWidth}px`;
      }
      return props.minWidth;
    })
  };
}
const tCaptionProps = {
  caption: String,
  captionWidth: [Number, String],
  tCaptionWidth: [Number, String],
  tInputProps: Object,
  tBorderProps: Object
};
var TCaption_vue_vue_type_style_index_0_lang = "";
const __default__ = defineComponent({
  name: "TCaption",
  components: {},
  props: {
    ...tCaptionProps,
    ...tFlexProps
  },
  emits: [],
  setup() {
    return {
      injectTCaptionWidth: inject(
        "tCaptionWidth",
        void 0
      )
    };
  },
  data() {
    return {
      open: false
    };
  },
  computed: {
    captionWidthComputed() {
      var _a;
      const captionWidth = (_a = this.captionWidth) != null ? _a : this.injectTCaptionWidth;
      if (isNumeric(captionWidth)) {
        return `${toNumberOrDefault(captionWidth)}px`;
      }
      return captionWidth;
    },
    ICONS() {
      return ICONS;
    }
  },
  watch: {},
  created() {
  },
  methods: { boolToString }
});
const __injectCSSVars__ = () => {
  useCssVars((_ctx) => ({
    "1a740aae": _ctx.captionWidthComputed
  }));
};
const __setup__ = __default__.setup;
__default__.setup = __setup__ ? (props, ctx) => {
  __injectCSSVars__();
  return __setup__(props, ctx);
} : __injectCSSVars__;
const _sfc_main$a = __default__;
const _hoisted_1$2 = { class: "t-caption__caption" };
function _sfc_render$a(_ctx, _cache, $props, $setup, $data, $options) {
  var _a;
  const _component_TInput = resolveComponent("TInput");
  const _component_TFlex = resolveComponent("TFlex");
  return openBlock(), createBlock(_component_TFlex, mergeProps(_ctx.$props, {
    "justify-content": (_a = _ctx.justifyContent) != null ? _a : "space-between",
    gap: _ctx.gap === false ? 5 : _ctx.gap,
    class: "t-caption"
  }), {
    default: withCtx(() => [
      createElementVNode("span", _hoisted_1$2, toDisplayString(_ctx.caption), 1),
      (openBlock(), createBlock(resolveDynamicComponent(_ctx.tBorderProps ? "TBorder" : "div"), mergeProps(_ctx.tBorderProps, {
        "t-caption-width": _ctx.tCaptionWidth,
        class: "t-caption__content"
      }), {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default"),
          _ctx.tInputProps ? (openBlock(), createBlock(_component_TInput, normalizeProps(mergeProps({ key: 0 }, _ctx.tInputProps)), null, 16)) : createCommentVNode("", true)
        ]),
        _: 3
      }, 16, ["t-caption-width"]))
    ]),
    _: 3
  }, 16, ["justify-content", "gap"]);
}
var TCaption = /* @__PURE__ */ _export_sfc(_sfc_main$a, [["render", _sfc_render$a]]);
function useProvideTCaptionWidth(props) {
  const injectTCaptionWidth = inject("tCaptionWidth", void 0);
  provide(
    "tCaptionWidth",
    computed(
      () => {
        var _a;
        return (_a = props.tCaptionWidth) != null ? _a : injectTCaptionWidth == null ? void 0 : injectTCaptionWidth.value;
      }
    )
  );
}
function useProvideFormContext(props) {
  const injectFormContext = inject("formContext", void 0);
  provide(
    "formContext",
    computed(
      () => {
        var _a;
        return (_a = props.formContext) != null ? _a : injectFormContext == null ? void 0 : injectFormContext.value;
      }
    )
  );
}
function useProvideTFlex(props) {
  useProvideFormContext(props);
  useProvideTCaptionWidth(props);
}
function useFormContext() {
  const formContext = inject(
    "formContext",
    void 0
  );
  return formContext;
}
function useOnChangeInput() {
  const formContext = inject(
    "onChangeInput",
    void 0
  );
  return formContext;
}
var TBorder_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$9 = defineComponent({
  name: "TBorder",
  components: {},
  props: {
    caption: String,
    ...tFlexProps,
    ...tFlexProvideProps
  },
  emits: [],
  setup(props) {
    useProvideTFlex(props);
    return {
      boolToString
    };
  },
  data() {
    return {
      open: false
    };
  },
  computed: {
    ICONS() {
      return ICONS;
    }
  },
  watch: {},
  created() {
  },
  methods: {}
});
function _sfc_render$9(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TFlex = resolveComponent("TFlex");
  return openBlock(), createBlock(_component_TFlex, mergeProps({ class: "t-border" }, _ctx.$props), {
    default: withCtx(() => [
      renderSlot(_ctx.$slots, "default", {}, void 0, true)
    ]),
    _: 3
  }, 16);
}
var TBorder = /* @__PURE__ */ _export_sfc(_sfc_main$9, [["render", _sfc_render$9], ["__scopeId", "data-v-624072bb"]]);
const tInputProps = {
  caption: String,
  name: {
    type: String,
    required: true
  },
  readonly: Boolean
};
var TInput_vue_vue_type_style_index_0_lang = "";
const _sfc_main$8 = defineComponent({
  name: "TInput",
  components: {},
  props: {
    ...tInputProps,
    name: {
      type: String,
      required: true
    }
  },
  emits: ["change"],
  setup(props) {
    const formContext = useFormContext();
    const onChangeInput = useOnChangeInput();
    if (!(formContext == null ? void 0 : formContext.value)) {
      throw new Error("formContext not provided");
    }
    return {
      formContext,
      onChangeInput
    };
  },
  data() {
    return {
      open: false
    };
  },
  computed: {
    model() {
      var _a, _b;
      return (_b = this.formContext.getModel(this.name)) != null ? _b : {
        field: this.name,
        caption: (_a = this.caption) != null ? _a : this.name
      };
    },
    type() {
      var _a;
      return (_a = this.formContext.data.types[this.model.type]) != null ? _a : DEFAULT_REPOSITORY_READ_TYPE_DTO;
    },
    readonlyComputed() {
      const result = this.readonly || this.model.readonly;
      return result;
    }
  },
  watch: {},
  created() {
  },
  methods: {
    onChange(model, value) {
      const change = {
        model,
        value
      };
      this.formContext.setChange(change);
      this.onChangeEmit(model, value);
    },
    onChangeEmit(model, value) {
      var _a;
      const valueChange = { [model.field]: value };
      this.$emit("change", valueChange);
      (_a = this.onChangeInput) == null ? void 0 : _a.call(this, valueChange);
    },
    onReset(model) {
      const value = this.formContext.data.initialData[model.field];
      const change = {
        model,
        value
      };
      this.formContext.setChange(change);
      this.onChangeEmit(model, value);
    }
  }
});
function _sfc_render$8(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_AttrInputBase = resolveComponent("AttrInputBase");
  return openBlock(), createBlock(_component_AttrInputBase, {
    caption: _ctx.caption,
    "force-update-value-prop": _ctx.formContext.data.currentData,
    model: _ctx.model,
    "read-only": _ctx.readonlyComputed,
    type: _ctx.type,
    types: _ctx.formContext.data.types,
    value: _ctx.formContext.data.currentData[_ctx.model.field],
    class: "t-input",
    "is-hide-caption": "",
    "is-hide-reset": "",
    onChange: _cache[0] || (_cache[0] = ($event) => _ctx.onChange(_ctx.model, $event)),
    onReset: _cache[1] || (_cache[1] = ($event) => _ctx.onReset(_ctx.model))
  }, null, 8, ["caption", "force-update-value-prop", "model", "read-only", "type", "types", "value"]);
}
var TInput = /* @__PURE__ */ _export_sfc(_sfc_main$8, [["render", _sfc_render$8]]);
var TFlex_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$7 = defineComponent({
  name: "TFlex",
  components: {},
  props: {
    class: TVuePropTypes.class,
    style: TVuePropTypes.style,
    ...tFlexProps,
    ...tFlexProvideProps
  },
  emits: [],
  setup(props) {
    useProvideTFlex(props);
    const flexPropsComputed = getComputedTFlexProps(props);
    return {
      flexPropsKeys: computed(() => Object.keys(flexPropsComputed)),
      ...flexPropsComputed
    };
  },
  data() {
    return {};
  },
  computed: {
    classComputed() {
      return [this.class, "t-flex"];
    },
    styleComputed() {
      const style = [];
      const flexStyle = {};
      this.flexPropsKeys.forEach((key) => {
        if (this[key] === void 0) {
          return;
        }
        const styleKey = key.substring(0, key.length - "Computed".length);
        flexStyle[styleKey] = this[key];
      });
      style.push(flexStyle);
      if (this.style) {
        style.push(this.style);
      }
      return style;
    }
  },
  watch: {},
  created() {
  },
  methods: {}
});
function _sfc_render$7(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(_ctx.classComputed),
    style: normalizeStyle(_ctx.styleComputed)
  }, [
    renderSlot(_ctx.$slots, "default", {}, void 0, true)
  ], 6);
}
var TFlex = /* @__PURE__ */ _export_sfc(_sfc_main$7, [["render", _sfc_render$7], ["__scopeId", "data-v-e1bf0b1c"]]);
const tBoxColumnProps = {
  caption: String,
  tCaptionWidth: [Number, String]
};
var TBoxColumn_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$6 = defineComponent({
  name: "TBoxColumn",
  components: {},
  props: {
    ...tBoxColumnProps,
    ...tFlexProps
  },
  emits: [],
  setup() {
    return {};
  },
  data() {
    return {
      open: false
    };
  },
  computed: {
    ICONS() {
      return ICONS;
    }
  },
  watch: {},
  created() {
  },
  methods: {}
});
function _sfc_render$6(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TCaption = resolveComponent("TCaption");
  return openBlock(), createBlock(_component_TCaption, mergeProps(_ctx.$props, {
    "t-border-props": {
      grow: true,
      column: true,
      gap: true,
      padding: true,
      wrap: true,
      tCaptionWidth: _ctx.tCaptionWidth
    },
    basis: "",
    class: "t-box-column",
    column: "",
    gap: "",
    grow: "",
    wrap: ""
  }), {
    default: withCtx(() => [
      renderSlot(_ctx.$slots, "default", {}, void 0, true)
    ]),
    _: 3
  }, 16, ["t-border-props"]);
}
var TBoxColumn = /* @__PURE__ */ _export_sfc(_sfc_main$6, [["render", _sfc_render$6], ["__scopeId", "data-v-d63f815e"]]);
var TBoxRow_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$5 = defineComponent({
  name: "TBoxRow",
  components: {},
  props: {
    caption: String,
    tCaptionWidth: [Number, String],
    ...tFlexProps
  },
  emits: [],
  setup() {
    return {};
  },
  data() {
    return {
      open: false
    };
  },
  computed: {
    ICONS() {
      return ICONS;
    }
  },
  watch: {},
  created() {
  },
  methods: {}
});
function _sfc_render$5(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TFlex = resolveComponent("TFlex");
  const _component_TBorder = resolveComponent("TBorder");
  const _component_TCaption = resolveComponent("TCaption");
  return openBlock(), createBlock(_component_TCaption, mergeProps(_ctx.$props, {
    class: "t-box-row",
    grow: "",
    column: ""
  }), {
    default: withCtx(() => [
      createVNode(_component_TFlex, {
        grow: "",
        gap: ""
      }, {
        default: withCtx(() => [
          createVNode(_component_TBorder, {
            grow: "",
            column: "",
            gap: "",
            padding: ""
          }, {
            default: withCtx(() => [
              createVNode(_component_TFlex, {
                gap: "",
                wrap: ""
              }, {
                default: withCtx(() => [
                  renderSlot(_ctx.$slots, "default", {}, void 0, true)
                ]),
                _: 3
              })
            ]),
            _: 3
          })
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 16);
}
var TBoxRow = /* @__PURE__ */ _export_sfc(_sfc_main$5, [["render", _sfc_render$5], ["__scopeId", "data-v-0dc00fbc"]]);
var TCaptionInput_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$4 = defineComponent({
  name: "TCaptionInput",
  components: {},
  props: {
    ...tInputProps,
    ...tCaptionProps,
    name: {
      type: String,
      required: true
    },
    inputStyle: TVuePropTypes.style,
    inputClass: TVuePropTypes.class
  },
  emits: ["change"],
  setup() {
    const formContext = useFormContext();
    if (!(formContext == null ? void 0 : formContext.value)) {
      throw new Error("formContext not provided");
    }
    return {
      formContext,
      boolToString
    };
  },
  data() {
    return {
      open: false
    };
  },
  computed: {
    ICONS() {
      return ICONS;
    },
    model() {
      var _a, _b;
      return (_b = this.formContext.getModel(this.name)) != null ? _b : {
        field: this.name,
        caption: (_a = this.caption) != null ? _a : this.name
      };
    }
  },
  watch: {},
  created() {
  },
  methods: {
    onChange(event) {
      this.$emit("change", event);
    }
  }
});
function _sfc_render$4(_ctx, _cache, $props, $setup, $data, $options) {
  var _a, _b;
  const _component_TInput = resolveComponent("TInput");
  const _component_TCaption = resolveComponent("TCaption");
  return openBlock(), createBlock(_component_TCaption, {
    "align-items": "center",
    caption: (_b = _ctx.caption) != null ? _b : ((_a = _ctx.model) == null ? void 0 : _a.caption) + ":",
    class: "t-caption-input"
  }, {
    default: withCtx(() => [
      createVNode(_component_TInput, {
        caption: _ctx.caption,
        class: normalizeClass(_ctx.inputClass),
        name: _ctx.name,
        style: normalizeStyle(_ctx.inputStyle),
        readonly: _ctx.readonly,
        onChange: _ctx.onChange
      }, null, 8, ["caption", "class", "name", "style", "readonly", "onChange"])
    ]),
    _: 1
  }, 8, ["caption"]);
}
var TCaptionInput = /* @__PURE__ */ _export_sfc(_sfc_main$4, [["render", _sfc_render$4], ["__scopeId", "data-v-ab59370c"]]);
var TBoxColumnContainer_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$3 = defineComponent({
  name: "TBoxColumnContainer",
  components: {},
  props: {
    ...tBoxColumnProps,
    ...tFlexProps
  },
  emits: [],
  setup() {
    return {};
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {
  },
  methods: {}
});
function _sfc_render$3(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TFlex = resolveComponent("TFlex");
  return openBlock(), createBlock(_component_TFlex, mergeProps(_ctx.$props, {
    class: "t-box-column-container",
    gap: "",
    wrap: ""
  }), {
    default: withCtx(() => [
      renderSlot(_ctx.$slots, "default", {}, void 0, true)
    ]),
    _: 3
  }, 16);
}
var TBoxColumnContainer = /* @__PURE__ */ _export_sfc(_sfc_main$3, [["render", _sfc_render$3], ["__scopeId", "data-v-b9a27d20"]]);
var TBoxContainer_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$2 = defineComponent({
  name: "TBoxContainer",
  components: {},
  props: {
    ...tFlexProps,
    ...tFlexProvideProps
  },
  emits: ["change"],
  setup(props, context) {
    const onChange = (event) => {
      context.emit("change", event);
    };
    provide("onChangeInput", onChange);
    return {};
  },
  data() {
    return {};
  },
  computed: {
    formContextLoading() {
      if (this.formContext === void 0) {
        return false;
      }
      return this.formContext === null || !this.formContext.data.repository;
    }
  },
  watch: {},
  created() {
  },
  methods: {}
});
function _sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ScreenSpinner = resolveComponent("ScreenSpinner");
  const _component_TFlex = resolveComponent("TFlex");
  return openBlock(), createBlock(_component_TFlex, mergeProps(_ctx.$props, {
    class: "t-box-container",
    column: "",
    gap: "",
    grow: ""
  }), {
    default: withCtx(() => [
      _ctx.formContextLoading ? (openBlock(), createBlock(_component_ScreenSpinner, {
        key: 0,
        absolute: false
      })) : renderSlot(_ctx.$slots, "default", { key: 1 }, void 0, true)
    ]),
    _: 3
  }, 16);
}
var TBoxContainer = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["render", _sfc_render$2], ["__scopeId", "data-v-7a05d1f8"]]);
var TableCellModalSelect_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$1 = defineComponent({
  name: "TableCellModalSelect",
  props: {
    context: {
      type: Object,
      required: true
    },
    form: {
      type: Object,
      required: true
    },
    route: {
      type: Object,
      required: true
    }
  },
  provide: {
    form: Object,
    api: Object
  },
  components: {
    SearchComponent,
    ButtonComponent,
    CircleLoader,
    TablePaginationBottom
  },
  setup() {
    const api = inject("api");
    return {
      api,
      ICONS,
      declension,
      boolToString
    };
  },
  data() {
    return {
      loading: true,
      tableDataSet: null,
      tableDataSetFactory: null,
      vocDataSet: null,
      show: {
        footer: true
      },
      newValue: {},
      updateSearchDebounce: debounce(this.updateSearch, 300)
    };
  },
  async created() {
    var _a, _b;
    this.$watch(
      () => {
        var _a2;
        return (_a2 = this.vocDataSet) == null ? void 0 : _a2.data.search;
      },
      () => {
        if (!this.vocDataSet) {
          return;
        }
        this.updateSearchDebounce();
      }
    );
    this.$watch(
      () => this.initialFilters,
      () => {
        const tableDataSet = this.getTableDataSet();
        if (!tableDataSet) {
          return;
        }
        tableDataSet.setInitialFilters(this.initialFilters);
        tableDataSet.getVisibleRows();
      },
      { immediate: true }
    );
    this.form.set_caption(
      (_b = (_a = this.repository) == null ? void 0 : _a.caption) != null ? _b : this.context.model.caption
    );
    await this.init();
    this.loading = false;
  },
  computed: {
    initialFilters() {
      if (!this.vocDataSet) {
        return [];
      }
      const filters = [
        ...this.vocDataSet.data.searchFilters.map((filter) => ({
          key: "search",
          filter
        })),
        ...this.vocDataSet.data.panelFilters.map((filter) => ({
          key: "panel",
          filter
        }))
      ];
      if (this.modelVocFilter) {
        filters.push({
          key: "model",
          filter: this.modelVocFilter
        });
      }
      return filters.filter(
        (x) => Boolean(x.filter)
      );
    },
    modelVocFilter() {
      var _a;
      return FilterFactory.parseString((_a = this.model) == null ? void 0 : _a.voc_filter);
    },
    selectionMode() {
      return ModelHelper.getSelectionMode(this.context.model, this.type);
    },
    type() {
      return this.context.type;
    },
    model() {
      return this.context.model;
    },
    isShowFooter() {
      return this.selectionMode === "multiple" && this.show.footer;
    },
    repository() {
      return this.type.select_form;
    },
    serverFilterSort() {
      var _a, _b, _c;
      return (_c = (_b = (_a = this.repository) == null ? void 0 : _a.form.table.options) == null ? void 0 : _b.server_filter_sort) != null ? _c : true;
    },
    modelSort() {
      var _a;
      if (!this.tableDataSet || !((_a = this.vocDataSet) == null ? void 0 : _a.cachedVoc)) {
        return [];
      }
      const { headers, model } = this.vocDataSet.cachedVoc.dto.form.table;
      return getModelDtoSort(headers, model);
    },
    valueByNewValue() {
      return Object.keys(this.newValue).join(`${VOC_JOIN_SEPARATOR} `);
    },
    valuesValueIdDict() {
      if (!this.tableDataSet) {
        return {};
      }
      return this.tableDataSet.rows.reduce((value, tableRow, row) => {
        const vocValue = tableRow.original;
        value[toStr(vocValue.value_id)] = {
          voc: vocValue,
          tableRow,
          row
        };
        return value;
      }, {});
    },
    rowsSelected() {
      return Object.keys(this.newValue).length;
    }
  },
  methods: {
    getVocDataSet() {
      if (!this.vocDataSet) {
        throw new Error("not found vocDataSet");
      }
      return this.vocDataSet;
    },
    getTableDataSetFactory() {
      if (!this.tableDataSetFactory) {
        throw new Error("not found tableDataSetFactory");
      }
      return this.tableDataSetFactory;
    },
    getTableDataSet() {
      return this.tableDataSet;
    },
    async init() {
      var _a, _b;
      if (!this.repository) {
        Logger$1.warn("not found repository");
        return;
      }
      const staticParams = {
        action: "select"
      };
      const serverFilterSort = ((_a = this.repository.form.table.options) == null ? void 0 : _a.server_filter_sort) !== false;
      this.vocDataSet = new VocDataSet(
        void 0,
        this.type,
        (_b = this.repository.data_source_url) != null ? _b : this.context.uniqueId,
        {
          staticParams,
          lazyLoadSize: serverFilterSort ? this.repository.lazy_load_size : void 0,
          filter: serverFilterSort ? this.route.query.filter : void 0,
          getRowAttrs: (x) => x,
          listUrl: this.repository.data_source_url
        }
      );
      this.vocDataSet.setContext(GlobalContext.get());
      if (this.serverFilterSort) {
        const filter = this.initialFilters.length ? FilterFactory.createLogical(
          "and",
          this.initialFilters.map((x) => x.filter)
        ) : void 0;
        this.vocDataSet.setFilter(filter);
      }
      await this.vocDataSet.get();
      if (this.tableDataSet === null) {
        await this.initTableDataSet();
      }
      this.updateSearch();
      this.initCurrentSelectedRows();
    },
    initCurrentSelectedRows() {
      if (!this.tableDataSet) {
        Logger$1.error("not found tableDataSet");
        return;
      }
      const vocDataSet = this.getVocDataSet();
      const tableDataSet = this.getTableDataSet();
      let newCursor = null;
      this.tableDataSet.rows.forEach((tableRow, row) => {
        const vocValue = tableRow.original;
        tableRow.select = Boolean(
          this.newValue[toStr(vocDataSet.getValueId(vocValue))]
        );
        if (tableRow.select && newCursor === null) {
          newCursor = {
            row,
            col_name: tableDataSet.getFirstColNameVisible()
          };
        }
      });
      tableDataSet.setCursor(
        newCursor || tableDataSet.getFirstVisibleCellPointer()
      );
    },
    updateSearch() {
      const tableDataSet = this.getTableDataSet();
      const vocDataSet = this.getVocDataSet();
      if (!tableDataSet) {
        vocDataSet.setDataAssign({
          search: "",
          searchFilters: []
        });
        return;
      }
      const filter = FilterFactory.createSearchFilter(
        vocDataSet.data.search,
        tableDataSet.getSystemFields()
      );
      vocDataSet.setDataAssign({
        searchFilters: [filter]
      });
    },
    focusSearch(event) {
      const searchComponent = this.$refs.searchRef;
      if ((event == null ? void 0 : event.target) === searchComponent.$refs.inputRef) {
        return;
      }
      searchComponent.focus();
    },
    async getDataSetData() {
      if (!this.vocDataSet) {
        throw new Error("not found vocDataSet");
      }
      let voc = this.vocDataSet.cachedVoc;
      if (!voc) {
        Logger$1.warn(`voc == ${voc}`, this.vocDataSet);
        voc = await this.vocDataSet.get();
      }
      return voc;
    },
    onPanelFiltersExecute(data) {
      var _a;
      const filterLogical = PanelFiltersFactory.toFilterLogical(data);
      (_a = this.vocDataSet) == null ? void 0 : _a.setDataAssign({
        panelFilters: [filterLogical]
      });
    },
    async createTableDataSetFactory(voc) {
      var _a, _b, _c, _d;
      const formRepository = voc.dto;
      const filtersSet = new PanelFiltersSet();
      filtersSet.subject.subscribe(this.onPanelFiltersExecute);
      const tableDto = formRepository.form.table;
      return new TableDataSetFactory({
        tableName: "modal-select-table",
        uniqId: toNormaliseDomId(
          `${(_c = (_b = (_a = voc.type) == null ? void 0 : _a.voc_type) != null ? _b : voc.repositoryType.data_url) != null ? _c : this.context.uniqueId}`
        ),
        headers: tableDto.headers,
        modelDtoArray: tableDto.model,
        rows: voc.values.map((x) => VocDataSet.getAttrs(x, formRepository)),
        rowsOriginal: voc.values,
        types: formRepository.types,
        edit: {},
        repository: new TableDefaultRepository(),
        getSystemField: (model) => formRepository.attrs_wrap === false ? model.field : `attrs.${model.field}`,
        enableAutoSaveSettings: true,
        tableDataSetOptions: {
          listeners: {
            destroy: {
              next: () => {
                var _a2;
                (_a2 = this.vocDataSet) == null ? void 0 : _a2.tableDataSetDestroy(this.getTableDataSet());
              }
            },
            changeFilters: {
              next: async () => {
                var _a2;
                if (!this.tableDataSetFactory) {
                  return;
                }
                await ((_a2 = this.vocDataSet) == null ? void 0 : _a2.onChangeFilters(
                  this.getTableDataSet(),
                  this.getTableDataSetFactory()
                ));
              }
            },
            changeSort: {
              next: async () => {
                var _a2;
                if (!this.tableDataSetFactory) {
                  return;
                }
                await ((_a2 = this.vocDataSet) == null ? void 0 : _a2.onChangeSort(
                  this.getTableDataSet(),
                  this.getTableDataSetFactory()
                ));
              }
            }
          },
          extra: {
            voc_type: (_d = voc.type) == null ? void 0 : _d.voc_type
          },
          filtersSet,
          uniqueWordWrapSave: true,
          optionsDto: tableDto.options
        },
        isSelection: true
      });
    },
    async initTableDataSet() {
      const vocDataSet = this.getVocDataSet();
      const dataSetData = await this.getDataSetData();
      const factory = await this.createTableDataSetFactory(dataSetData);
      let tableDataSet;
      if (this.tableDataSet) {
        tableDataSet = this.tableDataSet;
        const tableRows = factory.getTableRows(await factory.getModel());
        tableDataSet.setTableRows(tableRows);
      } else {
        tableDataSet = await factory.create();
      }
      tableDataSet.setInitialFilters(this.initialFilters);
      tableDataSet.options.pagination = vocDataSet.pagination;
      await vocDataSet.updateValuesRemain(dataSetData, tableDataSet);
      this.tableDataSetFactory = factory;
      this.tableDataSet = tableDataSet;
    },
    async onCommit() {
      this.api.modal.commit(this, { value: "value" });
    },
    onSearchKeyDown(event) {
      const eventHelper = new KeyboardEventHelper(event);
      if (!this.tableDataSet) {
        return;
      }
      if (eventHelper.keyArrowVertical.keyEnter.isAnyTrue) {
        const tableRow = this.tableDataSet.visibleRows[0];
        if (tableRow) {
          TableRow.focusFirstCell(this.tableDataSet, tableRow);
        }
        this.focusTable();
      } else {
        this.tableDataSet.setCursor(null);
      }
    },
    onConfirmInput() {
      const isCursorSelectable = this.isCursorSelectable();
      if (this.selectionMode === "single") {
        if (isCursorSelectable === false) {
          this.sendNotSelectable();
          return;
        } else if (isCursorSelectable) {
          this.onSelectOnly(this.tableDataSet.selected.cursor.row);
        }
      }
      this.confirmAndFocusInput();
    },
    onSelectOnly(row) {
      this.onSelectedAll("clear");
      this.onSwitchRow(row);
    },
    async onUpdateVoc() {
      const tableDataSet = this.getTableDataSet();
      const vocDataSet = this.getVocDataSet();
      if (!tableDataSet || !this.tableDataSetFactory) {
        throw new Error("not found data");
      }
      vocDataSet.clearCache();
      await vocDataSet.onLoad(
        tableDataSet,
        this.tableDataSetFactory
      );
    },
    onPagination(mode) {
      var _a;
      if (!this.tableDataSet || !this.tableDataSetFactory) {
        throw new Error("not found data");
      }
      const tableDataSet = this.getTableDataSet();
      const factory = this.tableDataSetFactory;
      return (_a = this.vocDataSet) == null ? void 0 : _a.paginationLoad(mode, tableDataSet, factory);
    },
    onSelectedAll(mode = "") {
      const tableDataSet = this.getTableDataSet();
      if (!tableDataSet) {
        return;
      }
      const isSelectedAll = tableDataSet.isSelectedAll;
      if (mode === "clear" || isSelectedAll) {
        this.newValue = {};
        tableDataSet.rows.forEach((x) => x.select = false);
      } else {
        this.newValue = tableDataSet.visibleRows.reduce((value, tableRow) => {
          if (TableRow.isSelectable(tableRow)) {
            const vocValue = tableRow.original;
            value[toStr(vocValue.value_id)] = { value: vocValue };
            tableRow.select = true;
          }
          return value;
        }, {});
      }
    },
    onTableKeyDown(event) {
      var _a, _b;
      const eventHelper = new KeyboardEventHelper(event);
      if (eventHelper.codeDelete.isAnyTrue) {
        this.onSelectedAll("clear");
      } else if (eventHelper.keyTab.keyArrow.keyEnter.codeSpace.pressShift.pressCtrl.isAllFalse) {
        if (!event.altKey && !((_a = this.tableDataSet.options.display) == null ? void 0 : _a.fullScreen)) {
          (_b = this.tableDataSet) == null ? void 0 : _b.setCursor(null);
          this.focusSearch();
        }
      }
    },
    onClickColumnRow(row) {
      if (this.selectionMode === "single") {
        this.onSelectOnly(row);
      } else {
        this.onSwitchRow(row);
      }
    },
    onClickRemoveByValueId(value_id) {
      if (toStr(value_id) in this.valuesValueIdDict) {
        return this.onClickColumnRow(
          this.valuesValueIdDict[toStr(value_id)].row
        );
      }
      delete this.newValue[toStr(value_id)];
    },
    onSwitchRow(row) {
      var _a;
      const tableRow = (_a = this.getTableDataSet()) == null ? void 0 : _a.getRowOrUndefined(row);
      if (!tableRow || tableRow.group || !TableRow.isSelectable(tableRow)) {
        return;
      }
      tableRow.select = !tableRow.select;
      this.updateNewValueByRow(row);
    },
    updateNewValueByRow(row) {
      var _a;
      const tableRow = (_a = this.getTableDataSet()) == null ? void 0 : _a.getRowOrUndefined(row);
      if (!tableRow || tableRow.group) {
        return;
      }
      const vocValue = tableRow.original;
      const value_id = toStr(vocValue.value_id);
      if (tableRow.select) {
        this.newValue[value_id] = { value: vocValue };
      } else {
        delete this.newValue[value_id];
      }
    },
    onCellDblClick(value) {
      if (!this.isPointerSelectable(value.pointer)) {
        this.sendNotSelectable();
        return;
      }
      this.onClickColumnRow(value.pointer.row);
      if (this.selectionMode === "single") {
        this.confirmAndFocusInput();
      }
    },
    onCellKeyDown({
      event,
      pointer
    }) {
      const eventHelper = new KeyboardEventHelper(event);
      if (eventHelper.keyEnter.isAllTrue && eventHelper.pressCtrl.pressShift.pressAlt.isAllFalse) {
        if (this.selectionMode === "single") {
          if (!this.isPointerSelectable(pointer)) {
            this.sendNotSelectable();
            setTimeout(() => {
              var _a;
              (_a = this.tableDataSet) == null ? void 0 : _a.setCursor(pointer);
            });
            return;
          }
          this.onSelectedAndConfirm(pointer);
        } else {
          this.confirmAndFocusInput();
          return;
        }
      }
      if (eventHelper.stop.prevent.codeSpace.isAllTrue) {
        this.onClickColumnRow(pointer.row);
      }
    },
    onSelectedAndConfirm(pointer) {
      this.onSelectedAll("clear");
      this.onSwitchRow(pointer.row);
      this.confirmAndFocusInput();
    },
    confirmAndFocusInput() {
      this.api.modal.commit(this, { value: this.valueByNewValue });
    },
    focusTable() {
      var _a, _b;
      (_b = (_a = this.tableDataSet) == null ? void 0 : _a.getTableEl()) == null ? void 0 : _b.focus();
    },
    isCursorSelectable() {
      var _a;
      if (!((_a = this.tableDataSet) == null ? void 0 : _a.selected.cursor)) {
        return void 0;
      }
      return this.isPointerSelectable(this.tableDataSet.selected.cursor);
    },
    isPointerSelectable(pointer) {
      const tableDataSet = this.tableDataSet;
      if (!tableDataSet) {
        return false;
      }
      if (!pointer) {
        return false;
      }
      const rowObj = tableDataSet.getRowOrUndefined(pointer.row);
      return TableRow.isSelectable(rowObj);
    },
    sendNotSelectable() {
      NotificationsService$1.send({
        title: "\u041E\u0448\u0438\u0431\u043A\u0430 \u0432\u044B\u0431\u043E\u0440\u0430",
        text: "\u0422\u0435\u043A\u0443\u0449\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C \u043D\u0435\u043B\u044C\u0437\u044F \u0432\u044B\u0431\u0440\u0430\u0442\u044C",
        type: "error",
        duration: 5e3
      });
    }
  }
});
const _withScopeId = (n) => (pushScopeId("data-v-06931233"), n = n(), popScopeId(), n);
const _hoisted_1$1 = {
  class: "flex-column-overflow-grow",
  style: { "min-height": "calc(100vh - 100px)" }
};
const _hoisted_2$1 = { style: { "display": "flex", "gap": "20px", "padding": "10px 20px 20px" } };
const _hoisted_3$1 = {
  key: 1,
  class: "flex-full-center"
};
const _hoisted_4$1 = {
  key: 2,
  class: "voc-footer"
};
const _hoisted_5$1 = { class: "voc-footer-top" };
const _hoisted_6 = { class: "voc-footer-top-labels" };
const _hoisted_7 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("div", { class: "label-s18-c333" }, "\u0412\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F", -1));
const _hoisted_8 = { class: "label-gray" };
const _hoisted_9 = { class: "voc-footer-top-buttons" };
const _hoisted_10 = ["alt", "src"];
const _hoisted_11 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("span", null, "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C", -1));
const _hoisted_12 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("span", null, "\u0421\u043A\u0440\u044B\u0442\u044C", -1));
const _hoisted_13 = { class: "voc-footer-content" };
const _hoisted_14 = ["data-not-found"];
const _hoisted_15 = { class: "voc-footer-content-value__title" };
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ScreenSpinner = resolveComponent("ScreenSpinner");
  const _component_TableActionsComponent = resolveComponent("TableActionsComponent");
  const _component_SearchComponent = resolveComponent("SearchComponent");
  const _component_ButtonComponent = resolveComponent("ButtonComponent");
  const _component_PanelFilters = resolveComponent("PanelFilters");
  const _component_TableMultiHeaders = resolveComponent("TableMultiHeaders");
  const _component_TableComponent = resolveComponent("TableComponent");
  const _component_TablePaginationBottom = resolveComponent("TablePaginationBottom");
  const _component_CircleLoader = resolveComponent("CircleLoader");
  const _component_CloseIcon = resolveComponent("CloseIcon");
  return openBlock(), createElementBlock("div", _hoisted_1$1, [
    _ctx.loading ? (openBlock(), createBlock(_component_ScreenSpinner, {
      key: 0,
      absolute: false,
      zoom: "1"
    })) : _ctx.tableDataSet && _ctx.vocDataSet ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
      createElementVNode("div", _hoisted_2$1, [
        _ctx.tableDataSet ? (openBlock(), createBlock(_component_TableActionsComponent, {
          key: 0,
          "table-data-set": _ctx.tableDataSet,
          "changes-state": "hide",
          "filter-state": "enable",
          "full-screen-state": "hide",
          "icons-style": "gap: 20px;",
          "row-append-state": "hide",
          "update-indexes-state": "hide"
        }, null, 8, ["table-data-set"])) : createCommentVNode("", true),
        createVNode(_component_SearchComponent, {
          ref: "searchRef",
          "is-original-enter-event": true,
          "model-value": _ctx.vocDataSet.data.search,
          classContainer: "voc-input-search",
          onKeydown: _ctx.onSearchKeyDown,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.vocDataSet.setDataAssign({ search: $event }))
        }, null, 8, ["model-value", "onKeydown"]),
        createVNode(_component_ButtonComponent, {
          icon: _ctx.ICONS.autorenew,
          class: "button-blue",
          onClick: _ctx.onUpdateVoc
        }, {
          default: withCtx(() => [
            createTextVNode(" \u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C ")
          ]),
          _: 1
        }, 8, ["icon", "onClick"]),
        createElementVNode("button", {
          class: "form-button",
          "data-type": "accent",
          style: { "min-width": "167px" },
          onClick: _cache[1] || (_cache[1] = (...args) => _ctx.onConfirmInput && _ctx.onConfirmInput(...args))
        }, " \u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C \u0432\u0432\u043E\u0434 ")
      ]),
      _ctx.tableDataSet && _ctx.vocDataSet.cachedVoc ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        _ctx.tableDataSet.options.filtersSet.open ? (openBlock(), createBlock(_component_PanelFilters, {
          key: 0,
          "data-set": _ctx.tableDataSet.options.filtersSet,
          "global-handlers": _ctx.context.globalHandlers,
          "model-array": _ctx.tableDataSet.modelUnref,
          "table-data-set": _ctx.tableDataSet,
          types: _ctx.tableDataSet.types,
          "validation-handlers": _ctx.context.validationHandlers,
          style: { "margin-inline": "20px", "margin-bottom": "10px" },
          onKeydown: _cache[2] || (_cache[2] = withModifiers(() => {
          }, ["stop"]))
        }, null, 8, ["data-set", "global-handlers", "model-array", "table-data-set", "types", "validation-handlers"])) : createCommentVNode("", true),
        createVNode(_component_TableComponent, {
          ref: "tableRef",
          "init-cursor": void 0,
          isShowInfo: false,
          "screen-spinner": _ctx.vocDataSet.pagination.loading,
          "selection-mode": _ctx.selectionMode,
          "table-data-set": _ctx.tableDataSet,
          "container-class": "table-scroll-container",
          "container-style": "flex-grow: 1; height: initial; overflow: auto;",
          onClickColumnSelect: _ctx.onClickColumnRow,
          onCellDblClick: _ctx.onCellDblClick,
          onCellKeydown: _ctx.onCellKeyDown,
          onTableKeydown: _ctx.onTableKeyDown
        }, {
          headers: withCtx(({ classes }) => [
            createVNode(_component_TableMultiHeaders, {
              classes,
              "left-col": _ctx.selectionMode === "multiple" ? "checkbox" : void 0,
              "table-data-set": _ctx.tableDataSet,
              onClickLeftCol: _ctx.onSelectedAll
            }, null, 8, ["classes", "left-col", "table-data-set", "onClickLeftCol"])
          ]),
          _: 1
        }, 8, ["screen-spinner", "selection-mode", "table-data-set", "onClickColumnSelect", "onCellDblClick", "onCellKeydown", "onTableKeydown"]),
        createVNode(_component_TablePaginationBottom, {
          "table-data-set": _ctx.tableDataSet,
          onPagination: _ctx.onPagination
        }, null, 8, ["table-data-set", "onPagination"])
      ], 64)) : (openBlock(), createElementBlock("div", _hoisted_3$1, [
        createVNode(_component_CircleLoader, { zoom: "1" })
      ])),
      _ctx.isShowFooter ? (openBlock(), createElementBlock("div", _hoisted_4$1, [
        createElementVNode("div", _hoisted_5$1, [
          createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            createElementVNode("div", _hoisted_8, " \u0412\u044B\u0431\u0440\u0430\u043D\u043E " + toDisplayString(_ctx.rowsSelected) + " " + toDisplayString(_ctx.declension("\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435", "\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439", "\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F", _ctx.rowsSelected)), 1)
          ]),
          createElementVNode("div", _hoisted_9, [
            createElementVNode("button", {
              class: "button-blue",
              onClick: _cache[3] || (_cache[3] = ($event) => _ctx.onSelectedAll("clear"))
            }, [
              createElementVNode("img", {
                alt: _ctx.ICONS.restoreBlue.alt,
                src: _ctx.ICONS.restoreBlue.src,
                style: { "margin-right": "8px" }
              }, null, 8, _hoisted_10),
              _hoisted_11
            ]),
            createElementVNode("button", {
              class: "button-blue",
              onClick: _cache[4] || (_cache[4] = ($event) => _ctx.show.footer = false)
            }, [
              createVNode(_component_CloseIcon, { style: { "margin-right": "8px" } }),
              _hoisted_12
            ])
          ])
        ]),
        createElementVNode("div", _hoisted_13, [
          _ctx.tableDataSet ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(_ctx.newValue, (v, key) => {
            return openBlock(), createElementBlock("div", {
              key,
              "data-not-found": _ctx.boolToString(!(key in _ctx.valuesValueIdDict)),
              class: "voc-footer-content-value"
            }, [
              createElementVNode("div", _hoisted_15, toDisplayString(key in _ctx.valuesValueIdDict ? _ctx.valuesValueIdDict[key].voc.label : key), 1),
              createVNode(_component_ButtonComponent, {
                icon: _ctx.ICONS.closeBlue,
                class: "button-close",
                style: { "margin": "4px" },
                onClick: ($event) => _ctx.onClickRemoveByValueId(key)
              }, null, 8, ["icon", "onClick"])
            ], 8, _hoisted_14);
          }), 128)) : createCommentVNode("", true)
        ])
      ])) : createCommentVNode("", true)
    ], 64)) : createCommentVNode("", true)
  ]);
}
var TableCellModalSelect = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["render", _sfc_render$1], ["__scopeId", "data-v-06931233"]]);
const components = {
  TableComponent,
  TableMultiHeaders,
  TableMultiHeadersTh,
  TableCellComponent,
  TableFilterComponent,
  TableCellVocComponent,
  TableCellModalComponent,
  TableCellModalSelect,
  TableCellCalcComponent,
  TableCellSimple,
  TableActionsComponent,
  TableEnterModal,
  TableCellLabelComponent,
  TableExternalEditor,
  TableIndicatorsComponent,
  PanelFilters,
  PanelFiltersItem,
  NotificationsComponent,
  ContextMenu,
  ContextMenuGlobal,
  CheckboxComponent,
  ButtonComponent,
  ButtonIconComponent,
  TooltipComponent,
  ModalComponent,
  DynamicModal,
  BlueHelpComponent,
  SwitchComponent,
  CircleLoader,
  TRadioButton,
  TSelectComponent,
  TInputComponent,
  TDatePicker,
  TEditableSpan,
  ScreenSpinner,
  EnterModalComponent,
  EditableHelpComponent,
  ResizeComponent,
  PlusIcon,
  CloseIcon,
  MenuDownIcon,
  ChevronDownIcon,
  DotsVerticalIcon,
  FaqIcon,
  RecalcActivityRadionuclides,
  RecalcActivityRadionuclidesDemo,
  CalcCodeRao,
  CalcCodeRaoDemo,
  CalcCategoryRao,
  CalcCategoryZri,
  CalcCategoryZriDemo,
  CalcCodeWasteWaterReceiver,
  CalcCodeWasteWaterReceiverDemo,
  CalcCodeOyat,
  CalcCodeOyatDemo,
  CalcCodeTerritory,
  CalcCodeTerritoryDemo,
  CalcCodeStorage,
  CalcCodeStorageDemo,
  CalcTotalActivityRaoDepletedUraniumProductsDemo,
  CalcTotalActivityRaoDepletedUraniumProducts,
  CalcPeriodPotentialDangerDemo,
  CalcPeriodPotentialDanger,
  AttrInputBase,
  AttrInputList,
  AttrsComponent,
  ContextInput,
  TActionProgress,
  TInputFile,
  TInputFiles,
  TTable,
  TCollapse,
  TCaption,
  TBorder,
  TInput,
  TCaptionInput,
  TFlex,
  TBoxColumn,
  TBoxRow,
  TBoxColumnContainer,
  TBoxContainer
};
function install(Vue2) {
  for (const component in components) {
    try {
      Vue2.component(components[component].name, components[component]);
    } catch (e) {
      Logger$1.error(
        "install error. \u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u043D\u0435\u0442 \u043B\u0438 \u0432 \u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u0435 \u0438\u043C\u043F\u043E\u0440\u0442\u043E\u0432 \u0438\u0437 index.ts.",
        {
          componentName: component,
          e,
          component: components[component]
        }
      );
    }
  }
  return Vue2;
}
function getHeaderProcessed(header) {
  if (Array.isArray(header)) {
    return header.map(getHeaderProcessed).flat();
  }
  const title = Object.keys(header)[0];
  const other = header[title];
  const children = [];
  if (!Array.isArray(other)) {
    children.push(...getHeaderProcessed(other));
  }
  return [
    {
      title,
      children
    }
  ];
}
class DocumentStyleHelper {
  constructor(id = void 0) {
    this.id = id;
    this.newStylesBySelector = {};
    this.newStylesArray = [];
  }
  addStyleBySelector(selector, style) {
    if (selector in this.newStylesBySelector) {
      this.newStylesBySelector[selector] += "\r\n" + style;
    } else {
      this.newStylesBySelector[selector] = style;
    }
    return this;
  }
  addStyle(style) {
    this.newStylesArray.push(style);
    return this;
  }
  execute() {
    const styles = `
     ${Object.keys(this.newStylesBySelector).map(
      (selector) => `${selector} {\r
 ${this.newStylesBySelector[selector]} \r
}`
    ).join("\r\n")}
        ${this.newStylesArray.map((x) => x).join("\r\n")}
    `;
    if (this.id === void 0) {
      document.write(`
      <style>
       ${styles}
      </style>
    `);
    } else {
      let styleEl = document.getElementById(this.id);
      if (!styleEl) {
        styleEl = document.createElement("style");
        styleEl.id = this.id;
        document.body.appendChild(styleEl);
      }
      styleEl.innerHTML = styles;
    }
    this.newStylesBySelector = {};
    this.newStylesArray = [];
    return this;
  }
}
class FormContext {
  constructor(opts) {
    this.data = reactive({
      modelDict: {},
      currentData: {},
      initialData: {},
      types: {}
    });
    const data = opts == null ? void 0 : opts.data;
    if (data) {
      this.setData(data);
    }
  }
  async loadRepository(url) {
    const repository = (await HttpService$1.get(url)).json;
    return this.setRepository(repository);
  }
  async loadData(url) {
    const data = (await HttpService$1.get(url)).json;
    return this.setData(data);
  }
  setRepository(repository) {
    this.data.repository = repository;
    this.updateModelDict();
    this.updateTypes();
    return this.data.repository;
  }
  setData(data) {
    this.setInitialData(data);
    this.data.currentData = copy(data);
    return this.data.currentData;
  }
  setInitialData(data) {
    this.data.initialData = copy(data);
    return this.data.initialData;
  }
  assignData(data) {
    const newData = Object.assign(this.data.currentData, data);
    return this.setData(newData);
  }
  assignInitialData(data) {
    const newData = Object.assign(this.data.initialData, data);
    return this.setInitialData(newData);
  }
  async saveData(url) {
    const result = await HttpService$1.post(url, {
      body: JSON.stringify(this.data.currentData),
      headers: {
        "Content-Type": "application/json"
      }
    });
    this.data.initialData = copy(this.data.currentData);
    return result;
  }
  setChange(change) {
    this.data.currentData[change.model.field] = change.value;
  }
  updateModelDict() {
    var _a, _b, _c, _d, _e;
    Object.assign(
      this.data.modelDict,
      (_c = (_b = (_a = RepoService.getRepo()) == null ? void 0 : _a.attrs) == null ? void 0 : _b[RepoPartDefault]) != null ? _c : {}
    );
    this.data.modelDict = ((_e = (_d = this.data.repository) == null ? void 0 : _d.form.table.model) != null ? _e : []).reduce(
      (value, currentValue) => {
        value[currentValue.field] = currentValue;
        return value;
      },
      {}
    );
  }
  updateTypes() {
    var _a, _b, _c, _d;
    Object.assign(this.data.types, (_b = (_a = RepoService.getRepo()) == null ? void 0 : _a.attr_types) != null ? _b : {});
    Object.assign(this.data.types, (_d = (_c = this.data.repository) == null ? void 0 : _c.types) != null ? _d : {});
  }
  getModel(field) {
    var _a;
    return (_a = this.data.modelDict) == null ? void 0 : _a[field];
  }
}
class TableStylesHelper {
  constructor(classes, id = "standard-table-styles") {
    this.classes = classes;
    this.id = id;
    this.styleHelper = new DocumentStyleHelper(id);
  }
  addContainerColor(color = TABLE_STYLES.container.color) {
    this.styleHelper.addStyleBySelector(
      `.${this.classes.container}`,
      `color: ${color};`
    );
    return this;
  }
  addContainerBackground(color = TABLE_STYLES.container.background) {
    this.styleHelper.addStyleBySelector(
      `.${this.classes.container}`,
      `background: ${color};`
    );
    return this;
  }
  addThBackground(color = TABLE_STYLES.th.background) {
    this.styleHelper.addStyleBySelector(
      `.${this.classes.th}`,
      `background: ${color};`
    );
    return this;
  }
  addThColor(color) {
    this.styleHelper.addStyleBySelector(
      `.${this.classes.th}`,
      `color: ${color};`
    );
    return this;
  }
  addHeaderColor(color = TABLE_STYLES.header.color) {
    this.styleHelper.addStyleBySelector(
      `.${this.classes.header}`,
      `color: ${color};`
    );
    return this;
  }
  addTdColor(color) {
    this.styleHelper.addStyleBySelector(
      `.${this.classes.cell}`,
      `color: ${color};`
    );
    return this;
  }
  addTdBackground(color = TABLE_STYLES.cell.background) {
    if (!color) {
      return this;
    }
    this.styleHelper.addStyleBySelector(
      `.${this.classes.cell}`,
      `background: ${color};`
    );
    return this;
  }
  addTr2Background(color = TABLE_STYLES.row2.background) {
    this.styleHelper.addStyleBySelector(
      `tbody .${this.classes.row}:nth-of-type(odd)`,
      `background: ${color};`
    );
    return this;
  }
  addTrBackground(color = TABLE_STYLES.row.background) {
    this.styleHelper.addStyleBySelector(
      `.${this.classes.row}`,
      `background: ${color};`
    );
    return this;
  }
  addTrColor(color = TABLE_STYLES.row.color) {
    this.styleHelper.addStyleBySelector(
      `.${this.classes.row}`,
      `color: ${color};`
    );
    return this;
  }
  addBorderColor(color = TABLE_STYLES.cell["border-color"]) {
    this.styleHelper.addStyleBySelector(
      `.${this.classes.table}`,
      `border-color: ${color};`
    );
    this.styleHelper.addStyleBySelector(
      `.${this.classes.cell}`,
      `border-color: ${color};`
    );
    this.styleHelper.addStyleBySelector(
      `.${this.classes.th}`,
      `border-color: ${color};`
    );
    return this;
  }
  addPaddingInline(padding = TABLE_STYLES.cellDiv["padding-inline"]) {
    if (padding === TABLE_STYLES.cellDiv["padding-inline"]) {
      return this;
    }
    this.styleHelper.addStyleBySelector(
      `.${this.classes.cellDiv} input, .${this.classes.cellDiv} textarea, .cell-list-container .cell-list-input-block, .cell-dict-input-block, .table-div-span, .calc-label-block`,
      `padding-inline${padding} !important;`
    );
    this.styleHelper.addStyleBySelector(
      `.${this.classes.cellDiv} > span`,
      `margin-inline: ${padding} !important;`
    );
    return this;
  }
  addCellHeight(height = TABLE_STYLES.cellDiv.height) {
    if (height === TABLE_STYLES.cellDiv.height) {
      return this;
    }
    this.styleHelper.addStyleBySelector(
      `.${this.classes.cellDiv}`,
      `height: ${height};
      min-height: ${height};`
    );
    this.styleHelper.addStyleBySelector(
      `.${this.classes.cell}`,
      `line-height: ${height};`
    );
    this.styleHelper.addStyleBySelector(
      `.${this.classes.cellDiv} .checkbox-container`,
      `${this.classes.cellCheckboxSizeCssVariable}: calc(${height}/1.6);`
    );
    this.styleHelper.addStyleBySelector(
      `.${this.classes.cellDiv} .voc-label-block`,
      `min-height: ${height};`
    );
    return this;
  }
  addHeaderHeight(height = TABLE_STYLES.header.height) {
    if (height === TABLE_STYLES.header.height) {
      return this;
    }
    this.styleHelper.addStyleBySelector(
      `.${this.classes.header}`,
      `height: ${height};`
    );
    return this;
  }
  addSelectedHeaderBackground(color = TABLE_STYLES.selectedHeader.background) {
    this.styleHelper.addStyleBySelector(
      `.${this.classes.selectedHeader}`,
      `background: ${color};`
    );
    return this;
  }
  addTdSelectedCellBorderColor(color = TABLE_STYLES.selectedCell["border-color"]) {
    this.styleHelper.addStyleBySelector(
      `.${this.classes.selectedCell}`,
      `border-color: ${color};`
    );
    return this;
  }
  addEditedCellBorderColor(color = TABLE_STYLES.editedCell["border-color"]) {
    this.styleHelper.addStyleBySelector(
      `.${this.classes.editedCell}`,
      `border-color: ${color};`
    );
    return this;
  }
  addTdSelectedCell2BorderColor(color = TABLE_STYLES.selectedCell2["border-color"]) {
    this.styleHelper.addStyleBySelector(
      `.${this.classes.selectedCell2}`,
      `border-color: ${color};`
    );
    return this;
  }
  addLinkColor(color = TABLE_STYLES["*|*:link"].color) {
    if (color === TABLE_STYLES["*|*:link"].color) {
      return this;
    }
    this.styleHelper.addStyleBySelector(
      `.${this.classes.container} *|*:link`,
      `color: ${color};`
    );
    return this;
  }
  addVisitedColor(color = TABLE_STYLES["*|*:visited"].color) {
    if (color === TABLE_STYLES["*|*:visited"].color) {
      return this;
    }
    this.styleHelper.addStyleBySelector(
      `.${this.classes.container} *|*:visited`,
      `color: ${color};`
    );
    return this;
  }
  addCellFontSize(fontSize = TABLE_STYLES.cell["font-size"]) {
    if (fontSize === TABLE_STYLES.cell["font-size"]) {
      return this;
    }
    this.styleHelper.addStyleBySelector(
      `.${this.classes.cell}`,
      `font-size: ${fontSize};`
    );
    return this;
  }
  addHeaderFontSize(fontSize = TABLE_STYLES.header["font-size"]) {
    if (fontSize === TABLE_STYLES.header["font-size"]) {
      return this;
    }
    this.styleHelper.addStyleBySelector(
      `.${this.classes.header}`,
      `font-size: ${fontSize};`
    );
    return this;
  }
  execute() {
    this.styleHelper.execute();
    return this;
  }
}
class PaginationDataSet {
  constructor() {
    this.data = void 0;
  }
  get lazyLoadSize() {
    return this.params.lazyLoadSize;
  }
  get uniqueId() {
    if (!this.params.uniqueId) {
      this.params.uniqueId = makeId(5);
    }
    return this.params.uniqueId;
  }
  async setParams(params) {
    this.params = params;
    this.initPagination();
    if (params.filter) {
      this.setFilter(`["and",${params.filter}]`);
    }
  }
  async getData(listParams, paginationDataSetData) {
    const params = {
      ...this.params.staticParams,
      ...listParams
    };
    const { json: valuesResult } = await ApiService$1.getList(this.params.listUrl, params);
    let values = valuesResult.result;
    if (paginationDataSetData) {
      if (listParams == null ? void 0 : listParams.offset) {
        values = [...paginationDataSetData.values, ...values];
      }
    }
    const isPagination = listParams && (listParams.limit !== void 0 || listParams.offset !== void 0);
    const lazyPaginationState = isPagination && "values_remain" in valuesResult ? PaginationHelper.getStateByLazyResult(valuesResult) : void 0;
    return {
      values,
      newValues: valuesResult.result,
      lazyPaginationState
    };
  }
  async initRows(dataSetData, tableDataSet, factory) {
    const tableRows = factory.setRows(
      dataSetData.values.map((x) => this.params.getRowAttrs(x)),
      dataSetData.values
    ).getTableRows(tableDataSet.modelUnref);
    tableDataSet.initRows(tableRows);
    this.updateValuesRemain(tableDataSet);
  }
  clearCache() {
    this.initPagination();
    ApiService$1.clearCache(this.getKey());
    this.data = void 0;
    return this;
  }
  checkCache(prevKey, newKey) {
    if (prevKey === newKey) {
      return;
    }
    ApiService$1.clearCache(prevKey);
  }
  async get(paginationParams = this.pagination.params) {
    this.pagination.setLoading(true);
    try {
      const cacheKey = this.getKey(paginationParams);
      const data = await ApiService$1.useCache(
        cacheKey,
        () => this.getData(paginationParams, this.data)
      );
      await this.setPaginationParams(paginationParams);
      this.pagination.setLoading(false);
      this.data = data;
      return data;
    } catch (e) {
      await ApiHelper.wrapNotifyError(e, {
        isError: true,
        title: "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0435 \u0434\u0430\u043D\u043D\u044B\u0445"
      });
      Logger$1.error({ e });
      this.pagination.setLoading(false);
      return void 0;
    }
  }
  async paginationLoad(mode, tableDataSet, factory) {
    const paginationParams = PaginationHelper.getPaginationByMode(
      mode,
      this.pagination
    );
    if (!paginationParams) {
      return;
    }
    const dataSetData = await this.get(paginationParams);
    if (dataSetData) {
      await this.initRows(dataSetData, tableDataSet, factory);
    }
  }
  setPaginationParams(pagination) {
    const prevKey = this.getKey(this.pagination.params);
    this.pagination.setParams(pagination);
    const newKey = this.getKey(pagination);
    this.checkCache(prevKey, newKey);
  }
  setFilter(filter) {
    return this.setPaginationParamsPartial({
      filter: typeof filter === "string" ? filter : FilterFactory.getString(filter)
    });
  }
  setSort(sort) {
    return this.setPaginationParamsPartial({
      sort: SortFactory.getString(sort)
    });
  }
  setPaginationParamsPartial(paginationParams) {
    return this.setPaginationParams({
      ...this.pagination.params,
      ...paginationParams
    });
  }
  updateValuesRemain(tableDataSet) {
    var _a;
    if (!((_a = this.data) == null ? void 0 : _a.lazyPaginationState)) {
      return;
    }
    const pagination = this.pagination;
    pagination.setValuesRemain(this.data.lazyPaginationState.values_remain);
    tableDataSet.options.pagination = pagination;
  }
  async onChangeFilters(tableDataSet, factory) {
    if (!tableDataSet.isServerFilterAndSort) {
      this.setFilter(void 0);
      return;
    }
    this.pagination.setOffset(0).normaliseLimit();
    const filter = tableDataSet.getFilterLogicalObj();
    if (isDev) {
      Logger$1.log(
        `\u0424\u0438\u043B\u044C\u0442\u0440: ${FilterFactory.getString(
          filter
        )} (PaginationDataSet.onChangeFilters)`
      );
    }
    this.setFilter(filter);
    await this.onLoad(tableDataSet, factory);
  }
  async onChangeSort(tableDataSet, factory) {
    if (!this) {
      throw new Error("this not found");
    }
    if (!tableDataSet.isServerFilterAndSort) {
      this.setSort(void 0);
      return;
    }
    this.pagination.setOffset(0).normaliseLimit();
    const sort = tableDataSet.getSort();
    this.setSort(sort);
    await this.onLoad(tableDataSet, factory);
  }
  async onLoad(tableDataSet, factory) {
    const dataSetData = await this.get();
    if (dataSetData) {
      await this.initRows(dataSetData, tableDataSet, factory);
    }
  }
  destroy() {
    this.clearCache();
  }
  tableDataSetDestroy(tableDataSet) {
  }
  getKey(pagination = this.pagination.params) {
    var _a, _b, _c;
    let key = (_c = (_b = (_a = this.params).getKey) == null ? void 0 : _b.call(_a, this, pagination)) != null ? _c : `pagination-data-set-${toStr(this.params.staticParams)}_${this.uniqueId}_${TablePagination.getKey(pagination)}`;
    return toNormaliseDomId(md5(key));
  }
  initPagination() {
    if (!this.pagination) {
      const lazyLoadSize = isNumeric(this.lazyLoadSize) ? this.lazyLoadSize : void 0;
      this.pagination = new TablePagination({
        lazyLoadSize
      });
    }
    this.pagination.setOffset(0);
  }
}
class PanelFiltersSaveModuleAbstract {
  constructor() {
    this.currentFilter = void 0;
    this.filters = [];
  }
}
async function digestText(text, algorithm = "SHA-256") {
  const msgUint8 = new TextEncoder().encode(text);
  const hashBuffer = await crypto.subtle.digest(algorithm, msgUint8);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
  return hashHex;
}
function firstKeyOrDefault(object, _default = void 0) {
  if (!object) {
    return _default;
  }
  const keys2 = Object.keys(object);
  if (!keys2.length) {
    return _default;
  }
  return keys2[0];
}
function getDifferencesObjects(objArray, types) {
  var _a;
  objArray = objArray.map((x) => x || {});
  const keys2 = Array.from(
    new Set(
      objArray.map((x) => {
        const keys22 = [];
        for (let xKey in x) {
          if ((types == null ? void 0 : types.length) && !types.some((type) => type === typeof x[xKey])) {
            continue;
          }
          keys22.push(xKey);
        }
        return keys22;
      }).flat()
    )
  );
  const objects = objArray.map(() => ({}));
  const changes = {};
  for (let key of keys2) {
    const obj1 = objArray[0];
    for (let i = 1; i < objArray.length; i++) {
      const currentObj = objArray[i];
      if (obj1[key] !== currentObj[key]) {
        objects[0][key] = obj1[key];
        objects[i][key] = currentObj[key];
        (_a = changes[key]) != null ? _a : changes[key] = [obj1[key]];
        changes[key].push(currentObj[key]);
      }
    }
  }
  return {
    objects,
    changes
  };
}
function getFirstByProp(obj, prop, maxDeep = -1, currentDeep = 0) {
  if (prop in obj) {
    return obj[prop];
  }
  for (const key of Object.keys(obj)) {
    const current = obj[key];
    if (typeof current !== "object" || isNullOrUndefined(obj)) {
      continue;
    }
    if (prop in current) {
      return current[prop];
    } else {
      if (maxDeep !== -1 && currentDeep + 1 >= maxDeep) {
        continue;
      }
      const propResult = getFirstByProp(
        current,
        prop,
        maxDeep,
        currentDeep + 1
      );
      if (propResult !== void 0) {
        return propResult;
      }
    }
  }
  return void 0;
}
function getValueOrOriginal(object) {
  if (typeof object === "object") {
    return object.value;
  }
  return object;
}
function insert(arr, index, ...newItems) {
  return [
    ...arr.slice(0, index),
    ...newItems,
    ...arr.slice(index)
  ];
}
function insertBefore(arr, el, ...newItems) {
  const index = arr.indexOf(el);
  return insert(arr, index, ...newItems);
}
function normaliseRange(range) {
  if (range.end > range.start) {
    const end = range.end;
    range.end = range.start;
    range.start = end;
  }
  return range;
}
function toJS(obj) {
  return JSON.parse(JSON.stringify(obj));
}
function toNumberOrNull(str) {
  str = replaceCommaNumber(str);
  if (isNumeric(str)) {
    return Number(str);
  }
  return null;
}
function toUndefinedIfNull(v) {
  if (v === null) {
    return void 0;
  }
  return v;
}
async function waitTablesQueue() {
  while (GlobalTableSettingsService.tableDataSetsQueueLength.value > 0) {
    await sleep(100);
  }
}
async function wrapNotifyAndAwaited(promiseOrFunctionArray, _params) {
  const promises = [];
  promiseOrFunctionArray.forEach((promiseOrFunc, i) => {
    promises.push(
      ApiHelper.wrapNotifyError(() => {
        const promise = typeof promiseOrFunc === "function" ? promiseOrFunc() : promiseOrFunc;
        promise.catch((error) => {
          Logger$1.error(`wrapNotifyAndAwaited ${i}:`, error);
        });
        return promise;
      }, _params)
    );
  });
  await Promise.all(promises);
}
const masks = {
  default: "ddd mmm dd yyyy HH:MM:ss",
  rusDate: "dd.mm.yyyy",
  rusDateTime: "dd.mm.yyyy HH:MM",
  shortDate: "m/d/yy",
  mediumDate: "mmm d, yyyy",
  longDate: "mmmm d, yyyy",
  fullDate: "dddd, mmmm d, yyyy",
  shortTime: "h:MM TT",
  mediumTime: "h:MM:ss TT",
  longTime: "h:MM:ss TT Z",
  isoDate: "yyyy-mm-dd",
  isoTime: "HH:MM:ss",
  isoDateTime: "yyyy-mm-dd'T'HH:MM:ss",
  isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'"
};
const i18n = {
  dayNames: [
    "\u0412\u0441",
    "\u041F\u043D",
    "\u0412\u0442",
    "\u0421\u0440",
    "\u0427\u0442",
    "\u041F\u0442",
    "\u0421\u0431",
    "\u0412\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
    "\u041F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
    "\u0412\u0442\u043E\u0440\u043D\u0438\u043A",
    "\u0421\u0440\u0435\u0434\u0430",
    "\u0427\u0435\u0442\u0432\u0435\u0440\u0433",
    "\u041F\u044F\u0442\u043D\u0438\u0446\u0430",
    "\u0421\u0443\u0431\u0431\u043E\u0442\u0430"
  ],
  monthNames: [
    "\u042F\u043D\u0432",
    "\u0424\u0435\u0432",
    "\u041C\u0430\u0440\u0442",
    "\u0410\u043F\u0440",
    "\u041C\u0430\u0439",
    "\u0418\u044E\u043D\u044C",
    "\u0418\u044E\u043B\u044C",
    "\u0410\u0432\u0433",
    "\u0421\u0435\u043D\u0442",
    "\u041E\u043A\u0442",
    "\u041D\u043E\u044F\u0431",
    "\u0414\u0435\u043A",
    "\u042F\u043D\u0432\u0430\u0440\u044C",
    "\u0424\u0435\u0432\u0440\u0430\u043B\u044C",
    "\u041C\u0430\u0440\u0442",
    "\u0410\u043F\u0440\u0435\u043B\u044C",
    "\u041C\u0430\u0439",
    "\u0418\u044E\u043D\u044C",
    "\u0418\u044E\u043B\u044C",
    "\u0410\u0432\u0433\u0443\u0441\u0442",
    "\u0421\u0435\u043D\u0442\u044F\u0431\u0440\u044C",
    "\u041E\u043A\u0442\u044F\u0431\u0440\u044C",
    "\u041D\u043E\u044F\u0431\u0440\u044C",
    "\u0414\u0435\u043A\u0430\u0431\u0440\u044C"
  ]
};
const dF = {
  masks,
  i18n
};
const dateFormat = function() {
  const token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g, timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g, timezoneClip = /[^-+\dA-Z]/g, pad = function(val, len = 2) {
    val = String(val);
    while (val.length < len) {
      val = "0" + val;
    }
    return val;
  };
  return function(date, mask, utc) {
    if (date === void 0 || date === null || date === "") {
      return "";
    }
    if (arguments.length == 1 && Object.prototype.toString.call(date) == "[object String]" && !/\d/.test(date)) {
      mask = date;
      date = void 0;
    }
    date = date ? new Date(date) : new Date();
    if (isNaN(date)) {
      throw SyntaxError("invalid date");
    }
    mask = String(dF.masks[mask] || mask || dF.masks["default"]);
    if (mask.slice(0, 4) == "UTC:") {
      mask = mask.slice(4);
      utc = true;
    }
    const _ = utc ? "getUTC" : "get", d = date[_ + "Date"](), D = date[_ + "Day"](), m = date[_ + "Month"](), y = date[_ + "FullYear"](), H = date[_ + "Hours"](), M = date[_ + "Minutes"](), s = date[_ + "Seconds"](), L = date[_ + "Milliseconds"](), o = utc ? 0 : date.getTimezoneOffset(), flags = {
      d,
      dd: pad(d),
      ddd: dF.i18n.dayNames[D],
      dddd: dF.i18n.dayNames[D + 7],
      m: m + 1,
      mm: pad(m + 1),
      mmm: dF.i18n.monthNames[m],
      mmmm: dF.i18n.monthNames[m + 12],
      yy: String(y).slice(2),
      yyyy: y,
      h: H % 12 || 12,
      hh: pad(H % 12 || 12),
      H,
      HH: pad(H),
      M,
      MM: pad(M),
      s,
      ss: pad(s),
      l: pad(L, 3),
      L: pad(L > 99 ? Math.round(L / 10) : L),
      t: H < 12 ? "a" : "p",
      tt: H < 12 ? "am" : "pm",
      T: H < 12 ? "A" : "P",
      TT: H < 12 ? "AM" : "PM",
      Z: utc ? "UTC" : (String(date).match(timezone) || [""]).pop().replace(timezoneClip, ""),
      o: (o > 0 ? "-" : "+") + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
      S: ["th", "st", "nd", "rd"][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10]
    };
    return mask.replace(token, function($0) {
      return $0 in flags ? flags[$0] : $0.slice(1, $0.length - 1);
    });
  };
}();
const STATUS_REPORT_NAME = {
  draft: "\u0427\u0435\u0440\u043D\u043E\u0432\u0438\u043A",
  confirmed: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0430",
  loaded: "\u0417\u0430\u0433\u0440\u0443\u0436\u0435\u043D\u0430",
  rejected: "\u041E\u0442\u043A\u043B\u043E\u043D\u0435\u043D\u0430",
  remarks: "\u0417\u0430\u043C\u0435\u0447\u0430\u043D\u0438\u044F",
  verified: "\u041F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u0430",
  unloaded: "\u0412\u044B\u0433\u0440\u0443\u0436\u0435\u043D\u0430",
  accepted: "\u041F\u0440\u0438\u043D\u044F\u0442\u0430",
  canceled: "\u0410\u043D\u043D\u0443\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u0430"
};
function getStatusReportName(status) {
  return STATUS_REPORT_NAME[status] || status || "\u041D\u0435 \u0443\u043A\u0430\u0437\u0430\u043D\u043E";
}
const STATUS_REPORTING_FORM_NAME = {
  draft: "\u0427\u0435\u0440\u043D\u043E\u0432\u0438\u043A",
  remarks: "\u0417\u0430\u043C\u0435\u0447\u0430\u043D\u0438\u044F",
  verified: "\u041F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u0430",
  confirmed: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0430",
  unloaded: "\u0412\u044B\u0433\u0440\u0443\u0436\u0435\u043D\u0430",
  rejected: "\u041E\u0442\u043A\u043B\u043E\u043D\u0435\u043D\u0430",
  accepted: "\u041F\u0440\u0438\u043D\u044F\u0442\u0430",
  canceled: "\u0410\u043D\u043D\u0443\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u0430",
  loaded: "\u0417\u0430\u0433\u0440\u0443\u0436\u0435\u043D\u0430"
};
function getStatusReportingFormName(status) {
  return STATUS_REPORTING_FORM_NAME[status] || status || "\u041D\u0435 \u0443\u043A\u0430\u0437\u0430\u043D\u043E";
}
const REPORTING_FORM_RULES_GENERAL = {
  draft: {
    edit: true,
    remark: true,
    comment: true,
    warning: false,
    unloadingExchangeFile: true,
    unloading: true
  },
  confirmed: {
    edit: false,
    remark: false,
    comment: true,
    warning: false,
    unloadingExchangeFile: true,
    unloading: true
  },
  loaded: {
    edit: false,
    remark: false,
    comment: true,
    warning: true,
    unloadingExchangeFile: true,
    unloading: true
  },
  rejected: {
    edit: false,
    remark: false,
    comment: false,
    warning: false,
    unloadingExchangeFile: true,
    unloading: true
  }
};
const REPORTING_FORM_RULES = {
  draft: REPORTING_FORM_RULES_GENERAL.draft,
  remarks: REPORTING_FORM_RULES_GENERAL.draft,
  verified: REPORTING_FORM_RULES_GENERAL.draft,
  confirmed: REPORTING_FORM_RULES_GENERAL.confirmed,
  loaded: REPORTING_FORM_RULES_GENERAL.loaded,
  unloaded: REPORTING_FORM_RULES_GENERAL.loaded,
  accepted: REPORTING_FORM_RULES_GENERAL.loaded,
  rejected: REPORTING_FORM_RULES_GENERAL.rejected,
  canceled: REPORTING_FORM_RULES_GENERAL.rejected
};
const STATUS_REPORTING_FORM_SELECT_VALUES = Object.keys(STATUS_REPORTING_FORM_NAME).map((key) => ({
  label: STATUS_REPORTING_FORM_NAME[key],
  value: key
}));
async function getVocUniqueValuesColumn(tableDataSet, model, searchValue, limit, only_active, value, config_url) {
  const field = model.systemField || model.field;
  const filter = searchValue ? FilterFactory.getString(
    FilterFactory.createComparison("like", field, toStr(searchValue))
  ) : void 0;
  return (await ApiService$1.getVocValues(
    tableDataSet.options.extra.voc_type,
    {
      limit,
      offset: 0,
      filter,
      extract: [field],
      unique: true,
      only_active
    },
    false,
    value,
    config_url
  )).json.result;
}
const LS_KEY = "test-modal-page";
const _sfc_main = defineComponent({
  name: "TTestDynamicModalComponent",
  components: {
    ButtonComponent,
    TInputComponent
  },
  props: {},
  emits: [],
  setup() {
    return {};
  },
  data() {
    return {
      url: "",
      context: "",
      result: void 0
    };
  },
  computed: {},
  watch: {},
  created() {
    var _a, _b;
    const currentSave = this.getSave();
    this.url = (_a = currentSave.url) != null ? _a : "";
    this.context = (_b = currentSave.context) != null ? _b : "";
  },
  methods: {
    onFileChange(e) {
      this.url = window.URL.createObjectURL(e.target.files[0]);
    },
    save() {
      localStorage.setItem(
        LS_KEY,
        JSON.stringify({
          url: this.url,
          context: this.context
        })
      );
    },
    getSave() {
      var _a;
      return JSON.parse((_a = localStorage.getItem(LS_KEY)) != null ? _a : "{}");
    },
    async onOpenModal() {
      this.save();
      this.result = void 0;
      let context = this.context;
      try {
        context = JSON.parse(context);
      } catch (ex) {
        Logger$1.log(
          "\u041D\u0435\u0432\u0430\u043B\u0438\u0434\u043D\u044B\u0439 JSON \u0443 \u043A\u043E\u043D\u0442\u0435\u043A\u0441\u0442\u0430, \u043F\u043E\u044D\u0442\u043E\u043C\u0443 \u043E\u043D \u0431\u044B\u043B \u043F\u0435\u0440\u0435\u0434\u0430\u043D \u0432 \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u0435 \u0441\u0442\u0440\u043E\u043A\u0438."
        );
      }
      try {
        this.result = await TDynamicModalService.show(this.url, context);
      } catch (ex) {
        this.result = ex;
      }
    }
  }
});
const _hoisted_1 = { class: "default-page-container default-page-padding-inline" };
const _hoisted_2 = { style: { "display": "flex", "gap": "10px", "flex-direction": "column" } };
const _hoisted_3 = /* @__PURE__ */ createElementVNode("div", { class: "app-h-s22-h24-w7-c333" }, "TestModalPage", -1);
const _hoisted_4 = { key: 0 };
const _hoisted_5 = /* @__PURE__ */ createElementVNode("div", { class: "app-h-s16-h24-w7-c333" }, "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442:", -1);
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TInputComponent = resolveComponent("TInputComponent");
  const _component_ButtonComponent = resolveComponent("ButtonComponent");
  return openBlock(), createElementBlock("div", _hoisted_1, [
    createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      createVNode(_component_TInputComponent, {
        modelValue: _ctx.url,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.url = $event),
        caption: "URL",
        "is-hide-reset": ""
      }, null, 8, ["modelValue"]),
      createElementVNode("input", {
        type: "file",
        accept: ".js",
        onChange: _cache[1] || (_cache[1] = (...args) => _ctx.onFileChange && _ctx.onFileChange(...args))
      }, null, 32),
      withDirectives(createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.context = $event),
        placeholder: "Context",
        rows: "10"
      }, null, 512), [
        [vModelText, _ctx.context]
      ]),
      createVNode(_component_ButtonComponent, {
        class: "form-button",
        onClick: _ctx.onOpenModal
      }, {
        default: withCtx(() => [
          createTextVNode(" \u041E\u0442\u043A\u0440\u044B\u0442\u044C ")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _ctx.result ? (openBlock(), createElementBlock("div", _hoisted_4, [
        _hoisted_5,
        createElementVNode("pre", null, toDisplayString(_ctx.result), 1)
      ])) : createCommentVNode("", true)
    ])
  ]);
}
var TTestDynamicModalComponent = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
const version = "1.28.0";
var release = {
  version
};
var VocValueStatusEnum = /* @__PURE__ */ ((VocValueStatusEnum2) => {
  VocValueStatusEnum2[VocValueStatusEnum2["Draft"] = 0] = "Draft";
  VocValueStatusEnum2[VocValueStatusEnum2["Active"] = 1] = "Active";
  VocValueStatusEnum2[VocValueStatusEnum2["Deprecated"] = 2] = "Deprecated";
  return VocValueStatusEnum2;
})(VocValueStatusEnum || {});
export { ApiErrorInstance, ApiHelper, ApiService$1 as ApiService, AttrInputBase, AttrInputList, AttrsComponent, BlueHelpComponent, ButtonComponent, ButtonIconComponent, CALC_PARAMS, CalcCategoryRao, CalcCategoryZri, CalcCategoryZriDemo, CalcCodeOyat, CalcCodeOyatDemo, CalcCodeRao, CalcCodeRaoDemo, CalcCodeStorage, CalcCodeStorageDemo, CalcCodeTerritory, CalcCodeTerritoryDemo, CalcCodeWasteWaterReceiver, CalcCodeWasteWaterReceiverDemo, CalcPeriodPotentialDanger, CalcPeriodPotentialDangerDemo, CalcTotalActivityRaoDepletedUraniumProducts, CalcTotalActivityRaoDepletedUraniumProductsDemo, CheckboxComponent, ChevronDownIcon, CircleLoader, CloseIcon, ContextInput, ContextMenu, ContextMenuGlobal, ContextMenuService, DEFAULT_ATTR_LABEL_OPTS, DataSet, DocumentStyleHelper, DotsVerticalIcon, DropdownComponent, EditableHelpComponent, EnterModalComponent, EventHelper, FILTER_COMPARISON_OPERATIONS, FILTER_COMPARISON_OPERATION_OPTIONS, FILTER_COMPARISON_OPERATION_SUPPORT_TYPE_INPUT, FILTER_COMPARISON_OPERATION__CREATE_INPUT, FILTER_LOCAL_COMPARISON_OPERATIONS, FILTER_LOCAL_COMPARISON_OPERATIONS_ARRAY, FILTER_LOGICAL_OPERATIONS, FaqIcon, FilterFactory, FormContext, GlobalContext, GlobalTableSettingsService, HelpHelper, HttpService$1 as HttpService, INIT_CODE_SYMBOL, KeyboardEventHelper, Logger$1 as Logger, MenuDownIcon, ModalComponent, ModelHelper, NOT_SUPPORT_FILTER_ATTR_INPUT_BASE_TYPES, NOT_SUPPORT_LIKE_ATTR_INPUT_BASE_TYPES, NUMBER_COMPARER_ASC, NUMBER_COMPARER_DESC, NotificationsComponent, NotificationsService$1 as NotificationsService, PagePlugin, PageService, PaginationDataSet, PaginationHelper, PanelFilters, PanelFiltersFactory, PanelFiltersItem, PanelFiltersSaveModuleAbstract, PanelFiltersSet, PlusIcon, PointerHelper, REPORTING_FORM_RULES, RecalcActivityRadionuclides, RecalcActivityRadionuclidesDemo, RepoPartDefault, RepoService, ResizeComponent, SCROLL_INTO_VIEW_PARAMS, STATUS_REPORTING_FORM_NAME, STATUS_REPORTING_FORM_SELECT_VALUES, STATUS_REPORT_NAME, ScreenSpinner, SortFactory, Subject, SwitchComponent, TABLE_CLASSES, consts as TABLE_CONSTS, TABLE_GLOBAL_HANDLERS, ICONS as TABLE_ICONS, release as TABLE_RELEASE_JSON, TABLE_STYLES, TActionProgress, TBorder, TBoxColumn, TBoxColumnContainer, TBoxContainer, TBoxRow, TCaption, TCaptionInput, TCollapse, TDatePicker, DynamicModal as TDynamicModal, TDynamicModalService, TEditableSpan, TFlex, TInput, TInputComponent, TInputFile, TInputFiles, TRadioButton, TSelectComponent, TTable, TTestDynamicModalComponent, TableActionsComponent, TableCell, TableCellCalcComponent, TableCellComponent, TableCellLabelComponent, TableCellModalComponent, TableCellModalSelect, TableCellSimple, TableCellVocComponent, TableChangeEvents, TableChanges, TableComponent, TableDataSet, TableDataSetFactory, TableDefaultRepository, TableEventAbstract, TableEventAddRow, TableEventChangeCell, TableEventChangeRow, TableEventDeleteRow, TableEventMoveRow, TableEventResizeColumn, TableEventUpdateRowIndexes, TableFilterComponent, TableFilterHelper, TableHandlersHelper, TableIndicatorsComponent, TableInfo, TableKeyboard, TableLocalRepository, TableModel, TableMultiHeaders, TableMultiHeadersTh, TablePagination, TablePaginationBottom, TableRow, TableSelected, TableSettingsService, TableSort, TableStylesHelper, TooltipComponent, VOC_NAMES_DICT, ValidErrorEnum, VocDataSet, VocValueHelper, VocValueStatusEnum, boolToString, classToQuerySelector, cloneDeep, combineQueue, copy, copyToClipboard, dateFormat, dateTransform, debounce, declension, digestText, fillObject, filterComparisonOptionToStr, firstKeyOrDefault, firstOrDefault, formatTimeStr, get, getApiDefaultPage, getArrayHeaders, getCalcHeader, getDifferencesObjects, getFirstByProp, getHeaderProcessed, getKeys, getMinMaxCellPointer, getMinutes, getModelDtoDict, getModelDtoSort, getModelVoc, getNumbersByObject, getStatusReportName, getStatusReportingFormName, getTableModelArrayByFormRepository, getTableRowsByFormRead, getTime, getValidError, getValidErrorLabel, getValueOrOriginal, getVocUniqueValuesColumn, groupBy, groupByMap, importDefault, insert, insertBefore, install, isLocatedRange, isNullOrUndefined, isNumeric, isObject, isSupportFilterAttrInput, lastOrDefault, makeId, maxBy, md5, mergeDeep, minBy, moment, normaliseRange, queueIsAddRow, queueIsChangeCells, queueIsChangeRows, queueIsDeleteRows, randomInt, set, sleep, sortBy, strToFilterComparisonOption, stringToFormInfoDataDto, timeToStr, toClearObject, toJS, toNormaliseDomId, toNumberOrDefault, toNumberOrNull, toNumberOrUndefined, toStr, toUndefinedIfNull, uniqBy, unique, waitTablesQueue, wrapNotifyAndAwaited };
